var __defProp2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a2, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a2, prop, b[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b) => __defProps(a2, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck2 = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet2 = (obj, member, getter) => {
  __accessCheck2(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd2 = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet2 = (obj, member, value, setter) => {
  __accessCheck2(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod2 = (obj, member, method) => {
  __accessCheck2(obj, member, "access private method");
  return method;
};
var _eventPromises, _asyncListeners, _socketClient, _localMediaHandler, _sfuHandler, _a2, _availableDevices, _b, _localMediaHandler2, _localMediaUtils, _c, _permissions, _roomNodeClient, _localMediaHandler3, _previewMediaHandler, _theme, _permissions2, _isPinned, _d, _theme2, _permissions3, _theme3, _socketService, _roomNodeClient2, _e, _isPinned2, _roomNodeClient3, _self, _eventEmitter2, _listeners2, _roomNodeClient4, _self2, _roomNodeClient5, _self3, _consumerPeerMap, _roomNodeClient6, _pluginSocketHandler, _roomNodeClient7, _socketServerName, _self4, _participants, _chat, _authToken, _self5, _chatSocketHandler, _roomNodeClient8, _socketServerName2, _roomNodeClient9, _socketServerName3, _f, _self6, _pluginSocketHandler2, _roomNodeClient10, _socketServerName4, _chatSocketHandler2, _g, _roomNodeClient11, _self7, _roomNodeClient12, _self8, _roomNodeClient13, _self9, _participants2, _roomNodeClient14, _self10, _participants3, _url2, _sockrates, _peerId, _generateId, generateId_fn, _self11, _socketService2, _h, _controller;
import log from "loglevel";
import { v4 } from "uuid";
import axios from "axios";
import Bowser from "bowser";
import { io } from "socket.io-client";
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { SemanticAttributes } from "@opentelemetry/semantic-conventions";
import opentelemetry, { ROOT_CONTEXT } from "@opentelemetry/api";
import { Resource } from "@opentelemetry/resources";
import { Device } from "@dytesdk/mediasoup-client";
var EventCategory;
(function(EventCategory2) {
  EventCategory2[EventCategory2["MAJOR_EVENT"] = 0] = "MAJOR_EVENT";
  EventCategory2[EventCategory2["MINOR_EVENT"] = 1] = "MINOR_EVENT";
})(EventCategory || (EventCategory = {}));
var Event;
(function(Event2) {
  Event2["PRECALL_TEST_BEGIN"] = "precall_begin";
  Event2["PRECALL_TEST_COMPLETE"] = "precall_end";
  Event2["CALL_JOIN_BEGIN"] = "call_join";
  Event2["NET_QUALITY_TEST_BEGIN"] = "net_quality_test_begin";
  Event2["NET_QUALITY_TEST_END"] = "net_quality_test_end";
  Event2["WEBSOCKET_CONNECTED"] = "websocket_connected";
  Event2["TRANSPORT_CONNECTED"] = "transport_connected";
  Event2["AUDIO_ON"] = "audio_on";
  Event2["AUDIO_OFF"] = "audio_off";
  Event2["VIDEO_ON"] = "video_on";
  Event2["VIDEO_OFF"] = "video_off";
  Event2["PARTICIPANT_ROLE"] = "participant_role";
  Event2["PING_STAT"] = "ping_stat";
  Event2["DISCONNECT"] = "disconnect";
  Event2["RECONNECT_ATTEMPT"] = "reconnect_attempt";
  Event2["SCREENSHARE_START_REQUESTED"] = "screenshare_start_requested";
  Event2["SCREENSHARE_STARTED"] = "screenshare_started";
  Event2["SCREENSHARE_STOPPED"] = "screenshare_stopped";
  Event2["TAB_CHANGE"] = "tab_change";
  Event2["BROWSER_BACKGROUNDED"] = "browser_backgrounded";
  Event2["BROWSER_FOREGROUNDED"] = "browser_foregrounded";
  Event2["DOMINANT_SPEAKER"] = "dominant_speaker";
  Event2["AUDIO_DEVICES_UPDATES"] = "audio_devices_updates";
  Event2["VIDEO_DEVICES_UPDATES"] = "video_devices_updates";
  Event2["SPEAKER_DEVICES_UPDATES"] = "speaker_devices_updates";
  Event2["SELECTED_MICROHPONE_UPDATE"] = "selected_microphone_update";
  Event2["SELECTED_CAMERA_UPDATE"] = "selected_camera_update";
  Event2["SELECTED_SPEAKER_UPDATE"] = "selected_speaker_update";
  Event2["MEDIA_PERMISSION"] = "camera_permission";
  Event2["LEGACY_SWITCH"] = "legacy_switch";
  Event2["AUDIO_PLAY_FAILED"] = "audio_play_failed";
  Event2["VIDEO_PLAY_FAILED"] = "video_play_failed";
  Event2["AUDIO_TRACK_MUTED"] = "audio_track_muted";
  Event2["VIDEO_TRACK_MUTED"] = "video_track_muted";
})(Event || (Event = {}));
var EventCategoryMap = new Map([
  [Event.PRECALL_TEST_BEGIN, EventCategory.MINOR_EVENT],
  [Event.PRECALL_TEST_COMPLETE, EventCategory.MINOR_EVENT],
  [Event.CALL_JOIN_BEGIN, EventCategory.MAJOR_EVENT],
  [Event.NET_QUALITY_TEST_BEGIN, EventCategory.MINOR_EVENT],
  [Event.NET_QUALITY_TEST_END, EventCategory.MINOR_EVENT],
  [Event.WEBSOCKET_CONNECTED, EventCategory.MINOR_EVENT],
  [Event.TRANSPORT_CONNECTED, EventCategory.MAJOR_EVENT],
  [Event.AUDIO_ON, EventCategory.MINOR_EVENT],
  [Event.AUDIO_OFF, EventCategory.MINOR_EVENT],
  [Event.VIDEO_ON, EventCategory.MINOR_EVENT],
  [Event.VIDEO_OFF, EventCategory.MINOR_EVENT],
  [Event.PARTICIPANT_ROLE, EventCategory.MINOR_EVENT],
  [Event.PING_STAT, EventCategory.MAJOR_EVENT],
  [Event.DISCONNECT, EventCategory.MAJOR_EVENT],
  [Event.RECONNECT_ATTEMPT, EventCategory.MAJOR_EVENT],
  [Event.SCREENSHARE_START_REQUESTED, EventCategory.MINOR_EVENT],
  [Event.SCREENSHARE_STARTED, EventCategory.MINOR_EVENT],
  [Event.SCREENSHARE_STOPPED, EventCategory.MINOR_EVENT],
  [Event.TAB_CHANGE, EventCategory.MINOR_EVENT],
  [Event.BROWSER_BACKGROUNDED, EventCategory.MINOR_EVENT],
  [Event.BROWSER_FOREGROUNDED, EventCategory.MINOR_EVENT],
  [Event.DOMINANT_SPEAKER, EventCategory.MINOR_EVENT],
  [Event.AUDIO_DEVICES_UPDATES, EventCategory.MINOR_EVENT],
  [Event.VIDEO_DEVICES_UPDATES, EventCategory.MINOR_EVENT],
  [Event.SPEAKER_DEVICES_UPDATES, EventCategory.MINOR_EVENT],
  [Event.SELECTED_MICROHPONE_UPDATE, EventCategory.MINOR_EVENT],
  [Event.SELECTED_CAMERA_UPDATE, EventCategory.MINOR_EVENT],
  [Event.SELECTED_SPEAKER_UPDATE, EventCategory.MINOR_EVENT],
  [Event.MEDIA_PERMISSION, EventCategory.MINOR_EVENT],
  [Event.LEGACY_SWITCH, EventCategory.MINOR_EVENT],
  [Event.AUDIO_PLAY_FAILED, EventCategory.MINOR_EVENT],
  [Event.VIDEO_PLAY_FAILED, EventCategory.MINOR_EVENT],
  [Event.AUDIO_TRACK_MUTED, EventCategory.MINOR_EVENT],
  [Event.VIDEO_TRACK_MUTED, EventCategory.MINOR_EVENT]
]);
var commonjsGlobal$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var events$1 = { exports: {} };
var R$2 = typeof Reflect === "object" ? Reflect : null;
var ReflectApply$1 = R$2 && typeof R$2.apply === "function" ? R$2.apply : function ReflectApply2(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys$1;
if (R$2 && typeof R$2.ownKeys === "function") {
  ReflectOwnKeys$1 = R$2.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys$1 = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys$1 = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target);
  };
}
function ProcessEmitWarning$1(warning) {
  if (console && console.warn)
    console.warn(warning);
}
var NumberIsNaN$1 = Number.isNaN || function NumberIsNaN2(value) {
  return value !== value;
};
function EventEmitter$2() {
  EventEmitter$2.init.call(this);
}
events$1.exports = EventEmitter$2;
events$1.exports.once = once$1;
EventEmitter$2.EventEmitter = EventEmitter$2;
EventEmitter$2.prototype._events = void 0;
EventEmitter$2.prototype._eventsCount = 0;
EventEmitter$2.prototype._maxListeners = void 0;
var defaultMaxListeners$1 = 10;
function checkListener$1(listener) {
  if (typeof listener !== "function") {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}
Object.defineProperty(EventEmitter$2, "defaultMaxListeners", {
  enumerable: true,
  get: function() {
    return defaultMaxListeners$1;
  },
  set: function(arg) {
    if (typeof arg !== "number" || arg < 0 || NumberIsNaN$1(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
    }
    defaultMaxListeners$1 = arg;
  }
});
EventEmitter$2.init = function() {
  if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || void 0;
};
EventEmitter$2.prototype.setMaxListeners = function setMaxListeners(n2) {
  if (typeof n2 !== "number" || n2 < 0 || NumberIsNaN$1(n2)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n2 + ".");
  }
  this._maxListeners = n2;
  return this;
};
function _getMaxListeners$1(that) {
  if (that._maxListeners === void 0)
    return EventEmitter$2.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter$2.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners$1(this);
};
EventEmitter$2.prototype.emit = function emit(type) {
  var args = [];
  for (var i2 = 1; i2 < arguments.length; i2++)
    args.push(arguments[i2]);
  var doError = type === "error";
  var events2 = this._events;
  if (events2 !== void 0)
    doError = doError && events2.error === void 0;
  else if (!doError)
    return false;
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      throw er;
    }
    var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
    err.context = er;
    throw err;
  }
  var handler = events2[type];
  if (handler === void 0)
    return false;
  if (typeof handler === "function") {
    ReflectApply$1(handler, this, args);
  } else {
    var len2 = handler.length;
    var listeners3 = arrayClone$1(handler, len2);
    for (var i2 = 0; i2 < len2; ++i2)
      ReflectApply$1(listeners3[i2], this, args);
  }
  return true;
};
function _addListener$1(target, type, listener, prepend) {
  var m;
  var events2;
  var existing;
  checkListener$1(listener);
  events2 = target._events;
  if (events2 === void 0) {
    events2 = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    if (events2.newListener !== void 0) {
      target.emit("newListener", type, listener.listener ? listener.listener : listener);
      events2 = target._events;
    }
    existing = events2[type];
  }
  if (existing === void 0) {
    existing = events2[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === "function") {
      existing = events2[type] = prepend ? [listener, existing] : [existing, listener];
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }
    m = _getMaxListeners$1(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      var w2 = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      w2.name = "MaxListenersExceededWarning";
      w2.emitter = target;
      w2.type = type;
      w2.count = existing.length;
      ProcessEmitWarning$1(w2);
    }
  }
  return target;
}
EventEmitter$2.prototype.addListener = function addListener(type, listener) {
  return _addListener$1(this, type, listener, false);
};
EventEmitter$2.prototype.on = EventEmitter$2.prototype.addListener;
EventEmitter$2.prototype.prependListener = function prependListener(type, listener) {
  return _addListener$1(this, type, listener, true);
};
function onceWrapper$1() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}
function _onceWrap$1(target, type, listener) {
  var state = { fired: false, wrapFn: void 0, target, type, listener };
  var wrapped = onceWrapper$1.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}
EventEmitter$2.prototype.once = function once2(type, listener) {
  checkListener$1(listener);
  this.on(type, _onceWrap$1(this, type, listener));
  return this;
};
EventEmitter$2.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  checkListener$1(listener);
  this.prependListener(type, _onceWrap$1(this, type, listener));
  return this;
};
EventEmitter$2.prototype.removeListener = function removeListener(type, listener) {
  var list, events2, position, i2, originalListener;
  checkListener$1(listener);
  events2 = this._events;
  if (events2 === void 0)
    return this;
  list = events2[type];
  if (list === void 0)
    return this;
  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0)
      this._events = Object.create(null);
    else {
      delete events2[type];
      if (events2.removeListener)
        this.emit("removeListener", type, list.listener || listener);
    }
  } else if (typeof list !== "function") {
    position = -1;
    for (i2 = list.length - 1; i2 >= 0; i2--) {
      if (list[i2] === listener || list[i2].listener === listener) {
        originalListener = list[i2].listener;
        position = i2;
        break;
      }
    }
    if (position < 0)
      return this;
    if (position === 0)
      list.shift();
    else {
      spliceOne$1(list, position);
    }
    if (list.length === 1)
      events2[type] = list[0];
    if (events2.removeListener !== void 0)
      this.emit("removeListener", type, originalListener || listener);
  }
  return this;
};
EventEmitter$2.prototype.off = EventEmitter$2.prototype.removeListener;
EventEmitter$2.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners3, events2, i2;
  events2 = this._events;
  if (events2 === void 0)
    return this;
  if (events2.removeListener === void 0) {
    if (arguments.length === 0) {
      this._events = Object.create(null);
      this._eventsCount = 0;
    } else if (events2[type] !== void 0) {
      if (--this._eventsCount === 0)
        this._events = Object.create(null);
      else
        delete events2[type];
    }
    return this;
  }
  if (arguments.length === 0) {
    var keys = Object.keys(events2);
    var key;
    for (i2 = 0; i2 < keys.length; ++i2) {
      key = keys[i2];
      if (key === "removeListener")
        continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners("removeListener");
    this._events = Object.create(null);
    this._eventsCount = 0;
    return this;
  }
  listeners3 = events2[type];
  if (typeof listeners3 === "function") {
    this.removeListener(type, listeners3);
  } else if (listeners3 !== void 0) {
    for (i2 = listeners3.length - 1; i2 >= 0; i2--) {
      this.removeListener(type, listeners3[i2]);
    }
  }
  return this;
};
function _listeners$1(target, type, unwrap) {
  var events2 = target._events;
  if (events2 === void 0)
    return [];
  var evlistener = events2[type];
  if (evlistener === void 0)
    return [];
  if (typeof evlistener === "function")
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  return unwrap ? unwrapListeners$1(evlistener) : arrayClone$1(evlistener, evlistener.length);
}
EventEmitter$2.prototype.listeners = function listeners(type) {
  return _listeners$1(this, type, true);
};
EventEmitter$2.prototype.rawListeners = function rawListeners(type) {
  return _listeners$1(this, type, false);
};
EventEmitter$2.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === "function") {
    return emitter.listenerCount(type);
  } else {
    return listenerCount$1.call(emitter, type);
  }
};
EventEmitter$2.prototype.listenerCount = listenerCount$1;
function listenerCount$1(type) {
  var events2 = this._events;
  if (events2 !== void 0) {
    var evlistener = events2[type];
    if (typeof evlistener === "function") {
      return 1;
    } else if (evlistener !== void 0) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter$2.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys$1(this._events) : [];
};
function arrayClone$1(arr, n2) {
  var copy = new Array(n2);
  for (var i2 = 0; i2 < n2; ++i2)
    copy[i2] = arr[i2];
  return copy;
}
function spliceOne$1(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}
function unwrapListeners$1(arr) {
  var ret = new Array(arr.length);
  for (var i2 = 0; i2 < ret.length; ++i2) {
    ret[i2] = arr[i2].listener || arr[i2];
  }
  return ret;
}
function once$1(emitter, name) {
  return new Promise(function(resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }
    function resolver() {
      if (typeof emitter.removeListener === "function") {
        emitter.removeListener("error", errorListener);
      }
      resolve([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener$1(emitter, name, resolver, { once: true });
    if (name !== "error") {
      addErrorHandlerIfEventEmitter$1(emitter, errorListener, { once: true });
    }
  });
}
function addErrorHandlerIfEventEmitter$1(emitter, handler, flags) {
  if (typeof emitter.on === "function") {
    eventTargetAgnosticAddListener$1(emitter, "error", handler, flags);
  }
}
function eventTargetAgnosticAddListener$1(emitter, name, listener, flags) {
  if (typeof emitter.on === "function") {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === "function") {
    emitter.addEventListener(name, function wrapListener(arg) {
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}
var EventEmitter$3 = events$1.exports;
var __extends$a = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var EventStore = function() {
  function EventStore2() {
    this.currentChunk = {
      entries: []
    };
    this.flushedChunks = [];
  }
  EventStore2.prototype.add = function(entry) {
    this.currentChunk.entries.push(entry);
  };
  EventStore2.prototype.flush = function() {
    var chunk = this.currentChunk;
    this.currentChunk = {
      entries: []
    };
    this.flushedChunks.push(chunk);
    return chunk;
  };
  return EventStore2;
}();
var EventHandler = function(_super) {
  __extends$a(EventHandler2, _super);
  function EventHandler2(connection) {
    var _this = _super.call(this) || this;
    _this.connection = connection;
    _this.eventStore = new EventStore();
    return _this;
  }
  EventHandler2.prototype.callEvent = function(entry) {
    entry.timestamp = new Date();
    this.eventStore.add(entry);
    this.emit(entry.event, entry.metaData);
    if (EventCategoryMap.get(entry.event) === EventCategory.MAJOR_EVENT) {
      var chunk = this.eventStore.flush();
      this.connection.sendChunk(chunk);
    }
  };
  return EventHandler2;
}(EventEmitter$3);
var BrowserTypes;
(function(BrowserTypes2) {
  BrowserTypes2["CHROMIUM"] = "chromum";
  BrowserTypes2["FIREFOX"] = "firefox";
  BrowserTypes2["SAFARI"] = "safari";
})(BrowserTypes || (BrowserTypes = {}));
var ClientEnvType;
(function(ClientEnvType2) {
  ClientEnvType2["DEV"] = "dev";
  ClientEnvType2["STAGING"] = "staging";
  ClientEnvType2["PRODUCTION"] = "production";
})(ClientEnvType || (ClientEnvType = {}));
var MediaDeviceType;
(function(MediaDeviceType2) {
  MediaDeviceType2["AUDIO"] = "AUDIO";
  MediaDeviceType2["VIDEO"] = "VIDEO";
  MediaDeviceType2["SPEAKER"] = "SPEAKER";
})(MediaDeviceType || (MediaDeviceType = {}));
var PermissionEnum;
(function(PermissionEnum2) {
  PermissionEnum2[PermissionEnum2["INIT"] = 0] = "INIT";
  PermissionEnum2[PermissionEnum2["ACCEPTED"] = 1] = "ACCEPTED";
  PermissionEnum2[PermissionEnum2["DENIED"] = 2] = "DENIED";
  PermissionEnum2[PermissionEnum2["SYS_DENIED"] = 3] = "SYS_DENIED";
  PermissionEnum2[PermissionEnum2["FAILED"] = 4] = "FAILED";
  PermissionEnum2[PermissionEnum2["NOTFOUND"] = 5] = "NOTFOUND";
  PermissionEnum2[PermissionEnum2["NOT_APPLICABLE"] = 6] = "NOT_APPLICABLE";
})(PermissionEnum || (PermissionEnum = {}));
var __extends$9 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Connector = function() {
  function Connector2() {
  }
  Connector2.prototype.authenticate = function(data) {
    this.authInfo = data;
  };
  return Connector2;
}();
var QueuedConnector = function(_super) {
  __extends$9(QueuedConnector2, _super);
  function QueuedConnector2(flushInterval) {
    if (flushInterval === void 0) {
      flushInterval = 5e3;
    }
    var _this = _super.call(this) || this;
    _this.chunkQueue = {
      entries: []
    };
    _this.flushInterval = flushInterval;
    return _this;
  }
  QueuedConnector2.prototype.sendChunk = function(data) {
    this.sendChunkToServer(data);
  };
  return QueuedConnector2;
}(Connector);
var __extends$8 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter$7 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$6 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f, y2, t2, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t2 = _.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t2[1]) {
              _.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _.label < t2[2]) {
              _.label = t2[2];
              _.ops.push(op);
              break;
            }
            if (t2[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var PubSubConnector = function(_super) {
  __extends$8(PubSubConnector2, _super);
  function PubSubConnector2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PubSubConnector2.prototype.sendChunk = function(data) {
    _super.prototype.sendChunk.call(this, data);
  };
  PubSubConnector2.prototype.sendChunkToServer = function(data) {
    return __awaiter$7(this, void 0, void 0, function() {
      return __generator$6(this, function(_a3) {
        return [2, false];
      });
    });
  };
  return PubSubConnector2;
}(QueuedConnector);
var querystring = {};
var buffer = {};
var base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
  var len2 = b64.length;
  if (len2 % 4 > 0) {
    throw new Error("Invalid string. Length must be a multiple of 4");
  }
  var validLen = b64.indexOf("=");
  if (validLen === -1)
    validLen = len2;
  var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
}
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  var curByte = 0;
  var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
  var i2;
  for (i2 = 0; i2 < len2; i2 += 4) {
    tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
    arr[curByte++] = tmp >> 16 & 255;
    arr[curByte++] = tmp >> 8 & 255;
    arr[curByte++] = tmp & 255;
  }
  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
    arr[curByte++] = tmp & 255;
  }
  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 255;
    arr[curByte++] = tmp & 255;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
}
function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i2 = start; i2 < end; i2 += 3) {
    tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
    output.push(tripletToBase64(tmp));
  }
  return output.join("");
}
function fromByteArray(uint8) {
  var tmp;
  var len2 = uint8.length;
  var extraBytes = len2 % 3;
  var parts = [];
  var maxChunkLength = 16383;
  for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
    parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
  }
  if (extraBytes === 1) {
    tmp = uint8[len2 - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==");
  } else if (extraBytes === 2) {
    tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "=");
  }
  return parts.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(buffer2, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i2 = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer2[offset + i2];
  i2 += d;
  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer2[offset + i2], i2 += d, nBits -= 8) {
  }
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer2[offset + i2], i2 += d, nBits -= 8) {
  }
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
ieee754.write = function(buffer2, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i2 = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer2[offset + i2] = m & 255, i2 += d, m /= 256, mLen -= 8) {
  }
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer2[offset + i2] = e & 255, i2 += d, e /= 256, eLen -= 8) {
  }
  buffer2[offset + i2 - d] |= s * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(exports2) {
  const base64 = base64Js;
  const ieee754$1 = ieee754;
  const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
  exports2.Buffer = Buffer2;
  exports2.SlowBuffer = SlowBuffer;
  exports2.INSPECT_MAX_BYTES = 50;
  const K_MAX_LENGTH = 2147483647;
  exports2.kMaxLength = K_MAX_LENGTH;
  Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
  if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
    console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
  }
  function typedArraySupport() {
    try {
      const arr = new Uint8Array(1);
      const proto2 = { foo: function() {
        return 42;
      } };
      Object.setPrototypeOf(proto2, Uint8Array.prototype);
      Object.setPrototypeOf(arr, proto2);
      return arr.foo() === 42;
    } catch (e) {
      return false;
    }
  }
  Object.defineProperty(Buffer2.prototype, "parent", {
    enumerable: true,
    get: function() {
      if (!Buffer2.isBuffer(this))
        return void 0;
      return this.buffer;
    }
  });
  Object.defineProperty(Buffer2.prototype, "offset", {
    enumerable: true,
    get: function() {
      if (!Buffer2.isBuffer(this))
        return void 0;
      return this.byteOffset;
    }
  });
  function createBuffer(length) {
    if (length > K_MAX_LENGTH) {
      throw new RangeError('The value "' + length + '" is invalid for option "size"');
    }
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer2.prototype);
    return buf;
  }
  function Buffer2(arg, encodingOrOffset, length) {
    if (typeof arg === "number") {
      if (typeof encodingOrOffset === "string") {
        throw new TypeError('The "string" argument must be of type string. Received type number');
      }
      return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
  }
  Buffer2.poolSize = 8192;
  function from(value, encodingOrOffset, length) {
    if (typeof value === "string") {
      return fromString(value, encodingOrOffset);
    }
    if (ArrayBuffer.isView(value)) {
      return fromArrayView(value);
    }
    if (value == null) {
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
      return fromArrayBuffer(value, encodingOrOffset, length);
    }
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
      return fromArrayBuffer(value, encodingOrOffset, length);
    }
    if (typeof value === "number") {
      throw new TypeError('The "value" argument must not be of type number. Received type number');
    }
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) {
      return Buffer2.from(valueOf, encodingOrOffset, length);
    }
    const b = fromObject(value);
    if (b)
      return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
      return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    }
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
  }
  Buffer2.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
  };
  Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
  Object.setPrototypeOf(Buffer2, Uint8Array);
  function assertSize(size) {
    if (typeof size !== "number") {
      throw new TypeError('"size" argument must be of type number');
    } else if (size < 0) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
  }
  function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
      return createBuffer(size);
    }
    if (fill !== void 0) {
      return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    }
    return createBuffer(size);
  }
  Buffer2.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
  };
  function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
  }
  Buffer2.allocUnsafe = function(size) {
    return allocUnsafe(size);
  };
  Buffer2.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
  };
  function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") {
      encoding = "utf8";
    }
    if (!Buffer2.isEncoding(encoding)) {
      throw new TypeError("Unknown encoding: " + encoding);
    }
    const length = byteLength2(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) {
      buf = buf.slice(0, actual);
    }
    return buf;
  }
  function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for (let i2 = 0; i2 < length; i2 += 1) {
      buf[i2] = array[i2] & 255;
    }
    return buf;
  }
  function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
      const copy = new Uint8Array(arrayView);
      return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
  }
  function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) {
      throw new RangeError('"offset" is outside of buffer bounds');
    }
    if (array.byteLength < byteOffset + (length || 0)) {
      throw new RangeError('"length" is outside of buffer bounds');
    }
    let buf;
    if (byteOffset === void 0 && length === void 0) {
      buf = new Uint8Array(array);
    } else if (length === void 0) {
      buf = new Uint8Array(array, byteOffset);
    } else {
      buf = new Uint8Array(array, byteOffset, length);
    }
    Object.setPrototypeOf(buf, Buffer2.prototype);
    return buf;
  }
  function fromObject(obj) {
    if (Buffer2.isBuffer(obj)) {
      const len2 = checked(obj.length) | 0;
      const buf = createBuffer(len2);
      if (buf.length === 0) {
        return buf;
      }
      obj.copy(buf, 0, 0, len2);
      return buf;
    }
    if (obj.length !== void 0) {
      if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
        return createBuffer(0);
      }
      return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) {
      return fromArrayLike(obj.data);
    }
  }
  function checked(length) {
    if (length >= K_MAX_LENGTH) {
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    }
    return length | 0;
  }
  function SlowBuffer(length) {
    if (+length != length) {
      length = 0;
    }
    return Buffer2.alloc(+length);
  }
  Buffer2.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer2.prototype;
  };
  Buffer2.compare = function compare(a2, b) {
    if (isInstance(a2, Uint8Array))
      a2 = Buffer2.from(a2, a2.offset, a2.byteLength);
    if (isInstance(b, Uint8Array))
      b = Buffer2.from(b, b.offset, b.byteLength);
    if (!Buffer2.isBuffer(a2) || !Buffer2.isBuffer(b)) {
      throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    }
    if (a2 === b)
      return 0;
    let x = a2.length;
    let y2 = b.length;
    for (let i2 = 0, len2 = Math.min(x, y2); i2 < len2; ++i2) {
      if (a2[i2] !== b[i2]) {
        x = a2[i2];
        y2 = b[i2];
        break;
      }
    }
    if (x < y2)
      return -1;
    if (y2 < x)
      return 1;
    return 0;
  };
  Buffer2.isEncoding = function isEncoding(encoding) {
    switch (String(encoding).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return true;
      default:
        return false;
    }
  };
  Buffer2.concat = function concat(list, length) {
    if (!Array.isArray(list)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    if (list.length === 0) {
      return Buffer2.alloc(0);
    }
    let i2;
    if (length === void 0) {
      length = 0;
      for (i2 = 0; i2 < list.length; ++i2) {
        length += list[i2].length;
      }
    }
    const buffer2 = Buffer2.allocUnsafe(length);
    let pos = 0;
    for (i2 = 0; i2 < list.length; ++i2) {
      let buf = list[i2];
      if (isInstance(buf, Uint8Array)) {
        if (pos + buf.length > buffer2.length) {
          if (!Buffer2.isBuffer(buf))
            buf = Buffer2.from(buf);
          buf.copy(buffer2, pos);
        } else {
          Uint8Array.prototype.set.call(buffer2, buf, pos);
        }
      } else if (!Buffer2.isBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      } else {
        buf.copy(buffer2, pos);
      }
      pos += buf.length;
    }
    return buffer2;
  };
  function byteLength2(string, encoding) {
    if (Buffer2.isBuffer(string)) {
      return string.length;
    }
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
      return string.byteLength;
    }
    if (typeof string !== "string") {
      throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    }
    const len2 = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len2 === 0)
      return 0;
    let loweredCase = false;
    for (; ; ) {
      switch (encoding) {
        case "ascii":
        case "latin1":
        case "binary":
          return len2;
        case "utf8":
        case "utf-8":
          return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return len2 * 2;
        case "hex":
          return len2 >>> 1;
        case "base64":
          return base64ToBytes(string).length;
        default:
          if (loweredCase) {
            return mustMatch ? -1 : utf8ToBytes(string).length;
          }
          encoding = ("" + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer2.byteLength = byteLength2;
  function slowToString(encoding, start, end) {
    let loweredCase = false;
    if (start === void 0 || start < 0) {
      start = 0;
    }
    if (start > this.length) {
      return "";
    }
    if (end === void 0 || end > this.length) {
      end = this.length;
    }
    if (end <= 0) {
      return "";
    }
    end >>>= 0;
    start >>>= 0;
    if (end <= start) {
      return "";
    }
    if (!encoding)
      encoding = "utf8";
    while (true) {
      switch (encoding) {
        case "hex":
          return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
          return utf8Slice(this, start, end);
        case "ascii":
          return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
          return latin1Slice(this, start, end);
        case "base64":
          return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return utf16leSlice(this, start, end);
        default:
          if (loweredCase)
            throw new TypeError("Unknown encoding: " + encoding);
          encoding = (encoding + "").toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer2.prototype._isBuffer = true;
  function swap(b, n2, m) {
    const i2 = b[n2];
    b[n2] = b[m];
    b[m] = i2;
  }
  Buffer2.prototype.swap16 = function swap16() {
    const len2 = this.length;
    if (len2 % 2 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    }
    for (let i2 = 0; i2 < len2; i2 += 2) {
      swap(this, i2, i2 + 1);
    }
    return this;
  };
  Buffer2.prototype.swap32 = function swap32() {
    const len2 = this.length;
    if (len2 % 4 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    }
    for (let i2 = 0; i2 < len2; i2 += 4) {
      swap(this, i2, i2 + 3);
      swap(this, i2 + 1, i2 + 2);
    }
    return this;
  };
  Buffer2.prototype.swap64 = function swap64() {
    const len2 = this.length;
    if (len2 % 8 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    }
    for (let i2 = 0; i2 < len2; i2 += 8) {
      swap(this, i2, i2 + 7);
      swap(this, i2 + 1, i2 + 6);
      swap(this, i2 + 2, i2 + 5);
      swap(this, i2 + 3, i2 + 4);
    }
    return this;
  };
  Buffer2.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0)
      return "";
    if (arguments.length === 0)
      return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
  };
  Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
  Buffer2.prototype.equals = function equals(b) {
    if (!Buffer2.isBuffer(b))
      throw new TypeError("Argument must be a Buffer");
    if (this === b)
      return true;
    return Buffer2.compare(this, b) === 0;
  };
  Buffer2.prototype.inspect = function inspect() {
    let str = "";
    const max = exports2.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max)
      str += " ... ";
    return "<Buffer " + str + ">";
  };
  if (customInspectSymbol) {
    Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
  }
  Buffer2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) {
      target = Buffer2.from(target, target.offset, target.byteLength);
    }
    if (!Buffer2.isBuffer(target)) {
      throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    }
    if (start === void 0) {
      start = 0;
    }
    if (end === void 0) {
      end = target ? target.length : 0;
    }
    if (thisStart === void 0) {
      thisStart = 0;
    }
    if (thisEnd === void 0) {
      thisEnd = this.length;
    }
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError("out of range index");
    }
    if (thisStart >= thisEnd && start >= end) {
      return 0;
    }
    if (thisStart >= thisEnd) {
      return -1;
    }
    if (start >= end) {
      return 1;
    }
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target)
      return 0;
    let x = thisEnd - thisStart;
    let y2 = end - start;
    const len2 = Math.min(x, y2);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for (let i2 = 0; i2 < len2; ++i2) {
      if (thisCopy[i2] !== targetCopy[i2]) {
        x = thisCopy[i2];
        y2 = targetCopy[i2];
        break;
      }
    }
    if (x < y2)
      return -1;
    if (y2 < x)
      return 1;
    return 0;
  };
  function bidirectionalIndexOf(buffer2, val, byteOffset, encoding, dir) {
    if (buffer2.length === 0)
      return -1;
    if (typeof byteOffset === "string") {
      encoding = byteOffset;
      byteOffset = 0;
    } else if (byteOffset > 2147483647) {
      byteOffset = 2147483647;
    } else if (byteOffset < -2147483648) {
      byteOffset = -2147483648;
    }
    byteOffset = +byteOffset;
    if (numberIsNaN(byteOffset)) {
      byteOffset = dir ? 0 : buffer2.length - 1;
    }
    if (byteOffset < 0)
      byteOffset = buffer2.length + byteOffset;
    if (byteOffset >= buffer2.length) {
      if (dir)
        return -1;
      else
        byteOffset = buffer2.length - 1;
    } else if (byteOffset < 0) {
      if (dir)
        byteOffset = 0;
      else
        return -1;
    }
    if (typeof val === "string") {
      val = Buffer2.from(val, encoding);
    }
    if (Buffer2.isBuffer(val)) {
      if (val.length === 0) {
        return -1;
      }
      return arrayIndexOf(buffer2, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
      val = val & 255;
      if (typeof Uint8Array.prototype.indexOf === "function") {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer2, val, byteOffset);
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer2, val, byteOffset);
        }
      }
      return arrayIndexOf(buffer2, [val], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
  }
  function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== void 0) {
      encoding = String(encoding).toLowerCase();
      if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
        if (arr.length < 2 || val.length < 2) {
          return -1;
        }
        indexSize = 2;
        arrLength /= 2;
        valLength /= 2;
        byteOffset /= 2;
      }
    }
    function read(buf, i3) {
      if (indexSize === 1) {
        return buf[i3];
      } else {
        return buf.readUInt16BE(i3 * indexSize);
      }
    }
    let i2;
    if (dir) {
      let foundIndex = -1;
      for (i2 = byteOffset; i2 < arrLength; i2++) {
        if (read(arr, i2) === read(val, foundIndex === -1 ? 0 : i2 - foundIndex)) {
          if (foundIndex === -1)
            foundIndex = i2;
          if (i2 - foundIndex + 1 === valLength)
            return foundIndex * indexSize;
        } else {
          if (foundIndex !== -1)
            i2 -= i2 - foundIndex;
          foundIndex = -1;
        }
      }
    } else {
      if (byteOffset + valLength > arrLength)
        byteOffset = arrLength - valLength;
      for (i2 = byteOffset; i2 >= 0; i2--) {
        let found = true;
        for (let j = 0; j < valLength; j++) {
          if (read(arr, i2 + j) !== read(val, j)) {
            found = false;
            break;
          }
        }
        if (found)
          return i2;
      }
    }
    return -1;
  }
  Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
  };
  Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
  };
  Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
  };
  function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) {
      length = remaining;
    } else {
      length = Number(length);
      if (length > remaining) {
        length = remaining;
      }
    }
    const strLen = string.length;
    if (length > strLen / 2) {
      length = strLen / 2;
    }
    let i2;
    for (i2 = 0; i2 < length; ++i2) {
      const parsed = parseInt(string.substr(i2 * 2, 2), 16);
      if (numberIsNaN(parsed))
        return i2;
      buf[offset + i2] = parsed;
    }
    return i2;
  }
  function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
  }
  function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
  }
  function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
  }
  function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
  }
  Buffer2.prototype.write = function write(string, offset, length, encoding) {
    if (offset === void 0) {
      encoding = "utf8";
      length = this.length;
      offset = 0;
    } else if (length === void 0 && typeof offset === "string") {
      encoding = offset;
      length = this.length;
      offset = 0;
    } else if (isFinite(offset)) {
      offset = offset >>> 0;
      if (isFinite(length)) {
        length = length >>> 0;
        if (encoding === void 0)
          encoding = "utf8";
      } else {
        encoding = length;
        length = void 0;
      }
    } else {
      throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    }
    const remaining = this.length - offset;
    if (length === void 0 || length > remaining)
      length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
      throw new RangeError("Attempt to write outside buffer bounds");
    }
    if (!encoding)
      encoding = "utf8";
    let loweredCase = false;
    for (; ; ) {
      switch (encoding) {
        case "hex":
          return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
          return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
          return asciiWrite(this, string, offset, length);
        case "base64":
          return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ucs2Write(this, string, offset, length);
        default:
          if (loweredCase)
            throw new TypeError("Unknown encoding: " + encoding);
          encoding = ("" + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  };
  Buffer2.prototype.toJSON = function toJSON() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) {
      return base64.fromByteArray(buf);
    } else {
      return base64.fromByteArray(buf.slice(start, end));
    }
  }
  function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i2 = start;
    while (i2 < end) {
      const firstByte = buf[i2];
      let codePoint = null;
      let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
      if (i2 + bytesPerSequence <= end) {
        let secondByte, thirdByte, fourthByte, tempCodePoint;
        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 128) {
              codePoint = firstByte;
            }
            break;
          case 2:
            secondByte = buf[i2 + 1];
            if ((secondByte & 192) === 128) {
              tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
              if (tempCodePoint > 127) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 3:
            secondByte = buf[i2 + 1];
            thirdByte = buf[i2 + 2];
            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
              tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
              if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 4:
            secondByte = buf[i2 + 1];
            thirdByte = buf[i2 + 2];
            fourthByte = buf[i2 + 3];
            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
              tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
              if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                codePoint = tempCodePoint;
              }
            }
        }
      }
      if (codePoint === null) {
        codePoint = 65533;
        bytesPerSequence = 1;
      } else if (codePoint > 65535) {
        codePoint -= 65536;
        res.push(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
      }
      res.push(codePoint);
      i2 += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
  }
  const MAX_ARGUMENTS_LENGTH = 4096;
  function decodeCodePointsArray(codePoints) {
    const len2 = codePoints.length;
    if (len2 <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints);
    }
    let res = "";
    let i2 = 0;
    while (i2 < len2) {
      res += String.fromCharCode.apply(String, codePoints.slice(i2, i2 += MAX_ARGUMENTS_LENGTH));
    }
    return res;
  }
  function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for (let i2 = start; i2 < end; ++i2) {
      ret += String.fromCharCode(buf[i2] & 127);
    }
    return ret;
  }
  function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for (let i2 = start; i2 < end; ++i2) {
      ret += String.fromCharCode(buf[i2]);
    }
    return ret;
  }
  function hexSlice(buf, start, end) {
    const len2 = buf.length;
    if (!start || start < 0)
      start = 0;
    if (!end || end < 0 || end > len2)
      end = len2;
    let out = "";
    for (let i2 = start; i2 < end; ++i2) {
      out += hexSliceLookupTable[buf[i2]];
    }
    return out;
  }
  function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    for (let i2 = 0; i2 < bytes.length - 1; i2 += 2) {
      res += String.fromCharCode(bytes[i2] + bytes[i2 + 1] * 256);
    }
    return res;
  }
  Buffer2.prototype.slice = function slice(start, end) {
    const len2 = this.length;
    start = ~~start;
    end = end === void 0 ? len2 : ~~end;
    if (start < 0) {
      start += len2;
      if (start < 0)
        start = 0;
    } else if (start > len2) {
      start = len2;
    }
    if (end < 0) {
      end += len2;
      if (end < 0)
        end = 0;
    } else if (end > len2) {
      end = len2;
    }
    if (end < start)
      end = start;
    const newBuf = this.subarray(start, end);
    Object.setPrototypeOf(newBuf, Buffer2.prototype);
    return newBuf;
  };
  function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0)
      throw new RangeError("offset is not uint");
    if (offset + ext > length)
      throw new RangeError("Trying to access beyond buffer length");
  }
  Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    let val = this[offset];
    let mul = 1;
    let i2 = 0;
    while (++i2 < byteLength3 && (mul *= 256)) {
      val += this[offset + i2] * mul;
    }
    return val;
  };
  Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      checkOffset(offset, byteLength3, this.length);
    }
    let val = this[offset + --byteLength3];
    let mul = 1;
    while (byteLength3 > 0 && (mul *= 256)) {
      val += this[offset + --byteLength3] * mul;
    }
    return val;
  };
  Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 1, this.length);
    return this[offset];
  };
  Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
  };
  Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
  };
  Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
  };
  Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
  };
  Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
  });
  Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
  });
  Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    let val = this[offset];
    let mul = 1;
    let i2 = 0;
    while (++i2 < byteLength3 && (mul *= 256)) {
      val += this[offset + i2] * mul;
    }
    mul *= 128;
    if (val >= mul)
      val -= Math.pow(2, 8 * byteLength3);
    return val;
  };
  Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    let i2 = byteLength3;
    let mul = 1;
    let val = this[offset + --i2];
    while (i2 > 0 && (mul *= 256)) {
      val += this[offset + --i2] * mul;
    }
    mul *= 128;
    if (val >= mul)
      val -= Math.pow(2, 8 * byteLength3);
    return val;
  };
  Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 1, this.length);
    if (!(this[offset] & 128))
      return this[offset];
    return (255 - this[offset] + 1) * -1;
  };
  Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 32768 ? val | 4294901760 : val;
  };
  Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 32768 ? val | 4294901760 : val;
  };
  Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
  };
  Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
  };
  Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last << 24);
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
  });
  Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const val = (first << 24) + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last);
  });
  Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return ieee754$1.read(this, offset, true, 23, 4);
  };
  Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return ieee754$1.read(this, offset, false, 23, 4);
  };
  Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 8, this.length);
    return ieee754$1.read(this, offset, true, 52, 8);
  };
  Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 8, this.length);
    return ieee754$1.read(this, offset, false, 52, 8);
  };
  function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer2.isBuffer(buf))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min)
      throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length)
      throw new RangeError("Index out of range");
  }
  Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      const maxBytes = Math.pow(2, 8 * byteLength3) - 1;
      checkInt(this, value, offset, byteLength3, maxBytes, 0);
    }
    let mul = 1;
    let i2 = 0;
    this[offset] = value & 255;
    while (++i2 < byteLength3 && (mul *= 256)) {
      this[offset + i2] = value / mul & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      const maxBytes = Math.pow(2, 8 * byteLength3) - 1;
      checkInt(this, value, offset, byteLength3, maxBytes, 0);
    }
    let i2 = byteLength3 - 1;
    let mul = 1;
    this[offset + i2] = value & 255;
    while (--i2 >= 0 && (mul *= 256)) {
      this[offset + i2] = value / mul & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 1, 255, 0);
    this[offset] = value & 255;
    return offset + 1;
  };
  Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 65535, 0);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    return offset + 2;
  };
  Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 65535, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 255;
    return offset + 2;
  };
  Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 4294967295, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 255;
    return offset + 4;
  };
  Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 4294967295, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 255;
    return offset + 4;
  };
  function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(4294967295));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(4294967295));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
  }
  function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(4294967295));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(4294967295));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
  }
  Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
  });
  Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
  });
  Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      const limit = Math.pow(2, 8 * byteLength3 - 1);
      checkInt(this, value, offset, byteLength3, limit - 1, -limit);
    }
    let i2 = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 255;
    while (++i2 < byteLength3 && (mul *= 256)) {
      if (value < 0 && sub === 0 && this[offset + i2 - 1] !== 0) {
        sub = 1;
      }
      this[offset + i2] = (value / mul >> 0) - sub & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      const limit = Math.pow(2, 8 * byteLength3 - 1);
      checkInt(this, value, offset, byteLength3, limit - 1, -limit);
    }
    let i2 = byteLength3 - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i2] = value & 255;
    while (--i2 >= 0 && (mul *= 256)) {
      if (value < 0 && sub === 0 && this[offset + i2 + 1] !== 0) {
        sub = 1;
      }
      this[offset + i2] = (value / mul >> 0) - sub & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 1, 127, -128);
    if (value < 0)
      value = 255 + value + 1;
    this[offset] = value & 255;
    return offset + 1;
  };
  Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 32767, -32768);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    return offset + 2;
  };
  Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 32767, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 255;
    return offset + 2;
  };
  Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 2147483647, -2147483648);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
  };
  Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 2147483647, -2147483648);
    if (value < 0)
      value = 4294967295 + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 255;
    return offset + 4;
  };
  Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length)
      throw new RangeError("Index out of range");
    if (offset < 0)
      throw new RangeError("Index out of range");
  }
  function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 4);
    }
    ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
  }
  Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
  };
  Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
  };
  function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 8);
    }
    ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
  }
  Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
  };
  Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
  };
  Buffer2.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer2.isBuffer(target))
      throw new TypeError("argument should be a Buffer");
    if (!start)
      start = 0;
    if (!end && end !== 0)
      end = this.length;
    if (targetStart >= target.length)
      targetStart = target.length;
    if (!targetStart)
      targetStart = 0;
    if (end > 0 && end < start)
      end = start;
    if (end === start)
      return 0;
    if (target.length === 0 || this.length === 0)
      return 0;
    if (targetStart < 0) {
      throw new RangeError("targetStart out of bounds");
    }
    if (start < 0 || start >= this.length)
      throw new RangeError("Index out of range");
    if (end < 0)
      throw new RangeError("sourceEnd out of bounds");
    if (end > this.length)
      end = this.length;
    if (target.length - targetStart < end - start) {
      end = target.length - targetStart + start;
    }
    const len2 = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
      this.copyWithin(targetStart, start, end);
    } else {
      Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    }
    return len2;
  };
  Buffer2.prototype.fill = function fill(val, start, end, encoding) {
    if (typeof val === "string") {
      if (typeof start === "string") {
        encoding = start;
        start = 0;
        end = this.length;
      } else if (typeof end === "string") {
        encoding = end;
        end = this.length;
      }
      if (encoding !== void 0 && typeof encoding !== "string") {
        throw new TypeError("encoding must be a string");
      }
      if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      if (val.length === 1) {
        const code2 = val.charCodeAt(0);
        if (encoding === "utf8" && code2 < 128 || encoding === "latin1") {
          val = code2;
        }
      }
    } else if (typeof val === "number") {
      val = val & 255;
    } else if (typeof val === "boolean") {
      val = Number(val);
    }
    if (start < 0 || this.length < start || this.length < end) {
      throw new RangeError("Out of range index");
    }
    if (end <= start) {
      return this;
    }
    start = start >>> 0;
    end = end === void 0 ? this.length : end >>> 0;
    if (!val)
      val = 0;
    let i2;
    if (typeof val === "number") {
      for (i2 = start; i2 < end; ++i2) {
        this[i2] = val;
      }
    } else {
      const bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
      const len2 = bytes.length;
      if (len2 === 0) {
        throw new TypeError('The value "' + val + '" is invalid for argument "value"');
      }
      for (i2 = 0; i2 < end - start; ++i2) {
        this[i2 + start] = bytes[i2 % len2];
      }
    }
    return this;
  };
  const errors = {};
  function E2(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
      constructor() {
        super();
        Object.defineProperty(this, "message", {
          value: getMessage.apply(this, arguments),
          writable: true,
          configurable: true
        });
        this.name = `${this.name} [${sym}]`;
        this.stack;
        delete this.name;
      }
      get code() {
        return sym;
      }
      set code(value) {
        Object.defineProperty(this, "code", {
          configurable: true,
          enumerable: true,
          value,
          writable: true
        });
      }
      toString() {
        return `${this.name} [${sym}]: ${this.message}`;
      }
    };
  }
  E2("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) {
      return `${name} is outside of buffer bounds`;
    }
    return "Attempt to access memory outside buffer bounds";
  }, RangeError);
  E2("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
  }, TypeError);
  E2("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input));
    } else if (typeof input === "bigint") {
      received = String(input);
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received);
      }
      received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
  }, RangeError);
  function addNumericalSeparator(val) {
    let res = "";
    let i2 = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for (; i2 >= start + 4; i2 -= 3) {
      res = `_${val.slice(i2 - 3, i2)}${res}`;
    }
    return `${val.slice(0, i2)}${res}`;
  }
  function checkBounds(buf, offset, byteLength3) {
    validateNumber(offset, "offset");
    if (buf[offset] === void 0 || buf[offset + byteLength3] === void 0) {
      boundsError(offset, buf.length - (byteLength3 + 1));
    }
  }
  function checkIntBI(value, min, max, buf, offset, byteLength3) {
    if (value > max || value < min) {
      const n2 = typeof min === "bigint" ? "n" : "";
      let range;
      if (byteLength3 > 3) {
        if (min === 0 || min === BigInt(0)) {
          range = `>= 0${n2} and < 2${n2} ** ${(byteLength3 + 1) * 8}${n2}`;
        } else {
          range = `>= -(2${n2} ** ${(byteLength3 + 1) * 8 - 1}${n2}) and < 2 ** ${(byteLength3 + 1) * 8 - 1}${n2}`;
        }
      } else {
        range = `>= ${min}${n2} and <= ${max}${n2}`;
      }
      throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength3);
  }
  function validateNumber(value, name) {
    if (typeof value !== "number") {
      throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
    }
  }
  function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
      validateNumber(value, type);
      throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) {
      throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    }
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
  }
  const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
  function base64clean(str) {
    str = str.split("=")[0];
    str = str.trim().replace(INVALID_BASE64_RE, "");
    if (str.length < 2)
      return "";
    while (str.length % 4 !== 0) {
      str = str + "=";
    }
    return str;
  }
  function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for (let i2 = 0; i2 < length; ++i2) {
      codePoint = string.charCodeAt(i2);
      if (codePoint > 55295 && codePoint < 57344) {
        if (!leadSurrogate) {
          if (codePoint > 56319) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            continue;
          } else if (i2 + 1 === length) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            continue;
          }
          leadSurrogate = codePoint;
          continue;
        }
        if (codePoint < 56320) {
          if ((units -= 3) > -1)
            bytes.push(239, 191, 189);
          leadSurrogate = codePoint;
          continue;
        }
        codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
      } else if (leadSurrogate) {
        if ((units -= 3) > -1)
          bytes.push(239, 191, 189);
      }
      leadSurrogate = null;
      if (codePoint < 128) {
        if ((units -= 1) < 0)
          break;
        bytes.push(codePoint);
      } else if (codePoint < 2048) {
        if ((units -= 2) < 0)
          break;
        bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
      } else if (codePoint < 65536) {
        if ((units -= 3) < 0)
          break;
        bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
      } else if (codePoint < 1114112) {
        if ((units -= 4) < 0)
          break;
        bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
      } else {
        throw new Error("Invalid code point");
      }
    }
    return bytes;
  }
  function asciiToBytes(str) {
    const byteArray = [];
    for (let i2 = 0; i2 < str.length; ++i2) {
      byteArray.push(str.charCodeAt(i2) & 255);
    }
    return byteArray;
  }
  function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for (let i2 = 0; i2 < str.length; ++i2) {
      if ((units -= 2) < 0)
        break;
      c = str.charCodeAt(i2);
      hi = c >> 8;
      lo = c % 256;
      byteArray.push(lo);
      byteArray.push(hi);
    }
    return byteArray;
  }
  function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
  }
  function blitBuffer(src, dst, offset, length) {
    let i2;
    for (i2 = 0; i2 < length; ++i2) {
      if (i2 + offset >= dst.length || i2 >= src.length)
        break;
      dst[i2 + offset] = src[i2];
    }
    return i2;
  }
  function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
  }
  function numberIsNaN(obj) {
    return obj !== obj;
  }
  const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for (let i2 = 0; i2 < 16; ++i2) {
      const i16 = i2 * 16;
      for (let j = 0; j < 16; ++j) {
        table[i16 + j] = alphabet[i2] + alphabet[j];
      }
    }
    return table;
  }();
  function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
  }
  function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
  }
})(buffer);
(function(exports2) {
  var QueryString = exports2;
  var Buffer2 = buffer.Buffer;
  QueryString.unescapeBuffer = function(s, decodeSpaces) {
    var out = new Buffer2(s.length);
    var state = 0;
    var n2, m, hexchar;
    for (var inIndex = 0, outIndex = 0; inIndex <= s.length; inIndex++) {
      var c = inIndex < s.length ? s.charCodeAt(inIndex) : NaN;
      switch (state) {
        case 0:
          switch (c) {
            case 37:
              n2 = 0;
              m = 0;
              state = 1;
              break;
            case 43:
              if (decodeSpaces)
                c = 32;
            default:
              out[outIndex++] = c;
              break;
          }
          break;
        case 1:
          hexchar = c;
          if (c >= 48 && c <= 57) {
            n2 = c - 48;
          } else if (c >= 65 && c <= 70) {
            n2 = c - 65 + 10;
          } else if (c >= 97 && c <= 102) {
            n2 = c - 97 + 10;
          } else {
            out[outIndex++] = 37;
            out[outIndex++] = c;
            state = 0;
            break;
          }
          state = 2;
          break;
        case 2:
          state = 0;
          if (c >= 48 && c <= 57) {
            m = c - 48;
          } else if (c >= 65 && c <= 70) {
            m = c - 65 + 10;
          } else if (c >= 97 && c <= 102) {
            m = c - 97 + 10;
          } else {
            out[outIndex++] = 37;
            out[outIndex++] = hexchar;
            out[outIndex++] = c;
            break;
          }
          out[outIndex++] = 16 * n2 + m;
          break;
      }
    }
    return out.slice(0, outIndex - 1);
  };
  function qsUnescape(s, decodeSpaces) {
    try {
      return decodeURIComponent(s);
    } catch (e) {
      return QueryString.unescapeBuffer(s, decodeSpaces).toString();
    }
  }
  QueryString.unescape = qsUnescape;
  var hexTable = new Array(256);
  for (var i2 = 0; i2 < 256; ++i2)
    hexTable[i2] = "%" + ((i2 < 16 ? "0" : "") + i2.toString(16)).toUpperCase();
  QueryString.escape = function(str) {
    if (typeof str !== "string")
      str += "";
    var out = "";
    var lastPos = 0;
    for (var i3 = 0; i3 < str.length; ++i3) {
      var c = str.charCodeAt(i3);
      if (c === 33 || c === 45 || c === 46 || c === 95 || c === 126 || c >= 39 && c <= 42 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122) {
        continue;
      }
      if (i3 - lastPos > 0)
        out += str.slice(lastPos, i3);
      if (c < 128) {
        lastPos = i3 + 1;
        out += hexTable[c];
        continue;
      }
      if (c < 2048) {
        lastPos = i3 + 1;
        out += hexTable[192 | c >> 6] + hexTable[128 | c & 63];
        continue;
      }
      if (c < 55296 || c >= 57344) {
        lastPos = i3 + 1;
        out += hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
        continue;
      }
      ++i3;
      var c2;
      if (i3 < str.length)
        c2 = str.charCodeAt(i3) & 1023;
      else
        throw new URIError("URI malformed");
      lastPos = i3 + 1;
      c = 65536 + ((c & 1023) << 10 | c2);
      out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
    }
    if (lastPos === 0)
      return str;
    if (lastPos < str.length)
      return out + str.slice(lastPos);
    return out;
  };
  var stringifyPrimitive = function(v2) {
    if (typeof v2 === "string")
      return v2;
    if (typeof v2 === "number" && isFinite(v2))
      return "" + v2;
    if (typeof v2 === "boolean")
      return v2 ? "true" : "false";
    return "";
  };
  QueryString.stringify = QueryString.encode = function(obj, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var encode = QueryString.escape;
    if (options && typeof options.encodeURIComponent === "function") {
      encode = options.encodeURIComponent;
    }
    if (obj !== null && typeof obj === "object") {
      var keys = Object.keys(obj);
      var len2 = keys.length;
      var flast = len2 - 1;
      var fields = "";
      for (var i3 = 0; i3 < len2; ++i3) {
        var k = keys[i3];
        var v2 = obj[k];
        var ks = encode(stringifyPrimitive(k)) + eq;
        if (Array.isArray(v2)) {
          var vlen = v2.length;
          var vlast = vlen - 1;
          for (var j = 0; j < vlen; ++j) {
            fields += ks + encode(stringifyPrimitive(v2[j]));
            if (j < vlast)
              fields += sep;
          }
          if (vlen && i3 < flast)
            fields += sep;
        } else {
          fields += ks + encode(stringifyPrimitive(v2));
          if (i3 < flast)
            fields += sep;
        }
      }
      return fields;
    }
    return "";
  };
  QueryString.parse = QueryString.decode = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) {
      return obj;
    }
    if (typeof sep !== "string")
      sep += "";
    var eqLen = eq.length;
    var sepLen = sep.length;
    var maxKeys = 1e3;
    if (options && typeof options.maxKeys === "number") {
      maxKeys = options.maxKeys;
    }
    var pairs = Infinity;
    if (maxKeys > 0)
      pairs = maxKeys;
    var decode = QueryString.unescape;
    if (options && typeof options.decodeURIComponent === "function") {
      decode = options.decodeURIComponent;
    }
    var customDecode = decode !== qsUnescape;
    var keys = [];
    var lastPos = 0;
    var sepIdx = 0;
    var eqIdx = 0;
    var key = "";
    var value = "";
    var keyEncoded = customDecode;
    var valEncoded = customDecode;
    var encodeCheck = 0;
    for (var i3 = 0; i3 < qs.length; ++i3) {
      var code2 = qs.charCodeAt(i3);
      if (code2 === sep.charCodeAt(sepIdx)) {
        if (++sepIdx === sepLen) {
          var end = i3 - sepIdx + 1;
          if (eqIdx < eqLen) {
            if (lastPos < end)
              key += qs.slice(lastPos, end);
          } else if (lastPos < end)
            value += qs.slice(lastPos, end);
          if (keyEncoded)
            key = decodeStr(key, decode);
          if (valEncoded)
            value = decodeStr(value, decode);
          if (keys.indexOf(key) === -1) {
            obj[key] = value;
            keys[keys.length] = key;
          } else {
            var curValue = obj[key];
            if (curValue instanceof Array)
              curValue[curValue.length] = value;
            else
              obj[key] = [curValue, value];
          }
          if (--pairs === 0)
            break;
          keyEncoded = valEncoded = customDecode;
          encodeCheck = 0;
          key = value = "";
          lastPos = i3 + 1;
          sepIdx = eqIdx = 0;
        }
        continue;
      } else {
        sepIdx = 0;
        if (!valEncoded) {
          if (code2 === 37) {
            encodeCheck = 1;
          } else if (encodeCheck > 0 && (code2 >= 48 && code2 <= 57 || code2 >= 65 && code2 <= 70 || code2 >= 97 && code2 <= 102)) {
            if (++encodeCheck === 3)
              valEncoded = true;
          } else {
            encodeCheck = 0;
          }
        }
      }
      if (eqIdx < eqLen) {
        if (code2 === eq.charCodeAt(eqIdx)) {
          if (++eqIdx === eqLen) {
            var end = i3 - eqIdx + 1;
            if (lastPos < end)
              key += qs.slice(lastPos, end);
            encodeCheck = 0;
            lastPos = i3 + 1;
          }
          continue;
        } else {
          eqIdx = 0;
          if (!keyEncoded) {
            if (code2 === 37) {
              encodeCheck = 1;
            } else if (encodeCheck > 0 && (code2 >= 48 && code2 <= 57 || code2 >= 65 && code2 <= 70 || code2 >= 97 && code2 <= 102)) {
              if (++encodeCheck === 3)
                keyEncoded = true;
            } else {
              encodeCheck = 0;
            }
          }
        }
      }
      if (code2 === 43) {
        if (eqIdx < eqLen) {
          if (i3 - lastPos > 0)
            key += qs.slice(lastPos, i3);
          key += "%20";
          keyEncoded = true;
        } else {
          if (i3 - lastPos > 0)
            value += qs.slice(lastPos, i3);
          value += "%20";
          valEncoded = true;
        }
        lastPos = i3 + 1;
      }
    }
    if (pairs > 0 && (lastPos < qs.length || eqIdx > 0)) {
      if (lastPos < qs.length) {
        if (eqIdx < eqLen)
          key += qs.slice(lastPos);
        else if (sepIdx < sepLen)
          value += qs.slice(lastPos);
      }
      if (keyEncoded)
        key = decodeStr(key, decode);
      if (valEncoded)
        value = decodeStr(value, decode);
      if (keys.indexOf(key) === -1) {
        obj[key] = value;
        keys[keys.length] = key;
      } else {
        var curValue = obj[key];
        if (curValue instanceof Array)
          curValue[curValue.length] = value;
        else
          obj[key] = [curValue, value];
      }
    }
    return obj;
  };
  function decodeStr(s, decoder) {
    try {
      return decoder(s);
    } catch (e) {
      return QueryString.unescape(s, true);
    }
  }
})(querystring);
var sha256 = { exports: {} };
var core = { exports: {} };
(function(module, exports2) {
  (function(root, factory) {
    {
      module.exports = factory();
    }
  })(commonjsGlobal$1, function() {
    var CryptoJS = CryptoJS || function(Math2, undefined$1) {
      var crypto;
      if (typeof window !== "undefined" && window.crypto) {
        crypto = window.crypto;
      }
      if (typeof self !== "undefined" && self.crypto) {
        crypto = self.crypto;
      }
      if (typeof globalThis !== "undefined" && globalThis.crypto) {
        crypto = globalThis.crypto;
      }
      if (!crypto && typeof window !== "undefined" && window.msCrypto) {
        crypto = window.msCrypto;
      }
      if (!crypto && typeof commonjsGlobal$1 !== "undefined" && commonjsGlobal$1.crypto) {
        crypto = commonjsGlobal$1.crypto;
      }
      if (!crypto && typeof commonjsRequire === "function") {
        try {
          crypto = require("crypto");
        } catch (err) {
        }
      }
      var cryptoSecureRandomInt = function() {
        if (crypto) {
          if (typeof crypto.getRandomValues === "function") {
            try {
              return crypto.getRandomValues(new Uint32Array(1))[0];
            } catch (err) {
            }
          }
          if (typeof crypto.randomBytes === "function") {
            try {
              return crypto.randomBytes(4).readInt32LE();
            } catch (err) {
            }
          }
        }
        throw new Error("Native crypto module could not be used to get secure random number.");
      };
      var create = Object.create || function() {
        function F2() {
        }
        return function(obj) {
          var subtype;
          F2.prototype = obj;
          subtype = new F2();
          F2.prototype = null;
          return subtype;
        };
      }();
      var C2 = {};
      var C_lib = C2.lib = {};
      var Base = C_lib.Base = function() {
        return {
          extend: function(overrides) {
            var subtype = create(this);
            if (overrides) {
              subtype.mixIn(overrides);
            }
            if (!subtype.hasOwnProperty("init") || this.init === subtype.init) {
              subtype.init = function() {
                subtype.$super.init.apply(this, arguments);
              };
            }
            subtype.init.prototype = subtype;
            subtype.$super = this;
            return subtype;
          },
          create: function() {
            var instance2 = this.extend();
            instance2.init.apply(instance2, arguments);
            return instance2;
          },
          init: function() {
          },
          mixIn: function(properties) {
            for (var propertyName in properties) {
              if (properties.hasOwnProperty(propertyName)) {
                this[propertyName] = properties[propertyName];
              }
            }
            if (properties.hasOwnProperty("toString")) {
              this.toString = properties.toString;
            }
          },
          clone: function() {
            return this.init.prototype.extend(this);
          }
        };
      }();
      var WordArray = C_lib.WordArray = Base.extend({
        init: function(words, sigBytes) {
          words = this.words = words || [];
          if (sigBytes != undefined$1) {
            this.sigBytes = sigBytes;
          } else {
            this.sigBytes = words.length * 4;
          }
        },
        toString: function(encoder) {
          return (encoder || Hex).stringify(this);
        },
        concat: function(wordArray) {
          var thisWords = this.words;
          var thatWords = wordArray.words;
          var thisSigBytes = this.sigBytes;
          var thatSigBytes = wordArray.sigBytes;
          this.clamp();
          if (thisSigBytes % 4) {
            for (var i2 = 0; i2 < thatSigBytes; i2++) {
              var thatByte = thatWords[i2 >>> 2] >>> 24 - i2 % 4 * 8 & 255;
              thisWords[thisSigBytes + i2 >>> 2] |= thatByte << 24 - (thisSigBytes + i2) % 4 * 8;
            }
          } else {
            for (var j = 0; j < thatSigBytes; j += 4) {
              thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
            }
          }
          this.sigBytes += thatSigBytes;
          return this;
        },
        clamp: function() {
          var words = this.words;
          var sigBytes = this.sigBytes;
          words[sigBytes >>> 2] &= 4294967295 << 32 - sigBytes % 4 * 8;
          words.length = Math2.ceil(sigBytes / 4);
        },
        clone: function() {
          var clone = Base.clone.call(this);
          clone.words = this.words.slice(0);
          return clone;
        },
        random: function(nBytes) {
          var words = [];
          for (var i2 = 0; i2 < nBytes; i2 += 4) {
            words.push(cryptoSecureRandomInt());
          }
          return new WordArray.init(words, nBytes);
        }
      });
      var C_enc = C2.enc = {};
      var Hex = C_enc.Hex = {
        stringify: function(wordArray) {
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes;
          var hexChars = [];
          for (var i2 = 0; i2 < sigBytes; i2++) {
            var bite = words[i2 >>> 2] >>> 24 - i2 % 4 * 8 & 255;
            hexChars.push((bite >>> 4).toString(16));
            hexChars.push((bite & 15).toString(16));
          }
          return hexChars.join("");
        },
        parse: function(hexStr) {
          var hexStrLength = hexStr.length;
          var words = [];
          for (var i2 = 0; i2 < hexStrLength; i2 += 2) {
            words[i2 >>> 3] |= parseInt(hexStr.substr(i2, 2), 16) << 24 - i2 % 8 * 4;
          }
          return new WordArray.init(words, hexStrLength / 2);
        }
      };
      var Latin1 = C_enc.Latin1 = {
        stringify: function(wordArray) {
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes;
          var latin1Chars = [];
          for (var i2 = 0; i2 < sigBytes; i2++) {
            var bite = words[i2 >>> 2] >>> 24 - i2 % 4 * 8 & 255;
            latin1Chars.push(String.fromCharCode(bite));
          }
          return latin1Chars.join("");
        },
        parse: function(latin1Str) {
          var latin1StrLength = latin1Str.length;
          var words = [];
          for (var i2 = 0; i2 < latin1StrLength; i2++) {
            words[i2 >>> 2] |= (latin1Str.charCodeAt(i2) & 255) << 24 - i2 % 4 * 8;
          }
          return new WordArray.init(words, latin1StrLength);
        }
      };
      var Utf8 = C_enc.Utf8 = {
        stringify: function(wordArray) {
          try {
            return decodeURIComponent(escape(Latin1.stringify(wordArray)));
          } catch (e) {
            throw new Error("Malformed UTF-8 data");
          }
        },
        parse: function(utf8Str) {
          return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
        }
      };
      var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
        reset: function() {
          this._data = new WordArray.init();
          this._nDataBytes = 0;
        },
        _append: function(data) {
          if (typeof data == "string") {
            data = Utf8.parse(data);
          }
          this._data.concat(data);
          this._nDataBytes += data.sigBytes;
        },
        _process: function(doFlush) {
          var processedWords;
          var data = this._data;
          var dataWords = data.words;
          var dataSigBytes = data.sigBytes;
          var blockSize = this.blockSize;
          var blockSizeBytes = blockSize * 4;
          var nBlocksReady = dataSigBytes / blockSizeBytes;
          if (doFlush) {
            nBlocksReady = Math2.ceil(nBlocksReady);
          } else {
            nBlocksReady = Math2.max((nBlocksReady | 0) - this._minBufferSize, 0);
          }
          var nWordsReady = nBlocksReady * blockSize;
          var nBytesReady = Math2.min(nWordsReady * 4, dataSigBytes);
          if (nWordsReady) {
            for (var offset = 0; offset < nWordsReady; offset += blockSize) {
              this._doProcessBlock(dataWords, offset);
            }
            processedWords = dataWords.splice(0, nWordsReady);
            data.sigBytes -= nBytesReady;
          }
          return new WordArray.init(processedWords, nBytesReady);
        },
        clone: function() {
          var clone = Base.clone.call(this);
          clone._data = this._data.clone();
          return clone;
        },
        _minBufferSize: 0
      });
      C_lib.Hasher = BufferedBlockAlgorithm.extend({
        cfg: Base.extend(),
        init: function(cfg) {
          this.cfg = this.cfg.extend(cfg);
          this.reset();
        },
        reset: function() {
          BufferedBlockAlgorithm.reset.call(this);
          this._doReset();
        },
        update: function(messageUpdate) {
          this._append(messageUpdate);
          this._process();
          return this;
        },
        finalize: function(messageUpdate) {
          if (messageUpdate) {
            this._append(messageUpdate);
          }
          var hash2 = this._doFinalize();
          return hash2;
        },
        blockSize: 512 / 32,
        _createHelper: function(hasher) {
          return function(message2, cfg) {
            return new hasher.init(cfg).finalize(message2);
          };
        },
        _createHmacHelper: function(hasher) {
          return function(message2, key) {
            return new C_algo.HMAC.init(hasher, key).finalize(message2);
          };
        }
      });
      var C_algo = C2.algo = {};
      return C2;
    }(Math);
    return CryptoJS;
  });
})(core);
(function(module, exports2) {
  (function(root, factory) {
    {
      module.exports = factory(core.exports);
    }
  })(commonjsGlobal$1, function(CryptoJS) {
    (function(Math2) {
      var C2 = CryptoJS;
      var C_lib = C2.lib;
      var WordArray = C_lib.WordArray;
      var Hasher = C_lib.Hasher;
      var C_algo = C2.algo;
      var H2 = [];
      var K2 = [];
      (function() {
        function isPrime(n3) {
          var sqrtN = Math2.sqrt(n3);
          for (var factor = 2; factor <= sqrtN; factor++) {
            if (!(n3 % factor)) {
              return false;
            }
          }
          return true;
        }
        function getFractionalBits(n3) {
          return (n3 - (n3 | 0)) * 4294967296 | 0;
        }
        var n2 = 2;
        var nPrime = 0;
        while (nPrime < 64) {
          if (isPrime(n2)) {
            if (nPrime < 8) {
              H2[nPrime] = getFractionalBits(Math2.pow(n2, 1 / 2));
            }
            K2[nPrime] = getFractionalBits(Math2.pow(n2, 1 / 3));
            nPrime++;
          }
          n2++;
        }
      })();
      var W2 = [];
      var SHA2562 = C_algo.SHA256 = Hasher.extend({
        _doReset: function() {
          this._hash = new WordArray.init(H2.slice(0));
        },
        _doProcessBlock: function(M2, offset) {
          var H3 = this._hash.words;
          var a2 = H3[0];
          var b = H3[1];
          var c = H3[2];
          var d = H3[3];
          var e = H3[4];
          var f = H3[5];
          var g = H3[6];
          var h = H3[7];
          for (var i2 = 0; i2 < 64; i2++) {
            if (i2 < 16) {
              W2[i2] = M2[offset + i2] | 0;
            } else {
              var gamma0x = W2[i2 - 15];
              var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
              var gamma1x = W2[i2 - 2];
              var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
              W2[i2] = gamma0 + W2[i2 - 7] + gamma1 + W2[i2 - 16];
            }
            var ch = e & f ^ ~e & g;
            var maj = a2 & b ^ a2 & c ^ b & c;
            var sigma0 = (a2 << 30 | a2 >>> 2) ^ (a2 << 19 | a2 >>> 13) ^ (a2 << 10 | a2 >>> 22);
            var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
            var t1 = h + sigma1 + ch + K2[i2] + W2[i2];
            var t2 = sigma0 + maj;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a2;
            a2 = t1 + t2 | 0;
          }
          H3[0] = H3[0] + a2 | 0;
          H3[1] = H3[1] + b | 0;
          H3[2] = H3[2] + c | 0;
          H3[3] = H3[3] + d | 0;
          H3[4] = H3[4] + e | 0;
          H3[5] = H3[5] + f | 0;
          H3[6] = H3[6] + g | 0;
          H3[7] = H3[7] + h | 0;
        },
        _doFinalize: function() {
          var data = this._data;
          var dataWords = data.words;
          var nBitsTotal = this._nDataBytes * 8;
          var nBitsLeft = data.sigBytes * 8;
          dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math2.floor(nBitsTotal / 4294967296);
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
          data.sigBytes = dataWords.length * 4;
          this._process();
          return this._hash;
        },
        clone: function() {
          var clone = Hasher.clone.call(this);
          clone._hash = this._hash.clone();
          return clone;
        }
      });
      C2.SHA256 = Hasher._createHelper(SHA2562);
      C2.HmacSHA256 = Hasher._createHmacHelper(SHA2562);
    })(Math);
    return CryptoJS.SHA256;
  });
})(sha256);
var SHA256 = sha256.exports;
var hmacSha256 = { exports: {} };
var hmac$1 = { exports: {} };
(function(module, exports2) {
  (function(root, factory) {
    {
      module.exports = factory(core.exports);
    }
  })(commonjsGlobal$1, function(CryptoJS) {
    (function() {
      var C2 = CryptoJS;
      var C_lib = C2.lib;
      var Base = C_lib.Base;
      var C_enc = C2.enc;
      var Utf8 = C_enc.Utf8;
      var C_algo = C2.algo;
      C_algo.HMAC = Base.extend({
        init: function(hasher, key) {
          hasher = this._hasher = new hasher.init();
          if (typeof key == "string") {
            key = Utf8.parse(key);
          }
          var hasherBlockSize = hasher.blockSize;
          var hasherBlockSizeBytes = hasherBlockSize * 4;
          if (key.sigBytes > hasherBlockSizeBytes) {
            key = hasher.finalize(key);
          }
          key.clamp();
          var oKey = this._oKey = key.clone();
          var iKey = this._iKey = key.clone();
          var oKeyWords = oKey.words;
          var iKeyWords = iKey.words;
          for (var i2 = 0; i2 < hasherBlockSize; i2++) {
            oKeyWords[i2] ^= 1549556828;
            iKeyWords[i2] ^= 909522486;
          }
          oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
          this.reset();
        },
        reset: function() {
          var hasher = this._hasher;
          hasher.reset();
          hasher.update(this._iKey);
        },
        update: function(messageUpdate) {
          this._hasher.update(messageUpdate);
          return this;
        },
        finalize: function(messageUpdate) {
          var hasher = this._hasher;
          var innerHash = hasher.finalize(messageUpdate);
          hasher.reset();
          var hmac2 = hasher.finalize(this._oKey.clone().concat(innerHash));
          return hmac2;
        }
      });
    })();
  });
})(hmac$1);
(function(module, exports2) {
  (function(root, factory, undef) {
    {
      module.exports = factory(core.exports, sha256.exports, hmac$1.exports);
    }
  })(commonjsGlobal$1, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
  });
})(hmacSha256);
var hmacSHA256 = hmacSha256.exports;
function lru(size) {
  return new LruCache(size);
}
function LruCache(size) {
  this.capacity = size | 0;
  this.map = Object.create(null);
  this.list = new DoublyLinkedList();
}
LruCache.prototype.get = function(key) {
  var node = this.map[key];
  if (node == null)
    return void 0;
  this.used(node);
  return node.val;
};
LruCache.prototype.set = function(key, val) {
  var node = this.map[key];
  if (node != null) {
    node.val = val;
  } else {
    if (!this.capacity)
      this.prune();
    if (!this.capacity)
      return false;
    node = new DoublyLinkedNode(key, val);
    this.map[key] = node;
    this.capacity--;
  }
  this.used(node);
  return true;
};
LruCache.prototype.used = function(node) {
  this.list.moveToFront(node);
};
LruCache.prototype.prune = function() {
  var node = this.list.pop();
  if (node != null) {
    delete this.map[node.key];
    this.capacity += 1;
  }
};
function DoublyLinkedList() {
  this.firstNode = null;
  this.lastNode = null;
}
DoublyLinkedList.prototype.moveToFront = function(node) {
  if (this.firstNode == node)
    return;
  this.remove(node);
  if (this.firstNode == null) {
    this.firstNode = node;
    this.lastNode = node;
    node.prev = null;
    node.next = null;
  } else {
    node.prev = null;
    node.next = this.firstNode;
    node.next.prev = node;
    this.firstNode = node;
  }
};
DoublyLinkedList.prototype.pop = function() {
  var lastNode = this.lastNode;
  if (lastNode != null) {
    this.remove(lastNode);
  }
  return lastNode;
};
DoublyLinkedList.prototype.remove = function(node) {
  if (this.firstNode == node) {
    this.firstNode = node.next;
  } else if (node.prev != null) {
    node.prev.next = node.next;
  }
  if (this.lastNode == node) {
    this.lastNode = node.prev;
  } else if (node.next != null) {
    node.next.prev = node.prev;
  }
};
function DoublyLinkedNode(key, val) {
  this.key = key;
  this.val = val;
  this.prev = null;
  this.next = null;
}
if (!querystring) {
  console.error("Error in callstats, querystring module undefined");
}
var credentialsCache = lru(1e3);
function hmac(key, string, encoding) {
  return hmacSHA256(string, key);
}
function hash(string, encoding) {
  return SHA256(string);
}
function encodeRfc3986(urlEncodedString) {
  return urlEncodedString.replace(/[!'()*]/g, function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
  });
}
function encodeRfc3986Full(str) {
  return encodeRfc3986(encodeURIComponent(str));
}
var HEADERS_TO_IGNORE = {
  authorization: true,
  connection: true,
  "x-amzn-trace-id": true,
  "user-agent": true,
  expect: true,
  "presigned-expires": true,
  range: true
};
function _RequestSigner(request, credentials) {
  if (typeof request === "string")
    request = new URL(request);
  var headers = request.headers = request.headers || {};
  var hostParts = (!this.service || !this.region) && this.matchHost(request.hostname || request.host || headers.Host || headers.host);
  this.request = request;
  this.credentials = credentials || this.defaultCredentials();
  this.service = request.service || hostParts[0] || "";
  this.region = request.region || hostParts[1] || "us-east-1";
  if (this.service === "email")
    this.service = "ses";
  if (!request.method && request.body)
    request.method = "POST";
  if (!headers.Host && !headers.host) {
    headers.Host = request.hostname || request.host || this.createHost();
    if (request.port)
      headers.Host += ":" + request.port;
  }
  if (!request.hostname && !request.host)
    request.hostname = headers.Host || headers.host;
  this.isCodeCommitGit = this.service === "codecommit" && request.method === "GIT";
}
_RequestSigner.prototype.matchHost = function(host) {
  var match = (host || "").match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com(\.cn)?$/);
  var hostParts = (match || []).slice(1, 3);
  if (hostParts[1] === "es")
    hostParts = hostParts.reverse();
  if (hostParts[1] == "s3") {
    hostParts[0] = "s3";
    hostParts[1] = "us-east-1";
  } else {
    for (var i2 = 0; i2 < 2; i2 += 1) {
      if (/^s3-/.test(hostParts[i2])) {
        hostParts[1] = hostParts[i2].slice(3);
        hostParts[0] = "s3";
        break;
      }
    }
  }
  return hostParts;
};
_RequestSigner.prototype.isSingleRegion = function() {
  if (["s3", "sdb"].indexOf(this.service) >= 0 && this.region === "us-east-1")
    return true;
  return ["cloudfront", "ls", "route53", "iam", "importexport", "sts"].indexOf(this.service) >= 0;
};
_RequestSigner.prototype.createHost = function() {
  var region = this.isSingleRegion() ? "" : "." + this.region;
  var subdomain = this.service === "ses" ? "email" : this.service;
  return subdomain + region + ".amazonaws.com";
};
_RequestSigner.prototype.prepareRequest = function() {
  try {
    this.parsePath();
  } catch (e) {
    console.error("Error in callstats:", e);
  }
  var request = this.request;
  var headers = request.headers;
  var query;
  if (request.signQuery) {
    this.parsedPath.query = query = this.parsedPath.query || {};
    if (this.credentials.sessionToken)
      query["X-Amz-Security-Token"] = this.credentials.sessionToken;
    if (this.service === "s3" && !query["X-Amz-Expires"])
      query["X-Amz-Expires"] = 86400;
    if (query["X-Amz-Date"])
      this.datetime = query["X-Amz-Date"];
    else
      query["X-Amz-Date"] = this.getDateTime();
    query["X-Amz-Algorithm"] = "AWS4-HMAC-SHA256";
    query["X-Amz-Credential"] = this.credentials.accessKeyId + "/" + this.credentialString();
    query["X-Amz-SignedHeaders"] = this.signedHeaders();
  } else {
    if (!request.doNotModifyHeaders && !this.isCodeCommitGit) {
      if (request.body && !headers["Content-Type"] && !headers["content-type"])
        headers["Content-Type"] = "application/x-www-form-urlencoded; charset=utf-8";
      if (request.body && !headers["Content-Length"] && !headers["content-length"])
        headers["Content-Length"] = Buffer.byteLength(request.body);
      if (this.credentials.sessionToken && !headers["X-Amz-Security-Token"] && !headers["x-amz-security-token"])
        headers["X-Amz-Security-Token"] = this.credentials.sessionToken;
      if (this.service === "s3" && !headers["X-Amz-Content-Sha256"] && !headers["x-amz-content-sha256"])
        headers["X-Amz-Content-Sha256"] = hash(this.request.body || "");
      if (headers["X-Amz-Date"] || headers["x-amz-date"])
        this.datetime = headers["X-Amz-Date"] || headers["x-amz-date"];
      else
        headers["X-Amz-Date"] = this.getDateTime();
    }
    delete headers.Authorization;
    delete headers.authorization;
  }
};
_RequestSigner.prototype.sign = function() {
  if (!this.parsedPath)
    this.prepareRequest();
  if (this.request.signQuery) {
    this.parsedPath.query["X-Amz-Signature"] = this.signature();
  } else {
    this.request.headers.Authorization = this.authHeader();
  }
  this.request.path = this.formatPath();
  return this.request;
};
_RequestSigner.prototype.getDateTime = function() {
  if (!this.datetime) {
    var headers = this.request.headers;
    var date = new Date(headers.Date || headers.date || new Date());
    this.datetime = date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
    if (this.isCodeCommitGit)
      this.datetime = this.datetime.slice(0, -1);
  }
  return this.datetime;
};
_RequestSigner.prototype.getDate = function() {
  return this.getDateTime().substr(0, 8);
};
_RequestSigner.prototype.authHeader = function() {
  return [
    "AWS4-HMAC-SHA256 Credential=" + this.credentials.accessKeyId + "/" + this.credentialString(),
    "SignedHeaders=" + this.signedHeaders(),
    "Signature=" + this.signature()
  ].join(", ");
};
_RequestSigner.prototype.signature = function() {
  var date = this.getDate();
  var cacheKey = [this.credentials.secretAccessKey, date, this.region, this.service].join();
  var kDate;
  var kRegion;
  var kService;
  var kCredentials = credentialsCache.get(cacheKey);
  if (!kCredentials) {
    kDate = hmac("AWS4" + this.credentials.secretAccessKey, date);
    kRegion = hmac(kDate, this.region);
    kService = hmac(kRegion, this.service);
    kCredentials = hmac(kService, "aws4_request");
    credentialsCache.set(cacheKey, kCredentials);
  }
  return hmac(kCredentials, this.stringToSign());
};
_RequestSigner.prototype.stringToSign = function() {
  return [
    "AWS4-HMAC-SHA256",
    this.getDateTime(),
    this.credentialString(),
    hash(this.canonicalString())
  ].join("\n");
};
_RequestSigner.prototype.canonicalString = function() {
  if (!this.parsedPath)
    this.prepareRequest();
  var pathStr = this.parsedPath.path;
  var query = this.parsedPath.query;
  var headers = this.request.headers;
  var queryStr = "";
  var normalizePath = this.service !== "s3";
  var decodePath = this.service === "s3" || this.request.doNotEncodePath;
  var decodeSlashesInPath = this.service === "s3";
  var firstValOnly = this.service === "s3";
  var bodyHash;
  if (this.service === "s3" && this.request.signQuery) {
    bodyHash = "UNSIGNED-PAYLOAD";
  } else if (this.isCodeCommitGit) {
    bodyHash = "";
  } else {
    bodyHash = headers["X-Amz-Content-Sha256"] || headers["x-amz-content-sha256"] || hash(this.request.body || "");
  }
  if (query) {
    var reducedQuery_1 = Object.keys(query).reduce(function(obj, key) {
      if (!key)
        return obj;
      obj[encodeRfc3986Full(key)] = !Array.isArray(query[key]) ? query[key] : firstValOnly ? query[key][0] : query[key];
      return obj;
    }, {});
    var encodedQueryPieces_1 = [];
    Object.keys(reducedQuery_1).sort().forEach(function(key) {
      if (!Array.isArray(reducedQuery_1[key])) {
        encodedQueryPieces_1.push(key + "=" + encodeRfc3986Full(reducedQuery_1[key]));
      } else {
        reducedQuery_1[key].map(encodeRfc3986Full).sort().forEach(function(val) {
          encodedQueryPieces_1.push(key + "=" + val);
        });
      }
    });
    queryStr = encodedQueryPieces_1.join("&");
  }
  if (pathStr !== "/") {
    if (normalizePath)
      pathStr = pathStr.replace(/\/{2,}/g, "/");
    pathStr = pathStr.split("/").reduce(function(path, piece) {
      if (normalizePath && piece === "..") {
        path.pop();
      } else if (!normalizePath || piece !== ".") {
        if (decodePath)
          piece = decodeURIComponent(piece.replace(/\+/g, " "));
        path.push(encodeRfc3986Full(piece));
      }
      return path;
    }, []).join("/");
    if (pathStr[0] !== "/")
      pathStr = "/" + pathStr;
    if (decodeSlashesInPath)
      pathStr = pathStr.replace(/%2F/g, "/");
  }
  return [
    this.request.method || "GET",
    pathStr,
    queryStr,
    this.canonicalHeaders() + "\n",
    this.signedHeaders(),
    bodyHash
  ].join("\n");
};
_RequestSigner.prototype.canonicalHeaders = function() {
  var headers = this.request.headers;
  function trimAll(header) {
    return header.toString().trim().replace(/\s+/g, " ");
  }
  return Object.keys(headers).filter(function(key) {
    return HEADERS_TO_IGNORE[key.toLowerCase()] == null;
  }).sort(function(a2, b) {
    return a2.toLowerCase() < b.toLowerCase() ? -1 : 1;
  }).map(function(key) {
    return key.toLowerCase() + ":" + trimAll(headers[key]);
  }).join("\n");
};
_RequestSigner.prototype.signedHeaders = function() {
  return Object.keys(this.request.headers).map(function(key) {
    return key.toLowerCase();
  }).filter(function(key) {
    return HEADERS_TO_IGNORE[key] == null;
  }).sort().join(";");
};
_RequestSigner.prototype.credentialString = function() {
  return [
    this.getDate(),
    this.region,
    this.service,
    "aws4_request"
  ].join("/");
};
_RequestSigner.prototype.defaultCredentials = function() {
  var env = process.env;
  return {
    accessKeyId: env.AWS_ACCESS_KEY_ID || env.AWS_ACCESS_KEY,
    secretAccessKey: env.AWS_SECRET_ACCESS_KEY || env.AWS_SECRET_KEY,
    sessionToken: env.AWS_SESSION_TOKEN
  };
};
_RequestSigner.prototype.parsePath = function() {
  var path = this.request.path || "/";
  if (/[^0-9A-Za-z;,/?:@&=+$\-_.!~*'()#%]/.test(path)) {
    path = encodeURI(decodeURI(path));
  }
  var queryIx = path.indexOf("?");
  var query = null;
  if (queryIx >= 0) {
    query = querystring.parse(path.slice(queryIx + 1));
    path = path.slice(0, queryIx);
  }
  this.parsedPath = {
    path,
    query
  };
};
_RequestSigner.prototype.formatPath = function() {
  var path = this.parsedPath.path;
  var query = this.parsedPath.query;
  if (!query)
    return path;
  if (query[""] != null)
    delete query[""];
  return path + "?" + encodeRfc3986(querystring.stringify(query));
};
var RequestSigner = _RequestSigner;
var sign = function(request, credentials) {
  return new RequestSigner(request, credentials).sign();
};
var __extends$7 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter$6 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$5 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f, y2, t2, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t2 = _.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t2[1]) {
              _.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _.label < t2[2]) {
              _.label = t2[2];
              _.ops.push(op);
              break;
            }
            if (t2[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var SQSConnector = function(_super) {
  __extends$7(SQSConnector2, _super);
  function SQSConnector2(env) {
    var _this = _super.call(this) || this;
    if (env === ClientEnvType.DEV)
      _this.logger = console;
    else
      _this.logger = { log: function(e) {
      }, error: function(e) {
      } };
    _this.config = {
      region: "ap-south-1",
      credentials: {
        accessKeyId: atob("QUtJQTVZQUhSS1pSQklZTjdXVTc="),
        secretAccessKey: atob("YVpIM2Y5SHlHZnp6ZDZ4OHg5SkhaZzlUcGVPS2Z0cE92MUk3bE1HKw==")
      }
    };
    if (env === ClientEnvType.PRODUCTION) {
      _this.config.queue = "/944908621410/Callstats-Queue";
    } else {
      _this.config.queue = "/944908621410/Callstats-Queue";
    }
    return _this;
  }
  SQSConnector2.prototype.sendChunk = function(data) {
    _super.prototype.sendChunk.call(this, data);
  };
  SQSConnector2.prototype.sendChunkToServer = function(data) {
    return __awaiter$6(this, void 0, void 0, function() {
      var packet, params, opts, command, error_1;
      return __generator$5(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            this.logger.log("finalCHUNK:", data);
            packet = {
              payload: data,
              peerId: this.authInfo.peerId
            };
            params = new URLSearchParams({
              Action: "SendMessage",
              MessageBody: JSON.stringify(packet)
            });
            _a3.label = 1;
          case 1:
            _a3.trys.push([1, 3, , 4]);
            opts = sign({
              service: "sqs",
              region: this.config.region,
              path: this.config.queue + "/?" + params.toString()
            }, this.config.credentials);
            command = "https://" + opts.hostname + opts.path;
            return [4, fetch(command, opts)];
          case 2:
            _a3.sent();
            return [2, true];
          case 3:
            error_1 = _a3.sent();
            this.logger.error("Error in SQSConnector.sendChunkToServer", error_1);
            return [2, false];
          case 4:
            return [2];
        }
      });
    });
  };
  return SQSConnector2;
}(PubSubConnector);
var __extends$6 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter$5 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$4 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f, y2, t2, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t2 = _.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t2[1]) {
              _.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _.label < t2[2]) {
              _.label = t2[2];
              _.ops.push(op);
              break;
            }
            if (t2[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read$3 = globalThis && globalThis.__read || function(o, n2) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i2 = m.call(o), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m = i2["return"]))
        m.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var CallTest = function() {
  function CallTest2(config2) {
    this.constrainOfferToRemoveVideoFec = false;
    var pc1 = new RTCPeerConnection(config2);
    var pc2 = new RTCPeerConnection(config2);
    this.pc1 = pc1;
    this.pc2 = pc2;
    this.iceCandidateFilter = CallTest2.noFilter;
    this.pc1.addEventListener("icecandidate", this.onIceCandidate.bind(this, this.pc2));
    this.pc2.addEventListener("icecandidate", this.onIceCandidate.bind(this, this.pc1));
  }
  CallTest2.parseCandidate = function(text) {
    var candidateStr = "candidate:";
    var pos = text.indexOf(candidateStr) + candidateStr.length;
    var fields = text.substr(pos).split(" ");
    return {
      type: fields[7],
      protocol: fields[2],
      address: fields[4]
    };
  };
  CallTest2.isNotHostCandidate = function(candidate) {
    return candidate.type !== "host";
  };
  CallTest2.isHost = function(candidate) {
    return candidate.type === "host";
  };
  CallTest2.isRelay = function(candidate) {
    return candidate.type === "relay";
  };
  CallTest2.isReflexive = function(candidate) {
    return candidate.type === "srflx";
  };
  CallTest2.noFilter = function(parsed) {
    return true;
  };
  CallTest2.prototype.onIceCandidate = function(otherPeer, event) {
    if (event.candidate) {
      var parsed = CallTest2.parseCandidate(event.candidate.candidate);
      if (this.iceCandidateFilter(parsed)) {
        otherPeer.addIceCandidate(event.candidate);
      }
    }
  };
  CallTest2.prototype.setIceCandidateFilter = function(filter) {
    this.iceCandidateFilter = filter;
  };
  CallTest2.prototype.constrainVideoBitrate = function(maxVideoBitrateKbps) {
    this.constrainVideoBitrateKbps = maxVideoBitrateKbps;
  };
  CallTest2.prototype.disableVideoFec = function() {
    this.constrainOfferToRemoveVideoFec = true;
  };
  CallTest2.prototype.gotOffer = function(offer) {
    if (this.constrainOfferToRemoveVideoFec) {
      offer.sdp = offer.sdp.replace(/(m=video 1 [^\r]+)(116 117)(\r\n)/g, "$1\r\n");
      offer.sdp = offer.sdp.replace(/a=rtpmap:116 red\/90000\r\n/g, "");
      offer.sdp = offer.sdp.replace(/a=rtpmap:117 ulpfec\/90000\r\n/g, "");
      offer.sdp = offer.sdp.replace(/a=rtpmap:98 rtx\/90000\r\n/g, "");
      offer.sdp = offer.sdp.replace(/a=fmtp:98 apt=116\r\n/g, "");
    }
    this.pc1.setLocalDescription(offer);
    this.pc2.setRemoteDescription(offer);
    this.pc2.createAnswer().then(this.gotAnswer.bind(this), this.reportFatal.bind(this));
  };
  CallTest2.prototype.gotAnswer = function(answer) {
    if (this.constrainVideoBitrateKbps) {
      answer.sdp = answer.sdp.replace(/a=mid:video\r\n/g, "a=mid:video\r\nb=AS:" + this.constrainVideoBitrateKbps + "\r\n");
    }
    this.pc2.setLocalDescription(answer);
    this.pc1.setRemoteDescription(answer);
  };
  CallTest2.prototype.establishConnection = function() {
    this.pc1.createOffer().then(this.gotOffer.bind(this), this.reportFatal.bind(this));
  };
  CallTest2.prototype.reportFatal = function(reason) {
    console.error("Error:", reason);
  };
  CallTest2.prototype.getRoundTripTime = function() {
    return __awaiter$5(this, void 0, void 0, function() {
      var _a3, sendStats, recieveStats, sendPairStats, recievePairStats, rtt;
      return __generator$4(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            return [4, Promise.all([this.pc1.getStats(), this.pc2.getStats()])];
          case 1:
            _a3 = __read$3.apply(void 0, [_b2.sent(), 2]), sendStats = _a3[0], recieveStats = _a3[1];
            sendStats.forEach(function(e) {
              if (e.type === "candidate-pair" && e.nominated === true && e.bytesSent > 0) {
                sendPairStats = e;
              }
            });
            recieveStats.forEach(function(e) {
              if (e.type === "candidate-pair" && e.nominated === true && e.bytesReceived > 0) {
                recievePairStats = e;
              }
            });
            if (sendPairStats && recievePairStats) {
              try {
                if (sendPairStats.currentRoundTripTime && recievePairStats.currentRoundTripTime) {
                  return [2, {
                    rtt: sendPairStats.currentRoundTripTime,
                    backendRTT: recievePairStats.currentRoundTripTime
                  }];
                }
                rtt = (recievePairStats.lastPacketReceivedTimestamp - sendPairStats.lastPacketSentTimestamp) / 1e3;
                return [2, {
                  rtt,
                  backendRTT: rtt
                }];
              } catch (_c2) {
                return [2, void 0];
              }
            }
            return [2, void 0];
        }
      });
    });
  };
  CallTest2.prototype.close = function() {
    this.pc1.close();
    this.pc2.close();
  };
  return CallTest2;
}();
var SimpleCallTest = function(_super) {
  __extends$6(SimpleCallTest2, _super);
  function SimpleCallTest2(config2) {
    var _this = _super.call(this) || this;
    _this.call = new CallTest(config2);
    return _this;
  }
  SimpleCallTest2.prototype.start = function(timeout) {
    if (timeout === void 0) {
      timeout = 1e4;
    }
    this.call.establishConnection();
    this.timeOut = setTimeout(this.testFailed.bind(this), timeout);
  };
  SimpleCallTest2.prototype.testComplete = function(data) {
    clearTimeout(this.timeOut);
    this.call.close();
    this.emit("done", data);
  };
  SimpleCallTest2.prototype.testFailed = function(error) {
    console.warn("Test failed, ", error);
    this.call.close();
    this.emit("failed", error);
  };
  return SimpleCallTest2;
}(EventEmitter$3);
var __extends$5 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var BYTES_TO_BITS = 8;
var BITS_TO_KILOBITS = 1 / 1e3;
var DataThroughputTest = function(_super) {
  __extends$5(DataThroughputTest2, _super);
  function DataThroughputTest2(config2) {
    var _this = _super.call(this, config2) || this;
    _this.sentPayloadBytes = 0;
    _this.recievedPayloadBytes = 0;
    _this.lastReceivedPayloadBytes = 0;
    _this.stopSending = false;
    _this.testProgress = 0;
    _this.samplePacket = "";
    _this.finalBitrateSum = 0;
    _this.bitRateSampels = 0;
    _this.maxNumberOfPacketsToSend = 0;
    _this.bytesToKeepBuffered = 0;
    _this.testDurationSeconds = 5;
    _this.call.setIceCandidateFilter(CallTest.isNotHostCandidate);
    _this.senderChannel = _this.call.pc1.createDataChannel(null);
    for (var i2 = 0; i2 < 1024 * 256; i2 += 1) {
      _this.samplePacket += "h";
    }
    _this.maxNumberOfPacketsToSend = 1;
    _this.bytesToKeepBuffered = 1024 * _this.maxNumberOfPacketsToSend;
    _this.testDurationSeconds = 4;
    _this.senderChannel.addEventListener("open", _this.sendingStep.bind(_this));
    _this.call.pc2.addEventListener("datachannel", _this.onRecieverChannel.bind(_this));
    return _this;
  }
  DataThroughputTest2.prototype.sendingStep = function() {
    var now = new Date();
    if (!this.startTime) {
      this.startTime = now;
      this.lastBitrateMeasureTime = now;
    }
    for (var i2 = 0; i2 !== this.maxNumberOfPacketsToSend; i2 += 1) {
      if (this.senderChannel.bufferedAmount >= this.bytesToKeepBuffered) {
        break;
      }
      this.sentPayloadBytes += this.samplePacket.length;
      try {
        this.senderChannel.send(this.samplePacket);
      } catch (_a3) {
      }
    }
    var duration = now.getTime() - this.startTime.getTime();
    if (duration >= 1e3 * this.testDurationSeconds) {
      this.stopSending = true;
      this.testProgress = 100;
    } else {
      this.testProgress = duration / (10 * this.testDurationSeconds);
      setTimeout(this.sendingStep.bind(this), 1);
    }
  };
  DataThroughputTest2.prototype.onMessageRecieved = function(event) {
    this.recievedPayloadBytes += event.data.length;
    var now = new Date();
    var duration = now.getTime() - this.lastBitrateMeasureTime.getTime();
    if (duration >= 1e3) {
      var deltaBytes = this.recievedPayloadBytes - this.lastReceivedPayloadBytes;
      var bitrate = deltaBytes * BYTES_TO_BITS / (duration / 1e3);
      this.finalBitrateSum += bitrate;
      this.bitRateSampels += 1;
      this.lastReceivedPayloadBytes = this.recievedPayloadBytes;
      this.lastBitrateMeasureTime = now;
    }
    if (this.stopSending && this.sentPayloadBytes === this.recievedPayloadBytes) {
      var averageBitrate = this.finalBitrateSum / this.bitRateSampels;
      this.testComplete({
        throughput: Math.round(averageBitrate * BITS_TO_KILOBITS)
      });
    }
  };
  DataThroughputTest2.prototype.testComplete = function(data) {
    var _this = this;
    this.call.getRoundTripTime().then(function(_a3) {
      var rtt = _a3.rtt, backendRTT = _a3.backendRTT;
      return _super.prototype.testComplete.call(_this, {
        RTT: rtt,
        backendRTT,
        throughput: data.throughput
      });
    });
  };
  DataThroughputTest2.prototype.onRecieverChannel = function(event) {
    this.recieveChannel = event.channel;
    this.recieveChannel.addEventListener("message", this.onMessageRecieved.bind(this));
  };
  return DataThroughputTest2;
}(SimpleCallTest);
var __extends$4 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ConnectivityTest = function(_super) {
  __extends$4(ConnectivityTest2, _super);
  function ConnectivityTest2(config2, filter) {
    if (filter === void 0) {
      filter = CallTest.noFilter;
    }
    var _this = _super.call(this, config2) || this;
    _this.call.setIceCandidateFilter(filter);
    var ch1 = _this.call.pc1.createDataChannel(null);
    _this.ch1 = ch1;
    ch1.addEventListener("open", function() {
      ch1.send("hello");
    });
    ch1.addEventListener("message", _this.onCh1Recieve.bind(_this));
    _this.call.pc2.addEventListener("datachannel", _this.dataChannelHandler.bind(_this));
    return _this;
  }
  ConnectivityTest2.prototype.onCh1Recieve = function(event) {
    if (event.data !== "world") {
      this.hangup("Invalid data transmitted.");
    } else {
      this.testComplete({
        connectivity: true
      });
    }
  };
  ConnectivityTest2.prototype.onCh2Recieve = function(event) {
    if (event.data !== "hello") {
      this.hangup("Invalid data transmitted.");
    } else {
      try {
        this.ch2.send("world");
      } catch (_a3) {
      }
    }
  };
  ConnectivityTest2.prototype.dataChannelHandler = function(event) {
    var ch2 = event.channel;
    this.ch2 = ch2;
    ch2.addEventListener("message", this.onCh2Recieve.bind(this));
  };
  ConnectivityTest2.prototype.hangup = function(errorMessage) {
    this.testFailed(errorMessage);
  };
  return ConnectivityTest2;
}(SimpleCallTest);
var HostConnectivityTest = function(_super) {
  __extends$4(HostConnectivityTest2, _super);
  function HostConnectivityTest2(config2) {
    return _super.call(this, config2, CallTest.isHost) || this;
  }
  return HostConnectivityTest2;
}(ConnectivityTest);
var RelayConnectivityTest = function(_super) {
  __extends$4(RelayConnectivityTest2, _super);
  function RelayConnectivityTest2(config2) {
    return _super.call(this, config2, CallTest.isRelay) || this;
  }
  return RelayConnectivityTest2;
}(ConnectivityTest);
var ReflexiveConnectivityTest = function(_super) {
  __extends$4(ReflexiveConnectivityTest2, _super);
  function ReflexiveConnectivityTest2(config2) {
    return _super.call(this, config2, CallTest.isReflexive) || this;
  }
  return ReflexiveConnectivityTest2;
}(ConnectivityTest);
var __assign$2 = globalThis && globalThis.__assign || function() {
  __assign$2 = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t2[p] = s[p];
    }
    return t2;
  };
  return __assign$2.apply(this, arguments);
};
var __awaiter$4 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$3 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f, y2, t2, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t2 = _.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t2[1]) {
              _.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _.label < t2[2]) {
              _.label = t2[2];
              _.ops.push(op);
              break;
            }
            if (t2[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read$2 = globalThis && globalThis.__read || function(o, n2) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i2 = m.call(o), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m = i2["return"]))
        m.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __values$3 = globalThis && globalThis.__values || function(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i2 = 0;
  if (m)
    return m.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i2 >= o.length)
          o = void 0;
        return { value: o && o[i2++], done: !o };
      }
    };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var FALLBACK_ICE_SERVERS = [
  {
    urls: "turn:turn.dyte.in:443?transport=tcp",
    username: "dyte",
    credential: "dytein",
    credentialType: "password"
  },
  {
    urls: "turn:turn.dyte.in:3478?transport=udp",
    username: "dyte",
    credential: "dytein",
    credentialType: "password"
  }
];
function parseIpLocation(loc) {
  var _a3 = __read$2(loc.split(","), 2), latitude = _a3[0], longitude = _a3[1];
  return {
    coords: {
      latitude: Number(latitude),
      longitude: Number(longitude)
    }
  };
}
var ParsedRTCStats = function() {
  function ParsedRTCStats2() {
    this.outboundVideoRtp = new Map();
    this.inboundVideoRtp = new Map();
    this.outboundAudioRtp = new Map();
    this.inboundAudioRtp = new Map();
    this.remoteInboundRtp = new Map();
    this.producerStreamMap = new Map();
    this.consumerStreamMap = new Map();
    this.staleProducerStreamMap = false;
    this.staleConsumerStreamMap = false;
  }
  return ParsedRTCStats2;
}();
var Measurements = function() {
  function Measurements2() {
    this.outboundProducerMap = new Map();
    this.inboundConsumerMap = new Map();
    this.consumerPeerIdMap = new Map();
    this.overallProducingTransportsStatsMap = {};
    this.overallConsumingTransportsStatsMap = {};
    this.overallConsumersStatsMap = {};
    this.overallProducersStatsMap = {};
    this.consumerIdsWithFreezedVideo = new Set();
    this.consumerIdsWithFreezedAudio = new Set();
    this.producerIdsWithFreezedVideo = new Set();
    this.producerIdsWithFreezedAudio = new Set();
    this.freezedProducingTransportIds = new Set();
    this.freezedConsumingTransportIds = new Set();
  }
  Measurements2.prototype.registerProducer = function(producer) {
    return __awaiter$4(this, void 0, void 0, function() {
      return __generator$3(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            return [4, this.generateProducerStreamMap(producer)];
          case 1:
            _a3.sent();
            producer.observer.on("close", this.deregisterProducer.bind(this, producer));
            return [2];
        }
      });
    });
  };
  Measurements2.prototype.processInboundConsumerVideoStats = function(consumerId, overallStatsForConsumer, streamStatsData) {
    var _a3, _b2;
    var consumerMediaStates = ((_b2 = (_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.consumerSharedMediaStatesMap) === null || _b2 === void 0 ? void 0 : _b2.get(consumerId)) || {};
    if (overallStatsForConsumer.totalVideoPacketsReceived === streamStatsData.packetsReceived) {
      this.consumerIdsWithFreezedVideo.add(consumerId);
      if (this.callStatsInstance && consumerMediaStates.video) {
        this.callStatsInstance.logger.log("video freezed for consumer id:", consumerId);
        this.callStatsInstance.eventHandler.emit("consumer_video_status", "pause", consumerId);
      }
    } else {
      overallStatsForConsumer.totalVideoPacketsReceived = streamStatsData.packetsReceived;
      if (this.consumerIdsWithFreezedVideo.has(consumerId)) {
        this.consumerIdsWithFreezedVideo.delete(consumerId);
        if (this.callStatsInstance && consumerMediaStates.video) {
          this.callStatsInstance.logger.log("video working fine for consumer id:", consumerId);
          this.callStatsInstance.eventHandler.emit("consumer_video_status", "resume", consumerId);
        }
      }
    }
  };
  Measurements2.prototype.processInboundConsumerAudioStats = function(consumerId, overallStatsForConsumer, streamStatsData) {
    var _a3, _b2;
    var consumerMediaStates = ((_b2 = (_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.consumerSharedMediaStatesMap) === null || _b2 === void 0 ? void 0 : _b2.get(consumerId)) || {};
    if (overallStatsForConsumer.totalAudioPacketsReceived === streamStatsData.packetsReceived) {
      this.consumerIdsWithFreezedAudio.add(consumerId);
      if (this.callStatsInstance && consumerMediaStates.audio) {
        this.callStatsInstance.logger.log("audio freezed for consumer id:", consumerId);
        this.callStatsInstance.eventHandler.emit("consumer_audio_status", "pause", consumerId);
      }
    } else {
      overallStatsForConsumer.totalAudioPacketsReceived = streamStatsData.packetsReceived;
      if (this.consumerIdsWithFreezedAudio.has(consumerId)) {
        this.consumerIdsWithFreezedAudio.delete(consumerId);
        if (this.callStatsInstance && consumerMediaStates.audio) {
          this.callStatsInstance.logger.log("audio working fine for consumer id:", consumerId);
          this.callStatsInstance.eventHandler.emit("consumer_audio_status", "resume", consumerId);
        }
      }
    }
  };
  Measurements2.prototype.processOutboundProducerVideoStats = function(producerId, overallStatsForProducer, streamStatsData) {
    var _a3;
    var currentUserMediaStates = ((_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.currentUserMediaStates) || {};
    if (overallStatsForProducer.totalVideoPacketsSent === streamStatsData.packetsSent) {
      this.producerIdsWithFreezedVideo.add(producerId);
      if (this.callStatsInstance && currentUserMediaStates.video) {
        this.callStatsInstance.logger.log("video freezed for producer id:", producerId);
        this.callStatsInstance.eventHandler.emit("producer_video_status", "pause", producerId);
      }
    } else {
      overallStatsForProducer.totalVideoPacketsSent = streamStatsData.packetsSent;
      if (this.producerIdsWithFreezedVideo.has(producerId)) {
        this.producerIdsWithFreezedVideo.delete(producerId);
        if (this.callStatsInstance && currentUserMediaStates.video) {
          this.callStatsInstance.logger.log("video working fine for producer id:", producerId);
          this.callStatsInstance.eventHandler.emit("producer_video_status", "resume", producerId);
        }
      }
    }
  };
  Measurements2.prototype.processOutboundProducerAudioStats = function(producerId, overallStatsForProducer, streamStatsData) {
    var _a3;
    var currentUserMediaStates = ((_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.currentUserMediaStates) || {};
    if (overallStatsForProducer.totalAudioPacketsSent === streamStatsData.packetsSent) {
      this.producerIdsWithFreezedAudio.add(producerId);
      if (this.callStatsInstance && currentUserMediaStates.audio) {
        this.callStatsInstance.logger.log("audio freezed for producer id:", producerId);
        this.callStatsInstance.eventHandler.emit("producer_audio_status", "pause", producerId);
      }
    } else {
      overallStatsForProducer.totalAudioPacketsSent = streamStatsData.packetsSent;
      if (this.producerIdsWithFreezedAudio.has(producerId)) {
        this.producerIdsWithFreezedAudio.delete(producerId);
        if (this.callStatsInstance && currentUserMediaStates.audio) {
          this.callStatsInstance.logger.log("audio working fine for producer id:", producerId);
          this.callStatsInstance.eventHandler.emit("producer_audio_status", "resume", producerId);
        }
      }
    }
  };
  Measurements2.prototype.processProducingTransportStats = function(transportId, overallStatsForTransport, transportStatsData) {
    var _a3;
    var currentUserMediaStates = ((_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.currentUserMediaStates) || {};
    var audioIsOn = currentUserMediaStates.audio, videoIsOn = currentUserMediaStates.video, screenIsOn = currentUserMediaStates.screen;
    var isAnyProducerActivityOn = audioIsOn || videoIsOn || screenIsOn;
    if (overallStatsForTransport.totalPacketsSent === transportStatsData.packetsSent) {
      this.freezedProducingTransportIds.add(transportId);
      if (this.callStatsInstance && isAnyProducerActivityOn) {
        this.callStatsInstance.logger.log("producing transport freezed for transport id:", transportId);
        this.callStatsInstance.eventHandler.emit("producing_transport_status", "pause", transportId);
      }
    } else {
      overallStatsForTransport.totalPacketsSent = transportStatsData.packetsSent;
      if (this.freezedProducingTransportIds.has(transportId)) {
        this.freezedProducingTransportIds.delete(transportId);
        if (this.callStatsInstance && isAnyProducerActivityOn) {
          this.callStatsInstance.logger.log("producing transport working fine for transport id:", transportId);
          this.callStatsInstance.eventHandler.emit("producing_transport_status", "resume", transportId);
        }
      }
    }
  };
  Measurements2.prototype.processConsumingTransportStats = function(transportId, overallStatsForTransport, streamStatsData) {
    var _a3, _b2;
    var combindConsumerStates = Array.from(((_b2 = (_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.consumerSharedMediaStatesMap) === null || _b2 === void 0 ? void 0 : _b2.values()) || []);
    var isAnyConsumerActivityOn = !!combindConsumerStates.reduce(function(acc, val) {
      return acc || val.audio || val.video || val.screen;
    }, false);
    if (overallStatsForTransport.totalPacketsReceived === streamStatsData.packetsSent) {
      this.freezedConsumingTransportIds.add(transportId);
      if (this.callStatsInstance && isAnyConsumerActivityOn) {
        this.callStatsInstance.logger.log("consuming transport freezed for transport id:", transportId);
        this.callStatsInstance.eventHandler.emit("consuming_transport_status", "pause", transportId);
      }
    } else {
      overallStatsForTransport.totalPacketsReceived = streamStatsData.packetsSent;
      if (this.freezedConsumingTransportIds.has(transportId)) {
        this.freezedConsumingTransportIds.delete(transportId);
        if (this.callStatsInstance && isAnyConsumerActivityOn) {
          this.callStatsInstance.logger.log("consuming transport working fine for transport id:", transportId);
          this.callStatsInstance.eventHandler.emit("consuming_transport_status", "resume", transportId);
        }
      }
    }
  };
  Measurements2.prototype.registerConsumer = function(consumer) {
    return __awaiter$4(this, void 0, void 0, function() {
      return __generator$3(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            return [4, this.generateConsumerStreamMap(consumer)];
          case 1:
            _a3.sent();
            this.consumerPeerIdMap.set(consumer.id, {
              producerId: consumer.producerId,
              peerId: consumer.appData.peerId
            });
            consumer.observer.on("close", this.deregisterConsumer.bind(this, consumer));
            return [2];
        }
      });
    });
  };
  Measurements2.prototype.generateProducerStreamMap = function(producer, parse) {
    if (parse === void 0) {
      parse = false;
    }
    return __awaiter$4(this, void 0, void 0, function() {
      var stat, result, _a3, _b2, entry;
      var e_1, _c2;
      return __generator$3(this, function(_d2) {
        switch (_d2.label) {
          case 0:
            return [4, producer.getStats()];
          case 1:
            stat = _d2.sent();
            result = parse ? this.getProducerStatsFromReport(this.parseRTCReport(stat, ["outbound-rtp", "remote-inbound-rtp"], false, producer.id))[0] : void 0;
            try {
              for (_a3 = __values$3(stat.values()), _b2 = _a3.next(); !_b2.done; _b2 = _a3.next()) {
                entry = _b2.value;
                switch (entry.type) {
                  case "outbound-rtp": {
                    this.outboundProducerMap.set(entry.id, producer.id);
                    break;
                  }
                  default:
                    break;
                }
              }
            } catch (e_1_1) {
              e_1 = { error: e_1_1 };
            } finally {
              try {
                if (_b2 && !_b2.done && (_c2 = _a3.return))
                  _c2.call(_a3);
              } finally {
                if (e_1)
                  throw e_1.error;
              }
            }
            return [2, result];
        }
      });
    });
  };
  Measurements2.prototype.generateConsumerStreamMap = function(consumer, parse) {
    if (parse === void 0) {
      parse = false;
    }
    return __awaiter$4(this, void 0, void 0, function() {
      var stat, result, _a3, _b2, entry;
      var e_2, _c2;
      return __generator$3(this, function(_d2) {
        switch (_d2.label) {
          case 0:
            return [4, consumer.getStats()];
          case 1:
            stat = _d2.sent();
            result = parse ? this.getConsumerStatsFromReport(this.parseRTCReport(stat, ["inbound-rtp"], false, consumer.id))[0] : void 0;
            try {
              for (_a3 = __values$3(stat.values()), _b2 = _a3.next(); !_b2.done; _b2 = _a3.next()) {
                entry = _b2.value;
                switch (entry.type) {
                  case "inbound-rtp": {
                    this.inboundConsumerMap.set(entry.id, consumer.id);
                    break;
                  }
                  default:
                    break;
                }
              }
            } catch (e_2_1) {
              e_2 = { error: e_2_1 };
            } finally {
              try {
                if (_b2 && !_b2.done && (_c2 = _a3.return))
                  _c2.call(_a3);
              } finally {
                if (e_2)
                  throw e_2.error;
              }
            }
            return [2, result];
        }
      });
    });
  };
  Measurements2.prototype.deregisterProducer = function(producer) {
    var _this = this;
    this.outboundProducerMap.forEach(function(value, key) {
      if (value === producer.id) {
        _this.outboundProducerMap.delete(key);
      }
    });
  };
  Measurements2.prototype.deregisterConsumer = function(consumer) {
    var _this = this;
    this.inboundConsumerMap.forEach(function(value, key) {
      if (value === consumer.id) {
        _this.inboundConsumerMap.delete(key);
      }
    });
    this.consumerPeerIdMap.delete(consumer.id);
  };
  Measurements2.prototype.parseRTCReport = function(report, filters, onceOnly, ownerId, transportInfo) {
    var e_3, _a3;
    if (filters === void 0) {
      filters = [];
    }
    if (onceOnly === void 0) {
      onceOnly = false;
    }
    if (ownerId === void 0) {
      ownerId = void 0;
    }
    if (transportInfo === void 0) {
      transportInfo = void 0;
    }
    var stat = report;
    var result = new ParsedRTCStats();
    var filtersSet = filters.length ? new Set(filters) : void 0;
    try {
      for (var _b2 = __values$3(stat.values()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var entry = _c2.value;
        if (filtersSet) {
          if (filtersSet.size === 0) {
            break;
          } else if (!filtersSet.has(entry.type)) {
            continue;
          } else if (onceOnly) {
            filtersSet.delete(entry.type);
          }
        }
        switch (entry.type) {
          case "candidate-pair": {
            if (entry.nominated === true && entry.selected === true) {
              var candidateStats = entry;
              var data = {
                bytesReceived: candidateStats.bytesReceived,
                bytesSent: candidateStats.bytesSent,
                currentRoundTripTime: candidateStats.currentRoundTripTime,
                totalRoundTripTime: candidateStats.totalRoundTripTime,
                availableOutgoingBitrate: candidateStats.availableOutgoingBitrate
              };
              result.candidatePair = data;
              break;
            }
            break;
          }
          case "transport": {
            var transportStats = entry;
            if (transportInfo) {
              if (transportInfo.producing) {
                if (!this.overallProducingTransportsStatsMap[transportInfo.id]) {
                  this.overallProducingTransportsStatsMap[transportInfo.id] = {
                    totalPacketsSent: 0
                  };
                }
              }
              if (transportInfo.consuming) {
                if (!this.overallConsumingTransportsStatsMap[transportInfo.id]) {
                  this.overallConsumingTransportsStatsMap[transportInfo.id] = {
                    totalPacketsReceived: 0
                  };
                }
              }
            }
            var data = {
              bytesReceived: transportStats.bytesReceived,
              bytesSent: transportStats.bytesSent,
              packetsSent: transportStats.packetsSent,
              packetsReceived: transportStats.packetsReceived,
              dtlsCipher: transportStats.dtlsCipher,
              dtlsState: transportStats["dtlsState"],
              iceRole: transportStats["iceRole"]
            };
            result.transport = data;
            if (transportInfo) {
              if (transportInfo.producing) {
                var overallStatsForTransport = this.overallProducingTransportsStatsMap[transportInfo.id];
                this.processProducingTransportStats(transportInfo.id, overallStatsForTransport, data);
              }
              if (transportInfo.consuming) {
                var overallStatsForTransport = this.overallConsumingTransportsStatsMap[transportInfo.id];
                this.processConsumingTransportStats(transportInfo.id, overallStatsForTransport, data);
              }
            }
            break;
          }
          case "remote-inbound-rtp": {
            var rtpStreamStats = entry;
            var data = {
              jitter: rtpStreamStats.jitter,
              fractionLost: rtpStreamStats.fractionLost,
              roundTripTime: rtpStreamStats.roundTripTime,
              roundTripTimeMeasurements: rtpStreamStats.roundTripTimeMeasurements,
              totalRoundTripTime: rtpStreamStats.totalRoundTripTime,
              packetsLost: rtpStreamStats.packetsLost
            };
            result.remoteInboundRtp.set(rtpStreamStats.localId, data);
            break;
          }
          case "outbound-rtp": {
            var rtpStreamStats = entry;
            var producerId = ownerId || this.outboundProducerMap.get(entry.id);
            if (!this.overallProducersStatsMap[producerId]) {
              this.overallProducersStatsMap[producerId] = {
                totalVideoPacketsSent: 0,
                totalAudioPacketsSent: 0
              };
            }
            var overallStatsForProducer = this.overallProducersStatsMap[producerId];
            if (["video", "audio"].includes(rtpStreamStats.mediaType)) {
              if (!this.outboundProducerMap.has(entry.id)) {
                result.staleProducerStreamMap = true;
                if (filtersSet) {
                  filtersSet.delete("outbound-rtp");
                }
                break;
              }
              if (!result.producerStreamMap.has(producerId)) {
                result.producerStreamMap.set(producerId, {
                  outboundVideoRtpId: [],
                  outboundAudioRtpId: []
                });
              }
              var outboundData = {
                bytesSent: rtpStreamStats.bytesSent,
                packetsSent: rtpStreamStats.packetsSent,
                nackCount: rtpStreamStats.nackCount
              };
              if (rtpStreamStats.mediaType === "video") {
                if (rtpStreamStats.decoderImplementation === "unknown") {
                  break;
                }
                var videoRtpStreamStats = rtpStreamStats;
                var data = __assign$2({ frameHeight: videoRtpStreamStats.frameHeight, frameWidth: videoRtpStreamStats.frameWidth, framesEncoded: videoRtpStreamStats.framesEncoded, framesDropped: videoRtpStreamStats.framesDropped, framesPerSecond: videoRtpStreamStats.framesPerSecond, framesSent: videoRtpStreamStats.framesSent, keyFramesEncoded: videoRtpStreamStats.keyFramesEncoded, firCount: videoRtpStreamStats.firCount, encoderImplementation: videoRtpStreamStats.encoderImplementation, hugeFramesSent: videoRtpStreamStats.hugeFramesSent, pliCount: videoRtpStreamStats.pliCount, qpSum: videoRtpStreamStats.qpSum, qualityLimitationDurations: videoRtpStreamStats.qualityLimitationDurations, qualityLimitationReason: videoRtpStreamStats.qualityLimitationReason, qualityLimitationResolutionChanges: videoRtpStreamStats.qualityLimitationResolutionChanges, totalEncodeTime: videoRtpStreamStats.totalEncodeTime, totalPacketSendDelay: videoRtpStreamStats.totalEncodeTime, retransmittedBytesSent: videoRtpStreamStats.retransmittedBytesSent, retransmittedPacketsSent: videoRtpStreamStats.retransmittedPacketsSent }, outboundData);
                result.outboundVideoRtp.set(entry.id, data);
                result.producerStreamMap.get(producerId).outboundVideoRtpId.push(entry.id);
                this.processOutboundProducerVideoStats(producerId, overallStatsForProducer, data);
              } else if (rtpStreamStats.mediaType === "audio") {
                var audioStreamStats = rtpStreamStats;
                var data = __assign$2({ retransmittedBytesSent: audioStreamStats.retransmittedBytesSent, retransmittedPacketsSent: audioStreamStats.retransmittedPacketsSent }, outboundData);
                result.outboundAudioRtp.set(entry.id, data);
                result.producerStreamMap.get(producerId).outboundAudioRtpId.push(entry.id);
                this.processOutboundProducerAudioStats(producerId, overallStatsForProducer, data);
              }
            } else {
            }
            break;
          }
          case "inbound-rtp": {
            var rtpStreamStats = entry;
            var consumerId = ownerId || this.inboundConsumerMap.get(entry.id);
            if (rtpStreamStats.ssrc === 1234) {
              break;
            }
            if (!this.overallConsumersStatsMap[consumerId]) {
              this.overallConsumersStatsMap[consumerId] = {
                totalVideoPacketsReceived: 0,
                totalAudioPacketsReceived: 0
              };
            }
            var overallStatsForConsumer = this.overallConsumersStatsMap[consumerId];
            if (["video", "audio"].includes(rtpStreamStats.mediaType)) {
              if (!this.inboundConsumerMap.has(entry.id)) {
                result.staleConsumerStreamMap = true;
                if (filtersSet) {
                  filtersSet.delete("inbound-rtp");
                }
                break;
              }
              if (!result.consumerStreamMap.has(consumerId)) {
                result.consumerStreamMap.set(consumerId, {
                  inboundVideoRtpId: [],
                  inboundAudioRtpId: []
                });
              }
              var inboundData = {
                bytesReceived: rtpStreamStats.bytesReceived,
                packetsReceived: rtpStreamStats.packetsReceived,
                packetsLost: rtpStreamStats.packetsLost,
                jitter: rtpStreamStats.jitter,
                nackCount: rtpStreamStats.nackCount
              };
              if (rtpStreamStats.mediaType === "video") {
                if (rtpStreamStats.decoderImplementation === "unknown") {
                  break;
                }
                var videoRtpStreamStats = rtpStreamStats;
                var data = __assign$2({ frameHeight: videoRtpStreamStats.frameHeight, frameWidth: videoRtpStreamStats.frameWidth, framesDecoded: videoRtpStreamStats.framesDecoded, framesDropped: videoRtpStreamStats.framesDropped, framesPerSecond: videoRtpStreamStats.framesPerSecond, framesReceived: videoRtpStreamStats.framesReceived, keyFramesDecoded: videoRtpStreamStats.keyFramesDecoded, firCount: videoRtpStreamStats.firCount, decoderImplementation: videoRtpStreamStats.decoderImplementation }, inboundData);
                result.inboundVideoRtp.set(entry.id, data);
                result.consumerStreamMap.get(consumerId).inboundVideoRtpId.push(entry.id);
                this.processInboundConsumerVideoStats(consumerId, overallStatsForConsumer, data);
              } else if (rtpStreamStats.mediaType === "audio") {
                var audioStreamStats = rtpStreamStats;
                var data = __assign$2({ audioLevel: audioStreamStats.audioLevel, concealedSampels: audioStreamStats.concealedSampels, concealmentEvents: audioStreamStats.concealmentEvents, jitterBufferDelay: audioStreamStats.jitterBufferDelay, jitterBufferEmittedCount: audioStreamStats.jitterBufferEmittedCount, totalAudioEnergy: audioStreamStats.totalAudioEnergy, totalSamplesDuration: audioStreamStats.totalSamplesDuration, totalSamplesReceived: audioStreamStats.totalSamplesReceived }, inboundData);
                result.inboundAudioRtp.set(entry.id, data);
                result.consumerStreamMap.get(consumerId).inboundAudioRtpId.push(entry.id);
                this.processInboundConsumerAudioStats(consumerId, overallStatsForConsumer, data);
              }
            } else {
            }
            break;
          }
          default:
            break;
        }
      }
    } catch (e_3_1) {
      e_3 = { error: e_3_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a3 = _b2.return))
          _a3.call(_b2);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
    result.outboundVideoRtp.forEach(function(value, key) {
      value.remoteData = result.remoteInboundRtp.get(key);
    });
    result.outboundAudioRtp.forEach(function(value, key) {
      value.remoteData = result.remoteInboundRtp.get(key);
    });
    if (result.candidatePair) {
      if (result.transport) {
        result.transport.totalRoundTripTime = result.candidatePair.totalRoundTripTime;
        result.transport.availableOutgoingBitrate = result.candidatePair.availableOutgoingBitrate;
        result.transport.roundTripTime = result.candidatePair.currentRoundTripTime;
      } else {
        result.transport = {
          bytesReceived: result.candidatePair.bytesReceived,
          bytesSent: result.candidatePair.bytesSent,
          totalRoundTripTime: result.candidatePair.totalRoundTripTime,
          availableOutgoingBitrate: result.candidatePair.availableOutgoingBitrate,
          roundTripTime: result.candidatePair.currentRoundTripTime
        };
      }
    }
    if (result.transport && !result.transport.roundTripTime) {
      var rtt_1 = 0;
      var totalRTT_1 = 0;
      result.remoteInboundRtp.forEach(function(value, key) {
        if (value.roundTripTime && value.roundTripTime > rtt_1) {
          rtt_1 = value.roundTripTime;
          totalRTT_1 = value.totalRoundTripTime;
        }
      });
      result.transport.roundTripTime = rtt_1;
      result.transport.totalRoundTripTime = totalRTT_1;
    }
    return result;
  };
  Measurements2.prototype.getProducersReport = function(producers) {
    return __awaiter$4(this, void 0, void 0, function() {
      var producerPromises;
      var _this = this;
      return __generator$3(this, function(_a3) {
        producerPromises = producers.map(function(producer) {
          return _this.generateProducerStreamMap(producer, true);
        });
        return [2, producerPromises.length > 0 ? Promise.all(producerPromises) : void 0];
      });
    });
  };
  Measurements2.prototype.getConsumersReport = function(consumers) {
    return __awaiter$4(this, void 0, void 0, function() {
      var consumerPromises;
      var _this = this;
      return __generator$3(this, function(_a3) {
        consumerPromises = consumers.map(function(consumer) {
          return _this.generateConsumerStreamMap(consumer, true);
        });
        return [2, consumerPromises.length > 0 ? Promise.all(consumerPromises) : void 0];
      });
    });
  };
  Measurements2.prototype.getTransportReport = function(transport) {
    return __awaiter$4(this, void 0, void 0, function() {
      return __generator$3(this, function(_a3) {
        return [2, transport.getStats()];
      });
    });
  };
  Measurements2.prototype.getProcessedStats = function(transport, consuming, producing) {
    return __awaiter$4(this, void 0, void 0, function() {
      var transportStats, transportInfo, stat, result, transportReport, producerReport, consumerReport;
      return __generator$3(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            return [4, this.getTransportReport(transport)];
          case 1:
            transportStats = _a3.sent();
            transportInfo = { producing, consuming, id: transport.id };
            stat = transportStats;
            result = this.parseRTCReport(stat, ["transport", "candidate-pair", "inbound-rtp", "outbound-rtp", "remote-inbound-rtp"], false, void 0, transportInfo);
            if (!result) {
              return [2, void 0];
            }
            transportReport = {
              stats: result.transport,
              transportId: transport.id,
              consuming,
              producing
            };
            producerReport = result.staleProducerStreamMap ? void 0 : this.getProducerStatsFromReport(result);
            consumerReport = result.staleConsumerStreamMap ? void 0 : this.getConsumerStatsFromReport(result);
            return [2, {
              transportReport,
              producerReport,
              consumerReport
            }];
        }
      });
    });
  };
  Measurements2.prototype.getProducerStatsFromReport = function(report) {
    var producerReport = [];
    try {
      report.producerStreamMap.forEach(function(value, key) {
        producerReport.push({
          producerId: key,
          videoStats: value.outboundVideoRtpId.map(function(id) {
            return report.outboundVideoRtp.get(id);
          }),
          audioStats: value.outboundAudioRtpId.map(function(id) {
            return report.outboundAudioRtp.get(id);
          })
        });
      });
    } catch (error) {
      console.error("getProducersReport: ", error, report);
    }
    return producerReport;
  };
  Measurements2.prototype.getConsumerStatsFromReport = function(report) {
    var _this = this;
    var consumerReport = [];
    try {
      report.consumerStreamMap.forEach(function(value, key) {
        var _a3 = _this.consumerPeerIdMap.get(key), peerId = _a3.peerId, producerId = _a3.producerId;
        consumerReport.push({
          consumerId: key,
          peerId,
          producerId,
          videoStats: value.inboundVideoRtpId.map(function(id) {
            return report.inboundVideoRtp.get(id);
          }),
          audioStats: value.inboundAudioRtpId.map(function(id) {
            return report.inboundAudioRtp.get(id);
          })
        });
      });
    } catch (error) {
      console.error("getConsumersReport: ", error, report);
    }
    return consumerReport;
  };
  Measurements2.prototype.getUserLocation = function() {
    return __awaiter$4(this, void 0, void 0, function() {
      var promise;
      return __generator$3(this, function(_a3) {
        promise = new Promise(function(resolve, reject) {
          try {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(function(position) {
                resolve(position);
              });
            } else {
              reject();
            }
          } catch (e) {
            reject(e);
          }
        });
        return [2, promise];
      });
    });
  };
  Measurements2.prototype.getConnectivity = function(iceServers) {
    return __awaiter$4(this, void 0, void 0, function() {
      var config_1, hostPromise, relayPromise, reflexivePromise, _a3, host, relay, reflexive;
      return __generator$3(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            _c2.trys.push([0, 2, , 3]);
            config_1 = {
              iceServers: iceServers || FALLBACK_ICE_SERVERS
            };
            hostPromise = new Promise(function(resolve, reject) {
              try {
                var test_1 = new HostConnectivityTest(config_1);
                test_1.addListener("done", resolve);
                test_1.addListener("failed", function() {
                  resolve({ connectivity: false });
                });
                test_1.start(2e3);
              } catch (e) {
                reject(e);
              }
            });
            relayPromise = new Promise(function(resolve, reject) {
              try {
                var test_2 = new RelayConnectivityTest(config_1);
                test_2.addListener("done", resolve);
                test_2.addListener("failed", function() {
                  resolve({ connectivity: false });
                });
                test_2.start(2e3);
              } catch (e) {
                reject(e);
              }
            });
            reflexivePromise = new Promise(function(resolve, reject) {
              try {
                var test_3 = new ReflexiveConnectivityTest(config_1);
                test_3.addListener("done", resolve);
                test_3.addListener("failed", function() {
                  resolve({ connectivity: false });
                });
                test_3.start(2e3);
              } catch (e) {
                reject(e);
              }
            });
            return [4, Promise.all([hostPromise, relayPromise, reflexivePromise])];
          case 1:
            _a3 = __read$2.apply(void 0, [_c2.sent(), 3]), host = _a3[0], relay = _a3[1], reflexive = _a3[2];
            return [2, {
              host: host === null || host === void 0 ? void 0 : host.connectivity,
              relay: relay === null || relay === void 0 ? void 0 : relay.connectivity,
              reflexive: reflexive === null || reflexive === void 0 ? void 0 : reflexive.connectivity
            }];
          case 2:
            _c2.sent();
            return [2, {
              host: false,
              relay: false,
              reflexive: false
            }];
          case 3:
            return [2];
        }
      });
    });
  };
  Measurements2.prototype.getThroughput = function(iceServers) {
    return __awaiter$4(this, void 0, void 0, function() {
      var throughPutPromise, results;
      return __generator$3(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            _b2.trys.push([0, 2, , 3]);
            throughPutPromise = new Promise(function(resolve, reject) {
              try {
                var config2 = {
                  iceServers: iceServers || FALLBACK_ICE_SERVERS
                };
                var test_4 = new DataThroughputTest(config2);
                test_4.addListener("done", resolve);
                test_4.addListener("failed", reject);
                test_4.start(1e4);
              } catch (e) {
                reject(e);
              }
            });
            return [4, throughPutPromise];
          case 1:
            results = _b2.sent();
            return [2, {
              throughput: results.throughput,
              fractionalLoss: 0,
              RTT: results.RTT,
              jitter: 0,
              backendRTT: results.backendRTT
            }];
          case 2:
            _b2.sent();
            return [2, void 0];
          case 3:
            return [2];
        }
      });
    });
  };
  Measurements2.prototype.getIPDetails = function() {
    return __awaiter$4(this, void 0, void 0, function() {
      var response, data, _a3;
      return __generator$3(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            _c2.trys.push([0, 4, , 5]);
            if (!!this.ipDetails)
              return [3, 3];
            return [4, fetch("https://location-service.dyte.io/?token=3c493932b0624c", {
              method: "POST"
            })];
          case 1:
            response = _c2.sent();
            data = response.json();
            _a3 = this;
            return [4, data];
          case 2:
            _a3.ipDetails = _c2.sent();
            _c2.label = 3;
          case 3:
            return [2, this.ipDetails];
          case 4:
            _c2.sent();
            return [2, void 0];
          case 5:
            return [2];
        }
      });
    });
  };
  Measurements2.prototype.getNetworkQuality = function(iceServers) {
    return __awaiter$4(this, void 0, void 0, function() {
      var _a3, connectivity, throughput, measurements;
      return __generator$3(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            return [4, Promise.all([
              this.getConnectivity(iceServers),
              this.getThroughput(iceServers)
            ])];
          case 1:
            _a3 = __read$2.apply(void 0, [_b2.sent(), 2]), connectivity = _a3[0], throughput = _a3[1];
            measurements = {
              connectivity,
              throughput: throughput === null || throughput === void 0 ? void 0 : throughput.throughput,
              fractionalLoss: throughput === null || throughput === void 0 ? void 0 : throughput.fractionalLoss,
              RTT: throughput === null || throughput === void 0 ? void 0 : throughput.RTT,
              jitter: throughput === null || throughput === void 0 ? void 0 : throughput.jitter,
              backendRTT: throughput === null || throughput === void 0 ? void 0 : throughput.backendRTT
            };
            return [2, measurements];
        }
      });
    });
  };
  Measurements2.prototype.getNetworkInfo = function(iceServers) {
    var _a3;
    return __awaiter$4(this, void 0, void 0, function() {
      var _b2, connectivity, throughput, ipDetails, measurements;
      return __generator$3(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            return [4, Promise.all([
              this.getConnectivity(iceServers),
              this.getThroughput(iceServers),
              this.getIPDetails()
            ])];
          case 1:
            _b2 = __read$2.apply(void 0, [_c2.sent(), 3]), connectivity = _b2[0], throughput = _b2[1], ipDetails = _b2[2];
            measurements = {
              ipDetails,
              effectiveNetworkType: (_a3 = navigator.connection) === null || _a3 === void 0 ? void 0 : _a3.effectiveType,
              location: ipDetails.loc ? parseIpLocation(ipDetails.loc) : void 0,
              turnConnectivity: connectivity ? connectivity.host || connectivity.relay || connectivity.reflexive : false,
              connectivity,
              throughput: throughput === null || throughput === void 0 ? void 0 : throughput.throughput,
              fractionalLoss: throughput === null || throughput === void 0 ? void 0 : throughput.fractionalLoss,
              RTT: throughput === null || throughput === void 0 ? void 0 : throughput.RTT,
              jitter: throughput === null || throughput === void 0 ? void 0 : throughput.jitter,
              backendRTT: throughput === null || throughput === void 0 ? void 0 : throughput.backendRTT
            };
            return [2, measurements];
        }
      });
    });
  };
  return Measurements2;
}();
var __extends$3 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ChromeMeasurements = function(_super) {
  __extends$3(ChromeMeasurements2, _super);
  function ChromeMeasurements2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return ChromeMeasurements2;
}(Measurements);
var __extends$2 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$1 = globalThis && globalThis.__assign || function() {
  __assign$1 = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t2[p] = s[p];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
var __awaiter$3 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$2 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f, y2, t2, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t2 = _.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t2[1]) {
              _.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _.label < t2[2]) {
              _.label = t2[2];
              _.ops.push(op);
              break;
            }
            if (t2[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read$1 = globalThis && globalThis.__read || function(o, n2) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i2 = m.call(o), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m = i2["return"]))
        m.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spreadArray$1 = globalThis && globalThis.__spreadArray || function(to, from) {
  for (var i2 = 0, il = from.length, j = to.length; i2 < il; i2++, j++)
    to[j] = from[i2];
  return to;
};
var __values$2 = globalThis && globalThis.__values || function(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i2 = 0;
  if (m)
    return m.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i2 >= o.length)
          o = void 0;
        return { value: o && o[i2++], done: !o };
      }
    };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var FirefoxMeasurements = function(_super) {
  __extends$2(FirefoxMeasurements2, _super);
  function FirefoxMeasurements2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.producerMap = new Map();
    _this.consumerMap = new Map();
    return _this;
  }
  FirefoxMeasurements2.prototype.registerProducer = function(producer) {
    return __awaiter$3(this, void 0, void 0, function() {
      return __generator$2(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            this.producerMap.set(producer.id, producer);
            return [4, this.generateProducerStreamMap(producer)];
          case 1:
            _a3.sent();
            producer.observer.on("close", this.deregisterProducer.bind(this, producer));
            return [2];
        }
      });
    });
  };
  FirefoxMeasurements2.prototype.registerConsumer = function(consumer) {
    return __awaiter$3(this, void 0, void 0, function() {
      return __generator$2(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            this.consumerMap.set(consumer.id, consumer);
            return [4, this.generateConsumerStreamMap(consumer)];
          case 1:
            _a3.sent();
            this.consumerPeerIdMap.set(consumer.id, {
              producerId: consumer.producerId,
              peerId: consumer.appData.peerId
            });
            consumer.observer.on("close", this.deregisterConsumer.bind(this, consumer));
            return [2];
        }
      });
    });
  };
  FirefoxMeasurements2.prototype.generateConsumerStreamMap = function(consumer, parse) {
    if (parse === void 0) {
      parse = false;
    }
    return __awaiter$3(this, void 0, void 0, function() {
      var stat, report, statsObj, result, _a3, _b2, entry;
      var e_1, _c2;
      return __generator$2(this, function(_d2) {
        switch (_d2.label) {
          case 0:
            return [4, consumer.getStats()];
          case 1:
            stat = _d2.sent();
            report = this.parseRTCReport(stat, ["inbound-rtp"], false, consumer.id);
            statsObj = __spreadArray$1([], __read$1(report.consumerStreamMap.values()))[0];
            result = parse ? this.getConsumerStatsFromParsedConsumerStats(report, statsObj, consumer.id) : void 0;
            try {
              for (_a3 = __values$2(stat.values()), _b2 = _a3.next(); !_b2.done; _b2 = _a3.next()) {
                entry = _b2.value;
                switch (entry.type) {
                  case "inbound-rtp": {
                    this.inboundConsumerMap.set(entry.id, consumer.id);
                    break;
                  }
                  default:
                    break;
                }
              }
            } catch (e_1_1) {
              e_1 = { error: e_1_1 };
            } finally {
              try {
                if (_b2 && !_b2.done && (_c2 = _a3.return))
                  _c2.call(_a3);
              } finally {
                if (e_1)
                  throw e_1.error;
              }
            }
            return [2, result];
        }
      });
    });
  };
  FirefoxMeasurements2.prototype.deregisterProducer = function(producer) {
    var _this = this;
    this.producerMap.delete(producer.id);
    this.outboundProducerMap.forEach(function(value, key) {
      if (value === producer.id) {
        _this.outboundProducerMap.delete(key);
      }
    });
  };
  FirefoxMeasurements2.prototype.deregisterConsumer = function(consumer) {
    var _this = this;
    this.consumerMap.delete(consumer.id);
    this.inboundConsumerMap.forEach(function(value, key) {
      if (value === consumer.id) {
        _this.inboundConsumerMap.delete(key);
      }
    });
    this.consumerPeerIdMap.delete(consumer.id);
  };
  FirefoxMeasurements2.prototype.parseRTCReport = function(report, filters, onceOnly, ownerId, transportInfo) {
    var e_2, _a3;
    if (filters === void 0) {
      filters = [];
    }
    if (onceOnly === void 0) {
      onceOnly = false;
    }
    if (ownerId === void 0) {
      ownerId = void 0;
    }
    if (transportInfo === void 0) {
      transportInfo = void 0;
    }
    var stat = report;
    var result = new ParsedRTCStats();
    var filtersSet = filters.length ? new Set(filters) : void 0;
    try {
      for (var _b2 = __values$2(stat.values()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var entry = _c2.value;
        if (filtersSet) {
          if (filtersSet.size === 0) {
            break;
          } else if (!filtersSet.has(entry.type)) {
            continue;
          } else if (onceOnly) {
            filtersSet.delete(entry.type);
          }
        }
        switch (entry.type) {
          case "candidate-pair": {
            if (entry.nominated === true && entry.selected === true) {
              var candidateStats = entry;
              var data = {
                bytesReceived: candidateStats.bytesReceived,
                bytesSent: candidateStats.bytesSent,
                currentRoundTripTime: candidateStats.currentRoundTripTime,
                totalRoundTripTime: candidateStats.totalRoundTripTime,
                availableOutgoingBitrate: candidateStats.availableOutgoingBitrate
              };
              result.candidatePair = data;
              break;
            }
            break;
          }
          case "transport": {
            var transportStats = entry;
            if (transportInfo) {
              if (transportInfo.producing) {
                if (!this.overallProducingTransportsStatsMap[transportInfo.id]) {
                  this.overallProducingTransportsStatsMap[transportInfo.id] = {
                    totalPacketsSent: 0
                  };
                }
              }
              if (transportInfo.consuming) {
                if (!this.overallConsumingTransportsStatsMap[transportInfo.id]) {
                  this.overallConsumingTransportsStatsMap[transportInfo.id] = {
                    totalPacketsReceived: 0
                  };
                }
              }
            }
            var data = {
              bytesReceived: transportStats.bytesReceived,
              bytesSent: transportStats.bytesSent,
              packetsSent: transportStats.packetsSent,
              packetsReceived: transportStats.packetsReceived,
              dtlsCipher: transportStats.dtlsCipher,
              dtlsState: transportStats.dtlsState,
              iceRole: transportStats.iceRole
            };
            result.transport = data;
            if (transportInfo) {
              if (transportInfo.producing) {
                var overallStatsForTransport = this.overallProducingTransportsStatsMap[transportInfo.id];
                this.processProducingTransportStats(transportInfo.id, overallStatsForTransport, data);
              }
              if (transportInfo.consuming) {
                var overallStatsForTransport = this.overallConsumingTransportsStatsMap[transportInfo.id];
                this.processConsumingTransportStats(transportInfo.id, overallStatsForTransport, data);
              }
            }
            break;
          }
          case "remote-inbound-rtp": {
            var rtpStreamStats = entry;
            var data = {
              jitter: rtpStreamStats.jitter,
              fractionLost: rtpStreamStats.fractionLost,
              roundTripTime: rtpStreamStats.roundTripTime,
              roundTripTimeMeasurements: rtpStreamStats.roundTripTimeMeasurements,
              totalRoundTripTime: rtpStreamStats.totalRoundTripTime,
              packetsLost: rtpStreamStats.packetsLost
            };
            result.remoteInboundRtp.set(rtpStreamStats.localId, data);
            break;
          }
          case "outbound-rtp": {
            var rtpStreamStats = entry;
            var producerId = ownerId || this.outboundProducerMap.get(entry.id);
            if (!this.overallProducersStatsMap[producerId]) {
              this.overallProducersStatsMap[producerId] = {
                totalVideoPacketsSent: 0,
                totalAudioPacketsSent: 0
              };
            }
            var overallStatsForProducer = this.overallProducersStatsMap[producerId];
            if (["video", "audio"].includes(rtpStreamStats.mediaType)) {
              if (!this.outboundProducerMap.has(entry.id)) {
                result.staleProducerStreamMap = true;
                if (filtersSet) {
                  filtersSet.delete("outbound-rtp");
                }
                break;
              }
              if (!result.producerStreamMap.has(producerId)) {
                result.producerStreamMap.set(producerId, {
                  outboundVideoRtpId: [],
                  outboundAudioRtpId: []
                });
              }
              var outboundData = {
                bytesSent: rtpStreamStats.bytesSent,
                packetsSent: rtpStreamStats.packetsSent,
                nackCount: rtpStreamStats.nackCount
              };
              if (rtpStreamStats.mediaType === "video") {
                if (rtpStreamStats.decoderImplementation === "unknown") {
                  break;
                }
                var videoRtpStreamStats = rtpStreamStats;
                var data = __assign$1({ frameHeight: videoRtpStreamStats.frameHeight, frameWidth: videoRtpStreamStats.frameWidth, framesEncoded: videoRtpStreamStats.framesEncoded, framesDropped: videoRtpStreamStats.framesDropped ? videoRtpStreamStats.framesDropped : videoRtpStreamStats.droppedFrames, framesPerSecond: videoRtpStreamStats.framesPerSecond ? videoRtpStreamStats.framesPerSecond : videoRtpStreamStats.framerateMean, framesSent: videoRtpStreamStats.framesSent, keyFramesEncoded: videoRtpStreamStats.keyFramesEncoded, firCount: videoRtpStreamStats.firCount, encoderImplementation: videoRtpStreamStats.encoderImplementation, hugeFramesSent: videoRtpStreamStats.hugeFramesSent, pliCount: videoRtpStreamStats.pliCount, qpSum: videoRtpStreamStats.qpSum, qualityLimitationReason: videoRtpStreamStats.qualityLimitationReason, qualityLimitationDurations: videoRtpStreamStats.qualityLimitationDurations, qualityLimitationResolutionChanges: videoRtpStreamStats.qualityLimitationResolutionChanges, totalEncodeTime: videoRtpStreamStats.totalEncodeTime, totalPacketSendDelay: videoRtpStreamStats.totalEncodeTime, retransmittedBytesSent: videoRtpStreamStats.retransmittedBytesSent, retransmittedPacketsSent: videoRtpStreamStats.retransmittedPacketsSent }, outboundData);
                result.outboundVideoRtp.set(entry.id, data);
                result.producerStreamMap.get(producerId).outboundVideoRtpId.push(entry.id);
                this.processOutboundProducerVideoStats(producerId, overallStatsForProducer, data);
              } else if (rtpStreamStats.mediaType === "audio") {
                var audioStreamStats = rtpStreamStats;
                var data = __assign$1({ retransmittedBytesSent: audioStreamStats.retransmittedBytesSent, retransmittedPacketsSent: audioStreamStats.retransmittedPacketsSent }, outboundData);
                result.outboundAudioRtp.set(entry.id, data);
                result.producerStreamMap.get(producerId).outboundAudioRtpId.push(entry.id);
                this.processOutboundProducerAudioStats(producerId, overallStatsForProducer, data);
              }
            } else {
            }
            break;
          }
          case "inbound-rtp": {
            var rtpStreamStats = entry;
            var consumerId = ownerId || this.inboundConsumerMap.get(entry.id);
            if (!this.overallConsumersStatsMap[consumerId]) {
              this.overallConsumersStatsMap[consumerId] = {
                totalVideoPacketsReceived: 0,
                totalAudioPacketsReceived: 0
              };
            }
            var overallStatsForConsumer = this.overallConsumersStatsMap[consumerId];
            if (["video", "audio"].includes(rtpStreamStats.mediaType)) {
              if (!this.inboundConsumerMap.has(entry.id)) {
                result.staleConsumerStreamMap = true;
                if (filtersSet) {
                  filtersSet.delete("inbound-rtp");
                }
                break;
              }
              if (!result.consumerStreamMap.has(consumerId)) {
                result.consumerStreamMap.set(consumerId, {
                  inboundVideoRtpId: [],
                  inboundAudioRtpId: []
                });
              }
              var inboundData = {
                bytesReceived: rtpStreamStats.bytesReceived,
                packetsReceived: rtpStreamStats.packetsReceived,
                packetsLost: rtpStreamStats.packetsLost,
                jitter: rtpStreamStats.jitter,
                nackCount: rtpStreamStats.nackCount
              };
              if (rtpStreamStats.mediaType === "video") {
                if (rtpStreamStats.decoderImplementation === "unknown") {
                  break;
                }
                var videoRtpStreamStats = rtpStreamStats;
                var data = __assign$1({ frameHeight: videoRtpStreamStats.frameHeight, frameWidth: videoRtpStreamStats.frameWidth, framesDecoded: videoRtpStreamStats.framesDecoded, framesDropped: videoRtpStreamStats.framesDropped ? videoRtpStreamStats.framesDropped : videoRtpStreamStats.droppedFrames, framesPerSecond: videoRtpStreamStats.framesPerSecond ? videoRtpStreamStats.framesPerSecond : videoRtpStreamStats.framerateMean, framesReceived: videoRtpStreamStats.framesReceived, keyFramesDecoded: videoRtpStreamStats.keyFramesDecoded, firCount: videoRtpStreamStats.firCount, decoderImplementation: videoRtpStreamStats.decoderImplementation }, inboundData);
                result.inboundVideoRtp.set(entry.id, data);
                result.consumerStreamMap.get(consumerId).inboundVideoRtpId.push(entry.id);
                this.processInboundConsumerVideoStats(consumerId, overallStatsForConsumer, data);
              } else if (rtpStreamStats.mediaType === "audio") {
                var audioStreamStats = rtpStreamStats;
                var data = __assign$1({ audioLevel: audioStreamStats.audioLevel, concealedSampels: audioStreamStats.concealedSampels, concealmentEvents: audioStreamStats.concealmentEvents, jitterBufferDelay: audioStreamStats.jitterBufferDelay, jitterBufferEmittedCount: audioStreamStats.jitterBufferEmittedCount, totalAudioEnergy: audioStreamStats.totalAudioEnergy, totalSamplesDuration: audioStreamStats.totalSamplesDuration, totalSamplesReceived: audioStreamStats.totalSamplesReceived }, inboundData);
                result.inboundAudioRtp.set(entry.id, data);
                result.consumerStreamMap.get(consumerId).inboundAudioRtpId.push(entry.id);
                this.processInboundConsumerAudioStats(consumerId, overallStatsForConsumer, data);
              }
            } else {
            }
            break;
          }
          default:
            break;
        }
      }
    } catch (e_2_1) {
      e_2 = { error: e_2_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a3 = _b2.return))
          _a3.call(_b2);
      } finally {
        if (e_2)
          throw e_2.error;
      }
    }
    result.outboundVideoRtp.forEach(function(value, key) {
      value.remoteData = result.remoteInboundRtp.get(key);
    });
    result.outboundAudioRtp.forEach(function(value, key) {
      value.remoteData = result.remoteInboundRtp.get(key);
    });
    if (result.candidatePair) {
      if (result.transport) {
        result.transport.bytesReceived = result.candidatePair.bytesReceived;
        result.transport.bytesSent = result.candidatePair.bytesSent;
        result.transport.totalRoundTripTime = result.candidatePair.totalRoundTripTime;
        result.transport.availableOutgoingBitrate = result.candidatePair.availableOutgoingBitrate;
        result.transport.roundTripTime = result.candidatePair.currentRoundTripTime;
      } else {
        result.transport = {
          bytesReceived: result.candidatePair.bytesReceived,
          bytesSent: result.candidatePair.bytesSent,
          totalRoundTripTime: result.candidatePair.totalRoundTripTime,
          availableOutgoingBitrate: result.candidatePair.availableOutgoingBitrate,
          roundTripTime: result.candidatePair.currentRoundTripTime
        };
      }
    }
    if (result.transport && !result.transport.roundTripTime) {
      var rtt_1 = 0;
      var totalRTT_1 = 0;
      result.remoteInboundRtp.forEach(function(value, key) {
        if (value.roundTripTime && value.roundTripTime > rtt_1) {
          rtt_1 = value.roundTripTime;
          totalRTT_1 = value.totalRoundTripTime;
        }
      });
      result.transport.roundTripTime = rtt_1;
      result.transport.totalRoundTripTime = totalRTT_1;
    }
    return result;
  };
  FirefoxMeasurements2.prototype.getProducerStatsFromReport = function(report) {
    var _this = this;
    var producerReport = [];
    try {
      report.producerStreamMap.forEach(function(value, key) {
        var producer = _this.producerMap.get(key);
        var track = producer.track.getSettings();
        var videoStats = value.outboundVideoRtpId.map(function(id) {
          var val = report.outboundVideoRtp.get(id);
          if (!val.frameHeight) {
            val.frameHeight = track.height;
            val.frameWidth = track.width;
            val.framesPerSecond = track.frameRate;
          }
          return val;
        });
        var entry = {
          producerId: key,
          videoStats,
          audioStats: value.outboundAudioRtpId.map(function(id) {
            return report.outboundAudioRtp.get(id);
          })
        };
        producerReport.push(entry);
      });
    } catch (error) {
      console.error("getProducersReport: ", error, report);
    }
    return producerReport;
  };
  FirefoxMeasurements2.prototype.getConsumerStatsFromParsedConsumerStats = function(report, stats, consumerId) {
    var _this = this;
    var consumerReport;
    try {
      var _a3 = this.consumerPeerIdMap.get(consumerId), peerId = _a3.peerId, producerId = _a3.producerId;
      var videoStats = stats === null || stats === void 0 ? void 0 : stats.inboundVideoRtpId.map(function(id) {
        var consumer = _this.consumerMap.get(consumerId);
        var track = consumer.track.getSettings();
        var val = report.inboundVideoRtp.get(id);
        if (!val.frameHeight) {
          val.frameHeight = track.height;
          val.frameWidth = track.width;
          val.framesPerSecond = track.frameRate;
        }
        return val;
      });
      consumerReport = {
        consumerId,
        peerId,
        producerId,
        videoStats,
        audioStats: stats === null || stats === void 0 ? void 0 : stats.inboundAudioRtpId.map(function(id) {
          return report.inboundAudioRtp.get(id);
        })
      };
    } catch (error) {
      console.error("getConsumerStatsFromParsedConsumerStats: ", error, report);
    }
    return consumerReport;
  };
  FirefoxMeasurements2.prototype.getConsumerStatsFromReport = function(report) {
    var _this = this;
    var consumerReport = [];
    try {
      report.consumerStreamMap.forEach(function(value, key) {
        consumerReport.push(_this.getConsumerStatsFromParsedConsumerStats(report, value, key));
      });
    } catch (error) {
      console.error("getConsumerStatsFromReport: ", error, report);
    }
    return consumerReport;
  };
  return FirefoxMeasurements2;
}(Measurements);
var __extends$1 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var SafariMeasurements = function(_super) {
  __extends$1(SafariMeasurements2, _super);
  function SafariMeasurements2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return SafariMeasurements2;
}(FirefoxMeasurements);
var __values$1 = globalThis && globalThis.__values || function(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i2 = 0;
  if (m)
    return m.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i2 >= o.length)
          o = void 0;
        return { value: o && o[i2++], done: !o };
      }
    };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function handleError(ctx, errorType, handler, error) {
  if (typeof handler === "function" && error instanceof errorType) {
    handler.call(null, error, ctx);
  } else {
    throw error;
  }
}
function generateDescriptor(descriptor, errorType, handler) {
  var originalMethod = descriptor.value;
  descriptor.value = function() {
    var _this = this;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    try {
      var result = originalMethod.apply(this, args);
      if (result && result instanceof Promise) {
        return result.catch(function(error) {
          handleError(_this, errorType, handler, error);
        });
      }
      return result;
    } catch (error) {
      handleError(this, errorType, handler, error);
    }
    return null;
  };
  return descriptor;
}
var CatchFunction = function(errorType, handler) {
  return function(target, propertyKey, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function() {
      var _this = this;
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      try {
        var result = originalMethod.apply(this, args);
        if (result && result instanceof Promise) {
          return result.catch(function(error) {
            handleError(_this, errorType, handler, error);
          });
        }
        return result;
      } catch (error) {
        handleError(this, errorType, handler, error);
      }
      return null;
    };
    return descriptor;
  };
};
var CatchClass = function(errorType, handler) {
  return function(target, propertyKey, descriptor) {
    var e_1, _a3;
    if (descriptor) {
      return generateDescriptor(descriptor, errorType, handler);
    }
    try {
      for (var _b2 = __values$1(Reflect.ownKeys(target.prototype).filter(function(prop) {
        return prop !== "constructor";
      })), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var propertyName = _c2.value;
        var desc = Object.getOwnPropertyDescriptor(target.prototype, propertyName);
        var isMethod = desc.value instanceof Function;
        if (!isMethod)
          continue;
        Object.defineProperty(target.prototype, propertyName, generateDescriptor(desc, errorType, handler));
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a3 = _b2.return))
          _a3.call(_b2);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
    return void 0;
  };
};
var __assign = globalThis && globalThis.__assign || function() {
  __assign = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t2[p] = s[p];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
var __decorate = globalThis && globalThis.__decorate || function(decorators, target, key, desc) {
  var c = arguments.length, r2 = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r2 = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i2 = decorators.length - 1; i2 >= 0; i2--)
      if (d = decorators[i2])
        r2 = (c < 3 ? d(r2) : c > 3 ? d(target, key, r2) : d(target, key)) || r2;
  return c > 3 && r2 && Object.defineProperty(target, key, r2), r2;
};
var __awaiter$2 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$1 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f, y2, t2, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t2 = _.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t2[1]) {
              _.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _.label < t2[2]) {
              _.label = t2[2];
              _.ops.push(op);
              break;
            }
            if (t2[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __values = globalThis && globalThis.__values || function(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i2 = 0;
  if (m)
    return m.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i2 >= o.length)
          o = void 0;
        return { value: o && o[i2++], done: !o };
      }
    };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = globalThis && globalThis.__read || function(o, n2) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i2 = m.call(o), r2, ar = [], e;
  try {
    while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
      ar.push(r2.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r2 && !r2.done && (m = i2["return"]))
        m.call(i2);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spreadArray = globalThis && globalThis.__spreadArray || function(to, from) {
  for (var i2 = 0, il = from.length, j = to.length; i2 < il; i2++, j++)
    to[j] = from[i2];
  return to;
};
var mainLogger = console;
var CallStats = function() {
  function CallStats2(backendUrl, engineName, env) {
    var _this = this;
    if (engineName === void 0) {
      engineName = "Blink";
    }
    if (env === void 0) {
      env = ClientEnvType.PRODUCTION;
    }
    this.producers = new Map();
    this.consumers = new Map();
    this.consumerSharedMediaStatesMap = new Map();
    this.currentUserMediaStates = {};
    this.env = env;
    if (env === ClientEnvType.DEV)
      this.logger = console;
    else {
      this.logger = {
        log: function(e) {
        },
        error: function(e) {
        },
        debug: function(e) {
        },
        trace: function(e) {
        }
      };
    }
    var connection = new SQSConnector(env);
    this.eventHandler = new EventHandler(connection);
    this.logger.log("engineName: ", engineName);
    switch (engineName) {
      case "Blink":
        this.measurements = new ChromeMeasurements();
        break;
      case "Gecko":
        this.measurements = new FirefoxMeasurements();
        break;
      case "WebKit":
        this.measurements = new SafariMeasurements();
        break;
      default:
        throw Error("Unknown engineName! " + engineName);
    }
    this.measurements.callStatsInstance = this;
    this.registerProducer = this.registerProducer.bind(this);
    this.registerConsumer = this.registerConsumer.bind(this);
    this.measurements.getIPDetails().then(function(e) {
      if (e) {
        var obj = __assign({}, e);
        if (e.loc) {
          obj.loc = parseIpLocation(e.loc);
        }
        _this.eventHandler.emit("initialized", obj);
      }
    });
  }
  CallStats2.prototype.authenticate = function(authPayload) {
    this.eventHandler.connection.authenticate(authPayload);
  };
  CallStats2.prototype.registerIceServers = function(servers) {
    this.iceServers = servers;
  };
  CallStats2.prototype.registerConsumer = function(consumer) {
    if (!this.consumerSharedMediaStatesMap.has(consumer.id)) {
      this.consumerSharedMediaStatesMap.set(consumer.id, {});
    }
    this.consumers.set(consumer.id, consumer);
    this.measurements.registerConsumer(consumer);
    this.logger.log("Registered Consumer", consumer.id, consumer);
    consumer.observer.on("close", this.deRegisterConsumer.bind(this, consumer));
  };
  CallStats2.prototype.registerProducer = function(producer) {
    this.producers.set(producer.id, producer);
    this.measurements.registerProducer(producer);
    this.logger.log("Registered Producer", producer.id, producer);
    producer.observer.on("close", this.deRegisterProducer.bind(this, producer));
  };
  CallStats2.prototype.sendConsumerSharedMediaStateEvent = function(consumerId, statusObj) {
    if (!this.consumerSharedMediaStatesMap.has(consumerId)) {
      this.consumerSharedMediaStatesMap.set(consumerId, {});
    }
    var currentStatusObj = this.consumerSharedMediaStatesMap.get(consumerId);
    this.consumerSharedMediaStatesMap.set(consumerId, Object.assign(currentStatusObj, statusObj));
  };
  CallStats2.prototype.registerProducingTransport = function(transport) {
    var _this = this;
    var _a3;
    this.producingTransport = transport;
    transport.observer.on("close", this.disconnectProducingTransport.bind(this, transport));
    transport.observer.on("disconnect", this.disconnectProducingTransport.bind(this, transport));
    var existingProducers = Array.from(((_a3 = transport._producers) === null || _a3 === void 0 ? void 0 : _a3.values()) || []);
    existingProducers.forEach(function(producer) {
      _this.registerProducer(producer);
    });
    transport.observer.on("newproducer", this.registerProducer);
  };
  CallStats2.prototype.registerConsumingTransport = function(transport) {
    var _this = this;
    var _a3;
    this.consumingTransport = transport;
    transport.observer.on("close", this.disconnectConsumingTransport.bind(this, transport));
    transport.observer.on("disconnect", this.disconnectConsumingTransport.bind(this, transport));
    var existingConsumers = Array.from(((_a3 = transport._consumers) === null || _a3 === void 0 ? void 0 : _a3.values()) || []);
    existingConsumers.forEach(function(consumer) {
      _this.registerConsumer(consumer);
    });
    transport.observer.on("newconsumer", this.registerConsumer);
  };
  CallStats2.prototype.deRegisterConsumer = function(consumer) {
    this.consumers.delete(consumer.id);
  };
  CallStats2.prototype.deRegisterProducer = function(producer) {
    this.producers.delete(producer.id);
  };
  CallStats2.prototype.disconnectConsumingTransport = function() {
    this.consumingTransport = void 0;
  };
  CallStats2.prototype.disconnectProducingTransport = function() {
    this.producingTransport = void 0;
  };
  CallStats2.prototype.callEvent = function(entry) {
    this.eventHandler.callEvent(entry);
  };
  CallStats2.prototype.sendPreCallTestBeginEvent = function() {
    var _this = this;
    this.connectionInfoPromise = this.measurements.getNetworkInfo(this.iceServers);
    this.eventHandler.callEvent({
      event: Event.PRECALL_TEST_BEGIN,
      timestamp: new Date()
    });
    if (this.connectionInfoPromise) {
      this.connectionInfoPromise.then(function(e) {
        _this.eventHandler.callEvent({
          event: Event.PRECALL_TEST_COMPLETE,
          metaData: {
            connectionInfo: e
          },
          timestamp: new Date()
        });
      });
    }
  };
  CallStats2.prototype.sendScreenShareToggleEvent = function(on, ssrc) {
    this.currentUserMediaStates.screen = on;
    this.eventHandler.callEvent({
      event: on ? Event.SCREENSHARE_STARTED : Event.SCREENSHARE_STOPPED,
      metaData: {
        ssrc
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendScreenShareRequestedEvent = function() {
    this.eventHandler.callEvent({
      event: Event.SCREENSHARE_START_REQUESTED,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendActiveSpeakerEvent = function(peerId) {
    this.eventHandler.callEvent({
      event: Event.DOMINANT_SPEAKER,
      metaData: {
        peerId
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.devices = function(deviceType, deviceList) {
    this.eventHandler.callEvent({
      event: deviceType === MediaDeviceType.AUDIO && Event.AUDIO_DEVICES_UPDATES || deviceType === MediaDeviceType.VIDEO && Event.VIDEO_DEVICES_UPDATES || deviceType === MediaDeviceType.SPEAKER && Event.SPEAKER_DEVICES_UPDATES,
      metaData: {
        deviceList
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.selectedDevice = function(deviceType, device) {
    this.eventHandler.callEvent({
      event: deviceType === MediaDeviceType.AUDIO && Event.SELECTED_MICROHPONE_UPDATE || deviceType === MediaDeviceType.VIDEO && Event.SELECTED_CAMERA_UPDATE || deviceType === MediaDeviceType.SPEAKER && Event.SELECTED_SPEAKER_UPDATE,
      metaData: {
        device
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.mediaPermission = function(deviceType, permission) {
    this.eventHandler.callEvent({
      event: Event.MEDIA_PERMISSION,
      metaData: {
        deviceType,
        permission
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.mediaPlaybackFailed = function(deviceType) {
    this.eventHandler.callEvent({
      event: deviceType === MediaDeviceType.AUDIO && Event.AUDIO_PLAY_FAILED || deviceType === MediaDeviceType.VIDEO && Event.VIDEO_PLAY_FAILED,
      metaData: {
        deviceType
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.mediaTrackMuted = function(deviceType) {
    this.eventHandler.callEvent({
      event: deviceType === MediaDeviceType.AUDIO && Event.AUDIO_TRACK_MUTED || deviceType === MediaDeviceType.VIDEO && Event.VIDEO_TRACK_MUTED,
      metaData: {
        deviceType
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.tabChanged = function(backToCurrentTab) {
    this.eventHandler.callEvent({
      event: Event.TAB_CHANGE,
      backToCurrentTab,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.browserBackgrounded = function() {
    this.eventHandler.callEvent({
      event: Event.BROWSER_BACKGROUNDED,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.browserForegrounded = function() {
    this.eventHandler.callEvent({
      event: Event.BROWSER_FOREGROUNDED,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.legacySwitch = function(on) {
    this.eventHandler.callEvent({
      event: Event.LEGACY_SWITCH,
      metadata: { on },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.getPreCallTestResults = function() {
    return __awaiter$2(this, void 0, void 0, function() {
      return __generator$1(this, function(_a3) {
        return [2, this.connectionInfoPromise];
      });
    });
  };
  CallStats2.prototype.sendCallJoinBeginEvent = function(peerMetaData) {
    peerMetaData = __assign(__assign({}, peerMetaData), { meetingEnv: this.env });
    peerMetaData.deviceInfo = __assign(__assign({}, peerMetaData.deviceInfo), { userAgent: navigator.userAgent, cpus: navigator.hardwareConcurrency, memory: navigator.deviceMemory });
    this.eventHandler.callEvent({
      event: Event.CALL_JOIN_BEGIN,
      metaData: {
        peerMetaData
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendNetworkQualityTestBeginEvent = function(regionalInformations) {
    var _this = this;
    this.eventHandler.callEvent({
      event: Event.NET_QUALITY_TEST_BEGIN,
      timestamp: new Date()
    });
    var promise = new Promise(function(resolve, reject) {
      return __awaiter$2(_this, void 0, void 0, function() {
        var regionData, regionalInformations_1, regionalInformations_1_1, e, results, e_1, e_2_1, e_3;
        var e_2, _a3;
        return __generator$1(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              regionData = [];
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 13, , 14]);
              _b2.label = 2;
            case 2:
              _b2.trys.push([2, 10, 11, 12]);
              regionalInformations_1 = __values(regionalInformations), regionalInformations_1_1 = regionalInformations_1.next();
              _b2.label = 3;
            case 3:
              if (!!regionalInformations_1_1.done)
                return [3, 9];
              e = regionalInformations_1_1.value;
              _b2.label = 4;
            case 4:
              _b2.trys.push([4, 7, , 8]);
              if (!(e.iceServers && e.iceServers.length > 0))
                return [3, 6];
              return [4, this.measurements.getNetworkQuality(e.iceServers)];
            case 5:
              results = _b2.sent();
              regionData.push(__assign(__assign({}, e), { networkResults: results }));
              _b2.label = 6;
            case 6:
              return [3, 8];
            case 7:
              e_1 = _b2.sent();
              console.warn("Error handling ", e_1);
              return [3, 8];
            case 8:
              regionalInformations_1_1 = regionalInformations_1.next();
              return [3, 3];
            case 9:
              return [3, 12];
            case 10:
              e_2_1 = _b2.sent();
              e_2 = { error: e_2_1 };
              return [3, 12];
            case 11:
              try {
                if (regionalInformations_1_1 && !regionalInformations_1_1.done && (_a3 = regionalInformations_1.return))
                  _a3.call(regionalInformations_1);
              } finally {
                if (e_2)
                  throw e_2.error;
              }
              return [7];
            case 12:
              resolve({
                regionData
              });
              return [3, 14];
            case 13:
              e_3 = _b2.sent();
              console.warn("Error in callstats, ", e_3);
              reject(e_3);
              return [3, 14];
            case 14:
              return [2];
          }
        });
      });
    });
    promise.then(function(e) {
      _this.eventHandler.callEvent({
        event: Event.NET_QUALITY_TEST_END,
        timestamp: new Date(),
        metaData: e
      });
    });
  };
  CallStats2.prototype.sendWebSocketConnectedEvent = function() {
    this.eventHandler.callEvent({
      event: Event.WEBSOCKET_CONNECTED,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendTransportConnectedEvent = function() {
    this.eventHandler.callEvent({
      event: Event.TRANSPORT_CONNECTED,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendAudioToggleEvent = function(on) {
    this.currentUserMediaStates.audio = on;
    var event;
    if (!on) {
      event = Event.AUDIO_OFF;
    } else {
      event = Event.AUDIO_ON;
    }
    this.eventHandler.callEvent({
      event,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendVideoToggleEvent = function(on) {
    this.currentUserMediaStates.video = on;
    var event;
    if (!on) {
      event = Event.VIDEO_OFF;
    } else {
      event = Event.VIDEO_ON;
    }
    this.eventHandler.callEvent({
      event,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendParticipantRoleToggleEvent = function(role) {
    this.eventHandler.callEvent({
      event: Event.PARTICIPANT_ROLE,
      timestamp: new Date(),
      metaData: role
    });
  };
  CallStats2.prototype.startPingStats = function(interval) {
    if (interval === void 0) {
      interval = 7e3;
    }
    this.pingStatsTimeout = setInterval(this.sendPingStatsEvent.bind(this), interval);
  };
  CallStats2.prototype.stopPingStats = function() {
    clearInterval(this.pingStatsTimeout);
  };
  CallStats2.prototype.sendPingStatsEvent = function() {
    var _a3, _b2;
    return __awaiter$2(this, void 0, void 0, function() {
      var proReport, conReport, report, report, metaData;
      return __generator$1(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            if (!this.producingTransport)
              return [3, 5];
            return [4, this.measurements.getProcessedStats(this.producingTransport, false, true)];
          case 1:
            proReport = _c2.sent();
            if (!(!proReport || !(proReport === null || proReport === void 0 ? void 0 : proReport.producerReport)))
              return [3, 5];
            this.logger.log("Stale producer? Regenerating Stream Maps!");
            return [4, this.measurements.getProducersReport(__spreadArray([], __read(this.producers.values())))];
          case 2:
            report = _c2.sent();
            if (!(proReport && report))
              return [3, 3];
            proReport.producerReport = report;
            return [3, 5];
          case 3:
            return [4, this.measurements.getProcessedStats(this.producingTransport, false, true)];
          case 4:
            proReport = _c2.sent();
            if (!proReport || !(proReport === null || proReport === void 0 ? void 0 : proReport.producerReport)) {
              this.logger.log("Stream maps invalid despite regenerating!");
            }
            _c2.label = 5;
          case 5:
            if (!this.consumingTransport)
              return [3, 10];
            return [4, this.measurements.getProcessedStats(this.consumingTransport, true, false)];
          case 6:
            conReport = _c2.sent();
            if (!(!conReport || !conReport.consumerReport))
              return [3, 10];
            this.logger.log("Stale consumer? Regenerating Stream Maps!");
            return [4, this.measurements.getConsumersReport(__spreadArray([], __read(this.consumers.values())))];
          case 7:
            report = _c2.sent();
            if (!(conReport && report))
              return [3, 8];
            conReport.consumerReport = report;
            return [3, 10];
          case 8:
            return [4, this.measurements.getProcessedStats(this.consumingTransport, true, false)];
          case 9:
            conReport = _c2.sent();
            if (!conReport || !conReport.consumerReport) {
              this.logger.log("Stream maps invalid despite regenerating!");
            }
            _c2.label = 10;
          case 10:
            metaData = {
              producingTransportStats: proReport ? proReport === null || proReport === void 0 ? void 0 : proReport.transportReport : void 0,
              consumingTransportStats: conReport ? conReport === null || conReport === void 0 ? void 0 : conReport.transportReport : void 0,
              producerStats: proReport ? (_a3 = proReport === null || proReport === void 0 ? void 0 : proReport.producerReport) === null || _a3 === void 0 ? void 0 : _a3.concat(conReport === null || conReport === void 0 ? void 0 : conReport.producerReport) : void 0,
              consumerStats: conReport ? (_b2 = conReport === null || conReport === void 0 ? void 0 : conReport.consumerReport) === null || _b2 === void 0 ? void 0 : _b2.concat(proReport === null || proReport === void 0 ? void 0 : proReport.consumerReport) : void 0
            };
            this.eventHandler.callEvent({
              event: Event.PING_STAT,
              metaData,
              timestamp: new Date()
            });
            return [2];
        }
      });
    });
  };
  CallStats2.prototype.sendDisconnectEvent = function() {
    this.eventHandler.callEvent({
      event: Event.DISCONNECT,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendReconnectEvent = function() {
    this.eventHandler.callEvent({
      event: Event.RECONNECT_ATTEMPT,
      timestamp: new Date()
    });
  };
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "authenticate", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "registerIceServers", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "registerConsumer", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "registerProducer", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendConsumerSharedMediaStateEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "registerProducingTransport", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "registerConsumingTransport", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "deRegisterConsumer", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "deRegisterProducer", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "disconnectConsumingTransport", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "disconnectProducingTransport", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendPreCallTestBeginEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendScreenShareToggleEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendScreenShareRequestedEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendActiveSpeakerEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "devices", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "selectedDevice", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "mediaPermission", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "mediaPlaybackFailed", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "mediaTrackMuted", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "tabChanged", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "browserBackgrounded", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "browserForegrounded", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "legacySwitch", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "getPreCallTestResults", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendCallJoinBeginEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendNetworkQualityTestBeginEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendWebSocketConnectedEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendTransportConnectedEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendAudioToggleEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendVideoToggleEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendParticipantRoleToggleEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "startPingStats", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "stopPingStats", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendPingStatsEvent", null);
  CallStats2 = __decorate([
    CatchClass(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2);
  return CallStats2;
}();
var __extends = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter$1 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f, y2, t2, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n2) {
    return function(v2) {
      return step([n2, v2]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
          return t2;
        if (y2 = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y2 = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t2 = _.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t2[1]) {
              _.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _.label < t2[2]) {
              _.label = t2[2];
              _.ops.push(op);
              break;
            }
            if (t2[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y2 = 0;
      } finally {
        f = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var InhouseCallStats = function(_super) {
  __extends(InhouseCallStats2, _super);
  function InhouseCallStats2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.initialized = false;
    _this.stalled = false;
    return _this;
  }
  InhouseCallStats2.prototype.initialize = function(_a3) {
    var _b2, _c2;
    var peerId = _a3.peerId, engineName = _a3.engineName, _d2 = _a3.env, env = _d2 === void 0 ? ClientEnvType.PRODUCTION : _d2, iceServers = _a3.iceServers, _e2 = _a3.apiBase, apiBase = _e2 === void 0 ? "https://api.cluster.dyte.in" : _e2;
    return __awaiter$1(this, void 0, void 0, function() {
      var _this = this;
      return __generator(this, function(_f2) {
        try {
          this.peerId = peerId;
          this.backend = new CallStats(apiBase, engineName, env);
          this.backend.eventHandler.on("initialized", function(e) {
            _this.ipInformation = e;
            _this.initialized = true;
            _this.emit("initialized", e);
          });
          (_b2 = this.backend) === null || _b2 === void 0 ? void 0 : _b2.authenticate({ peerId });
          this.iceServers = iceServers;
          (_c2 = this.backend) === null || _c2 === void 0 ? void 0 : _c2.registerIceServers(this.iceServers);
          this.startPreCallTest();
        } catch (error) {
          console.error("CallStatsIntegration: ", error);
          this.stallCallStats();
        }
        return [2];
      });
    });
  };
  InhouseCallStats2.prototype.setRoomName = function(roomName) {
    this.roomURL = roomName;
  };
  InhouseCallStats2.prototype.configureSendTransport = function(sendTransport) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.registerProducingTransport(sendTransport);
  };
  InhouseCallStats2.prototype.configureRecvTransport = function(recvTransport) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.registerConsumingTransport(recvTransport);
  };
  InhouseCallStats2.prototype.candidateRegionalNetworkQualityTest = function(regionalIceServersInfo) {
    var _a3;
    return __awaiter$1(this, void 0, void 0, function() {
      return __generator(this, function(_b2) {
        try {
          (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendNetworkQualityTestBeginEvent(regionalIceServersInfo);
        } catch (ex) {
          console.log("sendNetworkQualityTestBeginEvent Failed: ", ex);
        }
        return [2];
      });
    });
  };
  InhouseCallStats2.prototype.roomJoined = function(peerData) {
    var _a3, _b2;
    return __awaiter$1(this, void 0, void 0, function() {
      return __generator(this, function(_c2) {
        (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendCallJoinBeginEvent(peerData);
        if (this.backend)
          ;
        (_b2 = this.backend) === null || _b2 === void 0 ? void 0 : _b2.startPingStats();
        return [2];
      });
    });
  };
  InhouseCallStats2.prototype.audioOff = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendAudioToggleEvent(false);
  };
  InhouseCallStats2.prototype.audioOn = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendAudioToggleEvent(true);
  };
  InhouseCallStats2.prototype.videoOff = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendVideoToggleEvent(false);
  };
  InhouseCallStats2.prototype.videoOn = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendVideoToggleEvent(true);
  };
  InhouseCallStats2.prototype.callEnded = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendDisconnectEvent();
  };
  InhouseCallStats2.prototype.screenShareStart = function(ssrc) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendScreenShareToggleEvent(true, ssrc);
  };
  InhouseCallStats2.prototype.consumerSharedMediaState = function(consumerId, statusObj) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendConsumerSharedMediaStateEvent(consumerId, statusObj);
  };
  InhouseCallStats2.prototype.screenShareStop = function(ssrc) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendScreenShareToggleEvent(false, ssrc);
  };
  InhouseCallStats2.prototype.screenShareRequested = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendScreenShareRequestedEvent();
  };
  InhouseCallStats2.prototype.activeSpeaker = function(peerId) {
    var _a3;
    if (peerId !== this.peerId) {
      return;
    }
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendActiveSpeakerEvent(peerId);
  };
  InhouseCallStats2.prototype.devices = function(deviceType, deviceList) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.devices(deviceType, deviceList);
  };
  InhouseCallStats2.prototype.selectedDevice = function(deviceType, device) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.selectedDevice(deviceType, device);
  };
  InhouseCallStats2.prototype.mediaPermission = function(deviceType, permission) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.mediaPermission(deviceType, permission);
  };
  InhouseCallStats2.prototype.mediaPlaybackFailed = function(deviceType) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.mediaPlaybackFailed(deviceType);
  };
  InhouseCallStats2.prototype.mediaTrackMuted = function(deviceType) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.mediaTrackMuted(deviceType);
  };
  InhouseCallStats2.prototype.tabChanged = function(backToCurrentTab) {
    var _a3;
    if (backToCurrentTab === void 0) {
      backToCurrentTab = false;
    }
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.tabChanged(backToCurrentTab);
  };
  InhouseCallStats2.prototype.browserBackgrounded = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.browserBackgrounded();
  };
  InhouseCallStats2.prototype.browserForegrounded = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.browserForegrounded();
  };
  InhouseCallStats2.prototype.legacySwitch = function(on) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.legacySwitch(on);
  };
  InhouseCallStats2.prototype.startPreCallTest = function() {
    var _a3;
    return __awaiter$1(this, void 0, void 0, function() {
      return __generator(this, function(_b2) {
        (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendPreCallTestBeginEvent();
        return [2];
      });
    });
  };
  InhouseCallStats2.prototype.onPreCallTestResults = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.once("precall_end", fx);
    return fx;
  };
  InhouseCallStats2.prototype.onReceivingConsumerAudioStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("consumer_audio_status", fx);
  };
  InhouseCallStats2.prototype.onReceivingConsumerVideoStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("consumer_video_status", fx);
  };
  InhouseCallStats2.prototype.onReceivingProducerAudioStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("producer_audio_status", fx);
  };
  InhouseCallStats2.prototype.onReceivingProducerVideoStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("producer_video_status", fx);
  };
  InhouseCallStats2.prototype.onReceivingProducingTransportStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("producing_transport_status", fx);
  };
  InhouseCallStats2.prototype.onReceivingConsumingTransportStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("consuming_transport_status", fx);
  };
  InhouseCallStats2.prototype.onSafeInitialization = function(cb2) {
    if (this.initialized) {
      cb2(this.ipInformation, false);
    } else if (!this.stalled) {
      var eventEmitterCB = function(ipInfo) {
        var isAsyncInitialization = true;
        cb2(ipInfo, isAsyncInitialization);
      };
      this.once("initialized", eventEmitterCB);
      return eventEmitterCB;
    }
    return function() {
    };
  };
  InhouseCallStats2.prototype.removeInitializationListener = function(fx) {
    this.removeListener("initialized", fx);
  };
  InhouseCallStats2.prototype.stallCallStats = function() {
    this.stalled = true;
    this.removeAllListeners("initialized");
  };
  return InhouseCallStats2;
}(EventEmitter$3);
var callStats = new InhouseCallStats();
callStats.setMaxListeners(30);
log.setLevel("SILENT");
var dist$1 = {};
var defaultPreset = {};
var types = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", { value: true });
  exports2.WaitingRoomConversionToV1Type = exports2.DyteViewTypes = exports2.WaitingRoomTypes = void 0;
  (function(WaitingRoomTypes) {
    WaitingRoomTypes["skip"] = "SKIP";
    WaitingRoomTypes["onAccept"] = "ON_ACCEPT";
    WaitingRoomTypes["skipOnPrivilegedUserEntry"] = "SKIP_ON_PRIVILEGED_USER_ENTRY";
    WaitingRoomTypes["skipOnAccept"] = "SKIP_ON_ACCEPT";
  })(exports2.WaitingRoomTypes || (exports2.WaitingRoomTypes = {}));
  (function(DyteViewTypes) {
    DyteViewTypes["groupCall"] = "GROUP_CALL";
    DyteViewTypes["webinar"] = "WEBINAR";
    DyteViewTypes["audioRoom"] = "AUDIO_ROOM";
  })(exports2.DyteViewTypes || (exports2.DyteViewTypes = {}));
  (function(WaitingRoomConversionToV1Type) {
    WaitingRoomConversionToV1Type["SKIP"] = "skip";
    WaitingRoomConversionToV1Type["SKIP_ON_PRIVILEGED_USER_ENTRY"] = "skipOnPrivilegedUserEntry";
    WaitingRoomConversionToV1Type["ON_ACCEPT"] = "skipOnAccept";
    WaitingRoomConversionToV1Type["SKIP_ON_ACCEPT"] = "";
  })(exports2.WaitingRoomConversionToV1Type || (exports2.WaitingRoomConversionToV1Type = {}));
})(types);
Object.defineProperty(defaultPreset, "__esModule", { value: true });
defaultPreset.theme = defaultPreset.permissions = void 0;
const types_1$1 = types;
defaultPreset.permissions = {
  view_type: types_1$1.DyteViewTypes.groupCall,
  accept_waiting_requests: false,
  accept_present_requests: false,
  request_produce: false,
  can_allow_participant_audio: false,
  can_allow_participant_screensharing: false,
  can_allow_participant_video: false,
  request_kick_participant: false,
  kick_participant: false,
  pin_participant: false,
  can_edit_display_name: false,
  can_record: false,
  can_present: true,
  waiting_room_type: types_1$1.WaitingRoomTypes.skipOnAccept,
  plugins: {
    can_close: true,
    can_start: true
  },
  polls: {
    can_create: true,
    can_vote: true,
    can_view: true
  },
  produce: {
    video: {
      allow: true,
      quality: "vga",
      frame_rate: 24
    },
    audio: true,
    screenshare: {
      allow: true,
      quality: "hd",
      frame_rate: 5
    }
  },
  chat: {
    public: {
      can_send: true,
      text: true,
      files: true
    },
    private: {
      can_send: false,
      can_receive: false,
      text: false,
      files: false
    }
  },
  reactions: false,
  hidden_participant: false,
  is_recorder: false,
  show_participant_list: true,
  can_change_participant_role: false,
  can_change_theme: false,
  max_screenshare_count: 1
};
defaultPreset.theme = {
  setup_screen: {
    is_enabled: true
  },
  alone_here: {
    is_enabled: true
  },
  waiting_room: {
    is_enabled: false,
    enable_preview: true
  },
  control_bar: {
    is_enabled: true,
    elements: {
      plugins: true,
      screenshare: true,
      invite: true,
      participants: true,
      chat: true,
      reactions: false,
      polls: true,
      fullscreen: true,
      layout: true
    }
  },
  header: {
    is_enabled: true,
    elements: {
      timer: true,
      title: true,
      participant_count: true,
      change_layout: true
    }
  },
  pip_mode: true,
  auto_tune: true,
  grid: {
    multi: {
      maxVideoCount: 6,
      videoFit: "cover"
    },
    single: {
      maxVideoCount: 6,
      videoFit: "cover"
    },
    defaultView: "multi"
  },
  controls: {
    pip_toggle: false
  }
};
var presetConversion = {};
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", { value: true });
  exports2.convertPresetToV2 = exports2.convertThemeToV2 = exports2.convertPresetToV1 = void 0;
  const types_12 = types;
  const convertPresetToV1 = (exisitngPreset, preset) => {
    var _a3, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _j, _k, _l, _m;
    const convertedPreset = Object.assign({}, exisitngPreset);
    if (preset.permissions) {
      const modifiedPermissions = Object.assign({}, convertedPreset.role);
      if (preset.permissions.accept_waiting_requests !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { acceptWaitingRequests: preset.permissions.accept_waiting_requests });
      }
      if (preset.permissions.can_allow_participant_audio !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { disableParticipantAudio: preset.permissions.can_allow_participant_audio });
      }
      if (preset.permissions.can_allow_participant_screensharing !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { disableParticipantScreensharing: preset.permissions.can_allow_participant_screensharing });
      }
      if (preset.permissions.can_allow_participant_video !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { disableParticipantVideo: preset.permissions.can_allow_participant_video });
      }
      if (preset.permissions.kick_participant !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { kickParticipants: preset.permissions.kick_participant });
      }
      if (preset.permissions.pin_participant !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { pinParticipant: preset.permissions.pin_participant });
      }
      if (preset.permissions.can_record !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { allowRecording: preset.permissions.can_record });
      }
      if (preset.permissions.can_edit_display_name !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { editDisplayName: preset.permissions.can_edit_display_name });
      }
      const { waiting_room_type } = preset.permissions;
      if (waiting_room_type) {
        modifiedPermissions.waitingRoom = types_12.WaitingRoomConversionToV1Type[waiting_room_type];
      }
      if (preset.permissions.plugins) {
        modifiedPermissions.plugins = {
          close: preset.permissions.plugins.can_close,
          start: preset.permissions.plugins.can_start
        };
      }
      if (preset.permissions.produce) {
        modifiedPermissions.produce = Object.assign(Object.assign({}, modifiedPermissions.produce), { video: preset.permissions.produce.video.allow, audio: preset.permissions.produce.audio, screenshare: preset.permissions.produce.screenshare.allow });
      }
      if (preset.permissions.polls) {
        modifiedPermissions.produce = Object.assign(Object.assign({}, modifiedPermissions.produce), { polls: preset.permissions.polls.can_create });
      }
      if (preset.permissions.chat) {
        modifiedPermissions.produce = Object.assign(Object.assign({}, modifiedPermissions.produce), { chat: {
          text: preset.permissions.chat.public.text,
          files: preset.permissions.chat.public.files
        } });
      }
      if (preset.permissions.reactions !== void 0) {
        modifiedPermissions.produce = Object.assign(Object.assign({}, modifiedPermissions.produce), { reactions: preset.permissions.reactions });
      }
      if (preset.permissions.hidden_participant !== void 0) {
        modifiedPermissions.flags = Object.assign(Object.assign({}, modifiedPermissions.flags), { hiddenParticipant: preset.permissions.hidden_participant });
      }
      if (preset.permissions.is_recorder !== void 0) {
        modifiedPermissions.flags = Object.assign(Object.assign({}, modifiedPermissions.flags), { recorder: preset.permissions.is_recorder });
      }
      if (preset.permissions.view_type === types_12.DyteViewTypes.webinar) {
        modifiedPermissions.webinar = Object.assign(Object.assign({}, modifiedPermissions.webinar), { viewOnly: preset.permissions.request_produce });
        convertedPreset.roomViewType = "webinar";
      }
      if (preset.permissions.accept_present_requests !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { acceptWaitingRequests: preset.permissions.accept_present_requests });
        modifiedPermissions.webinar = Object.assign(Object.assign({}, modifiedPermissions.webinar), { viewOnly: !preset.permissions.accept_present_requests });
        convertedPreset.roomViewType = "webinar";
      }
      convertedPreset["role"] = modifiedPermissions;
    }
    if (preset.theme) {
      const modifiedUiConfig = Object.assign({}, convertedPreset.uiConfig);
      if (preset.theme.alone_here) {
        modifiedUiConfig["aloneHereElement"] = !!preset.theme.alone_here;
      }
      if (preset.theme.waiting_room) {
        modifiedUiConfig["waitingRoom"] = {
          showSelf: preset.theme.waiting_room.enable_preview,
          roomElement: preset.theme.waiting_room.element
        };
      }
      if (preset.theme.control_bar) {
        modifiedUiConfig["controlBar"] = preset.theme.control_bar.is_enabled;
        modifiedUiConfig["controlBarElements"] = {
          share: (_a3 = preset.theme.control_bar.elements) === null || _a3 === void 0 ? void 0 : _a3.invite,
          screenShare: (_b2 = preset.theme.control_bar.elements) === null || _b2 === void 0 ? void 0 : _b2.screenshare,
          plugins: (_c2 = preset.theme.control_bar.elements) === null || _c2 === void 0 ? void 0 : _c2.plugins,
          participants: (_d2 = preset.theme.control_bar.elements) === null || _d2 === void 0 ? void 0 : _d2.participants,
          chat: (_e2 = preset.theme.control_bar.elements) === null || _e2 === void 0 ? void 0 : _e2.chat,
          polls: (_f2 = preset.theme.control_bar.elements) === null || _f2 === void 0 ? void 0 : _f2.polls,
          fullscreen: (_g2 = preset.theme.control_bar.elements) === null || _g2 === void 0 ? void 0 : _g2.fullscreen
        };
      }
      if (preset.theme.header) {
        modifiedUiConfig["header"] = preset.theme.header.is_enabled;
        modifiedUiConfig["headerElements"] = {
          clock: (_h2 = preset.theme.header.elements) === null || _h2 === void 0 ? void 0 : _h2.timer,
          title: (_j = preset.theme.header.elements) === null || _j === void 0 ? void 0 : _j.title,
          logo: !!((_k = preset.theme.header.elements) === null || _k === void 0 ? void 0 : _k.logo),
          participantCount: (_l = preset.theme.header.elements) === null || _l === void 0 ? void 0 : _l.participant_count
        };
        modifiedUiConfig["logo"] = (_m = preset.theme.header.elements) === null || _m === void 0 ? void 0 : _m.logo;
      }
      if (preset.theme.auto_tune) {
        modifiedUiConfig.grid = Object.assign({}, preset.theme.grid);
      }
      if (preset.theme.grid) {
        modifiedUiConfig.grid = Object.assign({}, preset.theme.grid);
      }
      if (preset.theme.colors) {
        modifiedUiConfig["colors"] = {
          primary: preset.theme.colors.primary,
          secondary: preset.theme.colors.secondary,
          textPrimary: preset.theme.colors.text,
          videoBackground: preset.theme.colors.background
        };
      }
      if (preset.theme.dimensions) {
        modifiedUiConfig["dimensions"] = {
          width: preset.theme.dimensions.width,
          height: preset.theme.dimensions.height
        };
      }
      convertedPreset["uiConfig"] = modifiedUiConfig;
    }
    return convertedPreset;
  };
  exports2.convertPresetToV1 = convertPresetToV1;
  const convertThemeToV2 = (parentTheme, oldTheme) => {
    var _a3;
    const newTheme = Object.assign({}, parentTheme);
    const controlBarBody = Object.assign(Object.assign({}, newTheme.control_bar), { is_enabled: oldTheme.controlBar !== void 0 ? oldTheme.controlBar : newTheme.control_bar.is_enabled });
    const headerBody = Object.assign(Object.assign({}, newTheme.header), { is_enabled: oldTheme.header !== void 0 ? oldTheme.header : newTheme.header.is_enabled });
    if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements) {
      const elements = Object.assign({}, controlBarBody.elements);
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.chat) !== void 0) {
        elements.chat = oldTheme.controlBarElements.chat;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.fullscreen) !== void 0) {
        elements.fullscreen = oldTheme.controlBarElements.fullscreen;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.participants) !== void 0) {
        elements.participants = oldTheme.controlBarElements.participants;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.plugins) !== void 0) {
        elements.plugins = oldTheme.controlBarElements.plugins;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.polls) !== void 0) {
        elements.polls = oldTheme.controlBarElements.polls;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.screenShare) !== void 0) {
        elements.screenshare = oldTheme.controlBarElements.screenShare;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.share) !== void 0) {
        elements.invite = oldTheme.controlBarElements.share;
      }
      elements.reactions = false;
      elements.layout = false;
      controlBarBody.elements = elements;
    }
    if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.headerElements) {
      const elements = Object.assign({}, headerBody.elements);
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.headerElements.clock) !== void 0) {
        elements.timer = oldTheme.headerElements.clock;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.headerElements.participantCount) !== void 0) {
        elements.participant_count = oldTheme.headerElements.participantCount;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.headerElements.title) !== void 0) {
        elements.title = oldTheme.headerElements.title;
      }
      elements.change_layout = false;
      headerBody.elements = elements;
    }
    if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.logo) !== void 0 && oldTheme.logo !== "") {
      headerBody.elements.logo = oldTheme.logo;
    }
    newTheme.header = headerBody;
    newTheme.control_bar = controlBarBody;
    if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.colors) {
      const colorBody = Object.assign({}, newTheme.colors);
      if (oldTheme.colors.primary) {
        colorBody.primary = oldTheme.colors.primary;
      }
      if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.colors.secondary) {
        colorBody.secondary = oldTheme.colors.secondary;
      }
      if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.colors.textPrimary) {
        colorBody.text = oldTheme.colors.textPrimary;
        colorBody.textPrimary = oldTheme.colors.textPrimary;
      }
      if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.colors.videoBackground) {
        colorBody.background = oldTheme.colors.videoBackground;
        colorBody.videoBackground = oldTheme.colors.videoBackground;
      }
      newTheme.colors = colorBody;
    }
    if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.dimensions) {
      newTheme.dimensions = oldTheme.dimensions;
    }
    if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.waitingRoom) {
      newTheme.waiting_room = {
        is_enabled: true,
        enable_preview: ((_a3 = oldTheme.waitingRoom) === null || _a3 === void 0 ? void 0 : _a3.showSelf) !== void 0 ? oldTheme.waitingRoom.showSelf : true,
        element: oldTheme.waitingRoom.roomElement
      };
    }
    if (oldTheme.aloneHereElement !== void 0) {
      newTheme.alone_here = {
        is_enabled: oldTheme.aloneHereElement
      };
    }
    newTheme.pip_mode = true;
    return newTheme;
  };
  exports2.convertThemeToV2 = convertThemeToV2;
  const convertPresetToV2 = (exisitngPreset, preset) => {
    var _a3, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const convertedPreset = Object.assign({}, exisitngPreset);
    if (preset.role) {
      const permissionBody = Object.assign({}, convertedPreset.permissions);
      if (((_a3 = preset.role.permissions) === null || _a3 === void 0 ? void 0 : _a3.acceptWaitingRequests) !== void 0) {
        permissionBody.accept_waiting_requests = preset.role.permissions.acceptWaitingRequests;
      }
      if (((_b2 = preset.role.permissions) === null || _b2 === void 0 ? void 0 : _b2.allowRecording) !== void 0) {
        permissionBody.can_record = preset.role.permissions.allowRecording;
      }
      if (((_c2 = preset.role.permissions) === null || _c2 === void 0 ? void 0 : _c2.editDisplayName) !== void 0) {
        permissionBody.can_edit_display_name = preset.role.permissions.editDisplayName;
      }
      if (((_d2 = preset.role.permissions) === null || _d2 === void 0 ? void 0 : _d2.disableParticipantAudio) !== void 0) {
        permissionBody.can_allow_participant_audio = preset.role.permissions.disableParticipantAudio;
      }
      if (((_e2 = preset.role.permissions) === null || _e2 === void 0 ? void 0 : _e2.disableParticipantScreensharing) !== void 0) {
        permissionBody.can_allow_participant_screensharing = preset.role.permissions.disableParticipantScreensharing;
      }
      if (((_f2 = preset.role.permissions) === null || _f2 === void 0 ? void 0 : _f2.disableParticipantVideo) !== void 0) {
        permissionBody.can_allow_participant_video = preset.role.permissions.disableParticipantVideo;
      }
      if (((_g2 = preset.role.permissions) === null || _g2 === void 0 ? void 0 : _g2.kickParticipants) !== void 0) {
        permissionBody.kick_participant = preset.role.permissions.kickParticipants;
      }
      if (((_h2 = preset.role.permissions) === null || _h2 === void 0 ? void 0 : _h2.pinParticipant) !== void 0) {
        permissionBody.pin_participant = preset.role.permissions.pinParticipant;
      }
      if ((_j = preset.role) === null || _j === void 0 ? void 0 : _j.plugins) {
        permissionBody.plugins = {
          can_start: preset.role.plugins.start,
          can_close: preset.role.plugins.close,
          can_edit_acl: preset.role.plugins.canEditAcl,
          config: {}
        };
        if ((_l = (_k = preset.role) === null || _k === void 0 ? void 0 : _k.pluginConfig) === null || _l === void 0 ? void 0 : _l.hostOnlyControl) {
          preset.role.pluginConfig.hostOnlyControl.forEach((pluginId) => {
            permissionBody.plugins.config[pluginId] = {
              defaultAccess: "whitelist"
            };
          });
        }
        if ((_o = (_m = preset.role) === null || _m === void 0 ? void 0 : _m.pluginConfig) === null || _o === void 0 ? void 0 : _o.handlesViewOnly) {
          preset.role.pluginConfig.hostOnlyControl.forEach((pluginId) => {
            if (permissionBody.plugins.config[pluginId] === void 0) {
              permissionBody.plugins.config[pluginId] = {
                defaultAccess: "blacklist"
              };
            }
            permissionBody.plugins.config[pluginId].handlesViewOnly = true;
          });
        }
      }
      if ((_p = preset.role) === null || _p === void 0 ? void 0 : _p.produce) {
        permissionBody.produce = {
          video: Object.assign(Object.assign({}, permissionBody.produce.video), { allow: ((_q = preset.role.produce) === null || _q === void 0 ? void 0 : _q.video) !== void 0 ? preset.role.produce.video : true }),
          audio: preset.role.produce.audio !== void 0 ? preset.role.produce.audio : true,
          screenshare: Object.assign(Object.assign({}, permissionBody.produce.screenshare), { allow: ((_r = preset.role.produce) === null || _r === void 0 ? void 0 : _r.screenshare) !== void 0 ? preset.role.produce.screenshare : true })
        };
        permissionBody.polls = Object.assign(Object.assign({}, permissionBody.polls), { can_create: preset.role.produce.polls !== void 0 ? preset.role.produce.polls : true });
        if ((_s = preset.role.produce) === null || _s === void 0 ? void 0 : _s.chat) {
          permissionBody.chat = Object.assign(Object.assign({}, permissionBody.chat), { public: Object.assign(Object.assign({}, preset.role.produce.chat), { can_send: true }) });
        }
      }
      if (preset.role.flags) {
        permissionBody.hidden_participant = preset.role.flags.hiddenParticipant;
        permissionBody.is_recorder = preset.role.flags.recorder;
      }
      permissionBody.show_participant_list = true;
      permissionBody.can_change_participant_role = false;
      permissionBody.view_type = preset.roomViewType ? types_12.DyteViewTypes[preset.roomViewType] : types_12.DyteViewTypes.groupCall;
      permissionBody.reactions = false;
      permissionBody.request_produce = !!(types_12.DyteViewTypes[preset.roomViewType] === types_12.DyteViewTypes.webinar && ((_u = (_t = preset.role) === null || _t === void 0 ? void 0 : _t.webinar) === null || _u === void 0 ? void 0 : _u.viewOnly));
      permissionBody.request_kick_participant = false;
      permissionBody.waiting_room_type = preset.role.waitingRoom ? types_12.WaitingRoomTypes[preset.role.waitingRoom] : types_12.WaitingRoomTypes.skip;
      permissionBody.accept_present_requests = !!(types_12.DyteViewTypes[preset.roomViewType] === types_12.DyteViewTypes.webinar && !((_w = (_v = preset.role) === null || _v === void 0 ? void 0 : _v.webinar) === null || _w === void 0 ? void 0 : _w.viewOnly) && ((_x = preset.role.permissions) === null || _x === void 0 ? void 0 : _x.acceptWaitingRequests));
      convertedPreset.permissions = permissionBody;
    }
    if (preset.uiConfig) {
      convertedPreset.theme = (0, exports2.convertThemeToV2)(convertedPreset.theme, preset.uiConfig);
    }
    return convertedPreset;
  };
  exports2.convertPresetToV2 = convertPresetToV2;
})(presetConversion);
var defaultV2preset = {};
Object.defineProperty(defaultV2preset, "__esModule", { value: true });
defaultV2preset.defaultV2Preset = void 0;
const types_1 = types;
const defaultRolePermissions = {
  view_type: types_1.DyteViewTypes.groupCall,
  accept_waiting_requests: false,
  accept_present_requests: false,
  request_produce: false,
  can_allow_participant_audio: false,
  can_allow_participant_screensharing: false,
  can_allow_participant_video: false,
  request_kick_participant: false,
  kick_participant: false,
  pin_participant: false,
  can_edit_display_name: false,
  can_record: false,
  waiting_room_type: types_1.WaitingRoomTypes.skipOnAccept,
  plugins: {
    can_close: true,
    can_start: true,
    can_edit_acl: false,
    config: {}
  },
  polls: {
    can_create: true,
    can_vote: true,
    can_view: true
  },
  produce: {
    video: {
      allow: true,
      quality: "vga",
      frame_rate: 24
    },
    audio: true,
    screenshare: {
      allow: true,
      quality: "hd",
      frame_rate: 5
    }
  },
  chat: {
    public: {
      can_send: true,
      text: true,
      files: true
    },
    private: {
      can_send: false,
      can_receive: false,
      text: false,
      files: false
    }
  },
  reactions: false,
  hidden_participant: false,
  is_recorder: false,
  show_participant_list: true,
  can_change_participant_role: false,
  can_change_theme: false,
  can_present: false,
  max_screenshare_count: 1
};
const defaultTheme = {
  setup_screen: {
    is_enabled: false
  },
  alone_here: {
    is_enabled: false
  },
  waiting_room: {
    is_enabled: false,
    enable_preview: true
  },
  control_bar: {
    is_enabled: true,
    elements: {
      plugins: true,
      screenshare: true,
      invite: false,
      participants: true,
      chat: true,
      reactions: false,
      polls: true,
      fullscreen: true,
      layout: true
    }
  },
  header: {
    is_enabled: true,
    elements: {
      timer: true,
      title: true,
      participant_count: true,
      change_layout: true
    }
  },
  pip_mode: true,
  auto_tune: true,
  grid: {
    multi: {
      maxVideoCount: 6,
      videoFit: "cover"
    },
    single: {
      maxVideoCount: 6,
      videoFit: "cover"
    },
    defaultView: "MULTI"
  },
  controls: {
    pip_toggle: false
  }
};
defaultV2preset.defaultV2Preset = {
  permissions: defaultRolePermissions,
  theme: defaultTheme,
  version: "0.5.0"
};
var flagsmith = {};
var __awaiter = commonjsGlobal$1 && commonjsGlobal$1.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
var _a;
Object.defineProperty(flagsmith, "__esModule", { value: true });
flagsmith.createNewFlagsmithInstance = flagsmith.globalFlagsmith = void 0;
const axios_1 = __importDefault(axios);
let defaultEnvironmentKey = "hXgU8Wc8pwuGNq9ms5q9Hh";
if (typeof process != "undefined") {
  if ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.FLAGSMITH_ENVIRONMENT_KEY) {
    defaultEnvironmentKey = {}.FLAGSMITH_ENVIRONMENT_KEY;
  }
}
function normalizeFlags(respFlags = []) {
  const formattedFlags = {};
  respFlags.forEach((respFlag) => {
    formattedFlags[respFlag.feature.name] = {
      enabled: respFlag.enabled,
      value: respFlag.feature_state_value
    };
  });
  return formattedFlags;
}
class Flagsmith {
  constructor(environmentKey = defaultEnvironmentKey) {
    this.flags = {};
    this.environmentKey = null;
    this.environmentKey = environmentKey;
    this.identify = this.identify.bind(this);
    this.getValue = this.getValue.bind(this);
    this.hasFeature = this.hasFeature.bind(this);
    this.getAllFlags = this.getAllFlags.bind(this);
  }
  identify(uniqueIdentifier, traitsObj = {}, forceEvaluate = false, timeout = 5e3) {
    return __awaiter(this, void 0, void 0, function* () {
      const traits = JSON.parse(JSON.stringify(traitsObj));
      const formattedTraits = Object.entries(traits).map((tuple) => ({
        trait_key: tuple[0],
        trait_value: tuple[1]
      }));
      try {
        const randomChars = "_" + (Math.random() + 1).toString(36).substring(2);
        const flagsmithResponse = yield axios_1.default.post("https://api.flagsmith.com/api/v1/identities/", {
          identifier: uniqueIdentifier + (forceEvaluate ? randomChars : ""),
          traits: formattedTraits
        }, {
          headers: {
            "Content-Type": "application/json",
            "X-Environment-Key": this.environmentKey
          },
          timeout
        });
        this.flags = normalizeFlags(flagsmithResponse.data.flags || []);
      } catch (ex) {
      }
      return this.flags;
    });
  }
  getValue(featureFlagName) {
    return this.flags && this.flags[featureFlagName] && this.flags[featureFlagName].value;
  }
  hasFeature(featureFlagName) {
    return this.flags && this.flags[featureFlagName] && this.flags[featureFlagName].enabled;
  }
  getAllFlags() {
    return this.flags;
  }
}
const globalFlagsmith = new Flagsmith();
flagsmith.globalFlagsmith = globalFlagsmith;
function createNewFlagsmithInstance(environmentKey) {
  return new Flagsmith(environmentKey);
}
flagsmith.createNewFlagsmithInstance = createNewFlagsmithInstance;
(function(exports2) {
  var __createBinding = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault || (Object.create ? function(o, v2) {
    Object.defineProperty(o, "default", { enumerable: true, value: v2 });
  } : function(o, v2) {
    o["default"] = v2;
  });
  var __importStar = commonjsGlobal$1 && commonjsGlobal$1.__importStar || function(mod) {
    if (mod && mod.__esModule)
      return mod;
    var result = {};
    if (mod != null) {
      for (var k in mod)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
  };
  var __exportStar = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(m, exports3) {
    for (var p in m)
      if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p))
        __createBinding(exports3, m, p);
  };
  Object.defineProperty(exports2, "__esModule", { value: true });
  exports2.defaultPreset = void 0;
  const defaultPreset$1 = __importStar(defaultPreset);
  exports2.defaultPreset = defaultPreset$1;
  __exportStar(presetConversion, exports2);
  __exportStar(types, exports2);
  __exportStar(defaultV2preset, exports2);
  __exportStar(flagsmith, exports2);
})(dist$1);
const CHROME = "chrome";
const OPERA = "opera";
const FIREFOX = "firefox";
const INTERNET_EXPLORER = "iexplorer";
const SAFARI = "safari";
const NWJS = "nwjs";
const ELECTRON = "electron";
const REACT_NATIVE = "react-native";
const UNKNOWN = "unknown";
const bowserNameToJitsiName = {
  Chrome: CHROME,
  Chromium: CHROME,
  Opera: OPERA,
  Firefox: FIREFOX,
  "Internet Explorer": INTERNET_EXPLORER,
  Safari: SAFARI
};
function _detectChromiumBased() {
  const { userAgent } = navigator;
  const browserInfo = {
    name: UNKNOWN,
    version: void 0
  };
  if (userAgent.match(/Chrome/) && !userAgent.match(/Edge/)) {
    if (userAgent.match(/Edg(A?)/)) {
      const version = userAgent.match(/Chrome\/([\d.]+)/)[1];
      if (Number.parseInt(version, 10) > 72) {
        browserInfo.name = CHROME;
        browserInfo.version = version;
      }
    } else {
      browserInfo.name = CHROME;
      browserInfo.version = userAgent.match(/Chrome\/([\d.]+)/)[1];
    }
  }
  return browserInfo;
}
function _detectElectron() {
  const { userAgent } = navigator;
  if (userAgent.match(/Electron/)) {
    const version = userAgent.match(/Electron\/([\d.]+)/)[1];
    return {
      name: ELECTRON,
      version
    };
  }
  return null;
}
function _detectNWJS() {
  const { userAgent } = navigator;
  if (userAgent.match(/JitsiMeetNW/)) {
    const version = userAgent.match(/JitsiMeetNW\/([\d.]+)/)[1];
    return {
      name: NWJS,
      version
    };
  }
}
function _detectReactNative() {
  const match = navigator.userAgent.match(/\b(react[ \t_-]*native)(?:\/(\S+))?/i);
  let version;
  if (match || navigator.product === "ReactNative") {
    if (match && match.length > 2) {
      version = match[2];
    }
    version || (version = "unknown");
    return {
      name: REACT_NATIVE,
      version
    };
  }
}
function _detect(bowser) {
  let browserInfo;
  const detectors = [
    _detectReactNative,
    _detectElectron,
    _detectNWJS
  ];
  for (let i2 = 0; i2 < detectors.length; i2 += 1) {
    browserInfo = detectors[i2]();
    if (browserInfo) {
      return browserInfo;
    }
  }
  const name = bowser.getBrowserName();
  if (name in bowserNameToJitsiName) {
    return {
      name: bowserNameToJitsiName[name],
      version: bowser.getBrowserVersion()
    };
  }
  browserInfo = _detectChromiumBased();
  if (browserInfo) {
    return browserInfo;
  }
  return {
    name: UNKNOWN,
    version: void 0
  };
}
class BrowserDetection {
  constructor() {
    __publicField(this, "_bowser");
    __publicField(this, "_name");
    __publicField(this, "_version");
    __publicField(this, "getDeviceInfo", () => ({
      isMobile: this.isMobile(),
      browserName: this._bowser.getBrowserName(),
      osName: this._bowser.getOSName(),
      browserVersion: this._bowser.getBrowserVersion(),
      osVersionName: this._bowser.getOSVersion(),
      engineName: this._bowser.getEngineName()
    }));
  }
  init(browserInfo) {
    let name;
    let version;
    this._bowser = Bowser.getParser(navigator.userAgent);
    if (typeof browserInfo === "undefined") {
      const detectedBrowserInfo = _detect(this._bowser);
      name = detectedBrowserInfo.name;
      version = detectedBrowserInfo.version;
    } else if (browserInfo.name in bowserNameToJitsiName) {
      name = bowserNameToJitsiName[browserInfo.name];
      version = browserInfo.version;
    } else {
      name = UNKNOWN;
      version = void 0;
    }
    this._name = name;
    this._version = version;
  }
  getName() {
    return this._name;
  }
  isChrome() {
    return this._name === CHROME;
  }
  isOpera() {
    return this._name === OPERA;
  }
  isFirefox() {
    return this._name === FIREFOX;
  }
  isIExplorer() {
    return this._name === INTERNET_EXPLORER;
  }
  isSafari() {
    return this._name === SAFARI;
  }
  isNWJS() {
    return this._name === NWJS;
  }
  isElectron() {
    return this._name === ELECTRON;
  }
  isReactNative() {
    return this._name === REACT_NATIVE;
  }
  getVersion() {
    return this._version;
  }
  isMobile() {
    return this._bowser.getPlatformType() === "mobile";
  }
  _checkCondition(checkTree) {
    if (this._version) {
      return this._bowser.satisfies(checkTree);
    }
  }
  isVersionGreaterThan(version) {
    return this._checkCondition({ [this._name]: `>${version}` });
  }
  isVersionLessThan(version) {
    return this._checkCondition({ [this._name]: `<${version}` });
  }
  isVersionEqualTo(version) {
    return this._checkCondition({ [this._name]: `~${version}` });
  }
}
const MIN_REQUIRED_CHROME_VERSION = 72;
class BrowserCapabilities extends BrowserDetection {
  doesVideoMuteByStreamRemove() {
    return this.isChromiumBased() || this.isWebKitBased();
  }
  supportsP2P() {
    return !this.usesUnifiedPlan();
  }
  isChromiumBased() {
    return this.isChrome() || this.isElectron() || this.isNWJS() || this.isOpera();
  }
  isWebKitBased() {
    return this._bowser.isEngine("webkit") && typeof navigator.mediaDevices !== "undefined" && typeof navigator.mediaDevices.getUserMedia !== "undefined" && typeof window.RTCRtpTransceiver !== "undefined" && Object.keys(RTCRtpTransceiver.prototype).indexOf("currentDirection") > -1;
  }
  isSupported() {
    return this.isChromiumBased() && this._getChromiumBasedVersion() >= MIN_REQUIRED_CHROME_VERSION || this.isFirefox() || this.isReactNative() || this.isWebKitBased();
  }
  isUserInteractionRequiredForUnmute() {
    return this.isFirefox() && this.isVersionLessThan("68");
  }
  supportsVideoMuteOnConnInterrupted() {
    return this.isChromiumBased() || this.isReactNative() || this.isWebKitBased();
  }
  supportsBandwidthStatistics() {
    return !this.isFirefox() && !this.isWebKitBased();
  }
  supportsCodecPreferences() {
    return this.usesUnifiedPlan() && typeof window.RTCRtpTransceiver !== "undefined" && Object.keys(window.RTCRtpTransceiver.prototype).indexOf("setCodecPreferences") > -1 && Object.keys(RTCRtpSender.prototype).indexOf("getCapabilities") > -1 && !this.isWebKitBased();
  }
  supportsDeviceChangeEvent() {
    return navigator.mediaDevices && typeof navigator.mediaDevices.ondevicechange !== "undefined" && typeof navigator.mediaDevices.addEventListener !== "undefined";
  }
  supportsLocalCandidateRttStatistics() {
    return this.isChromiumBased() || this.isReactNative() || this.isWebKitBased();
  }
  supportsPerformanceObserver() {
    return typeof window.PerformanceObserver !== "undefined" && PerformanceObserver.supportedEntryTypes.indexOf("longtask") > -1;
  }
  supportsReceiverStats() {
    return typeof window.RTCRtpReceiver !== "undefined" && Object.keys(RTCRtpReceiver.prototype).indexOf("getSynchronizationSources") > -1;
  }
  supportsRTTStatistics() {
    return !this.isFirefox();
  }
  usesPlanB() {
    return !this.usesUnifiedPlan();
  }
  usesSdpMungingForSimulcast() {
    return this.isChromiumBased() || this.isReactNative() || this.isWebKitBased();
  }
  usesUnifiedPlan() {
    if (this.isFirefox() || this.isWebKitBased()) {
      return true;
    }
    return false;
  }
  usesNewGumFlow() {
    if (this.isChromiumBased() || this.isFirefox() || this.isWebKitBased()) {
      return true;
    }
    return false;
  }
  usesAdapter() {
    return this.usesNewGumFlow();
  }
  usesRidsForSimulcast() {
    return false;
  }
  supportsGetDisplayMedia() {
    return typeof navigator.getDisplayMedia !== "undefined" || typeof navigator.mediaDevices !== "undefined" && typeof navigator.mediaDevices.getDisplayMedia !== "undefined";
  }
  supportsInsertableStreams() {
    if (!(typeof window.RTCRtpSender !== "undefined" && (window.RTCRtpSender.prototype.createEncodedStreams || window.RTCRtpSender.prototype.createEncodedVideoStreams))) {
      return false;
    }
    const stream = new ReadableStream();
    try {
      window.postMessage(stream, "*", [stream]);
      return true;
    } catch {
      return false;
    }
  }
  supportsAudioRed() {
    return Boolean(window.RTCRtpSender && window.RTCRtpSender.getCapabilities && window.RTCRtpSender.getCapabilities("audio").codecs.some((codec) => codec.mimeType === "audio/red") && window.RTCRtpReceiver && window.RTCRtpReceiver.getCapabilities && window.RTCRtpReceiver.getCapabilities("audio").codecs.some((codec) => codec.mimeType === "audio/red"));
  }
  supportsSdpSemantics() {
    return this.isChromiumBased();
  }
  _getChromiumBasedVersion() {
    if (this.isChromiumBased()) {
      if (this.isNWJS()) {
        return Number.parseInt(process.versions.chromium, 10);
      }
      const ua = navigator.userAgent;
      if (ua.match(/Chrome/)) {
        const version = Number.parseInt(ua.match(/Chrome\/([\d.]+)/)[1], 10);
        return version;
      }
    }
    return -1;
  }
}
const browserSpecs = new BrowserCapabilities();
var FlagsmithIdentifierPrefix;
(function(FlagsmithIdentifierPrefix2) {
  FlagsmithIdentifierPrefix2["PARTICIPANT"] = "PARTICIPANT";
  FlagsmithIdentifierPrefix2["PEER"] = "PEER";
  FlagsmithIdentifierPrefix2["CLIENT"] = "CLIENT";
})(FlagsmithIdentifierPrefix || (FlagsmithIdentifierPrefix = {}));
var FlagsmithFeatureFlags;
(function(FlagsmithFeatureFlags2) {
  FlagsmithFeatureFlags2["QUICK_ZOOM"] = "quick_zoom";
  FlagsmithFeatureFlags2["INTERNAL_CALL_STATS"] = "internal_call_stats";
  FlagsmithFeatureFlags2["CFWS"] = "cfws";
  FlagsmithFeatureFlags2["LOGROCKET"] = "logrocket";
  FlagsmithFeatureFlags2["SIMULCAST"] = "simulcast";
  FlagsmithFeatureFlags2["CHAT_SOCKET_SERVER"] = "chat_socket_server";
  FlagsmithFeatureFlags2["PLUGIN_SOCKET_SERVER"] = "plugin_socket_server";
  FlagsmithFeatureFlags2["DEV_MODE_PLUGINS"] = "dev_mode_plugins";
  FlagsmithFeatureFlags2["NR_OTEL_WEB"] = "nr_otel_web";
})(FlagsmithFeatureFlags || (FlagsmithFeatureFlags = {}));
function _flattenObjForOpenTelemetry(obj, parentKey, res = {}) {
  Object.getOwnPropertyNames(obj).forEach((key) => {
    if ([null, void 0, NaN].includes(obj[key])) {
      return;
    }
    const propName = parentKey ? `${parentKey}.${key}` : key;
    if (typeof obj[key] === "object") {
      _flattenObjForOpenTelemetry(obj[key], propName, res);
    } else {
      res[propName] = obj[key];
    }
  });
  return res;
}
const _DyteTelemetry = class {
  static init(peerId) {
    const exporter = new OTLPTraceExporter({
      url: "https://otel.dyte.io/v1/traces",
      headers: {
        "api-key": ""
      }
    });
    const provider = new WebTracerProvider({
      resource: new Resource({
        "service.name": "web-core"
      })
    });
    _DyteTelemetry.tracer = provider.getTracer(peerId);
    _DyteTelemetry.meetingMetadata.peerId = peerId;
    provider.addSpanProcessor(new BatchSpanProcessor(exporter));
    provider.register({
      contextManager: new ZoneContextManager()
    });
    _DyteTelemetry.rootSpan = _DyteTelemetry.tracer.startSpan(`peer_${peerId}`, {}, ROOT_CONTEXT);
    _DyteTelemetry.rootSpan.end();
    _DyteTelemetry.logsProcessorTimer = setInterval(_DyteTelemetry.processCachedLogs, _DyteTelemetry.logsProcessingInterval);
  }
  static trace(spanName) {
    return (_target, _propertyKey, descriptor) => {
      const originalMethod = descriptor.value;
      descriptor.value = function opentelemetryValueDescriptorFunc(...args) {
        const immmediateParentSpan = _DyteTelemetry.getCurrentSpan();
        const ctx = opentelemetry.trace.setSpan(ROOT_CONTEXT, immmediateParentSpan);
        if (!dist$1.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.NR_OTEL_WEB)) {
          _DyteTelemetry.addEventInCurrentSpan("info", spanName);
        }
        return _DyteTelemetry.tracer.startActiveSpan(spanName, {}, ctx, (span) => {
          span.setAttributes({
            [SemanticAttributes.CODE_FUNCTION]: spanName
          });
          const result = originalMethod.apply(this, args);
          Promise.resolve(result).then(() => {
            span.end();
          }).catch(() => {
            span.end();
          });
          return result;
        });
      };
      return descriptor;
    };
  }
  static getCurrentSpan() {
    let immmediateParentSpan = opentelemetry.trace.getSpan(opentelemetry.context.active());
    immmediateParentSpan != null ? immmediateParentSpan : immmediateParentSpan = _DyteTelemetry.rootSpan;
    return immmediateParentSpan;
  }
  static getCurrentSpanName() {
    var _a3;
    return (_a3 = this.getCurrentSpan()) == null ? void 0 : _a3.name;
  }
  static addEventInCurrentSpan(eventSeverity = "info", eventName, metadata = {}, noCache) {
    var _a3;
    try {
      const flattendMetadata = _flattenObjForOpenTelemetry(metadata, "metadata");
      const currentSpan = _DyteTelemetry.getCurrentSpan();
      const logToProcess = __spreadProps(__spreadValues({
        message: eventName,
        logSeverity: eventSeverity
      }, flattendMetadata), {
        "trace.id": _DyteTelemetry.meetingMetadata.peerId,
        "span.id": (_a3 = currentSpan == null ? void 0 : currentSpan.spanContext()) == null ? void 0 : _a3.spanId,
        loggedAt: new Date().getTime()
      });
      if (noCache) {
        _DyteTelemetry.sendOtelLogsToNewRelic([logToProcess]);
      } else {
        _DyteTelemetry.logsCache.push(logToProcess);
      }
    } catch (ex) {
      log.error("opentelemetry::addEventInCurrentSpan_failed", ex);
    }
  }
  static sendOtelLogsToNewRelic(logs) {
    axios.post(_DyteTelemetry.logsEndpoint, {
      meetingMetadata: _flattenObjForOpenTelemetry(_DyteTelemetry.meetingMetadata, "meetingMetadata"),
      serviceName: "web-core",
      logs
    }).catch((err) => {
      log.error("opentelemetry::sendOtelLogToNewRelic_failed", err);
    });
  }
  static processCachedLogs() {
    const logs = _DyteTelemetry.logsCache.splice(0, 25);
    if (logs == null ? void 0 : logs.length) {
      _DyteTelemetry.sendOtelLogsToNewRelic(logs);
    }
  }
};
let DyteTelemetry = _DyteTelemetry;
__publicField(DyteTelemetry, "tracer");
__publicField(DyteTelemetry, "rootSpan");
__publicField(DyteTelemetry, "logsCache", []);
__publicField(DyteTelemetry, "logsProcessorTimer");
__publicField(DyteTelemetry, "logsEndpoint", "https://api-silos.dyte.io/otel/logs");
__publicField(DyteTelemetry, "logsProcessingInterval", 7e3);
__publicField(DyteTelemetry, "logExclusionList", [
  "message",
  "websocket/message",
  "roomMessage",
  "websocket/room-message",
  "chatMessage",
  "websocket/new-chat-message",
  "websocket/no-active-speaker",
  "websocket/selected-peers",
  "websocket/active-speaker"
]);
__publicField(DyteTelemetry, "meetingMetadata", {});
var SocketEvents;
(function(SocketEvents2) {
  SocketEvents2["SOCKET_CONNECTED"] = "SOCKET_CONNECTED";
  SocketEvents2["SOCKET_DISCONNECTED"] = "SOCKET_DISCONNECTED";
  SocketEvents2["SOCKET_CONNECTION_ERROR"] = "SOCKET_CONNECTION_ERROR";
  SocketEvents2["SOCKET_MESSAGE"] = "SOCKET_MESSAGE";
})(SocketEvents || (SocketEvents = {}));
var SocketState;
(function(SocketState2) {
  SocketState2[SocketState2["NOT_STARTED"] = 0] = "NOT_STARTED";
  SocketState2[SocketState2["CONNECTED"] = 1] = "CONNECTED";
  SocketState2[SocketState2["DISCONNECTED"] = 2] = "DISCONNECTED";
  SocketState2[SocketState2["ERRORED"] = 3] = "ERRORED";
})(SocketState || (SocketState = {}));
var SessionEvents;
(function(SessionEvents2) {
  SessionEvents2["NEW_PRODUCER"] = "NEW_PRODUCER";
  SessionEvents2["ROOM_NODE_CONNECTED"] = "ROOM_NODE_CONNECTED";
  SessionEvents2["ROOM_NODE_DISCONNECTED"] = "ROOM_NODE_DISCONNECTED";
  SessionEvents2["ROOM_JOINED"] = "ROOM_JOINED";
  SessionEvents2["SELF_ROOM_JOINED"] = "SELF_ROOM_JOINED";
  SessionEvents2["LOW_PRODUCER_SCORE"] = "LOW_PRODUCER_SCORE";
  SessionEvents2["LOW_CONSUMER_SCORE"] = "LOW_CONSUMER_SCORE";
  SessionEvents2["MEDIA_PERMISSION_ERROR"] = "MEDIA_PERMISSION_ERROR";
  SessionEvents2["WAITLISTED"] = "WAIT_LISTED";
  SessionEvents2["WAITLIST_ACCEPTED"] = "websocket/waitlist-accepted";
  SessionEvents2["WAITLIST_REJECTED"] = "websocket/waitlist-rejected";
  SessionEvents2["WAITLIST_PEER_ADDED"] = "websocket/waitlist-peer-added";
  SessionEvents2["WAITLIST_PEER_REMOVED"] = "websocket/waitlist-peer-closed";
  SessionEvents2["MESSAGE"] = "websocket/message";
  SessionEvents2["ROOM_MESSAGE"] = "websocket/room-message";
  SessionEvents2["DISABLE_AUDIO"] = "websocket/disable-audio";
  SessionEvents2["DISABLE_VIDEO"] = "websocket/disable-video";
  SessionEvents2["PEER_JOINED"] = "websocket/peer-joined";
  SessionEvents2["PEER_CLOSED"] = "websocket/peer-closed";
  SessionEvents2["PEER_MUTED"] = "websocket/peer-muted";
  SessionEvents2["PEER_UNMUTED"] = "websocket/peer-unmuted";
  SessionEvents2["PEER_PINNED"] = "websocket/pin-peer";
  SessionEvents2["PEER_UNPINNED"] = "websocker/unpin-peer";
  SessionEvents2["MUTE_ALL"] = "websocket/mute-all";
  SessionEvents2["MUTE_ALL_VIDEO"] = "websocket/mute-all-video";
  SessionEvents2["CONSUMER_CLOSED"] = "websocket/consumer-closed";
  SessionEvents2["CONSUMER_PAUSED"] = "websocket/consumer-paused";
  SessionEvents2["CONSUMER_RESUMED"] = "websocket/consumer-resumed";
  SessionEvents2["PRODUCER_CLOSED"] = "websocket/producer-closed";
  SessionEvents2["NEW_CONSUMER"] = "websocket/new-consumer";
  SessionEvents2["GET_CHAT_MESSAGES"] = "websocket/get-chat-messages";
  SessionEvents2["NEW_CHAT_MESSAGE"] = "websocket/new-chat-message";
  SessionEvents2["PIN_CHAT_MESSAGE"] = "websocket/pin-chat-message";
  SessionEvents2["UNPIN_CHAT_MESSAGE"] = "websocket/unpin-chat-message";
  SessionEvents2["GET_POLLS"] = "websocket/get-polls";
  SessionEvents2["UPDATE_POLL"] = "websocket/update-poll";
  SessionEvents2["SELECTED_PEERS"] = "websocket/selected-peers";
  SessionEvents2["GET_PAGE"] = "websocket/get-page";
  SessionEvents2["ACTIVE_SPEAKER"] = "websocket/active-speaker";
  SessionEvents2["NO_ACTIVE_SPEAKER"] = "websocket/no-active-speaker";
  SessionEvents2["PRODUCER_SCORE"] = "websocket/producer-score";
  SessionEvents2["CONSUMER_SCORE"] = "websocket/consumer-score";
  SessionEvents2["ENABLE_PLUGIN"] = "websocket/enable-plugin";
  SessionEvents2["DISABLE_PLUGIN"] = "websocket/disable-plugin";
  SessionEvents2["PLUGIN_EVENT"] = "websocket/plugin-event";
  SessionEvents2["PLUGIN_DATA"] = "websocket/plugin-data";
  SessionEvents2["PLUGIN_INTERNAL_DATA"] = "websocket/plugin-internal-data";
  SessionEvents2["KICKED"] = "websocket/kicked";
  SessionEvents2["RECORDING_STARTED"] = "websocket/recording-started";
  SessionEvents2["RECORDING_STOPPED"] = "websocket/recording-stopped";
})(SessionEvents || (SessionEvents = {}));
class SessionStoreHandler extends events$1.exports.EventEmitter {
  constructor() {
    super();
    __privateAdd2(this, _eventPromises, void 0);
    __privateAdd2(this, _asyncListeners, void 0);
    __publicField(this, "asyncPromiseTimeout");
    __privateSet2(this, _eventPromises, new Map());
    __privateSet2(this, _asyncListeners, new Map());
    this.asyncPromiseTimeout = 8e3;
  }
  async emitAsync(event, ...args) {
    __privateGet2(this, _eventPromises).set(event, []);
    const promises = __privateGet2(this, _asyncListeners).get(event).map(() => new Promise((resolve) => {
      __privateGet2(this, _eventPromises).get(event).push(resolve);
    }));
    super.emit(event, ...args);
    await Promise.race([
      Promise.all(promises),
      new Promise((_, reject) => setTimeout(() => reject(new Error("emitAsync failed to resolve.")), this.asyncPromiseTimeout))
    ]);
    __privateGet2(this, _eventPromises).delete(event);
  }
  onAsync(event, cb2) {
    const eventPromises = __privateGet2(this, _eventPromises);
    const listener = async (...args) => {
      var _a3;
      try {
        await cb2(...args);
      } catch (e) {
        log.error(`[onAsync] ${e}`);
      }
      const resolve = (_a3 = eventPromises.get(event)) == null ? void 0 : _a3.shift();
      resolve == null ? void 0 : resolve();
    };
    if (!__privateGet2(this, _asyncListeners).get(event)) {
      __privateGet2(this, _asyncListeners).set(event, []);
    }
    __privateGet2(this, _asyncListeners).get(event).push(listener);
    return super.on(event, listener);
  }
}
_eventPromises = new WeakMap();
_asyncListeners = new WeakMap();
const SessionStore = new SessionStoreHandler();
var __defProp$i = Object.defineProperty;
var __getOwnPropDesc$i = Object.getOwnPropertyDescriptor;
var __decorateClass$i = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$i(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$i(target, key, result);
  return result;
};
const SIMPLE_SERVER_MESSAGE_EVENT = "event://server-simple-message";
const CLIENT_SIDE_EVENT = "event://send-message";
class SocketClient extends EventEmitter$3 {
  constructor(options) {
    super();
    __publicField(this, "socket");
    __publicField(this, "socketState");
    __publicField(this, "callbackHandler", null);
    this.socketState = SocketState.NOT_STARTED;
    if (options.callbackHandler) {
      this.callbackHandler = options.callbackHandler;
    }
  }
  connect(url) {
    if (this.socket) {
      this.socket.disconnect();
    }
    this.socket = io(url);
    this.setupSocket();
  }
  disconnect() {
    this.socket.disconnect();
  }
  reconnect() {
    this.socket.connect();
  }
  setupSocket() {
    this.socket.on("disconnect", (reason) => {
      this.socketState = SocketState.DISCONNECTED;
      DyteTelemetry.addEventInCurrentSpan("warn", "SocketClient::socket_disconnected", { reason });
      this.emit(SocketEvents.SOCKET_DISCONNECTED, { reason });
    });
    this.socket.on("connect_error", (err) => {
      this.socketState = SocketState.ERRORED;
      log.error(`socket connection errored due to : ${err}`);
      DyteTelemetry.addEventInCurrentSpan("error", "SocketClient::socket_connection_errored", { message: err.message });
      this.emit(SocketEvents.SOCKET_CONNECTION_ERROR, { err });
    });
    this.socket.on("connect", () => {
      this.socketState = SocketState.CONNECTED;
      DyteTelemetry.addEventInCurrentSpan("info", "SocketClient::socket_connected");
      this.emit(SocketEvents.SOCKET_CONNECTED);
    });
    this.socket.on(SIMPLE_SERVER_MESSAGE_EVENT, async (message2, callback) => {
      const parsedMessage = JSON.parse(message2);
      if (!DyteTelemetry.logExclusionList.includes(parsedMessage == null ? void 0 : parsedMessage.type)) {
        DyteTelemetry.addEventInCurrentSpan("info", "SocketClient::SIMPLE_SERVER_MESSAGE_EVENT", { message: parsedMessage });
      }
      if (callback) {
        let response = "OK";
        if (this.callbackHandler) {
          response = await this.callbackHandler(parsedMessage);
        }
        callback(response);
      } else
        this.emit(SocketEvents.SOCKET_MESSAGE, parsedMessage);
      if (Object.values(SessionEvents).find((e) => e === parsedMessage.type)) {
        SessionStore.emit(parsedMessage.type, parsedMessage.payload);
      }
    });
  }
  async sendMessage(message2) {
    if (!DyteTelemetry.logExclusionList.includes(message2 == null ? void 0 : message2.type)) {
      DyteTelemetry.addEventInCurrentSpan("info", "SocketClient::sendMessage", { message: message2 });
    }
    return new Promise((resolve) => {
      this.socket.emit(CLIENT_SIDE_EVENT, JSON.stringify(message2), (response) => {
        if (!response) {
          resolve(void 0);
          return;
        }
        const parsedMessage = JSON.parse(response);
        resolve(parsedMessage);
      });
    });
  }
}
__decorateClass$i([
  DyteTelemetry.trace("SocketClient.connect")
], SocketClient.prototype, "connect", 1);
__decorateClass$i([
  DyteTelemetry.trace("SocketClient.disconnect")
], SocketClient.prototype, "disconnect", 1);
__decorateClass$i([
  DyteTelemetry.trace("SocketClient.reconnect")
], SocketClient.prototype, "reconnect", 1);
__decorateClass$i([
  DyteTelemetry.trace("SocketClient.setupSocket")
], SocketClient.prototype, "setupSocket", 1);
const VIDEO_CONSTRAINTS = {
  qvga: { width: { ideal: 320 }, height: { ideal: 240 } },
  vga: { width: { ideal: 640 }, height: { ideal: 480 } },
  hd: { width: { ideal: 1280 }, height: { ideal: 720 } },
  hd_cropped: { width: { ideal: 900 }, height: { ideal: 720 } }
};
const PC_PROPRIETARY_CONSTRAINTS = {};
const WEBCAM_SIMULCAST_ENCODINGS_VGA = [
  { rid: "r0", scalabilityMode: "S1T2" },
  { rid: "r1", scalabilityMode: "S1T2" }
];
const WEBCAM_KSVC_ENCODINGS = [
  { scalabilityMode: "L3T3_KEY" }
];
var PRODUCERS_TYPE;
(function(PRODUCERS_TYPE2) {
  PRODUCERS_TYPE2["WEBCAM"] = "webcam";
  PRODUCERS_TYPE2["MIC"] = "mic";
  PRODUCERS_TYPE2["SCREENSHARE_VIDEO"] = "screenshare_video";
  PRODUCERS_TYPE2["SCREENSHARE_AUDIO"] = "screenshare_audio";
})(PRODUCERS_TYPE || (PRODUCERS_TYPE = {}));
class API {
  constructor(options) {
    __publicField(this, "axios");
    __publicField(this, "requests");
    __publicField(this, "roomName");
    __publicField(this, "roomUUID");
    __publicField(this, "peerId");
    __publicField(this, "authToken");
    __publicField(this, "organizationId");
    const {
      timeout = 1e4,
      baseURL = "https://api.cluster.dyte.in",
      authToken
    } = options || {};
    this.requests = axios.create({
      baseURL,
      responseType: "json",
      timeout
    });
    this.axios = axios;
    this.setAuthToken(authToken, { bearer: true });
    this.requests.interceptors.response.use((response) => {
      if (response.config.url !== DyteTelemetry.logsEndpoint) {
        DyteTelemetry.addEventInCurrentSpan("debug", "xhr::axios", {
          data: response.data,
          status: response.status,
          statusText: response.statusText,
          headers: response.config.headers,
          baseURL: response.config.baseURL,
          url: response.config.url
        });
      }
      return response;
    }, (error) => {
      var _a3, _b2, _c2, _d2;
      if (error && error.config && ((_a3 = error.config) == null ? void 0 : _a3.url) !== DyteTelemetry.logsEndpoint) {
        DyteTelemetry.addEventInCurrentSpan("error", "xhr::axios", {
          message: error == null ? void 0 : error.message,
          headers: (_b2 = error == null ? void 0 : error.config) == null ? void 0 : _b2.headers,
          status: error == null ? void 0 : error.status,
          statusText: error == null ? void 0 : error.statusText,
          stack: error == null ? void 0 : error.stack,
          baseUrl: (_c2 = error == null ? void 0 : error.config) == null ? void 0 : _c2.baseURL,
          url: (_d2 = error == null ? void 0 : error.config) == null ? void 0 : _d2.url
        });
      }
    });
  }
  setAuthToken(token, options) {
    const { bearer } = options || {};
    this.authToken = token;
    this.requests.defaults.headers.common.Authorization = bearer ? `Bearer ${token}` : token;
  }
  setHeader(key, value) {
    this.requests.defaults.headers.common[key] = value;
  }
  setRoomName(name) {
    this.roomName = name;
  }
  setRoomUUID(id) {
    this.roomUUID = id;
  }
  setPeerId(id) {
    this.peerId = id;
  }
  setOrganizationId(id) {
    this.organizationId = id;
  }
}
function stringToCamelCase(snakeCaseString) {
  return snakeCaseString.replace(/([-_]\w)/g, (g) => g[1].toUpperCase());
}
function objectToCamelCase(snakeCaseObject) {
  if (!snakeCaseObject || typeof snakeCaseObject !== "object") {
    return snakeCaseObject;
  }
  if (Array.isArray(snakeCaseObject)) {
    return snakeCaseObject.map((i2) => objectToCamelCase(i2));
  }
  const n2 = {};
  Object.keys(snakeCaseObject).forEach((k) => {
    n2[stringToCamelCase(k)] = objectToCamelCase(snakeCaseObject[k]);
  });
  return n2;
}
function postMessageSanitizer(value, acc = {}) {
  if (value === void 0 || value === null)
    return {};
  Object.getOwnPropertyNames(value).forEach((property) => {
    if (typeof value[property] === "function")
      return;
    if (typeof value[property] === "object") {
      postMessageSanitizer(value[property], acc[property] = {});
      return;
    }
    acc[property] = value[property];
  });
  return acc;
}
const config = {
  roomName: void 0,
  authToken: void 0,
  peerId: void 0,
  apiBase: void 0,
  defaults: void 0,
  modules: void 0
};
function setConfig(options) {
  config.roomName = options.roomName;
  config.authToken = options.authToken;
  config.peerId = options.peerId;
  config.apiBase = options.apiBase;
  config.defaults = options.defaults;
  config.modules = options.modules;
}
const WEB_CORE_VERSION = "0.29.0";
class DyteError extends Error {
  constructor(message2) {
    super(message2);
    __publicField(this, "code");
    this.name = "DyteError";
  }
}
const constants = {
  isV2AuthToken: false
};
function setIsV2AuthToken(authToken, roomName) {
  if (roomName) {
    constants.isV2AuthToken = false;
    return;
  }
  try {
    const { meetingId } = JSON.parse(atob(authToken.split(".")[1]));
    if (!meetingId)
      throw Error(`Received V1 authtoken ${authToken}`);
    constants.isV2AuthToken = true;
  } catch (ex) {
    DyteTelemetry.addEventInCurrentSpan("error", "constants::setIsV2AuthToken", {
      reason: "Unable to decode auth Token",
      authToken,
      roomName,
      exception: ex
    }, true);
    throw new DyteError("Invalid auth token or missing roomName");
  }
}
class APIClient extends API {
  constructor(options) {
    super(options);
    this.setHeader("x-dyte-web-core-version", WEB_CORE_VERSION);
  }
  async getRoomNodeData(roomName) {
    const { roomNodeLink, title } = constants.isV2AuthToken ? await this.getRoomNodeLinkAndTitleV2() : await this.getRoomNodeLinkAndTitleV1(roomName);
    return {
      roomNodeUrl: roomNodeLink,
      meetingTitle: title
    };
  }
  async getRoomNodeLinkAndTitleV1(roomName) {
    const query = `
        query Session($roomName: String!, $password: String) {
            session(roomName: $roomName, password: $password) {
              title,
              roomNodeLink,
              roomName,
              password
            }
          }
        `;
    const { roomNodeLink, title } = (await this.requests.post("/graphql", {
      query,
      variables: { roomName }
    })).data.data.session;
    return { roomNodeLink, title };
  }
  async getRoomNodeLinkAndTitleV2() {
    const { roomNodeLink, title } = objectToCamelCase((await this.requests.post("v2/internals/rooms")).data.data);
    return { roomNodeLink, title };
  }
  async getICEServers() {
    const { success, iceServers } = (await this.requests.get("/iceservers")).data;
    if (success) {
      return iceServers;
    }
    return void 0;
  }
  async getUserDetails() {
    return constants.isV2AuthToken ? this.getUserDetailsV2() : this.getUserDetailsV1();
  }
  async getUserDetailsV1() {
    const { user } = (await this.requests.get("/auth/basicUserDetails")).data;
    return user;
  }
  async getUserDetailsV2() {
    const userDetailsResponseV2 = (await this.requests.get("v2/internals/participant-details")).data.data;
    return objectToCamelCase(userDetailsResponseV2);
  }
  async getUserPreset(roomName) {
    const { preset } = (await this.requests.post("/v1/userpreset", {
      roomName,
      authToken: this.authToken,
      clientType: "CLIENT_APP",
      version: "0.5.0"
    })).data.data;
    return objectToCamelCase(preset);
  }
  async getPlugins() {
    const { plugins } = (await this.requests.get("/v2/plugins/user")).data.data;
    return plugins;
  }
  async getPluginDetails(pluginId) {
    const { plugin } = (await this.requests.get(`/v2/plugins/view/${pluginId}`)).data.data;
    return plugin;
  }
  async getPluginConfig(pluginBaseUrl) {
    const config2 = (await this.axios.get(`${pluginBaseUrl}/dyte-config.json`)).data;
    return config2;
  }
  async authorizePlugin(pluginId) {
    const { token } = (await this.requests.post(`/v2/plugins/authorize/${pluginId}`, {
      roomName: this.roomName,
      peerId: this.peerId
    })).data.data;
    return token;
  }
  async getPresignedUrls(filename) {
    const { getLocation, putLocation } = (await this.requests.post("/v1/meetings/genPreSignedUploadUrl", {
      roomUUID: this.roomUUID,
      filename
    })).data.data;
    return {
      getLocation,
      putLocation
    };
  }
  async uploadFile(file, url) {
    await this.axios.put(url, file, {
      headers: {
        "Content-Type": file.type
      }
    });
  }
  async startRecording() {
    const response = await this.requests.post(`/v1/organizations/${this.organizationId}/rooms/${this.roomName}/recording`);
    if (response.status !== 201) {
      throw new Error("Recording failed to start");
    }
    return response.data.data.recording.id;
  }
  async stopRecording(recordingId) {
    const response = await this.requests.put(`/v1/organizations/${this.organizationId}/rooms/${this.roomName}/recordings/${recordingId}`, { recordingAction: "stop" });
    if (response.status !== 201) {
      throw new Error("Recording failed to stop");
    }
    return response;
  }
  async getActiveRecording() {
    if (!this.organizationId)
      return {};
    const response = await this.requests.get(`/v1/organizations/${this.organizationId}/rooms/${this.roomName}/active-recording?limit=50`);
    return response.data.data.recording;
  }
}
let api;
function setupAPIClient(options) {
  api = new APIClient(options);
  return api;
}
function getAPIClient() {
  return api;
}
var __defProp$h = Object.defineProperty;
var __getOwnPropDesc$h = Object.getOwnPropertyDescriptor;
var __decorateClass$h = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$h(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$h(target, key, result);
  return result;
};
class SFUHandler extends EventEmitter$3 {
  constructor(socketClient) {
    super();
    __publicField(this, "device");
    __publicField(this, "sendTransport");
    __publicField(this, "recvTransport");
    __publicField(this, "consumers");
    __publicField(this, "producers");
    __publicField(this, "socketClient");
    this.producers = new Map();
    this.consumers = new Map();
    this.device = new Device();
    this.socketClient = socketClient;
  }
  async setupTransports() {
    const APIClient2 = getAPIClient();
    const iceServers = await APIClient2.getICEServers();
    await this.loadRouter();
    await Promise.all([
      this.createRecvTransport(iceServers),
      this.createSendTransport(iceServers)
    ]);
  }
  async loadRouter() {
    if (this.recvTransport || this.sendTransport) {
      await this.stopAllTransports();
    }
    const routerMessage = await this.socketClient.sendMessage({
      type: "getRouterRtpCapabilities"
    });
    const routerRtpCapabilities = routerMessage == null ? void 0 : routerMessage.payload;
    if (this.device.loaded) {
      this.device = new Device();
    }
    if (routerRtpCapabilities) {
      routerRtpCapabilities.headerExtensions = routerRtpCapabilities.headerExtensions.filter((ext) => ext.uri !== "urn:3gpp:video-orientation");
    }
    return this.device.load({ routerRtpCapabilities });
  }
  getRTPCapabilities() {
    return this.device.rtpCapabilities;
  }
  async createRecvTransport(iceServers) {
    if (!this.socketClient) {
      return;
    }
    const payload = {
      forceTcp: false,
      producing: false,
      consuming: true
    };
    const transportOptions = (await this.socketClient.sendMessage({
      type: "createWebRtcTransport",
      payload
    })).payload;
    DyteTelemetry.addEventInCurrentSpan("info", "recvTransport::initializing_transport");
    this.recvTransport = this.device.createRecvTransport(__spreadProps(__spreadValues({}, transportOptions), {
      iceServers,
      proprietaryConstraints: PC_PROPRIETARY_CONSTRAINTS
    }));
    DyteTelemetry.addEventInCurrentSpan("info", "recvTransport::initialized_transport");
    callStats.onSafeInitialization(() => {
      callStats.configureRecvTransport(this.recvTransport);
    });
    this.recvTransport.on("connect", async ({ dtlsParameters }, callback, err) => {
      var _a3;
      const message2 = await this.socketClient.sendMessage({
        type: "connectWebRtcTransport",
        payload: {
          transportId: this.recvTransport.id,
          dtlsParameters
        }
      });
      if (!((_a3 = message2.payload) == null ? void 0 : _a3.error)) {
        callback();
        DyteTelemetry.addEventInCurrentSpan("info", "recvTransport::transport_status", {
          status: "connected"
        });
      } else {
        DyteTelemetry.addEventInCurrentSpan("error", "recvTransport::transport_status", {
          status: "failed"
        });
        err();
      }
    });
    this.recvTransport.observer.on("close", () => {
      this.recvTransport = void 0;
      DyteTelemetry.addEventInCurrentSpan("warn", "recvTransport_closed");
    });
  }
  async createSendTransport(iceServers) {
    const payload = {
      forceTcp: false,
      producing: true,
      consuming: false
    };
    const transportOptions = (await this.socketClient.sendMessage({
      type: "createWebRtcTransport",
      payload
    })).payload;
    DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::initializing_transport");
    this.sendTransport = this.device.createSendTransport(__spreadProps(__spreadValues({}, transportOptions), {
      iceServers,
      proprietaryConstraints: PC_PROPRIETARY_CONSTRAINTS
    }));
    DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::initialized_transport");
    callStats.onSafeInitialization(() => {
      callStats.configureSendTransport(this.sendTransport);
    });
    this.sendTransport.on("connect", async ({ dtlsParameters }, callback, err) => {
      var _a3, _b2;
      const message2 = await this.socketClient.sendMessage({
        type: "connectWebRtcTransport",
        payload: {
          transportId: (_a3 = this.sendTransport) == null ? void 0 : _a3.id,
          dtlsParameters
        }
      });
      if (!((_b2 = message2.payload) == null ? void 0 : _b2.error)) {
        DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::transport_status", {
          status: "connected"
        });
        callback();
      } else {
        DyteTelemetry.addEventInCurrentSpan("error", "sendTransport::transport_status", {
          status: "failed"
        });
        err();
      }
    });
    this.sendTransport.on("produce", async ({
      kind,
      rtpParameters,
      appData
    }, callback, err) => {
      var _a3, _b2, _c2, _d2;
      const message2 = await this.socketClient.sendMessage({
        type: "produce",
        payload: {
          transportId: (_a3 = this.sendTransport) == null ? void 0 : _a3.id,
          kind,
          rtpParameters,
          appData
        }
      });
      if (!((_b2 = message2.payload) == null ? void 0 : _b2.error)) {
        DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::producer_status", {
          kind,
          appData,
          status: "producing"
        });
        callback({ id: (_c2 = message2.payload) == null ? void 0 : _c2.id });
      } else {
        DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::producer_status", {
          kind,
          appData,
          status: "failed"
        });
        err((_d2 = message2.payload) == null ? void 0 : _d2.error);
      }
    });
    this.sendTransport.observer.on("close", () => {
      this.sendTransport = void 0;
      DyteTelemetry.addEventInCurrentSpan("warn", "sendTransport_closed");
    });
  }
  async createConsumer(request) {
    if (this.recvTransport === void 0 || this.recvTransport.closed) {
      return;
    }
    const {
      peerId,
      producerId,
      id,
      kind,
      rtpParameters,
      appData,
      remotelyPaused
    } = request;
    DyteTelemetry.addEventInCurrentSpan("info", "createConsumer::initializing_consumer", {
      peerId,
      kind,
      appData,
      remotelyPaused
    });
    const consumer = await this.recvTransport.consume({
      id,
      producerId,
      kind,
      rtpParameters,
      appData: __spreadProps(__spreadValues({}, appData), { peerId })
    });
    DyteTelemetry.addEventInCurrentSpan("info", "createConsumer::initialized_consumer", {
      peerId,
      kind,
      appData,
      remotelyPaused
    });
    const extendedConsumer = consumer;
    extendedConsumer.peerId = peerId;
    extendedConsumer.remotelyPaused = remotelyPaused;
    extendedConsumer.score = 10;
    this.consumers.set(consumer.id, extendedConsumer);
  }
  async closeConsumer(request) {
    const { id } = request;
    const consumer = this.consumers.get(id);
    if (!consumer)
      return;
    DyteTelemetry.addEventInCurrentSpan("info", "SFUHandler::close_consumer", {
      peerId: consumer.peerId,
      kind: consumer.kind,
      appData: consumer.appData
    });
    consumer.close();
    this.consumers.delete(id);
  }
  async cleanupConsumers() {
    var _a3;
    (_a3 = this.consumers) == null ? void 0 : _a3.forEach((consumer) => {
      SessionStore.emit(SessionEvents.CONSUMER_CLOSED, { id: consumer.id });
      this.closeConsumer({ id: consumer.id });
    });
  }
  async pauseConsumer(request) {
    const { id } = request;
    const consumer = this.consumers.get(id);
    if (!consumer)
      return;
    consumer.pause();
  }
  async resumeConsumer(request) {
    const { id } = request;
    const consumer = this.consumers.get(id);
    if (!consumer)
      return;
    consumer.resume();
  }
  async createProducer(producerType, producerOptions, onDisconnect) {
    if (this.sendTransport === void 0 || this.sendTransport.closed) {
      return;
    }
    DyteTelemetry.addEventInCurrentSpan("info", "createProducer::initializing_producer", {
      producerType
    });
    const producer = await this.sendTransport.produce(producerOptions);
    DyteTelemetry.addEventInCurrentSpan("info", "createProducer::initialized_producer", {
      producerType
    });
    producer.on("transportclose", () => {
      DyteTelemetry.addEventInCurrentSpan("info", "producer::transportclose", {
        producerType
      });
      this.producers.delete(producerType);
    });
    producer.on("trackended", () => {
      DyteTelemetry.addEventInCurrentSpan("info", "producer::trackended", {
        producerType
      });
      if (![PRODUCERS_TYPE.MIC, PRODUCERS_TYPE.WEBCAM].includes(producerType)) {
        onDisconnect();
      }
    });
    const extendedProducer = producer;
    extendedProducer.score = 10;
    this.producers.set(producerType, extendedProducer);
  }
  async removeProducer(producerType, stopTrack = true) {
    const producer = this.producers.get(producerType);
    if (!producer || producer.closed) {
      return;
    }
    DyteTelemetry.addEventInCurrentSpan("info", "SFUHandler::remove_producer", {
      producerType,
      stopTrack
    });
    if (stopTrack) {
      producer.track.stop();
    }
    producer.close();
    await this.socketClient.sendMessage({ type: "closeProducer", payload: { producerId: producer.id } });
    this.producers.delete(producerType);
  }
  stopAllProducers() {
    Array.from(this.producers.keys()).forEach((producerType) => {
      this.removeProducer(producerType);
    });
  }
  async stopAllTransports() {
    if (this.sendTransport) {
      try {
        this.sendTransport.close();
      } catch (err) {
        log.error(err);
      }
      this.sendTransport = void 0;
    }
    if (this.recvTransport) {
      try {
        this.recvTransport.close();
      } catch (err) {
        DyteTelemetry.addEventInCurrentSpan("error", "SFUHandler::stopAllTransports::error", {
          message: err.message
        });
        log.error(err);
      }
      this.recvTransport = void 0;
    }
  }
}
__decorateClass$h([
  DyteTelemetry.trace("setupTransports")
], SFUHandler.prototype, "setupTransports", 1);
__decorateClass$h([
  DyteTelemetry.trace("loadRouter")
], SFUHandler.prototype, "loadRouter", 1);
__decorateClass$h([
  DyteTelemetry.trace("createRecvTransport")
], SFUHandler.prototype, "createRecvTransport", 1);
__decorateClass$h([
  DyteTelemetry.trace("createSendTransport")
], SFUHandler.prototype, "createSendTransport", 1);
__decorateClass$h([
  DyteTelemetry.trace("createConsumer")
], SFUHandler.prototype, "createConsumer", 1);
__decorateClass$h([
  DyteTelemetry.trace("closeConsumer")
], SFUHandler.prototype, "closeConsumer", 1);
__decorateClass$h([
  DyteTelemetry.trace("cleanupConsumers")
], SFUHandler.prototype, "cleanupConsumers", 1);
__decorateClass$h([
  DyteTelemetry.trace("pauseConsumer")
], SFUHandler.prototype, "pauseConsumer", 1);
__decorateClass$h([
  DyteTelemetry.trace("resumeConsumer")
], SFUHandler.prototype, "resumeConsumer", 1);
__decorateClass$h([
  DyteTelemetry.trace("createProducer")
], SFUHandler.prototype, "createProducer", 1);
__decorateClass$h([
  DyteTelemetry.trace("removeProducer")
], SFUHandler.prototype, "removeProducer", 1);
__decorateClass$h([
  DyteTelemetry.trace("stopAllProducers")
], SFUHandler.prototype, "stopAllProducers", 1);
__decorateClass$h([
  DyteTelemetry.trace("stopAllTransports")
], SFUHandler.prototype, "stopAllTransports", 1);
var DyteEvents;
(function(DyteEvents2) {
  DyteEvents2[DyteEvents2["*"] = 0] = "*";
  DyteEvents2[DyteEvents2["added"] = 1] = "added";
  DyteEvents2[DyteEvents2["deleted"] = 2] = "deleted";
  DyteEvents2[DyteEvents2["cleared"] = 3] = "cleared";
  DyteEvents2[DyteEvents2["connected"] = 4] = "connected";
  DyteEvents2[DyteEvents2["disconnected"] = 5] = "disconnected";
  DyteEvents2[DyteEvents2["poorConnection"] = 6] = "poorConnection";
  DyteEvents2[DyteEvents2["roomJoined"] = 7] = "roomJoined";
  DyteEvents2[DyteEvents2["waitlisted"] = 8] = "waitlisted";
  DyteEvents2[DyteEvents2["roomLeft"] = 9] = "roomLeft";
  DyteEvents2[DyteEvents2["audioUpdate"] = 10] = "audioUpdate";
  DyteEvents2[DyteEvents2["videoUpdate"] = 11] = "videoUpdate";
  DyteEvents2[DyteEvents2["screenShareUpdate"] = 12] = "screenShareUpdate";
  DyteEvents2[DyteEvents2["previewUpdate"] = 13] = "previewUpdate";
  DyteEvents2[DyteEvents2["deviceUpdate"] = 14] = "deviceUpdate";
  DyteEvents2[DyteEvents2["chatUpdate"] = 15] = "chatUpdate";
  DyteEvents2[DyteEvents2["pinMessage"] = 16] = "pinMessage";
  DyteEvents2[DyteEvents2["unpinMessage"] = 17] = "unpinMessage";
  DyteEvents2[DyteEvents2["pollsUpdate"] = 18] = "pollsUpdate";
  DyteEvents2[DyteEvents2["participantJoined"] = 19] = "participantJoined";
  DyteEvents2[DyteEvents2["participantLeft"] = 20] = "participantLeft";
  DyteEvents2[DyteEvents2["participantsCleared"] = 21] = "participantsCleared";
  DyteEvents2[DyteEvents2["participantsUpdate"] = 22] = "participantsUpdate";
  DyteEvents2[DyteEvents2["viewModeChanged"] = 23] = "viewModeChanged";
  DyteEvents2[DyteEvents2["pageChanged"] = 24] = "pageChanged";
  DyteEvents2[DyteEvents2["activeSpeaker"] = 25] = "activeSpeaker";
  DyteEvents2[DyteEvents2["pluginAdded"] = 26] = "pluginAdded";
  DyteEvents2[DyteEvents2["pluginDeleted"] = 27] = "pluginDeleted";
  DyteEvents2[DyteEvents2["stateUpdate"] = 28] = "stateUpdate";
  DyteEvents2[DyteEvents2["pinned"] = 29] = "pinned";
  DyteEvents2[DyteEvents2["unpinned"] = 30] = "unpinned";
  DyteEvents2[DyteEvents2["recordingUpdate"] = 31] = "recordingUpdate";
  DyteEvents2[DyteEvents2["remoteRequestAdd"] = 32] = "remoteRequestAdd";
  DyteEvents2[DyteEvents2["remoteRequestRemove"] = 33] = "remoteRequestRemove";
  DyteEvents2[DyteEvents2["remoteUpdate"] = 34] = "remoteUpdate";
  DyteEvents2[DyteEvents2["closed"] = 35] = "closed";
  DyteEvents2[DyteEvents2["ready"] = 36] = "ready";
  DyteEvents2[DyteEvents2["mediaPermissionError"] = 37] = "mediaPermissionError";
  DyteEvents2[DyteEvents2["broadcastedMessage"] = 38] = "broadcastedMessage";
})(DyteEvents || (DyteEvents = {}));
class DyteEventEmitter extends events$1.exports.EventEmitter {
  emit(event, ...args) {
    super.emit("*", event, ...args);
    return super.emit(event, ...args);
  }
  on(event, callback) {
    return super.on(event, callback);
  }
  addListener(event, callback) {
    return super.addListener(event, callback);
  }
  off(event, callback) {
    return super.off(event, callback);
  }
  once(event, callback) {
    return super.once(event, callback);
  }
  prependListener(event, callback) {
    return super.prependListener(event, callback);
  }
  prependOnceListener(event, callback) {
    return super.prependOnceListener(event, callback);
  }
  removeListener(event, callback) {
    return super.removeListener(event, callback);
  }
  removeAllListeners(event) {
    return super.removeAllListeners(event);
  }
  listeners(event) {
    return super.listeners(event);
  }
  listenerCount(event) {
    return super.listenerCount(event);
  }
}
var RemoteRequestType;
(function(RemoteRequestType2) {
  RemoteRequestType2["REQUEST"] = "REQUEST";
  RemoteRequestType2["ACCEPT"] = "ACCEPT";
  RemoteRequestType2["REJECT"] = "REJECT";
  RemoteRequestType2["END"] = "END";
  RemoteRequestType2["EVENT"] = "EVENT";
})(RemoteRequestType || (RemoteRequestType = {}));
var RemoteRequestState;
(function(RemoteRequestState2) {
  RemoteRequestState2["PENDING"] = "PENDING";
  RemoteRequestState2["ACCEPTED"] = "ACCEPTED";
  RemoteRequestState2["REJECTED"] = "REJECTED";
  RemoteRequestState2["ENDED"] = "ENDED";
})(RemoteRequestState || (RemoteRequestState = {}));
var RemoteEventType;
(function(RemoteEventType2) {
  RemoteEventType2["KEYBOARD"] = "KEYBOARD";
  RemoteEventType2["MOUSE"] = "MOUSE";
})(RemoteEventType || (RemoteEventType = {}));
var RemoteMouseEventTypes;
(function(RemoteMouseEventTypes2) {
  RemoteMouseEventTypes2["LEFT_CLICK"] = "click";
  RemoteMouseEventTypes2["RIGHT_CLICK"] = "contextmenu";
  RemoteMouseEventTypes2["MOVE"] = "mousemove";
})(RemoteMouseEventTypes || (RemoteMouseEventTypes = {}));
var RemoteUpdateType;
(function(RemoteUpdateType2) {
  RemoteUpdateType2["REQUEST_RECEIVED"] = "REQUEST_RECEIVED";
  RemoteUpdateType2["REQUEST_SENT"] = "REQUEST_SENT";
  RemoteUpdateType2["INCOMING_REQUEST_ACCEPTED"] = "INCOMING_REQUEST_ACCEPTED";
  RemoteUpdateType2["OUTGOING_REQUEST_ACCEPTED"] = "OUTGOING_REQUEST_ACCEPTED";
  RemoteUpdateType2["INCOMING_REQUEST_ENDED"] = "INCOMING_REQUEST_ENDED";
  RemoteUpdateType2["OUTGOING_REQUEST_ENDED"] = "OUTGOING_REQUEST_ENDED";
})(RemoteUpdateType || (RemoteUpdateType = {}));
class DyteRemoteRequest extends DyteEventEmitter {
  constructor(request) {
    super();
    __publicField(this, "id");
    __publicField(this, "remotePeerId");
    __publicField(this, "hostPeerId");
    __publicField(this, "state");
    const {
      remotePeerId,
      requestId,
      hostPeerId,
      state
    } = request;
    this.id = requestId;
    this.remotePeerId = remotePeerId;
    this.hostPeerId = hostPeerId;
    this.state = state;
  }
}
var __defProp$g = Object.defineProperty;
var __getOwnPropDesc$g = Object.getOwnPropertyDescriptor;
var __decorateClass$g = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$g(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$g(target, key, result);
  return result;
};
const _RoomNodeClient = (_a2 = class {
  constructor(options) {
    __privateAdd2(this, _socketClient, void 0);
    __privateAdd2(this, _localMediaHandler, void 0);
    __publicField(this, "isV2AuthToken");
    __privateAdd2(this, _sfuHandler, void 0);
    __publicField(this, "maxPreferredStreams");
    __publicField(this, "legacyMode");
    __publicField(this, "roomNodeUrl");
    __publicField(this, "meetingTitle");
    __publicField(this, "roomName");
    __publicField(this, "roomUUID");
    __publicField(this, "peerId");
    __publicField(this, "authToken");
    __publicField(this, "roomJoined");
    __publicField(this, "peerDisplayName");
    __publicField(this, "isDisconnected");
    const {
      roomName,
      roomNodeUrl,
      peerId,
      authToken,
      legacyMode,
      socketClient,
      localMediaHandler,
      meetingTitle
    } = options;
    this.roomName = roomName;
    this.roomNodeUrl = roomNodeUrl;
    this.peerId = peerId;
    this.authToken = authToken;
    this.legacyMode = legacyMode;
    __privateSet2(this, _socketClient, socketClient);
    this.roomJoined = false;
    this.meetingTitle = meetingTitle;
    __privateSet2(this, _localMediaHandler, localMediaHandler);
    this.isV2AuthToken = constants.isV2AuthToken;
    __privateSet2(this, _sfuHandler, new SFUHandler(socketClient));
    callStats.legacySwitch(legacyMode);
  }
  static async init(options, localMediaHandler) {
    const {
      legacyMode = true,
      roomName,
      peerId,
      authToken,
      meetingTitle
    } = options;
    let roomNodeClient;
    const roomNodeUrl = `${options.roomNodeUrl}?roomURL=${roomName}&peerId=${peerId}&authToken=${authToken}&version=0.5.0`;
    const socketClient = new SocketClient({
      callbackHandler: async (message2) => {
        await roomNodeClient.handleSocketCallbacks(message2);
      }
    });
    socketClient.on(SocketEvents.SOCKET_MESSAGE, async (message2, callBack) => {
      await roomNodeClient.handleSockets(message2, callBack);
    });
    socketClient.connect(roomNodeUrl);
    roomNodeClient = new _RoomNodeClient({
      legacyMode,
      authToken,
      peerId,
      roomName,
      roomNodeUrl,
      localMediaHandler,
      socketClient,
      meetingTitle
    });
    socketClient.on(SocketEvents.SOCKET_DISCONNECTED, (event) => {
      var _a3;
      roomNodeClient.isDisconnected = true;
      (_a3 = __privateGet2(roomNodeClient, _sfuHandler)) == null ? void 0 : _a3.cleanupConsumers();
      SessionStore.emit(SessionEvents.ROOM_NODE_DISCONNECTED, event);
      roomNodeClient.roomJoined = false;
      DyteTelemetry.addEventInCurrentSpan("info", "ROOM_NODE_DISCONNECTED");
    });
    socketClient.on(SocketEvents.SOCKET_CONNECTED, async (event) => {
      SessionStore.emit(SessionEvents.ROOM_NODE_CONNECTED, event);
      if (roomNodeClient.isDisconnected) {
        await roomNodeClient.resetRoomNodeClient();
      }
      roomNodeClient.isDisconnected = false;
      DyteTelemetry.addEventInCurrentSpan("info", "ROOM_NODE_CONNECTED");
    });
    return roomNodeClient;
  }
  reconnect() {
    __privateGet2(this, _socketClient).reconnect();
  }
  async setupTransports() {
    await __privateGet2(this, _sfuHandler).setupTransports();
  }
  async resetRoomNodeClient() {
    __privateGet2(this, _sfuHandler).cleanupConsumers();
    await __privateGet2(this, _sfuHandler).setupTransports();
    await this.joinRoom(this.peerDisplayName, __privateGet2(this, _localMediaHandler).audioEnabled, this.roomUUID, this.meetingTitle, {
      audio: __privateGet2(this, _localMediaHandler).audioEnabled,
      video: __privateGet2(this, _localMediaHandler).videoEnabled,
      screen: __privateGet2(this, _localMediaHandler).screenShareEnabled
    });
    if (__privateGet2(this, _localMediaHandler).videoEnabled) {
      await this.shareWebcam(__privateGet2(this, _localMediaHandler).videoTrack);
    }
    if (__privateGet2(this, _localMediaHandler).audioEnabled) {
      await this.shareMic(__privateGet2(this, _localMediaHandler).audioTrack);
    }
    if (__privateGet2(this, _localMediaHandler).screenShareEnabled) {
      await this.shareScreen({
        video: __privateGet2(this, _localMediaHandler).screenShareTracks.video,
        audio: __privateGet2(this, _localMediaHandler).screenShareTracks.audio
      });
    }
  }
  async handleSocketCallbacks(message2) {
    switch (message2.type) {
      case SessionEvents.NEW_CONSUMER:
        return __privateGet2(this, _sfuHandler).createConsumer(message2.payload);
      default:
        return null;
    }
  }
  async handleSockets(message2, callBack) {
    if (!message2) {
      return;
    }
    if (!DyteTelemetry.logExclusionList.includes(message2.type)) {
      DyteTelemetry.addEventInCurrentSpan("info", "RoomNodeClient::handleSockets", {
        type: message2.type,
        payload: message2.payload
      });
    }
    switch (message2.type) {
      case SessionEvents.CONSUMER_CLOSED:
        __privateGet2(this, _sfuHandler).closeConsumer(message2.payload);
        break;
      case SessionEvents.CONSUMER_PAUSED:
        __privateGet2(this, _sfuHandler).pauseConsumer(message2.payload);
        break;
      case SessionEvents.CONSUMER_RESUMED:
        __privateGet2(this, _sfuHandler).resumeConsumer(message2.payload);
        break;
      case SessionEvents.CONSUMER_SCORE:
        this.handleConsumerScore(message2.payload);
        break;
      case SessionEvents.PRODUCER_SCORE:
        this.handleProducerScore(message2.payload);
        break;
      case SessionEvents.PRODUCER_CLOSED:
        this.handleProducerClosed(message2.payload);
        break;
    }
    if (typeof callBack === "function") {
      callBack();
    }
  }
  async joinRoom(displayName, audioMuted, roomUUID, roomTitle, currentUserSharedMediaStates = {}) {
    var _a3, _b2, _c2;
    this.peerDisplayName = displayName;
    this.roomUUID = roomUUID;
    const response = await __privateGet2(this, _socketClient).sendMessage({
      type: "joinRoom",
      payload: {
        device: browserSpecs.getDeviceInfo(),
        displayName,
        rtpCapabilities: __privateGet2(this, _sfuHandler).getRTPCapabilities(),
        isLegacy: this.legacyMode,
        audioMuted
      }
    });
    if ((_a3 = response.payload) == null ? void 0 : _a3.waitlisted) {
      SessionStore.emit(SessionEvents.WAITLISTED);
      return response;
    }
    (_c2 = (_b2 = response.payload) == null ? void 0 : _b2.waitlistedPeers) == null ? void 0 : _c2.forEach((data) => {
      SessionStore.emit(SessionEvents.WAITLIST_PEER_ADDED, data);
    });
    this.legacyMode = response.payload.legacyMode || this.legacyMode;
    if (roomTitle && roomTitle !== "") {
      await this.changeRoomDisplayTitle(roomTitle);
    }
    this.maxPreferredStreams = response.payload.maxPreferredStreams;
    this.roomJoined = true;
    const APIClient2 = getAPIClient();
    DyteTelemetry.addEventInCurrentSpan("info", "RoomNodeClient::joinRoom::pre_emitasync_room_joined");
    await SessionStore.emitAsync(SessionEvents.ROOM_JOINED, response.payload);
    DyteTelemetry.addEventInCurrentSpan("info", "RoomNodeClient::joinRoom::post_emitasync_room_joined");
    SessionStore.emit(SessionEvents.SELF_ROOM_JOINED);
    if (dist$1.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.INTERNAL_CALL_STATS) && navigator.product !== "ReactNative") {
      setTimeout(async () => {
        const user = await APIClient2.getUserDetails();
        const peerData = {
          userId: constants.isV2AuthToken ? user.participant.id : user.id,
          peerId: this.peerId,
          displayName,
          roomUUID: this.roomUUID,
          roomViewType: "groupCall",
          roomName: this.roomName,
          deviceInfo: __spreadProps(__spreadValues({}, browserSpecs.getDeviceInfo()), {
            userAgent: navigator.userAgent,
            memory: navigator.deviceMemory,
            cpus: navigator.hardwareConcurrency
          }),
          metaData: {},
          permissions: {}
        };
        callStats.roomJoined(peerData);
        if (currentUserSharedMediaStates == null ? void 0 : currentUserSharedMediaStates.audio) {
          callStats.audioOn();
        } else {
          callStats.audioOff();
        }
        if (currentUserSharedMediaStates == null ? void 0 : currentUserSharedMediaStates.video) {
          callStats.videoOn();
        } else {
          callStats.videoOff();
        }
      });
    }
    return response;
  }
  async leaveRoom() {
    __privateGet2(this, _sfuHandler).stopAllProducers();
    await __privateGet2(this, _sfuHandler).stopAllTransports();
    __privateGet2(this, _socketClient).disconnect();
    callStats.callEnded();
    clearInterval(DyteTelemetry.logsProcessorTimer);
    DyteTelemetry.processCachedLogs();
  }
  handleProducerClosed({ id }) {
    __privateGet2(this, _sfuHandler).producers.forEach((producer, type) => {
      if (producer.id === id) {
        __privateGet2(this, _sfuHandler).removeProducer(type);
      }
    });
  }
  getConsumers() {
    return __privateGet2(this, _sfuHandler).consumers;
  }
  handleConsumerScore({ id, score }) {
    var _a3, _b2;
    DyteTelemetry.addEventInCurrentSpan("info", "RoomNodeClient::received_consumer_score", { id, score });
    const consumer = __privateGet2(this, _sfuHandler).consumers.get(id);
    if (!consumer)
      return;
    consumer.score = (_b2 = score == null ? void 0 : score.score) != null ? _b2 : (_a3 = consumer.score) != null ? _a3 : 10;
    if (consumer.score < 5) {
      SessionStore.emit(SessionEvents.LOW_CONSUMER_SCORE, {
        id: consumer.id,
        kind: consumer.kind,
        peerId: consumer.peerId,
        score: consumer.score
      });
    }
  }
  handleProducerScore({ id, score }) {
    var _a3;
    DyteTelemetry.addEventInCurrentSpan("info", "RoomNodeClient::received_producer_score", { id, score });
    const producer = [...__privateGet2(this, _sfuHandler).producers.values()].find((p) => p.id === id);
    if (!producer) {
      DyteTelemetry.addEventInCurrentSpan("error", "RoomNodeClient::producer_not_found", { id });
      return;
    }
    if (!producer)
      return;
    producer.score = (_a3 = score == null ? void 0 : score.score) != null ? _a3 : 10;
    if (producer.score && producer.score < 5) {
      SessionStore.emit(SessionEvents.LOW_PRODUCER_SCORE, {
        id: producer.id,
        score: producer.score
      });
    }
  }
  async shareWebcam(videoTrack) {
    if (videoTrack === void 0) {
      return;
    }
    if (__privateGet2(this, _sfuHandler).producers.has(PRODUCERS_TYPE.WEBCAM)) {
      const webcamProducer = __privateGet2(this, _sfuHandler).producers.get(PRODUCERS_TYPE.WEBCAM);
      if (!webcamProducer.closed) {
        await webcamProducer.replaceTrack({ track: videoTrack });
        await this.resumeWebcam();
        return;
      }
      await __privateGet2(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.WEBCAM, false);
    }
    let simulcast = WEBCAM_SIMULCAST_ENCODINGS_VGA;
    const vp9Codec = __privateGet2(this, _sfuHandler).getRTPCapabilities().codecs.find((c) => c.mimeType.toLowerCase() === "video/vp9") || void 0;
    const vp8Codec = __privateGet2(this, _sfuHandler).getRTPCapabilities().codecs.find((c) => c.mimeType.toLowerCase() === "video/vp8") || void 0;
    if (vp9Codec && !this.legacyMode) {
      simulcast = WEBCAM_KSVC_ENCODINGS;
    }
    const getCodec = () => this.legacyMode ? vp8Codec : vp9Codec;
    const producerOptions = {
      track: videoTrack,
      encodings: simulcast,
      codecOptions: {
        videoGoogleStartBitrate: 1e3
      },
      codec: getCodec(),
      appData: {
        screenShare: false
      },
      stopTracks: false
    };
    const onDisconnect = () => {
      this.disableWebcam();
    };
    await __privateGet2(this, _sfuHandler).createProducer(PRODUCERS_TYPE.WEBCAM, producerOptions, onDisconnect);
  }
  async shareScreen(tracks) {
    var _a3, _b2;
    const { video: videoTrack, audio: audioTrack } = tracks;
    if (videoTrack === void 0) {
      return;
    }
    const producerOptions = {
      track: videoTrack,
      codecOptions: {
        videoGoogleStartBitrate: 1e3
      },
      appData: {
        screenShare: true,
        supportsRemoteControl: browserSpecs.isElectron()
      },
      stopTracks: false
    };
    let onDisconnect = () => {
      this.disableScreenShare();
    };
    callStats.screenShareRequested();
    await __privateGet2(this, _sfuHandler).createProducer(PRODUCERS_TYPE.SCREENSHARE_VIDEO, producerOptions, onDisconnect);
    if (audioTrack) {
      const audioProducerOptions = {
        track: audioTrack,
        codecOptions: {
          opusDtx: false,
          opusStereo: false,
          opusFec: true
        },
        appData: {
          screenShare: true,
          supportsRemoteControl: browserSpecs.isElectron()
        },
        stopTracks: false
      };
      onDisconnect = () => {
      };
      await __privateGet2(this, _sfuHandler).createProducer(PRODUCERS_TYPE.SCREENSHARE_AUDIO, audioProducerOptions, onDisconnect);
    }
    callStats.screenShareStart((_b2 = (_a3 = __privateGet2(this, _sfuHandler).producers.get(PRODUCERS_TYPE.SCREENSHARE_VIDEO)) == null ? void 0 : _a3.rtpParameters.encodings[0]) == null ? void 0 : _b2.ssrc);
  }
  async shareMic(audioTrack) {
    if (audioTrack === void 0) {
      return;
    }
    if (__privateGet2(this, _sfuHandler).producers.has(PRODUCERS_TYPE.MIC)) {
      const micProducer = __privateGet2(this, _sfuHandler).producers.get(PRODUCERS_TYPE.MIC);
      if (!micProducer.closed) {
        await micProducer.replaceTrack({ track: audioTrack });
        await this.resumeMic();
        return;
      }
      await __privateGet2(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.MIC, false);
    }
    const producerOptions = {
      track: audioTrack,
      codecOptions: {
        opusDtx: false,
        opusStereo: false,
        opusFec: true,
        opusMaxAverageBitrate: 16e3
      },
      stopTracks: false
    };
    const onDisconnect = () => {
      this.disableMic();
    };
    await __privateGet2(this, _sfuHandler).createProducer(PRODUCERS_TYPE.MIC, producerOptions, onDisconnect);
  }
  pauseMic() {
    const micProducer = __privateGet2(this, _sfuHandler).producers.get(PRODUCERS_TYPE.MIC);
    if (!micProducer) {
      DyteTelemetry.addEventInCurrentSpan("error", "pauseMic::could_not_find_mic_producer");
      return;
    }
    micProducer.pause();
    __privateGet2(this, _socketClient).sendMessage({
      type: "pauseProducer",
      payload: { producerId: micProducer.id }
    });
  }
  async pauseWebcam() {
    const webcamProducer = __privateGet2(this, _sfuHandler).producers.get(PRODUCERS_TYPE.WEBCAM);
    if (!webcamProducer) {
      DyteTelemetry.addEventInCurrentSpan("error", "pauseWebcam::could_not_find_webcam_producer");
      return;
    }
    webcamProducer.pause();
    await __privateGet2(this, _socketClient).sendMessage({
      type: "pauseProducer",
      payload: { producerId: webcamProducer.id }
    });
  }
  async resumeMic() {
    const micProducer = __privateGet2(this, _sfuHandler).producers.get(PRODUCERS_TYPE.MIC);
    if (!micProducer) {
      DyteTelemetry.addEventInCurrentSpan("error", "resumeMic::could_not_find_mic_producer");
      return;
    }
    micProducer.resume();
    await __privateGet2(this, _socketClient).sendMessage({
      type: "resumeProducer",
      payload: { producerId: micProducer.id }
    });
  }
  async resumeWebcam() {
    const webcamProducer = __privateGet2(this, _sfuHandler).producers.get(PRODUCERS_TYPE.WEBCAM);
    if (!webcamProducer) {
      DyteTelemetry.addEventInCurrentSpan("error", "resumeWebcam::could_not_find_webcam_producer");
      return;
    }
    webcamProducer.resume();
    await __privateGet2(this, _socketClient).sendMessage({
      type: "resumeProducer",
      payload: { producerId: webcamProducer.id }
    });
  }
  async disableWebcam() {
    await __privateGet2(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.WEBCAM);
  }
  async disableMic() {
    await __privateGet2(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.MIC);
  }
  async disableScreenShare() {
    var _a3, _b2;
    DyteTelemetry.addEventInCurrentSpan("info", "screen_sharing_stopped");
    callStats.screenShareStop((_b2 = (_a3 = __privateGet2(this, _sfuHandler).producers.get(PRODUCERS_TYPE.SCREENSHARE_VIDEO)) == null ? void 0 : _a3.rtpParameters.encodings[0]) == null ? void 0 : _b2.ssrc);
    await __privateGet2(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.SCREENSHARE_VIDEO);
    await __privateGet2(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.SCREENSHARE_AUDIO);
  }
  async resetVideoProducers(videoTrack, screenShareTrack) {
    if (videoTrack) {
      await __privateGet2(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.WEBCAM, false);
      this.shareWebcam(videoTrack);
    }
    if (screenShareTrack) {
      await __privateGet2(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.SCREENSHARE_VIDEO, false);
      this.shareScreen({ video: screenShareTrack });
    }
  }
  async getRoomState() {
    return __privateGet2(this, _socketClient).sendMessage({ type: "getRoomState" });
  }
  async changeRoomDisplayTitle(displayTitle) {
    await __privateGet2(this, _socketClient).sendMessage({
      type: "changeDisplayTitle",
      payload: {
        displayTitle
      }
    });
  }
  async sendMessage(message2) {
    return __privateGet2(this, _socketClient).sendMessage(message2);
  }
  async broadcastMessage(type, messagePayload) {
    const payload = {
      payload: messagePayload,
      type
    };
    return __privateGet2(this, _socketClient).sendMessage({ type: "roomMessage", payload });
  }
  async sendChatMessage(message2) {
    await __privateGet2(this, _socketClient).sendMessage({ type: "chatMessage", payload: message2 });
  }
  async getChatMessages() {
    return __privateGet2(this, _socketClient).sendMessage({ type: "getChatMessages" });
  }
  async pinChatMessage(payload) {
    return __privateGet2(this, _socketClient).sendMessage({ type: "pinChatMessage", payload });
  }
  async unpinChatMessage(payload) {
    return __privateGet2(this, _socketClient).sendMessage({ type: "unpinChatMessage", payload });
  }
  async getPolls() {
    return __privateGet2(this, _socketClient).sendMessage({ type: "getPolls" });
  }
  async newPoll(poll) {
    await __privateGet2(this, _socketClient).sendMessage({ type: "newPoll", payload: poll });
  }
  async votePoll(poll) {
    await __privateGet2(this, _socketClient).sendMessage({ type: "votePoll", payload: poll });
  }
  async acceptWaitingRequest(peerId) {
    await __privateGet2(this, _socketClient).sendMessage({ type: "acceptWaitingRequest", payload: { id: peerId } });
  }
  async rejectWaitingRequest(peerId) {
    await __privateGet2(this, _socketClient).sendMessage({ type: "rejectWaitingRequest", payload: { id: peerId } });
  }
  async muteAll(allowUnMute) {
    await __privateGet2(this, _socketClient).sendMessage({ type: "muteAllNew", payload: { allowUnMute } });
  }
  async muteAllVideo() {
    await __privateGet2(this, _socketClient).sendMessage({ type: "muteAllVideo" });
  }
  async pinPeer(peerId) {
    return __privateGet2(this, _socketClient).sendMessage({ type: "pinPeer", payload: { id: peerId } });
  }
  async unpinPeer(peerId) {
    return __privateGet2(this, _socketClient).sendMessage({ type: "unpinPeer", payload: { id: peerId } });
  }
  async disableAudio(peerId) {
    await __privateGet2(this, _socketClient).sendMessage({ type: "disableAudioPeerNew", payload: { id: peerId } });
  }
  async disableVideo(peerId) {
    await __privateGet2(this, _socketClient).sendMessage({ type: "disableVideoPeer", payload: { id: peerId } });
  }
  async kickAll() {
    await __privateGet2(this, _socketClient).sendMessage({ type: "kickAll" });
  }
  async kick(peerId) {
    await __privateGet2(this, _socketClient).sendMessage({ type: "kick", payload: { id: peerId } });
  }
  async getPage(pageNum) {
    return __privateGet2(this, _socketClient).sendMessage({ type: "getPage", payload: { pageNum } });
  }
  async muteSelf() {
    this.pauseMic();
    await __privateGet2(this, _socketClient).sendMessage({ type: "muteSelf" });
  }
  async unmuteSelf() {
    await this.resumeMic();
    await __privateGet2(this, _socketClient).sendMessage({ type: "unmuteSelf" });
  }
  async addRoomPlugin(plugin) {
    return __privateGet2(this, _socketClient).sendMessage({
      type: "addPlugin",
      payload: plugin
    });
  }
  async removeRoomPlugin(plugin) {
    return __privateGet2(this, _socketClient).sendMessage({
      type: "removePlugin",
      payload: plugin
    });
  }
  async remoteControlMessage(payload) {
    return __privateGet2(this, _socketClient).sendMessage({
      type: "message",
      payload
    });
  }
  async requestRemoteControl(request) {
    return this.remoteControlMessage({
      peerId: request.hostPeerId,
      remoteRequestId: request.id,
      hostPeerId: request.hostPeerId,
      remotePeerId: request.remotePeerId,
      remoteRequestType: RemoteRequestType.REQUEST
    });
  }
  async acceptRemoteControl(request) {
    return this.remoteControlMessage({
      peerId: request.remotePeerId,
      remoteRequestId: request.id,
      hostPeerId: request.hostPeerId,
      remotePeerId: request.remotePeerId,
      remoteRequestType: RemoteRequestType.ACCEPT
    });
  }
  async terminateRemoteControl(peerId, request) {
    return this.remoteControlMessage({
      peerId,
      remoteRequestId: request.id,
      hostPeerId: request.hostPeerId,
      remotePeerId: request.remotePeerId,
      remoteRequestType: RemoteRequestType.END
    });
  }
  async sendEventRemoteControl(peerId, remoteRequestId, remoteEvent) {
    return this.remoteControlMessage({
      peerId,
      remoteRequestId,
      remoteEvent,
      hostPeerId: this.peerId,
      remotePeerId: peerId,
      remoteRequestType: RemoteRequestType.EVENT
    });
  }
}, _socketClient = new WeakMap(), _localMediaHandler = new WeakMap(), _sfuHandler = new WeakMap(), _a2);
let RoomNodeClient = _RoomNodeClient;
__decorateClass$g([
  DyteTelemetry.trace("RoomNodeClient.reconnect")
], RoomNodeClient.prototype, "reconnect", 1);
__decorateClass$g([
  DyteTelemetry.trace("resetRoomNodeClientOnSocketReconnect")
], RoomNodeClient.prototype, "resetRoomNodeClient", 1);
__decorateClass$g([
  DyteTelemetry.trace("joinRoom.RoomNodeClient")
], RoomNodeClient.prototype, "joinRoom", 1);
__decorateClass$g([
  DyteTelemetry.trace("RoomNodeClient.leaveRoom")
], RoomNodeClient.prototype, "leaveRoom", 1);
__decorateClass$g([
  DyteTelemetry.trace("shareWebcam")
], RoomNodeClient.prototype, "shareWebcam", 1);
__decorateClass$g([
  DyteTelemetry.trace("shareScreen")
], RoomNodeClient.prototype, "shareScreen", 1);
__decorateClass$g([
  DyteTelemetry.trace("shareMic")
], RoomNodeClient.prototype, "shareMic", 1);
__decorateClass$g([
  DyteTelemetry.trace("pauseMic")
], RoomNodeClient.prototype, "pauseMic", 1);
__decorateClass$g([
  DyteTelemetry.trace("pauseWebcam")
], RoomNodeClient.prototype, "pauseWebcam", 1);
__decorateClass$g([
  DyteTelemetry.trace("resumeMic")
], RoomNodeClient.prototype, "resumeMic", 1);
__decorateClass$g([
  DyteTelemetry.trace("resumeWebcam")
], RoomNodeClient.prototype, "resumeWebcam", 1);
__decorateClass$g([
  DyteTelemetry.trace("disableWebcam")
], RoomNodeClient.prototype, "disableWebcam", 1);
__decorateClass$g([
  DyteTelemetry.trace("disableMic")
], RoomNodeClient.prototype, "disableMic", 1);
__decorateClass$g([
  DyteTelemetry.trace("disableScreenShare")
], RoomNodeClient.prototype, "disableScreenShare", 1);
__decorateClass$g([
  DyteTelemetry.trace("resetVideoProducers")
], RoomNodeClient.prototype, "resetVideoProducers", 1);
class LocalMediaError extends Error {
  constructor(message2, code2) {
    super(message2);
    __publicField(this, "code");
    this.code = code2;
  }
}
class LocalMediaException extends Error {
  constructor(name, message2, constraints) {
    super(message2);
    __publicField(this, "constraints");
    __publicField(this, "name");
    this.name = name;
    this.constraints = constraints;
  }
}
var __defProp$f = Object.defineProperty;
var __getOwnPropDesc$f = Object.getOwnPropertyDescriptor;
var __decorateClass$f = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$f(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$f(target, key, result);
  return result;
};
const _LocalMediaUtils = (_b = class {
  constructor(availableDevices) {
    __privateAdd2(this, _availableDevices, void 0);
    __privateSet2(this, _availableDevices, availableDevices);
  }
  static async init() {
    let availableDevices = [];
    if (_LocalMediaUtils.isDeviceListAvailable()) {
      availableDevices = await _LocalMediaUtils.enumerateDevices();
      DyteTelemetry.addEventInCurrentSpan("info", "initial_full_device_list", {
        devices: JSON.stringify(availableDevices, null, 2)
      });
    }
    return new _LocalMediaUtils(availableDevices);
  }
  static isDeviceListAvailable() {
    return !!(navigator.mediaDevices && navigator.mediaDevices.enumerateDevices);
  }
  static enumerateDevices() {
    try {
      return navigator.mediaDevices.enumerateDevices();
    } catch (error) {
      DyteTelemetry.addEventInCurrentSpan("error", "enumerate_devices_failed", {
        message: error.message
      });
      log.info("Failed to enumerate devices", error);
      return Promise.resolve([]);
    }
  }
  static getAudioConstraints(options) {
    const constraints = {};
    const {
      disableAP = false,
      disableAEC = false,
      disableNS = false,
      disableAGC = false,
      disableHPF = false
    } = options.audioOptions || {};
    if (browserSpecs.isFirefox() || browserSpecs.isWebKitBased()) {
      constraints.audio = {
        deviceId: options.audioDeviceId,
        autoGainControl: !disableAGC && !disableAP,
        echoCancellation: !disableAEC && !disableAP,
        noiseSuppression: !disableNS && !disableAP
      };
    } else {
      if (typeof constraints.audio === "boolean") {
        return constraints;
      }
      constraints.audio = {};
      constraints.audio.optional = [
        { sourceId: options.audioDeviceId },
        { echoCancellation: !disableAEC && !disableAP },
        { googEchoCancellation: !disableAEC && !disableAP },
        { googAutoGainControl: !disableAGC && !disableAP },
        { googNoiseSuppression: !disableNS && !disableAP },
        { googHighpassFilter: !disableHPF && !disableAP },
        { googNoiseSuppression2: !disableNS && !disableAP },
        { googEchoCancellation2: !disableAEC && !disableAP },
        { googAutoGainControl2: !disableAGC && !disableAP }
      ];
    }
    return constraints;
  }
  static getVideoConstraints(options) {
    const constraints = {};
    const {
      videoDeviceId,
      videoTrackConstraints,
      facingMode = "user",
      frameRate = { ideal: 24, max: 30 }
    } = options;
    constraints.video = videoTrackConstraints || VIDEO_CONSTRAINTS.vga;
    if (typeof constraints.video === "boolean") {
      return constraints;
    }
    if (videoDeviceId) {
      constraints.video.deviceId = { exact: videoDeviceId };
    }
    constraints.video.facingMode = facingMode;
    constraints.video.frameRate = frameRate;
    return constraints;
  }
  static async getUserMediaWithTimeout(constraints = {}, timeout = 0) {
    try {
      DyteTelemetry.addEventInCurrentSpan("info", "getUserMediaWithTimeout::requesting_user_media", {
        timeout,
        constraints
      });
      if (!timeout) {
        const mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
        DyteTelemetry.addEventInCurrentSpan("info", "getUserMediaWithTimeout::received_user_media", {
          timeout,
          constraints
        });
        return mediaStream;
      }
      const mediaStreamResp = await Promise.race([
        navigator.mediaDevices.getUserMedia(constraints),
        new Promise((_resolve, reject) => {
          setTimeout(() => reject(new LocalMediaError("Get user media timed out", "ERR_GUM_TIMEOUT")), timeout);
        })
      ]);
      DyteTelemetry.addEventInCurrentSpan("info", "getUserMediaWithTimeout::received_user_media", {
        timeout,
        constraints
      });
      return mediaStreamResp;
    } catch (err) {
      DyteTelemetry.addEventInCurrentSpan("error", "getUserMediaWithTimeout::failed_to_access_local_media", {
        message: err.message,
        constraints
      });
      log.info("Failed to get access to local media.", err, constraints);
      throw new LocalMediaException(err.name, err.message, constraints);
    }
  }
  static async getAudioTrack(constraints) {
    const mediaStream = await _LocalMediaUtils.getUserMediaWithTimeout(constraints);
    return mediaStream.getAudioTracks()[0];
  }
  static async getVideoTrack(constraints) {
    const mediaStream = await _LocalMediaUtils.getUserMediaWithTimeout(constraints);
    return mediaStream.getVideoTracks()[0];
  }
  static async getScreenShareTracks(constraints) {
    const stream = await navigator.mediaDevices.getDisplayMedia(constraints);
    return { video: stream.getVideoTracks()[0], audio: stream.getAudioTracks()[0] };
  }
  static async getAudioAndVideoTrack(constraints) {
    const mediaStream = await _LocalMediaUtils.getUserMediaWithTimeout(constraints);
    return {
      audioTrack: mediaStream.getAudioTracks()[0],
      videoTrack: mediaStream.getVideoTracks()[0]
    };
  }
  onDeviceChange(callback) {
    if (browserSpecs.supportsDeviceChangeEvent()) {
      navigator.mediaDevices.addEventListener("devicechange", async (ev) => {
        const previouslyAvailableDevices = this.availableDevices;
        const previouslyAvailableDeviceIds = new Set(previouslyAvailableDevices.map((device) => device.deviceId));
        await this.repopulateAvailableDevices();
        const currentlyAvailableDevices = this.availableDevices;
        const currentlyAvailableDeviceIds = new Set(currentlyAvailableDevices.map((device) => device.deviceId));
        const changedDevices = {
          added: currentlyAvailableDevices.filter((device) => !previouslyAvailableDeviceIds.has(device.deviceId)),
          removed: previouslyAvailableDevices.filter((device) => !currentlyAvailableDeviceIds.has(device.deviceId))
        };
        this.repopulateAvailableDevices().then(() => callback(ev, changedDevices));
      });
    }
  }
  async repopulateAvailableDevices() {
    const devices = await _LocalMediaUtils.enumerateDevices();
    __privateSet2(this, _availableDevices, devices);
    callStats.devices("AUDIO", this.getAudioDevices());
    callStats.devices("VIDEO", this.getVideoDevices());
    callStats.devices("SPEAKER", this.getSpeakerDevices());
    DyteTelemetry.addEventInCurrentSpan("info", "repopulated_full_device_list", {
      devices: JSON.stringify(devices, null, 2)
    });
  }
  get availableDevices() {
    return __privateGet2(this, _availableDevices);
  }
  getAvailableDevicesByKind(kind) {
    return __privateGet2(this, _availableDevices).filter((device) => device.kind === kind);
  }
  getDeviceById(deviceId, kind) {
    return __privateGet2(this, _availableDevices).find((device) => device.deviceId === deviceId && device.kind === kind);
  }
  getAudioDevices() {
    return this.getAvailableDevicesByKind("audioinput");
  }
  getVideoDevices() {
    return this.getAvailableDevicesByKind("videoinput");
  }
  getSpeakerDevices() {
    return this.getAvailableDevicesByKind("audiooutput");
  }
}, _availableDevices = new WeakMap(), _b);
let LocalMediaUtils = _LocalMediaUtils;
__decorateClass$f([
  DyteTelemetry.trace("onDeviceChange")
], LocalMediaUtils.prototype, "onDeviceChange", 1);
__decorateClass$f([
  DyteTelemetry.trace("repopulateAvailableDevices")
], LocalMediaUtils.prototype, "repopulateAvailableDevices", 1);
__decorateClass$f([
  DyteTelemetry.trace("isDeviceListAvailable")
], LocalMediaUtils, "isDeviceListAvailable", 1);
__decorateClass$f([
  DyteTelemetry.trace("enumerateDevices")
], LocalMediaUtils, "enumerateDevices", 1);
__decorateClass$f([
  DyteTelemetry.trace("getUserMediaWithTimeout")
], LocalMediaUtils, "getUserMediaWithTimeout", 1);
__decorateClass$f([
  DyteTelemetry.trace("getAudioTrack")
], LocalMediaUtils, "getAudioTrack", 1);
__decorateClass$f([
  DyteTelemetry.trace("getVideoTrack")
], LocalMediaUtils, "getVideoTrack", 1);
__decorateClass$f([
  DyteTelemetry.trace("getScreenShareTracks")
], LocalMediaUtils, "getScreenShareTracks", 1);
__decorateClass$f([
  DyteTelemetry.trace("getAudioAndVideoTrack")
], LocalMediaUtils, "getAudioAndVideoTrack", 1);
var __defProp$e = Object.defineProperty;
var __getOwnPropDesc$e = Object.getOwnPropertyDescriptor;
var __decorateClass$e = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$e(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$e(target, key, result);
  return result;
};
class MediaMiddlewareUtils {
  constructor(localMediaHandler) {
    __privateAdd2(this, _localMediaHandler2, void 0);
    __publicField(this, "audioMiddlewares", []);
    __publicField(this, "videoMiddlewares", []);
    __privateSet2(this, _localMediaHandler2, localMediaHandler);
  }
  async getTransformedVideoTrack(originalVideoTrack) {
    var _a3, _b2;
    if (!((_a3 = this.videoMiddlewares) == null ? void 0 : _a3.length)) {
      return originalVideoTrack;
    }
    const middlewares = await Promise.all((_b2 = this.videoMiddlewares) == null ? void 0 : _b2.map((videoMiddleware) => videoMiddleware()));
    const originalVideoStream = new MediaStream();
    originalVideoStream.addTrack(originalVideoTrack);
    const transformedVideoCanvasElement = document.createElement("canvas");
    const transformedVideoCanvasCtx = transformedVideoCanvasElement.getContext("2d");
    const rawVideoFeedElement = document.createElement("video");
    rawVideoFeedElement.srcObject = originalVideoStream;
    rawVideoFeedElement.autoplay = true;
    const worker = new Worker(new URL("data:application/javascript;base64,bGV0IGludGVydmFsSWQ7Cm9ubWVzc2FnZSA9IChldmVudCkgPT4gewogICAgc3dpdGNoIChldmVudC5kYXRhPy5hY3Rpb24pIHsKICAgIGNhc2UgJ2NsZWFyLWludGVydmFsJzoKICAgICAgICBjbGVhckludGVydmFsKGludGVydmFsSWQpOwogICAgICAgIGJyZWFrOwogICAgY2FzZSAnc3RhcnQtd29ya2VyJzoKICAgICAgICBpbnRlcnZhbElkID0gdGhpcy5zZXRJbnRlcnZhbCgoKSA9PiBwb3N0TWVzc2FnZSh7IGFjdGlvbjogJ3Byb2Nlc3MtbmV4dC1mcmFtZScsIHRpbWVzdGFtcDogbmV3IERhdGUoKS5nZXRUaW1lKCkgfSksIDUwKTsKICAgICAgICBicmVhazsKICAgIGRlZmF1bHQ6CiAgICAgICAgYnJlYWs7CiAgICB9Cn07Cg==", self.location));
    worker.onmessage = async (event) => {
      var _a4;
      switch ((_a4 = event.data) == null ? void 0 : _a4.action) {
        case "process-next-frame":
          if (!__privateGet2(this, _localMediaHandler2).videoEnabled || originalVideoTrack.readyState === "ended") {
            worker.postMessage({ action: "clear-interval" });
            worker.terminate();
            rawVideoFeedElement.remove();
            transformedVideoCanvasElement.remove();
            return;
          }
          try {
            transformedVideoCanvasCtx.drawImage(rawVideoFeedElement, 0, 0);
            for (let middlewareIndex = 0; middlewareIndex < middlewares.length; middlewareIndex += 1) {
              await middlewares[middlewareIndex](transformedVideoCanvasElement, transformedVideoCanvasCtx);
            }
          } catch (ex) {
            DyteTelemetry.addEventInCurrentSpan("error", "getTransformedVideoTrack::middleware_execution_failed", {});
          }
          break;
      }
    };
    try {
      rawVideoFeedElement.play();
    } catch (ex) {
    }
    rawVideoFeedElement.addEventListener("play", () => {
      transformedVideoCanvasElement.width = rawVideoFeedElement.width || originalVideoTrack.getSettings().width;
      transformedVideoCanvasElement.height = rawVideoFeedElement.width || originalVideoTrack.getSettings().height;
      worker.postMessage({ action: "start-worker" });
    }, false);
    const canvasMediaStream = transformedVideoCanvasElement.captureStream();
    return canvasMediaStream.getVideoTracks()[0];
  }
  async addVideoMiddleware(videoMiddleware) {
    if (browserSpecs.isSafari()) {
      return { success: false, message: "Video middlewares are not yet supported in Safari." };
    }
    if (this.videoMiddlewares.includes(videoMiddleware)) {
      return { success: true, message: "This video middleware has been applied, already. Skipping." };
    }
    this.videoMiddlewares.push(videoMiddleware);
    if (__privateGet2(this, _localMediaHandler2).videoEnabled) {
      __privateGet2(this, _localMediaHandler2).setVideoTrack(await this.getTransformedVideoTrack(__privateGet2(this, _localMediaHandler2).rawVideoTrack));
      __privateGet2(this, _localMediaHandler2).emit("VIDEO_TRACK_CHANGE");
      return { success: true, message: "Successfully applied the video middleware." };
    }
    return { success: true, message: "Successfully added the video middleware. It will be applied automatically once webcam is turned on." };
  }
  async removeVideoMiddleware(videoMiddleware) {
    const index = this.videoMiddlewares.indexOf(videoMiddleware, 0);
    if (index > -1) {
      this.videoMiddlewares.splice(index, 1);
      if (__privateGet2(this, _localMediaHandler2).videoEnabled) {
        __privateGet2(this, _localMediaHandler2).setVideoTrack(await this.getTransformedVideoTrack(__privateGet2(this, _localMediaHandler2).rawVideoTrack));
        __privateGet2(this, _localMediaHandler2).emit("VIDEO_TRACK_CHANGE");
      }
      return { success: true, message: "Successfully removed the video middleware." };
    }
    return { success: true, message: "No such video middleware was found. Skipping." };
  }
  async getTransformedAudioTrack(originalAudioTrack) {
    var _a3, _b2;
    if (!((_a3 = this.audioMiddlewares) == null ? void 0 : _a3.length)) {
      return originalAudioTrack;
    }
    const audioContext = new AudioContext();
    const middlewares = await Promise.all((_b2 = this.audioMiddlewares) == null ? void 0 : _b2.map((audioMiddleware) => audioMiddleware(audioContext)));
    const mediaStreamSource = audioContext.createMediaStreamSource(new MediaStream([originalAudioTrack]));
    const transformedStreamHolder = audioContext.createMediaStreamDestination();
    try {
      let lastMediaStreamSource = mediaStreamSource;
      for (let middlewareIndex = 0; middlewareIndex < middlewares.length; middlewareIndex += 1) {
        lastMediaStreamSource.connect(middlewares[middlewareIndex]);
        lastMediaStreamSource = middlewares[middlewareIndex];
      }
      lastMediaStreamSource.connect(transformedStreamHolder);
    } catch (ex) {
      DyteTelemetry.addEventInCurrentSpan("error", "getTransformedAudioTrack::middleware_execution_failed", {});
      return originalAudioTrack;
    }
    return transformedStreamHolder.stream.getAudioTracks()[0];
  }
  async addAudioMiddleware(audioMiddleware) {
    if (browserSpecs.isSafari()) {
      return { success: false, message: "Audio middlewares are not yet supported in Safari." };
    }
    if (this.audioMiddlewares.includes(audioMiddleware)) {
      return { success: true, message: "This audio middleware has been applied, already. Skipping." };
    }
    this.audioMiddlewares.push(audioMiddleware);
    if (__privateGet2(this, _localMediaHandler2).audioEnabled) {
      __privateGet2(this, _localMediaHandler2).setAudioTrack(await this.getTransformedAudioTrack(__privateGet2(this, _localMediaHandler2).rawAudioTrack));
      __privateGet2(this, _localMediaHandler2).emit("AUDIO_TRACK_CHANGE");
      return { success: true, message: "Successfully applied the audio middleware." };
    }
    return { success: true, message: "Successfully added the audio middleware. It will be applied automatically once mic is turned on." };
  }
  async removeAudioMiddleware(audioMiddleware) {
    const index = this.audioMiddlewares.indexOf(audioMiddleware, 0);
    if (index > -1) {
      this.audioMiddlewares.splice(index, 1);
      if (__privateGet2(this, _localMediaHandler2).audioEnabled) {
        __privateGet2(this, _localMediaHandler2).setAudioTrack(await this.getTransformedAudioTrack(__privateGet2(this, _localMediaHandler2).rawAudioTrack));
        __privateGet2(this, _localMediaHandler2).emit("AUDIO_TRACK_CHANGE");
      }
      return { success: true, message: "Successfully removed the audio middleware." };
    }
    return { success: true, message: "No such audio middleware was found. Skipping." };
  }
}
_localMediaHandler2 = new WeakMap();
__decorateClass$e([
  DyteTelemetry.trace("getTransformedVideoTrack")
], MediaMiddlewareUtils.prototype, "getTransformedVideoTrack", 1);
__decorateClass$e([
  DyteTelemetry.trace("addVideoMiddleware")
], MediaMiddlewareUtils.prototype, "addVideoMiddleware", 1);
__decorateClass$e([
  DyteTelemetry.trace("removeVideoMiddleware")
], MediaMiddlewareUtils.prototype, "removeVideoMiddleware", 1);
__decorateClass$e([
  DyteTelemetry.trace("getTransformedAudioTrack")
], MediaMiddlewareUtils.prototype, "getTransformedAudioTrack", 1);
__decorateClass$e([
  DyteTelemetry.trace("addAudioMiddleware")
], MediaMiddlewareUtils.prototype, "addAudioMiddleware", 1);
__decorateClass$e([
  DyteTelemetry.trace("removeAudioMiddleware")
], MediaMiddlewareUtils.prototype, "removeAudioMiddleware", 1);
const delay = (timeout = 0) => new Promise((resolve) => setTimeout(resolve, timeout));
const detectSilence = (audioContext, stream, timeout) => {
  const timer = typeof timeout === "number" ? timeout : 250;
  const source = audioContext.createMediaStreamSource(stream);
  const analyser = audioContext.createAnalyser();
  analyser.fftSize = 2048;
  source.connect(analyser);
  const samples = new Uint8Array(analyser.fftSize);
  let timeoutDidFire = false;
  setTimeout(() => {
    timeoutDidFire = true;
  }, timer);
  function checkSilentSamples() {
    if (timeoutDidFire) {
      return Promise.resolve(true);
    }
    analyser.getByteTimeDomainData(samples);
    return samples.some((sample) => sample !== 128 && sample !== 0) ? Promise.resolve(false) : delay().then(checkSilentSamples);
  }
  return checkSilentSamples().then((isSilent) => {
    source.disconnect();
    return isSilent;
  }, (error) => {
    source.disconnect();
    throw error;
  });
};
const NativeAudioContext = typeof AudioContext !== "undefined" ? AudioContext : null;
class AudioContextProvider {
  constructor(opts) {
    __publicField(this, "_AudioContext");
    __publicField(this, "audioContext");
    __publicField(this, "_audioContextRefContainers");
    const options = __spreadValues({ AudioContext: NativeAudioContext }, opts);
    Object.defineProperties(this, {
      _AudioContext: {
        value: options.AudioContext
      },
      audioContext: {
        value: null,
        writable: true
      },
      _audioContextRefContainers: {
        value: new Set()
      },
      AudioContextProvider: {
        enumerable: true,
        value: AudioContextProvider
      }
    });
  }
  getOrCreate(audioContextRefContainer) {
    if (!this._audioContextRefContainers.has(audioContextRefContainer)) {
      this._audioContextRefContainers.add(audioContextRefContainer);
      if (this._AudioContext && !this.audioContext) {
        try {
          this.audioContext = new this._AudioContext();
        } catch (error) {
        }
      }
    }
    return this.audioContext;
  }
  release(audioContextRefContainer) {
    if (this._audioContextRefContainers.has(audioContextRefContainer)) {
      this._audioContextRefContainers.delete(audioContextRefContainer);
      if (!this._audioContextRefContainers.size && this.audioContext) {
        this.audioContext.close();
        this.audioContext = null;
      }
    }
  }
}
var AudioContextProvider$1 = new AudioContextProvider();
const NUM_OF_ATTEMPTS = 3;
const ATTEMPT_DURATION_MS = 250;
function detectAudioElementSilence(el) {
  const audioContextRefContainer = {};
  const audioContext = AudioContextProvider$1.getOrCreate(audioContextRefContainer);
  let attemptsLeft = NUM_OF_ATTEMPTS;
  function performSilenceCheck() {
    attemptsLeft -= 1;
    return detectSilence(audioContext, el.srcObject, ATTEMPT_DURATION_MS).then((isSilent) => {
      if (!isSilent) {
        return false;
      }
      if (attemptsLeft > 0) {
        return performSilenceCheck();
      }
      return true;
    }).catch(() => true);
  }
  return performSilenceCheck().finally(() => {
    AudioContextProvider$1.release(audioContextRefContainer);
  });
}
async function checkIfAudioTrackIsSilent(audioTrack) {
  const el = new Audio();
  const stream = new MediaStream();
  stream.addTrack(audioTrack);
  el.srcObject = stream;
  let isSilent = false;
  try {
    const promise = el.play();
    if (promise)
      await promise;
    isSilent = await detectAudioElementSilence(el);
    if (isSilent) {
      DyteTelemetry.addEventInCurrentSpan("info", "checkIfAudioTrackIsSilent::silence_detected");
    }
  } catch (error) {
    DyteTelemetry.addEventInCurrentSpan("warn", "checkIfAudioTrackIsSilent::failed_to_detect_silence");
    log.warn("Failed to detect silence:", error);
  } finally {
    el.pause();
    el.remove();
  }
  return isSilent;
}
const _LocalMediaExecutionContext = class {
  constructor() {
    __publicField(this, "mediaPermissionEvent");
    this.mediaPermissionEvent = true;
  }
  static getInstance() {
    if (!_LocalMediaExecutionContext.instance) {
      _LocalMediaExecutionContext.instance = new _LocalMediaExecutionContext();
    }
    return _LocalMediaExecutionContext.instance;
  }
  get shouldEmitMediaPermissionEvent() {
    return this.mediaPermissionEvent;
  }
  setEmitMediaPermissionEvent(emit3) {
    this.mediaPermissionEvent = emit3;
  }
};
let LocalMediaExecutionContext = _LocalMediaExecutionContext;
__publicField(LocalMediaExecutionContext, "instance");
const instance = LocalMediaExecutionContext.getInstance();
var MediaPermission;
(function(MediaPermission2) {
  MediaPermission2[MediaPermission2["NOT_REQUESTED"] = 0] = "NOT_REQUESTED";
  MediaPermission2[MediaPermission2["ACCEPTED"] = 1] = "ACCEPTED";
  MediaPermission2[MediaPermission2["DENIED"] = 2] = "DENIED";
  MediaPermission2[MediaPermission2["SYSTEM_DENIED"] = 3] = "SYSTEM_DENIED";
  MediaPermission2[MediaPermission2["COULD_NOT_START"] = 4] = "COULD_NOT_START";
})(MediaPermission || (MediaPermission = {}));
var MediaErrorName;
(function(MediaErrorName2) {
  MediaErrorName2["NotAllowedError"] = "NotAllowedError";
  MediaErrorName2["NotReadableError"] = "NotReadableError";
  MediaErrorName2["NotFoundError"] = "NotFoundError";
  MediaErrorName2["AbortError"] = "AbortError";
})(MediaErrorName || (MediaErrorName = {}));
function resolveMediaPermissionError(errorName, errorMessage) {
  if (browserSpecs.isChromiumBased()) {
    if (errorName === MediaErrorName.NotAllowedError) {
      if (errorMessage.indexOf("by system") > 0) {
        return "SYSTEM_DENIED";
      }
      return "DENIED";
    }
    if (errorName === MediaErrorName.NotReadableError) {
      return "COULD_NOT_START";
    }
  } else if (browserSpecs.isSafari()) {
    if (errorName === MediaErrorName.NotAllowedError) {
      return "DENIED";
    }
  } else if (browserSpecs.isFirefox()) {
    if (errorName === MediaErrorName.NotFoundError || errorName === MediaErrorName.NotReadableError) {
      return "SYSTEM_DENIED";
    }
    if (errorName === MediaErrorName.NotAllowedError) {
      return "DENIED";
    }
    if (errorName === MediaErrorName.AbortError) {
      return "COULD_NOT_START";
    }
  }
  return "COULD_NOT_START";
}
var __defProp$d = Object.defineProperty;
var __getOwnPropDesc$d = Object.getOwnPropertyDescriptor;
var __decorateClass$d = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$d(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$d(target, key, result);
  return result;
};
var MediaEvents;
(function(MediaEvents2) {
  MediaEvents2[MediaEvents2["AUDIO_TRACK_CHANGE"] = 0] = "AUDIO_TRACK_CHANGE";
  MediaEvents2[MediaEvents2["VIDEO_TRACK_CHANGE"] = 1] = "VIDEO_TRACK_CHANGE";
  MediaEvents2[MediaEvents2["SCREENSHARE_TRACK_CHANGE"] = 2] = "SCREENSHARE_TRACK_CHANGE";
  MediaEvents2[MediaEvents2["SCREENSHARE_ENDED"] = 3] = "SCREENSHARE_ENDED";
})(MediaEvents || (MediaEvents = {}));
const _LocalMediaHandler = (_c = class extends events$1.exports.EventEmitter {
  constructor(localMediaUtils) {
    super();
    __privateAdd2(this, _localMediaUtils, void 0);
    __publicField(this, "mediaMiddlewareUtils");
    __publicField(this, "audioTrack");
    __publicField(this, "rawAudioTrack");
    __publicField(this, "videoTrack");
    __publicField(this, "rawVideoTrack");
    __publicField(this, "screenShareTracks");
    __publicField(this, "audioEnabled");
    __publicField(this, "videoEnabled");
    __publicField(this, "screenShareEnabled");
    __publicField(this, "currentDevices");
    __publicField(this, "permissions");
    __publicField(this, "audioUpdateInProgress");
    __publicField(this, "videoUpdateInProgress");
    __publicField(this, "screenShareUpdateInProgress");
    __privateSet2(this, _localMediaUtils, localMediaUtils);
    this.audioEnabled = true;
    this.videoEnabled = true;
    this.audioUpdateInProgress = false;
    this.videoUpdateInProgress = false;
    this.screenShareUpdateInProgress = false;
    this.screenShareEnabled = false;
    this.permissions = {
      audio: "NOT_REQUESTED",
      video: "NOT_REQUESTED",
      screenshare: "NOT_REQUESTED"
    };
    this.screenShareTracks = {
      audio: void 0,
      video: void 0
    };
    this.currentDevices = {
      audio: void 0,
      video: void 0,
      speaker: void 0
    };
    __privateGet2(this, _localMediaUtils).onDeviceChange((_, changedDevices) => this.onDeviceChange(changedDevices));
    if (browserSpecs.getName() !== "firefox") {
      this.onPermissionChange();
    }
    this.conditionallyRestartAudio = this.conditionallyRestartAudio.bind(this);
    this.conditionallyRestartVideo = this.conditionallyRestartVideo.bind(this);
    document.addEventListener("visibilitychange", this.onVisibilityChange.bind(this));
  }
  handlePermissionErrors(kind, err) {
    if (kind === "audio") {
      this.audioEnabled = false;
    } else if (kind === "video") {
      this.videoEnabled = false;
    }
    const permissionError = resolveMediaPermissionError(err.name, err.message);
    this.permissions[kind] = permissionError;
    SessionStore.emit(SessionEvents.MEDIA_PERMISSION_ERROR, {
      message: permissionError,
      constraints: err.constraints,
      kind
    });
  }
  onVisibilityChange() {
    if (document.visibilityState === "visible") {
      this.conditionallyRestartAudio();
      this.conditionallyRestartVideo();
    }
    callStats.tabChanged(document.visibilityState === "visible");
    if (document.visibilityState !== "visible") {
      callStats.browserBackgrounded();
    } else {
      callStats.browserForegrounded();
    }
  }
  async conditionallyRestartAudio(ev) {
    var _a3, _b2;
    if (!((_a3 = this.currentDevices) == null ? void 0 : _a3.audio) || !this.audioEnabled) {
      return;
    }
    await Promise.race([
      new Promise((resolve) => {
        var _a4;
        return (_a4 = this.rawAudioTrack) == null ? void 0 : _a4.addEventListener("unmute", (e) => {
          resolve(e);
        });
      }),
      new Promise((resolve) => setTimeout(resolve, 50))
    ]);
    DyteTelemetry.addEventInCurrentSpan("info", "performingCheck::shouldReacquireAudioTrack", { type: ev == null ? void 0 : ev.type });
    const reacquireTrack = await this.shouldReacquireTrack("audio");
    DyteTelemetry.addEventInCurrentSpan("info", "performedCheck::shouldReacquireAudioTrack", { reacquireTrack });
    if (reacquireTrack) {
      DyteTelemetry.addEventInCurrentSpan("info", "reacquiring_audio_track");
      this.removeMediaStreamTrackListeners(this.rawAudioTrack);
      await this.setupAudioStream((_b2 = this.currentDevices.audio) == null ? void 0 : _b2.deviceId);
      this.addMediaStreamTrackListeners(this.rawAudioTrack);
      this.emit("AUDIO_TRACK_CHANGE");
    }
  }
  async conditionallyRestartVideo(ev) {
    var _a3;
    if (!((_a3 = this.currentDevices) == null ? void 0 : _a3.video) || !this.videoEnabled)
      return;
    DyteTelemetry.addEventInCurrentSpan("info", "performingCheck::shouldReacquireVideoTrack", { type: ev == null ? void 0 : ev.type });
    await Promise.race([
      new Promise((resolve) => {
        var _a4;
        return (_a4 = this.rawVideoTrack) == null ? void 0 : _a4.addEventListener("unmute", resolve);
      }),
      new Promise((resolve) => setTimeout(resolve, 50))
    ]);
    const reacquireTrack = await this.shouldReacquireTrack("video");
    DyteTelemetry.addEventInCurrentSpan("info", "performedCheck::shouldReacquireVideoTrack", { reacquireTrack });
    if (reacquireTrack) {
      DyteTelemetry.addEventInCurrentSpan("info", "reacquiring_video_track");
      this.removeMediaStreamTrackListeners(this.rawVideoTrack);
      await this.setupVideoStream(this.currentDevices.video.deviceId);
      this.addMediaStreamTrackListeners(this.rawVideoTrack);
      this.emit("VIDEO_TRACK_CHANGE");
    }
  }
  async shouldReacquireTrack(kind) {
    const workaroundWebKitBug1208516 = true;
    let mediaStreamTrack;
    let wasEnabled = false;
    if (kind === "audio") {
      mediaStreamTrack = this.rawAudioTrack;
      wasEnabled = this.audioEnabled;
    } else if (kind === "video") {
      mediaStreamTrack = this.rawVideoTrack;
      wasEnabled = this.videoEnabled;
    }
    if (!mediaStreamTrack)
      return false;
    const isStopped = mediaStreamTrack.readyState === "ended";
    const isInadvertentlyStopped = isStopped && wasEnabled && workaroundWebKitBug1208516;
    let isSilentAudio = false;
    if (kind === "audio") {
      isSilentAudio = await checkIfAudioTrackIsSilent(this.rawAudioTrack);
    }
    return document.visibilityState === "visible" && (mediaStreamTrack.muted || isInadvertentlyStopped || isSilentAudio);
  }
  onAudioUnmute(ev) {
    DyteTelemetry.addEventInCurrentSpan("info", "audio_track_unmuted", { eventType: ev.type });
  }
  onVideoUnmute(ev) {
    DyteTelemetry.addEventInCurrentSpan("info", "video_track_unmuted", { eventType: ev.type });
  }
  removeMediaStreamTrackListeners(mediaStreamTrack) {
    DyteTelemetry.addEventInCurrentSpan("info", "Removing listerners: ", { mediaStreamTrackKind: mediaStreamTrack.kind });
    if (!mediaStreamTrack) {
      return void 0;
    }
    const conditionallyRestart = mediaStreamTrack.kind === "audio" ? this.conditionallyRestartAudio : this.conditionallyRestartVideo;
    mediaStreamTrack.removeEventListener("ended", conditionallyRestart);
    mediaStreamTrack.removeEventListener("mute", conditionallyRestart);
    mediaStreamTrack.removeEventListener("unmute", mediaStreamTrack.kind === "audio" ? this.onAudioUnmute : this.onVideoUnmute);
    return mediaStreamTrack;
  }
  addMediaStreamTrackListeners(mediaStreamTrack) {
    if (!mediaStreamTrack) {
      return null;
    }
    DyteTelemetry.addEventInCurrentSpan("info", `adding_${mediaStreamTrack.kind}_stream_listerners`);
    const conditionallyRestart = mediaStreamTrack.kind === "audio" ? this.conditionallyRestartAudio : this.conditionallyRestartVideo;
    mediaStreamTrack.addEventListener("ended", conditionallyRestart);
    mediaStreamTrack.addEventListener("mute", conditionallyRestart);
    mediaStreamTrack.addEventListener("unmute", mediaStreamTrack.kind === "audio" ? this.onAudioUnmute : this.onVideoUnmute);
    return mediaStreamTrack;
  }
  async setupAudioStream(deviceId, forceStopTrack = false) {
    var _a3, _b2;
    if (this.audioUpdateInProgress) {
      return;
    }
    try {
      this.audioUpdateInProgress = true;
      const audioDevices = __privateGet2(this, _localMediaUtils).getAudioDevices();
      if (!audioDevices.length) {
        return;
      }
      let audioDeviceId = deviceId;
      if (!audioDeviceId) {
        const operationalDevice = await this.getOperationalMicDeviceId();
        if (!operationalDevice.isOperational)
          return;
        audioDeviceId = operationalDevice.deviceId;
      }
      if (((_a3 = this.currentDevices.audio) == null ? void 0 : _a3.deviceId) !== audioDeviceId) {
        this.currentDevices.audio = __privateGet2(this, _localMediaUtils).getDeviceById(audioDeviceId, "audioinput");
      }
      const audioConstraints = LocalMediaUtils.getAudioConstraints({ audioDeviceId });
      if (forceStopTrack) {
        (_b2 = this.audioTrack) == null ? void 0 : _b2.stop();
      }
      this.rawAudioTrack = await LocalMediaUtils.getAudioTrack(audioConstraints);
      this.setAudioTrack(await this.mediaMiddlewareUtils.getTransformedAudioTrack(this.rawAudioTrack));
      this.addMediaStreamTrackListeners(this.rawAudioTrack);
      if (this.audioTrack && this.permissions.audio === "NOT_REQUESTED") {
        await __privateGet2(this, _localMediaUtils).repopulateAvailableDevices();
      }
      this.permissions.audio = "ACCEPTED";
      callStats.mediaPermission("AUDIO", PermissionEnum.ACCEPTED);
      callStats.selectedDevice("AUDIO", this.currentDevices.audio);
    } catch (err) {
      this.handlePermissionErrors("audio", err);
    } finally {
      this.audioUpdateInProgress = false;
    }
  }
  async setupVideoStream(deviceId, forceStopTrack = true) {
    var _a3, _b2;
    if (this.videoUpdateInProgress) {
      return;
    }
    try {
      this.videoUpdateInProgress = true;
      const videoDevices = __privateGet2(this, _localMediaUtils).getVideoDevices();
      if (!videoDevices.length) {
        return;
      }
      let videoDeviceId = deviceId;
      if (!videoDeviceId) {
        videoDeviceId = (await this.getOperationalWebcamDeviceId()).deviceId;
      }
      if (((_a3 = this.currentDevices.video) == null ? void 0 : _a3.deviceId) !== videoDeviceId) {
        this.currentDevices.video = __privateGet2(this, _localMediaUtils).getDeviceById(videoDeviceId, "videoinput");
      }
      if (forceStopTrack) {
        (_b2 = this.videoTrack) == null ? void 0 : _b2.stop();
      }
      if (this.videoEnabled) {
        const videoConstraints = LocalMediaUtils.getVideoConstraints({ videoDeviceId });
        this.rawVideoTrack = await LocalMediaUtils.getVideoTrack(videoConstraints);
        this.setVideoTrack(await this.mediaMiddlewareUtils.getTransformedVideoTrack(this.rawVideoTrack));
        this.addMediaStreamTrackListeners(this.rawVideoTrack);
      }
      if (this.videoTrack && this.permissions.video === "NOT_REQUESTED") {
        await __privateGet2(this, _localMediaUtils).repopulateAvailableDevices();
      }
      this.permissions.video = "ACCEPTED";
      callStats.mediaPermission("VIDEO", PermissionEnum.ACCEPTED);
      callStats.selectedDevice("VIDEO", this.currentDevices.video);
    } catch (err) {
      this.handlePermissionErrors("video", err);
    } finally {
      this.videoUpdateInProgress = false;
    }
  }
  async setupScreenShareStreams() {
    if (this.screenShareUpdateInProgress) {
      return;
    }
    const constraints = {
      audio: true,
      video: {
        width: { max: 1920 },
        height: { max: 1080 },
        frameRate: { max: 5 }
      }
    };
    try {
      this.screenShareUpdateInProgress = true;
      const screenShareTracks = await LocalMediaUtils.getScreenShareTracks(constraints);
      this.setScreenShareTracks(screenShareTracks);
    } catch (err) {
      this.handlePermissionErrors("screenshare", new LocalMediaException(err.name, err.message, constraints));
      throw new DyteError(err.message);
    } finally {
      this.screenShareUpdateInProgress = false;
    }
  }
  async setupSpeaker(deviceId) {
    var _a3;
    const speakerDevices = __privateGet2(this, _localMediaUtils).getSpeakerDevices();
    if (!speakerDevices.length) {
      return;
    }
    const speakerDeviceId = deviceId != null ? deviceId : speakerDevices[0].deviceId;
    if (((_a3 = this.currentDevices.speaker) == null ? void 0 : _a3.deviceId) !== speakerDeviceId) {
      this.currentDevices.speaker = __privateGet2(this, _localMediaUtils).getDeviceById(speakerDeviceId, "audiooutput");
      callStats.selectedDevice("SPEAKER", this.currentDevices.speaker);
    }
    document.querySelectorAll("audio").forEach(async (audioElem) => {
      if (typeof audioElem.sinkId !== "undefined" && this.currentDevices.speaker.deviceId && audioElem.sinkId !== this.currentDevices.speaker.deviceId) {
        try {
          await audioElem.setSinkId(this.currentDevices.speaker.deviceId);
        } catch {
        }
      }
    });
  }
  async getOperationalWebcamDeviceId() {
    const videoDevices = __privateGet2(this, _localMediaUtils).getVideoDevices();
    if (!videoDevices.length) {
      return { isOperational: false, deviceId: null };
    }
    instance.setEmitMediaPermissionEvent(false);
    const exceptions = [];
    const operationalDeviceId = await videoDevices.reduce(async (promisedActive, device) => {
      const active = await promisedActive;
      if (active !== null)
        return active;
      const videoConstraints = LocalMediaUtils.getVideoConstraints({
        videoDeviceId: device.deviceId
      });
      try {
        const videoTrack = await LocalMediaUtils.getVideoTrack(videoConstraints);
        videoTrack.stop();
        return device.deviceId;
      } catch (err) {
        DyteTelemetry.addEventInCurrentSpan("error", "could_not_acquire_video_device", { device });
        exceptions.push({ exception: err, constraints: videoConstraints });
      }
      return active;
    }, Promise.resolve(null));
    instance.setEmitMediaPermissionEvent(true);
    if (!operationalDeviceId && exceptions.length > 0 && exceptions.length === videoDevices.length) {
      const { exception, constraints } = exceptions[0];
      throw new LocalMediaException(exception.name, exception.message, constraints);
    }
    return operationalDeviceId ? { isOperational: true, deviceId: operationalDeviceId } : { isOperational: false, deviceId: videoDevices[0].deviceId };
  }
  async getOperationalMicDeviceId() {
    const audioDevices = __privateGet2(this, _localMediaUtils).getAudioDevices();
    if (!audioDevices.length) {
      return { isOperational: false, deviceId: null };
    }
    const exceptions = [];
    instance.setEmitMediaPermissionEvent(false);
    const operationalDevice = await audioDevices.reduce(async (promisedActive, device) => {
      const active = await promisedActive;
      if (active !== null)
        return active;
      const audioConstraints = LocalMediaUtils.getAudioConstraints({
        audioDeviceId: device.deviceId
      });
      try {
        const audioTrack = await LocalMediaUtils.getAudioTrack(audioConstraints);
        const isSilent = await checkIfAudioTrackIsSilent(audioTrack);
        if (!isSilent) {
          return device;
        }
      } catch (err) {
        DyteTelemetry.addEventInCurrentSpan("error", "could_not_acquire_audio_device", { device });
        exceptions.push({ exception: err, constraints: audioConstraints });
      }
      return active;
    }, Promise.resolve(null));
    instance.setEmitMediaPermissionEvent(true);
    if (!operationalDevice && exceptions.length > 0 && exceptions.length === audioDevices.length) {
      const { exception, constraints } = exceptions[0];
      throw new LocalMediaException(exception.name, exception.message, constraints);
    }
    return operationalDevice ? { isOperational: true, deviceId: operationalDevice.deviceId } : { isOperational: false, deviceId: audioDevices[0].deviceId };
  }
  async setupStreams({ audio, video }) {
    var _a3;
    const constraints = {};
    if (!this.currentDevices) {
      this.currentDevices = {
        audio: void 0,
        video: void 0,
        speaker: void 0
      };
    }
    try {
      if (audio && !this.audioUpdateInProgress) {
        const audioDevices = __privateGet2(this, _localMediaUtils).getAudioDevices();
        if (audioDevices.length !== 0) {
          const audioDeviceId = (await this.getOperationalMicDeviceId()).deviceId;
          this.currentDevices.audio = __privateGet2(this, _localMediaUtils).getDeviceById(audioDeviceId, "audioinput");
          const audioConstraints = LocalMediaUtils.getAudioConstraints({ audioDeviceId });
          constraints.audio = audioConstraints.audio;
        }
      }
      if (video && !this.videoUpdateInProgress) {
        const videoDevices = __privateGet2(this, _localMediaUtils).getVideoDevices();
        if (videoDevices.length !== 0) {
          const videoDeviceId = (await this.getOperationalWebcamDeviceId()).deviceId;
          this.currentDevices.video = __privateGet2(this, _localMediaUtils).getDeviceById(videoDeviceId, "videoinput");
          const videoConstraints = LocalMediaUtils.getVideoConstraints({ videoDeviceId });
          constraints.video = videoConstraints.video;
        }
      }
      if (((_a3 = Object.keys(constraints)) == null ? void 0 : _a3.length) === 0) {
        this.audioEnabled = audio != null ? audio : this.audioEnabled;
        this.videoEnabled = video != null ? video : this.videoEnabled;
        this.audioUpdateInProgress = false;
        this.videoUpdateInProgress = false;
        return;
      }
      const {
        audioTrack,
        videoTrack
      } = await LocalMediaUtils.getAudioAndVideoTrack(constraints);
      if (audio && audioTrack) {
        this.audioTrack = audioTrack;
        this.rawAudioTrack = audioTrack;
        this.permissions.audio = "ACCEPTED";
      }
      if (video && videoTrack) {
        this.videoTrack = videoTrack;
        this.rawVideoTrack = videoTrack;
        this.permissions.video = "ACCEPTED";
      }
    } catch (err) {
      if (err.name === "NotAllowedError") {
        if (audio)
          await this.setupAudioStream();
        if (video)
          await this.setupVideoStream();
      }
    }
    this.audioEnabled = !!this.audioTrack;
    this.videoEnabled = !!this.videoTrack;
    this.screenShareEnabled = false;
    this.audioUpdateInProgress = false;
    this.videoUpdateInProgress = false;
    await this.setupSpeaker();
  }
  stopAudioTrack() {
    var _a3, _b2;
    if (this.audioUpdateInProgress) {
      return;
    }
    this.audioUpdateInProgress = true;
    (_a3 = this.audioTrack) == null ? void 0 : _a3.stop();
    (_b2 = this.rawAudioTrack) == null ? void 0 : _b2.stop();
    this.audioEnabled = false;
    this.audioUpdateInProgress = false;
  }
  stopVideoTrack() {
    var _a3, _b2;
    if (this.videoUpdateInProgress) {
      return;
    }
    this.videoUpdateInProgress = true;
    (_a3 = this.videoTrack) == null ? void 0 : _a3.stop();
    (_b2 = this.rawVideoTrack) == null ? void 0 : _b2.stop();
    this.videoEnabled = false;
    this.videoUpdateInProgress = false;
  }
  stopScreenShareTracks(tracks = {}) {
    var _a3, _b2, _c2, _d2;
    if (this.screenShareUpdateInProgress) {
      return;
    }
    this.screenShareUpdateInProgress = true;
    const { audio = true, video = true } = tracks;
    if (audio) {
      (_b2 = (_a3 = this.screenShareTracks) == null ? void 0 : _a3.audio) == null ? void 0 : _b2.stop();
    }
    if (video) {
      (_d2 = (_c2 = this.screenShareTracks) == null ? void 0 : _c2.video) == null ? void 0 : _d2.stop();
    }
    if (audio && video) {
      this.screenShareEnabled = false;
    }
    this.screenShareUpdateInProgress = false;
  }
  removeAudioTrack() {
    this.stopAudioTrack();
    this.audioTrack = void 0;
    this.rawAudioTrack = void 0;
  }
  removeVideoTrack() {
    this.stopVideoTrack();
    this.videoTrack = void 0;
    this.rawVideoTrack = void 0;
  }
  removeScreenShareTracks(tracks) {
    var _a3;
    (_a3 = this.screenShareTracks.video) == null ? void 0 : _a3.removeEventListener("ended", this.onScreenShareEnded);
    this.stopScreenShareTracks(tracks);
    this.screenShareTracks = {
      audio: void 0,
      video: void 0
    };
  }
  removeAllTracks() {
    this.removeAudioTrack();
    this.removeVideoTrack();
    this.removeScreenShareTracks();
  }
  setAudioTrack(audioTrack) {
    if (audioTrack === this.audioTrack) {
      return;
    }
    if (audioTrack === void 0) {
      this.stopAudioTrack();
    }
    this.audioTrack = audioTrack;
    if (this.audioTrack) {
      this.audioTrack.enabled = this.audioEnabled;
    }
  }
  setVideoTrack(videoTrack) {
    if (videoTrack === this.videoTrack) {
      return;
    }
    if (videoTrack === void 0) {
      this.stopVideoTrack();
    }
    this.videoTrack = videoTrack;
  }
  setScreenShareTracks(tracks) {
    var _a3;
    const { audio, video } = tracks;
    if (!audio || !video) {
      this.stopScreenShareTracks({ audio: !!audio, video: !!video });
    }
    this.screenShareTracks = tracks;
    (_a3 = this.screenShareTracks.video) == null ? void 0 : _a3.addEventListener("ended", this.onScreenShareEnded.bind(this));
  }
  onScreenShareEnded() {
    this.emit("SCREENSHARE_ENDED");
  }
  async toggleAudio() {
    var _a3;
    if (this.permissions.audio === "DENIED") {
      this.audioEnabled = false;
      return;
    }
    try {
      if (!this.audioTrack) {
        await this.setupAudioStream((_a3 = this.currentDevices.audio) == null ? void 0 : _a3.deviceId);
      }
      if (!this.audioTrack) {
        this.audioEnabled = false;
        return;
      }
      this.audioEnabled = !this.audioEnabled;
    } catch (ex) {
      this.audioEnabled = false;
      DyteTelemetry.addEventInCurrentSpan("error", "LocalMediaHandler::toggleAudio", { message: ex.message, stack: ex.stack }, true);
    }
    if (this.audioTrack) {
      this.audioTrack.enabled = this.audioEnabled;
    }
    if (this.rawAudioTrack) {
      this.rawAudioTrack.enabled = this.audioEnabled;
    }
  }
  async toggleVideo() {
    var _a3;
    if (this.permissions.video === "DENIED") {
      this.videoEnabled = false;
      return;
    }
    if (this.videoEnabled) {
      this.removeVideoTrack();
      return;
    }
    this.videoEnabled = true;
    try {
      await this.setupVideoStream((_a3 = this.currentDevices.video) == null ? void 0 : _a3.deviceId);
    } catch {
      this.videoEnabled = false;
    }
    if (this.videoTrack) {
      this.videoTrack.enabled = this.videoEnabled;
    }
    if (this.rawVideoTrack) {
      this.rawVideoTrack.enabled = this.videoEnabled;
    }
  }
  async toggleScreenShare() {
    if (this.screenShareEnabled) {
      this.removeScreenShareTracks();
      return;
    }
    try {
      await this.setupScreenShareStreams();
      this.screenShareEnabled = true;
    } catch {
      this.screenShareEnabled = false;
    }
  }
  getAllDevices() {
    return __privateGet2(this, _localMediaUtils).availableDevices;
  }
  getDeviceById(deviceId, kind) {
    return __privateGet2(this, _localMediaUtils).getDeviceById(deviceId, kind);
  }
  getAudioDevices() {
    return __privateGet2(this, _localMediaUtils).getAudioDevices();
  }
  getVideoDevices() {
    return __privateGet2(this, _localMediaUtils).getVideoDevices();
  }
  getSpeakerDevices() {
    return __privateGet2(this, _localMediaUtils).getSpeakerDevices();
  }
  async onDeviceChange(changedDevices) {
    let addedDevice;
    let removedDevice;
    if (changedDevices.added.length)
      [addedDevice] = changedDevices.added;
    if (changedDevices.removed.length)
      [removedDevice] = changedDevices.removed;
    if (addedDevice) {
      if (addedDevice.kind === "audioinput") {
        await this.setupAudioStream(addedDevice.deviceId);
        this.emit("AUDIO_TRACK_CHANGE");
      } else if (addedDevice.kind === "videoinput") {
        await this.setupVideoStream(addedDevice.deviceId);
        this.emit("VIDEO_TRACK_CHANGE");
      } else if (addedDevice.kind === "audiooutput") {
        await this.setupSpeaker(addedDevice.deviceId);
      }
    }
    if (removedDevice) {
      if (removedDevice.kind === "audioinput") {
        await this.setupAudioStream();
        this.emit("AUDIO_TRACK_CHANGE");
      } else if (removedDevice.kind === "videoinput") {
        await this.setupVideoStream();
        this.emit("VIDEO_TRACK_CHANGE");
      } else if (removedDevice.kind === "audiooutput") {
        await this.setupSpeaker();
      }
    }
  }
  async onPermissionChange() {
    var _a3, _b2;
    const mic = "microphone";
    const camera = "camera";
    const micPermissions = await ((_a3 = navigator == null ? void 0 : navigator.permissions) == null ? void 0 : _a3.query({ name: mic }));
    const cameraPermissions = await ((_b2 = navigator == null ? void 0 : navigator.permissions) == null ? void 0 : _b2.query({ name: camera }));
    const updateDevices = async () => {
      await __privateGet2(this, _localMediaUtils).repopulateAvailableDevices();
    };
    if (micPermissions) {
      micPermissions.onchange = updateDevices;
    }
    if (cameraPermissions) {
      cameraPermissions.onchange = updateDevices;
    }
  }
  static async init() {
    const localMediaUtils = await LocalMediaUtils.init();
    const localMediaHandler = new _LocalMediaHandler(localMediaUtils);
    const mediaMiddlewareUtils = new MediaMiddlewareUtils(localMediaHandler);
    localMediaHandler.mediaMiddlewareUtils = mediaMiddlewareUtils;
    return localMediaHandler;
  }
  emit(event, ...args) {
    return super.emit(event, ...args);
  }
  on(event, listener) {
    return super.on(event, listener);
  }
}, _localMediaUtils = new WeakMap(), _c);
let LocalMediaHandler = _LocalMediaHandler;
__decorateClass$d([
  DyteTelemetry.trace("shouldReacquireTrack")
], LocalMediaHandler.prototype, "shouldReacquireTrack", 1);
__decorateClass$d([
  DyteTelemetry.trace("removeMediaStreamTrackListeners")
], LocalMediaHandler.prototype, "removeMediaStreamTrackListeners", 1);
__decorateClass$d([
  DyteTelemetry.trace("addMediaStreamTrackListeners")
], LocalMediaHandler.prototype, "addMediaStreamTrackListeners", 1);
__decorateClass$d([
  DyteTelemetry.trace("setupAudioStream")
], LocalMediaHandler.prototype, "setupAudioStream", 1);
__decorateClass$d([
  DyteTelemetry.trace("setupVideoStream")
], LocalMediaHandler.prototype, "setupVideoStream", 1);
__decorateClass$d([
  DyteTelemetry.trace("setupScreenShareStreams")
], LocalMediaHandler.prototype, "setupScreenShareStreams", 1);
__decorateClass$d([
  DyteTelemetry.trace("setupSpeaker")
], LocalMediaHandler.prototype, "setupSpeaker", 1);
__decorateClass$d([
  DyteTelemetry.trace("getOperationalWebcamDeviceId")
], LocalMediaHandler.prototype, "getOperationalWebcamDeviceId", 1);
__decorateClass$d([
  DyteTelemetry.trace("getOperationalMicDeviceId")
], LocalMediaHandler.prototype, "getOperationalMicDeviceId", 1);
__decorateClass$d([
  DyteTelemetry.trace("setupStreams")
], LocalMediaHandler.prototype, "setupStreams", 1);
__decorateClass$d([
  DyteTelemetry.trace("stopAudioTrack")
], LocalMediaHandler.prototype, "stopAudioTrack", 1);
__decorateClass$d([
  DyteTelemetry.trace("stopVideoTrack")
], LocalMediaHandler.prototype, "stopVideoTrack", 1);
__decorateClass$d([
  DyteTelemetry.trace("stopScreenShareTracks")
], LocalMediaHandler.prototype, "stopScreenShareTracks", 1);
__decorateClass$d([
  DyteTelemetry.trace("removeAudioTrack")
], LocalMediaHandler.prototype, "removeAudioTrack", 1);
__decorateClass$d([
  DyteTelemetry.trace("removeVideoTrack")
], LocalMediaHandler.prototype, "removeVideoTrack", 1);
__decorateClass$d([
  DyteTelemetry.trace("removeScreenShareTracks")
], LocalMediaHandler.prototype, "removeScreenShareTracks", 1);
__decorateClass$d([
  DyteTelemetry.trace("removeAllTracks")
], LocalMediaHandler.prototype, "removeAllTracks", 1);
__decorateClass$d([
  DyteTelemetry.trace("setAudioTrack")
], LocalMediaHandler.prototype, "setAudioTrack", 1);
__decorateClass$d([
  DyteTelemetry.trace("setVideoTrack")
], LocalMediaHandler.prototype, "setVideoTrack", 1);
__decorateClass$d([
  DyteTelemetry.trace("setScreenShareTracks")
], LocalMediaHandler.prototype, "setScreenShareTracks", 1);
__decorateClass$d([
  DyteTelemetry.trace("toggleAudio")
], LocalMediaHandler.prototype, "toggleAudio", 1);
__decorateClass$d([
  DyteTelemetry.trace("toggleVideo")
], LocalMediaHandler.prototype, "toggleVideo", 1);
__decorateClass$d([
  DyteTelemetry.trace("toggleScreenShare")
], LocalMediaHandler.prototype, "toggleScreenShare", 1);
var WaitingRoomType;
(function(WaitingRoomType2) {
  WaitingRoomType2["skip"] = "SKIP";
  WaitingRoomType2["onPrivilegedUserEntry"] = "ON_PRIVILEGED_USER_ENTRY";
  WaitingRoomType2["skipOnAccept"] = "SKIP_ON_ACCEPT";
})(WaitingRoomType || (WaitingRoomType = {}));
var CanProduceType;
(function(CanProduceType2) {
  CanProduceType2["allowed"] = "ALLOWED";
  CanProduceType2["notAllowed"] = "NOT_ALLOWED";
  CanProduceType2["canRequest"] = "CAN_REQUEST";
})(CanProduceType || (CanProduceType = {}));
const DEFAULT_PERMISSIONS_SNAKE_CASED$1 = {
  name: "Default Permission",
  accept_waiting_requests: false,
  disable_participant_audio: false,
  disable_participant_screensharing: false,
  disable_participant_video: false,
  kick_participant: true,
  pin_participant: true,
  can_record: false,
  waiting_room_type: WaitingRoomType.skip,
  plugins: {
    can_close: true,
    can_start: true
  },
  polls: {
    can_create: true,
    can_vote: true,
    can_view_results: true
  },
  media: {
    video: { can_produce: CanProduceType.allowed, can_accept_production_request: false },
    audio: { can_produce: CanProduceType.allowed, can_accept_production_request: false },
    screenshare: { can_produce: CanProduceType.allowed, can_accept_production_request: false }
  },
  chat: {
    public: {
      can_send: true,
      text: true,
      files: true
    },
    private: {
      can_send: false,
      can_receive: false,
      text: false,
      files: false
    }
  },
  hidden_participant: false,
  show_participant_list: true,
  can_change_participant_role: true
};
const DEFAULT_PERMISSIONS_CAMEL_CASED$1 = objectToCamelCase(DEFAULT_PERMISSIONS_SNAKE_CASED$1);
const _DytePermissionsPreset = class {
  constructor(userPresetResponse) {
    __privateAdd2(this, _permissions, void 0);
    if (!userPresetResponse) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePermissionsPreset::load_preset_permissions_failed");
      throw new DyteError("Could not load preset permissions.");
    }
    __privateSet2(this, _permissions, userPresetResponse);
    log.debug("Preset permissions:", __privateGet2(this, _permissions));
  }
  static fromResponse(response) {
    return new _DytePermissionsPreset(response);
  }
  static default() {
    return new _DytePermissionsPreset(DEFAULT_PERMISSIONS_CAMEL_CASED$1);
  }
  get acceptWaitingRequests() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.acceptWaitingRequests) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.acceptWaitingRequests;
  }
  get requestProduceVideo() {
    var _a3, _b2, _c2, _d2;
    return ((_d2 = (_c2 = (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.video) == null ? void 0 : _c2.canProduce) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.video.canProduce) === CanProduceType.canRequest;
  }
  get requestProduceAudio() {
    var _a3, _b2, _c2, _d2;
    return ((_d2 = (_c2 = (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.audio) == null ? void 0 : _c2.canProduce) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.audio.canProduce) === CanProduceType.canRequest;
  }
  get requestProduceScreenshare() {
    var _a3, _b2, _c2, _d2;
    return ((_d2 = (_c2 = (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.screenshare) == null ? void 0 : _c2.canProduce) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.screenshare.canProduce) === CanProduceType.canRequest;
  }
  get canAllowParticipantAudio() {
    var _a3, _b2, _c2, _d2;
    return (_d2 = (_c2 = (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.audio) == null ? void 0 : _c2.canAcceptProductionRequest) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.audio.canAcceptProductionRequest;
  }
  get canAllowParticipantScreensharing() {
    var _a3, _b2, _c2, _d2;
    return (_d2 = (_c2 = (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.screenshare) == null ? void 0 : _c2.canAcceptProductionRequest) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.screenshare.canAcceptProductionRequest;
  }
  get canAllowParticipantVideo() {
    var _a3, _b2, _c2, _d2;
    return (_d2 = (_c2 = (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.video) == null ? void 0 : _c2.canAcceptProductionRequest) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.video.canAcceptProductionRequest;
  }
  get kickParticipant() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.kickParticipant) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.kickParticipant;
  }
  get pinParticipant() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.pinParticipant) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.pinParticipant;
  }
  get canRecord() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.canRecord) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.canRecord;
  }
  get waitingRoomType() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.waitingRoomType) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.waitingRoomType;
  }
  get plugins() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.plugins) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.plugins;
  }
  get polls() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.polls) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.polls;
  }
  get produceVideo() {
    var _a3, _b2, _c2, _d2;
    return (_d2 = (_c2 = (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.video) == null ? void 0 : _c2.canProduce) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.video.canProduce;
  }
  get produceScreenshare() {
    var _a3, _b2, _c2, _d2;
    return (_d2 = (_c2 = (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.screenshare) == null ? void 0 : _c2.canProduce) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.screenshare.canProduce;
  }
  get produceAudio() {
    var _a3;
    return (_a3 = __privateGet2(this, _permissions).media.audio.canProduce) != null ? _a3 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.audio.canProduce;
  }
  get chatPublic() {
    var _a3, _b2, _c2;
    return (_c2 = (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.chat) == null ? void 0 : _b2.public) != null ? _c2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.chat.public;
  }
  get chatPrivate() {
    var _a3, _b2, _c2;
    return (_c2 = (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.chat) == null ? void 0 : _b2.private) != null ? _c2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.chat.private;
  }
  get hiddenParticipant() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.hiddenParticipant) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.hiddenParticipant;
  }
  get showParticipantList() {
    var _a3;
    return (_a3 = __privateGet2(this, _permissions).showParticipantList) != null ? _a3 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.showParticipantList;
  }
  get canChangeParticipantRole() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet2(this, _permissions)) == null ? void 0 : _a3.canChangeParticipantRole) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.canChangeParticipantRole;
  }
};
let DytePermissionsPreset = _DytePermissionsPreset;
_permissions = new WeakMap();
var __defProp$c = Object.defineProperty;
var __getOwnPropDesc$c = Object.getOwnPropertyDescriptor;
var __decorateClass$c = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$c(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$c(target, key, result);
  return result;
};
const _DyteSelf = (_d = class extends DyteEventEmitter {
  constructor(roomNodeClient, localMediaHandler, details, permissions, theme) {
    super();
    __publicField(this, "id");
    __publicField(this, "name");
    __publicField(this, "picture");
    __publicField(this, "clientSpecificId");
    __publicField(this, "waitlistStatus");
    __privateAdd2(this, _roomNodeClient, void 0);
    __privateAdd2(this, _localMediaHandler3, void 0);
    __privateAdd2(this, _previewMediaHandler, void 0);
    __privateAdd2(this, _theme, void 0);
    __privateAdd2(this, _permissions2, void 0);
    __privateAdd2(this, _isPinned, void 0);
    __publicField(this, "preview");
    __publicField(this, "role");
    __publicField(this, "userId");
    __publicField(this, "organizationId");
    __publicField(this, "supportsRemoteControl", false);
    __publicField(this, "device");
    __privateSet2(this, _roomNodeClient, roomNodeClient);
    __privateSet2(this, _localMediaHandler3, localMediaHandler);
    this.id = roomNodeClient.peerId;
    this.userId = details.id;
    this.name = details.name;
    this.picture = details.picture;
    this.clientSpecificId = details.clientSpecificId;
    this.waitlistStatus = "none";
    __privateSet2(this, _permissions2, permissions);
    __privateSet2(this, _theme, theme);
    __privateSet2(this, _isPinned, false);
    this.organizationId = details.organizationId;
    this.preview = {
      audioTrack: void 0,
      audioEnabled: false,
      videoTrack: void 0,
      videoEnabled: false
    };
    this.supportsRemoteControl = browserSpecs.isElectron();
    this.device = browserSpecs.getDeviceInfo();
    this.setupEvents();
  }
  static async init(roomNodeClient, details, permissions, theme, defaults, localMediaHandler) {
    var _a3, _b2;
    await localMediaHandler.setupStreams({
      video: (_a3 = defaults.video) != null ? _a3 : true,
      audio: (_b2 = defaults.audio) != null ? _b2 : true
    });
    return new _DyteSelf(roomNodeClient, localMediaHandler, details, permissions, theme);
  }
  setupEvents() {
    __privateGet2(this, _localMediaHandler3).on("AUDIO_TRACK_CHANGE", async () => {
      var _a3;
      DyteTelemetry.addEventInCurrentSpan("info", "DyteSelf::setupEvents::AUDIO_TRACK_CHANGE", {
        audioEnabled: this.audioEnabled,
        trackId: (_a3 = this.audioTrack) == null ? void 0 : _a3.id
      });
      if (__privateGet2(this, _roomNodeClient).roomJoined) {
        await __privateGet2(this, _roomNodeClient).shareMic(this.audioTrack);
      }
      this.emit("audioUpdate", {
        audioEnabled: this.audioEnabled,
        audioTrack: this.audioTrack
      });
    });
    __privateGet2(this, _localMediaHandler3).on("VIDEO_TRACK_CHANGE", async () => {
      var _a3;
      DyteTelemetry.addEventInCurrentSpan("info", "DyteSelf::setupEvents::VIDEO_TRACK_CHANGE", {
        videoEnabled: this.videoEnabled,
        trackId: (_a3 = this.videoTrack) == null ? void 0 : _a3.id
      });
      if (this.videoEnabled && __privateGet2(this, _roomNodeClient).roomJoined) {
        await __privateGet2(this, _roomNodeClient).shareWebcam(this.videoTrack);
      }
      this.emit("videoUpdate", {
        videoEnabled: this.videoEnabled,
        videoTrack: this.videoTrack
      });
    });
    __privateGet2(this, _localMediaHandler3).on("SCREENSHARE_TRACK_CHANGE", async () => {
      if (!__privateGet2(this, _roomNodeClient).roomJoined)
        return;
      if (this.screenShareEnabled) {
        await __privateGet2(this, _roomNodeClient).shareScreen(this.screenShareTracks);
      }
      DyteTelemetry.addEventInCurrentSpan("info", "DyteSelf::setupEvents::SCREENSHARE_TRACK_CHANGE", {
        screenShareEnabled: this.screenShareEnabled
      });
      this.emit("screenShareUpdate", {
        screenShareEnabled: this.screenShareEnabled,
        screenShareTracks: this.screenShareTracks
      });
    });
    __privateGet2(this, _localMediaHandler3).on("SCREENSHARE_ENDED", async () => {
      await this.disableScreenShare();
      DyteTelemetry.addEventInCurrentSpan("info", "DyteSelf::setupEvents::SCREENSHARE_ENDED", {
        screenShareEnabled: this.screenShareEnabled
      });
    });
  }
  get audioTrack() {
    return __privateGet2(this, _localMediaHandler3).audioTrack;
  }
  get rawAudioTrack() {
    return __privateGet2(this, _localMediaHandler3).rawAudioTrack;
  }
  async addAudioMiddleware(audioMiddleware) {
    return __privateGet2(this, _localMediaHandler3).mediaMiddlewareUtils.addAudioMiddleware(audioMiddleware);
  }
  async removeAudioMiddleware(audioMiddleware) {
    return __privateGet2(this, _localMediaHandler3).mediaMiddlewareUtils.removeAudioMiddleware(audioMiddleware);
  }
  get videoTrack() {
    return __privateGet2(this, _localMediaHandler3).videoTrack;
  }
  get rawVideoTrack() {
    return __privateGet2(this, _localMediaHandler3).rawVideoTrack;
  }
  async addVideoMiddleware(videoMiddleware) {
    return __privateGet2(this, _localMediaHandler3).mediaMiddlewareUtils.addVideoMiddleware(videoMiddleware);
  }
  async removeVideoMiddleware(videoMiddleware) {
    return __privateGet2(this, _localMediaHandler3).mediaMiddlewareUtils.removeVideoMiddleware(videoMiddleware);
  }
  get screenShareTracks() {
    return __privateGet2(this, _localMediaHandler3).screenShareTracks;
  }
  get audioEnabled() {
    return __privateGet2(this, _localMediaHandler3).audioEnabled;
  }
  get videoEnabled() {
    return __privateGet2(this, _localMediaHandler3).videoEnabled;
  }
  get screenShareEnabled() {
    return __privateGet2(this, _localMediaHandler3).screenShareEnabled;
  }
  get mediaPermissions() {
    return __privateGet2(this, _localMediaHandler3).permissions;
  }
  get permissions() {
    return __privateGet2(this, _permissions2);
  }
  get suggestedTheme() {
    return __privateGet2(this, _theme);
  }
  get roomJoined() {
    return __privateGet2(this, _roomNodeClient).roomJoined;
  }
  setName(name) {
    if (!name) {
      throw new DyteError("Name cannot be empty.");
    }
    this.name = name;
  }
  setupTracks(options = {}) {
    var _a3, _b2;
    return __privateGet2(this, _localMediaHandler3).setupStreams({
      video: (_a3 = options.video) != null ? _a3 : true,
      audio: (_b2 = options.audio) != null ? _b2 : true
    });
  }
  async enableAudio() {
    if (!this.permissions.produceAudio) {
      return;
    }
    if (this.audioEnabled) {
      return;
    }
    const wasAudioTrackDefined = !!this.audioTrack;
    await __privateGet2(this, _localMediaHandler3).toggleAudio();
    if (this.roomJoined) {
      if (!wasAudioTrackDefined && !!this.audioTrack) {
        await __privateGet2(this, _roomNodeClient).shareMic(this.audioTrack);
      }
      if (!this.audioEnabled) {
        return;
      }
      __privateGet2(this, _roomNodeClient).unmuteSelf();
    }
    this.emit("audioUpdate", {
      audioEnabled: this.audioEnabled,
      audioTrack: this.audioTrack
    });
    callStats.audioOn();
  }
  async enableVideo() {
    if (constants.isV2AuthToken ? __privateGet2(this, _permissions2).produceVideo !== CanProduceType.allowed : !__privateGet2(this, _permissions2).produceVideo.allow) {
      return;
    }
    if (this.videoEnabled) {
      return;
    }
    await __privateGet2(this, _localMediaHandler3).toggleVideo();
    if (this.roomJoined) {
      await __privateGet2(this, _roomNodeClient).shareWebcam(this.videoTrack);
    }
    this.emit("videoUpdate", {
      videoEnabled: this.videoEnabled,
      videoTrack: this.videoTrack
    });
    callStats.videoOn();
  }
  async enableScreenShare() {
    if (!__privateGet2(this, _roomNodeClient).roomJoined) {
      return;
    }
    if (constants.isV2AuthToken ? __privateGet2(this, _permissions2).produceScreenshare : !__privateGet2(this, _permissions2).produceScreenshare.allow) {
      return;
    }
    if (this.screenShareEnabled) {
      return;
    }
    await __privateGet2(this, _localMediaHandler3).toggleScreenShare();
    if (this.screenShareTracks.audio || this.screenShareTracks.video) {
      await __privateGet2(this, _roomNodeClient).shareScreen(this.screenShareTracks);
    }
    this.emit("screenShareUpdate", {
      screenShareEnabled: this.screenShareEnabled,
      screenShareTracks: this.screenShareTracks
    });
  }
  async disableAudio() {
    if (!this.audioEnabled) {
      return;
    }
    await __privateGet2(this, _localMediaHandler3).toggleAudio();
    if (this.roomJoined) {
      __privateGet2(this, _roomNodeClient).muteSelf();
    }
    this.emit("audioUpdate", {
      audioEnabled: this.audioEnabled,
      audioTrack: this.audioTrack
    });
    callStats.audioOff();
    callStats.mediaTrackMuted("AUDIO");
  }
  async disableVideo() {
    if (!this.videoEnabled) {
      return;
    }
    await __privateGet2(this, _localMediaHandler3).toggleVideo();
    if (this.roomJoined) {
      await __privateGet2(this, _roomNodeClient).pauseWebcam();
    }
    this.emit("videoUpdate", {
      videoEnabled: this.videoEnabled,
      videoTrack: this.videoTrack
    });
    callStats.videoOff();
    callStats.mediaTrackMuted("VIDEO");
  }
  async disableScreenShare() {
    if (!__privateGet2(this, _roomNodeClient).roomJoined) {
      return;
    }
    if (!this.screenShareEnabled) {
      return;
    }
    await __privateGet2(this, _localMediaHandler3).toggleScreenShare();
    await __privateGet2(this, _roomNodeClient).disableScreenShare();
    this.emit("screenShareUpdate", {
      screenShareEnabled: this.screenShareEnabled,
      screenShareTracks: this.screenShareTracks
    });
  }
  async enablePreview(options = { audio: true, video: true }) {
    var _a3, _b2;
    __privateSet2(this, _previewMediaHandler, (_a3 = __privateGet2(this, _previewMediaHandler)) != null ? _a3 : await LocalMediaHandler.init());
    let {
      audio = false,
      video = false
    } = options;
    if (this.preview.audioEnabled) {
      audio = void 0;
    }
    if (this.preview.videoEnabled) {
      video = void 0;
    }
    await __privateGet2(this, _previewMediaHandler).setupStreams({ audio, video });
    const {
      audioTrack,
      audioEnabled,
      videoTrack,
      videoEnabled
    } = (_b2 = __privateGet2(this, _previewMediaHandler)) != null ? _b2 : {};
    this.preview = {
      audioTrack,
      audioEnabled,
      videoTrack,
      videoEnabled
    };
    this.emit("previewUpdate", {
      preview: this.preview
    });
  }
  async disablePreview(options = { audio: true, video: true }) {
    var _a3, _b2, _c2;
    const { audio = false, video = false } = options;
    if (audio) {
      (_a3 = __privateGet2(this, _previewMediaHandler)) == null ? void 0 : _a3.removeAudioTrack();
    }
    if (video) {
      (_b2 = __privateGet2(this, _previewMediaHandler)) == null ? void 0 : _b2.removeVideoTrack();
    }
    const {
      audioTrack,
      audioEnabled,
      videoTrack,
      videoEnabled
    } = (_c2 = __privateGet2(this, _previewMediaHandler)) != null ? _c2 : {};
    this.preview = {
      audioTrack,
      audioEnabled,
      videoTrack,
      videoEnabled
    };
    if (!audioTrack && !audioEnabled && !videoTrack && !videoEnabled) {
      __privateSet2(this, _previewMediaHandler, void 0);
    }
    this.emit("previewUpdate", {
      preview: this.preview
    });
  }
  getCurrentDevices() {
    return __privateGet2(this, _localMediaHandler3).currentDevices;
  }
  getAudioDevices() {
    return __privateGet2(this, _localMediaHandler3).getAudioDevices();
  }
  getVideoDevices() {
    return __privateGet2(this, _localMediaHandler3).getVideoDevices();
  }
  getSpeakerDevices() {
    return __privateGet2(this, _localMediaHandler3).getSpeakerDevices();
  }
  getDeviceById(deviceId, kind) {
    let k;
    if (kind === "audio") {
      k = "audioinput";
    } else if (kind === "video") {
      k = "videoinput";
    } else if (kind === "speaker") {
      k = "audiooutput";
    }
    return __privateGet2(this, _localMediaHandler3).getDeviceById(deviceId, k);
  }
  getAllDevices() {
    return __privateGet2(this, _localMediaHandler3).getAllDevices();
  }
  setIsPinned(isPinned, emitEvent = true) {
    __privateSet2(this, _isPinned, isPinned);
    const event = isPinned ? "pinned" : "unpinned";
    if (emitEvent)
      this.emit(event, this);
  }
  get isPinned() {
    return __privateGet2(this, _isPinned);
  }
  async pin() {
    return __privateGet2(this, _roomNodeClient).pinPeer(this.id);
  }
  async unpin() {
    return __privateGet2(this, _roomNodeClient).pinPeer(null);
  }
  async setDevice(device, preview = false) {
    var _a3;
    const changedDevices = {
      added: [device],
      removed: []
    };
    if (!preview) {
      await __privateGet2(this, _localMediaHandler3).onDeviceChange(changedDevices);
    }
    await ((_a3 = __privateGet2(this, _previewMediaHandler)) == null ? void 0 : _a3.onDeviceChange(changedDevices));
    this.emit("deviceUpdate", {
      device,
      preview
    });
  }
}, _roomNodeClient = new WeakMap(), _localMediaHandler3 = new WeakMap(), _previewMediaHandler = new WeakMap(), _theme = new WeakMap(), _permissions2 = new WeakMap(), _isPinned = new WeakMap(), _d);
let DyteSelf = _DyteSelf;
__decorateClass$c([
  DyteTelemetry.trace("DyteSelf.setupEvents")
], DyteSelf.prototype, "setupEvents", 1);
__decorateClass$c([
  DyteTelemetry.trace("setupTracks")
], DyteSelf.prototype, "setupTracks", 1);
__decorateClass$c([
  DyteTelemetry.trace("enableAudio")
], DyteSelf.prototype, "enableAudio", 1);
__decorateClass$c([
  DyteTelemetry.trace("enableVideo")
], DyteSelf.prototype, "enableVideo", 1);
__decorateClass$c([
  DyteTelemetry.trace("enableScreenShare")
], DyteSelf.prototype, "enableScreenShare", 1);
__decorateClass$c([
  DyteTelemetry.trace("disableAudio")
], DyteSelf.prototype, "disableAudio", 1);
__decorateClass$c([
  DyteTelemetry.trace("disableVideo")
], DyteSelf.prototype, "disableVideo", 1);
__decorateClass$c([
  DyteTelemetry.trace("disableScreenShare")
], DyteSelf.prototype, "disableScreenShare", 1);
__decorateClass$c([
  DyteTelemetry.trace("enablePreview")
], DyteSelf.prototype, "enablePreview", 1);
__decorateClass$c([
  DyteTelemetry.trace("disablePreview")
], DyteSelf.prototype, "disablePreview", 1);
__decorateClass$c([
  DyteTelemetry.trace("setDevice")
], DyteSelf.prototype, "setDevice", 1);
const DEFAULT_THEME_SNAKE_CASED$1 = {
  setup_screen: { is_enabled: false },
  alone_here: { is_enabled: false },
  waiting_room: { is_enabled: false, enable_preview: true },
  control_bar: {
    is_enabled: true,
    elements: {
      plugins: true,
      screenshare: true,
      invite: false,
      participants: true,
      chat: true,
      reactions: false,
      polls: true,
      fullscreen: true,
      layout: true
    }
  },
  header: {
    is_enabled: true,
    elements: {
      logo: "https://app.dyte.in/dyte_logo.svg",
      timer: true,
      title: true,
      participant_count: true,
      change_layout: true
    }
  },
  pip_mode: true,
  auto_tune: true,
  grid: {
    multi: { max_video_count: 9, video_fit: "cover" },
    single: { max_video_count: 6, video_fit: "cover" },
    default_view: "MULTI"
  },
  colors: {
    primary: "#2160FD",
    secondary: "#1A1A1A",
    text: "#EEEEEE",
    background: "#1A1A1A",
    text_primary: "#EEEEEE",
    video_background: "#1A1A1A"
  },
  controls: { pip_toggle: false },
  plugins: []
};
const DEFAULT_THEME_CAMEL_CASED$1 = objectToCamelCase(DEFAULT_THEME_SNAKE_CASED$1);
const _DyteThemePresetV1 = class {
  constructor(presetThemeV1) {
    __privateAdd2(this, _theme2, void 0);
    if (!presetThemeV1) {
      throw new DyteError("Could not load preset theme.");
    }
    __privateSet2(this, _theme2, presetThemeV1);
    DyteTelemetry.addEventInCurrentSpan("debug", "preset_theme", {
      theme: __privateGet2(this, _theme2)
    });
  }
  static fromResponse(theme) {
    return new _DyteThemePresetV1(theme);
  }
  static default() {
    return new _DyteThemePresetV1(DEFAULT_THEME_CAMEL_CASED$1);
  }
  get setupScreen() {
    return __privateGet2(this, _theme2).setupScreen;
  }
  get aloneHere() {
    return __privateGet2(this, _theme2).aloneHere;
  }
  get waitingRoom() {
    return __privateGet2(this, _theme2).waitingRoom;
  }
  get controlBar() {
    return __privateGet2(this, _theme2).controlBar;
  }
  get header() {
    return __privateGet2(this, _theme2).header;
  }
  get pipMode() {
    return __privateGet2(this, _theme2).pipMode;
  }
  get autoTune() {
    return __privateGet2(this, _theme2).autoTune;
  }
  get grid() {
    return __privateGet2(this, _theme2).grid;
  }
  get colors() {
    return __privateGet2(this, _theme2).colors;
  }
  get controls() {
    return __privateGet2(this, _theme2).controls;
  }
  get plugins() {
    return __privateGet2(this, _theme2).plugins;
  }
};
let DyteThemePresetV1 = _DyteThemePresetV1;
_theme2 = new WeakMap();
const DEFAULT_PERMISSIONS_SNAKE_CASED = {
  view_type: "GROUP_CALL",
  accept_waiting_requests: false,
  request_produce: false,
  can_allow_participant_audio: true,
  can_allow_participant_screensharing: false,
  can_allow_participant_video: true,
  request_kick_participant: false,
  kick_participant: true,
  pin_participant: true,
  can_record: false,
  waiting_room_type: "SKIP",
  plugins: {
    can_close: true,
    can_start: true,
    can_edit_acl: false,
    config: {}
  },
  polls: {
    can_create: true,
    can_vote: true,
    can_view: true
  },
  produce: {
    video: { allow: true, quality: "vga", frame_rate: 24 },
    audio: true,
    screenshare: { allow: true, quality: "hd", frame_rate: 5 }
  },
  chat: {
    public: {
      can_send: true,
      text: true,
      files: true
    },
    private: {
      can_send: false,
      can_receive: false,
      text: false,
      files: false
    }
  },
  reactions: false,
  hidden_participant: false,
  show_participant_list: true,
  can_change_participant_role: true,
  can_change_theme: false,
  can_present: false,
  accept_present_requests: false,
  can_edit_display_name: false,
  max_screenshare_count: 1,
  is_recorder: false
};
const DEFAULT_PERMISSIONS_CAMEL_CASED = objectToCamelCase(DEFAULT_PERMISSIONS_SNAKE_CASED);
const _DytePermissionsPresetV1 = class {
  constructor(userPresetResponse) {
    __privateAdd2(this, _permissions3, void 0);
    if (!userPresetResponse) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePermissionsPresetV1::load_preset_permissions_failed");
      throw new DyteError("Could not load preset permissions.");
    }
    __privateSet2(this, _permissions3, userPresetResponse);
    log.debug("Preset permissions:", __privateGet2(this, _permissions3));
  }
  static fromResponse(response) {
    return new _DytePermissionsPresetV1(response);
  }
  static default() {
    return new _DytePermissionsPresetV1(DEFAULT_PERMISSIONS_CAMEL_CASED);
  }
  get viewType() {
    return __privateGet2(this, _permissions3).viewType;
  }
  get acceptWaitingRequests() {
    return __privateGet2(this, _permissions3).acceptWaitingRequests;
  }
  get requestProduce() {
    return __privateGet2(this, _permissions3).requestProduce;
  }
  get canAllowParticipantAudio() {
    return __privateGet2(this, _permissions3).canAllowParticipantAudio;
  }
  get canAllowParticipantScreensharing() {
    return __privateGet2(this, _permissions3).canAllowParticipantScreensharing;
  }
  get canAllowParticipantVideo() {
    return __privateGet2(this, _permissions3).canAllowParticipantVideo;
  }
  get requestKickParticipant() {
    return __privateGet2(this, _permissions3).requestKickParticipant;
  }
  get kickParticipant() {
    return __privateGet2(this, _permissions3).kickParticipant;
  }
  get pinParticipant() {
    return __privateGet2(this, _permissions3).pinParticipant;
  }
  get canRecord() {
    return __privateGet2(this, _permissions3).canRecord;
  }
  get waitingRoomType() {
    return __privateGet2(this, _permissions3).waitingRoomType;
  }
  get plugins() {
    return __privateGet2(this, _permissions3).plugins;
  }
  get polls() {
    return __privateGet2(this, _permissions3).polls;
  }
  get produceVideo() {
    return __spreadProps(__spreadValues({}, __privateGet2(this, _permissions3).produce.video), {
      allow: __privateGet2(this, _permissions3).produce.video.allow ? CanProduceType.allowed : CanProduceType.notAllowed
    });
  }
  get produceScreenshare() {
    return __spreadProps(__spreadValues({}, __privateGet2(this, _permissions3).produce.screenshare), {
      allow: __privateGet2(this, _permissions3).produce.screenshare.allow ? CanProduceType.allowed : CanProduceType.notAllowed
    });
  }
  get produceAudio() {
    return __privateGet2(this, _permissions3).produce.audio ? CanProduceType.allowed : CanProduceType.notAllowed;
  }
  get chatPublic() {
    return __privateGet2(this, _permissions3).chat.public;
  }
  get chatPrivate() {
    return __privateGet2(this, _permissions3).chat.private;
  }
  get reactions() {
    return __privateGet2(this, _permissions3).reactions;
  }
  get hiddenParticipant() {
    return __privateGet2(this, _permissions3).hiddenParticipant;
  }
  get showParticipantList() {
    return __privateGet2(this, _permissions3).showParticipantList;
  }
  get canChangeParticipantRole() {
    return __privateGet2(this, _permissions3).canChangeParticipantRole;
  }
  get canChangeTheme() {
    return __privateGet2(this, _permissions3).canChangeTheme;
  }
  get canPresent() {
    return __privateGet2(this, _permissions3).canPresent;
  }
  get acceptPresentRequests() {
    return __privateGet2(this, _permissions3).acceptPresentRequests;
  }
  get canEditDisplayName() {
    return __privateGet2(this, _permissions3).canEditDisplayName;
  }
  get maxScreenShareCount() {
    return __privateGet2(this, _permissions3).maxScreenshareCount;
  }
  get isRecorder() {
    return __privateGet2(this, _permissions3).isRecorder;
  }
};
let DytePermissionsPresetV1 = _DytePermissionsPresetV1;
_permissions3 = new WeakMap();
var dist = {};
var client_edge_pb = {};
var googleProtobuf$1 = {};
(function(exports) {
  var $jscomp = $jscomp || {};
  $jscomp.scope = {};
  $jscomp.findInternal = function(a2, b, c) {
    a2 instanceof String && (a2 = String(a2));
    for (var d = a2.length, e = 0; e < d; e++) {
      var f = a2[e];
      if (b.call(c, f, e, a2))
        return { i: e, v: f };
    }
    return { i: -1, v: void 0 };
  };
  $jscomp.ASSUME_ES5 = false;
  $jscomp.ASSUME_NO_NATIVE_MAP = false;
  $jscomp.ASSUME_NO_NATIVE_SET = false;
  $jscomp.SIMPLE_FROUND_POLYFILL = false;
  $jscomp.defineProperty = $jscomp.ASSUME_ES5 || typeof Object.defineProperties == "function" ? Object.defineProperty : function(a2, b, c) {
    a2 != Array.prototype && a2 != Object.prototype && (a2[b] = c.value);
  };
  $jscomp.getGlobal = function(a2) {
    return typeof window != "undefined" && window === a2 ? a2 : typeof commonjsGlobal$1 != "undefined" && commonjsGlobal$1 != null ? commonjsGlobal$1 : a2;
  };
  $jscomp.global = $jscomp.getGlobal(commonjsGlobal$1);
  $jscomp.polyfill = function(a2, b, c, d) {
    if (b) {
      c = $jscomp.global;
      a2 = a2.split(".");
      for (d = 0; d < a2.length - 1; d++) {
        var e = a2[d];
        e in c || (c[e] = {});
        c = c[e];
      }
      a2 = a2[a2.length - 1];
      d = c[a2];
      b = b(d);
      b != d && b != null && $jscomp.defineProperty(c, a2, { configurable: true, writable: true, value: b });
    }
  };
  $jscomp.polyfill("Array.prototype.findIndex", function(a2) {
    return a2 ? a2 : function(a3, c) {
      return $jscomp.findInternal(this, a3, c).i;
    };
  }, "es6", "es3");
  $jscomp.checkStringArgs = function(a2, b, c) {
    if (a2 == null)
      throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
    if (b instanceof RegExp)
      throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
    return a2 + "";
  };
  $jscomp.polyfill("String.prototype.endsWith", function(a2) {
    return a2 ? a2 : function(a3, c) {
      var b = $jscomp.checkStringArgs(this, a3, "endsWith");
      a3 += "";
      c === void 0 && (c = b.length);
      c = Math.max(0, Math.min(c | 0, b.length));
      for (var e = a3.length; 0 < e && 0 < c; )
        if (b[--c] != a3[--e])
          return false;
      return 0 >= e;
    };
  }, "es6", "es3");
  $jscomp.polyfill("Array.prototype.find", function(a2) {
    return a2 ? a2 : function(a3, c) {
      return $jscomp.findInternal(this, a3, c).v;
    };
  }, "es6", "es3");
  $jscomp.polyfill("String.prototype.startsWith", function(a2) {
    return a2 ? a2 : function(a3, c) {
      var b = $jscomp.checkStringArgs(this, a3, "startsWith");
      a3 += "";
      var e = b.length, f = a3.length;
      c = Math.max(0, Math.min(c | 0, b.length));
      for (var g = 0; g < f && c < e; )
        if (b[c++] != a3[g++])
          return false;
      return g >= f;
    };
  }, "es6", "es3");
  $jscomp.polyfill("String.prototype.repeat", function(a2) {
    return a2 ? a2 : function(a3) {
      var b = $jscomp.checkStringArgs(this, null, "repeat");
      if (0 > a3 || 1342177279 < a3)
        throw new RangeError("Invalid count value");
      a3 |= 0;
      for (var d = ""; a3; )
        if (a3 & 1 && (d += b), a3 >>>= 1)
          b += b;
      return d;
    };
  }, "es6", "es3");
  var COMPILED = true, goog = goog || {};
  goog.global = commonjsGlobal$1 || self;
  goog.isDef = function(a2) {
    return a2 !== void 0;
  };
  goog.isString = function(a2) {
    return typeof a2 == "string";
  };
  goog.isBoolean = function(a2) {
    return typeof a2 == "boolean";
  };
  goog.isNumber = function(a2) {
    return typeof a2 == "number";
  };
  goog.exportPath_ = function(a2, b, c) {
    a2 = a2.split(".");
    c = c || goog.global;
    a2[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a2[0]);
    for (var d; a2.length && (d = a2.shift()); )
      !a2.length && goog.isDef(b) ? c[d] = b : c = c[d] && c[d] !== Object.prototype[d] ? c[d] : c[d] = {};
  };
  goog.define = function(a2, b) {
    return b;
  };
  goog.FEATURESET_YEAR = 2012;
  goog.DEBUG = true;
  goog.LOCALE = "en";
  goog.TRUSTED_SITE = true;
  goog.STRICT_MODE_COMPATIBLE = false;
  goog.DISALLOW_TEST_ONLY_CODE = !goog.DEBUG;
  goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = false;
  goog.provide = function(a2) {
    if (goog.isInModuleLoader_())
      throw Error("goog.provide cannot be used within a module.");
    goog.constructNamespace_(a2);
  };
  goog.constructNamespace_ = function(a2, b) {
    goog.exportPath_(a2, b);
  };
  goog.getScriptNonce = function(a2) {
    if (a2 && a2 != goog.global)
      return goog.getScriptNonce_(a2.document);
    goog.cspNonce_ === null && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document));
    return goog.cspNonce_;
  };
  goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/;
  goog.cspNonce_ = null;
  goog.getScriptNonce_ = function(a2) {
    return (a2 = a2.querySelector && a2.querySelector("script[nonce]")) && (a2 = a2.nonce || a2.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(a2) ? a2 : "";
  };
  goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
  goog.module = function(a2) {
    if (!goog.isString(a2) || !a2 || a2.search(goog.VALID_MODULE_RE_) == -1)
      throw Error("Invalid module identifier");
    if (!goog.isInGoogModuleLoader_())
      throw Error("Module " + a2 + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
    if (goog.moduleLoaderState_.moduleName)
      throw Error("goog.module may only be called once per module.");
    goog.moduleLoaderState_.moduleName = a2;
  };
  goog.module.get = function(a2) {
    return goog.module.getInternal_(a2);
  };
  goog.module.getInternal_ = function(a2) {
    return null;
  };
  goog.ModuleType = { ES6: "es6", GOOG: "goog" };
  goog.moduleLoaderState_ = null;
  goog.isInModuleLoader_ = function() {
    return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
  };
  goog.isInGoogModuleLoader_ = function() {
    return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
  };
  goog.isInEs6ModuleLoader_ = function() {
    if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6)
      return true;
    var a2 = goog.global.$jscomp;
    return a2 ? typeof a2.getCurrentModulePath != "function" ? false : !!a2.getCurrentModulePath() : false;
  };
  goog.module.declareLegacyNamespace = function() {
    goog.moduleLoaderState_.declareLegacyNamespace = true;
  };
  goog.declareModuleId = function(a2) {
    if (goog.moduleLoaderState_)
      goog.moduleLoaderState_.moduleName = a2;
    else {
      var b = goog.global.$jscomp;
      if (!b || typeof b.getCurrentModulePath != "function")
        throw Error('Module with namespace "' + a2 + '" has been loaded incorrectly.');
      b = b.require(b.getCurrentModulePath());
      goog.loadedModules_[a2] = { exports: b, type: goog.ModuleType.ES6, moduleId: a2 };
    }
  };
  goog.setTestOnly = function(a2) {
    if (goog.DISALLOW_TEST_ONLY_CODE)
      throw a2 = a2 || "", Error("Importing test-only code into non-debug environment" + (a2 ? ": " + a2 : "."));
  };
  goog.forwardDeclare = function(a2) {
  };
  goog.getObjectByName = function(a2, b) {
    a2 = a2.split(".");
    b = b || goog.global;
    for (var c = 0; c < a2.length; c++)
      if (b = b[a2[c]], !goog.isDefAndNotNull(b))
        return null;
    return b;
  };
  goog.globalize = function(a2, b) {
    b = b || goog.global;
    for (var c in a2)
      b[c] = a2[c];
  };
  goog.addDependency = function(a2, b, c, d) {
  };
  goog.ENABLE_DEBUG_LOADER = true;
  goog.logToConsole_ = function(a2) {
    goog.global.console && goog.global.console.error(a2);
  };
  goog.require = function(a2) {
  };
  goog.requireType = function(a2) {
    return {};
  };
  goog.basePath = "";
  goog.nullFunction = function() {
  };
  goog.abstractMethod = function() {
    throw Error("unimplemented abstract method");
  };
  goog.addSingletonGetter = function(a2) {
    a2.instance_ = void 0;
    a2.getInstance = function() {
      if (a2.instance_)
        return a2.instance_;
      goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a2);
      return a2.instance_ = new a2();
    };
  };
  goog.instantiatedSingletons_ = [];
  goog.LOAD_MODULE_USING_EVAL = true;
  goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
  goog.loadedModules_ = {};
  goog.DEPENDENCIES_ENABLED = !COMPILED;
  goog.TRANSPILE = "detect";
  goog.ASSUME_ES_MODULES_TRANSPILED = false;
  goog.TRANSPILE_TO_LANGUAGE = "";
  goog.TRANSPILER = "transpile.js";
  goog.hasBadLetScoping = null;
  goog.useSafari10Workaround = function() {
    if (goog.hasBadLetScoping == null) {
      try {
        var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
      } catch (b) {
        a = false;
      }
      goog.hasBadLetScoping = a;
    }
    return goog.hasBadLetScoping;
  };
  goog.workaroundSafari10EvalBug = function(a2) {
    return "(function(){" + a2 + "\n;})();\n";
  };
  goog.loadModule = function(a2) {
    var b = goog.moduleLoaderState_;
    try {
      goog.moduleLoaderState_ = { moduleName: "", declareLegacyNamespace: false, type: goog.ModuleType.GOOG };
      if (goog.isFunction(a2))
        var c = a2.call(void 0, {});
      else if (goog.isString(a2))
        goog.useSafari10Workaround() && (a2 = goog.workaroundSafari10EvalBug(a2)), c = goog.loadModuleFromSource_.call(void 0, a2);
      else
        throw Error("Invalid module definition");
      var d = goog.moduleLoaderState_.moduleName;
      if (goog.isString(d) && d)
        goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(d, c) : goog.SEAL_MODULE_EXPORTS && Object.seal && typeof c == "object" && c != null && Object.seal(c), goog.loadedModules_[d] = { exports: c, type: goog.ModuleType.GOOG, moduleId: goog.moduleLoaderState_.moduleName };
      else
        throw Error('Invalid module name "' + d + '"');
    } finally {
      goog.moduleLoaderState_ = b;
    }
  };
  goog.loadModuleFromSource_ = function(a) {
    eval(a);
    return {};
  };
  goog.normalizePath_ = function(a2) {
    a2 = a2.split("/");
    for (var b = 0; b < a2.length; )
      a2[b] == "." ? a2.splice(b, 1) : b && a2[b] == ".." && a2[b - 1] && a2[b - 1] != ".." ? a2.splice(--b, 2) : b++;
    return a2.join("/");
  };
  goog.loadFileSync_ = function(a2) {
    if (goog.global.CLOSURE_LOAD_FILE_SYNC)
      return goog.global.CLOSURE_LOAD_FILE_SYNC(a2);
    try {
      var b = new goog.global.XMLHttpRequest();
      b.open("get", a2, false);
      b.send();
      return b.status == 0 || b.status == 200 ? b.responseText : null;
    } catch (c) {
      return null;
    }
  };
  goog.transpile_ = function(a2, b, c) {
    var d = goog.global.$jscomp;
    d || (goog.global.$jscomp = d = {});
    var e = d.transpile;
    if (!e) {
      var f = goog.basePath + goog.TRANSPILER, g = goog.loadFileSync_(f);
      if (g) {
        (function() {
          (0, eval)(g + "\n//# sourceURL=" + f);
        }).call(goog.global);
        if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile)
          throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
        goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
        d = goog.global.$jscomp;
        e = d.transpile;
      }
    }
    e || (e = d.transpile = function(a3, b2) {
      goog.logToConsole_(b2 + " requires transpilation but no transpiler was found.");
      return a3;
    });
    return e(a2, b, c);
  };
  goog.typeOf = function(a2) {
    var b = typeof a2;
    if (b == "object")
      if (a2) {
        if (a2 instanceof Array)
          return "array";
        if (a2 instanceof Object)
          return b;
        var c = Object.prototype.toString.call(a2);
        if (c == "[object Window]")
          return "object";
        if (c == "[object Array]" || typeof a2.length == "number" && typeof a2.splice != "undefined" && typeof a2.propertyIsEnumerable != "undefined" && !a2.propertyIsEnumerable("splice"))
          return "array";
        if (c == "[object Function]" || typeof a2.call != "undefined" && typeof a2.propertyIsEnumerable != "undefined" && !a2.propertyIsEnumerable("call"))
          return "function";
      } else
        return "null";
    else if (b == "function" && typeof a2.call == "undefined")
      return "object";
    return b;
  };
  goog.isNull = function(a2) {
    return a2 === null;
  };
  goog.isDefAndNotNull = function(a2) {
    return a2 != null;
  };
  goog.isArray = function(a2) {
    return goog.typeOf(a2) == "array";
  };
  goog.isArrayLike = function(a2) {
    var b = goog.typeOf(a2);
    return b == "array" || b == "object" && typeof a2.length == "number";
  };
  goog.isDateLike = function(a2) {
    return goog.isObject(a2) && typeof a2.getFullYear == "function";
  };
  goog.isFunction = function(a2) {
    return goog.typeOf(a2) == "function";
  };
  goog.isObject = function(a2) {
    var b = typeof a2;
    return b == "object" && a2 != null || b == "function";
  };
  goog.getUid = function(a2) {
    return a2[goog.UID_PROPERTY_] || (a2[goog.UID_PROPERTY_] = ++goog.uidCounter_);
  };
  goog.hasUid = function(a2) {
    return !!a2[goog.UID_PROPERTY_];
  };
  goog.removeUid = function(a2) {
    a2 !== null && "removeAttribute" in a2 && a2.removeAttribute(goog.UID_PROPERTY_);
    try {
      delete a2[goog.UID_PROPERTY_];
    } catch (b) {
    }
  };
  goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0);
  goog.uidCounter_ = 0;
  goog.getHashCode = goog.getUid;
  goog.removeHashCode = goog.removeUid;
  goog.cloneObject = function(a2) {
    var b = goog.typeOf(a2);
    if (b == "object" || b == "array") {
      if (typeof a2.clone === "function")
        return a2.clone();
      b = b == "array" ? [] : {};
      for (var c in a2)
        b[c] = goog.cloneObject(a2[c]);
      return b;
    }
    return a2;
  };
  goog.bindNative_ = function(a2, b, c) {
    return a2.call.apply(a2.bind, arguments);
  };
  goog.bindJs_ = function(a2, b, c) {
    if (!a2)
      throw Error();
    if (2 < arguments.length) {
      var d = Array.prototype.slice.call(arguments, 2);
      return function() {
        var c2 = Array.prototype.slice.call(arguments);
        Array.prototype.unshift.apply(c2, d);
        return a2.apply(b, c2);
      };
    }
    return function() {
      return a2.apply(b, arguments);
    };
  };
  goog.bind = function(a2, b, c) {
    Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
    return goog.bind.apply(null, arguments);
  };
  goog.partial = function(a2, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
      var b2 = c.slice();
      b2.push.apply(b2, arguments);
      return a2.apply(this, b2);
    };
  };
  goog.mixin = function(a2, b) {
    for (var c in b)
      a2[c] = b[c];
  };
  goog.now = goog.TRUSTED_SITE && Date.now || function() {
    return +new Date();
  };
  goog.globalEval = function(a2) {
    if (goog.global.execScript)
      goog.global.execScript(a2, "JavaScript");
    else if (goog.global.eval) {
      if (goog.evalWorksForGlobals_ == null) {
        try {
          goog.global.eval("var _evalTest_ = 1;");
        } catch (d) {
        }
        if (typeof goog.global._evalTest_ != "undefined") {
          try {
            delete goog.global._evalTest_;
          } catch (d) {
          }
          goog.evalWorksForGlobals_ = true;
        } else
          goog.evalWorksForGlobals_ = false;
      }
      if (goog.evalWorksForGlobals_)
        goog.global.eval(a2);
      else {
        var b = goog.global.document, c = b.createElement("SCRIPT");
        c.type = "text/javascript";
        c.defer = false;
        c.appendChild(b.createTextNode(a2));
        b.head.appendChild(c);
        b.head.removeChild(c);
      }
    } else
      throw Error("goog.globalEval not available");
  };
  goog.evalWorksForGlobals_ = null;
  goog.getCssName = function(a2, b) {
    if (String(a2).charAt(0) == ".")
      throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a2);
    var c = function(a3) {
      return goog.cssNameMapping_[a3] || a3;
    }, d = function(a3) {
      a3 = a3.split("-");
      for (var b2 = [], d2 = 0; d2 < a3.length; d2++)
        b2.push(c(a3[d2]));
      return b2.join("-");
    };
    d = goog.cssNameMapping_ ? goog.cssNameMappingStyle_ == "BY_WHOLE" ? c : d : function(a3) {
      return a3;
    };
    a2 = b ? a2 + "-" + d(b) : d(a2);
    return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(a2) : a2;
  };
  goog.setCssNameMapping = function(a2, b) {
    goog.cssNameMapping_ = a2;
    goog.cssNameMappingStyle_ = b;
  };
  goog.getMsg = function(a2, b, c) {
    c && c.html && (a2 = a2.replace(/</g, "&lt;"));
    b && (a2 = a2.replace(/\{\$([^}]+)}/g, function(a3, c2) {
      return b != null && c2 in b ? b[c2] : a3;
    }));
    return a2;
  };
  goog.getMsgWithFallback = function(a2, b) {
    return a2;
  };
  goog.exportSymbol = function(a2, b, c) {
    goog.exportPath_(a2, b, c);
  };
  goog.exportProperty = function(a2, b, c) {
    a2[b] = c;
  };
  goog.inherits = function(a2, b) {
    function c() {
    }
    c.prototype = b.prototype;
    a2.superClass_ = b.prototype;
    a2.prototype = new c();
    a2.prototype.constructor = a2;
    a2.base = function(a3, c2, f) {
      for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++)
        d[e - 2] = arguments[e];
      return b.prototype[c2].apply(a3, d);
    };
  };
  goog.base = function(a2, b, c) {
    var d = arguments.callee.caller;
    if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !d)
      throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");
    if (typeof d.superClass_ !== "undefined") {
      for (var e = Array(arguments.length - 1), f = 1; f < arguments.length; f++)
        e[f - 1] = arguments[f];
      return d.superClass_.constructor.apply(a2, e);
    }
    if (typeof b != "string" && typeof b != "symbol")
      throw Error("method names provided to goog.base must be a string or a symbol");
    e = Array(arguments.length - 2);
    for (f = 2; f < arguments.length; f++)
      e[f - 2] = arguments[f];
    f = false;
    for (var g = a2.constructor.prototype; g; g = Object.getPrototypeOf(g))
      if (g[b] === d)
        f = true;
      else if (f)
        return g[b].apply(a2, e);
    if (a2[b] === d)
      return a2.constructor.prototype[b].apply(a2, e);
    throw Error("goog.base called from a method of one name to a method of a different name");
  };
  goog.scope = function(a2) {
    if (goog.isInModuleLoader_())
      throw Error("goog.scope is not supported within a module.");
    a2.call(goog.global);
  };
  goog.defineClass = function(a2, b) {
    var c = b.constructor, d = b.statics;
    c && c != Object.prototype.constructor || (c = function() {
      throw Error("cannot instantiate an interface (no constructor defined).");
    });
    c = goog.defineClass.createSealingConstructor_(c, a2);
    a2 && goog.inherits(c, a2);
    delete b.constructor;
    delete b.statics;
    goog.defineClass.applyProperties_(c.prototype, b);
    d != null && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
    return c;
  };
  goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
  goog.defineClass.createSealingConstructor_ = function(a2, b) {
    if (!goog.defineClass.SEAL_CLASS_INSTANCES)
      return a2;
    var c = !goog.defineClass.isUnsealable_(b), d = function() {
      var b2 = a2.apply(this, arguments) || this;
      b2[goog.UID_PROPERTY_] = b2[goog.UID_PROPERTY_];
      this.constructor === d && c && Object.seal instanceof Function && Object.seal(b2);
      return b2;
    };
    return d;
  };
  goog.defineClass.isUnsealable_ = function(a2) {
    return a2 && a2.prototype && a2.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
  };
  goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
  goog.defineClass.applyProperties_ = function(a2, b) {
    for (var c in b)
      Object.prototype.hasOwnProperty.call(b, c) && (a2[c] = b[c]);
    for (var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++)
      c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a2[c] = b[c]);
  };
  goog.tagUnsealableClass = function(a2) {
  };
  goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable";
  goog.TRUSTED_TYPES_POLICY_NAME = "";
  goog.identity_ = function(a2) {
    return a2;
  };
  goog.createTrustedTypesPolicy = function(a2) {
    var b = null;
    if (typeof TrustedTypes === "undefined" || !TrustedTypes.createPolicy)
      return b;
    try {
      b = TrustedTypes.createPolicy(a2, { createHTML: goog.identity_, createScript: goog.identity_, createScriptURL: goog.identity_, createURL: goog.identity_ });
    } catch (c) {
      goog.logToConsole_(c.message);
    }
    return b;
  };
  goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null;
  goog.object = {};
  goog.object.is = function(a2, b) {
    return a2 === b ? a2 !== 0 || 1 / a2 === 1 / b : a2 !== a2 && b !== b;
  };
  goog.object.forEach = function(a2, b, c) {
    for (var d in a2)
      b.call(c, a2[d], d, a2);
  };
  goog.object.filter = function(a2, b, c) {
    var d = {}, e;
    for (e in a2)
      b.call(c, a2[e], e, a2) && (d[e] = a2[e]);
    return d;
  };
  goog.object.map = function(a2, b, c) {
    var d = {}, e;
    for (e in a2)
      d[e] = b.call(c, a2[e], e, a2);
    return d;
  };
  goog.object.some = function(a2, b, c) {
    for (var d in a2)
      if (b.call(c, a2[d], d, a2))
        return true;
    return false;
  };
  goog.object.every = function(a2, b, c) {
    for (var d in a2)
      if (!b.call(c, a2[d], d, a2))
        return false;
    return true;
  };
  goog.object.getCount = function(a2) {
    var b = 0, c;
    for (c in a2)
      b++;
    return b;
  };
  goog.object.getAnyKey = function(a2) {
    for (var b in a2)
      return b;
  };
  goog.object.getAnyValue = function(a2) {
    for (var b in a2)
      return a2[b];
  };
  goog.object.contains = function(a2, b) {
    return goog.object.containsValue(a2, b);
  };
  goog.object.getValues = function(a2) {
    var b = [], c = 0, d;
    for (d in a2)
      b[c++] = a2[d];
    return b;
  };
  goog.object.getKeys = function(a2) {
    var b = [], c = 0, d;
    for (d in a2)
      b[c++] = d;
    return b;
  };
  goog.object.getValueByKeys = function(a2, b) {
    var c = goog.isArrayLike(b), d = c ? b : arguments;
    for (c = c ? 0 : 1; c < d.length; c++) {
      if (a2 == null)
        return;
      a2 = a2[d[c]];
    }
    return a2;
  };
  goog.object.containsKey = function(a2, b) {
    return a2 !== null && b in a2;
  };
  goog.object.containsValue = function(a2, b) {
    for (var c in a2)
      if (a2[c] == b)
        return true;
    return false;
  };
  goog.object.findKey = function(a2, b, c) {
    for (var d in a2)
      if (b.call(c, a2[d], d, a2))
        return d;
  };
  goog.object.findValue = function(a2, b, c) {
    return (b = goog.object.findKey(a2, b, c)) && a2[b];
  };
  goog.object.isEmpty = function(a2) {
    for (var b in a2)
      return false;
    return true;
  };
  goog.object.clear = function(a2) {
    for (var b in a2)
      delete a2[b];
  };
  goog.object.remove = function(a2, b) {
    var c;
    (c = b in a2) && delete a2[b];
    return c;
  };
  goog.object.add = function(a2, b, c) {
    if (a2 !== null && b in a2)
      throw Error('The object already contains the key "' + b + '"');
    goog.object.set(a2, b, c);
  };
  goog.object.get = function(a2, b, c) {
    return a2 !== null && b in a2 ? a2[b] : c;
  };
  goog.object.set = function(a2, b, c) {
    a2[b] = c;
  };
  goog.object.setIfUndefined = function(a2, b, c) {
    return b in a2 ? a2[b] : a2[b] = c;
  };
  goog.object.setWithReturnValueIfNotSet = function(a2, b, c) {
    if (b in a2)
      return a2[b];
    c = c();
    return a2[b] = c;
  };
  goog.object.equals = function(a2, b) {
    for (var c in a2)
      if (!(c in b) || a2[c] !== b[c])
        return false;
    for (var d in b)
      if (!(d in a2))
        return false;
    return true;
  };
  goog.object.clone = function(a2) {
    var b = {}, c;
    for (c in a2)
      b[c] = a2[c];
    return b;
  };
  goog.object.unsafeClone = function(a2) {
    var b = goog.typeOf(a2);
    if (b == "object" || b == "array") {
      if (goog.isFunction(a2.clone))
        return a2.clone();
      b = b == "array" ? [] : {};
      for (var c in a2)
        b[c] = goog.object.unsafeClone(a2[c]);
      return b;
    }
    return a2;
  };
  goog.object.transpose = function(a2) {
    var b = {}, c;
    for (c in a2)
      b[a2[c]] = c;
    return b;
  };
  goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
  goog.object.extend = function(a2, b) {
    for (var c, d, e = 1; e < arguments.length; e++) {
      d = arguments[e];
      for (c in d)
        a2[c] = d[c];
      for (var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++)
        c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a2[c] = d[c]);
    }
  };
  goog.object.create = function(a2) {
    var b = arguments.length;
    if (b == 1 && goog.isArray(arguments[0]))
      return goog.object.create.apply(null, arguments[0]);
    if (b % 2)
      throw Error("Uneven number of arguments");
    for (var c = {}, d = 0; d < b; d += 2)
      c[arguments[d]] = arguments[d + 1];
    return c;
  };
  goog.object.createSet = function(a2) {
    var b = arguments.length;
    if (b == 1 && goog.isArray(arguments[0]))
      return goog.object.createSet.apply(null, arguments[0]);
    for (var c = {}, d = 0; d < b; d++)
      c[arguments[d]] = true;
    return c;
  };
  goog.object.createImmutableView = function(a2) {
    var b = a2;
    Object.isFrozen && !Object.isFrozen(a2) && (b = Object.create(a2), Object.freeze(b));
    return b;
  };
  goog.object.isImmutableView = function(a2) {
    return !!Object.isFrozen && Object.isFrozen(a2);
  };
  goog.object.getAllPropertyNames = function(a2, b, c) {
    if (!a2)
      return [];
    if (!Object.getOwnPropertyNames || !Object.getPrototypeOf)
      return goog.object.getKeys(a2);
    for (var d = {}; a2 && (a2 !== Object.prototype || b) && (a2 !== Function.prototype || c); ) {
      for (var e = Object.getOwnPropertyNames(a2), f = 0; f < e.length; f++)
        d[e[f]] = true;
      a2 = Object.getPrototypeOf(a2);
    }
    return goog.object.getKeys(d);
  };
  goog.object.getSuperClass = function(a2) {
    return (a2 = Object.getPrototypeOf(a2.prototype)) && a2.constructor;
  };
  goog.debug = {};
  goog.debug.Error = function(a2) {
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, goog.debug.Error);
    else {
      var b = Error().stack;
      b && (this.stack = b);
    }
    a2 && (this.message = String(a2));
    this.reportErrorToServer = true;
  };
  goog.inherits(goog.debug.Error, Error);
  goog.debug.Error.prototype.name = "CustomError";
  goog.dom = {};
  goog.dom.NodeType = { ELEMENT: 1, ATTRIBUTE: 2, TEXT: 3, CDATA_SECTION: 4, ENTITY_REFERENCE: 5, ENTITY: 6, PROCESSING_INSTRUCTION: 7, COMMENT: 8, DOCUMENT: 9, DOCUMENT_TYPE: 10, DOCUMENT_FRAGMENT: 11, NOTATION: 12 };
  goog.asserts = {};
  goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
  goog.asserts.AssertionError = function(a2, b) {
    goog.debug.Error.call(this, goog.asserts.subs_(a2, b));
    this.messagePattern = a2;
  };
  goog.inherits(goog.asserts.AssertionError, goog.debug.Error);
  goog.asserts.AssertionError.prototype.name = "AssertionError";
  goog.asserts.DEFAULT_ERROR_HANDLER = function(a2) {
    throw a2;
  };
  goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
  goog.asserts.subs_ = function(a2, b) {
    a2 = a2.split("%s");
    for (var c = "", d = a2.length - 1, e = 0; e < d; e++)
      c += a2[e] + (e < b.length ? b[e] : "%s");
    return c + a2[d];
  };
  goog.asserts.doAssertFailure_ = function(a2, b, c, d) {
    var e = "Assertion failed";
    if (c) {
      e += ": " + c;
      var f = d;
    } else
      a2 && (e += ": " + a2, f = b);
    a2 = new goog.asserts.AssertionError("" + e, f || []);
    goog.asserts.errorHandler_(a2);
  };
  goog.asserts.setErrorHandler = function(a2) {
    goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a2);
  };
  goog.asserts.assert = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !a2 && goog.asserts.doAssertFailure_("", null, b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertExists = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && a2 == null && goog.asserts.doAssertFailure_("Expected to exist: %s.", [a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.fail = function(a2, b) {
    goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a2 ? ": " + a2 : ""), Array.prototype.slice.call(arguments, 1)));
  };
  goog.asserts.assertNumber = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isNumber(a2) && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertString = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isString(a2) && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertFunction = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isFunction(a2) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertObject = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isObject(a2) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertArray = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isArray(a2) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertBoolean = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isBoolean(a2) && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertElement = function(a2, b, c) {
    !goog.asserts.ENABLE_ASSERTS || goog.isObject(a2) && a2.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertInstanceof = function(a2, b, c, d) {
    !goog.asserts.ENABLE_ASSERTS || a2 instanceof b || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(b), goog.asserts.getType_(a2)], c, Array.prototype.slice.call(arguments, 3));
    return a2;
  };
  goog.asserts.assertFinite = function(a2, b, c) {
    !goog.asserts.ENABLE_ASSERTS || typeof a2 == "number" && isFinite(a2) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertObjectPrototypeIsIntact = function() {
    for (var a2 in Object.prototype)
      goog.asserts.fail(a2 + " should not be enumerable in Object.prototype.");
  };
  goog.asserts.getType_ = function(a2) {
    return a2 instanceof Function ? a2.displayName || a2.name || "unknown type name" : a2 instanceof Object ? a2.constructor.displayName || a2.constructor.name || Object.prototype.toString.call(a2) : a2 === null ? "null" : typeof a2;
  };
  var jspb = { BinaryConstants: {}, ConstBinaryMessage: function() {
  }, BinaryMessage: function() {
  } };
  jspb.BinaryConstants.FieldType = { INVALID: -1, DOUBLE: 1, FLOAT: 2, INT64: 3, UINT64: 4, INT32: 5, FIXED64: 6, FIXED32: 7, BOOL: 8, STRING: 9, GROUP: 10, MESSAGE: 11, BYTES: 12, UINT32: 13, ENUM: 14, SFIXED32: 15, SFIXED64: 16, SINT32: 17, SINT64: 18, FHASH64: 30, VHASH64: 31 };
  jspb.BinaryConstants.WireType = { INVALID: -1, VARINT: 0, FIXED64: 1, DELIMITED: 2, START_GROUP: 3, END_GROUP: 4, FIXED32: 5 };
  jspb.BinaryConstants.FieldTypeToWireType = function(a2) {
    var b = jspb.BinaryConstants.FieldType, c = jspb.BinaryConstants.WireType;
    switch (a2) {
      case b.INT32:
      case b.INT64:
      case b.UINT32:
      case b.UINT64:
      case b.SINT32:
      case b.SINT64:
      case b.BOOL:
      case b.ENUM:
      case b.VHASH64:
        return c.VARINT;
      case b.DOUBLE:
      case b.FIXED64:
      case b.SFIXED64:
      case b.FHASH64:
        return c.FIXED64;
      case b.STRING:
      case b.MESSAGE:
      case b.BYTES:
        return c.DELIMITED;
      case b.FLOAT:
      case b.FIXED32:
      case b.SFIXED32:
        return c.FIXED32;
      default:
        return c.INVALID;
    }
  };
  jspb.BinaryConstants.INVALID_FIELD_NUMBER = -1;
  jspb.BinaryConstants.FLOAT32_EPS = 1401298464324817e-60;
  jspb.BinaryConstants.FLOAT32_MIN = 11754943508222875e-54;
  jspb.BinaryConstants.FLOAT32_MAX = 34028234663852886e22;
  jspb.BinaryConstants.FLOAT64_EPS = 5e-324;
  jspb.BinaryConstants.FLOAT64_MIN = 22250738585072014e-324;
  jspb.BinaryConstants.FLOAT64_MAX = 17976931348623157e292;
  jspb.BinaryConstants.TWO_TO_20 = 1048576;
  jspb.BinaryConstants.TWO_TO_23 = 8388608;
  jspb.BinaryConstants.TWO_TO_31 = 2147483648;
  jspb.BinaryConstants.TWO_TO_32 = 4294967296;
  jspb.BinaryConstants.TWO_TO_52 = 4503599627370496;
  jspb.BinaryConstants.TWO_TO_63 = 9223372036854776e3;
  jspb.BinaryConstants.TWO_TO_64 = 18446744073709552e3;
  jspb.BinaryConstants.ZERO_HASH = "\0\0\0\0\0\0\0\0";
  goog.array = {};
  goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
  goog.array.ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
  goog.array.peek = function(a2) {
    return a2[a2.length - 1];
  };
  goog.array.last = goog.array.peek;
  goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.indexOf.call(a2, b, c);
  } : function(a2, b, c) {
    c = c == null ? 0 : 0 > c ? Math.max(0, a2.length + c) : c;
    if (goog.isString(a2))
      return goog.isString(b) && b.length == 1 ? a2.indexOf(b, c) : -1;
    for (; c < a2.length; c++)
      if (c in a2 && a2[c] === b)
        return c;
    return -1;
  };
  goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.lastIndexOf.call(a2, b, c == null ? a2.length - 1 : c);
  } : function(a2, b, c) {
    c = c == null ? a2.length - 1 : c;
    0 > c && (c = Math.max(0, a2.length + c));
    if (goog.isString(a2))
      return goog.isString(b) && b.length == 1 ? a2.lastIndexOf(b, c) : -1;
    for (; 0 <= c; c--)
      if (c in a2 && a2[c] === b)
        return c;
    return -1;
  };
  goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    Array.prototype.forEach.call(a2, b, c);
  } : function(a2, b, c) {
    for (var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2, f = 0; f < d; f++)
      f in e && b.call(c, e[f], f, a2);
  };
  goog.array.forEachRight = function(a2, b, c) {
    var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2;
    for (--d; 0 <= d; --d)
      d in e && b.call(c, e[d], d, a2);
  };
  goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.filter.call(a2, b, c);
  } : function(a2, b, c) {
    for (var d = a2.length, e = [], f = 0, g = goog.isString(a2) ? a2.split("") : a2, h = 0; h < d; h++)
      if (h in g) {
        var k = g[h];
        b.call(c, k, h, a2) && (e[f++] = k);
      }
    return e;
  };
  goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.map.call(a2, b, c);
  } : function(a2, b, c) {
    for (var d = a2.length, e = Array(d), f = goog.isString(a2) ? a2.split("") : a2, g = 0; g < d; g++)
      g in f && (e[g] = b.call(c, f[g], g, a2));
    return e;
  };
  goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a2, b, c, d) {
    goog.asserts.assert(a2.length != null);
    d && (b = goog.bind(b, d));
    return Array.prototype.reduce.call(a2, b, c);
  } : function(a2, b, c, d) {
    var e = c;
    goog.array.forEach(a2, function(c2, g) {
      e = b.call(d, e, c2, g, a2);
    });
    return e;
  };
  goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a2, b, c, d) {
    goog.asserts.assert(a2.length != null);
    goog.asserts.assert(b != null);
    d && (b = goog.bind(b, d));
    return Array.prototype.reduceRight.call(a2, b, c);
  } : function(a2, b, c, d) {
    var e = c;
    goog.array.forEachRight(a2, function(c2, g) {
      e = b.call(d, e, c2, g, a2);
    });
    return e;
  };
  goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.some.call(a2, b, c);
  } : function(a2, b, c) {
    for (var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2, f = 0; f < d; f++)
      if (f in e && b.call(c, e[f], f, a2))
        return true;
    return false;
  };
  goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.every.call(a2, b, c);
  } : function(a2, b, c) {
    for (var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2, f = 0; f < d; f++)
      if (f in e && !b.call(c, e[f], f, a2))
        return false;
    return true;
  };
  goog.array.count = function(a2, b, c) {
    var d = 0;
    goog.array.forEach(a2, function(a3, f, g) {
      b.call(c, a3, f, g) && ++d;
    }, c);
    return d;
  };
  goog.array.find = function(a2, b, c) {
    b = goog.array.findIndex(a2, b, c);
    return 0 > b ? null : goog.isString(a2) ? a2.charAt(b) : a2[b];
  };
  goog.array.findIndex = function(a2, b, c) {
    for (var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2, f = 0; f < d; f++)
      if (f in e && b.call(c, e[f], f, a2))
        return f;
    return -1;
  };
  goog.array.findRight = function(a2, b, c) {
    b = goog.array.findIndexRight(a2, b, c);
    return 0 > b ? null : goog.isString(a2) ? a2.charAt(b) : a2[b];
  };
  goog.array.findIndexRight = function(a2, b, c) {
    var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2;
    for (--d; 0 <= d; d--)
      if (d in e && b.call(c, e[d], d, a2))
        return d;
    return -1;
  };
  goog.array.contains = function(a2, b) {
    return 0 <= goog.array.indexOf(a2, b);
  };
  goog.array.isEmpty = function(a2) {
    return a2.length == 0;
  };
  goog.array.clear = function(a2) {
    if (!goog.isArray(a2))
      for (var b = a2.length - 1; 0 <= b; b--)
        delete a2[b];
    a2.length = 0;
  };
  goog.array.insert = function(a2, b) {
    goog.array.contains(a2, b) || a2.push(b);
  };
  goog.array.insertAt = function(a2, b, c) {
    goog.array.splice(a2, c, 0, b);
  };
  goog.array.insertArrayAt = function(a2, b, c) {
    goog.partial(goog.array.splice, a2, c, 0).apply(null, b);
  };
  goog.array.insertBefore = function(a2, b, c) {
    var d;
    arguments.length == 2 || 0 > (d = goog.array.indexOf(a2, c)) ? a2.push(b) : goog.array.insertAt(a2, b, d);
  };
  goog.array.remove = function(a2, b) {
    b = goog.array.indexOf(a2, b);
    var c;
    (c = 0 <= b) && goog.array.removeAt(a2, b);
    return c;
  };
  goog.array.removeLast = function(a2, b) {
    b = goog.array.lastIndexOf(a2, b);
    return 0 <= b ? (goog.array.removeAt(a2, b), true) : false;
  };
  goog.array.removeAt = function(a2, b) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.splice.call(a2, b, 1).length == 1;
  };
  goog.array.removeIf = function(a2, b, c) {
    b = goog.array.findIndex(a2, b, c);
    return 0 <= b ? (goog.array.removeAt(a2, b), true) : false;
  };
  goog.array.removeAllIf = function(a2, b, c) {
    var d = 0;
    goog.array.forEachRight(a2, function(e, f) {
      b.call(c, e, f, a2) && goog.array.removeAt(a2, f) && d++;
    });
    return d;
  };
  goog.array.concat = function(a2) {
    return Array.prototype.concat.apply([], arguments);
  };
  goog.array.join = function(a2) {
    return Array.prototype.concat.apply([], arguments);
  };
  goog.array.toArray = function(a2) {
    var b = a2.length;
    if (0 < b) {
      for (var c = Array(b), d = 0; d < b; d++)
        c[d] = a2[d];
      return c;
    }
    return [];
  };
  goog.array.clone = goog.array.toArray;
  goog.array.extend = function(a2, b) {
    for (var c = 1; c < arguments.length; c++) {
      var d = arguments[c];
      if (goog.isArrayLike(d)) {
        var e = a2.length || 0, f = d.length || 0;
        a2.length = e + f;
        for (var g = 0; g < f; g++)
          a2[e + g] = d[g];
      } else
        a2.push(d);
    }
  };
  goog.array.splice = function(a2, b, c, d) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.splice.apply(a2, goog.array.slice(arguments, 1));
  };
  goog.array.slice = function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return 2 >= arguments.length ? Array.prototype.slice.call(a2, b) : Array.prototype.slice.call(a2, b, c);
  };
  goog.array.removeDuplicates = function(a2, b, c) {
    b = b || a2;
    var d = function(a3) {
      return goog.isObject(a3) ? "o" + goog.getUid(a3) : (typeof a3).charAt(0) + a3;
    };
    c = c || d;
    d = {};
    for (var e = 0, f = 0; f < a2.length; ) {
      var g = a2[f++], h = c(g);
      Object.prototype.hasOwnProperty.call(d, h) || (d[h] = true, b[e++] = g);
    }
    b.length = e;
  };
  goog.array.binarySearch = function(a2, b, c) {
    return goog.array.binarySearch_(a2, c || goog.array.defaultCompare, false, b);
  };
  goog.array.binarySelect = function(a2, b, c) {
    return goog.array.binarySearch_(a2, b, true, void 0, c);
  };
  goog.array.binarySearch_ = function(a2, b, c, d, e) {
    for (var f = 0, g = a2.length, h; f < g; ) {
      var k = f + g >> 1;
      var l = c ? b.call(e, a2[k], k, a2) : b(d, a2[k]);
      0 < l ? f = k + 1 : (g = k, h = !l);
    }
    return h ? f : ~f;
  };
  goog.array.sort = function(a2, b) {
    a2.sort(b || goog.array.defaultCompare);
  };
  goog.array.stableSort = function(a2, b) {
    for (var c = Array(a2.length), d = 0; d < a2.length; d++)
      c[d] = { index: d, value: a2[d] };
    var e = b || goog.array.defaultCompare;
    goog.array.sort(c, function(a3, b2) {
      return e(a3.value, b2.value) || a3.index - b2.index;
    });
    for (d = 0; d < a2.length; d++)
      a2[d] = c[d].value;
  };
  goog.array.sortByKey = function(a2, b, c) {
    var d = c || goog.array.defaultCompare;
    goog.array.sort(a2, function(a3, c2) {
      return d(b(a3), b(c2));
    });
  };
  goog.array.sortObjectsByKey = function(a2, b, c) {
    goog.array.sortByKey(a2, function(a3) {
      return a3[b];
    }, c);
  };
  goog.array.isSorted = function(a2, b, c) {
    b = b || goog.array.defaultCompare;
    for (var d = 1; d < a2.length; d++) {
      var e = b(a2[d - 1], a2[d]);
      if (0 < e || e == 0 && c)
        return false;
    }
    return true;
  };
  goog.array.equals = function(a2, b, c) {
    if (!goog.isArrayLike(a2) || !goog.isArrayLike(b) || a2.length != b.length)
      return false;
    var d = a2.length;
    c = c || goog.array.defaultCompareEquality;
    for (var e = 0; e < d; e++)
      if (!c(a2[e], b[e]))
        return false;
    return true;
  };
  goog.array.compare3 = function(a2, b, c) {
    c = c || goog.array.defaultCompare;
    for (var d = Math.min(a2.length, b.length), e = 0; e < d; e++) {
      var f = c(a2[e], b[e]);
      if (f != 0)
        return f;
    }
    return goog.array.defaultCompare(a2.length, b.length);
  };
  goog.array.defaultCompare = function(a2, b) {
    return a2 > b ? 1 : a2 < b ? -1 : 0;
  };
  goog.array.inverseDefaultCompare = function(a2, b) {
    return -goog.array.defaultCompare(a2, b);
  };
  goog.array.defaultCompareEquality = function(a2, b) {
    return a2 === b;
  };
  goog.array.binaryInsert = function(a2, b, c) {
    c = goog.array.binarySearch(a2, b, c);
    return 0 > c ? (goog.array.insertAt(a2, b, -(c + 1)), true) : false;
  };
  goog.array.binaryRemove = function(a2, b, c) {
    b = goog.array.binarySearch(a2, b, c);
    return 0 <= b ? goog.array.removeAt(a2, b) : false;
  };
  goog.array.bucket = function(a2, b, c) {
    for (var d = {}, e = 0; e < a2.length; e++) {
      var f = a2[e], g = b.call(c, f, e, a2);
      goog.isDef(g) && (d[g] || (d[g] = [])).push(f);
    }
    return d;
  };
  goog.array.toObject = function(a2, b, c) {
    var d = {};
    goog.array.forEach(a2, function(e, f) {
      d[b.call(c, e, f, a2)] = e;
    });
    return d;
  };
  goog.array.range = function(a2, b, c) {
    var d = [], e = 0, f = a2;
    c = c || 1;
    b !== void 0 && (e = a2, f = b);
    if (0 > c * (f - e))
      return [];
    if (0 < c)
      for (a2 = e; a2 < f; a2 += c)
        d.push(a2);
    else
      for (a2 = e; a2 > f; a2 += c)
        d.push(a2);
    return d;
  };
  goog.array.repeat = function(a2, b) {
    for (var c = [], d = 0; d < b; d++)
      c[d] = a2;
    return c;
  };
  goog.array.flatten = function(a2) {
    for (var b = [], c = 0; c < arguments.length; c++) {
      var d = arguments[c];
      if (goog.isArray(d))
        for (var e = 0; e < d.length; e += 8192) {
          var f = goog.array.slice(d, e, e + 8192);
          f = goog.array.flatten.apply(null, f);
          for (var g = 0; g < f.length; g++)
            b.push(f[g]);
        }
      else
        b.push(d);
    }
    return b;
  };
  goog.array.rotate = function(a2, b) {
    goog.asserts.assert(a2.length != null);
    a2.length && (b %= a2.length, 0 < b ? Array.prototype.unshift.apply(a2, a2.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a2, a2.splice(0, -b)));
    return a2;
  };
  goog.array.moveItem = function(a2, b, c) {
    goog.asserts.assert(0 <= b && b < a2.length);
    goog.asserts.assert(0 <= c && c < a2.length);
    b = Array.prototype.splice.call(a2, b, 1);
    Array.prototype.splice.call(a2, c, 0, b[0]);
  };
  goog.array.zip = function(a2) {
    if (!arguments.length)
      return [];
    for (var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++)
      arguments[d].length < c && (c = arguments[d].length);
    for (d = 0; d < c; d++) {
      for (var e = [], f = 0; f < arguments.length; f++)
        e.push(arguments[f][d]);
      b.push(e);
    }
    return b;
  };
  goog.array.shuffle = function(a2, b) {
    b = b || Math.random;
    for (var c = a2.length - 1; 0 < c; c--) {
      var d = Math.floor(b() * (c + 1)), e = a2[c];
      a2[c] = a2[d];
      a2[d] = e;
    }
  };
  goog.array.copyByIndex = function(a2, b) {
    var c = [];
    goog.array.forEach(b, function(b2) {
      c.push(a2[b2]);
    });
    return c;
  };
  goog.array.concatMap = function(a2, b, c) {
    return goog.array.concat.apply([], goog.array.map(a2, b, c));
  };
  goog.crypt = {};
  goog.crypt.stringToByteArray = function(a2) {
    for (var b = [], c = 0, d = 0; d < a2.length; d++) {
      var e = a2.charCodeAt(d);
      255 < e && (b[c++] = e & 255, e >>= 8);
      b[c++] = e;
    }
    return b;
  };
  goog.crypt.byteArrayToString = function(a2) {
    if (8192 >= a2.length)
      return String.fromCharCode.apply(null, a2);
    for (var b = "", c = 0; c < a2.length; c += 8192) {
      var d = goog.array.slice(a2, c, c + 8192);
      b += String.fromCharCode.apply(null, d);
    }
    return b;
  };
  goog.crypt.byteArrayToHex = function(a2, b) {
    return goog.array.map(a2, function(a3) {
      a3 = a3.toString(16);
      return 1 < a3.length ? a3 : "0" + a3;
    }).join(b || "");
  };
  goog.crypt.hexToByteArray = function(a2) {
    goog.asserts.assert(a2.length % 2 == 0, "Key string length must be multiple of 2");
    for (var b = [], c = 0; c < a2.length; c += 2)
      b.push(parseInt(a2.substring(c, c + 2), 16));
    return b;
  };
  goog.crypt.stringToUtf8ByteArray = function(a2) {
    for (var b = [], c = 0, d = 0; d < a2.length; d++) {
      var e = a2.charCodeAt(d);
      128 > e ? b[c++] = e : (2048 > e ? b[c++] = e >> 6 | 192 : ((e & 64512) == 55296 && d + 1 < a2.length && (a2.charCodeAt(d + 1) & 64512) == 56320 ? (e = 65536 + ((e & 1023) << 10) + (a2.charCodeAt(++d) & 1023), b[c++] = e >> 18 | 240, b[c++] = e >> 12 & 63 | 128) : b[c++] = e >> 12 | 224, b[c++] = e >> 6 & 63 | 128), b[c++] = e & 63 | 128);
    }
    return b;
  };
  goog.crypt.utf8ByteArrayToString = function(a2) {
    for (var b = [], c = 0, d = 0; c < a2.length; ) {
      var e = a2[c++];
      if (128 > e)
        b[d++] = String.fromCharCode(e);
      else if (191 < e && 224 > e) {
        var f = a2[c++];
        b[d++] = String.fromCharCode((e & 31) << 6 | f & 63);
      } else if (239 < e && 365 > e) {
        f = a2[c++];
        var g = a2[c++], h = a2[c++];
        e = ((e & 7) << 18 | (f & 63) << 12 | (g & 63) << 6 | h & 63) - 65536;
        b[d++] = String.fromCharCode(55296 + (e >> 10));
        b[d++] = String.fromCharCode(56320 + (e & 1023));
      } else
        f = a2[c++], g = a2[c++], b[d++] = String.fromCharCode((e & 15) << 12 | (f & 63) << 6 | g & 63);
    }
    return b.join("");
  };
  goog.crypt.xorByteArray = function(a2, b) {
    goog.asserts.assert(a2.length == b.length, "XOR array lengths must match");
    for (var c = [], d = 0; d < a2.length; d++)
      c.push(a2[d] ^ b[d]);
    return c;
  };
  goog.dom.asserts = {};
  goog.dom.asserts.assertIsLocation = function(a2) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var b = goog.dom.asserts.getWindow_(a2);
      b && (!a2 || !(a2 instanceof b.Location) && a2 instanceof b.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(a2));
    }
    return a2;
  };
  goog.dom.asserts.assertIsElementType_ = function(a2, b) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var c = goog.dom.asserts.getWindow_(a2);
      c && typeof c[b] != "undefined" && (a2 && (a2 instanceof c[b] || !(a2 instanceof c.Location || a2 instanceof c.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, goog.dom.asserts.debugStringForType_(a2)));
    }
    return a2;
  };
  goog.dom.asserts.assertIsHTMLAnchorElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLAnchorElement");
  };
  goog.dom.asserts.assertIsHTMLButtonElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLButtonElement");
  };
  goog.dom.asserts.assertIsHTMLLinkElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLLinkElement");
  };
  goog.dom.asserts.assertIsHTMLImageElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLImageElement");
  };
  goog.dom.asserts.assertIsHTMLAudioElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLAudioElement");
  };
  goog.dom.asserts.assertIsHTMLVideoElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLVideoElement");
  };
  goog.dom.asserts.assertIsHTMLInputElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLInputElement");
  };
  goog.dom.asserts.assertIsHTMLTextAreaElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLTextAreaElement");
  };
  goog.dom.asserts.assertIsHTMLCanvasElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLCanvasElement");
  };
  goog.dom.asserts.assertIsHTMLEmbedElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLEmbedElement");
  };
  goog.dom.asserts.assertIsHTMLFormElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLFormElement");
  };
  goog.dom.asserts.assertIsHTMLFrameElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLFrameElement");
  };
  goog.dom.asserts.assertIsHTMLIFrameElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLIFrameElement");
  };
  goog.dom.asserts.assertIsHTMLObjectElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLObjectElement");
  };
  goog.dom.asserts.assertIsHTMLScriptElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLScriptElement");
  };
  goog.dom.asserts.debugStringForType_ = function(a2) {
    if (goog.isObject(a2))
      try {
        return a2.constructor.displayName || a2.constructor.name || Object.prototype.toString.call(a2);
      } catch (b) {
        return "<object could not be stringified>";
      }
    else
      return a2 === void 0 ? "undefined" : a2 === null ? "null" : typeof a2;
  };
  goog.dom.asserts.getWindow_ = function(a2) {
    try {
      var b = a2 && a2.ownerDocument, c = b && (b.defaultView || b.parentWindow);
      c = c || goog.global;
      if (c.Element && c.Location)
        return c;
    } catch (d) {
    }
    return null;
  };
  goog.functions = {};
  goog.functions.constant = function(a2) {
    return function() {
      return a2;
    };
  };
  goog.functions.FALSE = function() {
    return false;
  };
  goog.functions.TRUE = function() {
    return true;
  };
  goog.functions.NULL = function() {
    return null;
  };
  goog.functions.identity = function(a2, b) {
    return a2;
  };
  goog.functions.error = function(a2) {
    return function() {
      throw Error(a2);
    };
  };
  goog.functions.fail = function(a2) {
    return function() {
      throw a2;
    };
  };
  goog.functions.lock = function(a2, b) {
    b = b || 0;
    return function() {
      return a2.apply(this, Array.prototype.slice.call(arguments, 0, b));
    };
  };
  goog.functions.nth = function(a2) {
    return function() {
      return arguments[a2];
    };
  };
  goog.functions.partialRight = function(a2, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
      var b2 = Array.prototype.slice.call(arguments);
      b2.push.apply(b2, c);
      return a2.apply(this, b2);
    };
  };
  goog.functions.withReturnValue = function(a2, b) {
    return goog.functions.sequence(a2, goog.functions.constant(b));
  };
  goog.functions.equalTo = function(a2, b) {
    return function(c) {
      return b ? a2 == c : a2 === c;
    };
  };
  goog.functions.compose = function(a2, b) {
    var c = arguments, d = c.length;
    return function() {
      var a3;
      d && (a3 = c[d - 1].apply(this, arguments));
      for (var b2 = d - 2; 0 <= b2; b2--)
        a3 = c[b2].call(this, a3);
      return a3;
    };
  };
  goog.functions.sequence = function(a2) {
    var b = arguments, c = b.length;
    return function() {
      for (var a3, e = 0; e < c; e++)
        a3 = b[e].apply(this, arguments);
      return a3;
    };
  };
  goog.functions.and = function(a2) {
    var b = arguments, c = b.length;
    return function() {
      for (var a3 = 0; a3 < c; a3++)
        if (!b[a3].apply(this, arguments))
          return false;
      return true;
    };
  };
  goog.functions.or = function(a2) {
    var b = arguments, c = b.length;
    return function() {
      for (var a3 = 0; a3 < c; a3++)
        if (b[a3].apply(this, arguments))
          return true;
      return false;
    };
  };
  goog.functions.not = function(a2) {
    return function() {
      return !a2.apply(this, arguments);
    };
  };
  goog.functions.create = function(a2, b) {
    var c = function() {
    };
    c.prototype = a2.prototype;
    c = new c();
    a2.apply(c, Array.prototype.slice.call(arguments, 1));
    return c;
  };
  goog.functions.CACHE_RETURN_VALUE = true;
  goog.functions.cacheReturnValue = function(a2) {
    var b = false, c;
    return function() {
      if (!goog.functions.CACHE_RETURN_VALUE)
        return a2();
      b || (c = a2(), b = true);
      return c;
    };
  };
  goog.functions.once = function(a2) {
    var b = a2;
    return function() {
      if (b) {
        var a3 = b;
        b = null;
        a3();
      }
    };
  };
  goog.functions.debounce = function(a2, b, c) {
    var d = 0;
    return function(e) {
      goog.global.clearTimeout(d);
      var f = arguments;
      d = goog.global.setTimeout(function() {
        a2.apply(c, f);
      }, b);
    };
  };
  goog.functions.throttle = function(a2, b, c) {
    var d = 0, e = false, f = [], g = function() {
      d = 0;
      e && (e = false, h());
    }, h = function() {
      d = goog.global.setTimeout(g, b);
      a2.apply(c, f);
    };
    return function(a3) {
      f = arguments;
      d ? e = true : h();
    };
  };
  goog.functions.rateLimit = function(a2, b, c) {
    var d = 0, e = function() {
      d = 0;
    };
    return function(f) {
      d || (d = goog.global.setTimeout(e, b), a2.apply(c, arguments));
    };
  };
  goog.dom.HtmlElement = function() {
  };
  goog.dom.TagName = function(a2) {
    this.tagName_ = a2;
  };
  goog.dom.TagName.prototype.toString = function() {
    return this.tagName_;
  };
  goog.dom.TagName.A = new goog.dom.TagName("A");
  goog.dom.TagName.ABBR = new goog.dom.TagName("ABBR");
  goog.dom.TagName.ACRONYM = new goog.dom.TagName("ACRONYM");
  goog.dom.TagName.ADDRESS = new goog.dom.TagName("ADDRESS");
  goog.dom.TagName.APPLET = new goog.dom.TagName("APPLET");
  goog.dom.TagName.AREA = new goog.dom.TagName("AREA");
  goog.dom.TagName.ARTICLE = new goog.dom.TagName("ARTICLE");
  goog.dom.TagName.ASIDE = new goog.dom.TagName("ASIDE");
  goog.dom.TagName.AUDIO = new goog.dom.TagName("AUDIO");
  goog.dom.TagName.B = new goog.dom.TagName("B");
  goog.dom.TagName.BASE = new goog.dom.TagName("BASE");
  goog.dom.TagName.BASEFONT = new goog.dom.TagName("BASEFONT");
  goog.dom.TagName.BDI = new goog.dom.TagName("BDI");
  goog.dom.TagName.BDO = new goog.dom.TagName("BDO");
  goog.dom.TagName.BIG = new goog.dom.TagName("BIG");
  goog.dom.TagName.BLOCKQUOTE = new goog.dom.TagName("BLOCKQUOTE");
  goog.dom.TagName.BODY = new goog.dom.TagName("BODY");
  goog.dom.TagName.BR = new goog.dom.TagName("BR");
  goog.dom.TagName.BUTTON = new goog.dom.TagName("BUTTON");
  goog.dom.TagName.CANVAS = new goog.dom.TagName("CANVAS");
  goog.dom.TagName.CAPTION = new goog.dom.TagName("CAPTION");
  goog.dom.TagName.CENTER = new goog.dom.TagName("CENTER");
  goog.dom.TagName.CITE = new goog.dom.TagName("CITE");
  goog.dom.TagName.CODE = new goog.dom.TagName("CODE");
  goog.dom.TagName.COL = new goog.dom.TagName("COL");
  goog.dom.TagName.COLGROUP = new goog.dom.TagName("COLGROUP");
  goog.dom.TagName.COMMAND = new goog.dom.TagName("COMMAND");
  goog.dom.TagName.DATA = new goog.dom.TagName("DATA");
  goog.dom.TagName.DATALIST = new goog.dom.TagName("DATALIST");
  goog.dom.TagName.DD = new goog.dom.TagName("DD");
  goog.dom.TagName.DEL = new goog.dom.TagName("DEL");
  goog.dom.TagName.DETAILS = new goog.dom.TagName("DETAILS");
  goog.dom.TagName.DFN = new goog.dom.TagName("DFN");
  goog.dom.TagName.DIALOG = new goog.dom.TagName("DIALOG");
  goog.dom.TagName.DIR = new goog.dom.TagName("DIR");
  goog.dom.TagName.DIV = new goog.dom.TagName("DIV");
  goog.dom.TagName.DL = new goog.dom.TagName("DL");
  goog.dom.TagName.DT = new goog.dom.TagName("DT");
  goog.dom.TagName.EM = new goog.dom.TagName("EM");
  goog.dom.TagName.EMBED = new goog.dom.TagName("EMBED");
  goog.dom.TagName.FIELDSET = new goog.dom.TagName("FIELDSET");
  goog.dom.TagName.FIGCAPTION = new goog.dom.TagName("FIGCAPTION");
  goog.dom.TagName.FIGURE = new goog.dom.TagName("FIGURE");
  goog.dom.TagName.FONT = new goog.dom.TagName("FONT");
  goog.dom.TagName.FOOTER = new goog.dom.TagName("FOOTER");
  goog.dom.TagName.FORM = new goog.dom.TagName("FORM");
  goog.dom.TagName.FRAME = new goog.dom.TagName("FRAME");
  goog.dom.TagName.FRAMESET = new goog.dom.TagName("FRAMESET");
  goog.dom.TagName.H1 = new goog.dom.TagName("H1");
  goog.dom.TagName.H2 = new goog.dom.TagName("H2");
  goog.dom.TagName.H3 = new goog.dom.TagName("H3");
  goog.dom.TagName.H4 = new goog.dom.TagName("H4");
  goog.dom.TagName.H5 = new goog.dom.TagName("H5");
  goog.dom.TagName.H6 = new goog.dom.TagName("H6");
  goog.dom.TagName.HEAD = new goog.dom.TagName("HEAD");
  goog.dom.TagName.HEADER = new goog.dom.TagName("HEADER");
  goog.dom.TagName.HGROUP = new goog.dom.TagName("HGROUP");
  goog.dom.TagName.HR = new goog.dom.TagName("HR");
  goog.dom.TagName.HTML = new goog.dom.TagName("HTML");
  goog.dom.TagName.I = new goog.dom.TagName("I");
  goog.dom.TagName.IFRAME = new goog.dom.TagName("IFRAME");
  goog.dom.TagName.IMG = new goog.dom.TagName("IMG");
  goog.dom.TagName.INPUT = new goog.dom.TagName("INPUT");
  goog.dom.TagName.INS = new goog.dom.TagName("INS");
  goog.dom.TagName.ISINDEX = new goog.dom.TagName("ISINDEX");
  goog.dom.TagName.KBD = new goog.dom.TagName("KBD");
  goog.dom.TagName.KEYGEN = new goog.dom.TagName("KEYGEN");
  goog.dom.TagName.LABEL = new goog.dom.TagName("LABEL");
  goog.dom.TagName.LEGEND = new goog.dom.TagName("LEGEND");
  goog.dom.TagName.LI = new goog.dom.TagName("LI");
  goog.dom.TagName.LINK = new goog.dom.TagName("LINK");
  goog.dom.TagName.MAIN = new goog.dom.TagName("MAIN");
  goog.dom.TagName.MAP = new goog.dom.TagName("MAP");
  goog.dom.TagName.MARK = new goog.dom.TagName("MARK");
  goog.dom.TagName.MATH = new goog.dom.TagName("MATH");
  goog.dom.TagName.MENU = new goog.dom.TagName("MENU");
  goog.dom.TagName.MENUITEM = new goog.dom.TagName("MENUITEM");
  goog.dom.TagName.META = new goog.dom.TagName("META");
  goog.dom.TagName.METER = new goog.dom.TagName("METER");
  goog.dom.TagName.NAV = new goog.dom.TagName("NAV");
  goog.dom.TagName.NOFRAMES = new goog.dom.TagName("NOFRAMES");
  goog.dom.TagName.NOSCRIPT = new goog.dom.TagName("NOSCRIPT");
  goog.dom.TagName.OBJECT = new goog.dom.TagName("OBJECT");
  goog.dom.TagName.OL = new goog.dom.TagName("OL");
  goog.dom.TagName.OPTGROUP = new goog.dom.TagName("OPTGROUP");
  goog.dom.TagName.OPTION = new goog.dom.TagName("OPTION");
  goog.dom.TagName.OUTPUT = new goog.dom.TagName("OUTPUT");
  goog.dom.TagName.P = new goog.dom.TagName("P");
  goog.dom.TagName.PARAM = new goog.dom.TagName("PARAM");
  goog.dom.TagName.PICTURE = new goog.dom.TagName("PICTURE");
  goog.dom.TagName.PRE = new goog.dom.TagName("PRE");
  goog.dom.TagName.PROGRESS = new goog.dom.TagName("PROGRESS");
  goog.dom.TagName.Q = new goog.dom.TagName("Q");
  goog.dom.TagName.RP = new goog.dom.TagName("RP");
  goog.dom.TagName.RT = new goog.dom.TagName("RT");
  goog.dom.TagName.RTC = new goog.dom.TagName("RTC");
  goog.dom.TagName.RUBY = new goog.dom.TagName("RUBY");
  goog.dom.TagName.S = new goog.dom.TagName("S");
  goog.dom.TagName.SAMP = new goog.dom.TagName("SAMP");
  goog.dom.TagName.SCRIPT = new goog.dom.TagName("SCRIPT");
  goog.dom.TagName.SECTION = new goog.dom.TagName("SECTION");
  goog.dom.TagName.SELECT = new goog.dom.TagName("SELECT");
  goog.dom.TagName.SMALL = new goog.dom.TagName("SMALL");
  goog.dom.TagName.SOURCE = new goog.dom.TagName("SOURCE");
  goog.dom.TagName.SPAN = new goog.dom.TagName("SPAN");
  goog.dom.TagName.STRIKE = new goog.dom.TagName("STRIKE");
  goog.dom.TagName.STRONG = new goog.dom.TagName("STRONG");
  goog.dom.TagName.STYLE = new goog.dom.TagName("STYLE");
  goog.dom.TagName.SUB = new goog.dom.TagName("SUB");
  goog.dom.TagName.SUMMARY = new goog.dom.TagName("SUMMARY");
  goog.dom.TagName.SUP = new goog.dom.TagName("SUP");
  goog.dom.TagName.SVG = new goog.dom.TagName("SVG");
  goog.dom.TagName.TABLE = new goog.dom.TagName("TABLE");
  goog.dom.TagName.TBODY = new goog.dom.TagName("TBODY");
  goog.dom.TagName.TD = new goog.dom.TagName("TD");
  goog.dom.TagName.TEMPLATE = new goog.dom.TagName("TEMPLATE");
  goog.dom.TagName.TEXTAREA = new goog.dom.TagName("TEXTAREA");
  goog.dom.TagName.TFOOT = new goog.dom.TagName("TFOOT");
  goog.dom.TagName.TH = new goog.dom.TagName("TH");
  goog.dom.TagName.THEAD = new goog.dom.TagName("THEAD");
  goog.dom.TagName.TIME = new goog.dom.TagName("TIME");
  goog.dom.TagName.TITLE = new goog.dom.TagName("TITLE");
  goog.dom.TagName.TR = new goog.dom.TagName("TR");
  goog.dom.TagName.TRACK = new goog.dom.TagName("TRACK");
  goog.dom.TagName.TT = new goog.dom.TagName("TT");
  goog.dom.TagName.U = new goog.dom.TagName("U");
  goog.dom.TagName.UL = new goog.dom.TagName("UL");
  goog.dom.TagName.VAR = new goog.dom.TagName("VAR");
  goog.dom.TagName.VIDEO = new goog.dom.TagName("VIDEO");
  goog.dom.TagName.WBR = new goog.dom.TagName("WBR");
  goog.dom.tags = {};
  goog.dom.tags.VOID_TAGS_ = { area: true, base: true, br: true, col: true, command: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true };
  goog.dom.tags.isVoidTag = function(a2) {
    return goog.dom.tags.VOID_TAGS_[a2] === true;
  };
  goog.html = {};
  goog.html.trustedtypes = {};
  goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html") : null;
  goog.string = {};
  goog.string.TypedString = function() {
  };
  goog.string.Const = function(a2, b) {
    this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = a2 === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && b || "";
    this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
  };
  goog.string.Const.prototype.implementsGoogStringTypedString = true;
  goog.string.Const.prototype.getTypedStringValue = function() {
    return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
  };
  goog.string.Const.prototype.toString = function() {
    return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
  };
  goog.string.Const.unwrap = function(a2) {
    if (a2 instanceof goog.string.Const && a2.constructor === goog.string.Const && a2.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_)
      return a2.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
    goog.asserts.fail("expected object of type Const, got '" + a2 + "'");
    return "type_error:Const";
  };
  goog.string.Const.from = function(a2) {
    return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, a2);
  };
  goog.string.Const.TYPE_MARKER_ = {};
  goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {};
  goog.string.Const.EMPTY = goog.string.Const.from("");
  goog.html.SafeScript = function() {
    this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = "";
    this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  };
  goog.html.SafeScript.prototype.implementsGoogStringTypedString = true;
  goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.SafeScript.fromConstant = function(a2) {
    a2 = goog.string.Const.unwrap(a2);
    return a2.length === 0 ? goog.html.SafeScript.EMPTY : goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeScript.fromConstantAndArgs = function(a2, b) {
    for (var c = [], d = 1; d < arguments.length; d++)
      c.push(goog.html.SafeScript.stringify_(arguments[d]));
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(a2) + ")(" + c.join(", ") + ");");
  };
  goog.html.SafeScript.fromJson = function(a2) {
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(a2));
  };
  goog.html.SafeScript.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
  };
  goog.DEBUG && (goog.html.SafeScript.prototype.toString = function() {
    return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
  });
  goog.html.SafeScript.unwrap = function(a2) {
    return goog.html.SafeScript.unwrapTrustedScript(a2).toString();
  };
  goog.html.SafeScript.unwrapTrustedScript = function(a2) {
    if (a2 instanceof goog.html.SafeScript && a2.constructor === goog.html.SafeScript && a2.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseSafeScriptWrappedValue_;
    goog.asserts.fail("expected object of type SafeScript, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:SafeScript";
  };
  goog.html.SafeScript.stringify_ = function(a2) {
    return JSON.stringify(a2).replace(/</g, "\\x3c");
  };
  goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(a2) {
    return new goog.html.SafeScript().initSecurityPrivateDoNotAccessOrElse_(a2);
  };
  goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a2) {
    this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(a2) : a2;
    return this;
  };
  goog.html.SafeScript.EMPTY = goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");
  goog.fs = {};
  goog.fs.url = {};
  goog.fs.url.createObjectUrl = function(a2) {
    return goog.fs.url.getUrlObject_().createObjectURL(a2);
  };
  goog.fs.url.revokeObjectUrl = function(a2) {
    goog.fs.url.getUrlObject_().revokeObjectURL(a2);
  };
  goog.fs.url.getUrlObject_ = function() {
    var a2 = goog.fs.url.findUrlObject_();
    if (a2 != null)
      return a2;
    throw Error("This browser doesn't seem to support blob URLs");
  };
  goog.fs.url.findUrlObject_ = function() {
    return goog.isDef(goog.global.URL) && goog.isDef(goog.global.URL.createObjectURL) ? goog.global.URL : goog.isDef(goog.global.webkitURL) && goog.isDef(goog.global.webkitURL.createObjectURL) ? goog.global.webkitURL : goog.isDef(goog.global.createObjectURL) ? goog.global : null;
  };
  goog.fs.url.browserSupportsObjectUrls = function() {
    return goog.fs.url.findUrlObject_() != null;
  };
  goog.i18n = {};
  goog.i18n.bidi = {};
  goog.i18n.bidi.FORCE_RTL = false;
  goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || (goog.LOCALE.substring(0, 2).toLowerCase() == "ar" || goog.LOCALE.substring(0, 2).toLowerCase() == "fa" || goog.LOCALE.substring(0, 2).toLowerCase() == "he" || goog.LOCALE.substring(0, 2).toLowerCase() == "iw" || goog.LOCALE.substring(0, 2).toLowerCase() == "ps" || goog.LOCALE.substring(0, 2).toLowerCase() == "sd" || goog.LOCALE.substring(0, 2).toLowerCase() == "ug" || goog.LOCALE.substring(0, 2).toLowerCase() == "ur" || goog.LOCALE.substring(0, 2).toLowerCase() == "yi") && (goog.LOCALE.length == 2 || goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") || 3 <= goog.LOCALE.length && goog.LOCALE.substring(0, 3).toLowerCase() == "ckb" && (goog.LOCALE.length == 3 || goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") || 7 <= goog.LOCALE.length && (goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") && (goog.LOCALE.substring(3, 7).toLowerCase() == "adlm" || goog.LOCALE.substring(3, 7).toLowerCase() == "arab" || goog.LOCALE.substring(3, 7).toLowerCase() == "hebr" || goog.LOCALE.substring(3, 7).toLowerCase() == "nkoo" || goog.LOCALE.substring(3, 7).toLowerCase() == "rohg" || goog.LOCALE.substring(3, 7).toLowerCase() == "thaa") || 8 <= goog.LOCALE.length && (goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") && (goog.LOCALE.substring(4, 8).toLowerCase() == "adlm" || goog.LOCALE.substring(4, 8).toLowerCase() == "arab" || goog.LOCALE.substring(4, 8).toLowerCase() == "hebr" || goog.LOCALE.substring(4, 8).toLowerCase() == "nkoo" || goog.LOCALE.substring(4, 8).toLowerCase() == "rohg" || goog.LOCALE.substring(4, 8).toLowerCase() == "thaa");
  goog.i18n.bidi.Format = { LRE: "\u202A", RLE: "\u202B", PDF: "\u202C", LRM: "\u200E", RLM: "\u200F" };
  goog.i18n.bidi.Dir = { LTR: 1, RTL: -1, NEUTRAL: 0 };
  goog.i18n.bidi.RIGHT = "right";
  goog.i18n.bidi.LEFT = "left";
  goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT;
  goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT;
  goog.i18n.bidi.toDir = function(a2, b) {
    return typeof a2 == "number" ? 0 < a2 ? goog.i18n.bidi.Dir.LTR : 0 > a2 ? goog.i18n.bidi.Dir.RTL : b ? null : goog.i18n.bidi.Dir.NEUTRAL : a2 == null ? null : a2 ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
  };
  goog.i18n.bidi.ltrChars_ = "A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u0300-\u0590\u0900-\u1FFF\u200E\u2C00-\uD801\uD804-\uD839\uD83C-\uDBFF\uF900-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF";
  goog.i18n.bidi.rtlChars_ = "\u0591-\u06EF\u06FA-\u08FF\u200F\uD802-\uD803\uD83A-\uD83B\uFB1D-\uFDFF\uFE70-\uFEFC";
  goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g;
  goog.i18n.bidi.stripHtmlIfNeeded_ = function(a2, b) {
    return b ? a2.replace(goog.i18n.bidi.htmlSkipReg_, "") : a2;
  };
  goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]");
  goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]");
  goog.i18n.bidi.hasAnyRtl = function(a2, b) {
    return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl;
  goog.i18n.bidi.hasAnyLtr = function(a2, b) {
    return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]");
  goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]");
  goog.i18n.bidi.isRtlChar = function(a2) {
    return goog.i18n.bidi.rtlRe_.test(a2);
  };
  goog.i18n.bidi.isLtrChar = function(a2) {
    return goog.i18n.bidi.ltrRe_.test(a2);
  };
  goog.i18n.bidi.isNeutralChar = function(a2) {
    return !goog.i18n.bidi.isLtrChar(a2) && !goog.i18n.bidi.isRtlChar(a2);
  };
  goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]");
  goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]");
  goog.i18n.bidi.startsWithRtl = function(a2, b) {
    return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl;
  goog.i18n.bidi.startsWithLtr = function(a2, b) {
    return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr;
  goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/;
  goog.i18n.bidi.isNeutralText = function(a2, b) {
    a2 = goog.i18n.bidi.stripHtmlIfNeeded_(a2, b);
    return goog.i18n.bidi.isRequiredLtrRe_.test(a2) || !goog.i18n.bidi.hasAnyLtr(a2) && !goog.i18n.bidi.hasAnyRtl(a2);
  };
  goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$");
  goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$");
  goog.i18n.bidi.endsWithLtr = function(a2, b) {
    return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr;
  goog.i18n.bidi.endsWithRtl = function(a2, b) {
    return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl;
  goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;
  goog.i18n.bidi.isRtlLanguage = function(a2) {
    return goog.i18n.bidi.rtlLocalesRe_.test(a2);
  };
  goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
  goog.i18n.bidi.guardBracketInText = function(a2, b) {
    b = (b === void 0 ? goog.i18n.bidi.hasAnyRtl(a2) : b) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM;
    return a2.replace(goog.i18n.bidi.bracketGuardTextRe_, b + "$&" + b);
  };
  goog.i18n.bidi.enforceRtlInHtml = function(a2) {
    return a2.charAt(0) == "<" ? a2.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + a2 + "</span>";
  };
  goog.i18n.bidi.enforceRtlInText = function(a2) {
    return goog.i18n.bidi.Format.RLE + a2 + goog.i18n.bidi.Format.PDF;
  };
  goog.i18n.bidi.enforceLtrInHtml = function(a2) {
    return a2.charAt(0) == "<" ? a2.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + a2 + "</span>";
  };
  goog.i18n.bidi.enforceLtrInText = function(a2) {
    return goog.i18n.bidi.Format.LRE + a2 + goog.i18n.bidi.Format.PDF;
  };
  goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;
  goog.i18n.bidi.leftRe_ = /left/gi;
  goog.i18n.bidi.rightRe_ = /right/gi;
  goog.i18n.bidi.tempRe_ = /%%%%/g;
  goog.i18n.bidi.mirrorCSS = function(a2) {
    return a2.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
  };
  goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g;
  goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g;
  goog.i18n.bidi.normalizeHebrewQuote = function(a2) {
    return a2.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1\u05F4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1\u05F3");
  };
  goog.i18n.bidi.wordSeparatorRe_ = /\s+/;
  goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/;
  goog.i18n.bidi.rtlDetectionThreshold_ = 0.4;
  goog.i18n.bidi.estimateDirection = function(a2, b) {
    var c = 0, d = 0, e = false;
    a2 = goog.i18n.bidi.stripHtmlIfNeeded_(a2, b).split(goog.i18n.bidi.wordSeparatorRe_);
    for (b = 0; b < a2.length; b++) {
      var f = a2[b];
      goog.i18n.bidi.startsWithRtl(f) ? (c++, d++) : goog.i18n.bidi.isRequiredLtrRe_.test(f) ? e = true : goog.i18n.bidi.hasAnyLtr(f) ? d++ : goog.i18n.bidi.hasNumeralsRe_.test(f) && (e = true);
    }
    return d == 0 ? e ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : c / d > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
  };
  goog.i18n.bidi.detectRtlDirectionality = function(a2, b) {
    return goog.i18n.bidi.estimateDirection(a2, b) == goog.i18n.bidi.Dir.RTL;
  };
  goog.i18n.bidi.setElementDirAndAlign = function(a2, b) {
    a2 && (b = goog.i18n.bidi.toDir(b)) && (a2.style.textAlign = b == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, a2.dir = b == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
  };
  goog.i18n.bidi.setElementDirByTextDirectionality = function(a2, b) {
    switch (goog.i18n.bidi.estimateDirection(b)) {
      case goog.i18n.bidi.Dir.LTR:
        a2.dir = "ltr";
        break;
      case goog.i18n.bidi.Dir.RTL:
        a2.dir = "rtl";
        break;
      default:
        a2.removeAttribute("dir");
    }
  };
  goog.i18n.bidi.DirectionalString = function() {
  };
  goog.html.TrustedResourceUrl = function() {
    this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = "";
    this.trustedURL_ = null;
    this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  };
  goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = true;
  goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
  };
  goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = true;
  goog.html.TrustedResourceUrl.prototype.getDirection = function() {
    return goog.i18n.bidi.Dir.LTR;
  };
  goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(a2, b) {
    var c = goog.html.TrustedResourceUrl.unwrap(this);
    c = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);
    var d = c[3] || "";
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", c[2] || "", a2) + goog.html.TrustedResourceUrl.stringifyParams_("#", d, b));
  };
  goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
    return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
  });
  goog.html.TrustedResourceUrl.unwrap = function(a2) {
    return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a2).toString();
  };
  goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(a2) {
    if (a2 instanceof goog.html.TrustedResourceUrl && a2.constructor === goog.html.TrustedResourceUrl && a2.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;
    goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:TrustedResourceUrl";
  };
  goog.html.TrustedResourceUrl.unwrapTrustedURL = function(a2) {
    return a2.trustedURL_ ? a2.trustedURL_ : goog.html.TrustedResourceUrl.unwrap(a2);
  };
  goog.html.TrustedResourceUrl.format = function(a2, b) {
    var c = goog.string.Const.unwrap(a2);
    if (!goog.html.TrustedResourceUrl.BASE_URL_.test(c))
      throw Error("Invalid TrustedResourceUrl format: " + c);
    a2 = c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(a3, e) {
      if (!Object.prototype.hasOwnProperty.call(b, e))
        throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
      a3 = b[e];
      return a3 instanceof goog.string.Const ? goog.string.Const.unwrap(a3) : encodeURIComponent(String(a3));
    });
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g;
  goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;
  goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
  goog.html.TrustedResourceUrl.formatWithParams = function(a2, b, c, d) {
    return goog.html.TrustedResourceUrl.format(a2, b).cloneWithParams(c, d);
  };
  goog.html.TrustedResourceUrl.fromConstant = function(a2) {
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a2));
  };
  goog.html.TrustedResourceUrl.fromConstants = function(a2) {
    for (var b = "", c = 0; c < a2.length; c++)
      b += goog.string.Const.unwrap(a2[c]);
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(a2) {
    var b = new goog.html.TrustedResourceUrl();
    b.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(a2) : a2;
    goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY && (b.trustedURL_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a2));
    return b;
  };
  goog.html.TrustedResourceUrl.stringifyParams_ = function(a2, b, c) {
    if (c == null)
      return b;
    if (goog.isString(c))
      return c ? a2 + encodeURIComponent(c) : "";
    for (var d in c) {
      var e = c[d];
      e = goog.isArray(e) ? e : [e];
      for (var f = 0; f < e.length; f++) {
        var g = e[f];
        g != null && (b || (b = a2), b += (b.length > a2.length ? "&" : "") + encodeURIComponent(d) + "=" + encodeURIComponent(String(g)));
      }
    }
    return b;
  };
  goog.string.internal = {};
  goog.string.internal.startsWith = function(a2, b) {
    return a2.lastIndexOf(b, 0) == 0;
  };
  goog.string.internal.endsWith = function(a2, b) {
    var c = a2.length - b.length;
    return 0 <= c && a2.indexOf(b, c) == c;
  };
  goog.string.internal.caseInsensitiveStartsWith = function(a2, b) {
    return goog.string.internal.caseInsensitiveCompare(b, a2.substr(0, b.length)) == 0;
  };
  goog.string.internal.caseInsensitiveEndsWith = function(a2, b) {
    return goog.string.internal.caseInsensitiveCompare(b, a2.substr(a2.length - b.length, b.length)) == 0;
  };
  goog.string.internal.caseInsensitiveEquals = function(a2, b) {
    return a2.toLowerCase() == b.toLowerCase();
  };
  goog.string.internal.isEmptyOrWhitespace = function(a2) {
    return /^[\s\xa0]*$/.test(a2);
  };
  goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a2) {
    return a2.trim();
  } : function(a2) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a2)[1];
  };
  goog.string.internal.caseInsensitiveCompare = function(a2, b) {
    a2 = String(a2).toLowerCase();
    b = String(b).toLowerCase();
    return a2 < b ? -1 : a2 == b ? 0 : 1;
  };
  goog.string.internal.newLineToBr = function(a2, b) {
    return a2.replace(/(\r\n|\r|\n)/g, b ? "<br />" : "<br>");
  };
  goog.string.internal.htmlEscape = function(a2, b) {
    if (b)
      a2 = a2.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
    else {
      if (!goog.string.internal.ALL_RE_.test(a2))
        return a2;
      a2.indexOf("&") != -1 && (a2 = a2.replace(goog.string.internal.AMP_RE_, "&amp;"));
      a2.indexOf("<") != -1 && (a2 = a2.replace(goog.string.internal.LT_RE_, "&lt;"));
      a2.indexOf(">") != -1 && (a2 = a2.replace(goog.string.internal.GT_RE_, "&gt;"));
      a2.indexOf('"') != -1 && (a2 = a2.replace(goog.string.internal.QUOT_RE_, "&quot;"));
      a2.indexOf("'") != -1 && (a2 = a2.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;"));
      a2.indexOf("\0") != -1 && (a2 = a2.replace(goog.string.internal.NULL_RE_, "&#0;"));
    }
    return a2;
  };
  goog.string.internal.AMP_RE_ = /&/g;
  goog.string.internal.LT_RE_ = /</g;
  goog.string.internal.GT_RE_ = />/g;
  goog.string.internal.QUOT_RE_ = /"/g;
  goog.string.internal.SINGLE_QUOTE_RE_ = /'/g;
  goog.string.internal.NULL_RE_ = /\x00/g;
  goog.string.internal.ALL_RE_ = /[\x00&<>"']/;
  goog.string.internal.whitespaceEscape = function(a2, b) {
    return goog.string.internal.newLineToBr(a2.replace(/  /g, " &#160;"), b);
  };
  goog.string.internal.contains = function(a2, b) {
    return a2.indexOf(b) != -1;
  };
  goog.string.internal.caseInsensitiveContains = function(a2, b) {
    return goog.string.internal.contains(a2.toLowerCase(), b.toLowerCase());
  };
  goog.string.internal.compareVersions = function(a2, b) {
    var c = 0;
    a2 = goog.string.internal.trim(String(a2)).split(".");
    b = goog.string.internal.trim(String(b)).split(".");
    for (var d = Math.max(a2.length, b.length), e = 0; c == 0 && e < d; e++) {
      var f = a2[e] || "", g = b[e] || "";
      do {
        f = /(\d*)(\D*)(.*)/.exec(f) || ["", "", "", ""];
        g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];
        if (f[0].length == 0 && g[0].length == 0)
          break;
        c = f[1].length == 0 ? 0 : parseInt(f[1], 10);
        var h = g[1].length == 0 ? 0 : parseInt(g[1], 10);
        c = goog.string.internal.compareElements_(c, h) || goog.string.internal.compareElements_(f[2].length == 0, g[2].length == 0) || goog.string.internal.compareElements_(f[2], g[2]);
        f = f[3];
        g = g[3];
      } while (c == 0);
    }
    return c;
  };
  goog.string.internal.compareElements_ = function(a2, b) {
    return a2 < b ? -1 : a2 > b ? 1 : 0;
  };
  goog.html.SafeUrl = function() {
    this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = "";
    this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  };
  goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez";
  goog.html.SafeUrl.prototype.implementsGoogStringTypedString = true;
  goog.html.SafeUrl.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
  };
  goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = true;
  goog.html.SafeUrl.prototype.getDirection = function() {
    return goog.i18n.bidi.Dir.LTR;
  };
  goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
    return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
  });
  goog.html.SafeUrl.unwrap = function(a2) {
    return goog.html.SafeUrl.unwrapTrustedURL(a2).toString();
  };
  goog.html.SafeUrl.unwrapTrustedURL = function(a2) {
    if (a2 instanceof goog.html.SafeUrl && a2.constructor === goog.html.SafeUrl && a2.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseSafeUrlWrappedValue_;
    goog.asserts.fail("expected object of type SafeUrl, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:SafeUrl";
  };
  goog.html.SafeUrl.fromConstant = function(a2) {
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a2));
  };
  goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime))(?:;\w+=(?:\w+|"[\w;=]+"))*$/i;
  goog.html.SafeUrl.isSafeMimeType = function(a2) {
    return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a2);
  };
  goog.html.SafeUrl.fromBlob = function(a2) {
    a2 = goog.html.SAFE_MIME_TYPE_PATTERN_.test(a2.type) ? goog.fs.url.createObjectUrl(a2) : goog.html.SafeUrl.INNOCUOUS_STRING;
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.DATA_URL_PATTERN_ = /^data:([^,]*);base64,[a-z0-9+\/]+=*$/i;
  goog.html.SafeUrl.fromDataUrl = function(a2) {
    a2 = a2.replace(/(%0A|%0D)/g, "");
    var b = a2.match(goog.html.DATA_URL_PATTERN_);
    b = b && goog.html.SAFE_MIME_TYPE_PATTERN_.test(b[1]);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b ? a2 : goog.html.SafeUrl.INNOCUOUS_STRING);
  };
  goog.html.SafeUrl.fromTelUrl = function(a2) {
    goog.string.internal.caseInsensitiveStartsWith(a2, "tel:") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;
  goog.html.SafeUrl.fromSipUrl = function(a2) {
    goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a2)) || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.fromFacebookMessengerUrl = function(a2) {
    goog.string.internal.caseInsensitiveStartsWith(a2, "fb-messenger://share") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.fromWhatsAppUrl = function(a2) {
    goog.string.internal.caseInsensitiveStartsWith(a2, "whatsapp://send") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.fromSmsUrl = function(a2) {
    goog.string.internal.caseInsensitiveStartsWith(a2, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(a2) || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.isSmsUrlBodyValid_ = function(a2) {
    var b = a2.indexOf("#");
    0 < b && (a2 = a2.substring(0, b));
    b = a2.match(/[?&]body=/gi);
    if (!b)
      return true;
    if (1 < b.length)
      return false;
    a2 = a2.match(/[?&]body=([^&]*)/)[1];
    if (!a2)
      return true;
    try {
      decodeURIComponent(a2);
    } catch (c) {
      return false;
    }
    return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a2);
  };
  goog.html.SafeUrl.fromSshUrl = function(a2) {
    goog.string.internal.caseInsensitiveStartsWith(a2, "ssh://") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(a2, b) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, a2, b);
  };
  goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(a2, b) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, a2, b);
  };
  goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(a2, b) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, a2, b);
  };
  goog.html.SafeUrl.sanitizeExtensionUrl_ = function(a2, b, c) {
    (a2 = a2.exec(b)) ? (a2 = a2[1], (c instanceof goog.string.Const ? [goog.string.Const.unwrap(c)] : c.map(function(a3) {
      return goog.string.Const.unwrap(a3);
    })).indexOf(a2) == -1 && (b = goog.html.SafeUrl.INNOCUOUS_STRING)) : b = goog.html.SafeUrl.INNOCUOUS_STRING;
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.SafeUrl.fromTrustedResourceUrl = function(a2) {
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a2));
  };
  goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
  goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_;
  goog.html.SafeUrl.sanitize = function(a2) {
    if (a2 instanceof goog.html.SafeUrl)
      return a2;
    a2 = typeof a2 == "object" && a2.implementsGoogStringTypedString ? a2.getTypedStringValue() : String(a2);
    goog.html.SAFE_URL_PATTERN_.test(a2) || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.sanitizeAssertUnchanged = function(a2, b) {
    if (a2 instanceof goog.html.SafeUrl)
      return a2;
    a2 = typeof a2 == "object" && a2.implementsGoogStringTypedString ? a2.getTypedStringValue() : String(a2);
    if (b && /^data:/i.test(a2) && (b = goog.html.SafeUrl.fromDataUrl(a2), b.getTypedStringValue() == a2))
      return b;
    goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a2), "%s does not match the safe URL pattern", a2) || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(a2) {
    var b = new goog.html.SafeUrl();
    b.privateDoNotAccessOrElseSafeUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a2) : a2;
    return b;
  };
  goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");
  goog.html.SafeStyle = function() {
    this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = "";
    this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  };
  goog.html.SafeStyle.prototype.implementsGoogStringTypedString = true;
  goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.SafeStyle.fromConstant = function(a2) {
    a2 = goog.string.Const.unwrap(a2);
    if (a2.length === 0)
      return goog.html.SafeStyle.EMPTY;
    goog.asserts.assert(goog.string.internal.endsWith(a2, ";"), "Last character of style string is not ';': " + a2);
    goog.asserts.assert(goog.string.internal.contains(a2, ":"), `Style string must contain at least one ':', to specify a "name: value" pair: ` + a2);
    return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeStyle.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
  };
  goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
    return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
  });
  goog.html.SafeStyle.unwrap = function(a2) {
    if (a2 instanceof goog.html.SafeStyle && a2.constructor === goog.html.SafeStyle && a2.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseSafeStyleWrappedValue_;
    goog.asserts.fail("expected object of type SafeStyle, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:SafeStyle";
  };
  goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(a2) {
    return new goog.html.SafeStyle().initSecurityPrivateDoNotAccessOrElse_(a2);
  };
  goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a2) {
    this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = a2;
    return this;
  };
  goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");
  goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez";
  goog.html.SafeStyle.create = function(a2) {
    var b = "", c;
    for (c in a2) {
      if (!/^[-_a-zA-Z0-9]+$/.test(c))
        throw Error("Name allows only [-_a-zA-Z0-9], got: " + c);
      var d = a2[c];
      d != null && (d = goog.isArray(d) ? goog.array.map(d, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(d), b += c + ":" + d + ";");
    }
    return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
  };
  goog.html.SafeStyle.sanitizePropertyValue_ = function(a2) {
    if (a2 instanceof goog.html.SafeUrl)
      return 'url("' + goog.html.SafeUrl.unwrap(a2).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
    a2 = a2 instanceof goog.string.Const ? goog.string.Const.unwrap(a2) : goog.html.SafeStyle.sanitizePropertyValueString_(String(a2));
    if (/[{;}]/.test(a2))
      throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [a2]);
    return a2;
  };
  goog.html.SafeStyle.sanitizePropertyValueString_ = function(a2) {
    var b = a2.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
    if (goog.html.SafeStyle.VALUE_RE_.test(b)) {
      if (goog.html.SafeStyle.COMMENT_RE_.test(a2))
        return goog.asserts.fail("String value disallows comments, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
      if (!goog.html.SafeStyle.hasBalancedQuotes_(a2))
        return goog.asserts.fail("String value requires balanced quotes, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
      if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(a2))
        return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
    } else
      return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
    return goog.html.SafeStyle.sanitizeUrl_(a2);
  };
  goog.html.SafeStyle.hasBalancedQuotes_ = function(a2) {
    for (var b = true, c = true, d = 0; d < a2.length; d++) {
      var e = a2.charAt(d);
      e == "'" && c ? b = !b : e == '"' && b && (c = !c);
    }
    return b && c;
  };
  goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(a2) {
    for (var b = true, c = /^[-_a-zA-Z0-9]$/, d = 0; d < a2.length; d++) {
      var e = a2.charAt(d);
      if (e == "]") {
        if (b)
          return false;
        b = true;
      } else if (e == "[") {
        if (!b)
          return false;
        b = false;
      } else if (!b && !c.test(e))
        return false;
    }
    return b;
  };
  goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = `[-,."'%_!# a-zA-Z0-9\\[\\]]`;
  goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$");
  goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;
  goog.html.SafeStyle.FUNCTIONS_RE_ = /\b(hsl|hsla|rgb|rgba|matrix|calc|minmax|fit-content|repeat|(rotate|scale|translate)(X|Y|Z|3d)?)\([-+*/0-9a-z.%\[\], ]+\)/g;
  goog.html.SafeStyle.COMMENT_RE_ = /\/\*/;
  goog.html.SafeStyle.sanitizeUrl_ = function(a2) {
    return a2.replace(goog.html.SafeStyle.URL_RE_, function(a3, c, d, e) {
      var b = "";
      d = d.replace(/^(['"])(.*)\1$/, function(a4, c2, d2) {
        b = c2;
        return d2;
      });
      a3 = goog.html.SafeUrl.sanitize(d).getTypedStringValue();
      return c + b + a3 + b + e;
    });
  };
  goog.html.SafeStyle.concat = function(a2) {
    var b = "", c = function(a3) {
      goog.isArray(a3) ? goog.array.forEach(a3, c) : b += goog.html.SafeStyle.unwrap(a3);
    };
    goog.array.forEach(arguments, c);
    return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
  };
  goog.html.SafeStyleSheet = function() {
    this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = "";
    this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  };
  goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString = true;
  goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.SafeStyleSheet.createRule = function(a2, b) {
    if (goog.string.internal.contains(a2, "<"))
      throw Error("Selector does not allow '<', got: " + a2);
    var c = a2.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
    if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c))
      throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + a2);
    if (!goog.html.SafeStyleSheet.hasBalancedBrackets_(c))
      throw Error("() and [] in selector must be balanced, got: " + a2);
    b instanceof goog.html.SafeStyle || (b = goog.html.SafeStyle.create(b));
    a2 = a2 + "{" + goog.html.SafeStyle.unwrap(b).replace(/</g, "\\3C ") + "}";
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeStyleSheet.hasBalancedBrackets_ = function(a2) {
    for (var b = { "(": ")", "[": "]" }, c = [], d = 0; d < a2.length; d++) {
      var e = a2[d];
      if (b[e])
        c.push(b[e]);
      else if (goog.object.contains(b, e) && c.pop() != e)
        return false;
    }
    return c.length == 0;
  };
  goog.html.SafeStyleSheet.concat = function(a2) {
    var b = "", c = function(a3) {
      goog.isArray(a3) ? goog.array.forEach(a3, c) : b += goog.html.SafeStyleSheet.unwrap(a3);
    };
    goog.array.forEach(arguments, c);
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.SafeStyleSheet.fromConstant = function(a2) {
    a2 = goog.string.Const.unwrap(a2);
    if (a2.length === 0)
      return goog.html.SafeStyleSheet.EMPTY;
    goog.asserts.assert(!goog.string.internal.contains(a2, "<"), "Forbidden '<' character in style sheet string: " + a2);
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeStyleSheet.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
  };
  goog.DEBUG && (goog.html.SafeStyleSheet.prototype.toString = function() {
    return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
  });
  goog.html.SafeStyleSheet.unwrap = function(a2) {
    if (a2 instanceof goog.html.SafeStyleSheet && a2.constructor === goog.html.SafeStyleSheet && a2.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
    goog.asserts.fail("expected object of type SafeStyleSheet, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:SafeStyleSheet";
  };
  goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(a2) {
    return new goog.html.SafeStyleSheet().initSecurityPrivateDoNotAccessOrElse_(a2);
  };
  goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a2) {
    this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = a2;
    return this;
  };
  goog.html.SafeStyleSheet.EMPTY = goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");
  goog.labs = {};
  goog.labs.userAgent = {};
  goog.labs.userAgent.util = {};
  goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
    var a2 = goog.labs.userAgent.util.getNavigator_();
    return a2 && (a2 = a2.userAgent) ? a2 : "";
  };
  goog.labs.userAgent.util.getNavigator_ = function() {
    return goog.global.navigator;
  };
  goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_();
  goog.labs.userAgent.util.setUserAgent = function(a2) {
    goog.labs.userAgent.util.userAgent_ = a2 || goog.labs.userAgent.util.getNativeUserAgentString_();
  };
  goog.labs.userAgent.util.getUserAgent = function() {
    return goog.labs.userAgent.util.userAgent_;
  };
  goog.labs.userAgent.util.matchUserAgent = function(a2) {
    var b = goog.labs.userAgent.util.getUserAgent();
    return goog.string.internal.contains(b, a2);
  };
  goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(a2) {
    var b = goog.labs.userAgent.util.getUserAgent();
    return goog.string.internal.caseInsensitiveContains(b, a2);
  };
  goog.labs.userAgent.util.extractVersionTuples = function(a2) {
    for (var b = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, c = [], d; d = b.exec(a2); )
      c.push([d[1], d[2], d[3] || void 0]);
    return c;
  };
  goog.labs.userAgent.browser = {};
  goog.labs.userAgent.browser.matchOpera_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Opera");
  };
  goog.labs.userAgent.browser.matchIE_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
  };
  goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edge");
  };
  goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edg/");
  };
  goog.labs.userAgent.browser.matchOperaChromium_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("OPR");
  };
  goog.labs.userAgent.browser.matchFirefox_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
  };
  goog.labs.userAgent.browser.matchSafari_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
  };
  goog.labs.userAgent.browser.matchCoast_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Coast");
  };
  goog.labs.userAgent.browser.matchIosWebview_ = function() {
    return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
  };
  goog.labs.userAgent.browser.matchChrome_ = function() {
    return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
  };
  goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
  };
  goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_;
  goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_;
  goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_;
  goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_;
  goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_;
  goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_;
  goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_;
  goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_;
  goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_;
  goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_;
  goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_;
  goog.labs.userAgent.browser.isSilk = function() {
    return goog.labs.userAgent.util.matchUserAgent("Silk");
  };
  goog.labs.userAgent.browser.getVersion = function() {
    function a2(a3) {
      a3 = goog.array.find(a3, d);
      return c[a3] || "";
    }
    var b = goog.labs.userAgent.util.getUserAgent();
    if (goog.labs.userAgent.browser.isIE())
      return goog.labs.userAgent.browser.getIEVersion_(b);
    b = goog.labs.userAgent.util.extractVersionTuples(b);
    var c = {};
    goog.array.forEach(b, function(a3) {
      c[a3[0]] = a3[1];
    });
    var d = goog.partial(goog.object.containsKey, c);
    return goog.labs.userAgent.browser.isOpera() ? a2(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? a2(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? a2(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? a2(["Chrome", "CriOS"]) : (b = b[2]) && b[1] || "";
  };
  goog.labs.userAgent.browser.isVersionOrHigher = function(a2) {
    return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), a2);
  };
  goog.labs.userAgent.browser.getIEVersion_ = function(a2) {
    var b = /rv: *([\d\.]*)/.exec(a2);
    if (b && b[1])
      return b[1];
    b = "";
    var c = /MSIE +([\d\.]+)/.exec(a2);
    if (c && c[1])
      if (a2 = /Trident\/(\d.\d)/.exec(a2), c[1] == "7.0")
        if (a2 && a2[1])
          switch (a2[1]) {
            case "4.0":
              b = "8.0";
              break;
            case "5.0":
              b = "9.0";
              break;
            case "6.0":
              b = "10.0";
              break;
            case "7.0":
              b = "11.0";
          }
        else
          b = "7.0";
      else
        b = c[1];
    return b;
  };
  goog.html.SafeHtml = function() {
    this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = "";
    this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    this.dir_ = null;
  };
  goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = true;
  goog.html.SafeHtml.prototype.getDirection = function() {
    return this.dir_;
  };
  goog.html.SafeHtml.prototype.implementsGoogStringTypedString = true;
  goog.html.SafeHtml.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
  };
  goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
    return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
  });
  goog.html.SafeHtml.unwrap = function(a2) {
    return goog.html.SafeHtml.unwrapTrustedHTML(a2).toString();
  };
  goog.html.SafeHtml.unwrapTrustedHTML = function(a2) {
    if (a2 instanceof goog.html.SafeHtml && a2.constructor === goog.html.SafeHtml && a2.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseSafeHtmlWrappedValue_;
    goog.asserts.fail("expected object of type SafeHtml, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:SafeHtml";
  };
  goog.html.SafeHtml.htmlEscape = function(a2) {
    if (a2 instanceof goog.html.SafeHtml)
      return a2;
    var b = typeof a2 == "object", c = null;
    b && a2.implementsGoogI18nBidiDirectionalString && (c = a2.getDirection());
    a2 = b && a2.implementsGoogStringTypedString ? a2.getTypedStringValue() : String(a2);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a2), c);
  };
  goog.html.SafeHtml.htmlEscapePreservingNewlines = function(a2) {
    if (a2 instanceof goog.html.SafeHtml)
      return a2;
    a2 = goog.html.SafeHtml.htmlEscape(a2);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a2)), a2.getDirection());
  };
  goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(a2) {
    if (a2 instanceof goog.html.SafeHtml)
      return a2;
    a2 = goog.html.SafeHtml.htmlEscape(a2);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a2)), a2.getDirection());
  };
  goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape;
  goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/;
  goog.html.SafeHtml.URL_ATTRIBUTES_ = { action: true, cite: true, data: true, formaction: true, href: true, manifest: true, poster: true, src: true };
  goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = { APPLET: true, BASE: true, EMBED: true, IFRAME: true, LINK: true, MATH: true, META: true, OBJECT: true, SCRIPT: true, STYLE: true, SVG: true, TEMPLATE: true };
  goog.html.SafeHtml.create = function(a2, b, c) {
    goog.html.SafeHtml.verifyTagName(String(a2));
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a2), b, c);
  };
  goog.html.SafeHtml.verifyTagName = function(a2) {
    if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a2))
      throw Error("Invalid tag name <" + a2 + ">.");
    if (a2.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_)
      throw Error("Tag name <" + a2 + "> is not allowed for SafeHtml.");
  };
  goog.html.SafeHtml.createIframe = function(a2, b, c, d) {
    a2 && goog.html.TrustedResourceUrl.unwrap(a2);
    var e = {};
    e.src = a2 || null;
    e.srcdoc = b && goog.html.SafeHtml.unwrap(b);
    a2 = goog.html.SafeHtml.combineAttributes(e, { sandbox: "" }, c);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a2, d);
  };
  goog.html.SafeHtml.createSandboxIframe = function(a2, b, c, d) {
    if (!goog.html.SafeHtml.canUseSandboxIframe())
      throw Error("The browser does not support sandboxed iframes.");
    var e = {};
    e.src = a2 ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a2)) : null;
    e.srcdoc = b || null;
    e.sandbox = "";
    a2 = goog.html.SafeHtml.combineAttributes(e, {}, c);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a2, d);
  };
  goog.html.SafeHtml.canUseSandboxIframe = function() {
    return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
  };
  goog.html.SafeHtml.createScriptSrc = function(a2, b) {
    goog.html.TrustedResourceUrl.unwrap(a2);
    a2 = goog.html.SafeHtml.combineAttributes({ src: a2 }, {}, b);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", a2);
  };
  goog.html.SafeHtml.createScript = function(a2, b) {
    for (var c in b) {
      var d = c.toLowerCase();
      if (d == "language" || d == "src" || d == "text" || d == "type")
        throw Error('Cannot set "' + d + '" attribute');
    }
    c = "";
    a2 = goog.array.concat(a2);
    for (d = 0; d < a2.length; d++)
      c += goog.html.SafeScript.unwrap(a2[d]);
    a2 = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", b, a2);
  };
  goog.html.SafeHtml.createStyle = function(a2, b) {
    b = goog.html.SafeHtml.combineAttributes({ type: "text/css" }, {}, b);
    var c = "";
    a2 = goog.array.concat(a2);
    for (var d = 0; d < a2.length; d++)
      c += goog.html.SafeStyleSheet.unwrap(a2[d]);
    a2 = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", b, a2);
  };
  goog.html.SafeHtml.createMetaRefresh = function(a2, b) {
    a2 = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a2));
    (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(a2, ";") && (a2 = "'" + a2.replace(/'/g, "%27") + "'");
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", { "http-equiv": "refresh", content: (b || 0) + "; url=" + a2 });
  };
  goog.html.SafeHtml.getAttrNameAndValue_ = function(a2, b, c) {
    if (c instanceof goog.string.Const)
      c = goog.string.Const.unwrap(c);
    else if (b.toLowerCase() == "style")
      c = goog.html.SafeHtml.getStyleValue_(c);
    else {
      if (/^on/i.test(b))
        throw Error('Attribute "' + b + '" requires goog.string.Const value, "' + c + '" given.');
      if (b.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_)
        if (c instanceof goog.html.TrustedResourceUrl)
          c = goog.html.TrustedResourceUrl.unwrap(c);
        else if (c instanceof goog.html.SafeUrl)
          c = goog.html.SafeUrl.unwrap(c);
        else if (goog.isString(c))
          c = goog.html.SafeUrl.sanitize(c).getTypedStringValue();
        else
          throw Error('Attribute "' + b + '" on tag "' + a2 + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + c + '" given.');
    }
    c.implementsGoogStringTypedString && (c = c.getTypedStringValue());
    goog.asserts.assert(goog.isString(c) || goog.isNumber(c), "String or number value expected, got " + typeof c + " with value: " + c);
    return b + '="' + goog.string.internal.htmlEscape(String(c)) + '"';
  };
  goog.html.SafeHtml.getStyleValue_ = function(a2) {
    if (!goog.isObject(a2))
      throw Error('The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof a2 + " given: " + a2);
    a2 instanceof goog.html.SafeStyle || (a2 = goog.html.SafeStyle.create(a2));
    return goog.html.SafeStyle.unwrap(a2);
  };
  goog.html.SafeHtml.createWithDir = function(a2, b, c, d) {
    b = goog.html.SafeHtml.create(b, c, d);
    b.dir_ = a2;
    return b;
  };
  goog.html.SafeHtml.join = function(a2, b) {
    a2 = goog.html.SafeHtml.htmlEscape(a2);
    var c = a2.getDirection(), d = [], e = function(a3) {
      goog.isArray(a3) ? goog.array.forEach(a3, e) : (a3 = goog.html.SafeHtml.htmlEscape(a3), d.push(goog.html.SafeHtml.unwrap(a3)), a3 = a3.getDirection(), c == goog.i18n.bidi.Dir.NEUTRAL ? c = a3 : a3 != goog.i18n.bidi.Dir.NEUTRAL && c != a3 && (c = null));
    };
    goog.array.forEach(b, e);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a2)), c);
  };
  goog.html.SafeHtml.concat = function(a2) {
    return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
  };
  goog.html.SafeHtml.concatWithDir = function(a2, b) {
    var c = goog.html.SafeHtml.concat(goog.array.slice(arguments, 1));
    c.dir_ = a2;
    return c;
  };
  goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(a2, b) {
    return new goog.html.SafeHtml().initSecurityPrivateDoNotAccessOrElse_(a2, b);
  };
  goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a2, b) {
    this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(a2) : a2;
    this.dir_ = b;
    return this;
  };
  goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(a2, b, c) {
    var d = null;
    var e = "<" + a2 + goog.html.SafeHtml.stringifyAttributes(a2, b);
    goog.isDefAndNotNull(c) ? goog.isArray(c) || (c = [c]) : c = [];
    goog.dom.tags.isVoidTag(a2.toLowerCase()) ? (goog.asserts.assert(!c.length, "Void tag <" + a2 + "> does not allow content."), e += ">") : (d = goog.html.SafeHtml.concat(c), e += ">" + goog.html.SafeHtml.unwrap(d) + "</" + a2 + ">", d = d.getDirection());
    (a2 = b && b.dir) && (d = /^(ltr|rtl|auto)$/i.test(a2) ? goog.i18n.bidi.Dir.NEUTRAL : null);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e, d);
  };
  goog.html.SafeHtml.stringifyAttributes = function(a2, b) {
    var c = "";
    if (b)
      for (var d in b) {
        if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d))
          throw Error('Invalid attribute name "' + d + '".');
        var e = b[d];
        goog.isDefAndNotNull(e) && (c += " " + goog.html.SafeHtml.getAttrNameAndValue_(a2, d, e));
      }
    return c;
  };
  goog.html.SafeHtml.combineAttributes = function(a2, b, c) {
    var d = {}, e;
    for (e in a2)
      goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = a2[e];
    for (e in b)
      goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = b[e];
    for (e in c) {
      var f = e.toLowerCase();
      if (f in a2)
        throw Error('Cannot override "' + f + '" attribute, got "' + e + '" with value "' + c[e] + '"');
      f in b && delete d[f];
      d[e] = c[e];
    }
    return d;
  };
  goog.html.SafeHtml.DOCTYPE_HTML = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL);
  goog.html.SafeHtml.EMPTY = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("", goog.i18n.bidi.Dir.NEUTRAL);
  goog.html.SafeHtml.BR = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL);
  goog.html.uncheckedconversions = {};
  goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(a2, b, c) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b, c || null);
  };
  goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(a2, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(a2, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(a2, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(a2, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(a2, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.dom.safe = {};
  goog.dom.safe.InsertAdjacentHtmlPosition = { AFTERBEGIN: "afterbegin", AFTEREND: "afterend", BEFOREBEGIN: "beforebegin", BEFOREEND: "beforeend" };
  goog.dom.safe.insertAdjacentHtml = function(a2, b, c) {
    a2.insertAdjacentHTML(b, goog.html.SafeHtml.unwrapTrustedHTML(c));
  };
  goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = { MATH: true, SCRIPT: true, STYLE: true, SVG: true, TEMPLATE: true };
  goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
    if (goog.DEBUG && typeof document === "undefined")
      return false;
    var a2 = document.createElement("div"), b = document.createElement("div");
    b.appendChild(document.createElement("div"));
    a2.appendChild(b);
    if (goog.DEBUG && !a2.firstChild)
      return false;
    b = a2.firstChild.firstChild;
    a2.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);
    return !b.parentElement;
  });
  goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(a2, b) {
    if (goog.dom.safe.isInnerHtmlCleanupRecursive_())
      for (; a2.lastChild; )
        a2.removeChild(a2.lastChild);
    a2.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
  };
  goog.dom.safe.setInnerHtml = function(a2, b) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var c = a2.tagName.toUpperCase();
      if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c])
        throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + a2.tagName + ".");
    }
    goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a2, b);
  };
  goog.dom.safe.setOuterHtml = function(a2, b) {
    a2.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
  };
  goog.dom.safe.setFormElementAction = function(a2, b) {
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    goog.dom.asserts.assertIsHTMLFormElement(a2).action = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setButtonFormAction = function(a2, b) {
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    goog.dom.asserts.assertIsHTMLButtonElement(a2).formAction = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setInputFormAction = function(a2, b) {
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    goog.dom.asserts.assertIsHTMLInputElement(a2).formAction = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setStyle = function(a2, b) {
    a2.style.cssText = goog.html.SafeStyle.unwrap(b);
  };
  goog.dom.safe.documentWrite = function(a2, b) {
    a2.write(goog.html.SafeHtml.unwrapTrustedHTML(b));
  };
  goog.dom.safe.setAnchorHref = function(a2, b) {
    goog.dom.asserts.assertIsHTMLAnchorElement(a2);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a2.href = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setImageSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLImageElement(a2);
    if (!(b instanceof goog.html.SafeUrl)) {
      var c = /^data:image\//i.test(b);
      b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
    }
    a2.src = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setAudioSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLAudioElement(a2);
    if (!(b instanceof goog.html.SafeUrl)) {
      var c = /^data:audio\//i.test(b);
      b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
    }
    a2.src = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setVideoSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLVideoElement(a2);
    if (!(b instanceof goog.html.SafeUrl)) {
      var c = /^data:video\//i.test(b);
      b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
    }
    a2.src = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setEmbedSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLEmbedElement(a2);
    a2.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
  };
  goog.dom.safe.setFrameSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLFrameElement(a2);
    a2.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setIframeSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLIFrameElement(a2);
    a2.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setIframeSrcdoc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLIFrameElement(a2);
    a2.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(b);
  };
  goog.dom.safe.setLinkHrefAndRel = function(a2, b, c) {
    goog.dom.asserts.assertIsHTMLLinkElement(a2);
    a2.rel = c;
    goog.string.internal.caseInsensitiveContains(c, "stylesheet") ? (goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), a2.href = goog.html.TrustedResourceUrl.unwrapTrustedURL(b)) : a2.href = b instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrapTrustedURL(b) : b instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrapTrustedURL(b) : goog.html.SafeUrl.unwrapTrustedURL(goog.html.SafeUrl.sanitizeAssertUnchanged(b));
  };
  goog.dom.safe.setObjectData = function(a2, b) {
    goog.dom.asserts.assertIsHTMLObjectElement(a2);
    a2.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
  };
  goog.dom.safe.setScriptSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLScriptElement(a2);
    a2.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
    (b = goog.getScriptNonce()) && a2.setAttribute("nonce", b);
  };
  goog.dom.safe.setScriptContent = function(a2, b) {
    goog.dom.asserts.assertIsHTMLScriptElement(a2);
    a2.text = goog.html.SafeScript.unwrapTrustedScript(b);
    (b = goog.getScriptNonce()) && a2.setAttribute("nonce", b);
  };
  goog.dom.safe.setLocationHref = function(a2, b) {
    goog.dom.asserts.assertIsLocation(a2);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a2.href = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.assignLocation = function(a2, b) {
    goog.dom.asserts.assertIsLocation(a2);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a2.assign(goog.html.SafeUrl.unwrapTrustedURL(b));
  };
  goog.dom.safe.replaceLocation = function(a2, b) {
    goog.dom.asserts.assertIsLocation(a2);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a2.replace(goog.html.SafeUrl.unwrapTrustedURL(b));
  };
  goog.dom.safe.openInWindow = function(a2, b, c, d, e) {
    a2 = a2 instanceof goog.html.SafeUrl ? a2 : goog.html.SafeUrl.sanitizeAssertUnchanged(a2);
    return (b || goog.global).open(goog.html.SafeUrl.unwrapTrustedURL(a2), c ? goog.string.Const.unwrap(c) : "", d, e);
  };
  goog.dom.safe.parseFromStringHtml = function(a2, b) {
    return goog.dom.safe.parseFromString(a2, b, "text/html");
  };
  goog.dom.safe.parseFromString = function(a2, b, c) {
    return a2.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b), c);
  };
  goog.dom.safe.createImageFromBlob = function(a2) {
    if (!/^image\/.*/g.test(a2.type))
      throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
    var b = goog.global.URL.createObjectURL(a2);
    a2 = new goog.global.Image();
    a2.onload = function() {
      goog.global.URL.revokeObjectURL(b);
    };
    goog.dom.safe.setImageSrc(a2, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), b));
    return a2;
  };
  goog.string.DETECT_DOUBLE_ESCAPING = false;
  goog.string.FORCE_NON_DOM_HTML_UNESCAPING = false;
  goog.string.Unicode = { NBSP: "\xA0" };
  goog.string.startsWith = goog.string.internal.startsWith;
  goog.string.endsWith = goog.string.internal.endsWith;
  goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith;
  goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith;
  goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals;
  goog.string.subs = function(a2, b) {
    for (var c = a2.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length; )
      d += c.shift() + e.shift();
    return d + c.join("%s");
  };
  goog.string.collapseWhitespace = function(a2) {
    return a2.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
  };
  goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace;
  goog.string.isEmptyString = function(a2) {
    return a2.length == 0;
  };
  goog.string.isEmpty = goog.string.isEmptyOrWhitespace;
  goog.string.isEmptyOrWhitespaceSafe = function(a2) {
    return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a2));
  };
  goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;
  goog.string.isBreakingWhitespace = function(a2) {
    return !/[^\t\n\r ]/.test(a2);
  };
  goog.string.isAlpha = function(a2) {
    return !/[^a-zA-Z]/.test(a2);
  };
  goog.string.isNumeric = function(a2) {
    return !/[^0-9]/.test(a2);
  };
  goog.string.isAlphaNumeric = function(a2) {
    return !/[^a-zA-Z0-9]/.test(a2);
  };
  goog.string.isSpace = function(a2) {
    return a2 == " ";
  };
  goog.string.isUnicodeChar = function(a2) {
    return a2.length == 1 && " " <= a2 && "~" >= a2 || "\x80" <= a2 && "\uFFFD" >= a2;
  };
  goog.string.stripNewlines = function(a2) {
    return a2.replace(/(\r\n|\r|\n)+/g, " ");
  };
  goog.string.canonicalizeNewlines = function(a2) {
    return a2.replace(/(\r\n|\r|\n)/g, "\n");
  };
  goog.string.normalizeWhitespace = function(a2) {
    return a2.replace(/\xa0|\s/g, " ");
  };
  goog.string.normalizeSpaces = function(a2) {
    return a2.replace(/\xa0|[ \t]+/g, " ");
  };
  goog.string.collapseBreakingSpaces = function(a2) {
    return a2.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
  };
  goog.string.trim = goog.string.internal.trim;
  goog.string.trimLeft = function(a2) {
    return a2.replace(/^[\s\xa0]+/, "");
  };
  goog.string.trimRight = function(a2) {
    return a2.replace(/[\s\xa0]+$/, "");
  };
  goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare;
  goog.string.numberAwareCompare_ = function(a2, b, c) {
    if (a2 == b)
      return 0;
    if (!a2)
      return -1;
    if (!b)
      return 1;
    for (var d = a2.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++) {
      c = d[g];
      var h = e[g];
      if (c != h)
        return a2 = parseInt(c, 10), !isNaN(a2) && (b = parseInt(h, 10), !isNaN(b) && a2 - b) ? a2 - b : c < h ? -1 : 1;
    }
    return d.length != e.length ? d.length - e.length : a2 < b ? -1 : 1;
  };
  goog.string.intAwareCompare = function(a2, b) {
    return goog.string.numberAwareCompare_(a2, b, /\d+|\D+/g);
  };
  goog.string.floatAwareCompare = function(a2, b) {
    return goog.string.numberAwareCompare_(a2, b, /\d+|\.\d+|\D+/g);
  };
  goog.string.numerateCompare = goog.string.floatAwareCompare;
  goog.string.urlEncode = function(a2) {
    return encodeURIComponent(String(a2));
  };
  goog.string.urlDecode = function(a2) {
    return decodeURIComponent(a2.replace(/\+/g, " "));
  };
  goog.string.newLineToBr = goog.string.internal.newLineToBr;
  goog.string.htmlEscape = function(a2, b) {
    a2 = goog.string.internal.htmlEscape(a2, b);
    goog.string.DETECT_DOUBLE_ESCAPING && (a2 = a2.replace(goog.string.E_RE_, "&#101;"));
    return a2;
  };
  goog.string.E_RE_ = /e/g;
  goog.string.unescapeEntities = function(a2) {
    return goog.string.contains(a2, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a2) : goog.string.unescapePureXmlEntities_(a2) : a2;
  };
  goog.string.unescapeEntitiesWithDocument = function(a2, b) {
    return goog.string.contains(a2, "&") ? goog.string.unescapeEntitiesUsingDom_(a2, b) : a2;
  };
  goog.string.unescapeEntitiesUsingDom_ = function(a2, b) {
    var c = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"' };
    var d = b ? b.createElement("div") : goog.global.document.createElement("div");
    return a2.replace(goog.string.HTML_ENTITY_PATTERN_, function(a3, b2) {
      var e = c[a3];
      if (e)
        return e;
      b2.charAt(0) == "#" && (b2 = Number("0" + b2.substr(1)), isNaN(b2) || (e = String.fromCharCode(b2)));
      e || (goog.dom.safe.setInnerHtml(d, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), a3 + " ")), e = d.firstChild.nodeValue.slice(0, -1));
      return c[a3] = e;
    });
  };
  goog.string.unescapePureXmlEntities_ = function(a2) {
    return a2.replace(/&([^;]+);/g, function(a3, c) {
      switch (c) {
        case "amp":
          return "&";
        case "lt":
          return "<";
        case "gt":
          return ">";
        case "quot":
          return '"';
        default:
          return c.charAt(0) != "#" || (c = Number("0" + c.substr(1)), isNaN(c)) ? a3 : String.fromCharCode(c);
      }
    });
  };
  goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;
  goog.string.whitespaceEscape = function(a2, b) {
    return goog.string.newLineToBr(a2.replace(/  /g, " &#160;"), b);
  };
  goog.string.preserveSpaces = function(a2) {
    return a2.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
  };
  goog.string.stripQuotes = function(a2, b) {
    for (var c = b.length, d = 0; d < c; d++) {
      var e = c == 1 ? b : b.charAt(d);
      if (a2.charAt(0) == e && a2.charAt(a2.length - 1) == e)
        return a2.substring(1, a2.length - 1);
    }
    return a2;
  };
  goog.string.truncate = function(a2, b, c) {
    c && (a2 = goog.string.unescapeEntities(a2));
    a2.length > b && (a2 = a2.substring(0, b - 3) + "...");
    c && (a2 = goog.string.htmlEscape(a2));
    return a2;
  };
  goog.string.truncateMiddle = function(a2, b, c, d) {
    c && (a2 = goog.string.unescapeEntities(a2));
    if (d && a2.length > b) {
      d > b && (d = b);
      var e = a2.length - d;
      a2 = a2.substring(0, b - d) + "..." + a2.substring(e);
    } else
      a2.length > b && (d = Math.floor(b / 2), e = a2.length - d, a2 = a2.substring(0, d + b % 2) + "..." + a2.substring(e));
    c && (a2 = goog.string.htmlEscape(a2));
    return a2;
  };
  goog.string.specialEscapeChars_ = { "\0": "\\0", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t", "\v": "\\x0B", '"': '\\"', "\\": "\\\\", "<": "\\u003C" };
  goog.string.jsEscapeCache_ = { "'": "\\'" };
  goog.string.quote = function(a2) {
    a2 = String(a2);
    for (var b = ['"'], c = 0; c < a2.length; c++) {
      var d = a2.charAt(c), e = d.charCodeAt(0);
      b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
    }
    b.push('"');
    return b.join("");
  };
  goog.string.escapeString = function(a2) {
    for (var b = [], c = 0; c < a2.length; c++)
      b[c] = goog.string.escapeChar(a2.charAt(c));
    return b.join("");
  };
  goog.string.escapeChar = function(a2) {
    if (a2 in goog.string.jsEscapeCache_)
      return goog.string.jsEscapeCache_[a2];
    if (a2 in goog.string.specialEscapeChars_)
      return goog.string.jsEscapeCache_[a2] = goog.string.specialEscapeChars_[a2];
    var b = a2.charCodeAt(0);
    if (31 < b && 127 > b)
      var c = a2;
    else {
      if (256 > b) {
        if (c = "\\x", 16 > b || 256 < b)
          c += "0";
      } else
        c = "\\u", 4096 > b && (c += "0");
      c += b.toString(16).toUpperCase();
    }
    return goog.string.jsEscapeCache_[a2] = c;
  };
  goog.string.contains = goog.string.internal.contains;
  goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains;
  goog.string.countOf = function(a2, b) {
    return a2 && b ? a2.split(b).length - 1 : 0;
  };
  goog.string.removeAt = function(a2, b, c) {
    var d = a2;
    0 <= b && b < a2.length && 0 < c && (d = a2.substr(0, b) + a2.substr(b + c, a2.length - b - c));
    return d;
  };
  goog.string.remove = function(a2, b) {
    return a2.replace(b, "");
  };
  goog.string.removeAll = function(a2, b) {
    b = new RegExp(goog.string.regExpEscape(b), "g");
    return a2.replace(b, "");
  };
  goog.string.replaceAll = function(a2, b, c) {
    b = new RegExp(goog.string.regExpEscape(b), "g");
    return a2.replace(b, c.replace(/\$/g, "$$$$"));
  };
  goog.string.regExpEscape = function(a2) {
    return String(a2).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
  };
  goog.string.repeat = String.prototype.repeat ? function(a2, b) {
    return a2.repeat(b);
  } : function(a2, b) {
    return Array(b + 1).join(a2);
  };
  goog.string.padNumber = function(a2, b, c) {
    a2 = goog.isDef(c) ? a2.toFixed(c) : String(a2);
    c = a2.indexOf(".");
    c == -1 && (c = a2.length);
    return goog.string.repeat("0", Math.max(0, b - c)) + a2;
  };
  goog.string.makeSafe = function(a2) {
    return a2 == null ? "" : String(a2);
  };
  goog.string.buildString = function(a2) {
    return Array.prototype.join.call(arguments, "");
  };
  goog.string.getRandomString = function() {
    return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
  };
  goog.string.compareVersions = goog.string.internal.compareVersions;
  goog.string.hashCode = function(a2) {
    for (var b = 0, c = 0; c < a2.length; ++c)
      b = 31 * b + a2.charCodeAt(c) >>> 0;
    return b;
  };
  goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;
  goog.string.createUniqueString = function() {
    return "goog_" + goog.string.uniqueStringCounter_++;
  };
  goog.string.toNumber = function(a2) {
    var b = Number(a2);
    return b == 0 && goog.string.isEmptyOrWhitespace(a2) ? NaN : b;
  };
  goog.string.isLowerCamelCase = function(a2) {
    return /^[a-z]+([A-Z][a-z]*)*$/.test(a2);
  };
  goog.string.isUpperCamelCase = function(a2) {
    return /^([A-Z][a-z]*)+$/.test(a2);
  };
  goog.string.toCamelCase = function(a2) {
    return String(a2).replace(/\-([a-z])/g, function(a3, c) {
      return c.toUpperCase();
    });
  };
  goog.string.toSelectorCase = function(a2) {
    return String(a2).replace(/([A-Z])/g, "-$1").toLowerCase();
  };
  goog.string.toTitleCase = function(a2, b) {
    b = goog.isString(b) ? goog.string.regExpEscape(b) : "\\s";
    return a2.replace(new RegExp("(^" + (b ? "|[" + b + "]+" : "") + ")([a-z])", "g"), function(a3, b2, e) {
      return b2 + e.toUpperCase();
    });
  };
  goog.string.capitalize = function(a2) {
    return String(a2.charAt(0)).toUpperCase() + String(a2.substr(1)).toLowerCase();
  };
  goog.string.parseInt = function(a2) {
    isFinite(a2) && (a2 = String(a2));
    return goog.isString(a2) ? /^\s*-?0x/i.test(a2) ? parseInt(a2, 16) : parseInt(a2, 10) : NaN;
  };
  goog.string.splitLimit = function(a2, b, c) {
    a2 = a2.split(b);
    for (var d = []; 0 < c && a2.length; )
      d.push(a2.shift()), c--;
    a2.length && d.push(a2.join(b));
    return d;
  };
  goog.string.lastComponent = function(a2, b) {
    if (b)
      typeof b == "string" && (b = [b]);
    else
      return a2;
    for (var c = -1, d = 0; d < b.length; d++)
      if (b[d] != "") {
        var e = a2.lastIndexOf(b[d]);
        e > c && (c = e);
      }
    return c == -1 ? a2 : a2.slice(c + 1);
  };
  goog.string.editDistance = function(a2, b) {
    var c = [], d = [];
    if (a2 == b)
      return 0;
    if (!a2.length || !b.length)
      return Math.max(a2.length, b.length);
    for (var e = 0; e < b.length + 1; e++)
      c[e] = e;
    for (e = 0; e < a2.length; e++) {
      d[0] = e + 1;
      for (var f = 0; f < b.length; f++)
        d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a2[e] != b[f]));
      for (f = 0; f < c.length; f++)
        c[f] = d[f];
    }
    return d[b.length];
  };
  goog.labs.userAgent.engine = {};
  goog.labs.userAgent.engine.isPresto = function() {
    return goog.labs.userAgent.util.matchUserAgent("Presto");
  };
  goog.labs.userAgent.engine.isTrident = function() {
    return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
  };
  goog.labs.userAgent.engine.isEdge = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edge");
  };
  goog.labs.userAgent.engine.isWebKit = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit") && !goog.labs.userAgent.engine.isEdge();
  };
  goog.labs.userAgent.engine.isGecko = function() {
    return goog.labs.userAgent.util.matchUserAgent("Gecko") && !goog.labs.userAgent.engine.isWebKit() && !goog.labs.userAgent.engine.isTrident() && !goog.labs.userAgent.engine.isEdge();
  };
  goog.labs.userAgent.engine.getVersion = function() {
    var a2 = goog.labs.userAgent.util.getUserAgent();
    if (a2) {
      a2 = goog.labs.userAgent.util.extractVersionTuples(a2);
      var b = goog.labs.userAgent.engine.getEngineTuple_(a2);
      if (b)
        return b[0] == "Gecko" ? goog.labs.userAgent.engine.getVersionForKey_(a2, "Firefox") : b[1];
      a2 = a2[0];
      var c;
      if (a2 && (c = a2[2]) && (c = /Trident\/([^\s;]+)/.exec(c)))
        return c[1];
    }
    return "";
  };
  goog.labs.userAgent.engine.getEngineTuple_ = function(a2) {
    if (!goog.labs.userAgent.engine.isEdge())
      return a2[1];
    for (var b = 0; b < a2.length; b++) {
      var c = a2[b];
      if (c[0] == "Edge")
        return c;
    }
  };
  goog.labs.userAgent.engine.isVersionOrHigher = function(a2) {
    return 0 <= goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(), a2);
  };
  goog.labs.userAgent.engine.getVersionForKey_ = function(a2, b) {
    return (a2 = goog.array.find(a2, function(a3) {
      return b == a3[0];
    })) && a2[1] || "";
  };
  goog.labs.userAgent.platform = {};
  goog.labs.userAgent.platform.isAndroid = function() {
    return goog.labs.userAgent.util.matchUserAgent("Android");
  };
  goog.labs.userAgent.platform.isIpod = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPod");
  };
  goog.labs.userAgent.platform.isIphone = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPhone") && !goog.labs.userAgent.util.matchUserAgent("iPod") && !goog.labs.userAgent.util.matchUserAgent("iPad");
  };
  goog.labs.userAgent.platform.isIpad = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPad");
  };
  goog.labs.userAgent.platform.isIos = function() {
    return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpad() || goog.labs.userAgent.platform.isIpod();
  };
  goog.labs.userAgent.platform.isMacintosh = function() {
    return goog.labs.userAgent.util.matchUserAgent("Macintosh");
  };
  goog.labs.userAgent.platform.isLinux = function() {
    return goog.labs.userAgent.util.matchUserAgent("Linux");
  };
  goog.labs.userAgent.platform.isWindows = function() {
    return goog.labs.userAgent.util.matchUserAgent("Windows");
  };
  goog.labs.userAgent.platform.isChromeOS = function() {
    return goog.labs.userAgent.util.matchUserAgent("CrOS");
  };
  goog.labs.userAgent.platform.isChromecast = function() {
    return goog.labs.userAgent.util.matchUserAgent("CrKey");
  };
  goog.labs.userAgent.platform.isKaiOS = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("KaiOS");
  };
  goog.labs.userAgent.platform.isGo2Phone = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("GAFP");
  };
  goog.labs.userAgent.platform.getVersion = function() {
    var a2 = goog.labs.userAgent.util.getUserAgent(), b = "";
    goog.labs.userAgent.platform.isWindows() ? (b = /Windows (?:NT|Phone) ([0-9.]+)/, b = (a2 = b.exec(a2)) ? a2[1] : "0.0") : goog.labs.userAgent.platform.isIos() ? (b = /(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/, b = (a2 = b.exec(a2)) && a2[1].replace(/_/g, ".")) : goog.labs.userAgent.platform.isMacintosh() ? (b = /Mac OS X ([0-9_.]+)/, b = (a2 = b.exec(a2)) ? a2[1].replace(/_/g, ".") : "10") : goog.labs.userAgent.platform.isKaiOS() ? (b = /(?:KaiOS)\/(\S+)/i, b = (a2 = b.exec(a2)) && a2[1]) : goog.labs.userAgent.platform.isAndroid() ? (b = /Android\s+([^\);]+)(\)|;)/, b = (a2 = b.exec(a2)) && a2[1]) : goog.labs.userAgent.platform.isChromeOS() && (b = /(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/, b = (a2 = b.exec(a2)) && a2[1]);
    return b || "";
  };
  goog.labs.userAgent.platform.isVersionOrHigher = function(a2) {
    return 0 <= goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(), a2);
  };
  goog.reflect = {};
  goog.reflect.object = function(a2, b) {
    return b;
  };
  goog.reflect.objectProperty = function(a2, b) {
    return a2;
  };
  goog.reflect.sinkValue = function(a2) {
    goog.reflect.sinkValue[" "](a2);
    return a2;
  };
  goog.reflect.sinkValue[" "] = goog.nullFunction;
  goog.reflect.canAccessProperty = function(a2, b) {
    try {
      return goog.reflect.sinkValue(a2[b]), true;
    } catch (c) {
    }
    return false;
  };
  goog.reflect.cache = function(a2, b, c, d) {
    d = d ? d(b) : b;
    return Object.prototype.hasOwnProperty.call(a2, d) ? a2[d] : a2[d] = c(b);
  };
  goog.userAgent = {};
  goog.userAgent.ASSUME_IE = false;
  goog.userAgent.ASSUME_EDGE = false;
  goog.userAgent.ASSUME_GECKO = false;
  goog.userAgent.ASSUME_WEBKIT = false;
  goog.userAgent.ASSUME_MOBILE_WEBKIT = false;
  goog.userAgent.ASSUME_OPERA = false;
  goog.userAgent.ASSUME_ANY_VERSION = false;
  goog.userAgent.BROWSER_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_GECKO || goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_OPERA;
  goog.userAgent.getUserAgentString = function() {
    return goog.labs.userAgent.util.getUserAgent();
  };
  goog.userAgent.getNavigatorTyped = function() {
    return goog.global.navigator || null;
  };
  goog.userAgent.getNavigator = function() {
    return goog.userAgent.getNavigatorTyped();
  };
  goog.userAgent.OPERA = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_OPERA : goog.labs.userAgent.browser.isOpera();
  goog.userAgent.IE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_IE : goog.labs.userAgent.browser.isIE();
  goog.userAgent.EDGE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_EDGE : goog.labs.userAgent.engine.isEdge();
  goog.userAgent.EDGE_OR_IE = goog.userAgent.EDGE || goog.userAgent.IE;
  goog.userAgent.GECKO = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_GECKO : goog.labs.userAgent.engine.isGecko();
  goog.userAgent.WEBKIT = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_MOBILE_WEBKIT : goog.labs.userAgent.engine.isWebKit();
  goog.userAgent.isMobile_ = function() {
    return goog.userAgent.WEBKIT && goog.labs.userAgent.util.matchUserAgent("Mobile");
  };
  goog.userAgent.MOBILE = goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.isMobile_();
  goog.userAgent.SAFARI = goog.userAgent.WEBKIT;
  goog.userAgent.determinePlatform_ = function() {
    var a2 = goog.userAgent.getNavigatorTyped();
    return a2 && a2.platform || "";
  };
  goog.userAgent.PLATFORM = goog.userAgent.determinePlatform_();
  goog.userAgent.ASSUME_MAC = false;
  goog.userAgent.ASSUME_WINDOWS = false;
  goog.userAgent.ASSUME_LINUX = false;
  goog.userAgent.ASSUME_X11 = false;
  goog.userAgent.ASSUME_ANDROID = false;
  goog.userAgent.ASSUME_IPHONE = false;
  goog.userAgent.ASSUME_IPAD = false;
  goog.userAgent.ASSUME_IPOD = false;
  goog.userAgent.ASSUME_KAIOS = false;
  goog.userAgent.ASSUME_GO2PHONE = false;
  goog.userAgent.PLATFORM_KNOWN_ = goog.userAgent.ASSUME_MAC || goog.userAgent.ASSUME_WINDOWS || goog.userAgent.ASSUME_LINUX || goog.userAgent.ASSUME_X11 || goog.userAgent.ASSUME_ANDROID || goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD;
  goog.userAgent.MAC = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_MAC : goog.labs.userAgent.platform.isMacintosh();
  goog.userAgent.WINDOWS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_WINDOWS : goog.labs.userAgent.platform.isWindows();
  goog.userAgent.isLegacyLinux_ = function() {
    return goog.labs.userAgent.platform.isLinux() || goog.labs.userAgent.platform.isChromeOS();
  };
  goog.userAgent.LINUX = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_LINUX : goog.userAgent.isLegacyLinux_();
  goog.userAgent.isX11_ = function() {
    var a2 = goog.userAgent.getNavigatorTyped();
    return !!a2 && goog.string.contains(a2.appVersion || "", "X11");
  };
  goog.userAgent.X11 = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_X11 : goog.userAgent.isX11_();
  goog.userAgent.ANDROID = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_ANDROID : goog.labs.userAgent.platform.isAndroid();
  goog.userAgent.IPHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE : goog.labs.userAgent.platform.isIphone();
  goog.userAgent.IPAD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad();
  goog.userAgent.IPOD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIpod();
  goog.userAgent.IOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIos();
  goog.userAgent.KAIOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_KAIOS : goog.labs.userAgent.platform.isKaiOS();
  goog.userAgent.GO2PHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_GO2PHONE : goog.labs.userAgent.platform.isGo2Phone();
  goog.userAgent.determineVersion_ = function() {
    var a2 = "", b = goog.userAgent.getVersionRegexResult_();
    b && (a2 = b ? b[1] : "");
    return goog.userAgent.IE && (b = goog.userAgent.getDocumentMode_(), b != null && b > parseFloat(a2)) ? String(b) : a2;
  };
  goog.userAgent.getVersionRegexResult_ = function() {
    var a2 = goog.userAgent.getUserAgentString();
    if (goog.userAgent.GECKO)
      return /rv:([^\);]+)(\)|;)/.exec(a2);
    if (goog.userAgent.EDGE)
      return /Edge\/([\d\.]+)/.exec(a2);
    if (goog.userAgent.IE)
      return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a2);
    if (goog.userAgent.WEBKIT)
      return /WebKit\/(\S+)/.exec(a2);
    if (goog.userAgent.OPERA)
      return /(?:Version)[ \/]?(\S+)/.exec(a2);
  };
  goog.userAgent.getDocumentMode_ = function() {
    var a2 = goog.global.document;
    return a2 ? a2.documentMode : void 0;
  };
  goog.userAgent.VERSION = goog.userAgent.determineVersion_();
  goog.userAgent.compare = function(a2, b) {
    return goog.string.compareVersions(a2, b);
  };
  goog.userAgent.isVersionOrHigherCache_ = {};
  goog.userAgent.isVersionOrHigher = function(a2) {
    return goog.userAgent.ASSUME_ANY_VERSION || goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_, a2, function() {
      return 0 <= goog.string.compareVersions(goog.userAgent.VERSION, a2);
    });
  };
  goog.userAgent.isVersion = goog.userAgent.isVersionOrHigher;
  goog.userAgent.isDocumentModeOrHigher = function(a2) {
    return Number(goog.userAgent.DOCUMENT_MODE) >= a2;
  };
  goog.userAgent.isDocumentMode = goog.userAgent.isDocumentModeOrHigher;
  goog.userAgent.DOCUMENT_MODE = function() {
    if (goog.global.document && goog.userAgent.IE)
      return goog.userAgent.getDocumentMode_();
  }();
  goog.userAgent.product = {};
  goog.userAgent.product.ASSUME_FIREFOX = false;
  goog.userAgent.product.ASSUME_IPHONE = false;
  goog.userAgent.product.ASSUME_IPAD = false;
  goog.userAgent.product.ASSUME_ANDROID = false;
  goog.userAgent.product.ASSUME_CHROME = false;
  goog.userAgent.product.ASSUME_SAFARI = false;
  goog.userAgent.product.PRODUCT_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_OPERA || goog.userAgent.product.ASSUME_FIREFOX || goog.userAgent.product.ASSUME_IPHONE || goog.userAgent.product.ASSUME_IPAD || goog.userAgent.product.ASSUME_ANDROID || goog.userAgent.product.ASSUME_CHROME || goog.userAgent.product.ASSUME_SAFARI;
  goog.userAgent.product.OPERA = goog.userAgent.OPERA;
  goog.userAgent.product.IE = goog.userAgent.IE;
  goog.userAgent.product.EDGE = goog.userAgent.EDGE;
  goog.userAgent.product.FIREFOX = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_FIREFOX : goog.labs.userAgent.browser.isFirefox();
  goog.userAgent.product.isIphoneOrIpod_ = function() {
    return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpod();
  };
  goog.userAgent.product.IPHONE = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPHONE : goog.userAgent.product.isIphoneOrIpod_();
  goog.userAgent.product.IPAD = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad();
  goog.userAgent.product.ANDROID = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_ANDROID : goog.labs.userAgent.browser.isAndroidBrowser();
  goog.userAgent.product.CHROME = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_CHROME : goog.labs.userAgent.browser.isChrome();
  goog.userAgent.product.isSafariDesktop_ = function() {
    return goog.labs.userAgent.browser.isSafari() && !goog.labs.userAgent.platform.isIos();
  };
  goog.userAgent.product.SAFARI = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_SAFARI : goog.userAgent.product.isSafariDesktop_();
  goog.crypt.base64 = {};
  goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  goog.crypt.base64.ENCODED_VALS = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "+/=";
  goog.crypt.base64.ENCODED_VALS_WEBSAFE = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "-_.";
  goog.crypt.base64.Alphabet = { DEFAULT: 0, NO_PADDING: 1, WEBSAFE: 2, WEBSAFE_DOT_PADDING: 3, WEBSAFE_NO_PADDING: 4 };
  goog.crypt.base64.paddingChars_ = "=.";
  goog.crypt.base64.isPadding_ = function(a2) {
    return goog.string.contains(goog.crypt.base64.paddingChars_, a2);
  };
  goog.crypt.base64.byteToCharMaps_ = {};
  goog.crypt.base64.charToByteMap_ = null;
  goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ = goog.userAgent.GECKO || goog.userAgent.WEBKIT && !goog.userAgent.product.SAFARI || goog.userAgent.OPERA;
  goog.crypt.base64.HAS_NATIVE_ENCODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || typeof goog.global.btoa == "function";
  goog.crypt.base64.HAS_NATIVE_DECODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || !goog.userAgent.product.SAFARI && !goog.userAgent.IE && typeof goog.global.atob == "function";
  goog.crypt.base64.encodeByteArray = function(a2, b) {
    goog.asserts.assert(goog.isArrayLike(a2), "encodeByteArray takes an array as a parameter");
    b === void 0 && (b = goog.crypt.base64.Alphabet.DEFAULT);
    goog.crypt.base64.init_();
    b = goog.crypt.base64.byteToCharMaps_[b];
    for (var c = [], d = 0; d < a2.length; d += 3) {
      var e = a2[d], f = d + 1 < a2.length, g = f ? a2[d + 1] : 0, h = d + 2 < a2.length, k = h ? a2[d + 2] : 0, l = e >> 2;
      e = (e & 3) << 4 | g >> 4;
      g = (g & 15) << 2 | k >> 6;
      k &= 63;
      h || (k = 64, f || (g = 64));
      c.push(b[l], b[e], b[g] || "", b[k] || "");
    }
    return c.join("");
  };
  goog.crypt.base64.encodeString = function(a2, b) {
    return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !b ? goog.global.btoa(a2) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(a2), b);
  };
  goog.crypt.base64.decodeString = function(a2, b) {
    if (goog.crypt.base64.HAS_NATIVE_DECODE_ && !b)
      return goog.global.atob(a2);
    var c = "";
    goog.crypt.base64.decodeStringInternal_(a2, function(a3) {
      c += String.fromCharCode(a3);
    });
    return c;
  };
  goog.crypt.base64.decodeStringToByteArray = function(a2, b) {
    var c = [];
    goog.crypt.base64.decodeStringInternal_(a2, function(a3) {
      c.push(a3);
    });
    return c;
  };
  goog.crypt.base64.decodeStringToUint8Array = function(a2) {
    goog.asserts.assert(!goog.userAgent.IE || goog.userAgent.isVersionOrHigher("10"), "Browser does not support typed arrays");
    var b = a2.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : goog.crypt.base64.isPadding_(a2[b - 1]) && (c = goog.crypt.base64.isPadding_(a2[b - 2]) ? c - 2 : c - 1);
    var d = new Uint8Array(c), e = 0;
    goog.crypt.base64.decodeStringInternal_(a2, function(a3) {
      d[e++] = a3;
    });
    return d.subarray(0, e);
  };
  goog.crypt.base64.decodeStringInternal_ = function(a2, b) {
    function c(b2) {
      for (; d < a2.length; ) {
        var c2 = a2.charAt(d++), e2 = goog.crypt.base64.charToByteMap_[c2];
        if (e2 != null)
          return e2;
        if (!goog.string.isEmptyOrWhitespace(c2))
          throw Error("Unknown base64 encoding at char: " + c2);
      }
      return b2;
    }
    goog.crypt.base64.init_();
    for (var d = 0; ; ) {
      var e = c(-1), f = c(0), g = c(64), h = c(64);
      if (h === 64 && e === -1)
        break;
      b(e << 2 | f >> 4);
      g != 64 && (b(f << 4 & 240 | g >> 2), h != 64 && b(g << 6 & 192 | h));
    }
  };
  goog.crypt.base64.init_ = function() {
    if (!goog.crypt.base64.charToByteMap_) {
      goog.crypt.base64.charToByteMap_ = {};
      for (var a2 = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
        var d = a2.concat(b[c].split(""));
        goog.crypt.base64.byteToCharMaps_[c] = d;
        for (var e = 0; e < d.length; e++) {
          var f = d[e], g = goog.crypt.base64.charToByteMap_[f];
          g === void 0 ? goog.crypt.base64.charToByteMap_[f] = e : goog.asserts.assert(g === e);
        }
      }
    }
  };
  jspb.utils = {};
  jspb.utils.split64Low = 0;
  jspb.utils.split64High = 0;
  jspb.utils.splitUint64 = function(a2) {
    var b = a2 >>> 0;
    a2 = Math.floor((a2 - b) / jspb.BinaryConstants.TWO_TO_32) >>> 0;
    jspb.utils.split64Low = b;
    jspb.utils.split64High = a2;
  };
  jspb.utils.splitInt64 = function(a2) {
    var b = 0 > a2;
    a2 = Math.abs(a2);
    var c = a2 >>> 0;
    a2 = Math.floor((a2 - c) / jspb.BinaryConstants.TWO_TO_32);
    a2 >>>= 0;
    b && (a2 = ~a2 >>> 0, c = (~c >>> 0) + 1, 4294967295 < c && (c = 0, a2++, 4294967295 < a2 && (a2 = 0)));
    jspb.utils.split64Low = c;
    jspb.utils.split64High = a2;
  };
  jspb.utils.splitZigzag64 = function(a2) {
    var b = 0 > a2;
    a2 = 2 * Math.abs(a2);
    jspb.utils.splitUint64(a2);
    a2 = jspb.utils.split64Low;
    var c = jspb.utils.split64High;
    b && (a2 == 0 ? c == 0 ? c = a2 = 4294967295 : (c--, a2 = 4294967295) : a2--);
    jspb.utils.split64Low = a2;
    jspb.utils.split64High = c;
  };
  jspb.utils.splitFloat32 = function(a2) {
    var b = 0 > a2 ? 1 : 0;
    a2 = b ? -a2 : a2;
    if (a2 === 0)
      0 < 1 / a2 ? (jspb.utils.split64High = 0, jspb.utils.split64Low = 0) : (jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483648);
    else if (isNaN(a2))
      jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483647;
    else if (a2 > jspb.BinaryConstants.FLOAT32_MAX)
      jspb.utils.split64High = 0, jspb.utils.split64Low = (b << 31 | 2139095040) >>> 0;
    else if (a2 < jspb.BinaryConstants.FLOAT32_MIN)
      a2 = Math.round(a2 / Math.pow(2, -149)), jspb.utils.split64High = 0, jspb.utils.split64Low = (b << 31 | a2) >>> 0;
    else {
      var c = Math.floor(Math.log(a2) / Math.LN2);
      a2 *= Math.pow(2, -c);
      a2 = Math.round(a2 * jspb.BinaryConstants.TWO_TO_23);
      16777216 <= a2 && ++c;
      jspb.utils.split64High = 0;
      jspb.utils.split64Low = (b << 31 | c + 127 << 23 | a2 & 8388607) >>> 0;
    }
  };
  jspb.utils.splitFloat64 = function(a2) {
    var b = 0 > a2 ? 1 : 0;
    a2 = b ? -a2 : a2;
    if (a2 === 0)
      jspb.utils.split64High = 0 < 1 / a2 ? 0 : 2147483648, jspb.utils.split64Low = 0;
    else if (isNaN(a2))
      jspb.utils.split64High = 2147483647, jspb.utils.split64Low = 4294967295;
    else if (a2 > jspb.BinaryConstants.FLOAT64_MAX)
      jspb.utils.split64High = (b << 31 | 2146435072) >>> 0, jspb.utils.split64Low = 0;
    else if (a2 < jspb.BinaryConstants.FLOAT64_MIN) {
      var c = a2 / Math.pow(2, -1074);
      a2 = c / jspb.BinaryConstants.TWO_TO_32;
      jspb.utils.split64High = (b << 31 | a2) >>> 0;
      jspb.utils.split64Low = c >>> 0;
    } else {
      c = a2;
      var d = 0;
      if (2 <= c)
        for (; 2 <= c && 1023 > d; )
          d++, c /= 2;
      else
        for (; 1 > c && -1022 < d; )
          c *= 2, d--;
      c = a2 * Math.pow(2, -d);
      a2 = c * jspb.BinaryConstants.TWO_TO_20 & 1048575;
      c = c * jspb.BinaryConstants.TWO_TO_52 >>> 0;
      jspb.utils.split64High = (b << 31 | d + 1023 << 20 | a2) >>> 0;
      jspb.utils.split64Low = c;
    }
  };
  jspb.utils.splitHash64 = function(a2) {
    var b = a2.charCodeAt(0), c = a2.charCodeAt(1), d = a2.charCodeAt(2), e = a2.charCodeAt(3), f = a2.charCodeAt(4), g = a2.charCodeAt(5), h = a2.charCodeAt(6);
    a2 = a2.charCodeAt(7);
    jspb.utils.split64Low = b + (c << 8) + (d << 16) + (e << 24) >>> 0;
    jspb.utils.split64High = f + (g << 8) + (h << 16) + (a2 << 24) >>> 0;
  };
  jspb.utils.joinUint64 = function(a2, b) {
    return b * jspb.BinaryConstants.TWO_TO_32 + (a2 >>> 0);
  };
  jspb.utils.joinInt64 = function(a2, b) {
    var c = b & 2147483648;
    c && (a2 = ~a2 + 1 >>> 0, b = ~b >>> 0, a2 == 0 && (b = b + 1 >>> 0));
    a2 = jspb.utils.joinUint64(a2, b);
    return c ? -a2 : a2;
  };
  jspb.utils.toZigzag64 = function(a2, b, c) {
    var d = b >> 31;
    return c(a2 << 1 ^ d, (b << 1 | a2 >>> 31) ^ d);
  };
  jspb.utils.joinZigzag64 = function(a2, b) {
    return jspb.utils.fromZigzag64(a2, b, jspb.utils.joinInt64);
  };
  jspb.utils.fromZigzag64 = function(a2, b, c) {
    var d = -(a2 & 1);
    return c((a2 >>> 1 | b << 31) ^ d, b >>> 1 ^ d);
  };
  jspb.utils.joinFloat32 = function(a2, b) {
    b = 2 * (a2 >> 31) + 1;
    var c = a2 >>> 23 & 255;
    a2 &= 8388607;
    return c == 255 ? a2 ? NaN : Infinity * b : c == 0 ? b * Math.pow(2, -149) * a2 : b * Math.pow(2, c - 150) * (a2 + Math.pow(2, 23));
  };
  jspb.utils.joinFloat64 = function(a2, b) {
    var c = 2 * (b >> 31) + 1, d = b >>> 20 & 2047;
    a2 = jspb.BinaryConstants.TWO_TO_32 * (b & 1048575) + a2;
    return d == 2047 ? a2 ? NaN : Infinity * c : d == 0 ? c * Math.pow(2, -1074) * a2 : c * Math.pow(2, d - 1075) * (a2 + jspb.BinaryConstants.TWO_TO_52);
  };
  jspb.utils.joinHash64 = function(a2, b) {
    return String.fromCharCode(a2 >>> 0 & 255, a2 >>> 8 & 255, a2 >>> 16 & 255, a2 >>> 24 & 255, b >>> 0 & 255, b >>> 8 & 255, b >>> 16 & 255, b >>> 24 & 255);
  };
  jspb.utils.DIGITS = "0123456789abcdef".split("");
  jspb.utils.ZERO_CHAR_CODE_ = 48;
  jspb.utils.A_CHAR_CODE_ = 97;
  jspb.utils.joinUnsignedDecimalString = function(a2, b) {
    function c(a3, b2) {
      a3 = a3 ? String(a3) : "";
      return b2 ? "0000000".slice(a3.length) + a3 : a3;
    }
    if (2097151 >= b)
      return "" + jspb.utils.joinUint64(a2, b);
    var d = (a2 >>> 24 | b << 8) >>> 0 & 16777215;
    b = b >> 16 & 65535;
    a2 = (a2 & 16777215) + 6777216 * d + 6710656 * b;
    d += 8147497 * b;
    b *= 2;
    1e7 <= a2 && (d += Math.floor(a2 / 1e7), a2 %= 1e7);
    1e7 <= d && (b += Math.floor(d / 1e7), d %= 1e7);
    return c(b, 0) + c(d, b) + c(a2, 1);
  };
  jspb.utils.joinSignedDecimalString = function(a2, b) {
    var c = b & 2147483648;
    c && (a2 = ~a2 + 1 >>> 0, b = ~b + (a2 == 0 ? 1 : 0) >>> 0);
    a2 = jspb.utils.joinUnsignedDecimalString(a2, b);
    return c ? "-" + a2 : a2;
  };
  jspb.utils.hash64ToDecimalString = function(a2, b) {
    jspb.utils.splitHash64(a2);
    a2 = jspb.utils.split64Low;
    var c = jspb.utils.split64High;
    return b ? jspb.utils.joinSignedDecimalString(a2, c) : jspb.utils.joinUnsignedDecimalString(a2, c);
  };
  jspb.utils.hash64ArrayToDecimalStrings = function(a2, b) {
    for (var c = Array(a2.length), d = 0; d < a2.length; d++)
      c[d] = jspb.utils.hash64ToDecimalString(a2[d], b);
    return c;
  };
  jspb.utils.decimalStringToHash64 = function(a2) {
    function b(a3, b2) {
      for (var c2 = 0; 8 > c2 && (a3 !== 1 || 0 < b2); c2++)
        b2 = a3 * e[c2] + b2, e[c2] = b2 & 255, b2 >>>= 8;
    }
    function c() {
      for (var a3 = 0; 8 > a3; a3++)
        e[a3] = ~e[a3] & 255;
    }
    goog.asserts.assert(0 < a2.length);
    var d = false;
    a2[0] === "-" && (d = true, a2 = a2.slice(1));
    for (var e = [0, 0, 0, 0, 0, 0, 0, 0], f = 0; f < a2.length; f++)
      b(10, a2.charCodeAt(f) - jspb.utils.ZERO_CHAR_CODE_);
    d && (c(), b(1, 1));
    return goog.crypt.byteArrayToString(e);
  };
  jspb.utils.splitDecimalString = function(a2) {
    jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a2));
  };
  jspb.utils.toHexDigit_ = function(a2) {
    return String.fromCharCode(10 > a2 ? jspb.utils.ZERO_CHAR_CODE_ + a2 : jspb.utils.A_CHAR_CODE_ - 10 + a2);
  };
  jspb.utils.fromHexCharCode_ = function(a2) {
    return a2 >= jspb.utils.A_CHAR_CODE_ ? a2 - jspb.utils.A_CHAR_CODE_ + 10 : a2 - jspb.utils.ZERO_CHAR_CODE_;
  };
  jspb.utils.hash64ToHexString = function(a2) {
    var b = Array(18);
    b[0] = "0";
    b[1] = "x";
    for (var c = 0; 8 > c; c++) {
      var d = a2.charCodeAt(7 - c);
      b[2 * c + 2] = jspb.utils.toHexDigit_(d >> 4);
      b[2 * c + 3] = jspb.utils.toHexDigit_(d & 15);
    }
    return b.join("");
  };
  jspb.utils.hexStringToHash64 = function(a2) {
    a2 = a2.toLowerCase();
    goog.asserts.assert(a2.length == 18);
    goog.asserts.assert(a2[0] == "0");
    goog.asserts.assert(a2[1] == "x");
    for (var b = "", c = 0; 8 > c; c++) {
      var d = jspb.utils.fromHexCharCode_(a2.charCodeAt(2 * c + 2)), e = jspb.utils.fromHexCharCode_(a2.charCodeAt(2 * c + 3));
      b = String.fromCharCode(16 * d + e) + b;
    }
    return b;
  };
  jspb.utils.hash64ToNumber = function(a2, b) {
    jspb.utils.splitHash64(a2);
    a2 = jspb.utils.split64Low;
    var c = jspb.utils.split64High;
    return b ? jspb.utils.joinInt64(a2, c) : jspb.utils.joinUint64(a2, c);
  };
  jspb.utils.numberToHash64 = function(a2) {
    jspb.utils.splitInt64(a2);
    return jspb.utils.joinHash64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.utils.countVarints = function(a2, b, c) {
    for (var d = 0, e = b; e < c; e++)
      d += a2[e] >> 7;
    return c - b - d;
  };
  jspb.utils.countVarintFields = function(a2, b, c, d) {
    var e = 0;
    d = 8 * d + jspb.BinaryConstants.WireType.VARINT;
    if (128 > d)
      for (; b < c && a2[b++] == d; )
        for (e++; ; ) {
          var f = a2[b++];
          if ((f & 128) == 0)
            break;
        }
    else
      for (; b < c; ) {
        for (f = d; 128 < f; ) {
          if (a2[b] != (f & 127 | 128))
            return e;
          b++;
          f >>= 7;
        }
        if (a2[b++] != f)
          break;
        for (e++; f = a2[b++], (f & 128) != 0; )
          ;
      }
    return e;
  };
  jspb.utils.countFixedFields_ = function(a2, b, c, d, e) {
    var f = 0;
    if (128 > d)
      for (; b < c && a2[b++] == d; )
        f++, b += e;
    else
      for (; b < c; ) {
        for (var g = d; 128 < g; ) {
          if (a2[b++] != (g & 127 | 128))
            return f;
          g >>= 7;
        }
        if (a2[b++] != g)
          break;
        f++;
        b += e;
      }
    return f;
  };
  jspb.utils.countFixed32Fields = function(a2, b, c, d) {
    return jspb.utils.countFixedFields_(a2, b, c, 8 * d + jspb.BinaryConstants.WireType.FIXED32, 4);
  };
  jspb.utils.countFixed64Fields = function(a2, b, c, d) {
    return jspb.utils.countFixedFields_(a2, b, c, 8 * d + jspb.BinaryConstants.WireType.FIXED64, 8);
  };
  jspb.utils.countDelimitedFields = function(a2, b, c, d) {
    var e = 0;
    for (d = 8 * d + jspb.BinaryConstants.WireType.DELIMITED; b < c; ) {
      for (var f = d; 128 < f; ) {
        if (a2[b++] != (f & 127 | 128))
          return e;
        f >>= 7;
      }
      if (a2[b++] != f)
        break;
      e++;
      for (var g = 0, h = 1; f = a2[b++], g += (f & 127) * h, h *= 128, (f & 128) != 0; )
        ;
      b += g;
    }
    return e;
  };
  jspb.utils.debugBytesToTextFormat = function(a2) {
    var b = '"';
    if (a2) {
      a2 = jspb.utils.byteSourceToUint8Array(a2);
      for (var c = 0; c < a2.length; c++)
        b += "\\x", 16 > a2[c] && (b += "0"), b += a2[c].toString(16);
    }
    return b + '"';
  };
  jspb.utils.debugScalarToTextFormat = function(a2) {
    return typeof a2 === "string" ? goog.string.quote(a2) : a2.toString();
  };
  jspb.utils.stringToByteArray = function(a2) {
    for (var b = new Uint8Array(a2.length), c = 0; c < a2.length; c++) {
      var d = a2.charCodeAt(c);
      if (255 < d)
        throw Error("Conversion error: string contains codepoint outside of byte range");
      b[c] = d;
    }
    return b;
  };
  jspb.utils.byteSourceToUint8Array = function(a2) {
    if (a2.constructor === Uint8Array)
      return a2;
    if (a2.constructor === ArrayBuffer || typeof Buffer != "undefined" && a2.constructor === Buffer || a2.constructor === Array)
      return new Uint8Array(a2);
    if (a2.constructor === String)
      return goog.crypt.base64.decodeStringToUint8Array(a2);
    goog.asserts.fail("Type not convertible to Uint8Array.");
    return new Uint8Array(0);
  };
  jspb.BinaryDecoder = function(a2, b, c) {
    this.bytes_ = null;
    this.cursor_ = this.end_ = this.start_ = 0;
    this.error_ = false;
    a2 && this.setBlock(a2, b, c);
  };
  jspb.BinaryDecoder.instanceCache_ = [];
  jspb.BinaryDecoder.alloc = function(a2, b, c) {
    if (jspb.BinaryDecoder.instanceCache_.length) {
      var d = jspb.BinaryDecoder.instanceCache_.pop();
      a2 && d.setBlock(a2, b, c);
      return d;
    }
    return new jspb.BinaryDecoder(a2, b, c);
  };
  jspb.BinaryDecoder.prototype.free = function() {
    this.clear();
    100 > jspb.BinaryDecoder.instanceCache_.length && jspb.BinaryDecoder.instanceCache_.push(this);
  };
  jspb.BinaryDecoder.prototype.clone = function() {
    return jspb.BinaryDecoder.alloc(this.bytes_, this.start_, this.end_ - this.start_);
  };
  jspb.BinaryDecoder.prototype.clear = function() {
    this.bytes_ = null;
    this.cursor_ = this.end_ = this.start_ = 0;
    this.error_ = false;
  };
  jspb.BinaryDecoder.prototype.getBuffer = function() {
    return this.bytes_;
  };
  jspb.BinaryDecoder.prototype.setBlock = function(a2, b, c) {
    this.bytes_ = jspb.utils.byteSourceToUint8Array(a2);
    this.start_ = b !== void 0 ? b : 0;
    this.end_ = c !== void 0 ? this.start_ + c : this.bytes_.length;
    this.cursor_ = this.start_;
  };
  jspb.BinaryDecoder.prototype.getEnd = function() {
    return this.end_;
  };
  jspb.BinaryDecoder.prototype.setEnd = function(a2) {
    this.end_ = a2;
  };
  jspb.BinaryDecoder.prototype.reset = function() {
    this.cursor_ = this.start_;
  };
  jspb.BinaryDecoder.prototype.getCursor = function() {
    return this.cursor_;
  };
  jspb.BinaryDecoder.prototype.setCursor = function(a2) {
    this.cursor_ = a2;
  };
  jspb.BinaryDecoder.prototype.advance = function(a2) {
    this.cursor_ += a2;
    goog.asserts.assert(this.cursor_ <= this.end_);
  };
  jspb.BinaryDecoder.prototype.atEnd = function() {
    return this.cursor_ == this.end_;
  };
  jspb.BinaryDecoder.prototype.pastEnd = function() {
    return this.cursor_ > this.end_;
  };
  jspb.BinaryDecoder.prototype.getError = function() {
    return this.error_ || 0 > this.cursor_ || this.cursor_ > this.end_;
  };
  jspb.BinaryDecoder.prototype.readSplitVarint64 = function(a2) {
    for (var b = 128, c = 0, d = 0, e = 0; 4 > e && 128 <= b; e++)
      b = this.bytes_[this.cursor_++], c |= (b & 127) << 7 * e;
    128 <= b && (b = this.bytes_[this.cursor_++], c |= (b & 127) << 28, d |= (b & 127) >> 4);
    if (128 <= b)
      for (e = 0; 5 > e && 128 <= b; e++)
        b = this.bytes_[this.cursor_++], d |= (b & 127) << 7 * e + 3;
    if (128 > b)
      return a2(c >>> 0, d >>> 0);
    goog.asserts.fail("Failed to read varint, encoding is invalid.");
    this.error_ = true;
  };
  jspb.BinaryDecoder.prototype.readSplitZigzagVarint64 = function(a2) {
    return this.readSplitVarint64(function(b, c) {
      return jspb.utils.fromZigzag64(b, c, a2);
    });
  };
  jspb.BinaryDecoder.prototype.readSplitFixed64 = function(a2) {
    var b = this.bytes_, c = this.cursor_;
    this.cursor_ += 8;
    for (var d = 0, e = 0, f = c + 7; f >= c; f--)
      d = d << 8 | b[f], e = e << 8 | b[f + 4];
    return a2(d, e);
  };
  jspb.BinaryDecoder.prototype.skipVarint = function() {
    for (; this.bytes_[this.cursor_] & 128; )
      this.cursor_++;
    this.cursor_++;
  };
  jspb.BinaryDecoder.prototype.unskipVarint = function(a2) {
    for (; 128 < a2; )
      this.cursor_--, a2 >>>= 7;
    this.cursor_--;
  };
  jspb.BinaryDecoder.prototype.readUnsignedVarint32 = function() {
    var a2 = this.bytes_;
    var b = a2[this.cursor_ + 0];
    var c = b & 127;
    if (128 > b)
      return this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a2[this.cursor_ + 1];
    c |= (b & 127) << 7;
    if (128 > b)
      return this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a2[this.cursor_ + 2];
    c |= (b & 127) << 14;
    if (128 > b)
      return this.cursor_ += 3, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a2[this.cursor_ + 3];
    c |= (b & 127) << 21;
    if (128 > b)
      return this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a2[this.cursor_ + 4];
    c |= (b & 15) << 28;
    if (128 > b)
      return this.cursor_ += 5, goog.asserts.assert(this.cursor_ <= this.end_), c >>> 0;
    this.cursor_ += 5;
    128 <= a2[this.cursor_++] && 128 <= a2[this.cursor_++] && 128 <= a2[this.cursor_++] && 128 <= a2[this.cursor_++] && 128 <= a2[this.cursor_++] && goog.asserts.assert(false);
    goog.asserts.assert(this.cursor_ <= this.end_);
    return c;
  };
  jspb.BinaryDecoder.prototype.readSignedVarint32 = jspb.BinaryDecoder.prototype.readUnsignedVarint32;
  jspb.BinaryDecoder.prototype.readUnsignedVarint32String = function() {
    return this.readUnsignedVarint32().toString();
  };
  jspb.BinaryDecoder.prototype.readSignedVarint32String = function() {
    return this.readSignedVarint32().toString();
  };
  jspb.BinaryDecoder.prototype.readZigzagVarint32 = function() {
    var a2 = this.readUnsignedVarint32();
    return a2 >>> 1 ^ -(a2 & 1);
  };
  jspb.BinaryDecoder.prototype.readUnsignedVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinUint64);
  };
  jspb.BinaryDecoder.prototype.readUnsignedVarint64String = function() {
    return this.readSplitVarint64(jspb.utils.joinUnsignedDecimalString);
  };
  jspb.BinaryDecoder.prototype.readSignedVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinInt64);
  };
  jspb.BinaryDecoder.prototype.readSignedVarint64String = function() {
    return this.readSplitVarint64(jspb.utils.joinSignedDecimalString);
  };
  jspb.BinaryDecoder.prototype.readZigzagVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinZigzag64);
  };
  jspb.BinaryDecoder.prototype.readZigzagVarintHash64 = function() {
    return this.readSplitZigzagVarint64(jspb.utils.joinHash64);
  };
  jspb.BinaryDecoder.prototype.readZigzagVarint64String = function() {
    return this.readSplitZigzagVarint64(jspb.utils.joinSignedDecimalString);
  };
  jspb.BinaryDecoder.prototype.readUint8 = function() {
    var a2 = this.bytes_[this.cursor_ + 0];
    this.cursor_ += 1;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a2;
  };
  jspb.BinaryDecoder.prototype.readUint16 = function() {
    var a2 = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1];
    this.cursor_ += 2;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a2 << 0 | b << 8;
  };
  jspb.BinaryDecoder.prototype.readUint32 = function() {
    var a2 = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1], c = this.bytes_[this.cursor_ + 2], d = this.bytes_[this.cursor_ + 3];
    this.cursor_ += 4;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return (a2 << 0 | b << 8 | c << 16 | d << 24) >>> 0;
  };
  jspb.BinaryDecoder.prototype.readUint64 = function() {
    var a2 = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinUint64(a2, b);
  };
  jspb.BinaryDecoder.prototype.readUint64String = function() {
    var a2 = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinUnsignedDecimalString(a2, b);
  };
  jspb.BinaryDecoder.prototype.readInt8 = function() {
    var a2 = this.bytes_[this.cursor_ + 0];
    this.cursor_ += 1;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a2 << 24 >> 24;
  };
  jspb.BinaryDecoder.prototype.readInt16 = function() {
    var a2 = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1];
    this.cursor_ += 2;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return (a2 << 0 | b << 8) << 16 >> 16;
  };
  jspb.BinaryDecoder.prototype.readInt32 = function() {
    var a2 = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1], c = this.bytes_[this.cursor_ + 2], d = this.bytes_[this.cursor_ + 3];
    this.cursor_ += 4;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a2 << 0 | b << 8 | c << 16 | d << 24;
  };
  jspb.BinaryDecoder.prototype.readInt64 = function() {
    var a2 = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinInt64(a2, b);
  };
  jspb.BinaryDecoder.prototype.readInt64String = function() {
    var a2 = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinSignedDecimalString(a2, b);
  };
  jspb.BinaryDecoder.prototype.readFloat = function() {
    var a2 = this.readUint32();
    return jspb.utils.joinFloat32(a2, 0);
  };
  jspb.BinaryDecoder.prototype.readDouble = function() {
    var a2 = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinFloat64(a2, b);
  };
  jspb.BinaryDecoder.prototype.readBool = function() {
    return !!this.bytes_[this.cursor_++];
  };
  jspb.BinaryDecoder.prototype.readEnum = function() {
    return this.readSignedVarint32();
  };
  jspb.BinaryDecoder.prototype.readString = function(a2) {
    var b = this.bytes_, c = this.cursor_;
    a2 = c + a2;
    for (var d = [], e = ""; c < a2; ) {
      var f = b[c++];
      if (128 > f)
        d.push(f);
      else if (192 > f)
        continue;
      else if (224 > f) {
        var g = b[c++];
        d.push((f & 31) << 6 | g & 63);
      } else if (240 > f) {
        g = b[c++];
        var h = b[c++];
        d.push((f & 15) << 12 | (g & 63) << 6 | h & 63);
      } else if (248 > f) {
        g = b[c++];
        h = b[c++];
        var k = b[c++];
        f = (f & 7) << 18 | (g & 63) << 12 | (h & 63) << 6 | k & 63;
        f -= 65536;
        d.push((f >> 10 & 1023) + 55296, (f & 1023) + 56320);
      }
      8192 <= d.length && (e += String.fromCharCode.apply(null, d), d.length = 0);
    }
    e += goog.crypt.byteArrayToString(d);
    this.cursor_ = c;
    return e;
  };
  jspb.BinaryDecoder.prototype.readStringWithLength = function() {
    var a2 = this.readUnsignedVarint32();
    return this.readString(a2);
  };
  jspb.BinaryDecoder.prototype.readBytes = function(a2) {
    if (0 > a2 || this.cursor_ + a2 > this.bytes_.length)
      return this.error_ = true, goog.asserts.fail("Invalid byte length!"), new Uint8Array(0);
    var b = this.bytes_.subarray(this.cursor_, this.cursor_ + a2);
    this.cursor_ += a2;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return b;
  };
  jspb.BinaryDecoder.prototype.readVarintHash64 = function() {
    return this.readSplitVarint64(jspb.utils.joinHash64);
  };
  jspb.BinaryDecoder.prototype.readFixedHash64 = function() {
    var a2 = this.bytes_, b = this.cursor_, c = a2[b + 0], d = a2[b + 1], e = a2[b + 2], f = a2[b + 3], g = a2[b + 4], h = a2[b + 5], k = a2[b + 6];
    a2 = a2[b + 7];
    this.cursor_ += 8;
    return String.fromCharCode(c, d, e, f, g, h, k, a2);
  };
  jspb.BinaryReader = function(a2, b, c) {
    this.decoder_ = jspb.BinaryDecoder.alloc(a2, b, c);
    this.fieldCursor_ = this.decoder_.getCursor();
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
    this.error_ = false;
    this.readCallbacks_ = null;
  };
  jspb.BinaryReader.instanceCache_ = [];
  jspb.BinaryReader.alloc = function(a2, b, c) {
    if (jspb.BinaryReader.instanceCache_.length) {
      var d = jspb.BinaryReader.instanceCache_.pop();
      a2 && d.decoder_.setBlock(a2, b, c);
      return d;
    }
    return new jspb.BinaryReader(a2, b, c);
  };
  jspb.BinaryReader.prototype.alloc = jspb.BinaryReader.alloc;
  jspb.BinaryReader.prototype.free = function() {
    this.decoder_.clear();
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
    this.error_ = false;
    this.readCallbacks_ = null;
    100 > jspb.BinaryReader.instanceCache_.length && jspb.BinaryReader.instanceCache_.push(this);
  };
  jspb.BinaryReader.prototype.getFieldCursor = function() {
    return this.fieldCursor_;
  };
  jspb.BinaryReader.prototype.getCursor = function() {
    return this.decoder_.getCursor();
  };
  jspb.BinaryReader.prototype.getBuffer = function() {
    return this.decoder_.getBuffer();
  };
  jspb.BinaryReader.prototype.getFieldNumber = function() {
    return this.nextField_;
  };
  jspb.BinaryReader.prototype.getWireType = function() {
    return this.nextWireType_;
  };
  jspb.BinaryReader.prototype.isDelimited = function() {
    return this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED;
  };
  jspb.BinaryReader.prototype.isEndGroup = function() {
    return this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP;
  };
  jspb.BinaryReader.prototype.getError = function() {
    return this.error_ || this.decoder_.getError();
  };
  jspb.BinaryReader.prototype.setBlock = function(a2, b, c) {
    this.decoder_.setBlock(a2, b, c);
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
  };
  jspb.BinaryReader.prototype.reset = function() {
    this.decoder_.reset();
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
  };
  jspb.BinaryReader.prototype.advance = function(a2) {
    this.decoder_.advance(a2);
  };
  jspb.BinaryReader.prototype.nextField = function() {
    if (this.decoder_.atEnd())
      return false;
    if (this.getError())
      return goog.asserts.fail("Decoder hit an error"), false;
    this.fieldCursor_ = this.decoder_.getCursor();
    var a2 = this.decoder_.readUnsignedVarint32(), b = a2 >>> 3;
    a2 &= 7;
    if (a2 != jspb.BinaryConstants.WireType.VARINT && a2 != jspb.BinaryConstants.WireType.FIXED32 && a2 != jspb.BinaryConstants.WireType.FIXED64 && a2 != jspb.BinaryConstants.WireType.DELIMITED && a2 != jspb.BinaryConstants.WireType.START_GROUP && a2 != jspb.BinaryConstants.WireType.END_GROUP)
      return goog.asserts.fail("Invalid wire type: %s (at position %s)", a2, this.fieldCursor_), this.error_ = true, false;
    this.nextField_ = b;
    this.nextWireType_ = a2;
    return true;
  };
  jspb.BinaryReader.prototype.unskipHeader = function() {
    this.decoder_.unskipVarint(this.nextField_ << 3 | this.nextWireType_);
  };
  jspb.BinaryReader.prototype.skipMatchingFields = function() {
    var a2 = this.nextField_;
    for (this.unskipHeader(); this.nextField() && this.getFieldNumber() == a2; )
      this.skipField();
    this.decoder_.atEnd() || this.unskipHeader();
  };
  jspb.BinaryReader.prototype.skipVarintField = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.VARINT ? (goog.asserts.fail("Invalid wire type for skipVarintField"), this.skipField()) : this.decoder_.skipVarint();
  };
  jspb.BinaryReader.prototype.skipDelimitedField = function() {
    if (this.nextWireType_ != jspb.BinaryConstants.WireType.DELIMITED)
      goog.asserts.fail("Invalid wire type for skipDelimitedField"), this.skipField();
    else {
      var a2 = this.decoder_.readUnsignedVarint32();
      this.decoder_.advance(a2);
    }
  };
  jspb.BinaryReader.prototype.skipFixed32Field = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED32 ? (goog.asserts.fail("Invalid wire type for skipFixed32Field"), this.skipField()) : this.decoder_.advance(4);
  };
  jspb.BinaryReader.prototype.skipFixed64Field = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED64 ? (goog.asserts.fail("Invalid wire type for skipFixed64Field"), this.skipField()) : this.decoder_.advance(8);
  };
  jspb.BinaryReader.prototype.skipGroup = function() {
    var a2 = this.nextField_;
    do {
      if (!this.nextField()) {
        goog.asserts.fail("Unmatched start-group tag: stream EOF");
        this.error_ = true;
        break;
      }
      if (this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP) {
        this.nextField_ != a2 && (goog.asserts.fail("Unmatched end-group tag"), this.error_ = true);
        break;
      }
      this.skipField();
    } while (1);
  };
  jspb.BinaryReader.prototype.skipField = function() {
    switch (this.nextWireType_) {
      case jspb.BinaryConstants.WireType.VARINT:
        this.skipVarintField();
        break;
      case jspb.BinaryConstants.WireType.FIXED64:
        this.skipFixed64Field();
        break;
      case jspb.BinaryConstants.WireType.DELIMITED:
        this.skipDelimitedField();
        break;
      case jspb.BinaryConstants.WireType.FIXED32:
        this.skipFixed32Field();
        break;
      case jspb.BinaryConstants.WireType.START_GROUP:
        this.skipGroup();
        break;
      default:
        goog.asserts.fail("Invalid wire encoding for field.");
    }
  };
  jspb.BinaryReader.prototype.registerReadCallback = function(a2, b) {
    this.readCallbacks_ === null && (this.readCallbacks_ = {});
    goog.asserts.assert(!this.readCallbacks_[a2]);
    this.readCallbacks_[a2] = b;
  };
  jspb.BinaryReader.prototype.runReadCallback = function(a2) {
    goog.asserts.assert(this.readCallbacks_ !== null);
    a2 = this.readCallbacks_[a2];
    goog.asserts.assert(a2);
    return a2(this);
  };
  jspb.BinaryReader.prototype.readAny = function(a2) {
    this.nextWireType_ = jspb.BinaryConstants.FieldTypeToWireType(a2);
    var b = jspb.BinaryConstants.FieldType;
    switch (a2) {
      case b.DOUBLE:
        return this.readDouble();
      case b.FLOAT:
        return this.readFloat();
      case b.INT64:
        return this.readInt64();
      case b.UINT64:
        return this.readUint64();
      case b.INT32:
        return this.readInt32();
      case b.FIXED64:
        return this.readFixed64();
      case b.FIXED32:
        return this.readFixed32();
      case b.BOOL:
        return this.readBool();
      case b.STRING:
        return this.readString();
      case b.GROUP:
        goog.asserts.fail("Group field type not supported in readAny()");
      case b.MESSAGE:
        goog.asserts.fail("Message field type not supported in readAny()");
      case b.BYTES:
        return this.readBytes();
      case b.UINT32:
        return this.readUint32();
      case b.ENUM:
        return this.readEnum();
      case b.SFIXED32:
        return this.readSfixed32();
      case b.SFIXED64:
        return this.readSfixed64();
      case b.SINT32:
        return this.readSint32();
      case b.SINT64:
        return this.readSint64();
      case b.FHASH64:
        return this.readFixedHash64();
      case b.VHASH64:
        return this.readVarintHash64();
      default:
        goog.asserts.fail("Invalid field type in readAny()");
    }
    return 0;
  };
  jspb.BinaryReader.prototype.readMessage = function(a2, b) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var c = this.decoder_.getEnd(), d = this.decoder_.readUnsignedVarint32();
    d = this.decoder_.getCursor() + d;
    this.decoder_.setEnd(d);
    b(a2, this);
    this.decoder_.setCursor(d);
    this.decoder_.setEnd(c);
  };
  jspb.BinaryReader.prototype.readGroup = function(a2, b, c) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.START_GROUP);
    goog.asserts.assert(this.nextField_ == a2);
    c(b, this);
    this.error_ || this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP || (goog.asserts.fail("Group submessage did not end with an END_GROUP tag"), this.error_ = true);
  };
  jspb.BinaryReader.prototype.getFieldDecoder = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var a2 = this.decoder_.readUnsignedVarint32(), b = this.decoder_.getCursor(), c = b + a2;
    a2 = jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(), b, a2);
    this.decoder_.setCursor(c);
    return a2;
  };
  jspb.BinaryReader.prototype.readInt32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint32();
  };
  jspb.BinaryReader.prototype.readInt32String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint32String();
  };
  jspb.BinaryReader.prototype.readInt64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint64();
  };
  jspb.BinaryReader.prototype.readInt64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint64String();
  };
  jspb.BinaryReader.prototype.readUint32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint32();
  };
  jspb.BinaryReader.prototype.readUint32String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint32String();
  };
  jspb.BinaryReader.prototype.readUint64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint64();
  };
  jspb.BinaryReader.prototype.readUint64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint64String();
  };
  jspb.BinaryReader.prototype.readSint32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarint32();
  };
  jspb.BinaryReader.prototype.readSint64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarint64();
  };
  jspb.BinaryReader.prototype.readSint64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarint64String();
  };
  jspb.BinaryReader.prototype.readFixed32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readUint32();
  };
  jspb.BinaryReader.prototype.readFixed64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readUint64();
  };
  jspb.BinaryReader.prototype.readFixed64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readUint64String();
  };
  jspb.BinaryReader.prototype.readSfixed32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readInt32();
  };
  jspb.BinaryReader.prototype.readSfixed32String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readInt32().toString();
  };
  jspb.BinaryReader.prototype.readSfixed64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readInt64();
  };
  jspb.BinaryReader.prototype.readSfixed64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readInt64String();
  };
  jspb.BinaryReader.prototype.readFloat = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readFloat();
  };
  jspb.BinaryReader.prototype.readDouble = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readDouble();
  };
  jspb.BinaryReader.prototype.readBool = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return !!this.decoder_.readUnsignedVarint32();
  };
  jspb.BinaryReader.prototype.readEnum = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint64();
  };
  jspb.BinaryReader.prototype.readString = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var a2 = this.decoder_.readUnsignedVarint32();
    return this.decoder_.readString(a2);
  };
  jspb.BinaryReader.prototype.readBytes = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var a2 = this.decoder_.readUnsignedVarint32();
    return this.decoder_.readBytes(a2);
  };
  jspb.BinaryReader.prototype.readVarintHash64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readVarintHash64();
  };
  jspb.BinaryReader.prototype.readSintHash64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarintHash64();
  };
  jspb.BinaryReader.prototype.readSplitVarint64 = function(a2) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSplitVarint64(a2);
  };
  jspb.BinaryReader.prototype.readSplitZigzagVarint64 = function(a2) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSplitVarint64(function(b, c) {
      return jspb.utils.fromZigzag64(b, c, a2);
    });
  };
  jspb.BinaryReader.prototype.readFixedHash64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readFixedHash64();
  };
  jspb.BinaryReader.prototype.readSplitFixed64 = function(a2) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readSplitFixed64(a2);
  };
  jspb.BinaryReader.prototype.readPackedField_ = function(a2) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var b = this.decoder_.readUnsignedVarint32();
    b = this.decoder_.getCursor() + b;
    for (var c = []; this.decoder_.getCursor() < b; )
      c.push(a2.call(this.decoder_));
    return c;
  };
  jspb.BinaryReader.prototype.readPackedInt32 = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint32);
  };
  jspb.BinaryReader.prototype.readPackedInt32String = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint32String);
  };
  jspb.BinaryReader.prototype.readPackedInt64 = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint64);
  };
  jspb.BinaryReader.prototype.readPackedInt64String = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint64String);
  };
  jspb.BinaryReader.prototype.readPackedUint32 = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint32);
  };
  jspb.BinaryReader.prototype.readPackedUint32String = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint32String);
  };
  jspb.BinaryReader.prototype.readPackedUint64 = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint64);
  };
  jspb.BinaryReader.prototype.readPackedUint64String = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint64String);
  };
  jspb.BinaryReader.prototype.readPackedSint32 = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint32);
  };
  jspb.BinaryReader.prototype.readPackedSint64 = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint64);
  };
  jspb.BinaryReader.prototype.readPackedSint64String = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint64String);
  };
  jspb.BinaryReader.prototype.readPackedFixed32 = function() {
    return this.readPackedField_(this.decoder_.readUint32);
  };
  jspb.BinaryReader.prototype.readPackedFixed64 = function() {
    return this.readPackedField_(this.decoder_.readUint64);
  };
  jspb.BinaryReader.prototype.readPackedFixed64String = function() {
    return this.readPackedField_(this.decoder_.readUint64String);
  };
  jspb.BinaryReader.prototype.readPackedSfixed32 = function() {
    return this.readPackedField_(this.decoder_.readInt32);
  };
  jspb.BinaryReader.prototype.readPackedSfixed64 = function() {
    return this.readPackedField_(this.decoder_.readInt64);
  };
  jspb.BinaryReader.prototype.readPackedSfixed64String = function() {
    return this.readPackedField_(this.decoder_.readInt64String);
  };
  jspb.BinaryReader.prototype.readPackedFloat = function() {
    return this.readPackedField_(this.decoder_.readFloat);
  };
  jspb.BinaryReader.prototype.readPackedDouble = function() {
    return this.readPackedField_(this.decoder_.readDouble);
  };
  jspb.BinaryReader.prototype.readPackedBool = function() {
    return this.readPackedField_(this.decoder_.readBool);
  };
  jspb.BinaryReader.prototype.readPackedEnum = function() {
    return this.readPackedField_(this.decoder_.readEnum);
  };
  jspb.BinaryReader.prototype.readPackedVarintHash64 = function() {
    return this.readPackedField_(this.decoder_.readVarintHash64);
  };
  jspb.BinaryReader.prototype.readPackedFixedHash64 = function() {
    return this.readPackedField_(this.decoder_.readFixedHash64);
  };
  jspb.BinaryEncoder = function() {
    this.buffer_ = [];
  };
  jspb.BinaryEncoder.prototype.length = function() {
    return this.buffer_.length;
  };
  jspb.BinaryEncoder.prototype.end = function() {
    var a2 = this.buffer_;
    this.buffer_ = [];
    return a2;
  };
  jspb.BinaryEncoder.prototype.writeSplitVarint64 = function(a2, b) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(b == Math.floor(b));
    goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_32);
    for (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32); 0 < b || 127 < a2; )
      this.buffer_.push(a2 & 127 | 128), a2 = (a2 >>> 7 | b << 25) >>> 0, b >>>= 7;
    this.buffer_.push(a2);
  };
  jspb.BinaryEncoder.prototype.writeSplitFixed64 = function(a2, b) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(b == Math.floor(b));
    goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_32);
    goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32);
    this.writeUint32(a2);
    this.writeUint32(b);
  };
  jspb.BinaryEncoder.prototype.writeUnsignedVarint32 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    for (goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_32); 127 < a2; )
      this.buffer_.push(a2 & 127 | 128), a2 >>>= 7;
    this.buffer_.push(a2);
  };
  jspb.BinaryEncoder.prototype.writeSignedVarint32 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_31 && a2 < jspb.BinaryConstants.TWO_TO_31);
    if (0 <= a2)
      this.writeUnsignedVarint32(a2);
    else {
      for (var b = 0; 9 > b; b++)
        this.buffer_.push(a2 & 127 | 128), a2 >>= 7;
      this.buffer_.push(1);
    }
  };
  jspb.BinaryEncoder.prototype.writeUnsignedVarint64 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_64);
    jspb.utils.splitInt64(a2);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeSignedVarint64 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_63 && a2 < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitInt64(a2);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeZigzagVarint32 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_31 && a2 < jspb.BinaryConstants.TWO_TO_31);
    this.writeUnsignedVarint32((a2 << 1 ^ a2 >> 31) >>> 0);
  };
  jspb.BinaryEncoder.prototype.writeZigzagVarint64 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_63 && a2 < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitZigzag64(a2);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeZigzagVarint64String = function(a2) {
    this.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(a2));
  };
  jspb.BinaryEncoder.prototype.writeZigzagVarintHash64 = function(a2) {
    var b = this;
    jspb.utils.splitHash64(a2);
    jspb.utils.toZigzag64(jspb.utils.split64Low, jspb.utils.split64High, function(a3, d) {
      b.writeSplitVarint64(a3 >>> 0, d >>> 0);
    });
  };
  jspb.BinaryEncoder.prototype.writeUint8 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(0 <= a2 && 256 > a2);
    this.buffer_.push(a2 >>> 0 & 255);
  };
  jspb.BinaryEncoder.prototype.writeUint16 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(0 <= a2 && 65536 > a2);
    this.buffer_.push(a2 >>> 0 & 255);
    this.buffer_.push(a2 >>> 8 & 255);
  };
  jspb.BinaryEncoder.prototype.writeUint32 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_32);
    this.buffer_.push(a2 >>> 0 & 255);
    this.buffer_.push(a2 >>> 8 & 255);
    this.buffer_.push(a2 >>> 16 & 255);
    this.buffer_.push(a2 >>> 24 & 255);
  };
  jspb.BinaryEncoder.prototype.writeUint64 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_64);
    jspb.utils.splitUint64(a2);
    this.writeUint32(jspb.utils.split64Low);
    this.writeUint32(jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeInt8 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(-128 <= a2 && 128 > a2);
    this.buffer_.push(a2 >>> 0 & 255);
  };
  jspb.BinaryEncoder.prototype.writeInt16 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(-32768 <= a2 && 32768 > a2);
    this.buffer_.push(a2 >>> 0 & 255);
    this.buffer_.push(a2 >>> 8 & 255);
  };
  jspb.BinaryEncoder.prototype.writeInt32 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_31 && a2 < jspb.BinaryConstants.TWO_TO_31);
    this.buffer_.push(a2 >>> 0 & 255);
    this.buffer_.push(a2 >>> 8 & 255);
    this.buffer_.push(a2 >>> 16 & 255);
    this.buffer_.push(a2 >>> 24 & 255);
  };
  jspb.BinaryEncoder.prototype.writeInt64 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_63 && a2 < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitInt64(a2);
    this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeInt64String = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(+a2 >= -jspb.BinaryConstants.TWO_TO_63 && +a2 < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a2));
    this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeFloat = function(a2) {
    goog.asserts.assert(a2 === Infinity || a2 === -Infinity || isNaN(a2) || a2 >= -jspb.BinaryConstants.FLOAT32_MAX && a2 <= jspb.BinaryConstants.FLOAT32_MAX);
    jspb.utils.splitFloat32(a2);
    this.writeUint32(jspb.utils.split64Low);
  };
  jspb.BinaryEncoder.prototype.writeDouble = function(a2) {
    goog.asserts.assert(a2 === Infinity || a2 === -Infinity || isNaN(a2) || a2 >= -jspb.BinaryConstants.FLOAT64_MAX && a2 <= jspb.BinaryConstants.FLOAT64_MAX);
    jspb.utils.splitFloat64(a2);
    this.writeUint32(jspb.utils.split64Low);
    this.writeUint32(jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeBool = function(a2) {
    goog.asserts.assert(typeof a2 === "boolean" || typeof a2 === "number");
    this.buffer_.push(a2 ? 1 : 0);
  };
  jspb.BinaryEncoder.prototype.writeEnum = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_31 && a2 < jspb.BinaryConstants.TWO_TO_31);
    this.writeSignedVarint32(a2);
  };
  jspb.BinaryEncoder.prototype.writeBytes = function(a2) {
    this.buffer_.push.apply(this.buffer_, a2);
  };
  jspb.BinaryEncoder.prototype.writeVarintHash64 = function(a2) {
    jspb.utils.splitHash64(a2);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeFixedHash64 = function(a2) {
    jspb.utils.splitHash64(a2);
    this.writeUint32(jspb.utils.split64Low);
    this.writeUint32(jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeString = function(a2) {
    for (var b = this.buffer_.length, c = 0; c < a2.length; c++) {
      var d = a2.charCodeAt(c);
      if (128 > d)
        this.buffer_.push(d);
      else if (2048 > d)
        this.buffer_.push(d >> 6 | 192), this.buffer_.push(d & 63 | 128);
      else if (65536 > d)
        if (55296 <= d && 56319 >= d && c + 1 < a2.length) {
          var e = a2.charCodeAt(c + 1);
          56320 <= e && 57343 >= e && (d = 1024 * (d - 55296) + e - 56320 + 65536, this.buffer_.push(d >> 18 | 240), this.buffer_.push(d >> 12 & 63 | 128), this.buffer_.push(d >> 6 & 63 | 128), this.buffer_.push(d & 63 | 128), c++);
        } else
          this.buffer_.push(d >> 12 | 224), this.buffer_.push(d >> 6 & 63 | 128), this.buffer_.push(d & 63 | 128);
    }
    return this.buffer_.length - b;
  };
  jspb.arith = {};
  jspb.arith.UInt64 = function(a2, b) {
    this.lo = a2;
    this.hi = b;
  };
  jspb.arith.UInt64.prototype.cmp = function(a2) {
    return this.hi < a2.hi || this.hi == a2.hi && this.lo < a2.lo ? -1 : this.hi == a2.hi && this.lo == a2.lo ? 0 : 1;
  };
  jspb.arith.UInt64.prototype.rightShift = function() {
    return new jspb.arith.UInt64((this.lo >>> 1 | (this.hi & 1) << 31) >>> 0, this.hi >>> 1 >>> 0);
  };
  jspb.arith.UInt64.prototype.leftShift = function() {
    return new jspb.arith.UInt64(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
  };
  jspb.arith.UInt64.prototype.msb = function() {
    return !!(this.hi & 2147483648);
  };
  jspb.arith.UInt64.prototype.lsb = function() {
    return !!(this.lo & 1);
  };
  jspb.arith.UInt64.prototype.zero = function() {
    return this.lo == 0 && this.hi == 0;
  };
  jspb.arith.UInt64.prototype.add = function(a2) {
    return new jspb.arith.UInt64((this.lo + a2.lo & 4294967295) >>> 0 >>> 0, ((this.hi + a2.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + a2.lo ? 1 : 0) >>> 0);
  };
  jspb.arith.UInt64.prototype.sub = function(a2) {
    return new jspb.arith.UInt64((this.lo - a2.lo & 4294967295) >>> 0 >>> 0, ((this.hi - a2.hi & 4294967295) >>> 0) - (0 > this.lo - a2.lo ? 1 : 0) >>> 0);
  };
  jspb.arith.UInt64.mul32x32 = function(a2, b) {
    var c = a2 & 65535;
    a2 >>>= 16;
    var d = b & 65535, e = b >>> 16;
    b = c * d + 65536 * (c * e & 65535) + 65536 * (a2 * d & 65535);
    for (c = a2 * e + (c * e >>> 16) + (a2 * d >>> 16); 4294967296 <= b; )
      b -= 4294967296, c += 1;
    return new jspb.arith.UInt64(b >>> 0, c >>> 0);
  };
  jspb.arith.UInt64.prototype.mul = function(a2) {
    var b = jspb.arith.UInt64.mul32x32(this.lo, a2);
    a2 = jspb.arith.UInt64.mul32x32(this.hi, a2);
    a2.hi = a2.lo;
    a2.lo = 0;
    return b.add(a2);
  };
  jspb.arith.UInt64.prototype.div = function(a2) {
    if (a2 == 0)
      return [];
    var b = new jspb.arith.UInt64(0, 0), c = new jspb.arith.UInt64(this.lo, this.hi);
    a2 = new jspb.arith.UInt64(a2, 0);
    for (var d = new jspb.arith.UInt64(1, 0); !a2.msb(); )
      a2 = a2.leftShift(), d = d.leftShift();
    for (; !d.zero(); )
      0 >= a2.cmp(c) && (b = b.add(d), c = c.sub(a2)), a2 = a2.rightShift(), d = d.rightShift();
    return [b, c];
  };
  jspb.arith.UInt64.prototype.toString = function() {
    for (var a2 = "", b = this; !b.zero(); ) {
      b = b.div(10);
      var c = b[0];
      a2 = b[1].lo + a2;
      b = c;
    }
    a2 == "" && (a2 = "0");
    return a2;
  };
  jspb.arith.UInt64.fromString = function(a2) {
    for (var b = new jspb.arith.UInt64(0, 0), c = new jspb.arith.UInt64(0, 0), d = 0; d < a2.length; d++) {
      if ("0" > a2[d] || "9" < a2[d])
        return null;
      var e = parseInt(a2[d], 10);
      c.lo = e;
      b = b.mul(10).add(c);
    }
    return b;
  };
  jspb.arith.UInt64.prototype.clone = function() {
    return new jspb.arith.UInt64(this.lo, this.hi);
  };
  jspb.arith.Int64 = function(a2, b) {
    this.lo = a2;
    this.hi = b;
  };
  jspb.arith.Int64.prototype.add = function(a2) {
    return new jspb.arith.Int64((this.lo + a2.lo & 4294967295) >>> 0 >>> 0, ((this.hi + a2.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + a2.lo ? 1 : 0) >>> 0);
  };
  jspb.arith.Int64.prototype.sub = function(a2) {
    return new jspb.arith.Int64((this.lo - a2.lo & 4294967295) >>> 0 >>> 0, ((this.hi - a2.hi & 4294967295) >>> 0) - (0 > this.lo - a2.lo ? 1 : 0) >>> 0);
  };
  jspb.arith.Int64.prototype.clone = function() {
    return new jspb.arith.Int64(this.lo, this.hi);
  };
  jspb.arith.Int64.prototype.toString = function() {
    var a2 = (this.hi & 2147483648) != 0, b = new jspb.arith.UInt64(this.lo, this.hi);
    a2 && (b = new jspb.arith.UInt64(0, 0).sub(b));
    return (a2 ? "-" : "") + b.toString();
  };
  jspb.arith.Int64.fromString = function(a2) {
    var b = 0 < a2.length && a2[0] == "-";
    b && (a2 = a2.substring(1));
    a2 = jspb.arith.UInt64.fromString(a2);
    if (a2 === null)
      return null;
    b && (a2 = new jspb.arith.UInt64(0, 0).sub(a2));
    return new jspb.arith.Int64(a2.lo, a2.hi);
  };
  jspb.BinaryWriter = function() {
    this.blocks_ = [];
    this.totalLength_ = 0;
    this.encoder_ = new jspb.BinaryEncoder();
    this.bookmarks_ = [];
  };
  jspb.BinaryWriter.prototype.appendUint8Array_ = function(a2) {
    var b = this.encoder_.end();
    this.blocks_.push(b);
    this.blocks_.push(a2);
    this.totalLength_ += b.length + a2.length;
  };
  jspb.BinaryWriter.prototype.beginDelimited_ = function(a2) {
    this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED);
    a2 = this.encoder_.end();
    this.blocks_.push(a2);
    this.totalLength_ += a2.length;
    a2.push(this.totalLength_);
    return a2;
  };
  jspb.BinaryWriter.prototype.endDelimited_ = function(a2) {
    var b = a2.pop();
    b = this.totalLength_ + this.encoder_.length() - b;
    for (goog.asserts.assert(0 <= b); 127 < b; )
      a2.push(b & 127 | 128), b >>>= 7, this.totalLength_++;
    a2.push(b);
    this.totalLength_++;
  };
  jspb.BinaryWriter.prototype.writeSerializedMessage = function(a2, b, c) {
    this.appendUint8Array_(a2.subarray(b, c));
  };
  jspb.BinaryWriter.prototype.maybeWriteSerializedMessage = function(a2, b, c) {
    a2 != null && b != null && c != null && this.writeSerializedMessage(a2, b, c);
  };
  jspb.BinaryWriter.prototype.reset = function() {
    this.blocks_ = [];
    this.encoder_.end();
    this.totalLength_ = 0;
    this.bookmarks_ = [];
  };
  jspb.BinaryWriter.prototype.getResultBuffer = function() {
    goog.asserts.assert(this.bookmarks_.length == 0);
    for (var a2 = new Uint8Array(this.totalLength_ + this.encoder_.length()), b = this.blocks_, c = b.length, d = 0, e = 0; e < c; e++) {
      var f = b[e];
      a2.set(f, d);
      d += f.length;
    }
    b = this.encoder_.end();
    a2.set(b, d);
    d += b.length;
    goog.asserts.assert(d == a2.length);
    this.blocks_ = [a2];
    return a2;
  };
  jspb.BinaryWriter.prototype.getResultBase64String = function(a2) {
    return goog.crypt.base64.encodeByteArray(this.getResultBuffer(), a2);
  };
  jspb.BinaryWriter.prototype.beginSubMessage = function(a2) {
    this.bookmarks_.push(this.beginDelimited_(a2));
  };
  jspb.BinaryWriter.prototype.endSubMessage = function() {
    goog.asserts.assert(0 <= this.bookmarks_.length);
    this.endDelimited_(this.bookmarks_.pop());
  };
  jspb.BinaryWriter.prototype.writeFieldHeader_ = function(a2, b) {
    goog.asserts.assert(1 <= a2 && a2 == Math.floor(a2));
    this.encoder_.writeUnsignedVarint32(8 * a2 + b);
  };
  jspb.BinaryWriter.prototype.writeAny = function(a2, b, c) {
    var d = jspb.BinaryConstants.FieldType;
    switch (a2) {
      case d.DOUBLE:
        this.writeDouble(b, c);
        break;
      case d.FLOAT:
        this.writeFloat(b, c);
        break;
      case d.INT64:
        this.writeInt64(b, c);
        break;
      case d.UINT64:
        this.writeUint64(b, c);
        break;
      case d.INT32:
        this.writeInt32(b, c);
        break;
      case d.FIXED64:
        this.writeFixed64(b, c);
        break;
      case d.FIXED32:
        this.writeFixed32(b, c);
        break;
      case d.BOOL:
        this.writeBool(b, c);
        break;
      case d.STRING:
        this.writeString(b, c);
        break;
      case d.GROUP:
        goog.asserts.fail("Group field type not supported in writeAny()");
        break;
      case d.MESSAGE:
        goog.asserts.fail("Message field type not supported in writeAny()");
        break;
      case d.BYTES:
        this.writeBytes(b, c);
        break;
      case d.UINT32:
        this.writeUint32(b, c);
        break;
      case d.ENUM:
        this.writeEnum(b, c);
        break;
      case d.SFIXED32:
        this.writeSfixed32(b, c);
        break;
      case d.SFIXED64:
        this.writeSfixed64(b, c);
        break;
      case d.SINT32:
        this.writeSint32(b, c);
        break;
      case d.SINT64:
        this.writeSint64(b, c);
        break;
      case d.FHASH64:
        this.writeFixedHash64(b, c);
        break;
      case d.VHASH64:
        this.writeVarintHash64(b, c);
        break;
      default:
        goog.asserts.fail("Invalid field type in writeAny()");
    }
  };
  jspb.BinaryWriter.prototype.writeUnsignedVarint32_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint32(b));
  };
  jspb.BinaryWriter.prototype.writeSignedVarint32_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(b));
  };
  jspb.BinaryWriter.prototype.writeUnsignedVarint64_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint64(b));
  };
  jspb.BinaryWriter.prototype.writeSignedVarint64_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint64(b));
  };
  jspb.BinaryWriter.prototype.writeZigzagVarint32_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint32(b));
  };
  jspb.BinaryWriter.prototype.writeZigzagVarint64_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64(b));
  };
  jspb.BinaryWriter.prototype.writeZigzagVarint64String_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64String(b));
  };
  jspb.BinaryWriter.prototype.writeZigzagVarintHash64_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarintHash64(b));
  };
  jspb.BinaryWriter.prototype.writeInt32 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeInt32String = function(a2, b) {
    b != null && (b = parseInt(b, 10), goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeInt64 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeSignedVarint64_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeInt64String = function(a2, b) {
    b != null && (b = jspb.arith.Int64.fromString(b), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(b.lo, b.hi));
  };
  jspb.BinaryWriter.prototype.writeUint32 = function(a2, b) {
    b != null && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeUint32String = function(a2, b) {
    b != null && (b = parseInt(b, 10), goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeUint64 = function(a2, b) {
    b != null && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_64), this.writeUnsignedVarint64_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeUint64String = function(a2, b) {
    b != null && (b = jspb.arith.UInt64.fromString(b), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(b.lo, b.hi));
  };
  jspb.BinaryWriter.prototype.writeSint32 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeZigzagVarint32_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeSint64 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeZigzagVarint64_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeSintHash64 = function(a2, b) {
    b != null && this.writeZigzagVarintHash64_(a2, b);
  };
  jspb.BinaryWriter.prototype.writeSint64String = function(a2, b) {
    b != null && this.writeZigzagVarint64String_(a2, b);
  };
  jspb.BinaryWriter.prototype.writeFixed32 = function(a2, b) {
    b != null && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeUint32(b));
  };
  jspb.BinaryWriter.prototype.writeFixed64 = function(a2, b) {
    b != null && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_64), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeUint64(b));
  };
  jspb.BinaryWriter.prototype.writeFixed64String = function(a2, b) {
    b != null && (b = jspb.arith.UInt64.fromString(b), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(b.lo, b.hi));
  };
  jspb.BinaryWriter.prototype.writeSfixed32 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeInt32(b));
  };
  jspb.BinaryWriter.prototype.writeSfixed64 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeInt64(b));
  };
  jspb.BinaryWriter.prototype.writeSfixed64String = function(a2, b) {
    b != null && (b = jspb.arith.Int64.fromString(b), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(b.lo, b.hi));
  };
  jspb.BinaryWriter.prototype.writeFloat = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeFloat(b));
  };
  jspb.BinaryWriter.prototype.writeDouble = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeDouble(b));
  };
  jspb.BinaryWriter.prototype.writeBool = function(a2, b) {
    b != null && (goog.asserts.assert(typeof b === "boolean" || typeof b === "number"), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeBool(b));
  };
  jspb.BinaryWriter.prototype.writeEnum = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(b));
  };
  jspb.BinaryWriter.prototype.writeString = function(a2, b) {
    b != null && (a2 = this.beginDelimited_(a2), this.encoder_.writeString(b), this.endDelimited_(a2));
  };
  jspb.BinaryWriter.prototype.writeBytes = function(a2, b) {
    b != null && (b = jspb.utils.byteSourceToUint8Array(b), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(b.length), this.appendUint8Array_(b));
  };
  jspb.BinaryWriter.prototype.writeMessage = function(a2, b, c) {
    b != null && (a2 = this.beginDelimited_(a2), c(b, this), this.endDelimited_(a2));
  };
  jspb.BinaryWriter.prototype.writeMessageSet = function(a2, b, c) {
    b != null && (this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.START_GROUP), this.writeFieldHeader_(2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(a2), a2 = this.beginDelimited_(3), c(b, this), this.endDelimited_(a2), this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.END_GROUP));
  };
  jspb.BinaryWriter.prototype.writeGroup = function(a2, b, c) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.START_GROUP), c(b, this), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.END_GROUP));
  };
  jspb.BinaryWriter.prototype.writeFixedHash64 = function(a2, b) {
    b != null && (goog.asserts.assert(b.length == 8), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeFixedHash64(b));
  };
  jspb.BinaryWriter.prototype.writeVarintHash64 = function(a2, b) {
    b != null && (goog.asserts.assert(b.length == 8), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeVarintHash64(b));
  };
  jspb.BinaryWriter.prototype.writeSplitFixed64 = function(a2, b, c) {
    this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64);
    this.encoder_.writeSplitFixed64(b, c);
  };
  jspb.BinaryWriter.prototype.writeSplitVarint64 = function(a2, b, c) {
    this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT);
    this.encoder_.writeSplitVarint64(b, c);
  };
  jspb.BinaryWriter.prototype.writeSplitZigzagVarint64 = function(a2, b, c) {
    this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT);
    var d = this.encoder_;
    jspb.utils.toZigzag64(b, c, function(a3, b2) {
      d.writeSplitVarint64(a3 >>> 0, b2 >>> 0);
    });
  };
  jspb.BinaryWriter.prototype.writeRepeatedInt32 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeSignedVarint32_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedInt32String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeInt32String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedInt64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeSignedVarint64_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSplitFixed64 = function(a2, b, c, d) {
    if (b != null)
      for (var e = 0; e < b.length; e++)
        this.writeSplitFixed64(a2, c(b[e]), d(b[e]));
  };
  jspb.BinaryWriter.prototype.writeRepeatedSplitVarint64 = function(a2, b, c, d) {
    if (b != null)
      for (var e = 0; e < b.length; e++)
        this.writeSplitVarint64(a2, c(b[e]), d(b[e]));
  };
  jspb.BinaryWriter.prototype.writeRepeatedSplitZigzagVarint64 = function(a2, b, c, d) {
    if (b != null)
      for (var e = 0; e < b.length; e++)
        this.writeSplitZigzagVarint64(a2, c(b[e]), d(b[e]));
  };
  jspb.BinaryWriter.prototype.writeRepeatedInt64String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeInt64String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedUint32 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeUnsignedVarint32_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedUint32String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeUint32String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedUint64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeUnsignedVarint64_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedUint64String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeUint64String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSint32 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeZigzagVarint32_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSint64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeZigzagVarint64_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSint64String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeZigzagVarint64String_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSintHash64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeZigzagVarintHash64_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedFixed32 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeFixed32(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedFixed64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeFixed64(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedFixed64String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeFixed64String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSfixed32 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeSfixed32(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSfixed64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeSfixed64(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSfixed64String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeSfixed64String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedFloat = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeFloat(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedDouble = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeDouble(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedBool = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeBool(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedEnum = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeEnum(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedString = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeString(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedBytes = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeBytes(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedMessage = function(a2, b, c) {
    if (b != null)
      for (var d = 0; d < b.length; d++) {
        var e = this.beginDelimited_(a2);
        c(b[d], this);
        this.endDelimited_(e);
      }
  };
  jspb.BinaryWriter.prototype.writeRepeatedGroup = function(a2, b, c) {
    if (b != null)
      for (var d = 0; d < b.length; d++)
        this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.START_GROUP), c(b[d], this), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.END_GROUP);
  };
  jspb.BinaryWriter.prototype.writeRepeatedFixedHash64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeFixedHash64(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedVarintHash64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeVarintHash64(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writePackedInt32 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeSignedVarint32(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedInt32String = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeSignedVarint32(parseInt(b[c], 10));
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedInt64 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeSignedVarint64(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSplitFixed64 = function(a2, b, c, d) {
    if (b != null) {
      a2 = this.beginDelimited_(a2);
      for (var e = 0; e < b.length; e++)
        this.encoder_.writeSplitFixed64(c(b[e]), d(b[e]));
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSplitVarint64 = function(a2, b, c, d) {
    if (b != null) {
      a2 = this.beginDelimited_(a2);
      for (var e = 0; e < b.length; e++)
        this.encoder_.writeSplitVarint64(c(b[e]), d(b[e]));
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSplitZigzagVarint64 = function(a2, b, c, d) {
    if (b != null) {
      a2 = this.beginDelimited_(a2);
      for (var e = this.encoder_, f = 0; f < b.length; f++)
        jspb.utils.toZigzag64(c(b[f]), d(b[f]), function(a3, b2) {
          e.writeSplitVarint64(a3 >>> 0, b2 >>> 0);
        });
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedInt64String = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++) {
        var d = jspb.arith.Int64.fromString(b[c]);
        this.encoder_.writeSplitVarint64(d.lo, d.hi);
      }
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedUint32 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeUnsignedVarint32(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedUint32String = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeUnsignedVarint32(parseInt(b[c], 10));
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedUint64 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeUnsignedVarint64(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedUint64String = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++) {
        var d = jspb.arith.UInt64.fromString(b[c]);
        this.encoder_.writeSplitVarint64(d.lo, d.hi);
      }
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSint32 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeZigzagVarint32(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSint64 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeZigzagVarint64(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSint64String = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(b[c]));
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSintHash64 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeZigzagVarintHash64(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedFixed32 = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeUint32(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedFixed64 = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeUint64(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedFixed64String = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++) {
        var c = jspb.arith.UInt64.fromString(b[a2]);
        this.encoder_.writeSplitFixed64(c.lo, c.hi);
      }
  };
  jspb.BinaryWriter.prototype.writePackedSfixed32 = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeInt32(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedSfixed64 = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeInt64(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedSfixed64String = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeInt64String(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedFloat = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeFloat(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedDouble = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeDouble(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedBool = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeBool(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedEnum = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeEnum(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedFixedHash64 = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeFixedHash64(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedVarintHash64 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeVarintHash64(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.Map = function(a2, b) {
    this.arr_ = a2;
    this.valueCtor_ = b;
    this.map_ = {};
    this.arrClean = true;
    0 < this.arr_.length && this.loadFromArray_();
  };
  jspb.Map.prototype.loadFromArray_ = function() {
    for (var a2 = 0; a2 < this.arr_.length; a2++) {
      var b = this.arr_[a2], c = b[0];
      this.map_[c.toString()] = new jspb.Map.Entry_(c, b[1]);
    }
    this.arrClean = true;
  };
  jspb.Map.prototype.toArray = function() {
    if (this.arrClean) {
      if (this.valueCtor_) {
        var a2 = this.map_, b;
        for (b in a2)
          if (Object.prototype.hasOwnProperty.call(a2, b)) {
            var c = a2[b].valueWrapper;
            c && c.toArray();
          }
      }
    } else {
      this.arr_.length = 0;
      a2 = this.stringKeys_();
      a2.sort();
      for (b = 0; b < a2.length; b++) {
        var d = this.map_[a2[b]];
        (c = d.valueWrapper) && c.toArray();
        this.arr_.push([d.key, d.value]);
      }
      this.arrClean = true;
    }
    return this.arr_;
  };
  jspb.Map.prototype.toObject = function(a2, b) {
    for (var c = this.toArray(), d = [], e = 0; e < c.length; e++) {
      var f = this.map_[c[e][0].toString()];
      this.wrapEntry_(f);
      var g = f.valueWrapper;
      g ? (goog.asserts.assert(b), d.push([f.key, b(a2, g)])) : d.push([f.key, f.value]);
    }
    return d;
  };
  jspb.Map.fromObject = function(a2, b, c) {
    b = new jspb.Map([], b);
    for (var d = 0; d < a2.length; d++) {
      var e = a2[d][0], f = c(a2[d][1]);
      b.set(e, f);
    }
    return b;
  };
  jspb.Map.ArrayIteratorIterable_ = function(a2) {
    this.idx_ = 0;
    this.arr_ = a2;
  };
  jspb.Map.ArrayIteratorIterable_.prototype.next = function() {
    return this.idx_ < this.arr_.length ? { done: false, value: this.arr_[this.idx_++] } : { done: true, value: void 0 };
  };
  typeof Symbol != "undefined" && (jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator] = function() {
    return this;
  });
  jspb.Map.prototype.getLength = function() {
    return this.stringKeys_().length;
  };
  jspb.Map.prototype.clear = function() {
    this.map_ = {};
    this.arrClean = false;
  };
  jspb.Map.prototype.del = function(a2) {
    a2 = a2.toString();
    var b = this.map_.hasOwnProperty(a2);
    delete this.map_[a2];
    this.arrClean = false;
    return b;
  };
  jspb.Map.prototype.getEntryList = function() {
    var a2 = [], b = this.stringKeys_();
    b.sort();
    for (var c = 0; c < b.length; c++) {
      var d = this.map_[b[c]];
      a2.push([d.key, d.value]);
    }
    return a2;
  };
  jspb.Map.prototype.entries = function() {
    var a2 = [], b = this.stringKeys_();
    b.sort();
    for (var c = 0; c < b.length; c++) {
      var d = this.map_[b[c]];
      a2.push([d.key, this.wrapEntry_(d)]);
    }
    return new jspb.Map.ArrayIteratorIterable_(a2);
  };
  jspb.Map.prototype.keys = function() {
    var a2 = [], b = this.stringKeys_();
    b.sort();
    for (var c = 0; c < b.length; c++)
      a2.push(this.map_[b[c]].key);
    return new jspb.Map.ArrayIteratorIterable_(a2);
  };
  jspb.Map.prototype.values = function() {
    var a2 = [], b = this.stringKeys_();
    b.sort();
    for (var c = 0; c < b.length; c++)
      a2.push(this.wrapEntry_(this.map_[b[c]]));
    return new jspb.Map.ArrayIteratorIterable_(a2);
  };
  jspb.Map.prototype.forEach = function(a2, b) {
    var c = this.stringKeys_();
    c.sort();
    for (var d = 0; d < c.length; d++) {
      var e = this.map_[c[d]];
      a2.call(b, this.wrapEntry_(e), e.key, this);
    }
  };
  jspb.Map.prototype.set = function(a2, b) {
    var c = new jspb.Map.Entry_(a2);
    this.valueCtor_ ? (c.valueWrapper = b, c.value = b.toArray()) : c.value = b;
    this.map_[a2.toString()] = c;
    this.arrClean = false;
    return this;
  };
  jspb.Map.prototype.wrapEntry_ = function(a2) {
    return this.valueCtor_ ? (a2.valueWrapper || (a2.valueWrapper = new this.valueCtor_(a2.value)), a2.valueWrapper) : a2.value;
  };
  jspb.Map.prototype.get = function(a2) {
    if (a2 = this.map_[a2.toString()])
      return this.wrapEntry_(a2);
  };
  jspb.Map.prototype.has = function(a2) {
    return a2.toString() in this.map_;
  };
  jspb.Map.prototype.serializeBinary = function(a2, b, c, d, e) {
    var f = this.stringKeys_();
    f.sort();
    for (var g = 0; g < f.length; g++) {
      var h = this.map_[f[g]];
      b.beginSubMessage(a2);
      c.call(b, 1, h.key);
      this.valueCtor_ ? d.call(b, 2, this.wrapEntry_(h), e) : d.call(b, 2, h.value);
      b.endSubMessage();
    }
  };
  jspb.Map.deserializeBinary = function(a2, b, c, d, e, f, g) {
    for (; b.nextField() && !b.isEndGroup(); ) {
      var h = b.getFieldNumber();
      h == 1 ? f = c.call(b) : h == 2 && (a2.valueCtor_ ? (goog.asserts.assert(e), g || (g = new a2.valueCtor_()), d.call(b, g, e)) : g = d.call(b));
    }
    goog.asserts.assert(f != void 0);
    goog.asserts.assert(g != void 0);
    a2.set(f, g);
  };
  jspb.Map.prototype.stringKeys_ = function() {
    var a2 = this.map_, b = [], c;
    for (c in a2)
      Object.prototype.hasOwnProperty.call(a2, c) && b.push(c);
    return b;
  };
  jspb.Map.Entry_ = function(a2, b) {
    this.key = a2;
    this.value = b;
    this.valueWrapper = void 0;
  };
  jspb.ExtensionFieldInfo = function(a2, b, c, d, e) {
    this.fieldIndex = a2;
    this.fieldName = b;
    this.ctor = c;
    this.toObjectFn = d;
    this.isRepeated = e;
  };
  jspb.ExtensionFieldBinaryInfo = function(a2, b, c, d, e, f) {
    this.fieldInfo = a2;
    this.binaryReaderFn = b;
    this.binaryWriterFn = c;
    this.binaryMessageSerializeFn = d;
    this.binaryMessageDeserializeFn = e;
    this.isPacked = f;
  };
  jspb.ExtensionFieldInfo.prototype.isMessageType = function() {
    return !!this.ctor;
  };
  jspb.Message = function() {
  };
  jspb.Message.GENERATE_TO_OBJECT = true;
  jspb.Message.GENERATE_FROM_OBJECT = !goog.DISALLOW_TEST_ONLY_CODE;
  jspb.Message.GENERATE_TO_STRING = true;
  jspb.Message.ASSUME_LOCAL_ARRAYS = false;
  jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS = true;
  jspb.Message.SUPPORTS_UINT8ARRAY_ = typeof Uint8Array == "function";
  jspb.Message.prototype.getJsPbMessageId = function() {
    return this.messageId_;
  };
  jspb.Message.getIndex_ = function(a2, b) {
    return b + a2.arrayIndexOffset_;
  };
  jspb.Message.hiddenES6Property_ = function() {
  };
  jspb.Message.getFieldNumber_ = function(a2, b) {
    return b - a2.arrayIndexOffset_;
  };
  jspb.Message.initialize = function(a2, b, c, d, e, f) {
    a2.wrappers_ = null;
    b || (b = c ? [c] : []);
    a2.messageId_ = c ? String(c) : void 0;
    a2.arrayIndexOffset_ = c === 0 ? -1 : 0;
    a2.array = b;
    jspb.Message.initPivotAndExtensionObject_(a2, d);
    a2.convertedPrimitiveFields_ = {};
    jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS || (a2.repeatedFields = e);
    if (e)
      for (b = 0; b < e.length; b++)
        c = e[b], c < a2.pivot_ ? (c = jspb.Message.getIndex_(a2, c), a2.array[c] = a2.array[c] || jspb.Message.EMPTY_LIST_SENTINEL_) : (jspb.Message.maybeInitEmptyExtensionObject_(a2), a2.extensionObject_[c] = a2.extensionObject_[c] || jspb.Message.EMPTY_LIST_SENTINEL_);
    if (f && f.length)
      for (b = 0; b < f.length; b++)
        jspb.Message.computeOneofCase(a2, f[b]);
  };
  jspb.Message.EMPTY_LIST_SENTINEL_ = goog.DEBUG && Object.freeze ? Object.freeze([]) : [];
  jspb.Message.isArray_ = function(a2) {
    return jspb.Message.ASSUME_LOCAL_ARRAYS ? a2 instanceof Array : Array.isArray(a2);
  };
  jspb.Message.isExtensionObject_ = function(a2) {
    return a2 !== null && typeof a2 == "object" && !jspb.Message.isArray_(a2) && !(jspb.Message.SUPPORTS_UINT8ARRAY_ && a2 instanceof Uint8Array);
  };
  jspb.Message.initPivotAndExtensionObject_ = function(a2, b) {
    var c = a2.array.length, d = -1;
    if (c && (d = c - 1, c = a2.array[d], jspb.Message.isExtensionObject_(c))) {
      a2.pivot_ = jspb.Message.getFieldNumber_(a2, d);
      a2.extensionObject_ = c;
      return;
    }
    -1 < b ? (a2.pivot_ = Math.max(b, jspb.Message.getFieldNumber_(a2, d + 1)), a2.extensionObject_ = null) : a2.pivot_ = Number.MAX_VALUE;
  };
  jspb.Message.maybeInitEmptyExtensionObject_ = function(a2) {
    var b = jspb.Message.getIndex_(a2, a2.pivot_);
    a2.array[b] || (a2.extensionObject_ = a2.array[b] = {});
  };
  jspb.Message.toObjectList = function(a2, b, c) {
    for (var d = [], e = 0; e < a2.length; e++)
      d[e] = b.call(a2[e], c, a2[e]);
    return d;
  };
  jspb.Message.toObjectExtension = function(a2, b, c, d, e) {
    for (var f in c) {
      var g = c[f], h = d.call(a2, g);
      if (h != null) {
        for (var k in g.fieldName)
          if (g.fieldName.hasOwnProperty(k))
            break;
        b[k] = g.toObjectFn ? g.isRepeated ? jspb.Message.toObjectList(h, g.toObjectFn, e) : g.toObjectFn(e, h) : h;
      }
    }
  };
  jspb.Message.serializeBinaryExtensions = function(a2, b, c, d) {
    for (var e in c) {
      var f = c[e], g = f.fieldInfo;
      if (!f.binaryWriterFn)
        throw Error("Message extension present that was generated without binary serialization support");
      var h = d.call(a2, g);
      if (h != null)
        if (g.isMessageType())
          if (f.binaryMessageSerializeFn)
            f.binaryWriterFn.call(b, g.fieldIndex, h, f.binaryMessageSerializeFn);
          else
            throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
        else
          f.binaryWriterFn.call(b, g.fieldIndex, h);
    }
  };
  jspb.Message.readBinaryExtension = function(a2, b, c, d, e) {
    var f = c[b.getFieldNumber()];
    if (f) {
      c = f.fieldInfo;
      if (!f.binaryReaderFn)
        throw Error("Deserializing extension whose generated code does not support binary format");
      if (c.isMessageType()) {
        var g = new c.ctor();
        f.binaryReaderFn.call(b, g, f.binaryMessageDeserializeFn);
      } else
        g = f.binaryReaderFn.call(b);
      c.isRepeated && !f.isPacked ? (b = d.call(a2, c)) ? b.push(g) : e.call(a2, c, [g]) : e.call(a2, c, g);
    } else
      b.skipField();
  };
  jspb.Message.getField = function(a2, b) {
    if (b < a2.pivot_) {
      b = jspb.Message.getIndex_(a2, b);
      var c = a2.array[b];
      return c === jspb.Message.EMPTY_LIST_SENTINEL_ ? a2.array[b] = [] : c;
    }
    if (a2.extensionObject_)
      return c = a2.extensionObject_[b], c === jspb.Message.EMPTY_LIST_SENTINEL_ ? a2.extensionObject_[b] = [] : c;
  };
  jspb.Message.getRepeatedField = function(a2, b) {
    return jspb.Message.getField(a2, b);
  };
  jspb.Message.getOptionalFloatingPointField = function(a2, b) {
    a2 = jspb.Message.getField(a2, b);
    return a2 == null ? a2 : +a2;
  };
  jspb.Message.getBooleanField = function(a2, b) {
    a2 = jspb.Message.getField(a2, b);
    return a2 == null ? a2 : !!a2;
  };
  jspb.Message.getRepeatedFloatingPointField = function(a2, b) {
    var c = jspb.Message.getRepeatedField(a2, b);
    a2.convertedPrimitiveFields_ || (a2.convertedPrimitiveFields_ = {});
    if (!a2.convertedPrimitiveFields_[b]) {
      for (var d = 0; d < c.length; d++)
        c[d] = +c[d];
      a2.convertedPrimitiveFields_[b] = true;
    }
    return c;
  };
  jspb.Message.getRepeatedBooleanField = function(a2, b) {
    var c = jspb.Message.getRepeatedField(a2, b);
    a2.convertedPrimitiveFields_ || (a2.convertedPrimitiveFields_ = {});
    if (!a2.convertedPrimitiveFields_[b]) {
      for (var d = 0; d < c.length; d++)
        c[d] = !!c[d];
      a2.convertedPrimitiveFields_[b] = true;
    }
    return c;
  };
  jspb.Message.bytesAsB64 = function(a2) {
    if (a2 == null || typeof a2 === "string")
      return a2;
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a2 instanceof Uint8Array)
      return goog.crypt.base64.encodeByteArray(a2);
    goog.asserts.fail("Cannot coerce to b64 string: " + goog.typeOf(a2));
    return null;
  };
  jspb.Message.bytesAsU8 = function(a2) {
    if (a2 == null || a2 instanceof Uint8Array)
      return a2;
    if (typeof a2 === "string")
      return goog.crypt.base64.decodeStringToUint8Array(a2);
    goog.asserts.fail("Cannot coerce to Uint8Array: " + goog.typeOf(a2));
    return null;
  };
  jspb.Message.bytesListAsB64 = function(a2) {
    jspb.Message.assertConsistentTypes_(a2);
    return a2.length && typeof a2[0] !== "string" ? goog.array.map(a2, jspb.Message.bytesAsB64) : a2;
  };
  jspb.Message.bytesListAsU8 = function(a2) {
    jspb.Message.assertConsistentTypes_(a2);
    return !a2.length || a2[0] instanceof Uint8Array ? a2 : goog.array.map(a2, jspb.Message.bytesAsU8);
  };
  jspb.Message.assertConsistentTypes_ = function(a2) {
    if (goog.DEBUG && a2 && 1 < a2.length) {
      var b = goog.typeOf(a2[0]);
      goog.array.forEach(a2, function(a3) {
        goog.typeOf(a3) != b && goog.asserts.fail("Inconsistent type in JSPB repeated field array. Got " + goog.typeOf(a3) + " expected " + b);
      });
    }
  };
  jspb.Message.getFieldWithDefault = function(a2, b, c) {
    a2 = jspb.Message.getField(a2, b);
    return a2 == null ? c : a2;
  };
  jspb.Message.getBooleanFieldWithDefault = function(a2, b, c) {
    a2 = jspb.Message.getBooleanField(a2, b);
    return a2 == null ? c : a2;
  };
  jspb.Message.getFloatingPointFieldWithDefault = function(a2, b, c) {
    a2 = jspb.Message.getOptionalFloatingPointField(a2, b);
    return a2 == null ? c : a2;
  };
  jspb.Message.getFieldProto3 = jspb.Message.getFieldWithDefault;
  jspb.Message.getMapField = function(a2, b, c, d) {
    a2.wrappers_ || (a2.wrappers_ = {});
    if (b in a2.wrappers_)
      return a2.wrappers_[b];
    var e = jspb.Message.getField(a2, b);
    if (!e) {
      if (c)
        return;
      e = [];
      jspb.Message.setField(a2, b, e);
    }
    return a2.wrappers_[b] = new jspb.Map(e, d);
  };
  jspb.Message.setField = function(a2, b, c) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    b < a2.pivot_ ? a2.array[jspb.Message.getIndex_(a2, b)] = c : (jspb.Message.maybeInitEmptyExtensionObject_(a2), a2.extensionObject_[b] = c);
    return a2;
  };
  jspb.Message.setProto3IntField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, 0);
  };
  jspb.Message.setProto3FloatField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, 0);
  };
  jspb.Message.setProto3BooleanField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, false);
  };
  jspb.Message.setProto3StringField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, "");
  };
  jspb.Message.setProto3BytesField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, "");
  };
  jspb.Message.setProto3EnumField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, 0);
  };
  jspb.Message.setProto3StringIntField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, "0");
  };
  jspb.Message.setFieldIgnoringDefault_ = function(a2, b, c, d) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    c !== d ? jspb.Message.setField(a2, b, c) : b < a2.pivot_ ? a2.array[jspb.Message.getIndex_(a2, b)] = null : (jspb.Message.maybeInitEmptyExtensionObject_(a2), delete a2.extensionObject_[b]);
    return a2;
  };
  jspb.Message.addToRepeatedField = function(a2, b, c, d) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    b = jspb.Message.getRepeatedField(a2, b);
    d != void 0 ? b.splice(d, 0, c) : b.push(c);
    return a2;
  };
  jspb.Message.setOneofField = function(a2, b, c, d) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    (c = jspb.Message.computeOneofCase(a2, c)) && c !== b && d !== void 0 && (a2.wrappers_ && c in a2.wrappers_ && (a2.wrappers_[c] = void 0), jspb.Message.setField(a2, c, void 0));
    return jspb.Message.setField(a2, b, d);
  };
  jspb.Message.computeOneofCase = function(a2, b) {
    for (var c, d, e = 0; e < b.length; e++) {
      var f = b[e], g = jspb.Message.getField(a2, f);
      g != null && (c = f, d = g, jspb.Message.setField(a2, f, void 0));
    }
    return c ? (jspb.Message.setField(a2, c, d), c) : 0;
  };
  jspb.Message.getWrapperField = function(a2, b, c, d) {
    a2.wrappers_ || (a2.wrappers_ = {});
    if (!a2.wrappers_[c]) {
      var e = jspb.Message.getField(a2, c);
      if (d || e)
        a2.wrappers_[c] = new b(e);
    }
    return a2.wrappers_[c];
  };
  jspb.Message.getRepeatedWrapperField = function(a2, b, c) {
    jspb.Message.wrapRepeatedField_(a2, b, c);
    b = a2.wrappers_[c];
    b == jspb.Message.EMPTY_LIST_SENTINEL_ && (b = a2.wrappers_[c] = []);
    return b;
  };
  jspb.Message.wrapRepeatedField_ = function(a2, b, c) {
    a2.wrappers_ || (a2.wrappers_ = {});
    if (!a2.wrappers_[c]) {
      for (var d = jspb.Message.getRepeatedField(a2, c), e = [], f = 0; f < d.length; f++)
        e[f] = new b(d[f]);
      a2.wrappers_[c] = e;
    }
  };
  jspb.Message.setWrapperField = function(a2, b, c) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    a2.wrappers_ || (a2.wrappers_ = {});
    var d = c ? c.toArray() : c;
    a2.wrappers_[b] = c;
    return jspb.Message.setField(a2, b, d);
  };
  jspb.Message.setOneofWrapperField = function(a2, b, c, d) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    a2.wrappers_ || (a2.wrappers_ = {});
    var e = d ? d.toArray() : d;
    a2.wrappers_[b] = d;
    return jspb.Message.setOneofField(a2, b, c, e);
  };
  jspb.Message.setRepeatedWrapperField = function(a2, b, c) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    a2.wrappers_ || (a2.wrappers_ = {});
    c = c || [];
    for (var d = [], e = 0; e < c.length; e++)
      d[e] = c[e].toArray();
    a2.wrappers_[b] = c;
    return jspb.Message.setField(a2, b, d);
  };
  jspb.Message.addToRepeatedWrapperField = function(a2, b, c, d, e) {
    jspb.Message.wrapRepeatedField_(a2, d, b);
    var f = a2.wrappers_[b];
    f || (f = a2.wrappers_[b] = []);
    c = c ? c : new d();
    a2 = jspb.Message.getRepeatedField(a2, b);
    e != void 0 ? (f.splice(e, 0, c), a2.splice(e, 0, c.toArray())) : (f.push(c), a2.push(c.toArray()));
    return c;
  };
  jspb.Message.toMap = function(a2, b, c, d) {
    for (var e = {}, f = 0; f < a2.length; f++)
      e[b.call(a2[f])] = c ? c.call(a2[f], d, a2[f]) : a2[f];
    return e;
  };
  jspb.Message.prototype.syncMapFields_ = function() {
    if (this.wrappers_)
      for (var a2 in this.wrappers_) {
        var b = this.wrappers_[a2];
        if (Array.isArray(b))
          for (var c = 0; c < b.length; c++)
            b[c] && b[c].toArray();
        else
          b && b.toArray();
      }
  };
  jspb.Message.prototype.toArray = function() {
    this.syncMapFields_();
    return this.array;
  };
  jspb.Message.GENERATE_TO_STRING && (jspb.Message.prototype.toString = function() {
    this.syncMapFields_();
    return this.array.toString();
  });
  jspb.Message.prototype.getExtension = function(a2) {
    if (this.extensionObject_) {
      this.wrappers_ || (this.wrappers_ = {});
      var b = a2.fieldIndex;
      if (a2.isRepeated) {
        if (a2.isMessageType())
          return this.wrappers_[b] || (this.wrappers_[b] = goog.array.map(this.extensionObject_[b] || [], function(b2) {
            return new a2.ctor(b2);
          })), this.wrappers_[b];
      } else if (a2.isMessageType())
        return !this.wrappers_[b] && this.extensionObject_[b] && (this.wrappers_[b] = new a2.ctor(this.extensionObject_[b])), this.wrappers_[b];
      return this.extensionObject_[b];
    }
  };
  jspb.Message.prototype.setExtension = function(a2, b) {
    this.wrappers_ || (this.wrappers_ = {});
    jspb.Message.maybeInitEmptyExtensionObject_(this);
    var c = a2.fieldIndex;
    a2.isRepeated ? (b = b || [], a2.isMessageType() ? (this.wrappers_[c] = b, this.extensionObject_[c] = goog.array.map(b, function(a3) {
      return a3.toArray();
    })) : this.extensionObject_[c] = b) : a2.isMessageType() ? (this.wrappers_[c] = b, this.extensionObject_[c] = b ? b.toArray() : b) : this.extensionObject_[c] = b;
    return this;
  };
  jspb.Message.difference = function(a2, b) {
    if (!(a2 instanceof b.constructor))
      throw Error("Messages have different types.");
    var c = a2.toArray();
    b = b.toArray();
    var d = [], e = 0, f = c.length > b.length ? c.length : b.length;
    a2.getJsPbMessageId() && (d[0] = a2.getJsPbMessageId(), e = 1);
    for (; e < f; e++)
      jspb.Message.compareFields(c[e], b[e]) || (d[e] = b[e]);
    return new a2.constructor(d);
  };
  jspb.Message.equals = function(a2, b) {
    return a2 == b || !(!a2 || !b) && a2 instanceof b.constructor && jspb.Message.compareFields(a2.toArray(), b.toArray());
  };
  jspb.Message.compareExtensions = function(a2, b) {
    a2 = a2 || {};
    b = b || {};
    var c = {}, d;
    for (d in a2)
      c[d] = 0;
    for (d in b)
      c[d] = 0;
    for (d in c)
      if (!jspb.Message.compareFields(a2[d], b[d]))
        return false;
    return true;
  };
  jspb.Message.compareFields = function(a2, b) {
    if (a2 == b)
      return true;
    if (!goog.isObject(a2) || !goog.isObject(b))
      return typeof a2 === "number" && isNaN(a2) || typeof b === "number" && isNaN(b) ? String(a2) == String(b) : false;
    if (a2.constructor != b.constructor)
      return false;
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a2.constructor === Uint8Array) {
      if (a2.length != b.length)
        return false;
      for (var c = 0; c < a2.length; c++)
        if (a2[c] != b[c])
          return false;
      return true;
    }
    if (a2.constructor === Array) {
      var d = void 0, e = void 0, f = Math.max(a2.length, b.length);
      for (c = 0; c < f; c++) {
        var g = a2[c], h = b[c];
        g && g.constructor == Object && (goog.asserts.assert(d === void 0), goog.asserts.assert(c === a2.length - 1), d = g, g = void 0);
        h && h.constructor == Object && (goog.asserts.assert(e === void 0), goog.asserts.assert(c === b.length - 1), e = h, h = void 0);
        if (!jspb.Message.compareFields(g, h))
          return false;
      }
      return d || e ? (d = d || {}, e = e || {}, jspb.Message.compareExtensions(d, e)) : true;
    }
    if (a2.constructor === Object)
      return jspb.Message.compareExtensions(a2, b);
    throw Error("Invalid type in JSPB array");
  };
  jspb.Message.prototype.cloneMessage = function() {
    return jspb.Message.cloneMessage(this);
  };
  jspb.Message.prototype.clone = function() {
    return jspb.Message.cloneMessage(this);
  };
  jspb.Message.clone = function(a2) {
    return jspb.Message.cloneMessage(a2);
  };
  jspb.Message.cloneMessage = function(a2) {
    return new a2.constructor(jspb.Message.clone_(a2.toArray()));
  };
  jspb.Message.copyInto = function(a2, b) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    goog.asserts.assertInstanceof(b, jspb.Message);
    goog.asserts.assert(a2.constructor == b.constructor, "Copy source and target message should have the same type.");
    a2 = jspb.Message.clone(a2);
    for (var c = b.toArray(), d = a2.toArray(), e = c.length = 0; e < d.length; e++)
      c[e] = d[e];
    b.wrappers_ = a2.wrappers_;
    b.extensionObject_ = a2.extensionObject_;
  };
  jspb.Message.clone_ = function(a2) {
    if (Array.isArray(a2)) {
      for (var b = Array(a2.length), c = 0; c < a2.length; c++) {
        var d = a2[c];
        d != null && (b[c] = typeof d == "object" ? jspb.Message.clone_(goog.asserts.assert(d)) : d);
      }
      return b;
    }
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a2 instanceof Uint8Array)
      return new Uint8Array(a2);
    b = {};
    for (c in a2)
      d = a2[c], d != null && (b[c] = typeof d == "object" ? jspb.Message.clone_(goog.asserts.assert(d)) : d);
    return b;
  };
  jspb.Message.registerMessageType = function(a2, b) {
    b.messageId = a2;
  };
  jspb.Message.messageSetExtensions = {};
  jspb.Message.messageSetExtensionsBinary = {};
  jspb.Export = {};
  exports.Map = jspb.Map, exports.Message = jspb.Message, exports.BinaryReader = jspb.BinaryReader, exports.BinaryWriter = jspb.BinaryWriter, exports.ExtensionFieldInfo = jspb.ExtensionFieldInfo, exports.ExtensionFieldBinaryInfo = jspb.ExtensionFieldBinaryInfo, exports.exportSymbol = goog.exportSymbol, exports.inherits = goog.inherits, exports.object = { extend: goog.object.extend }, exports.typeOf = goog.typeOf;
})(googleProtobuf$1);
var common_pb = {};
(function(exports2) {
  var jspb2 = googleProtobuf$1;
  var goog2 = jspb2;
  var global2 = Function("return this")();
  goog2.exportSymbol("proto.media.Codec", null, global2);
  goog2.exportSymbol("proto.media.CreateTransportRequest", null, global2);
  goog2.exportSymbol("proto.media.CreateTransportResponse", null, global2);
  goog2.exportSymbol("proto.media.DtlsParameters", null, global2);
  goog2.exportSymbol("proto.media.Fingerprint", null, global2);
  goog2.exportSymbol("proto.media.IceCandidate", null, global2);
  goog2.exportSymbol("proto.media.IceParameters", null, global2);
  goog2.exportSymbol("proto.media.MediaType", null, global2);
  goog2.exportSymbol("proto.media.NestedScore", null, global2);
  goog2.exportSymbol("proto.media.Pair", null, global2);
  goog2.exportSymbol("proto.media.Renegotiate", null, global2);
  goog2.exportSymbol("proto.media.RtcpParameters", null, global2);
  goog2.exportSymbol("proto.media.RtpParameters", null, global2);
  goog2.exportSymbol("proto.media.SessionDescription", null, global2);
  goog2.exportSymbol("proto.media.Target", null, global2);
  goog2.exportSymbol("proto.media.TrackInfo", null, global2);
  proto.media.Pair = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.Pair, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.Pair.displayName = "proto.media.Pair";
  }
  proto.media.Codec = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.Codec, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.Codec.displayName = "proto.media.Codec";
  }
  proto.media.RtcpParameters = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.RtcpParameters, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.RtcpParameters.displayName = "proto.media.RtcpParameters";
  }
  proto.media.RtpParameters = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.media.RtpParameters.repeatedFields_, null);
  };
  goog2.inherits(proto.media.RtpParameters, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.RtpParameters.displayName = "proto.media.RtpParameters";
  }
  proto.media.Fingerprint = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.Fingerprint, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.Fingerprint.displayName = "proto.media.Fingerprint";
  }
  proto.media.DtlsParameters = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.media.DtlsParameters.repeatedFields_, null);
  };
  goog2.inherits(proto.media.DtlsParameters, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.DtlsParameters.displayName = "proto.media.DtlsParameters";
  }
  proto.media.IceCandidate = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.IceCandidate, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.IceCandidate.displayName = "proto.media.IceCandidate";
  }
  proto.media.IceParameters = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.IceParameters, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.IceParameters.displayName = "proto.media.IceParameters";
  }
  proto.media.NestedScore = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.NestedScore, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.NestedScore.displayName = "proto.media.NestedScore";
  }
  proto.media.TrackInfo = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.TrackInfo, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.TrackInfo.displayName = "proto.media.TrackInfo";
  }
  proto.media.SessionDescription = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.SessionDescription, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.SessionDescription.displayName = "proto.media.SessionDescription";
  }
  proto.media.CreateTransportRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.CreateTransportRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.CreateTransportRequest.displayName = "proto.media.CreateTransportRequest";
  }
  proto.media.CreateTransportResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.CreateTransportResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.CreateTransportResponse.displayName = "proto.media.CreateTransportResponse";
  }
  proto.media.Renegotiate = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.Renegotiate, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.Renegotiate.displayName = "proto.media.Renegotiate";
  }
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.Pair.prototype.toObject = function(opt_includeInstance) {
      return proto.media.Pair.toObject(opt_includeInstance, this);
    };
    proto.media.Pair.toObject = function(includeInstance, msg) {
      var obj = {
        key: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        value: jspb2.Message.getFieldWithDefault(msg, 2, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.Pair.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.Pair();
    return proto.media.Pair.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.Pair.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setKey(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setValue(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.Pair.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.Pair.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.Pair.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getKey();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getValue();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };
  proto.media.Pair.prototype.getKey = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.Pair.prototype.setKey = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.Pair.prototype.getValue = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.Pair.prototype.setValue = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.Codec.prototype.toObject = function(opt_includeInstance) {
      return proto.media.Codec.toObject(opt_includeInstance, this);
    };
    proto.media.Codec.toObject = function(includeInstance, msg) {
      var obj = {};
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.Codec.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.Codec();
    return proto.media.Codec.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.Codec.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.Codec.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.Codec.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.Codec.serializeBinaryToWriter = function(message2, writer) {
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.RtcpParameters.prototype.toObject = function(opt_includeInstance) {
      return proto.media.RtcpParameters.toObject(opt_includeInstance, this);
    };
    proto.media.RtcpParameters.toObject = function(includeInstance, msg) {
      var obj = {
        cname: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        reducedSize: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false),
        mux: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.RtcpParameters.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.RtcpParameters();
    return proto.media.RtcpParameters.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.RtcpParameters.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setCname(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setReducedSize(value);
          break;
        case 3:
          var value = reader.readBool();
          msg.setMux(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.RtcpParameters.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.RtcpParameters.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.RtcpParameters.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getCname();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getReducedSize();
    if (f) {
      writer.writeBool(2, f);
    }
    f = message2.getMux();
    if (f) {
      writer.writeBool(3, f);
    }
  };
  proto.media.RtcpParameters.prototype.getCname = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.RtcpParameters.prototype.setCname = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.RtcpParameters.prototype.getReducedSize = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.media.RtcpParameters.prototype.setReducedSize = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  proto.media.RtcpParameters.prototype.getMux = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 3, false);
  };
  proto.media.RtcpParameters.prototype.setMux = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 3, value);
  };
  proto.media.RtpParameters.repeatedFields_ = [2, 3, 4];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.RtpParameters.prototype.toObject = function(opt_includeInstance) {
      return proto.media.RtpParameters.toObject(opt_includeInstance, this);
    };
    proto.media.RtpParameters.toObject = function(includeInstance, msg) {
      var f, obj = {
        mid: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        codecsList: jspb2.Message.toObjectList(msg.getCodecsList(), proto.media.Codec.toObject, includeInstance),
        headerExtensionsList: (f = jspb2.Message.getRepeatedField(msg, 3)) == null ? void 0 : f,
        encodingsList: (f = jspb2.Message.getRepeatedField(msg, 4)) == null ? void 0 : f,
        rtcp: (f = msg.getRtcp()) && proto.media.RtcpParameters.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.RtpParameters.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.RtpParameters();
    return proto.media.RtpParameters.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.RtpParameters.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setMid(value);
          break;
        case 2:
          var value = new proto.media.Codec();
          reader.readMessage(value, proto.media.Codec.deserializeBinaryFromReader);
          msg.addCodecs(value);
          break;
        case 3:
          var value = reader.readString();
          msg.addHeaderExtensions(value);
          break;
        case 4:
          var value = reader.readString();
          msg.addEncodings(value);
          break;
        case 5:
          var value = new proto.media.RtcpParameters();
          reader.readMessage(value, proto.media.RtcpParameters.deserializeBinaryFromReader);
          msg.setRtcp(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.RtpParameters.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.RtpParameters.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.RtpParameters.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getMid();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getCodecsList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(2, f, proto.media.Codec.serializeBinaryToWriter);
    }
    f = message2.getHeaderExtensionsList();
    if (f.length > 0) {
      writer.writeRepeatedString(3, f);
    }
    f = message2.getEncodingsList();
    if (f.length > 0) {
      writer.writeRepeatedString(4, f);
    }
    f = message2.getRtcp();
    if (f != null) {
      writer.writeMessage(5, f, proto.media.RtcpParameters.serializeBinaryToWriter);
    }
  };
  proto.media.RtpParameters.prototype.getMid = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.RtpParameters.prototype.setMid = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.RtpParameters.prototype.getCodecsList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.media.Codec, 2);
  };
  proto.media.RtpParameters.prototype.setCodecsList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 2, value);
  };
  proto.media.RtpParameters.prototype.addCodecs = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.media.Codec, opt_index);
  };
  proto.media.RtpParameters.prototype.clearCodecsList = function() {
    return this.setCodecsList([]);
  };
  proto.media.RtpParameters.prototype.getHeaderExtensionsList = function() {
    return jspb2.Message.getRepeatedField(this, 3);
  };
  proto.media.RtpParameters.prototype.setHeaderExtensionsList = function(value) {
    return jspb2.Message.setField(this, 3, value || []);
  };
  proto.media.RtpParameters.prototype.addHeaderExtensions = function(value, opt_index) {
    return jspb2.Message.addToRepeatedField(this, 3, value, opt_index);
  };
  proto.media.RtpParameters.prototype.clearHeaderExtensionsList = function() {
    return this.setHeaderExtensionsList([]);
  };
  proto.media.RtpParameters.prototype.getEncodingsList = function() {
    return jspb2.Message.getRepeatedField(this, 4);
  };
  proto.media.RtpParameters.prototype.setEncodingsList = function(value) {
    return jspb2.Message.setField(this, 4, value || []);
  };
  proto.media.RtpParameters.prototype.addEncodings = function(value, opt_index) {
    return jspb2.Message.addToRepeatedField(this, 4, value, opt_index);
  };
  proto.media.RtpParameters.prototype.clearEncodingsList = function() {
    return this.setEncodingsList([]);
  };
  proto.media.RtpParameters.prototype.getRtcp = function() {
    return jspb2.Message.getWrapperField(this, proto.media.RtcpParameters, 5);
  };
  proto.media.RtpParameters.prototype.setRtcp = function(value) {
    return jspb2.Message.setWrapperField(this, 5, value);
  };
  proto.media.RtpParameters.prototype.clearRtcp = function() {
    return this.setRtcp(void 0);
  };
  proto.media.RtpParameters.prototype.hasRtcp = function() {
    return jspb2.Message.getField(this, 5) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.Fingerprint.prototype.toObject = function(opt_includeInstance) {
      return proto.media.Fingerprint.toObject(opt_includeInstance, this);
    };
    proto.media.Fingerprint.toObject = function(includeInstance, msg) {
      var obj = {
        algorithm: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        value: jspb2.Message.getFieldWithDefault(msg, 2, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.Fingerprint.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.Fingerprint();
    return proto.media.Fingerprint.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.Fingerprint.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setAlgorithm(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setValue(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.Fingerprint.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.Fingerprint.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.Fingerprint.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getAlgorithm();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getValue();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };
  proto.media.Fingerprint.prototype.getAlgorithm = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.Fingerprint.prototype.setAlgorithm = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.Fingerprint.prototype.getValue = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.Fingerprint.prototype.setValue = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.media.DtlsParameters.repeatedFields_ = [1];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.DtlsParameters.prototype.toObject = function(opt_includeInstance) {
      return proto.media.DtlsParameters.toObject(opt_includeInstance, this);
    };
    proto.media.DtlsParameters.toObject = function(includeInstance, msg) {
      var obj = {
        fingerprintsList: jspb2.Message.toObjectList(msg.getFingerprintsList(), proto.media.Fingerprint.toObject, includeInstance),
        role: jspb2.Message.getFieldWithDefault(msg, 2, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.DtlsParameters.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.DtlsParameters();
    return proto.media.DtlsParameters.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.DtlsParameters.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.media.Fingerprint();
          reader.readMessage(value, proto.media.Fingerprint.deserializeBinaryFromReader);
          msg.addFingerprints(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setRole(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.DtlsParameters.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.DtlsParameters.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.DtlsParameters.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getFingerprintsList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(1, f, proto.media.Fingerprint.serializeBinaryToWriter);
    }
    f = message2.getRole();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };
  proto.media.DtlsParameters.prototype.getFingerprintsList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.media.Fingerprint, 1);
  };
  proto.media.DtlsParameters.prototype.setFingerprintsList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 1, value);
  };
  proto.media.DtlsParameters.prototype.addFingerprints = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.media.Fingerprint, opt_index);
  };
  proto.media.DtlsParameters.prototype.clearFingerprintsList = function() {
    return this.setFingerprintsList([]);
  };
  proto.media.DtlsParameters.prototype.getRole = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.DtlsParameters.prototype.setRole = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.IceCandidate.prototype.toObject = function(opt_includeInstance) {
      return proto.media.IceCandidate.toObject(opt_includeInstance, this);
    };
    proto.media.IceCandidate.toObject = function(includeInstance, msg) {
      var obj = {
        candidate: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        sdpMid: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        sdpmLineIndex: jspb2.Message.getFieldWithDefault(msg, 3, 0),
        usernameFragment: jspb2.Message.getFieldWithDefault(msg, 4, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.IceCandidate.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.IceCandidate();
    return proto.media.IceCandidate.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.IceCandidate.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setCandidate(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setSdpMid(value);
          break;
        case 3:
          var value = reader.readUint32();
          msg.setSdpmLineIndex(value);
          break;
        case 4:
          var value = reader.readString();
          msg.setUsernameFragment(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.IceCandidate.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.IceCandidate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.IceCandidate.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getCandidate();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = jspb2.Message.getField(message2, 2);
    if (f != null) {
      writer.writeString(2, f);
    }
    f = jspb2.Message.getField(message2, 3);
    if (f != null) {
      writer.writeUint32(3, f);
    }
    f = jspb2.Message.getField(message2, 4);
    if (f != null) {
      writer.writeString(4, f);
    }
  };
  proto.media.IceCandidate.prototype.getCandidate = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.IceCandidate.prototype.setCandidate = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.IceCandidate.prototype.getSdpMid = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.IceCandidate.prototype.setSdpMid = function(value) {
    return jspb2.Message.setField(this, 2, value);
  };
  proto.media.IceCandidate.prototype.clearSdpMid = function() {
    return jspb2.Message.setField(this, 2, void 0);
  };
  proto.media.IceCandidate.prototype.hasSdpMid = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  proto.media.IceCandidate.prototype.getSdpmLineIndex = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, 0);
  };
  proto.media.IceCandidate.prototype.setSdpmLineIndex = function(value) {
    return jspb2.Message.setField(this, 3, value);
  };
  proto.media.IceCandidate.prototype.clearSdpmLineIndex = function() {
    return jspb2.Message.setField(this, 3, void 0);
  };
  proto.media.IceCandidate.prototype.hasSdpmLineIndex = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  proto.media.IceCandidate.prototype.getUsernameFragment = function() {
    return jspb2.Message.getFieldWithDefault(this, 4, "");
  };
  proto.media.IceCandidate.prototype.setUsernameFragment = function(value) {
    return jspb2.Message.setField(this, 4, value);
  };
  proto.media.IceCandidate.prototype.clearUsernameFragment = function() {
    return jspb2.Message.setField(this, 4, void 0);
  };
  proto.media.IceCandidate.prototype.hasUsernameFragment = function() {
    return jspb2.Message.getField(this, 4) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.IceParameters.prototype.toObject = function(opt_includeInstance) {
      return proto.media.IceParameters.toObject(opt_includeInstance, this);
    };
    proto.media.IceParameters.toObject = function(includeInstance, msg) {
      var obj = {
        iceLite: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        password: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        usernameFragment: jspb2.Message.getFieldWithDefault(msg, 3, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.IceParameters.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.IceParameters();
    return proto.media.IceParameters.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.IceParameters.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setIceLite(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setPassword(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setUsernameFragment(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.IceParameters.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.IceParameters.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.IceParameters.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getIceLite();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message2.getPassword();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getUsernameFragment();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
  };
  proto.media.IceParameters.prototype.getIceLite = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.media.IceParameters.prototype.setIceLite = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.media.IceParameters.prototype.getPassword = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.IceParameters.prototype.setPassword = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.media.IceParameters.prototype.getUsernameFragment = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.media.IceParameters.prototype.setUsernameFragment = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.NestedScore.prototype.toObject = function(opt_includeInstance) {
      return proto.media.NestedScore.toObject(opt_includeInstance, this);
    };
    proto.media.NestedScore.toObject = function(includeInstance, msg) {
      var obj = {
        encodingIdx: jspb2.Message.getFieldWithDefault(msg, 1, 0),
        rid: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        score: jspb2.Message.getFieldWithDefault(msg, 3, 0),
        ssrc: jspb2.Message.getFieldWithDefault(msg, 4, 0)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.NestedScore.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.NestedScore();
    return proto.media.NestedScore.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.NestedScore.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readInt32();
          msg.setEncodingIdx(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setRid(value);
          break;
        case 3:
          var value = reader.readInt32();
          msg.setScore(value);
          break;
        case 4:
          var value = reader.readInt64();
          msg.setSsrc(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.NestedScore.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.NestedScore.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.NestedScore.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getEncodingIdx();
    if (f !== 0) {
      writer.writeInt32(1, f);
    }
    f = message2.getRid();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getScore();
    if (f !== 0) {
      writer.writeInt32(3, f);
    }
    f = message2.getSsrc();
    if (f !== 0) {
      writer.writeInt64(4, f);
    }
  };
  proto.media.NestedScore.prototype.getEncodingIdx = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, 0);
  };
  proto.media.NestedScore.prototype.setEncodingIdx = function(value) {
    return jspb2.Message.setProto3IntField(this, 1, value);
  };
  proto.media.NestedScore.prototype.getRid = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.NestedScore.prototype.setRid = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.media.NestedScore.prototype.getScore = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, 0);
  };
  proto.media.NestedScore.prototype.setScore = function(value) {
    return jspb2.Message.setProto3IntField(this, 3, value);
  };
  proto.media.NestedScore.prototype.getSsrc = function() {
    return jspb2.Message.getFieldWithDefault(this, 4, 0);
  };
  proto.media.NestedScore.prototype.setSsrc = function(value) {
    return jspb2.Message.setProto3IntField(this, 4, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.TrackInfo.prototype.toObject = function(opt_includeInstance) {
      return proto.media.TrackInfo.toObject(opt_includeInstance, this);
    };
    proto.media.TrackInfo.toObject = function(includeInstance, msg) {
      var obj = {
        id: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        kind: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        muted: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false),
        type: jspb2.Message.getFieldWithDefault(msg, 4, 0),
        streamId: jspb2.Message.getFieldWithDefault(msg, 5, ""),
        label: jspb2.Message.getFieldWithDefault(msg, 6, ""),
        layer: jspb2.Message.getFieldWithDefault(msg, 7, ""),
        width: jspb2.Message.getFieldWithDefault(msg, 8, 0),
        height: jspb2.Message.getFieldWithDefault(msg, 9, 0),
        frameRate: jspb2.Message.getFieldWithDefault(msg, 10, 0)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.TrackInfo.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.TrackInfo();
    return proto.media.TrackInfo.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.TrackInfo.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setKind(value);
          break;
        case 3:
          var value = reader.readBool();
          msg.setMuted(value);
          break;
        case 4:
          var value = reader.readEnum();
          msg.setType(value);
          break;
        case 5:
          var value = reader.readString();
          msg.setStreamId(value);
          break;
        case 6:
          var value = reader.readString();
          msg.setLabel(value);
          break;
        case 7:
          var value = reader.readString();
          msg.setLayer(value);
          break;
        case 8:
          var value = reader.readUint32();
          msg.setWidth(value);
          break;
        case 9:
          var value = reader.readUint32();
          msg.setHeight(value);
          break;
        case 10:
          var value = reader.readUint32();
          msg.setFrameRate(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.TrackInfo.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.TrackInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.TrackInfo.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getKind();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getMuted();
    if (f) {
      writer.writeBool(3, f);
    }
    f = message2.getType();
    if (f !== 0) {
      writer.writeEnum(4, f);
    }
    f = message2.getStreamId();
    if (f.length > 0) {
      writer.writeString(5, f);
    }
    f = message2.getLabel();
    if (f.length > 0) {
      writer.writeString(6, f);
    }
    f = message2.getLayer();
    if (f.length > 0) {
      writer.writeString(7, f);
    }
    f = message2.getWidth();
    if (f !== 0) {
      writer.writeUint32(8, f);
    }
    f = message2.getHeight();
    if (f !== 0) {
      writer.writeUint32(9, f);
    }
    f = message2.getFrameRate();
    if (f !== 0) {
      writer.writeUint32(10, f);
    }
  };
  proto.media.TrackInfo.prototype.getId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.TrackInfo.prototype.setId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.TrackInfo.prototype.getKind = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.TrackInfo.prototype.setKind = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.media.TrackInfo.prototype.getMuted = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 3, false);
  };
  proto.media.TrackInfo.prototype.setMuted = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 3, value);
  };
  proto.media.TrackInfo.prototype.getType = function() {
    return jspb2.Message.getFieldWithDefault(this, 4, 0);
  };
  proto.media.TrackInfo.prototype.setType = function(value) {
    return jspb2.Message.setProto3EnumField(this, 4, value);
  };
  proto.media.TrackInfo.prototype.getStreamId = function() {
    return jspb2.Message.getFieldWithDefault(this, 5, "");
  };
  proto.media.TrackInfo.prototype.setStreamId = function(value) {
    return jspb2.Message.setProto3StringField(this, 5, value);
  };
  proto.media.TrackInfo.prototype.getLabel = function() {
    return jspb2.Message.getFieldWithDefault(this, 6, "");
  };
  proto.media.TrackInfo.prototype.setLabel = function(value) {
    return jspb2.Message.setProto3StringField(this, 6, value);
  };
  proto.media.TrackInfo.prototype.getLayer = function() {
    return jspb2.Message.getFieldWithDefault(this, 7, "");
  };
  proto.media.TrackInfo.prototype.setLayer = function(value) {
    return jspb2.Message.setProto3StringField(this, 7, value);
  };
  proto.media.TrackInfo.prototype.getWidth = function() {
    return jspb2.Message.getFieldWithDefault(this, 8, 0);
  };
  proto.media.TrackInfo.prototype.setWidth = function(value) {
    return jspb2.Message.setProto3IntField(this, 8, value);
  };
  proto.media.TrackInfo.prototype.getHeight = function() {
    return jspb2.Message.getFieldWithDefault(this, 9, 0);
  };
  proto.media.TrackInfo.prototype.setHeight = function(value) {
    return jspb2.Message.setProto3IntField(this, 9, value);
  };
  proto.media.TrackInfo.prototype.getFrameRate = function() {
    return jspb2.Message.getFieldWithDefault(this, 10, 0);
  };
  proto.media.TrackInfo.prototype.setFrameRate = function(value) {
    return jspb2.Message.setProto3IntField(this, 10, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.SessionDescription.prototype.toObject = function(opt_includeInstance) {
      return proto.media.SessionDescription.toObject(opt_includeInstance, this);
    };
    proto.media.SessionDescription.toObject = function(includeInstance, msg) {
      var obj = {
        target: jspb2.Message.getFieldWithDefault(msg, 1, 0),
        type: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        sdp: jspb2.Message.getFieldWithDefault(msg, 3, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.SessionDescription.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.SessionDescription();
    return proto.media.SessionDescription.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.SessionDescription.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readEnum();
          msg.setTarget(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setType(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setSdp(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.SessionDescription.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.SessionDescription.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.SessionDescription.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getTarget();
    if (f !== 0) {
      writer.writeEnum(1, f);
    }
    f = message2.getType();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getSdp();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
  };
  proto.media.SessionDescription.prototype.getTarget = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, 0);
  };
  proto.media.SessionDescription.prototype.setTarget = function(value) {
    return jspb2.Message.setProto3EnumField(this, 1, value);
  };
  proto.media.SessionDescription.prototype.getType = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.SessionDescription.prototype.setType = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.media.SessionDescription.prototype.getSdp = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.media.SessionDescription.prototype.setSdp = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.CreateTransportRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.CreateTransportRequest.toObject(opt_includeInstance, this);
    };
    proto.media.CreateTransportRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        consuming: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        forceTcp: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false),
        description: (f = msg.getDescription()) && proto.media.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.CreateTransportRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.CreateTransportRequest();
    return proto.media.CreateTransportRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.CreateTransportRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setConsuming(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setForceTcp(value);
          break;
        case 3:
          var value = new proto.media.SessionDescription();
          reader.readMessage(value, proto.media.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.CreateTransportRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.CreateTransportRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.CreateTransportRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getConsuming();
    if (f) {
      writer.writeBool(1, f);
    }
    f = jspb2.Message.getField(message2, 2);
    if (f != null) {
      writer.writeBool(2, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(3, f, proto.media.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.CreateTransportRequest.prototype.getConsuming = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.media.CreateTransportRequest.prototype.setConsuming = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.media.CreateTransportRequest.prototype.getForceTcp = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.media.CreateTransportRequest.prototype.setForceTcp = function(value) {
    return jspb2.Message.setField(this, 2, value);
  };
  proto.media.CreateTransportRequest.prototype.clearForceTcp = function() {
    return jspb2.Message.setField(this, 2, void 0);
  };
  proto.media.CreateTransportRequest.prototype.hasForceTcp = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  proto.media.CreateTransportRequest.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, proto.media.SessionDescription, 3);
  };
  proto.media.CreateTransportRequest.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 3, value);
  };
  proto.media.CreateTransportRequest.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.CreateTransportRequest.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.CreateTransportResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.CreateTransportResponse.toObject(opt_includeInstance, this);
    };
    proto.media.CreateTransportResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        transportId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        description: (f = msg.getDescription()) && proto.media.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.CreateTransportResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.CreateTransportResponse();
    return proto.media.CreateTransportResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.CreateTransportResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setTransportId(value);
          break;
        case 2:
          var value = new proto.media.SessionDescription();
          reader.readMessage(value, proto.media.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.CreateTransportResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.CreateTransportResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.CreateTransportResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getTransportId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(2, f, proto.media.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.CreateTransportResponse.prototype.getTransportId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.CreateTransportResponse.prototype.setTransportId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.CreateTransportResponse.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, proto.media.SessionDescription, 2);
  };
  proto.media.CreateTransportResponse.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.CreateTransportResponse.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.CreateTransportResponse.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.Renegotiate.prototype.toObject = function(opt_includeInstance) {
      return proto.media.Renegotiate.toObject(opt_includeInstance, this);
    };
    proto.media.Renegotiate.toObject = function(includeInstance, msg) {
      var f, obj = {
        transportId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        description: (f = msg.getDescription()) && proto.media.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.Renegotiate.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.Renegotiate();
    return proto.media.Renegotiate.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.Renegotiate.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setTransportId(value);
          break;
        case 2:
          var value = new proto.media.SessionDescription();
          reader.readMessage(value, proto.media.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.Renegotiate.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.Renegotiate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.Renegotiate.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getTransportId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(2, f, proto.media.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.Renegotiate.prototype.getTransportId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.Renegotiate.prototype.setTransportId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.Renegotiate.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, proto.media.SessionDescription, 2);
  };
  proto.media.Renegotiate.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.Renegotiate.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.Renegotiate.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  proto.media.Target = {
    PUBLISHER: 0,
    SUBSCRIBER: 1
  };
  proto.media.MediaType = {
    MEDIAUNKNOWN: 0,
    USERMEDIA: 1,
    SCREENCAPTURE: 2,
    CAVANS: 3,
    STREAMING: 4,
    VOIP: 5
  };
  goog2.object.extend(exports2, proto.media);
})(common_pb);
(function(exports2) {
  var jspb2 = googleProtobuf$1;
  var goog2 = jspb2;
  var global2 = Function("return this")();
  var media_common_pb2 = common_pb;
  goog2.object.extend(proto, media_common_pb2);
  goog2.exportSymbol("proto.media.edge.ActiveSpeakerResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.ConnectWebRtcTransportRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.ConnectWebRtcTransportResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.ConsumeMultiplePeerRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.ConsumeMultiplePeerResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.ConsumePeerRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.ConsumePeerResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.ConsumerCloseRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.ConsumerClosingResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.ConsumerState", null, global2);
  goog2.exportSymbol("proto.media.edge.ConsumerToggleRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.ConsumerToggleResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.GetRoomStateResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.LatencyTestRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.NoActiveSpeakerResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.PeerJoinBroadcastResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.PeerJoinRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.PeerJoinResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.PeerLeaveBroadcastResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.PeerLeaveRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.PeerLeaveResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.PeerPreJoinRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.PeerPreJoinResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.PeerProducerCloseBroadcastResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.PeerProducerCreateBroadcastResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.PeerProducerToggleBroadcastResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.ProducerCloseRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.ProducerClosingResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.ProducerCreateRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.ProducerCreateResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.ProducerIdToConsumerMap", null, global2);
  goog2.exportSymbol("proto.media.edge.ProducerKind", null, global2);
  goog2.exportSymbol("proto.media.edge.ProducerScoreResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.ProducerState", null, global2);
  goog2.exportSymbol("proto.media.edge.ProducerToggleRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.ProducerToggleResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.RoomParticipants", null, global2);
  goog2.exportSymbol("proto.media.edge.SelectedPeersDiffEntry", null, global2);
  goog2.exportSymbol("proto.media.edge.SelectedPeersDiffResponse", null, global2);
  goog2.exportSymbol("proto.media.edge.SelectedPeersRequest", null, global2);
  goog2.exportSymbol("proto.media.edge.SelectedPeersResponse", null, global2);
  proto.media.edge.PeerPreJoinRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.PeerPreJoinRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.PeerPreJoinRequest.displayName = "proto.media.edge.PeerPreJoinRequest";
  }
  proto.media.edge.PeerJoinRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.PeerJoinRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.PeerJoinRequest.displayName = "proto.media.edge.PeerJoinRequest";
  }
  proto.media.edge.PeerLeaveRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.PeerLeaveRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.PeerLeaveRequest.displayName = "proto.media.edge.PeerLeaveRequest";
  }
  proto.media.edge.LatencyTestRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.LatencyTestRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.LatencyTestRequest.displayName = "proto.media.edge.LatencyTestRequest";
  }
  proto.media.edge.ConsumeMultiplePeerRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.media.edge.ConsumeMultiplePeerRequest.repeatedFields_, null);
  };
  goog2.inherits(proto.media.edge.ConsumeMultiplePeerRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ConsumeMultiplePeerRequest.displayName = "proto.media.edge.ConsumeMultiplePeerRequest";
  }
  proto.media.edge.ConsumePeerRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ConsumePeerRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ConsumePeerRequest.displayName = "proto.media.edge.ConsumePeerRequest";
  }
  proto.media.edge.ConnectWebRtcTransportRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ConnectWebRtcTransportRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ConnectWebRtcTransportRequest.displayName = "proto.media.edge.ConnectWebRtcTransportRequest";
  }
  proto.media.edge.ProducerCreateRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ProducerCreateRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ProducerCreateRequest.displayName = "proto.media.edge.ProducerCreateRequest";
  }
  proto.media.edge.SelectedPeersRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.SelectedPeersRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.SelectedPeersRequest.displayName = "proto.media.edge.SelectedPeersRequest";
  }
  proto.media.edge.ProducerToggleRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ProducerToggleRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ProducerToggleRequest.displayName = "proto.media.edge.ProducerToggleRequest";
  }
  proto.media.edge.ConsumerToggleRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ConsumerToggleRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ConsumerToggleRequest.displayName = "proto.media.edge.ConsumerToggleRequest";
  }
  proto.media.edge.ProducerCloseRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ProducerCloseRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ProducerCloseRequest.displayName = "proto.media.edge.ProducerCloseRequest";
  }
  proto.media.edge.ConsumerCloseRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ConsumerCloseRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ConsumerCloseRequest.displayName = "proto.media.edge.ConsumerCloseRequest";
  }
  proto.media.edge.GetRoomStateResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.GetRoomStateResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.GetRoomStateResponse.displayName = "proto.media.edge.GetRoomStateResponse";
  }
  proto.media.edge.ProducerState = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ProducerState, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ProducerState.displayName = "proto.media.edge.ProducerState";
  }
  proto.media.edge.RoomParticipants = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.media.edge.RoomParticipants.repeatedFields_, null);
  };
  goog2.inherits(proto.media.edge.RoomParticipants, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.RoomParticipants.displayName = "proto.media.edge.RoomParticipants";
  }
  proto.media.edge.PeerPreJoinResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.PeerPreJoinResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.PeerPreJoinResponse.displayName = "proto.media.edge.PeerPreJoinResponse";
  }
  proto.media.edge.PeerJoinResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.media.edge.PeerJoinResponse.repeatedFields_, null);
  };
  goog2.inherits(proto.media.edge.PeerJoinResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.PeerJoinResponse.displayName = "proto.media.edge.PeerJoinResponse";
  }
  proto.media.edge.PeerLeaveResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.PeerLeaveResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.PeerLeaveResponse.displayName = "proto.media.edge.PeerLeaveResponse";
  }
  proto.media.edge.ConsumerState = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ConsumerState, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ConsumerState.displayName = "proto.media.edge.ConsumerState";
  }
  proto.media.edge.ProducerIdToConsumerMap = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ProducerIdToConsumerMap, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ProducerIdToConsumerMap.displayName = "proto.media.edge.ProducerIdToConsumerMap";
  }
  proto.media.edge.ConsumeMultiplePeerResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ConsumeMultiplePeerResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ConsumeMultiplePeerResponse.displayName = "proto.media.edge.ConsumeMultiplePeerResponse";
  }
  proto.media.edge.ConsumePeerResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ConsumePeerResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ConsumePeerResponse.displayName = "proto.media.edge.ConsumePeerResponse";
  }
  proto.media.edge.ConnectWebRtcTransportResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ConnectWebRtcTransportResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ConnectWebRtcTransportResponse.displayName = "proto.media.edge.ConnectWebRtcTransportResponse";
  }
  proto.media.edge.ProducerCreateResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ProducerCreateResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ProducerCreateResponse.displayName = "proto.media.edge.ProducerCreateResponse";
  }
  proto.media.edge.ProducerScoreResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ProducerScoreResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ProducerScoreResponse.displayName = "proto.media.edge.ProducerScoreResponse";
  }
  proto.media.edge.ActiveSpeakerResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ActiveSpeakerResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ActiveSpeakerResponse.displayName = "proto.media.edge.ActiveSpeakerResponse";
  }
  proto.media.edge.NoActiveSpeakerResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.NoActiveSpeakerResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.NoActiveSpeakerResponse.displayName = "proto.media.edge.NoActiveSpeakerResponse";
  }
  proto.media.edge.SelectedPeersResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.media.edge.SelectedPeersResponse.repeatedFields_, null);
  };
  goog2.inherits(proto.media.edge.SelectedPeersResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.SelectedPeersResponse.displayName = "proto.media.edge.SelectedPeersResponse";
  }
  proto.media.edge.SelectedPeersDiffEntry = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.SelectedPeersDiffEntry, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.SelectedPeersDiffEntry.displayName = "proto.media.edge.SelectedPeersDiffEntry";
  }
  proto.media.edge.SelectedPeersDiffResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.media.edge.SelectedPeersDiffResponse.repeatedFields_, null);
  };
  goog2.inherits(proto.media.edge.SelectedPeersDiffResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.SelectedPeersDiffResponse.displayName = "proto.media.edge.SelectedPeersDiffResponse";
  }
  proto.media.edge.ProducerToggleResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ProducerToggleResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ProducerToggleResponse.displayName = "proto.media.edge.ProducerToggleResponse";
  }
  proto.media.edge.ConsumerToggleResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ConsumerToggleResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ConsumerToggleResponse.displayName = "proto.media.edge.ConsumerToggleResponse";
  }
  proto.media.edge.ProducerClosingResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ProducerClosingResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ProducerClosingResponse.displayName = "proto.media.edge.ProducerClosingResponse";
  }
  proto.media.edge.ConsumerClosingResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.ConsumerClosingResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.ConsumerClosingResponse.displayName = "proto.media.edge.ConsumerClosingResponse";
  }
  proto.media.edge.PeerJoinBroadcastResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.PeerJoinBroadcastResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.PeerJoinBroadcastResponse.displayName = "proto.media.edge.PeerJoinBroadcastResponse";
  }
  proto.media.edge.PeerProducerCreateBroadcastResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.PeerProducerCreateBroadcastResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.PeerProducerCreateBroadcastResponse.displayName = "proto.media.edge.PeerProducerCreateBroadcastResponse";
  }
  proto.media.edge.PeerProducerToggleBroadcastResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.PeerProducerToggleBroadcastResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.PeerProducerToggleBroadcastResponse.displayName = "proto.media.edge.PeerProducerToggleBroadcastResponse";
  }
  proto.media.edge.PeerProducerCloseBroadcastResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.PeerProducerCloseBroadcastResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.PeerProducerCloseBroadcastResponse.displayName = "proto.media.edge.PeerProducerCloseBroadcastResponse";
  }
  proto.media.edge.PeerLeaveBroadcastResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.edge.PeerLeaveBroadcastResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.edge.PeerLeaveBroadcastResponse.displayName = "proto.media.edge.PeerLeaveBroadcastResponse";
  }
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.PeerPreJoinRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.PeerPreJoinRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.PeerPreJoinRequest.toObject = function(includeInstance, msg) {
      var obj = {};
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.PeerPreJoinRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.PeerPreJoinRequest();
    return proto.media.edge.PeerPreJoinRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.PeerPreJoinRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.PeerPreJoinRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.PeerPreJoinRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.PeerPreJoinRequest.serializeBinaryToWriter = function(message2, writer) {
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.PeerJoinRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.PeerJoinRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.PeerJoinRequest.toObject = function(includeInstance, msg) {
      var obj = {
        displayName: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        prejoined: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.PeerJoinRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.PeerJoinRequest();
    return proto.media.edge.PeerJoinRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.PeerJoinRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setDisplayName(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setPrejoined(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.PeerJoinRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.PeerJoinRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.PeerJoinRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = jspb2.Message.getField(message2, 1);
    if (f != null) {
      writer.writeString(1, f);
    }
    f = message2.getPrejoined();
    if (f) {
      writer.writeBool(2, f);
    }
  };
  proto.media.edge.PeerJoinRequest.prototype.getDisplayName = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.PeerJoinRequest.prototype.setDisplayName = function(value) {
    return jspb2.Message.setField(this, 1, value);
  };
  proto.media.edge.PeerJoinRequest.prototype.clearDisplayName = function() {
    return jspb2.Message.setField(this, 1, void 0);
  };
  proto.media.edge.PeerJoinRequest.prototype.hasDisplayName = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  proto.media.edge.PeerJoinRequest.prototype.getPrejoined = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.media.edge.PeerJoinRequest.prototype.setPrejoined = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.PeerLeaveRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.PeerLeaveRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.PeerLeaveRequest.toObject = function(includeInstance, msg) {
      var obj = {
        closeRoom: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.PeerLeaveRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.PeerLeaveRequest();
    return proto.media.edge.PeerLeaveRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.PeerLeaveRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setCloseRoom(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.PeerLeaveRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.PeerLeaveRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.PeerLeaveRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getCloseRoom();
    if (f) {
      writer.writeBool(1, f);
    }
  };
  proto.media.edge.PeerLeaveRequest.prototype.getCloseRoom = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.media.edge.PeerLeaveRequest.prototype.setCloseRoom = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.LatencyTestRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.LatencyTestRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.LatencyTestRequest.toObject = function(includeInstance, msg) {
      var obj = {
        timestamp: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        id: jspb2.Message.getFieldWithDefault(msg, 2, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.LatencyTestRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.LatencyTestRequest();
    return proto.media.edge.LatencyTestRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.LatencyTestRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setTimestamp(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.LatencyTestRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.LatencyTestRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.LatencyTestRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getTimestamp();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getId();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };
  proto.media.edge.LatencyTestRequest.prototype.getTimestamp = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.LatencyTestRequest.prototype.setTimestamp = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.LatencyTestRequest.prototype.getId = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.edge.LatencyTestRequest.prototype.setId = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.repeatedFields_ = [1];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ConsumeMultiplePeerRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ConsumeMultiplePeerRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ConsumeMultiplePeerRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        producingPeerIdsList: (f = jspb2.Message.getRepeatedField(msg, 1)) == null ? void 0 : f,
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f),
        paused: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ConsumeMultiplePeerRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ConsumeMultiplePeerRequest();
    return proto.media.edge.ConsumeMultiplePeerRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.addProducingPeerIds(value);
          break;
        case 2:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        case 3:
          var value = reader.readBool();
          msg.setPaused(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ConsumeMultiplePeerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ConsumeMultiplePeerRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getProducingPeerIdsList();
    if (f.length > 0) {
      writer.writeRepeatedString(1, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(2, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
    f = jspb2.Message.getField(message2, 3);
    if (f != null) {
      writer.writeBool(3, f);
    }
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.getProducingPeerIdsList = function() {
    return jspb2.Message.getRepeatedField(this, 1);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.setProducingPeerIdsList = function(value) {
    return jspb2.Message.setField(this, 1, value || []);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.addProducingPeerIds = function(value, opt_index) {
    return jspb2.Message.addToRepeatedField(this, 1, value, opt_index);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.clearProducingPeerIdsList = function() {
    return this.setProducingPeerIdsList([]);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 2);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.getPaused = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 3, false);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.setPaused = function(value) {
    return jspb2.Message.setField(this, 3, value);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.clearPaused = function() {
    return jspb2.Message.setField(this, 3, void 0);
  };
  proto.media.edge.ConsumeMultiplePeerRequest.prototype.hasPaused = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ConsumePeerRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ConsumePeerRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ConsumePeerRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        producingPeerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f),
        paused: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false),
        producerId: jspb2.Message.getFieldWithDefault(msg, 4, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ConsumePeerRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ConsumePeerRequest();
    return proto.media.edge.ConsumePeerRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ConsumePeerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setProducingPeerId(value);
          break;
        case 2:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        case 3:
          var value = reader.readBool();
          msg.setPaused(value);
          break;
        case 4:
          var value = reader.readString();
          msg.setProducerId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ConsumePeerRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ConsumePeerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ConsumePeerRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getProducingPeerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(2, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
    f = jspb2.Message.getField(message2, 3);
    if (f != null) {
      writer.writeBool(3, f);
    }
    f = jspb2.Message.getField(message2, 4);
    if (f != null) {
      writer.writeString(4, f);
    }
  };
  proto.media.edge.ConsumePeerRequest.prototype.getProducingPeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.ConsumePeerRequest.prototype.setProducingPeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ConsumePeerRequest.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 2);
  };
  proto.media.edge.ConsumePeerRequest.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.edge.ConsumePeerRequest.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.edge.ConsumePeerRequest.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  proto.media.edge.ConsumePeerRequest.prototype.getPaused = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 3, false);
  };
  proto.media.edge.ConsumePeerRequest.prototype.setPaused = function(value) {
    return jspb2.Message.setField(this, 3, value);
  };
  proto.media.edge.ConsumePeerRequest.prototype.clearPaused = function() {
    return jspb2.Message.setField(this, 3, void 0);
  };
  proto.media.edge.ConsumePeerRequest.prototype.hasPaused = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  proto.media.edge.ConsumePeerRequest.prototype.getProducerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 4, "");
  };
  proto.media.edge.ConsumePeerRequest.prototype.setProducerId = function(value) {
    return jspb2.Message.setField(this, 4, value);
  };
  proto.media.edge.ConsumePeerRequest.prototype.clearProducerId = function() {
    return jspb2.Message.setField(this, 4, void 0);
  };
  proto.media.edge.ConsumePeerRequest.prototype.hasProducerId = function() {
    return jspb2.Message.getField(this, 4) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ConnectWebRtcTransportRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ConnectWebRtcTransportRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ConnectWebRtcTransportRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        transportId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        dtlsParameters: (f = msg.getDtlsParameters()) && media_common_pb2.DtlsParameters.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ConnectWebRtcTransportRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ConnectWebRtcTransportRequest();
    return proto.media.edge.ConnectWebRtcTransportRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ConnectWebRtcTransportRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setTransportId(value);
          break;
        case 2:
          var value = new media_common_pb2.DtlsParameters();
          reader.readMessage(value, media_common_pb2.DtlsParameters.deserializeBinaryFromReader);
          msg.setDtlsParameters(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ConnectWebRtcTransportRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ConnectWebRtcTransportRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ConnectWebRtcTransportRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getTransportId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getDtlsParameters();
    if (f != null) {
      writer.writeMessage(2, f, media_common_pb2.DtlsParameters.serializeBinaryToWriter);
    }
  };
  proto.media.edge.ConnectWebRtcTransportRequest.prototype.getTransportId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.ConnectWebRtcTransportRequest.prototype.setTransportId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ConnectWebRtcTransportRequest.prototype.getDtlsParameters = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.DtlsParameters, 2);
  };
  proto.media.edge.ConnectWebRtcTransportRequest.prototype.setDtlsParameters = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.edge.ConnectWebRtcTransportRequest.prototype.clearDtlsParameters = function() {
    return this.setDtlsParameters(void 0);
  };
  proto.media.edge.ConnectWebRtcTransportRequest.prototype.hasDtlsParameters = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ProducerCreateRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ProducerCreateRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ProducerCreateRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        kind: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        paused: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false),
        screenShare: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f),
        msid: jspb2.Message.getFieldWithDefault(msg, 5, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ProducerCreateRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ProducerCreateRequest();
    return proto.media.edge.ProducerCreateRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ProducerCreateRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setKind(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setPaused(value);
          break;
        case 3:
          var value = reader.readBool();
          msg.setScreenShare(value);
          break;
        case 4:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        case 5:
          var value = reader.readString();
          msg.setMsid(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ProducerCreateRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ProducerCreateRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ProducerCreateRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getKind();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getPaused();
    if (f) {
      writer.writeBool(2, f);
    }
    f = message2.getScreenShare();
    if (f) {
      writer.writeBool(3, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(4, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
    f = message2.getMsid();
    if (f.length > 0) {
      writer.writeString(5, f);
    }
  };
  proto.media.edge.ProducerCreateRequest.prototype.getKind = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.ProducerCreateRequest.prototype.setKind = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ProducerCreateRequest.prototype.getPaused = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.media.edge.ProducerCreateRequest.prototype.setPaused = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  proto.media.edge.ProducerCreateRequest.prototype.getScreenShare = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 3, false);
  };
  proto.media.edge.ProducerCreateRequest.prototype.setScreenShare = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 3, value);
  };
  proto.media.edge.ProducerCreateRequest.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 4);
  };
  proto.media.edge.ProducerCreateRequest.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 4, value);
  };
  proto.media.edge.ProducerCreateRequest.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.edge.ProducerCreateRequest.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 4) != null;
  };
  proto.media.edge.ProducerCreateRequest.prototype.getMsid = function() {
    return jspb2.Message.getFieldWithDefault(this, 5, "");
  };
  proto.media.edge.ProducerCreateRequest.prototype.setMsid = function(value) {
    return jspb2.Message.setProto3StringField(this, 5, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.SelectedPeersRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.SelectedPeersRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.SelectedPeersRequest.toObject = function(includeInstance, msg) {
      var obj = {};
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.SelectedPeersRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.SelectedPeersRequest();
    return proto.media.edge.SelectedPeersRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.SelectedPeersRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.SelectedPeersRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.SelectedPeersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.SelectedPeersRequest.serializeBinaryToWriter = function(message2, writer) {
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ProducerToggleRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ProducerToggleRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ProducerToggleRequest.toObject = function(includeInstance, msg) {
      var obj = {
        producerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        pause: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ProducerToggleRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ProducerToggleRequest();
    return proto.media.edge.ProducerToggleRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ProducerToggleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setProducerId(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setPause(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ProducerToggleRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ProducerToggleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ProducerToggleRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getProducerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getPause();
    if (f) {
      writer.writeBool(2, f);
    }
  };
  proto.media.edge.ProducerToggleRequest.prototype.getProducerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.ProducerToggleRequest.prototype.setProducerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ProducerToggleRequest.prototype.getPause = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.media.edge.ProducerToggleRequest.prototype.setPause = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ConsumerToggleRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ConsumerToggleRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ConsumerToggleRequest.toObject = function(includeInstance, msg) {
      var obj = {
        consumerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        pause: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ConsumerToggleRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ConsumerToggleRequest();
    return proto.media.edge.ConsumerToggleRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ConsumerToggleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setConsumerId(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setPause(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ConsumerToggleRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ConsumerToggleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ConsumerToggleRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getConsumerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getPause();
    if (f) {
      writer.writeBool(2, f);
    }
  };
  proto.media.edge.ConsumerToggleRequest.prototype.getConsumerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.ConsumerToggleRequest.prototype.setConsumerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ConsumerToggleRequest.prototype.getPause = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.media.edge.ConsumerToggleRequest.prototype.setPause = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ProducerCloseRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ProducerCloseRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ProducerCloseRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        producerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ProducerCloseRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ProducerCloseRequest();
    return proto.media.edge.ProducerCloseRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ProducerCloseRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setProducerId(value);
          break;
        case 2:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ProducerCloseRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ProducerCloseRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ProducerCloseRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getProducerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(2, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.edge.ProducerCloseRequest.prototype.getProducerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.ProducerCloseRequest.prototype.setProducerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ProducerCloseRequest.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 2);
  };
  proto.media.edge.ProducerCloseRequest.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.edge.ProducerCloseRequest.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.edge.ProducerCloseRequest.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ConsumerCloseRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ConsumerCloseRequest.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ConsumerCloseRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        consumerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ConsumerCloseRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ConsumerCloseRequest();
    return proto.media.edge.ConsumerCloseRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ConsumerCloseRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setConsumerId(value);
          break;
        case 2:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ConsumerCloseRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ConsumerCloseRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ConsumerCloseRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getConsumerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(2, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.edge.ConsumerCloseRequest.prototype.getConsumerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.ConsumerCloseRequest.prototype.setConsumerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ConsumerCloseRequest.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 2);
  };
  proto.media.edge.ConsumerCloseRequest.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.edge.ConsumerCloseRequest.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.edge.ConsumerCloseRequest.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.GetRoomStateResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.GetRoomStateResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.GetRoomStateResponse.toObject = function(includeInstance, msg) {
      var obj = {
        displayTitle: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        lockedMode: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false),
        roomUuid: jspb2.Message.getFieldWithDefault(msg, 3, ""),
        roomName: jspb2.Message.getFieldWithDefault(msg, 4, ""),
        currentPeerId: jspb2.Message.getFieldWithDefault(msg, 5, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.GetRoomStateResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.GetRoomStateResponse();
    return proto.media.edge.GetRoomStateResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.GetRoomStateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setDisplayTitle(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setLockedMode(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setRoomUuid(value);
          break;
        case 4:
          var value = reader.readString();
          msg.setRoomName(value);
          break;
        case 5:
          var value = reader.readString();
          msg.setCurrentPeerId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.GetRoomStateResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.GetRoomStateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.GetRoomStateResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getDisplayTitle();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getLockedMode();
    if (f) {
      writer.writeBool(2, f);
    }
    f = message2.getRoomUuid();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
    f = message2.getRoomName();
    if (f.length > 0) {
      writer.writeString(4, f);
    }
    f = message2.getCurrentPeerId();
    if (f.length > 0) {
      writer.writeString(5, f);
    }
  };
  proto.media.edge.GetRoomStateResponse.prototype.getDisplayTitle = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.GetRoomStateResponse.prototype.setDisplayTitle = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.GetRoomStateResponse.prototype.getLockedMode = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.media.edge.GetRoomStateResponse.prototype.setLockedMode = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  proto.media.edge.GetRoomStateResponse.prototype.getRoomUuid = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.media.edge.GetRoomStateResponse.prototype.setRoomUuid = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  proto.media.edge.GetRoomStateResponse.prototype.getRoomName = function() {
    return jspb2.Message.getFieldWithDefault(this, 4, "");
  };
  proto.media.edge.GetRoomStateResponse.prototype.setRoomName = function(value) {
    return jspb2.Message.setProto3StringField(this, 4, value);
  };
  proto.media.edge.GetRoomStateResponse.prototype.getCurrentPeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 5, "");
  };
  proto.media.edge.GetRoomStateResponse.prototype.setCurrentPeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 5, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ProducerState.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ProducerState.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ProducerState.toObject = function(includeInstance, msg) {
      var obj = {
        producerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        kind: jspb2.Message.getFieldWithDefault(msg, 2, 0),
        pause: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false),
        screenShare: jspb2.Message.getBooleanFieldWithDefault(msg, 4, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ProducerState.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ProducerState();
    return proto.media.edge.ProducerState.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ProducerState.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setProducerId(value);
          break;
        case 2:
          var value = reader.readEnum();
          msg.setKind(value);
          break;
        case 3:
          var value = reader.readBool();
          msg.setPause(value);
          break;
        case 4:
          var value = reader.readBool();
          msg.setScreenShare(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ProducerState.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ProducerState.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ProducerState.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getProducerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getKind();
    if (f !== 0) {
      writer.writeEnum(2, f);
    }
    f = message2.getPause();
    if (f) {
      writer.writeBool(3, f);
    }
    f = message2.getScreenShare();
    if (f) {
      writer.writeBool(4, f);
    }
  };
  proto.media.edge.ProducerState.prototype.getProducerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.ProducerState.prototype.setProducerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ProducerState.prototype.getKind = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, 0);
  };
  proto.media.edge.ProducerState.prototype.setKind = function(value) {
    return jspb2.Message.setProto3EnumField(this, 2, value);
  };
  proto.media.edge.ProducerState.prototype.getPause = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 3, false);
  };
  proto.media.edge.ProducerState.prototype.setPause = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 3, value);
  };
  proto.media.edge.ProducerState.prototype.getScreenShare = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 4, false);
  };
  proto.media.edge.ProducerState.prototype.setScreenShare = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 4, value);
  };
  proto.media.edge.RoomParticipants.repeatedFields_ = [2];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.RoomParticipants.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.RoomParticipants.toObject(opt_includeInstance, this);
    };
    proto.media.edge.RoomParticipants.toObject = function(includeInstance, msg) {
      var obj = {
        peerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        producerStatesList: jspb2.Message.toObjectList(msg.getProducerStatesList(), proto.media.edge.ProducerState.toObject, includeInstance),
        displayName: jspb2.Message.getFieldWithDefault(msg, 3, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.RoomParticipants.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.RoomParticipants();
    return proto.media.edge.RoomParticipants.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.RoomParticipants.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPeerId(value);
          break;
        case 2:
          var value = new proto.media.edge.ProducerState();
          reader.readMessage(value, proto.media.edge.ProducerState.deserializeBinaryFromReader);
          msg.addProducerStates(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setDisplayName(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.RoomParticipants.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.RoomParticipants.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.RoomParticipants.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPeerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getProducerStatesList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(2, f, proto.media.edge.ProducerState.serializeBinaryToWriter);
    }
    f = message2.getDisplayName();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
  };
  proto.media.edge.RoomParticipants.prototype.getPeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.RoomParticipants.prototype.setPeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.RoomParticipants.prototype.getProducerStatesList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.media.edge.ProducerState, 2);
  };
  proto.media.edge.RoomParticipants.prototype.setProducerStatesList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 2, value);
  };
  proto.media.edge.RoomParticipants.prototype.addProducerStates = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.media.edge.ProducerState, opt_index);
  };
  proto.media.edge.RoomParticipants.prototype.clearProducerStatesList = function() {
    return this.setProducerStatesList([]);
  };
  proto.media.edge.RoomParticipants.prototype.getDisplayName = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.media.edge.RoomParticipants.prototype.setDisplayName = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.PeerPreJoinResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.PeerPreJoinResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.PeerPreJoinResponse.toObject = function(includeInstance, msg) {
      var obj = {};
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.PeerPreJoinResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.PeerPreJoinResponse();
    return proto.media.edge.PeerPreJoinResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.PeerPreJoinResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.PeerPreJoinResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.PeerPreJoinResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.PeerPreJoinResponse.serializeBinaryToWriter = function(message2, writer) {
  };
  proto.media.edge.PeerJoinResponse.repeatedFields_ = [5];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.PeerJoinResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.PeerJoinResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.PeerJoinResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        maxPreferredStreams: jspb2.Message.getFieldWithDefault(msg, 2, 0),
        roomState: (f = msg.getRoomState()) && proto.media.edge.GetRoomStateResponse.toObject(includeInstance, f),
        participantsList: jspb2.Message.toObjectList(msg.getParticipantsList(), proto.media.edge.RoomParticipants.toObject, includeInstance)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.PeerJoinResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.PeerJoinResponse();
    return proto.media.edge.PeerJoinResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.PeerJoinResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 2:
          var value = reader.readInt32();
          msg.setMaxPreferredStreams(value);
          break;
        case 4:
          var value = new proto.media.edge.GetRoomStateResponse();
          reader.readMessage(value, proto.media.edge.GetRoomStateResponse.deserializeBinaryFromReader);
          msg.setRoomState(value);
          break;
        case 5:
          var value = new proto.media.edge.RoomParticipants();
          reader.readMessage(value, proto.media.edge.RoomParticipants.deserializeBinaryFromReader);
          msg.addParticipants(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.PeerJoinResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.PeerJoinResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.PeerJoinResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getMaxPreferredStreams();
    if (f !== 0) {
      writer.writeInt32(2, f);
    }
    f = message2.getRoomState();
    if (f != null) {
      writer.writeMessage(4, f, proto.media.edge.GetRoomStateResponse.serializeBinaryToWriter);
    }
    f = message2.getParticipantsList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(5, f, proto.media.edge.RoomParticipants.serializeBinaryToWriter);
    }
  };
  proto.media.edge.PeerJoinResponse.prototype.getMaxPreferredStreams = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, 0);
  };
  proto.media.edge.PeerJoinResponse.prototype.setMaxPreferredStreams = function(value) {
    return jspb2.Message.setProto3IntField(this, 2, value);
  };
  proto.media.edge.PeerJoinResponse.prototype.getRoomState = function() {
    return jspb2.Message.getWrapperField(this, proto.media.edge.GetRoomStateResponse, 4);
  };
  proto.media.edge.PeerJoinResponse.prototype.setRoomState = function(value) {
    return jspb2.Message.setWrapperField(this, 4, value);
  };
  proto.media.edge.PeerJoinResponse.prototype.clearRoomState = function() {
    return this.setRoomState(void 0);
  };
  proto.media.edge.PeerJoinResponse.prototype.hasRoomState = function() {
    return jspb2.Message.getField(this, 4) != null;
  };
  proto.media.edge.PeerJoinResponse.prototype.getParticipantsList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.media.edge.RoomParticipants, 5);
  };
  proto.media.edge.PeerJoinResponse.prototype.setParticipantsList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 5, value);
  };
  proto.media.edge.PeerJoinResponse.prototype.addParticipants = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.media.edge.RoomParticipants, opt_index);
  };
  proto.media.edge.PeerJoinResponse.prototype.clearParticipantsList = function() {
    return this.setParticipantsList([]);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.PeerLeaveResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.PeerLeaveResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.PeerLeaveResponse.toObject = function(includeInstance, msg) {
      var obj = {
        closed: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.PeerLeaveResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.PeerLeaveResponse();
    return proto.media.edge.PeerLeaveResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.PeerLeaveResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setClosed(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.PeerLeaveResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.PeerLeaveResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.PeerLeaveResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getClosed();
    if (f) {
      writer.writeBool(1, f);
    }
  };
  proto.media.edge.PeerLeaveResponse.prototype.getClosed = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.media.edge.PeerLeaveResponse.prototype.setClosed = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ConsumerState.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ConsumerState.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ConsumerState.toObject = function(includeInstance, msg) {
      var f, obj = {
        consumerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        producerState: (f = msg.getProducerState()) && proto.media.edge.ProducerState.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ConsumerState.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ConsumerState();
    return proto.media.edge.ConsumerState.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ConsumerState.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setConsumerId(value);
          break;
        case 2:
          var value = new proto.media.edge.ProducerState();
          reader.readMessage(value, proto.media.edge.ProducerState.deserializeBinaryFromReader);
          msg.setProducerState(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ConsumerState.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ConsumerState.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ConsumerState.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getConsumerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getProducerState();
    if (f != null) {
      writer.writeMessage(2, f, proto.media.edge.ProducerState.serializeBinaryToWriter);
    }
  };
  proto.media.edge.ConsumerState.prototype.getConsumerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.ConsumerState.prototype.setConsumerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ConsumerState.prototype.getProducerState = function() {
    return jspb2.Message.getWrapperField(this, proto.media.edge.ProducerState, 2);
  };
  proto.media.edge.ConsumerState.prototype.setProducerState = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.edge.ConsumerState.prototype.clearProducerState = function() {
    return this.setProducerState(void 0);
  };
  proto.media.edge.ConsumerState.prototype.hasProducerState = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ProducerIdToConsumerMap.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ProducerIdToConsumerMap.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ProducerIdToConsumerMap.toObject = function(includeInstance, msg) {
      var f, obj = {
        mapMap: (f = msg.getMapMap()) ? f.toObject(includeInstance, proto.media.edge.ConsumerState.toObject) : []
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ProducerIdToConsumerMap.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ProducerIdToConsumerMap();
    return proto.media.edge.ProducerIdToConsumerMap.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ProducerIdToConsumerMap.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = msg.getMapMap();
          reader.readMessage(value, function(message2, reader2) {
            jspb2.Map.deserializeBinary(message2, reader2, jspb2.BinaryReader.prototype.readString, jspb2.BinaryReader.prototype.readMessage, proto.media.edge.ConsumerState.deserializeBinaryFromReader, "", new proto.media.edge.ConsumerState());
          });
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ProducerIdToConsumerMap.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ProducerIdToConsumerMap.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ProducerIdToConsumerMap.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getMapMap(true);
    if (f && f.getLength() > 0) {
      f.serializeBinary(1, writer, jspb2.BinaryWriter.prototype.writeString, jspb2.BinaryWriter.prototype.writeMessage, proto.media.edge.ConsumerState.serializeBinaryToWriter);
    }
  };
  proto.media.edge.ProducerIdToConsumerMap.prototype.getMapMap = function(opt_noLazyCreate) {
    return jspb2.Message.getMapField(this, 1, opt_noLazyCreate, proto.media.edge.ConsumerState);
  };
  proto.media.edge.ProducerIdToConsumerMap.prototype.clearMapMap = function() {
    this.getMapMap().clear();
    return this;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ConsumeMultiplePeerResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ConsumeMultiplePeerResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ConsumeMultiplePeerResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        status: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        peerToConsumerIdsMapMap: (f = msg.getPeerToConsumerIdsMapMap()) ? f.toObject(includeInstance, proto.media.edge.ProducerIdToConsumerMap.toObject) : [],
        transportDetails: (f = msg.getTransportDetails()) && media_common_pb2.CreateTransportResponse.toObject(includeInstance, f),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ConsumeMultiplePeerResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ConsumeMultiplePeerResponse();
    return proto.media.edge.ConsumeMultiplePeerResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ConsumeMultiplePeerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setStatus(value);
          break;
        case 2:
          var value = msg.getPeerToConsumerIdsMapMap();
          reader.readMessage(value, function(message2, reader2) {
            jspb2.Map.deserializeBinary(message2, reader2, jspb2.BinaryReader.prototype.readString, jspb2.BinaryReader.prototype.readMessage, proto.media.edge.ProducerIdToConsumerMap.deserializeBinaryFromReader, "", new proto.media.edge.ProducerIdToConsumerMap());
          });
          break;
        case 3:
          var value = new media_common_pb2.CreateTransportResponse();
          reader.readMessage(value, media_common_pb2.CreateTransportResponse.deserializeBinaryFromReader);
          msg.setTransportDetails(value);
          break;
        case 4:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ConsumeMultiplePeerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ConsumeMultiplePeerResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getStatus();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message2.getPeerToConsumerIdsMapMap(true);
    if (f && f.getLength() > 0) {
      f.serializeBinary(2, writer, jspb2.BinaryWriter.prototype.writeString, jspb2.BinaryWriter.prototype.writeMessage, proto.media.edge.ProducerIdToConsumerMap.serializeBinaryToWriter);
    }
    f = message2.getTransportDetails();
    if (f != null) {
      writer.writeMessage(3, f, media_common_pb2.CreateTransportResponse.serializeBinaryToWriter);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(4, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.getStatus = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.setStatus = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.getPeerToConsumerIdsMapMap = function(opt_noLazyCreate) {
    return jspb2.Message.getMapField(this, 2, opt_noLazyCreate, proto.media.edge.ProducerIdToConsumerMap);
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.clearPeerToConsumerIdsMapMap = function() {
    this.getPeerToConsumerIdsMapMap().clear();
    return this;
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.getTransportDetails = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.CreateTransportResponse, 3);
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.setTransportDetails = function(value) {
    return jspb2.Message.setWrapperField(this, 3, value);
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.clearTransportDetails = function() {
    return this.setTransportDetails(void 0);
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.hasTransportDetails = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 4);
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 4, value);
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.edge.ConsumeMultiplePeerResponse.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 4) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ConsumePeerResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ConsumePeerResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ConsumePeerResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        status: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        consumerIdsMap: (f = msg.getConsumerIdsMap()) && proto.media.edge.ProducerIdToConsumerMap.toObject(includeInstance, f),
        transportDetails: (f = msg.getTransportDetails()) && media_common_pb2.CreateTransportResponse.toObject(includeInstance, f),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ConsumePeerResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ConsumePeerResponse();
    return proto.media.edge.ConsumePeerResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ConsumePeerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setStatus(value);
          break;
        case 2:
          var value = new proto.media.edge.ProducerIdToConsumerMap();
          reader.readMessage(value, proto.media.edge.ProducerIdToConsumerMap.deserializeBinaryFromReader);
          msg.setConsumerIdsMap(value);
          break;
        case 3:
          var value = new media_common_pb2.CreateTransportResponse();
          reader.readMessage(value, media_common_pb2.CreateTransportResponse.deserializeBinaryFromReader);
          msg.setTransportDetails(value);
          break;
        case 4:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ConsumePeerResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ConsumePeerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ConsumePeerResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getStatus();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message2.getConsumerIdsMap();
    if (f != null) {
      writer.writeMessage(2, f, proto.media.edge.ProducerIdToConsumerMap.serializeBinaryToWriter);
    }
    f = message2.getTransportDetails();
    if (f != null) {
      writer.writeMessage(3, f, media_common_pb2.CreateTransportResponse.serializeBinaryToWriter);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(4, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.edge.ConsumePeerResponse.prototype.getStatus = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.media.edge.ConsumePeerResponse.prototype.setStatus = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.media.edge.ConsumePeerResponse.prototype.getConsumerIdsMap = function() {
    return jspb2.Message.getWrapperField(this, proto.media.edge.ProducerIdToConsumerMap, 2);
  };
  proto.media.edge.ConsumePeerResponse.prototype.setConsumerIdsMap = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.edge.ConsumePeerResponse.prototype.clearConsumerIdsMap = function() {
    return this.setConsumerIdsMap(void 0);
  };
  proto.media.edge.ConsumePeerResponse.prototype.hasConsumerIdsMap = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  proto.media.edge.ConsumePeerResponse.prototype.getTransportDetails = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.CreateTransportResponse, 3);
  };
  proto.media.edge.ConsumePeerResponse.prototype.setTransportDetails = function(value) {
    return jspb2.Message.setWrapperField(this, 3, value);
  };
  proto.media.edge.ConsumePeerResponse.prototype.clearTransportDetails = function() {
    return this.setTransportDetails(void 0);
  };
  proto.media.edge.ConsumePeerResponse.prototype.hasTransportDetails = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  proto.media.edge.ConsumePeerResponse.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 4);
  };
  proto.media.edge.ConsumePeerResponse.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 4, value);
  };
  proto.media.edge.ConsumePeerResponse.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.edge.ConsumePeerResponse.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 4) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ConnectWebRtcTransportResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ConnectWebRtcTransportResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ConnectWebRtcTransportResponse.toObject = function(includeInstance, msg) {
      var obj = {
        status: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ConnectWebRtcTransportResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ConnectWebRtcTransportResponse();
    return proto.media.edge.ConnectWebRtcTransportResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ConnectWebRtcTransportResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setStatus(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ConnectWebRtcTransportResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ConnectWebRtcTransportResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ConnectWebRtcTransportResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getStatus();
    if (f) {
      writer.writeBool(1, f);
    }
  };
  proto.media.edge.ConnectWebRtcTransportResponse.prototype.getStatus = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.media.edge.ConnectWebRtcTransportResponse.prototype.setStatus = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ProducerCreateResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ProducerCreateResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ProducerCreateResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        status: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        producerId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        transportDetails: (f = msg.getTransportDetails()) && media_common_pb2.CreateTransportResponse.toObject(includeInstance, f),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ProducerCreateResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ProducerCreateResponse();
    return proto.media.edge.ProducerCreateResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ProducerCreateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setStatus(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setProducerId(value);
          break;
        case 3:
          var value = new media_common_pb2.CreateTransportResponse();
          reader.readMessage(value, media_common_pb2.CreateTransportResponse.deserializeBinaryFromReader);
          msg.setTransportDetails(value);
          break;
        case 4:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ProducerCreateResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ProducerCreateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ProducerCreateResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getStatus();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message2.getProducerId();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getTransportDetails();
    if (f != null) {
      writer.writeMessage(3, f, media_common_pb2.CreateTransportResponse.serializeBinaryToWriter);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(4, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.edge.ProducerCreateResponse.prototype.getStatus = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.media.edge.ProducerCreateResponse.prototype.setStatus = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.media.edge.ProducerCreateResponse.prototype.getProducerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.edge.ProducerCreateResponse.prototype.setProducerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.media.edge.ProducerCreateResponse.prototype.getTransportDetails = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.CreateTransportResponse, 3);
  };
  proto.media.edge.ProducerCreateResponse.prototype.setTransportDetails = function(value) {
    return jspb2.Message.setWrapperField(this, 3, value);
  };
  proto.media.edge.ProducerCreateResponse.prototype.clearTransportDetails = function() {
    return this.setTransportDetails(void 0);
  };
  proto.media.edge.ProducerCreateResponse.prototype.hasTransportDetails = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  proto.media.edge.ProducerCreateResponse.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 4);
  };
  proto.media.edge.ProducerCreateResponse.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 4, value);
  };
  proto.media.edge.ProducerCreateResponse.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.edge.ProducerCreateResponse.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 4) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ProducerScoreResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ProducerScoreResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ProducerScoreResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        responseid: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        score: (f = msg.getScore()) && media_common_pb2.NestedScore.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ProducerScoreResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ProducerScoreResponse();
    return proto.media.edge.ProducerScoreResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ProducerScoreResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setResponseid(value);
          break;
        case 2:
          var value = new media_common_pb2.NestedScore();
          reader.readMessage(value, media_common_pb2.NestedScore.deserializeBinaryFromReader);
          msg.setScore(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ProducerScoreResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ProducerScoreResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ProducerScoreResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getResponseid();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getScore();
    if (f != null) {
      writer.writeMessage(2, f, media_common_pb2.NestedScore.serializeBinaryToWriter);
    }
  };
  proto.media.edge.ProducerScoreResponse.prototype.getResponseid = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.ProducerScoreResponse.prototype.setResponseid = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ProducerScoreResponse.prototype.getScore = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.NestedScore, 2);
  };
  proto.media.edge.ProducerScoreResponse.prototype.setScore = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.edge.ProducerScoreResponse.prototype.clearScore = function() {
    return this.setScore(void 0);
  };
  proto.media.edge.ProducerScoreResponse.prototype.hasScore = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ActiveSpeakerResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ActiveSpeakerResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ActiveSpeakerResponse.toObject = function(includeInstance, msg) {
      var obj = {
        responsepeerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        volume: jspb2.Message.getFieldWithDefault(msg, 2, 0)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ActiveSpeakerResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ActiveSpeakerResponse();
    return proto.media.edge.ActiveSpeakerResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ActiveSpeakerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setResponsepeerId(value);
          break;
        case 2:
          var value = reader.readInt32();
          msg.setVolume(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ActiveSpeakerResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ActiveSpeakerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ActiveSpeakerResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getResponsepeerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getVolume();
    if (f !== 0) {
      writer.writeInt32(2, f);
    }
  };
  proto.media.edge.ActiveSpeakerResponse.prototype.getResponsepeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.ActiveSpeakerResponse.prototype.setResponsepeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ActiveSpeakerResponse.prototype.getVolume = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, 0);
  };
  proto.media.edge.ActiveSpeakerResponse.prototype.setVolume = function(value) {
    return jspb2.Message.setProto3IntField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.NoActiveSpeakerResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.NoActiveSpeakerResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.NoActiveSpeakerResponse.toObject = function(includeInstance, msg) {
      var obj = {};
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.NoActiveSpeakerResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.NoActiveSpeakerResponse();
    return proto.media.edge.NoActiveSpeakerResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.NoActiveSpeakerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.NoActiveSpeakerResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.NoActiveSpeakerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.NoActiveSpeakerResponse.serializeBinaryToWriter = function(message2, writer) {
  };
  proto.media.edge.SelectedPeersResponse.repeatedFields_ = [1, 2];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.SelectedPeersResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.SelectedPeersResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.SelectedPeersResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        audioPeersList: (f = jspb2.Message.getRepeatedField(msg, 1)) == null ? void 0 : f,
        compulsoryPeersList: (f = jspb2.Message.getRepeatedField(msg, 2)) == null ? void 0 : f
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.SelectedPeersResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.SelectedPeersResponse();
    return proto.media.edge.SelectedPeersResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.SelectedPeersResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.addAudioPeers(value);
          break;
        case 2:
          var value = reader.readString();
          msg.addCompulsoryPeers(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.SelectedPeersResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.SelectedPeersResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.SelectedPeersResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getAudioPeersList();
    if (f.length > 0) {
      writer.writeRepeatedString(1, f);
    }
    f = message2.getCompulsoryPeersList();
    if (f.length > 0) {
      writer.writeRepeatedString(2, f);
    }
  };
  proto.media.edge.SelectedPeersResponse.prototype.getAudioPeersList = function() {
    return jspb2.Message.getRepeatedField(this, 1);
  };
  proto.media.edge.SelectedPeersResponse.prototype.setAudioPeersList = function(value) {
    return jspb2.Message.setField(this, 1, value || []);
  };
  proto.media.edge.SelectedPeersResponse.prototype.addAudioPeers = function(value, opt_index) {
    return jspb2.Message.addToRepeatedField(this, 1, value, opt_index);
  };
  proto.media.edge.SelectedPeersResponse.prototype.clearAudioPeersList = function() {
    return this.setAudioPeersList([]);
  };
  proto.media.edge.SelectedPeersResponse.prototype.getCompulsoryPeersList = function() {
    return jspb2.Message.getRepeatedField(this, 2);
  };
  proto.media.edge.SelectedPeersResponse.prototype.setCompulsoryPeersList = function(value) {
    return jspb2.Message.setField(this, 2, value || []);
  };
  proto.media.edge.SelectedPeersResponse.prototype.addCompulsoryPeers = function(value, opt_index) {
    return jspb2.Message.addToRepeatedField(this, 2, value, opt_index);
  };
  proto.media.edge.SelectedPeersResponse.prototype.clearCompulsoryPeersList = function() {
    return this.setCompulsoryPeersList([]);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.SelectedPeersDiffEntry.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.SelectedPeersDiffEntry.toObject(opt_includeInstance, this);
    };
    proto.media.edge.SelectedPeersDiffEntry.toObject = function(includeInstance, msg) {
      var obj = {
        peerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        priority: jspb2.Message.getFieldWithDefault(msg, 2, 0)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.SelectedPeersDiffEntry.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.SelectedPeersDiffEntry();
    return proto.media.edge.SelectedPeersDiffEntry.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.SelectedPeersDiffEntry.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPeerId(value);
          break;
        case 2:
          var value = reader.readInt32();
          msg.setPriority(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.SelectedPeersDiffEntry.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.SelectedPeersDiffEntry.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.SelectedPeersDiffEntry.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPeerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getPriority();
    if (f !== 0) {
      writer.writeInt32(2, f);
    }
  };
  proto.media.edge.SelectedPeersDiffEntry.prototype.getPeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.SelectedPeersDiffEntry.prototype.setPeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.SelectedPeersDiffEntry.prototype.getPriority = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, 0);
  };
  proto.media.edge.SelectedPeersDiffEntry.prototype.setPriority = function(value) {
    return jspb2.Message.setProto3IntField(this, 2, value);
  };
  proto.media.edge.SelectedPeersDiffResponse.repeatedFields_ = [1];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.SelectedPeersDiffResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.SelectedPeersDiffResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.SelectedPeersDiffResponse.toObject = function(includeInstance, msg) {
      var obj = {
        entriesList: jspb2.Message.toObjectList(msg.getEntriesList(), proto.media.edge.SelectedPeersDiffEntry.toObject, includeInstance)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.SelectedPeersDiffResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.SelectedPeersDiffResponse();
    return proto.media.edge.SelectedPeersDiffResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.SelectedPeersDiffResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.media.edge.SelectedPeersDiffEntry();
          reader.readMessage(value, proto.media.edge.SelectedPeersDiffEntry.deserializeBinaryFromReader);
          msg.addEntries(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.SelectedPeersDiffResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.SelectedPeersDiffResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.SelectedPeersDiffResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getEntriesList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(1, f, proto.media.edge.SelectedPeersDiffEntry.serializeBinaryToWriter);
    }
  };
  proto.media.edge.SelectedPeersDiffResponse.prototype.getEntriesList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.media.edge.SelectedPeersDiffEntry, 1);
  };
  proto.media.edge.SelectedPeersDiffResponse.prototype.setEntriesList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 1, value);
  };
  proto.media.edge.SelectedPeersDiffResponse.prototype.addEntries = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.media.edge.SelectedPeersDiffEntry, opt_index);
  };
  proto.media.edge.SelectedPeersDiffResponse.prototype.clearEntriesList = function() {
    return this.setEntriesList([]);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ProducerToggleResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ProducerToggleResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ProducerToggleResponse.toObject = function(includeInstance, msg) {
      var obj = {};
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ProducerToggleResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ProducerToggleResponse();
    return proto.media.edge.ProducerToggleResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ProducerToggleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ProducerToggleResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ProducerToggleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ProducerToggleResponse.serializeBinaryToWriter = function(message2, writer) {
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ConsumerToggleResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ConsumerToggleResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ConsumerToggleResponse.toObject = function(includeInstance, msg) {
      var obj = {};
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ConsumerToggleResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ConsumerToggleResponse();
    return proto.media.edge.ConsumerToggleResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ConsumerToggleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ConsumerToggleResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ConsumerToggleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ConsumerToggleResponse.serializeBinaryToWriter = function(message2, writer) {
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ProducerClosingResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ProducerClosingResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ProducerClosingResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ProducerClosingResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ProducerClosingResponse();
    return proto.media.edge.ProducerClosingResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ProducerClosingResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ProducerClosingResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ProducerClosingResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ProducerClosingResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(1, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.edge.ProducerClosingResponse.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 1);
  };
  proto.media.edge.ProducerClosingResponse.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.media.edge.ProducerClosingResponse.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.edge.ProducerClosingResponse.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.ConsumerClosingResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.ConsumerClosingResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.ConsumerClosingResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.ConsumerClosingResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.ConsumerClosingResponse();
    return proto.media.edge.ConsumerClosingResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.ConsumerClosingResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.ConsumerClosingResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.ConsumerClosingResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.ConsumerClosingResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(1, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.edge.ConsumerClosingResponse.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 1);
  };
  proto.media.edge.ConsumerClosingResponse.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.media.edge.ConsumerClosingResponse.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.edge.ConsumerClosingResponse.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.PeerJoinBroadcastResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.PeerJoinBroadcastResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.PeerJoinBroadcastResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        participant: (f = msg.getParticipant()) && proto.media.edge.RoomParticipants.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.PeerJoinBroadcastResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.PeerJoinBroadcastResponse();
    return proto.media.edge.PeerJoinBroadcastResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.PeerJoinBroadcastResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.media.edge.RoomParticipants();
          reader.readMessage(value, proto.media.edge.RoomParticipants.deserializeBinaryFromReader);
          msg.setParticipant(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.PeerJoinBroadcastResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.PeerJoinBroadcastResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.PeerJoinBroadcastResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getParticipant();
    if (f != null) {
      writer.writeMessage(1, f, proto.media.edge.RoomParticipants.serializeBinaryToWriter);
    }
  };
  proto.media.edge.PeerJoinBroadcastResponse.prototype.getParticipant = function() {
    return jspb2.Message.getWrapperField(this, proto.media.edge.RoomParticipants, 1);
  };
  proto.media.edge.PeerJoinBroadcastResponse.prototype.setParticipant = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.media.edge.PeerJoinBroadcastResponse.prototype.clearParticipant = function() {
    return this.setParticipant(void 0);
  };
  proto.media.edge.PeerJoinBroadcastResponse.prototype.hasParticipant = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.PeerProducerCreateBroadcastResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.PeerProducerCreateBroadcastResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.PeerProducerCreateBroadcastResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        participantId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        producerState: (f = msg.getProducerState()) && proto.media.edge.ProducerState.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.PeerProducerCreateBroadcastResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.PeerProducerCreateBroadcastResponse();
    return proto.media.edge.PeerProducerCreateBroadcastResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.PeerProducerCreateBroadcastResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setParticipantId(value);
          break;
        case 2:
          var value = new proto.media.edge.ProducerState();
          reader.readMessage(value, proto.media.edge.ProducerState.deserializeBinaryFromReader);
          msg.setProducerState(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.PeerProducerCreateBroadcastResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.PeerProducerCreateBroadcastResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.PeerProducerCreateBroadcastResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getParticipantId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getProducerState();
    if (f != null) {
      writer.writeMessage(2, f, proto.media.edge.ProducerState.serializeBinaryToWriter);
    }
  };
  proto.media.edge.PeerProducerCreateBroadcastResponse.prototype.getParticipantId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.PeerProducerCreateBroadcastResponse.prototype.setParticipantId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.PeerProducerCreateBroadcastResponse.prototype.getProducerState = function() {
    return jspb2.Message.getWrapperField(this, proto.media.edge.ProducerState, 2);
  };
  proto.media.edge.PeerProducerCreateBroadcastResponse.prototype.setProducerState = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.edge.PeerProducerCreateBroadcastResponse.prototype.clearProducerState = function() {
    return this.setProducerState(void 0);
  };
  proto.media.edge.PeerProducerCreateBroadcastResponse.prototype.hasProducerState = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.PeerProducerToggleBroadcastResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.PeerProducerToggleBroadcastResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.PeerProducerToggleBroadcastResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        participantId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        producerState: (f = msg.getProducerState()) && proto.media.edge.ProducerState.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.PeerProducerToggleBroadcastResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.PeerProducerToggleBroadcastResponse();
    return proto.media.edge.PeerProducerToggleBroadcastResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.PeerProducerToggleBroadcastResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setParticipantId(value);
          break;
        case 2:
          var value = new proto.media.edge.ProducerState();
          reader.readMessage(value, proto.media.edge.ProducerState.deserializeBinaryFromReader);
          msg.setProducerState(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.PeerProducerToggleBroadcastResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.PeerProducerToggleBroadcastResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.PeerProducerToggleBroadcastResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getParticipantId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getProducerState();
    if (f != null) {
      writer.writeMessage(2, f, proto.media.edge.ProducerState.serializeBinaryToWriter);
    }
  };
  proto.media.edge.PeerProducerToggleBroadcastResponse.prototype.getParticipantId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.PeerProducerToggleBroadcastResponse.prototype.setParticipantId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.PeerProducerToggleBroadcastResponse.prototype.getProducerState = function() {
    return jspb2.Message.getWrapperField(this, proto.media.edge.ProducerState, 2);
  };
  proto.media.edge.PeerProducerToggleBroadcastResponse.prototype.setProducerState = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.edge.PeerProducerToggleBroadcastResponse.prototype.clearProducerState = function() {
    return this.setProducerState(void 0);
  };
  proto.media.edge.PeerProducerToggleBroadcastResponse.prototype.hasProducerState = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.PeerProducerCloseBroadcastResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.PeerProducerCloseBroadcastResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.PeerProducerCloseBroadcastResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        participantId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        producerState: (f = msg.getProducerState()) && proto.media.edge.ProducerState.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.PeerProducerCloseBroadcastResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.PeerProducerCloseBroadcastResponse();
    return proto.media.edge.PeerProducerCloseBroadcastResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.PeerProducerCloseBroadcastResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setParticipantId(value);
          break;
        case 2:
          var value = new proto.media.edge.ProducerState();
          reader.readMessage(value, proto.media.edge.ProducerState.deserializeBinaryFromReader);
          msg.setProducerState(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.PeerProducerCloseBroadcastResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.PeerProducerCloseBroadcastResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.PeerProducerCloseBroadcastResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getParticipantId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getProducerState();
    if (f != null) {
      writer.writeMessage(2, f, proto.media.edge.ProducerState.serializeBinaryToWriter);
    }
  };
  proto.media.edge.PeerProducerCloseBroadcastResponse.prototype.getParticipantId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.PeerProducerCloseBroadcastResponse.prototype.setParticipantId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.PeerProducerCloseBroadcastResponse.prototype.getProducerState = function() {
    return jspb2.Message.getWrapperField(this, proto.media.edge.ProducerState, 2);
  };
  proto.media.edge.PeerProducerCloseBroadcastResponse.prototype.setProducerState = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.edge.PeerProducerCloseBroadcastResponse.prototype.clearProducerState = function() {
    return this.setProducerState(void 0);
  };
  proto.media.edge.PeerProducerCloseBroadcastResponse.prototype.hasProducerState = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.edge.PeerLeaveBroadcastResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.edge.PeerLeaveBroadcastResponse.toObject(opt_includeInstance, this);
    };
    proto.media.edge.PeerLeaveBroadcastResponse.toObject = function(includeInstance, msg) {
      var obj = {
        participantId: jspb2.Message.getFieldWithDefault(msg, 1, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.edge.PeerLeaveBroadcastResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.edge.PeerLeaveBroadcastResponse();
    return proto.media.edge.PeerLeaveBroadcastResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.edge.PeerLeaveBroadcastResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setParticipantId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.edge.PeerLeaveBroadcastResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.edge.PeerLeaveBroadcastResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.edge.PeerLeaveBroadcastResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getParticipantId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
  };
  proto.media.edge.PeerLeaveBroadcastResponse.prototype.getParticipantId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.edge.PeerLeaveBroadcastResponse.prototype.setParticipantId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.edge.ProducerKind = {
    AUDIO: 0,
    VIDEO: 1
  };
  goog2.object.extend(exports2, proto.media.edge);
})(client_edge_pb);
var edge_hub_pb = {};
(function(exports2) {
  var jspb2 = googleProtobuf$1;
  var goog2 = jspb2;
  var global2 = Function("return this")();
  goog2.exportSymbol("proto.media.hub.BaseMediaHubMessage", null, global2);
  goog2.exportSymbol("proto.media.hub.LatencyTestResponse", null, global2);
  proto.media.hub.BaseMediaHubMessage = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.hub.BaseMediaHubMessage, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.hub.BaseMediaHubMessage.displayName = "proto.media.hub.BaseMediaHubMessage";
  }
  proto.media.hub.LatencyTestResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.hub.LatencyTestResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.hub.LatencyTestResponse.displayName = "proto.media.hub.LatencyTestResponse";
  }
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.hub.BaseMediaHubMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.media.hub.BaseMediaHubMessage.toObject(opt_includeInstance, this);
    };
    proto.media.hub.BaseMediaHubMessage.toObject = function(includeInstance, msg) {
      var obj = {
        event: jspb2.Message.getFieldWithDefault(msg, 1, 0),
        id: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        peerId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
        payload: msg.getPayload_asB64()
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.hub.BaseMediaHubMessage.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.hub.BaseMediaHubMessage();
    return proto.media.hub.BaseMediaHubMessage.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.hub.BaseMediaHubMessage.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readInt32();
          msg.setEvent(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setId(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setPeerId(value);
          break;
        case 4:
          var value = reader.readBytes();
          msg.setPayload(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.hub.BaseMediaHubMessage.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.hub.BaseMediaHubMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.hub.BaseMediaHubMessage.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getEvent();
    if (f !== 0) {
      writer.writeInt32(1, f);
    }
    f = message2.getId();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getPeerId();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
    f = message2.getPayload_asU8();
    if (f.length > 0) {
      writer.writeBytes(4, f);
    }
  };
  proto.media.hub.BaseMediaHubMessage.prototype.getEvent = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, 0);
  };
  proto.media.hub.BaseMediaHubMessage.prototype.setEvent = function(value) {
    return jspb2.Message.setProto3IntField(this, 1, value);
  };
  proto.media.hub.BaseMediaHubMessage.prototype.getId = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.hub.BaseMediaHubMessage.prototype.setId = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.media.hub.BaseMediaHubMessage.prototype.getPeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.media.hub.BaseMediaHubMessage.prototype.setPeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  proto.media.hub.BaseMediaHubMessage.prototype.getPayload = function() {
    return jspb2.Message.getFieldWithDefault(this, 4, "");
  };
  proto.media.hub.BaseMediaHubMessage.prototype.getPayload_asB64 = function() {
    return jspb2.Message.bytesAsB64(this.getPayload());
  };
  proto.media.hub.BaseMediaHubMessage.prototype.getPayload_asU8 = function() {
    return jspb2.Message.bytesAsU8(this.getPayload());
  };
  proto.media.hub.BaseMediaHubMessage.prototype.setPayload = function(value) {
    return jspb2.Message.setProto3BytesField(this, 4, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.hub.LatencyTestResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.hub.LatencyTestResponse.toObject(opt_includeInstance, this);
    };
    proto.media.hub.LatencyTestResponse.toObject = function(includeInstance, msg) {
      var obj = {
        timestamp: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        diff: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        id: jspb2.Message.getFieldWithDefault(msg, 3, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.hub.LatencyTestResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.hub.LatencyTestResponse();
    return proto.media.hub.LatencyTestResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.hub.LatencyTestResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setTimestamp(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setDiff(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.hub.LatencyTestResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.hub.LatencyTestResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.hub.LatencyTestResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getTimestamp();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getDiff();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getId();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
  };
  proto.media.hub.LatencyTestResponse.prototype.getTimestamp = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.hub.LatencyTestResponse.prototype.setTimestamp = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.hub.LatencyTestResponse.prototype.getDiff = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.hub.LatencyTestResponse.prototype.setDiff = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.media.hub.LatencyTestResponse.prototype.getId = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.media.hub.LatencyTestResponse.prototype.setId = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  goog2.object.extend(exports2, proto.media.hub);
})(edge_hub_pb);
var grpcWeb = {};
var n;
function aa(a2) {
  var b = 0;
  return function() {
    return b < a2.length ? { done: false, value: a2[b++] } : { done: true };
  };
}
var ba = typeof Object.defineProperties == "function" ? Object.defineProperty : function(a2, b, c) {
  a2 != Array.prototype && a2 != Object.prototype && (a2[b] = c.value);
};
function ca(a2) {
  a2 = [typeof window == "object" && window, typeof self == "object" && self, typeof commonjsGlobal$1 == "object" && commonjsGlobal$1, a2];
  for (var b = 0; b < a2.length; ++b) {
    var c = a2[b];
    if (c && c.Math == Math)
      return c;
  }
  throw Error("Cannot find global object");
}
var r = ca(commonjsGlobal$1);
function t() {
  t = function() {
  };
  r.Symbol || (r.Symbol = da);
}
function ea(a2, b) {
  this.a = a2;
  ba(this, "description", { configurable: true, writable: true, value: b });
}
ea.prototype.toString = function() {
  return this.a;
};
var da = function() {
  function a2(c) {
    if (this instanceof a2)
      throw new TypeError("Symbol is not a constructor");
    return new ea("jscomp_symbol_" + (c || "") + "_" + b++, c);
  }
  var b = 0;
  return a2;
}();
function u() {
  t();
  var a2 = r.Symbol.iterator;
  a2 || (a2 = r.Symbol.iterator = r.Symbol("Symbol.iterator"));
  typeof Array.prototype[a2] != "function" && ba(Array.prototype, a2, { configurable: true, writable: true, value: function() {
    return fa(aa(this));
  } });
  u = function() {
  };
}
function fa(a2) {
  u();
  a2 = { next: a2 };
  a2[r.Symbol.iterator] = function() {
    return this;
  };
  return a2;
}
function ha(a2) {
  var b = typeof Symbol != "undefined" && Symbol.iterator && a2[Symbol.iterator];
  return b ? b.call(a2) : { next: aa(a2) };
}
var ia = typeof Object.create == "function" ? Object.create : function(a2) {
  function b() {
  }
  b.prototype = a2;
  return new b();
}, ja;
if (typeof Object.setPrototypeOf == "function")
  ja = Object.setPrototypeOf;
else {
  var ka;
  a: {
    var la = { V: true }, ma = {};
    try {
      ma.__proto__ = la;
      ka = ma.V;
      break a;
    } catch (a2) {
    }
    ka = false;
  }
  ja = ka ? function(a2, b) {
    a2.__proto__ = b;
    if (a2.__proto__ !== b)
      throw new TypeError(a2 + " is not extensible");
    return a2;
  } : null;
}
var na = ja;
function oa(a2, b) {
  a2.prototype = ia(b.prototype);
  a2.prototype.constructor = a2;
  if (na)
    na(a2, b);
  else
    for (var c in b)
      if (c != "prototype")
        if (Object.defineProperties) {
          var d = Object.getOwnPropertyDescriptor(b, c);
          d && Object.defineProperty(a2, c, d);
        } else
          a2[c] = b[c];
  a2.O = b.prototype;
}
function pa(a2, b) {
  u();
  a2 instanceof String && (a2 += "");
  var c = 0, d = { next: function() {
    if (c < a2.length) {
      var f = c++;
      return { value: b(f, a2[f]), done: false };
    }
    d.next = function() {
      return { done: true, value: void 0 };
    };
    return d.next();
  } };
  d[Symbol.iterator] = function() {
    return d;
  };
  return d;
}
function v(a2, b) {
  if (b) {
    var c = r;
    a2 = a2.split(".");
    for (var d = 0; d < a2.length - 1; d++) {
      var f = a2[d];
      f in c || (c[f] = {});
      c = c[f];
    }
    a2 = a2[a2.length - 1];
    d = c[a2];
    b = b(d);
    b != d && b != null && ba(c, a2, { configurable: true, writable: true, value: b });
  }
}
v("Array.prototype.keys", function(a2) {
  return a2 ? a2 : function() {
    return pa(this, function(b) {
      return b;
    });
  };
});
v("Array.prototype.find", function(a2) {
  return a2 ? a2 : function(b, c) {
    a: {
      var d = this;
      d instanceof String && (d = String(d));
      for (var f = d.length, g = 0; g < f; g++) {
        var e = d[g];
        if (b.call(c, e, g, d)) {
          b = e;
          break a;
        }
      }
      b = void 0;
    }
    return b;
  };
});
v("Object.is", function(a2) {
  return a2 ? a2 : function(b, c) {
    return b === c ? b !== 0 || 1 / b === 1 / c : b !== b && c !== c;
  };
});
v("Array.prototype.includes", function(a2) {
  return a2 ? a2 : function(b, c) {
    var d = this;
    d instanceof String && (d = String(d));
    var f = d.length;
    c = c || 0;
    for (0 > c && (c = Math.max(c + f, 0)); c < f; c++) {
      var g = d[c];
      if (g === b || Object.is(g, b))
        return true;
    }
    return false;
  };
});
v("Promise", function(a2) {
  function b(e) {
    this.b = 0;
    this.c = void 0;
    this.a = [];
    var h = this.f();
    try {
      e(h.resolve, h.reject);
    } catch (k) {
      h.reject(k);
    }
  }
  function c() {
    this.a = null;
  }
  function d(e) {
    return e instanceof b ? e : new b(function(h) {
      h(e);
    });
  }
  if (a2)
    return a2;
  c.prototype.b = function(e) {
    if (this.a == null) {
      this.a = [];
      var h = this;
      this.c(function() {
        h.g();
      });
    }
    this.a.push(e);
  };
  var f = r.setTimeout;
  c.prototype.c = function(e) {
    f(e, 0);
  };
  c.prototype.g = function() {
    for (; this.a && this.a.length; ) {
      var e = this.a;
      this.a = [];
      for (var h = 0; h < e.length; ++h) {
        var k = e[h];
        e[h] = null;
        try {
          k();
        } catch (l) {
          this.f(l);
        }
      }
    }
    this.a = null;
  };
  c.prototype.f = function(e) {
    this.c(function() {
      throw e;
    });
  };
  b.prototype.f = function() {
    function e(l) {
      return function(m) {
        k || (k = true, l.call(h, m));
      };
    }
    var h = this, k = false;
    return { resolve: e(this.s), reject: e(this.g) };
  };
  b.prototype.s = function(e) {
    if (e === this)
      this.g(new TypeError("A Promise cannot resolve to itself"));
    else if (e instanceof b)
      this.v(e);
    else {
      a:
        switch (typeof e) {
          case "object":
            var h = e != null;
            break a;
          case "function":
            h = true;
            break a;
          default:
            h = false;
        }
      h ? this.m(e) : this.h(e);
    }
  };
  b.prototype.m = function(e) {
    var h = void 0;
    try {
      h = e.then;
    } catch (k) {
      this.g(k);
      return;
    }
    typeof h == "function" ? this.w(h, e) : this.h(e);
  };
  b.prototype.g = function(e) {
    this.i(2, e);
  };
  b.prototype.h = function(e) {
    this.i(1, e);
  };
  b.prototype.i = function(e, h) {
    if (this.b != 0)
      throw Error("Cannot settle(" + e + ", " + h + "): Promise already settled in state" + this.b);
    this.b = e;
    this.c = h;
    this.l();
  };
  b.prototype.l = function() {
    if (this.a != null) {
      for (var e = 0; e < this.a.length; ++e)
        g.b(this.a[e]);
      this.a = null;
    }
  };
  var g = new c();
  b.prototype.v = function(e) {
    var h = this.f();
    e.F(h.resolve, h.reject);
  };
  b.prototype.w = function(e, h) {
    var k = this.f();
    try {
      e.call(h, k.resolve, k.reject);
    } catch (l) {
      k.reject(l);
    }
  };
  b.prototype.then = function(e, h) {
    function k(q, x) {
      return typeof q == "function" ? function(z) {
        try {
          l(q(z));
        } catch (N) {
          m(N);
        }
      } : x;
    }
    var l, m, p = new b(function(q, x) {
      l = q;
      m = x;
    });
    this.F(k(e, l), k(h, m));
    return p;
  };
  b.prototype.catch = function(e) {
    return this.then(void 0, e);
  };
  b.prototype.F = function(e, h) {
    function k() {
      switch (l.b) {
        case 1:
          e(l.c);
          break;
        case 2:
          h(l.c);
          break;
        default:
          throw Error("Unexpected state: " + l.b);
      }
    }
    var l = this;
    this.a == null ? g.b(k) : this.a.push(k);
  };
  b.resolve = d;
  b.reject = function(e) {
    return new b(function(h, k) {
      k(e);
    });
  };
  b.race = function(e) {
    return new b(function(h, k) {
      for (var l = ha(e), m = l.next(); !m.done; m = l.next())
        d(m.value).F(h, k);
    });
  };
  b.all = function(e) {
    var h = ha(e), k = h.next();
    return k.done ? d([]) : new b(function(l, m) {
      function p(z) {
        return function(N) {
          q[z] = N;
          x--;
          x == 0 && l(q);
        };
      }
      var q = [], x = 0;
      do
        q.push(void 0), x++, d(k.value).F(p(q.length - 1), m), k = h.next();
      while (!k.done);
    });
  };
  return b;
});
var qa = qa || {}, w = commonjsGlobal$1 || self;
function y(a2, b) {
  a2 = a2.split(".");
  b = b || w;
  for (var c = 0; c < a2.length; c++)
    if (b = b[a2[c]], b == null)
      return null;
  return b;
}
function ra() {
}
function sa(a2) {
  var b = typeof a2;
  return b == "object" && a2 != null || b == "function";
}
function va(a2, b, c) {
  return a2.call.apply(a2.bind, arguments);
}
function wa(a2, b, c) {
  if (!a2)
    throw Error();
  if (2 < arguments.length) {
    var d = Array.prototype.slice.call(arguments, 2);
    return function() {
      var f = Array.prototype.slice.call(arguments);
      Array.prototype.unshift.apply(f, d);
      return a2.apply(b, f);
    };
  }
  return function() {
    return a2.apply(b, arguments);
  };
}
function A(a2, b, c) {
  Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? A = va : A = wa;
  return A.apply(null, arguments);
}
function B(a2, b) {
  function c() {
  }
  c.prototype = b.prototype;
  a2.O = b.prototype;
  a2.prototype = new c();
  a2.prototype.constructor = a2;
}
function xa(a2) {
  this.a = a2 || {};
}
xa.prototype.get = function(a2) {
  return this.a[a2];
};
xa.prototype.G = function() {
  return Object.keys(this.a);
};
function C(a2, b, c, d) {
  this.f = a2;
  this.c = b;
  this.b = c;
  this.a = d;
}
C.prototype.getRequestMessage = function() {
  return this.f;
};
C.prototype.getMethodDescriptor = function() {
  return this.c;
};
C.prototype.getMetadata = function() {
  return this.b;
};
C.prototype.getCallOptions = function() {
  return this.a;
};
function D(a2, b, c, d) {
  c = c === void 0 ? {} : c;
  this.c = a2;
  this.a = c;
  this.b = b;
  this.f = d === void 0 ? null : d;
}
D.prototype.getResponseMessage = function() {
  return this.c;
};
D.prototype.getMetadata = function() {
  return this.a;
};
D.prototype.getMethodDescriptor = function() {
  return this.b;
};
D.prototype.getStatus = function() {
  return this.f;
};
function E(a2, b, c, d, f, g) {
  this.name = a2;
  this.a = b;
  this.f = c;
  this.b = d;
  this.c = f;
  this.g = g;
}
function ya(a2, b, c) {
  c = c === void 0 ? {} : c;
  var d = d === void 0 ? new xa() : d;
  return new C(b, a2, c, d);
}
n = E.prototype;
n.getName = function() {
  return this.name;
};
n.getMethodType = function() {
  return this.a;
};
n.getResponseMessageCtor = function() {
  return this.b;
};
n.getRequestMessageCtor = function() {
  return this.f;
};
n.getResponseDeserializeFn = function() {
  return this.g;
};
n.getRequestSerializeFn = function() {
  return this.c;
};
E.prototype.getRequestSerializeFn = E.prototype.getRequestSerializeFn;
E.prototype.getResponseDeserializeFn = E.prototype.getResponseDeserializeFn;
E.prototype.getRequestMessageCtor = E.prototype.getRequestMessageCtor;
E.prototype.getResponseMessageCtor = E.prototype.getResponseMessageCtor;
E.prototype.getMethodType = E.prototype.getMethodType;
E.prototype.getName = E.prototype.getName;
function za(a2) {
  switch (a2) {
    case 200:
      return 0;
    case 400:
      return 3;
    case 401:
      return 16;
    case 403:
      return 7;
    case 404:
      return 5;
    case 409:
      return 10;
    case 412:
      return 9;
    case 429:
      return 8;
    case 499:
      return 1;
    case 500:
      return 2;
    case 501:
      return 12;
    case 503:
      return 14;
    case 504:
      return 4;
    default:
      return 2;
  }
}
function F(a2, b, c) {
  c = c === void 0 ? {} : c;
  b = Error.call(this, b);
  this.message = b.message;
  "stack" in b && (this.stack = b.stack);
  this.code = a2;
  this.metadata = c;
}
oa(F, Error);
F.prototype.name = "RpcError";
function Aa(a2) {
  this.a = a2;
}
Aa.prototype.on = function(a2, b) {
  return a2 == "data" || a2 == "error" ? this : this.a.on(a2, b);
};
Aa.prototype.removeListener = function(a2, b) {
  return this.a.removeListener(a2, b);
};
Aa.prototype.cancel = function() {
  this.a.cancel();
};
function Ba(a2) {
  switch (a2) {
    case 0:
      return "No Error";
    case 1:
      return "Access denied to content document";
    case 2:
      return "File not found";
    case 3:
      return "Firefox silently errored";
    case 4:
      return "Application custom error";
    case 5:
      return "An exception occurred";
    case 6:
      return "Http response at 400 or 500 level";
    case 7:
      return "Request was aborted";
    case 8:
      return "Request timed out";
    case 9:
      return "The resource is not available offline";
    default:
      return "Unrecognized error code";
  }
}
function G(a2) {
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, G);
  else {
    var b = Error().stack;
    b && (this.stack = b);
  }
  a2 && (this.message = String(a2));
}
B(G, Error);
G.prototype.name = "CustomError";
function Ca(a2, b) {
  a2 = a2.split("%s");
  for (var c = "", d = a2.length - 1, f = 0; f < d; f++)
    c += a2[f] + (f < b.length ? b[f] : "%s");
  G.call(this, c + a2[d]);
}
B(Ca, G);
Ca.prototype.name = "AssertionError";
function Da(a2, b) {
  throw new Ca("Failure" + (a2 ? ": " + a2 : ""), Array.prototype.slice.call(arguments, 1));
}
function Ea() {
  this.l = null;
  this.i = [];
  this.m = 0;
  this.b = Fa;
  this.f = this.a = this.h = 0;
  this.c = null;
  this.g = 0;
}
function Ga(a2, b) {
  function c(l) {
    l == Ha ? e.h = l : l == H ? e.h = l : Ia(e, h, k, "invalid frame byte");
    e.b = Ja;
    e.a = 0;
    e.f = 0;
  }
  function d(l) {
    e.f++;
    e.a = (e.a << 8) + l;
    e.f == 4 && (e.b = Ka, e.g = 0, typeof Uint8Array !== "undefined" ? e.c = new Uint8Array(e.a) : e.c = Array(e.a), e.a == 0 && g());
  }
  function f(l) {
    e.c[e.g++] = l;
    e.g == e.a && g();
  }
  function g() {
    var l = {};
    l[e.h] = e.c;
    e.i.push(l);
    e.b = Fa;
  }
  var e = a2, h, k = 0;
  for (b instanceof Uint8Array || b instanceof Array ? h = b : h = new Uint8Array(b); k < h.length; ) {
    switch (e.b) {
      case La:
        Ia(e, h, k, "stream already broken");
        break;
      case Fa:
        c(h[k]);
        break;
      case Ja:
        d(h[k]);
        break;
      case Ka:
        f(h[k]);
        break;
      default:
        throw Error("unexpected parser state: " + e.b);
    }
    e.m++;
    k++;
  }
  a2 = e.i;
  e.i = [];
  return 0 < a2.length ? a2 : null;
}
var Fa = 0, Ja = 1, Ka = 2, La = 3, Ha = 0, H = 128;
function Ia(a2, b, c, d) {
  a2.b = La;
  a2.l = "The stream is broken @" + a2.m + "/" + c + ". Error: " + d + ". With input:\n" + b;
  throw Error(a2.l);
}
var Ma = Array.prototype.indexOf ? function(a2, b) {
  return Array.prototype.indexOf.call(a2, b, void 0);
} : function(a2, b) {
  if (typeof a2 === "string")
    return typeof b !== "string" || b.length != 1 ? -1 : a2.indexOf(b, 0);
  for (var c = 0; c < a2.length; c++)
    if (c in a2 && a2[c] === b)
      return c;
  return -1;
};
var Na = String.prototype.trim ? function(a2) {
  return a2.trim();
} : function(a2) {
  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a2)[1];
};
function I(a2, b) {
  return a2.indexOf(b) != -1;
}
function Oa(a2, b) {
  return a2 < b ? -1 : a2 > b ? 1 : 0;
}
var J;
a: {
  var Pa = w.navigator;
  if (Pa) {
    var Qa = Pa.userAgent;
    if (Qa) {
      J = Qa;
      break a;
    }
  }
  J = "";
}
function Ra(a2, b) {
  for (var c in a2)
    b.call(void 0, a2[c], c, a2);
}
function Sa(a2, b) {
  var c = {}, d;
  for (d in a2)
    c[d] = b.call(void 0, a2[d], d, a2);
  return c;
}
var Ta = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function Ua(a2, b) {
  for (var c, d, f = 1; f < arguments.length; f++) {
    d = arguments[f];
    for (c in d)
      a2[c] = d[c];
    for (var g = 0; g < Ta.length; g++)
      c = Ta[g], Object.prototype.hasOwnProperty.call(d, c) && (a2[c] = d[c]);
  }
}
function Va(a2) {
  var b = 1;
  a2 = a2.split(":");
  for (var c = []; 0 < b && a2.length; )
    c.push(a2.shift()), b--;
  a2.length && c.push(a2.join(":"));
  return c;
}
function Wa(a2) {
  Wa[" "](a2);
  return a2;
}
Wa[" "] = ra;
function Xa(a2) {
  var b = Ya;
  return Object.prototype.hasOwnProperty.call(b, 9) ? b[9] : b[9] = a2(9);
}
var Za = I(J, "Opera"), $a = I(J, "Trident") || I(J, "MSIE"), ab = I(J, "Edge"), bb = I(J, "Gecko") && !(I(J.toLowerCase(), "webkit") && !I(J, "Edge")) && !(I(J, "Trident") || I(J, "MSIE")) && !I(J, "Edge"), cb = I(J.toLowerCase(), "webkit") && !I(J, "Edge"), db;
a: {
  var eb = "", fb = function() {
    var a2 = J;
    if (bb)
      return /rv:([^\);]+)(\)|;)/.exec(a2);
    if (ab)
      return /Edge\/([\d\.]+)/.exec(a2);
    if ($a)
      return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a2);
    if (cb)
      return /WebKit\/(\S+)/.exec(a2);
    if (Za)
      return /(?:Version)[ \/]?(\S+)/.exec(a2);
  }();
  fb && (eb = fb ? fb[1] : "");
  if ($a) {
    var gb, hb = w.document;
    gb = hb ? hb.documentMode : void 0;
    if (gb != null && gb > parseFloat(eb)) {
      db = String(gb);
      break a;
    }
  }
  db = eb;
}
var Ya = {};
function ib() {
  return Xa(function() {
    for (var a2 = 0, b = Na(String(db)).split("."), c = Na("9").split("."), d = Math.max(b.length, c.length), f = 0; a2 == 0 && f < d; f++) {
      var g = b[f] || "", e = c[f] || "";
      do {
        g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];
        e = /(\d*)(\D*)(.*)/.exec(e) || ["", "", "", ""];
        if (g[0].length == 0 && e[0].length == 0)
          break;
        a2 = Oa(g[1].length == 0 ? 0 : parseInt(g[1], 10), e[1].length == 0 ? 0 : parseInt(e[1], 10)) || Oa(g[2].length == 0, e[2].length == 0) || Oa(g[2], e[2]);
        g = g[3];
        e = e[3];
      } while (a2 == 0);
    }
    return 0 <= a2;
  });
}
function jb() {
  this.K = this.K;
}
jb.prototype.K = false;
var lb = Object.freeze || function(a2) {
  return a2;
};
function K(a2, b) {
  this.type = a2;
  this.a = this.target = b;
  this.defaultPrevented = false;
}
K.prototype.b = function() {
  this.defaultPrevented = true;
};
var mb = function() {
  if (!w.addEventListener || !Object.defineProperty)
    return false;
  var a2 = false, b = Object.defineProperty({}, "passive", { get: function() {
    a2 = true;
  } });
  try {
    w.addEventListener("test", ra, b), w.removeEventListener("test", ra, b);
  } catch (c) {
  }
  return a2;
}();
function L(a2, b) {
  K.call(this, a2 ? a2.type : "");
  this.relatedTarget = this.a = this.target = null;
  this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
  this.key = "";
  this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = false;
  this.pointerId = 0;
  this.pointerType = "";
  this.c = null;
  if (a2) {
    var c = this.type = a2.type, d = a2.changedTouches && a2.changedTouches.length ? a2.changedTouches[0] : null;
    this.target = a2.target || a2.srcElement;
    this.a = b;
    if (b = a2.relatedTarget) {
      if (bb) {
        a: {
          try {
            Wa(b.nodeName);
            var f = true;
            break a;
          } catch (g) {
          }
          f = false;
        }
        f || (b = null);
      }
    } else
      c == "mouseover" ? b = a2.fromElement : c == "mouseout" && (b = a2.toElement);
    this.relatedTarget = b;
    d ? (this.clientX = d.clientX !== void 0 ? d.clientX : d.pageX, this.clientY = d.clientY !== void 0 ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = a2.clientX !== void 0 ? a2.clientX : a2.pageX, this.clientY = a2.clientY !== void 0 ? a2.clientY : a2.pageY, this.screenX = a2.screenX || 0, this.screenY = a2.screenY || 0);
    this.button = a2.button;
    this.key = a2.key || "";
    this.ctrlKey = a2.ctrlKey;
    this.altKey = a2.altKey;
    this.shiftKey = a2.shiftKey;
    this.metaKey = a2.metaKey;
    this.pointerId = a2.pointerId || 0;
    this.pointerType = typeof a2.pointerType === "string" ? a2.pointerType : nb[a2.pointerType] || "";
    this.c = a2;
    a2.defaultPrevented && L.O.b.call(this);
  }
}
B(L, K);
var nb = lb({ 2: "touch", 3: "pen", 4: "mouse" });
L.prototype.b = function() {
  L.O.b.call(this);
  var a2 = this.c;
  a2.preventDefault ? a2.preventDefault() : a2.returnValue = false;
};
var ob = "closure_listenable_" + (1e6 * Math.random() | 0);
var pb = 0;
function qb(a2, b, c, d, f) {
  this.listener = a2;
  this.proxy = null;
  this.src = b;
  this.type = c;
  this.capture = !!d;
  this.H = f;
  this.key = ++pb;
  this.A = this.D = false;
}
function rb(a2) {
  a2.A = true;
  a2.listener = null;
  a2.proxy = null;
  a2.src = null;
  a2.H = null;
}
function sb(a2) {
  this.src = a2;
  this.a = {};
  this.b = 0;
}
sb.prototype.add = function(a2, b, c, d, f) {
  var g = a2.toString();
  a2 = this.a[g];
  a2 || (a2 = this.a[g] = [], this.b++);
  var e = tb(a2, b, d, f);
  -1 < e ? (b = a2[e], c || (b.D = false)) : (b = new qb(b, this.src, g, !!d, f), b.D = c, a2.push(b));
  return b;
};
sb.prototype.remove = function(a2, b, c, d) {
  a2 = a2.toString();
  if (!(a2 in this.a))
    return false;
  var f = this.a[a2];
  b = tb(f, b, c, d);
  return -1 < b ? (rb(f[b]), Array.prototype.splice.call(f, b, 1), f.length == 0 && (delete this.a[a2], this.b--), true) : false;
};
function ub(a2, b) {
  var c = b.type;
  if (c in a2.a) {
    var d = a2.a[c], f = Ma(d, b), g;
    (g = 0 <= f) && Array.prototype.splice.call(d, f, 1);
    g && (rb(b), a2.a[c].length == 0 && (delete a2.a[c], a2.b--));
  }
}
function tb(a2, b, c, d) {
  for (var f = 0; f < a2.length; ++f) {
    var g = a2[f];
    if (!g.A && g.listener == b && g.capture == !!c && g.H == d)
      return f;
  }
  return -1;
}
var vb = "closure_lm_" + (1e6 * Math.random() | 0), wb = {};
function yb(a2, b, c, d, f) {
  if (d && d.once)
    zb(a2, b, c, d, f);
  else if (Array.isArray(b))
    for (var g = 0; g < b.length; g++)
      yb(a2, b[g], c, d, f);
  else
    c = Ab(c), a2 && a2[ob] ? a2.f.add(String(b), c, false, sa(d) ? !!d.capture : !!d, f) : Bb(a2, b, c, false, d, f);
}
function Bb(a2, b, c, d, f, g) {
  if (!b)
    throw Error("Invalid event type");
  var e = sa(f) ? !!f.capture : !!f, h = Cb(a2);
  h || (a2[vb] = h = new sb(a2));
  c = h.add(b, c, d, e, g);
  if (!c.proxy) {
    d = Db();
    c.proxy = d;
    d.src = a2;
    d.listener = c;
    if (a2.addEventListener)
      mb || (f = e), f === void 0 && (f = false), a2.addEventListener(b.toString(), d, f);
    else if (a2.attachEvent)
      a2.attachEvent(Eb(b.toString()), d);
    else if (a2.addListener && a2.removeListener)
      a2.addListener(d);
    else
      throw Error("addEventListener and attachEvent are unavailable.");
  }
}
function Db() {
  function a2(c) {
    return b.call(a2.src, a2.listener, c);
  }
  var b = Fb;
  return a2;
}
function zb(a2, b, c, d, f) {
  if (Array.isArray(b))
    for (var g = 0; g < b.length; g++)
      zb(a2, b[g], c, d, f);
  else
    c = Ab(c), a2 && a2[ob] ? a2.f.add(String(b), c, true, sa(d) ? !!d.capture : !!d, f) : Bb(a2, b, c, true, d, f);
}
function Gb(a2, b, c, d, f) {
  if (Array.isArray(b))
    for (var g = 0; g < b.length; g++)
      Gb(a2, b[g], c, d, f);
  else
    (d = sa(d) ? !!d.capture : !!d, c = Ab(c), a2 && a2[ob]) ? a2.f.remove(String(b), c, d, f) : a2 && (a2 = Cb(a2)) && (b = a2.a[b.toString()], a2 = -1, b && (a2 = tb(b, c, d, f)), (c = -1 < a2 ? b[a2] : null) && Hb(c));
}
function Hb(a2) {
  if (typeof a2 !== "number" && a2 && !a2.A) {
    var b = a2.src;
    if (b && b[ob])
      ub(b.f, a2);
    else {
      var c = a2.type, d = a2.proxy;
      b.removeEventListener ? b.removeEventListener(c, d, a2.capture) : b.detachEvent ? b.detachEvent(Eb(c), d) : b.addListener && b.removeListener && b.removeListener(d);
      (c = Cb(b)) ? (ub(c, a2), c.b == 0 && (c.src = null, b[vb] = null)) : rb(a2);
    }
  }
}
function Eb(a2) {
  return a2 in wb ? wb[a2] : wb[a2] = "on" + a2;
}
function Fb(a2, b) {
  if (a2.A)
    a2 = true;
  else {
    b = new L(b, this);
    var c = a2.listener, d = a2.H || a2.src;
    a2.D && Hb(a2);
    a2 = c.call(d, b);
  }
  return a2;
}
function Cb(a2) {
  a2 = a2[vb];
  return a2 instanceof sb ? a2 : null;
}
var Ib = "__closure_events_fn_" + (1e9 * Math.random() >>> 0);
function Ab(a2) {
  if (typeof a2 === "function")
    return a2;
  a2[Ib] || (a2[Ib] = function(b) {
    return a2.handleEvent(b);
  });
  return a2[Ib];
}
function M() {
  jb.call(this);
  this.f = new sb(this);
  this.U = this;
}
B(M, jb);
M.prototype[ob] = true;
M.prototype.addEventListener = function(a2, b, c, d) {
  yb(this, a2, b, c, d);
};
M.prototype.removeEventListener = function(a2, b, c, d) {
  Gb(this, a2, b, c, d);
};
function O(a2, b) {
  a2 = a2.U;
  var c = b.type || b;
  if (typeof b === "string")
    b = new K(b, a2);
  else if (b instanceof K)
    b.target = b.target || a2;
  else {
    var d = b;
    b = new K(c, a2);
    Ua(b, d);
  }
  a2 = b.a = a2;
  Jb(a2, c, true, b);
  Jb(a2, c, false, b);
}
function Jb(a2, b, c, d) {
  if (b = a2.f.a[String(b)]) {
    b = b.concat();
    for (var f = true, g = 0; g < b.length; ++g) {
      var e = b[g];
      if (e && !e.A && e.capture == c) {
        var h = e.listener, k = e.H || e.src;
        e.D && ub(a2.f, e);
        f = h.call(k, d) !== false && f;
      }
    }
  }
}
var Kb = w;
function Lb(a2, b, c) {
  if (typeof a2 === "function")
    c && (a2 = A(a2, c));
  else if (a2 && typeof a2.handleEvent == "function")
    a2 = A(a2.handleEvent, a2);
  else
    throw Error("Invalid listener argument");
  return 2147483647 < Number(b) ? -1 : Kb.setTimeout(a2, b || 0);
}
function Mb(a2, b) {
  this.name = a2;
  this.value = b;
}
Mb.prototype.toString = function() {
  return this.name;
};
var Nb = new Mb("OFF", Infinity), Ob = new Mb("SEVERE", 1e3), Pb = new Mb("CONFIG", 700), Qb = new Mb("FINE", 500);
function Rb() {
  this.clear();
}
var Sb;
Rb.prototype.clear = function() {
};
function Ub(a2, b, c) {
  this.reset(a2 || Nb, b, c, void 0, void 0);
}
Ub.prototype.reset = function() {
};
function Vb(a2, b) {
  this.a = null;
  this.f = [];
  this.b = (b === void 0 ? null : b) || null;
  this.c = [];
  this.g = { getName: function() {
    return a2;
  } };
}
function Wb(a2) {
  if (a2.a)
    return a2.a;
  if (a2.b)
    return Wb(a2.b);
  Da("Root logger has no level set.");
  return Nb;
}
function Xb(a2, b) {
  for (; a2; )
    a2.f.forEach(function(c) {
      c(b);
    }), a2 = a2.b;
}
function Yb() {
  this.entries = {};
  var a2 = new Vb("");
  a2.a = Pb;
  this.entries[""] = a2;
}
var Zb;
function $b(a2, b, c) {
  var d = a2.entries[b];
  if (d)
    return c !== void 0 && (d.a = c), d;
  d = $b(a2, b.substr(0, b.lastIndexOf(".")));
  var f = new Vb(b, d);
  a2.entries[b] = f;
  d.c.push(f);
  c !== void 0 && (f.a = c);
  return f;
}
function ac() {
  Zb || (Zb = new Yb());
  return Zb;
}
function bc(a2, b, c) {
  var d;
  if (d = a2) {
    if (d = a2 && b) {
      d = b.value;
      var f = a2 ? Wb($b(ac(), a2.getName())) : Nb;
      d = d >= f.value;
    }
  }
  d && (b = b || Nb, d = $b(ac(), a2.getName()), typeof c === "function" && (c = c()), Sb || (Sb = new Rb()), a2 = a2.getName(), a2 = new Ub(b, c, a2), Xb(d, a2));
}
function P(a2, b) {
  a2 && bc(a2, Qb, b);
}
function cc() {
}
cc.prototype.a = null;
function dc(a2) {
  var b;
  (b = a2.a) || (b = {}, ec(a2) && (b[0] = true, b[1] = true), b = a2.a = b);
  return b;
}
var fc;
function gc() {
}
B(gc, cc);
function hc(a2) {
  return (a2 = ec(a2)) ? new ActiveXObject(a2) : new XMLHttpRequest();
}
function ec(a2) {
  if (!a2.b && typeof XMLHttpRequest == "undefined" && typeof ActiveXObject != "undefined") {
    for (var b = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], c = 0; c < b.length; c++) {
      var d = b[c];
      try {
        return new ActiveXObject(d), a2.b = d;
      } catch (f) {
      }
    }
    throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
  }
  return a2.b;
}
fc = new gc();
t();
u();
function ic(a2, b) {
  this.b = a2[w.Symbol.iterator]();
  this.c = b;
  this.f = 0;
}
ic.prototype[Symbol.iterator] = function() {
  return this;
};
ic.prototype.next = function() {
  var a2 = this.b.next();
  return { value: a2.done ? void 0 : this.c.call(void 0, a2.value, this.f++), done: a2.done };
};
function jc(a2, b) {
  return new ic(a2, b);
}
t();
u();
t();
u();
var kc = "StopIteration" in w ? w.StopIteration : { message: "StopIteration", stack: "" };
function Q() {
}
Q.prototype.next = function() {
  return Q.prototype.a.call(this);
};
Q.prototype.a = function() {
  throw kc;
};
Q.prototype.u = function() {
  return this;
};
function lc(a2) {
  if (a2 instanceof R$1 || a2 instanceof S || a2 instanceof T)
    return a2;
  if (typeof a2.next == "function")
    return new R$1(function() {
      return mc(a2);
    });
  t();
  u();
  if (typeof a2[Symbol.iterator] == "function")
    return t(), u(), new R$1(function() {
      return a2[Symbol.iterator]();
    });
  if (typeof a2.u == "function")
    return new R$1(function() {
      return mc(a2.u());
    });
  throw Error("Not an iterator or iterable.");
}
function mc(a2) {
  if (!(a2 instanceof Q))
    return a2;
  var b = false;
  return { next: function() {
    for (var c; !b; )
      try {
        c = a2.a();
        break;
      } catch (d) {
        if (d !== kc)
          throw d;
        b = true;
      }
    return { value: c, done: b };
  } };
}
t();
u();
function R$1(a2) {
  this.b = a2;
}
R$1.prototype.u = function() {
  return new S(this.b());
};
R$1.prototype[Symbol.iterator] = function() {
  return new T(this.b());
};
R$1.prototype.c = function() {
  return new T(this.b());
};
t();
u();
function S(a2) {
  this.b = a2;
}
oa(S, Q);
S.prototype.a = function() {
  var a2 = this.b.next();
  if (a2.done)
    throw kc;
  return a2.value;
};
S.prototype.next = function() {
  return S.prototype.a.call(this);
};
S.prototype[Symbol.iterator] = function() {
  return new T(this.b);
};
S.prototype.c = function() {
  return new T(this.b);
};
function T(a2) {
  R$1.call(this, function() {
    return a2;
  });
  this.f = a2;
}
oa(T, R$1);
T.prototype.next = function() {
  return this.f.next();
};
function nc(a2, b) {
  this.o = {};
  this.j = [];
  this.B = this.size = 0;
  var c = arguments.length;
  if (1 < c) {
    if (c % 2)
      throw Error("Uneven number of arguments");
    for (var d = 0; d < c; d += 2)
      this.set(arguments[d], arguments[d + 1]);
  } else
    a2 && this.addAll(a2);
}
n = nc.prototype;
n.G = function() {
  oc(this);
  return this.j.concat();
};
n.has = function(a2) {
  return U(this.o, a2);
};
n.clear = function() {
  this.o = {};
  this.B = this.size = this.j.length = 0;
};
n.remove = function(a2) {
  return this.delete(a2);
};
n.delete = function(a2) {
  return U(this.o, a2) ? (delete this.o[a2], --this.size, this.B++, this.j.length > 2 * this.size && oc(this), true) : false;
};
function oc(a2) {
  if (a2.size != a2.j.length) {
    for (var b = 0, c = 0; b < a2.j.length; ) {
      var d = a2.j[b];
      U(a2.o, d) && (a2.j[c++] = d);
      b++;
    }
    a2.j.length = c;
  }
  if (a2.size != a2.j.length) {
    var f = {};
    for (c = b = 0; b < a2.j.length; )
      d = a2.j[b], U(f, d) || (a2.j[c++] = d, f[d] = 1), b++;
    a2.j.length = c;
  }
}
n.get = function(a2, b) {
  return U(this.o, a2) ? this.o[a2] : b;
};
n.set = function(a2, b) {
  U(this.o, a2) || (this.size += 1, this.j.push(a2), this.B++);
  this.o[a2] = b;
};
n.addAll = function(a2) {
  if (a2 instanceof nc)
    for (var b = a2.G(), c = 0; c < b.length; c++)
      this.set(b[c], a2.get(b[c]));
  else
    for (b in a2)
      this.set(b, a2[b]);
};
n.forEach = function(a2, b) {
  for (var c = this.G(), d = 0; d < c.length; d++) {
    var f = c[d], g = this.get(f);
    a2.call(b, g, f, this);
  }
};
n.clone = function() {
  return new nc(this);
};
n.keys = function() {
  return lc(this.u(true)).c();
};
n.values = function() {
  return lc(this.u(false)).c();
};
n.entries = function() {
  var a2 = this;
  return jc(this.keys(), function(b) {
    return [b, a2.get(b)];
  });
};
n.u = function(a2) {
  oc(this);
  var b = 0, c = this.B, d = this, f = new Q();
  f.a = function() {
    if (c != d.B)
      throw Error("The map has changed since the iterator was created");
    if (b >= d.j.length)
      throw kc;
    var g = d.j[b++];
    return a2 ? g : d.o[g];
  };
  f.next = f.a.bind(f);
  return f;
};
function U(a2, b) {
  return Object.prototype.hasOwnProperty.call(a2, b);
}
var pc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function qc(a2) {
  M.call(this);
  this.headers = new nc();
  this.C = a2 || null;
  this.c = false;
  this.J = this.a = null;
  this.P = this.v = "";
  this.g = 0;
  this.l = "";
  this.i = this.N = this.s = this.L = false;
  this.h = 0;
  this.w = null;
  this.m = rc;
  this.I = this.M = false;
}
B(qc, M);
var rc = "";
qc.prototype.b = $b(ac(), "goog.net.XhrIo", void 0).g;
var sc = /^https?$/i, tc = ["POST", "PUT"];
function uc(a2, b, c) {
  if (a2.a)
    throw Error("[goog.net.XhrIo] Object is active with another request=" + a2.v + "; newUri=" + b);
  a2.v = b;
  a2.l = "";
  a2.g = 0;
  a2.P = "POST";
  a2.L = false;
  a2.c = true;
  a2.a = a2.C ? hc(a2.C) : hc(fc);
  a2.J = a2.C ? dc(a2.C) : dc(fc);
  a2.a.onreadystatechange = A(a2.R, a2);
  try {
    P(a2.b, V(a2, "Opening Xhr")), a2.N = true, a2.a.open("POST", String(b), true), a2.N = false;
  } catch (g) {
    P(a2.b, V(a2, "Error opening Xhr: " + g.message));
    vc(a2, g);
    return;
  }
  b = c || "";
  c = a2.headers.clone();
  var d = c.G().find(function(g) {
    return g.toLowerCase() == "content-type";
  }), f = w.FormData && b instanceof w.FormData;
  !(0 <= Ma(tc, "POST")) || d || f || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
  c.forEach(function(g, e) {
    this.a.setRequestHeader(e, g);
  }, a2);
  a2.m && (a2.a.responseType = a2.m);
  "withCredentials" in a2.a && a2.a.withCredentials !== a2.M && (a2.a.withCredentials = a2.M);
  try {
    wc(a2), 0 < a2.h && (a2.I = xc(a2.a), P(a2.b, V(a2, "Will abort after " + a2.h + "ms if incomplete, xhr2 " + a2.I)), a2.I ? (a2.a.timeout = a2.h, a2.a.ontimeout = A(a2.T, a2)) : a2.w = Lb(a2.T, a2.h, a2)), P(a2.b, V(a2, "Sending request")), a2.s = true, a2.a.send(b), a2.s = false;
  } catch (g) {
    P(a2.b, V(a2, "Send error: " + g.message)), vc(a2, g);
  }
}
function xc(a2) {
  return $a && ib() && typeof a2.timeout === "number" && a2.ontimeout !== void 0;
}
n = qc.prototype;
n.T = function() {
  typeof qa != "undefined" && this.a && (this.l = "Timed out after " + this.h + "ms, aborting", this.g = 8, P(this.b, V(this, this.l)), O(this, "timeout"), this.abort(8));
};
function vc(a2, b) {
  a2.c = false;
  a2.a && (a2.i = true, a2.a.abort(), a2.i = false);
  a2.l = b;
  a2.g = 5;
  yc(a2);
  zc(a2);
}
function yc(a2) {
  a2.L || (a2.L = true, O(a2, "complete"), O(a2, "error"));
}
n.abort = function(a2) {
  this.a && this.c && (P(this.b, V(this, "Aborting")), this.c = false, this.i = true, this.a.abort(), this.i = false, this.g = a2 || 7, O(this, "complete"), O(this, "abort"), zc(this));
};
n.R = function() {
  this.K || (this.N || this.s || this.i ? Ac(this) : this.W());
};
n.W = function() {
  Ac(this);
};
function Ac(a2) {
  if (a2.c && typeof qa != "undefined") {
    if (a2.J[1] && W(a2) == 4 && a2.getStatus() == 2)
      P(a2.b, V(a2, "Local request error detected and ignored"));
    else if (a2.s && W(a2) == 4)
      Lb(a2.R, 0, a2);
    else if (O(a2, "readystatechange"), W(a2) == 4) {
      P(a2.b, V(a2, "Request complete"));
      a2.c = false;
      try {
        var b = a2.getStatus();
        a:
          switch (b) {
            case 200:
            case 201:
            case 202:
            case 204:
            case 206:
            case 304:
            case 1223:
              var c = true;
              break a;
            default:
              c = false;
          }
        var d;
        if (!(d = c)) {
          var f;
          if (f = b === 0) {
            var g = String(a2.v).match(pc)[1] || null;
            if (!g && w.self && w.self.location) {
              var e = w.self.location.protocol;
              g = e.substr(0, e.length - 1);
            }
            f = !sc.test(g ? g.toLowerCase() : "");
          }
          d = f;
        }
        if (d)
          O(a2, "complete"), O(a2, "success");
        else {
          a2.g = 6;
          try {
            var h = 2 < W(a2) ? a2.a.statusText : "";
          } catch (k) {
            P(a2.b, "Can not get status: " + k.message), h = "";
          }
          a2.l = h + " [" + a2.getStatus() + "]";
          yc(a2);
        }
      } finally {
        zc(a2);
      }
    }
  }
}
function zc(a2) {
  if (a2.a) {
    wc(a2);
    var b = a2.a, c = a2.J[0] ? ra : null;
    a2.a = null;
    a2.J = null;
    O(a2, "ready");
    try {
      b.onreadystatechange = c;
    } catch (d) {
      (a2 = a2.b) && bc(a2, Ob, "Problem encountered resetting onreadystatechange: " + d.message);
    }
  }
}
function wc(a2) {
  a2.a && a2.I && (a2.a.ontimeout = null);
  a2.w && (Kb.clearTimeout(a2.w), a2.w = null);
}
function W(a2) {
  return a2.a ? a2.a.readyState : 0;
}
n.getStatus = function() {
  try {
    return 2 < W(this) ? this.a.status : -1;
  } catch (a2) {
    return -1;
  }
};
function Bc(a2) {
  try {
    if (!a2.a)
      return null;
    if ("response" in a2.a)
      return a2.a.response;
    switch (a2.m) {
      case rc:
      case "text":
        return a2.a.responseText;
      case "arraybuffer":
        if ("mozResponseArrayBuffer" in a2.a)
          return a2.a.mozResponseArrayBuffer;
    }
    var b = a2.b;
    b && bc(b, Ob, "Response type " + a2.m + " is not supported on this browser");
    return null;
  } catch (c) {
    return P(a2.b, "Can not get response: " + c.message), null;
  }
}
function Cc(a2, b) {
  if (a2.a && W(a2) == 4)
    return a2 = a2.a.getResponseHeader(b), a2 === null ? void 0 : a2;
}
function Dc(a2) {
  var b = {};
  a2 = (a2.a && W(a2) == 4 ? a2.a.getAllResponseHeaders() || "" : "").split("\r\n");
  for (var c = 0; c < a2.length; c++)
    if (!/^[\s\xa0]*$/.test(a2[c])) {
      var d = Va(a2[c]), f = d[0];
      d = d[1];
      if (typeof d === "string") {
        d = d.trim();
        var g = b[f] || [];
        b[f] = g;
        g.push(d);
      }
    }
  return Sa(b, function(e) {
    return e.join(", ");
  });
}
function V(a2, b) {
  return b + " [" + a2.P + " " + a2.v + " " + a2.getStatus() + "]";
}
var Ec = {}, Fc = null;
function Gc(a2) {
  var b = a2.length, c = 3 * b / 4;
  c % 3 ? c = Math.floor(c) : I("=.", a2[b - 1]) && (c = I("=.", a2[b - 2]) ? c - 2 : c - 1);
  var d = new Uint8Array(c), f = 0;
  Hc(a2, function(g) {
    d[f++] = g;
  });
  return d.subarray(0, f);
}
function Hc(a2, b) {
  function c(k) {
    for (; d < a2.length; ) {
      var l = a2.charAt(d++), m = Fc[l];
      if (m != null)
        return m;
      if (!/^[\s\xa0]*$/.test(l))
        throw Error("Unknown base64 encoding at char: " + l);
    }
    return k;
  }
  Ic();
  for (var d = 0; ; ) {
    var f = c(-1), g = c(0), e = c(64), h = c(64);
    if (h === 64 && f === -1)
      break;
    b(f << 2 | g >> 4);
    e != 64 && (b(g << 4 & 240 | e >> 2), h != 64 && b(e << 6 & 192 | h));
  }
}
function Ic() {
  if (!Fc) {
    Fc = {};
    for (var a2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
      var d = a2.concat(b[c].split(""));
      Ec[c] = d;
      for (var f = 0; f < d.length; f++) {
        var g = d[f];
        Fc[g] === void 0 && (Fc[g] = f);
      }
    }
  }
}
var Jc = ["content-type", "grpc-status", "grpc-message"];
function X(a2) {
  this.a = a2.Z;
  this.m = null;
  this.b = [];
  this.h = [];
  this.g = [];
  this.f = [];
  this.c = [];
  this.l = false;
  this.i = 0;
  this.s = new Ea();
  var b = this;
  yb(this.a, "readystatechange", function() {
    var c = b.a;
    if (c = c.a ? c.a.getResponseHeader("Content-Type") : null) {
      c = c.toLowerCase();
      if (c.lastIndexOf("application/grpc-web-text", 0) == 0) {
        c = b.a;
        try {
          var d = c.a ? c.a.responseText : "";
        } catch (k) {
          P(c.b, "Can not get responseText: " + k.message), d = "";
        }
        c = d || "";
        d = c.length - c.length % 4;
        c = c.substr(b.i, d - b.i);
        if (c.length == 0)
          return;
        b.i = d;
        c = Gc(c);
      } else if (c.lastIndexOf("application/grpc", 0) == 0)
        c = new Uint8Array(Bc(b.a));
      else {
        Y(b, new F(2, "Unknown Content-type received."));
        return;
      }
      d = null;
      try {
        d = Ga(b.s, c);
      } catch (k) {
        Y(b, new F(2, "Error in parsing response body"));
      }
      if (d)
        for (c = 0; c < d.length; c++) {
          if (Ha in d[c]) {
            var f = d[c][Ha];
            if (f) {
              var g = void 0;
              try {
                g = b.m(f);
              } catch (k) {
                Y(b, new F(13, "Error when deserializing response data; error: " + k + (", response: " + g)));
              }
              if (g) {
                f = b;
                for (var e = 0; e < f.b.length; e++)
                  f.b[e](g);
              }
            }
          }
          if (H in d[c] && 0 < d[c][H].length) {
            f = "";
            for (g = 0; g < d[c][H].length; g++)
              f += String.fromCharCode(d[c][H][g]);
            f = f.trim().split("\r\n");
            g = {};
            for (e = 0; e < f.length; e++) {
              var h = f[e].indexOf(":");
              g[f[e].substring(0, h).trim()] = f[e].substring(h + 1).trim();
            }
            f = g;
            g = 0;
            e = "";
            "grpc-status" in f && (g = Number(f["grpc-status"]), delete f["grpc-status"]);
            "grpc-message" in f && (e = f["grpc-message"], delete f["grpc-message"]);
            Y(b, new F(g, e, f));
          }
        }
    }
  });
  yb(this.a, "complete", function() {
    var c = b.a.g, d = 2, f = "", g = {}, e = Dc(b.a);
    Object.keys(e).forEach(function(h) {
      Jc.includes(h) || (g[h] = e[h]);
    });
    Kc(b, g);
    if (c != 0) {
      switch (c) {
        case 7:
          d = 10;
          break;
        case 8:
          d = 4;
          break;
        case 6:
          d = za(b.a.getStatus());
          break;
        default:
          d = 14;
      }
      d == 10 && b.l || Y(b, new F(d, Ba(c)));
    } else
      c = false, "grpc-status" in e && (d = Number(Cc(b.a, "grpc-status")), "grpc-message" in e && (f = Cc(b.a, "grpc-message")), d != 0 && (Y(b, new F(d, f || "", e)), c = true)), c || Lc(b);
  });
}
X.prototype.on = function(a2, b) {
  a2 == "data" ? this.b.push(b) : a2 == "status" ? this.h.push(b) : a2 == "metadata" ? this.g.push(b) : a2 == "end" ? this.c.push(b) : a2 == "error" && this.f.push(b);
  return this;
};
function Mc(a2, b) {
  b = a2.indexOf(b);
  -1 < b && a2.splice(b, 1);
}
X.prototype.removeListener = function(a2, b) {
  a2 == "data" ? Mc(this.b, b) : a2 == "status" ? Mc(this.h, b) : a2 == "metadata" ? Mc(this.g, b) : a2 == "end" ? Mc(this.c, b) : a2 == "error" && Mc(this.f, b);
  return this;
};
X.prototype.cancel = function() {
  this.l = true;
  this.a.abort();
};
function Y(a2, b) {
  if (b.code != 0)
    for (var c = new F(b.code, decodeURIComponent(b.message || ""), b.metadata), d = 0; d < a2.f.length; d++)
      a2.f[d](c);
  b = { code: b.code, details: decodeURIComponent(b.message || ""), metadata: b.metadata };
  for (c = 0; c < a2.h.length; c++)
    a2.h[c](b);
}
function Kc(a2, b) {
  for (var c = 0; c < a2.g.length; c++)
    a2.g[c](b);
}
function Lc(a2) {
  for (var b = 0; b < a2.c.length; b++)
    a2.c[b]();
}
X.prototype.cancel = X.prototype.cancel;
X.prototype.removeListener = X.prototype.removeListener;
X.prototype.on = X.prototype.on;
function Nc(a2) {
  var b = "";
  Ra(a2, function(c, d) {
    b += d;
    b += ":";
    b += c;
    b += "\r\n";
  });
  return b;
}
function Z(a2, b) {
  a2 = a2 === void 0 ? {} : a2;
  this.a = a2.format || y("format", a2) || "text";
  this.g = a2.aa || y("suppressCorsPreflight", a2) || false;
  this.f = a2.withCredentials || y("withCredentials", a2) || false;
  this.b = a2.$ || y("streamInterceptors", a2) || [];
  this.h = a2.ba || y("unaryInterceptors", a2) || [];
  this.c = b || null;
}
Z.prototype.X = function(a2, b, c, d, f) {
  var g = this, e = a2.substr(0, a2.length - d.name.length);
  a2 = Oc(function(h) {
    return Pc(g, h, e);
  }, this.b).call(this, ya(d, b, c));
  Qc(a2, f, false);
  return new Aa(a2);
};
Z.prototype.S = function(a2, b, c, d) {
  var f = this, g = a2.substr(0, a2.length - d.name.length);
  return Oc(function(e) {
    return new Promise(function(h, k) {
      var l = Pc(f, e, g), m, p, q;
      Qc(l, function(x, z, N, Tb) {
        x ? k(x) : z ? q = z : N ? p = N : Tb ? m = Tb : (x = e.getMethodDescriptor(), z = m, z = z === void 0 ? {} : z, h(new D(q, x, z, p === void 0 ? null : p)));
      }, true);
    });
  }, this.h).call(this, ya(d, b, c)).then(function(e) {
    return e.getResponseMessage();
  });
};
Z.prototype.unaryCall = function(a2, b, c, d) {
  return this.S(a2, b, c, d);
};
Z.prototype.Y = function(a2, b, c, d) {
  var f = this, g = a2.substr(0, a2.length - d.name.length);
  return Oc(function(e) {
    return Pc(f, e, g);
  }, this.b).call(this, ya(d, b, c));
};
function Pc(a2, b, c) {
  var d = b.getMethodDescriptor(), f = c + d.getName();
  c = a2.c ? a2.c : new qc();
  c.M = a2.f;
  var g = new X({ Z: c }), e = d.getResponseDeserializeFn();
  g.m = e;
  e = b.getMetadata();
  for (var h in e)
    c.headers.set(h, e[h]);
  a2.a == "text" ? (c.headers.set("Content-Type", "application/grpc-web-text"), c.headers.set("Accept", "application/grpc-web-text")) : c.headers.set("Content-Type", "application/grpc-web+proto");
  c.headers.set("X-User-Agent", "grpc-web-javascript/0.1");
  c.headers.set("X-Grpc-Web", "1");
  c.headers.has("deadline") && (h = Number(c.headers.get("deadline")), h = Math.ceil(h - new Date().getTime()), c.headers.delete("deadline"), h === Infinity && (h = 0), 0 < h && (c.headers.set("grpc-timeout", h + "m"), c.h = Math.max(0, Math.max(1e3, Math.ceil(1.1 * h)))));
  if (a2.g) {
    e = c.headers;
    h = {};
    for (var k = ha(e.keys()), l = k.next(); !l.done; l = k.next())
      l = l.value, h[l] = e.get(l);
    c.headers.clear();
    b: {
      for (m in h) {
        var m = false;
        break b;
      }
      m = true;
    }
    if (!m)
      if (h = Nc(h), typeof f === "string") {
        if (m = encodeURIComponent("$httpHeaders"), h = h != null ? "=" + encodeURIComponent(String(h)) : "", m += h)
          h = f.indexOf("#"), 0 > h && (h = f.length), e = f.indexOf("?"), 0 > e || e > h ? (e = h, k = "") : k = f.substring(e + 1, h), f = [f.substr(0, e), k, f.substr(h)], h = f[1], f[1] = m ? h ? h + "&" + m : m : h, f = f[0] + (f[1] ? "?" + f[1] : "") + f[2];
      } else
        f.a("$httpHeaders", h);
  }
  b = d.getRequestSerializeFn()(b.getRequestMessage());
  d = b.length;
  m = [0, 0, 0, 0];
  h = new Uint8Array(5 + d);
  for (e = 3; 0 <= e; e--)
    m[e] = d % 256, d >>>= 8;
  h.set(new Uint8Array(m), 1);
  h.set(b, 5);
  b = h;
  if (a2.a == "text") {
    a2 = b;
    var p;
    p === void 0 && (p = 0);
    Ic();
    p = Ec[p];
    b = Array(Math.floor(a2.length / 3));
    d = p[64] || "";
    for (m = h = 0; h < a2.length - 2; h += 3) {
      l = a2[h];
      var q = a2[h + 1];
      k = a2[h + 2];
      e = p[l >> 2];
      l = p[(l & 3) << 4 | q >> 4];
      q = p[(q & 15) << 2 | k >> 6];
      k = p[k & 63];
      b[m++] = e + l + q + k;
    }
    e = 0;
    k = d;
    switch (a2.length - h) {
      case 2:
        e = a2[h + 1], k = p[(e & 15) << 2] || d;
      case 1:
        a2 = a2[h], b[m] = p[a2 >> 2] + p[(a2 & 3) << 4 | e >> 4] + k + d;
    }
    b = b.join("");
  } else
    a2.a == "binary" && (c.m = "arraybuffer");
  uc(c, f, b);
  return g;
}
function Qc(a2, b, c) {
  var d = false, f = null, g = false;
  a2.on("data", function(e) {
    d = true;
    f = e;
  });
  a2.on("error", function(e) {
    e.code == 0 || g || (g = true, b(e, null));
  });
  a2.on("status", function(e) {
    e.code == 0 || g ? c && b(null, null, e) : (g = true, b({ code: e.code, message: e.details, metadata: e.metadata }, null));
  });
  if (c)
    a2.on("metadata", function(e) {
      b(null, null, null, e);
    });
  a2.on("end", function() {
    g || (d ? b(null, f) : b({ code: 2, message: "Incomplete response" }));
    c && b(null, null);
  });
}
function Oc(a2, b) {
  var c = a2;
  b.forEach(function(d) {
    var f = c;
    c = function(g) {
      return d.intercept(g, f);
    };
  });
  return c;
}
Z.prototype.serverStreaming = Z.prototype.Y;
Z.prototype.unaryCall = Z.prototype.unaryCall;
Z.prototype.thenableCall = Z.prototype.S;
Z.prototype.rpcCall = Z.prototype.X;
grpcWeb.CallOptions = xa;
grpcWeb.MethodDescriptor = E;
grpcWeb.GrpcWebClientBase = Z;
grpcWeb.RpcError = F;
grpcWeb.StatusCode = { OK: 0, CANCELLED: 1, UNKNOWN: 2, INVALID_ARGUMENT: 3, DEADLINE_EXCEEDED: 4, NOT_FOUND: 5, ALREADY_EXISTS: 6, PERMISSION_DENIED: 7, UNAUTHENTICATED: 16, RESOURCE_EXHAUSTED: 8, FAILED_PRECONDITION: 9, ABORTED: 10, OUT_OF_RANGE: 11, UNIMPLEMENTED: 12, INTERNAL: 13, UNAVAILABLE: 14, DATA_LOSS: 15 };
grpcWeb.MethodType = { UNARY: "unary", SERVER_STREAMING: "server_streaming", BIDI_STREAMING: "bidi_streaming" };
Kb = typeof globalThis !== "undefined" && globalThis || self;
var hub_node_pb = {};
(function(exports2) {
  var jspb2 = googleProtobuf$1;
  var goog2 = jspb2;
  var global2 = Function("return this")();
  var media_common_pb2 = common_pb;
  goog2.object.extend(proto, media_common_pb2);
  goog2.exportSymbol("proto.media.node.AudioLevelsRequest", null, global2);
  goog2.exportSymbol("proto.media.node.CloseConsumerRequest", null, global2);
  goog2.exportSymbol("proto.media.node.CloseConsumerResponse", null, global2);
  goog2.exportSymbol("proto.media.node.CloseProducerRequest", null, global2);
  goog2.exportSymbol("proto.media.node.CloseProducerResponse", null, global2);
  goog2.exportSymbol("proto.media.node.CloseTransportRequest", null, global2);
  goog2.exportSymbol("proto.media.node.CloseTransportResponse", null, global2);
  goog2.exportSymbol("proto.media.node.CreateConsumersForMultiplePeersRequest", null, global2);
  goog2.exportSymbol("proto.media.node.CreateConsumersForMultiplePeersResponse", null, global2);
  goog2.exportSymbol("proto.media.node.CreateConsumersRequest", null, global2);
  goog2.exportSymbol("proto.media.node.CreateConsumersResponse", null, global2);
  goog2.exportSymbol("proto.media.node.CreateProducerRequest", null, global2);
  goog2.exportSymbol("proto.media.node.CreateProducerResponse", null, global2);
  goog2.exportSymbol("proto.media.node.DeregisterHubHandshakeRequest", null, global2);
  goog2.exportSymbol("proto.media.node.DeregisterHubHandshakeResponse", null, global2);
  goog2.exportSymbol("proto.media.node.GetCapacityRequest", null, global2);
  goog2.exportSymbol("proto.media.node.GetCapacityResponse", null, global2);
  goog2.exportSymbol("proto.media.node.RegisterHubHandshakeRequest", null, global2);
  goog2.exportSymbol("proto.media.node.RegisterHubHandshakeResponse", null, global2);
  goog2.exportSymbol("proto.media.node.ReserveCapacityRequest", null, global2);
  goog2.exportSymbol("proto.media.node.ReserveCapacityResponse", null, global2);
  goog2.exportSymbol("proto.media.node.ToggleConsumerRequest", null, global2);
  goog2.exportSymbol("proto.media.node.ToggleConsumerResponse", null, global2);
  goog2.exportSymbol("proto.media.node.ToggleProducerRequest", null, global2);
  goog2.exportSymbol("proto.media.node.ToggleProducerResponse", null, global2);
  proto.media.node.GetCapacityRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.GetCapacityRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.GetCapacityRequest.displayName = "proto.media.node.GetCapacityRequest";
  }
  proto.media.node.GetCapacityResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.GetCapacityResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.GetCapacityResponse.displayName = "proto.media.node.GetCapacityResponse";
  }
  proto.media.node.ReserveCapacityRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.ReserveCapacityRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.ReserveCapacityRequest.displayName = "proto.media.node.ReserveCapacityRequest";
  }
  proto.media.node.ReserveCapacityResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.ReserveCapacityResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.ReserveCapacityResponse.displayName = "proto.media.node.ReserveCapacityResponse";
  }
  proto.media.node.RegisterHubHandshakeRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.RegisterHubHandshakeRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.RegisterHubHandshakeRequest.displayName = "proto.media.node.RegisterHubHandshakeRequest";
  }
  proto.media.node.RegisterHubHandshakeResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.RegisterHubHandshakeResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.RegisterHubHandshakeResponse.displayName = "proto.media.node.RegisterHubHandshakeResponse";
  }
  proto.media.node.DeregisterHubHandshakeRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.DeregisterHubHandshakeRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.DeregisterHubHandshakeRequest.displayName = "proto.media.node.DeregisterHubHandshakeRequest";
  }
  proto.media.node.DeregisterHubHandshakeResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.DeregisterHubHandshakeResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.DeregisterHubHandshakeResponse.displayName = "proto.media.node.DeregisterHubHandshakeResponse";
  }
  proto.media.node.CreateConsumersRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.CreateConsumersRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CreateConsumersRequest.displayName = "proto.media.node.CreateConsumersRequest";
  }
  proto.media.node.CreateConsumersResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.CreateConsumersResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CreateConsumersResponse.displayName = "proto.media.node.CreateConsumersResponse";
  }
  proto.media.node.CreateConsumersForMultiplePeersRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.media.node.CreateConsumersForMultiplePeersRequest.repeatedFields_, null);
  };
  goog2.inherits(proto.media.node.CreateConsumersForMultiplePeersRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CreateConsumersForMultiplePeersRequest.displayName = "proto.media.node.CreateConsumersForMultiplePeersRequest";
  }
  proto.media.node.CreateConsumersForMultiplePeersResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.CreateConsumersForMultiplePeersResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CreateConsumersForMultiplePeersResponse.displayName = "proto.media.node.CreateConsumersForMultiplePeersResponse";
  }
  proto.media.node.CreateProducerRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.CreateProducerRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CreateProducerRequest.displayName = "proto.media.node.CreateProducerRequest";
  }
  proto.media.node.CreateProducerResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.CreateProducerResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CreateProducerResponse.displayName = "proto.media.node.CreateProducerResponse";
  }
  proto.media.node.CloseConsumerRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.CloseConsumerRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CloseConsumerRequest.displayName = "proto.media.node.CloseConsumerRequest";
  }
  proto.media.node.CloseConsumerResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.CloseConsumerResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CloseConsumerResponse.displayName = "proto.media.node.CloseConsumerResponse";
  }
  proto.media.node.CloseProducerRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.CloseProducerRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CloseProducerRequest.displayName = "proto.media.node.CloseProducerRequest";
  }
  proto.media.node.CloseProducerResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.CloseProducerResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CloseProducerResponse.displayName = "proto.media.node.CloseProducerResponse";
  }
  proto.media.node.CloseTransportRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.CloseTransportRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CloseTransportRequest.displayName = "proto.media.node.CloseTransportRequest";
  }
  proto.media.node.CloseTransportResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.CloseTransportResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.CloseTransportResponse.displayName = "proto.media.node.CloseTransportResponse";
  }
  proto.media.node.ToggleProducerRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.ToggleProducerRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.ToggleProducerRequest.displayName = "proto.media.node.ToggleProducerRequest";
  }
  proto.media.node.ToggleProducerResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.ToggleProducerResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.ToggleProducerResponse.displayName = "proto.media.node.ToggleProducerResponse";
  }
  proto.media.node.ToggleConsumerRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.ToggleConsumerRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.ToggleConsumerRequest.displayName = "proto.media.node.ToggleConsumerRequest";
  }
  proto.media.node.ToggleConsumerResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.ToggleConsumerResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.ToggleConsumerResponse.displayName = "proto.media.node.ToggleConsumerResponse";
  }
  proto.media.node.AudioLevelsRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.media.node.AudioLevelsRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.media.node.AudioLevelsRequest.displayName = "proto.media.node.AudioLevelsRequest";
  }
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.GetCapacityRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.GetCapacityRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.GetCapacityRequest.toObject = function(includeInstance, msg) {
      var obj = {};
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.GetCapacityRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.GetCapacityRequest();
    return proto.media.node.GetCapacityRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.GetCapacityRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.GetCapacityRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.GetCapacityRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.GetCapacityRequest.serializeBinaryToWriter = function(message2, writer) {
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.GetCapacityResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.GetCapacityResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.GetCapacityResponse.toObject = function(includeInstance, msg) {
      var obj = {
        capacity: jspb2.Message.getFieldWithDefault(msg, 1, 0)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.GetCapacityResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.GetCapacityResponse();
    return proto.media.node.GetCapacityResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.GetCapacityResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readUint32();
          msg.setCapacity(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.GetCapacityResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.GetCapacityResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.GetCapacityResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getCapacity();
    if (f !== 0) {
      writer.writeUint32(1, f);
    }
  };
  proto.media.node.GetCapacityResponse.prototype.getCapacity = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, 0);
  };
  proto.media.node.GetCapacityResponse.prototype.setCapacity = function(value) {
    return jspb2.Message.setProto3IntField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.ReserveCapacityRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.ReserveCapacityRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.ReserveCapacityRequest.toObject = function(includeInstance, msg) {
      var obj = {
        capacity: jspb2.Message.getFieldWithDefault(msg, 1, 0)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.ReserveCapacityRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.ReserveCapacityRequest();
    return proto.media.node.ReserveCapacityRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.ReserveCapacityRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readUint32();
          msg.setCapacity(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.ReserveCapacityRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.ReserveCapacityRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.ReserveCapacityRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getCapacity();
    if (f !== 0) {
      writer.writeUint32(1, f);
    }
  };
  proto.media.node.ReserveCapacityRequest.prototype.getCapacity = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, 0);
  };
  proto.media.node.ReserveCapacityRequest.prototype.setCapacity = function(value) {
    return jspb2.Message.setProto3IntField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.ReserveCapacityResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.ReserveCapacityResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.ReserveCapacityResponse.toObject = function(includeInstance, msg) {
      var obj = {
        result: jspb2.Message.getFieldWithDefault(msg, 1, 0)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.ReserveCapacityResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.ReserveCapacityResponse();
    return proto.media.node.ReserveCapacityResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.ReserveCapacityResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readUint32();
          msg.setResult(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.ReserveCapacityResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.ReserveCapacityResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.ReserveCapacityResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getResult();
    if (f !== 0) {
      writer.writeUint32(1, f);
    }
  };
  proto.media.node.ReserveCapacityResponse.prototype.getResult = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, 0);
  };
  proto.media.node.ReserveCapacityResponse.prototype.setResult = function(value) {
    return jspb2.Message.setProto3IntField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.RegisterHubHandshakeRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.RegisterHubHandshakeRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.RegisterHubHandshakeRequest.toObject = function(includeInstance, msg) {
      var obj = {
        hubId: jspb2.Message.getFieldWithDefault(msg, 1, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.RegisterHubHandshakeRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.RegisterHubHandshakeRequest();
    return proto.media.node.RegisterHubHandshakeRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.RegisterHubHandshakeRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setHubId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.RegisterHubHandshakeRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.RegisterHubHandshakeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.RegisterHubHandshakeRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getHubId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
  };
  proto.media.node.RegisterHubHandshakeRequest.prototype.getHubId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.RegisterHubHandshakeRequest.prototype.setHubId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.RegisterHubHandshakeResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.RegisterHubHandshakeResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.RegisterHubHandshakeResponse.toObject = function(includeInstance, msg) {
      var obj = {
        nodeId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        status: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.RegisterHubHandshakeResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.RegisterHubHandshakeResponse();
    return proto.media.node.RegisterHubHandshakeResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.RegisterHubHandshakeResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setNodeId(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setStatus(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.RegisterHubHandshakeResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.RegisterHubHandshakeResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.RegisterHubHandshakeResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getNodeId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getStatus();
    if (f) {
      writer.writeBool(2, f);
    }
  };
  proto.media.node.RegisterHubHandshakeResponse.prototype.getNodeId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.RegisterHubHandshakeResponse.prototype.setNodeId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.node.RegisterHubHandshakeResponse.prototype.getStatus = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.media.node.RegisterHubHandshakeResponse.prototype.setStatus = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.DeregisterHubHandshakeRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.DeregisterHubHandshakeRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.DeregisterHubHandshakeRequest.toObject = function(includeInstance, msg) {
      var obj = {
        hubId: jspb2.Message.getFieldWithDefault(msg, 1, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.DeregisterHubHandshakeRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.DeregisterHubHandshakeRequest();
    return proto.media.node.DeregisterHubHandshakeRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.DeregisterHubHandshakeRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setHubId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.DeregisterHubHandshakeRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.DeregisterHubHandshakeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.DeregisterHubHandshakeRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getHubId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
  };
  proto.media.node.DeregisterHubHandshakeRequest.prototype.getHubId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.DeregisterHubHandshakeRequest.prototype.setHubId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.DeregisterHubHandshakeResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.DeregisterHubHandshakeResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.DeregisterHubHandshakeResponse.toObject = function(includeInstance, msg) {
      var obj = {
        status: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.DeregisterHubHandshakeResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.DeregisterHubHandshakeResponse();
    return proto.media.node.DeregisterHubHandshakeResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.DeregisterHubHandshakeResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setStatus(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.DeregisterHubHandshakeResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.DeregisterHubHandshakeResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.DeregisterHubHandshakeResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getStatus();
    if (f) {
      writer.writeBool(1, f);
    }
  };
  proto.media.node.DeregisterHubHandshakeResponse.prototype.getStatus = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.media.node.DeregisterHubHandshakeResponse.prototype.setStatus = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CreateConsumersRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CreateConsumersRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.CreateConsumersRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        consumingTransportId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        producingTransportId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        producerId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CreateConsumersRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CreateConsumersRequest();
    return proto.media.node.CreateConsumersRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CreateConsumersRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setConsumingTransportId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setProducingTransportId(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setProducerId(value);
          break;
        case 4:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CreateConsumersRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CreateConsumersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CreateConsumersRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getConsumingTransportId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getProducingTransportId();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = jspb2.Message.getField(message2, 3);
    if (f != null) {
      writer.writeString(3, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(4, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.node.CreateConsumersRequest.prototype.getConsumingTransportId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.CreateConsumersRequest.prototype.setConsumingTransportId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.node.CreateConsumersRequest.prototype.getProducingTransportId = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.node.CreateConsumersRequest.prototype.setProducingTransportId = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.media.node.CreateConsumersRequest.prototype.getProducerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.media.node.CreateConsumersRequest.prototype.setProducerId = function(value) {
    return jspb2.Message.setField(this, 3, value);
  };
  proto.media.node.CreateConsumersRequest.prototype.clearProducerId = function() {
    return jspb2.Message.setField(this, 3, void 0);
  };
  proto.media.node.CreateConsumersRequest.prototype.hasProducerId = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  proto.media.node.CreateConsumersRequest.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 4);
  };
  proto.media.node.CreateConsumersRequest.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 4, value);
  };
  proto.media.node.CreateConsumersRequest.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.node.CreateConsumersRequest.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 4) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CreateConsumersResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CreateConsumersResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.CreateConsumersResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        consumerIdsMapMap: (f = msg.getConsumerIdsMapMap()) ? f.toObject(includeInstance, void 0) : [],
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CreateConsumersResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CreateConsumersResponse();
    return proto.media.node.CreateConsumersResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CreateConsumersResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = msg.getConsumerIdsMapMap();
          reader.readMessage(value, function(message2, reader2) {
            jspb2.Map.deserializeBinary(message2, reader2, jspb2.BinaryReader.prototype.readString, jspb2.BinaryReader.prototype.readString, null, "", "");
          });
          break;
        case 2:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CreateConsumersResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CreateConsumersResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CreateConsumersResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getConsumerIdsMapMap(true);
    if (f && f.getLength() > 0) {
      f.serializeBinary(1, writer, jspb2.BinaryWriter.prototype.writeString, jspb2.BinaryWriter.prototype.writeString);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(2, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.node.CreateConsumersResponse.prototype.getConsumerIdsMapMap = function(opt_noLazyCreate) {
    return jspb2.Message.getMapField(this, 1, opt_noLazyCreate, null);
  };
  proto.media.node.CreateConsumersResponse.prototype.clearConsumerIdsMapMap = function() {
    this.getConsumerIdsMapMap().clear();
    return this;
  };
  proto.media.node.CreateConsumersResponse.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 2);
  };
  proto.media.node.CreateConsumersResponse.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.node.CreateConsumersResponse.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.node.CreateConsumersResponse.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.repeatedFields_ = [2];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CreateConsumersForMultiplePeersRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.CreateConsumersForMultiplePeersRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        consumingTransportId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        producingTransportIdsList: (f = jspb2.Message.getRepeatedField(msg, 2)) == null ? void 0 : f,
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CreateConsumersForMultiplePeersRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CreateConsumersForMultiplePeersRequest();
    return proto.media.node.CreateConsumersForMultiplePeersRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setConsumingTransportId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.addProducingTransportIds(value);
          break;
        case 3:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CreateConsumersForMultiplePeersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getConsumingTransportId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getProducingTransportIdsList();
    if (f.length > 0) {
      writer.writeRepeatedString(2, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(3, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.getConsumingTransportId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.setConsumingTransportId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.getProducingTransportIdsList = function() {
    return jspb2.Message.getRepeatedField(this, 2);
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.setProducingTransportIdsList = function(value) {
    return jspb2.Message.setField(this, 2, value || []);
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.addProducingTransportIds = function(value, opt_index) {
    return jspb2.Message.addToRepeatedField(this, 2, value, opt_index);
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.clearProducingTransportIdsList = function() {
    return this.setProducingTransportIdsList([]);
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 3);
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 3, value);
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.node.CreateConsumersForMultiplePeersRequest.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CreateConsumersForMultiplePeersResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CreateConsumersForMultiplePeersResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.CreateConsumersForMultiplePeersResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        producingTransportToConsumersMapMap: (f = msg.getProducingTransportToConsumersMapMap()) ? f.toObject(includeInstance, proto.media.node.CreateConsumersResponse.toObject) : [],
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CreateConsumersForMultiplePeersResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CreateConsumersForMultiplePeersResponse();
    return proto.media.node.CreateConsumersForMultiplePeersResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CreateConsumersForMultiplePeersResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = msg.getProducingTransportToConsumersMapMap();
          reader.readMessage(value, function(message2, reader2) {
            jspb2.Map.deserializeBinary(message2, reader2, jspb2.BinaryReader.prototype.readString, jspb2.BinaryReader.prototype.readMessage, proto.media.node.CreateConsumersResponse.deserializeBinaryFromReader, "", new proto.media.node.CreateConsumersResponse());
          });
          break;
        case 2:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CreateConsumersForMultiplePeersResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CreateConsumersForMultiplePeersResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CreateConsumersForMultiplePeersResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getProducingTransportToConsumersMapMap(true);
    if (f && f.getLength() > 0) {
      f.serializeBinary(1, writer, jspb2.BinaryWriter.prototype.writeString, jspb2.BinaryWriter.prototype.writeMessage, proto.media.node.CreateConsumersResponse.serializeBinaryToWriter);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(2, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.node.CreateConsumersForMultiplePeersResponse.prototype.getProducingTransportToConsumersMapMap = function(opt_noLazyCreate) {
    return jspb2.Message.getMapField(this, 1, opt_noLazyCreate, proto.media.node.CreateConsumersResponse);
  };
  proto.media.node.CreateConsumersForMultiplePeersResponse.prototype.clearProducingTransportToConsumersMapMap = function() {
    this.getProducingTransportToConsumersMapMap().clear();
    return this;
  };
  proto.media.node.CreateConsumersForMultiplePeersResponse.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 2);
  };
  proto.media.node.CreateConsumersForMultiplePeersResponse.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.node.CreateConsumersForMultiplePeersResponse.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.node.CreateConsumersForMultiplePeersResponse.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CreateProducerRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CreateProducerRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.CreateProducerRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        producingTransportId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        kind: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        paused: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false),
        screenShare: jspb2.Message.getBooleanFieldWithDefault(msg, 4, false),
        trackId: jspb2.Message.getFieldWithDefault(msg, 5, ""),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CreateProducerRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CreateProducerRequest();
    return proto.media.node.CreateProducerRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CreateProducerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setProducingTransportId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setKind(value);
          break;
        case 3:
          var value = reader.readBool();
          msg.setPaused(value);
          break;
        case 4:
          var value = reader.readBool();
          msg.setScreenShare(value);
          break;
        case 5:
          var value = reader.readString();
          msg.setTrackId(value);
          break;
        case 6:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CreateProducerRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CreateProducerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CreateProducerRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getProducingTransportId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getKind();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getPaused();
    if (f) {
      writer.writeBool(3, f);
    }
    f = message2.getScreenShare();
    if (f) {
      writer.writeBool(4, f);
    }
    f = message2.getTrackId();
    if (f.length > 0) {
      writer.writeString(5, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(6, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.node.CreateProducerRequest.prototype.getProducingTransportId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.CreateProducerRequest.prototype.setProducingTransportId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.node.CreateProducerRequest.prototype.getKind = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.media.node.CreateProducerRequest.prototype.setKind = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.media.node.CreateProducerRequest.prototype.getPaused = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 3, false);
  };
  proto.media.node.CreateProducerRequest.prototype.setPaused = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 3, value);
  };
  proto.media.node.CreateProducerRequest.prototype.getScreenShare = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 4, false);
  };
  proto.media.node.CreateProducerRequest.prototype.setScreenShare = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 4, value);
  };
  proto.media.node.CreateProducerRequest.prototype.getTrackId = function() {
    return jspb2.Message.getFieldWithDefault(this, 5, "");
  };
  proto.media.node.CreateProducerRequest.prototype.setTrackId = function(value) {
    return jspb2.Message.setProto3StringField(this, 5, value);
  };
  proto.media.node.CreateProducerRequest.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 6);
  };
  proto.media.node.CreateProducerRequest.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 6, value);
  };
  proto.media.node.CreateProducerRequest.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.node.CreateProducerRequest.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 6) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CreateProducerResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CreateProducerResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.CreateProducerResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        producerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CreateProducerResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CreateProducerResponse();
    return proto.media.node.CreateProducerResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CreateProducerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setProducerId(value);
          break;
        case 2:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CreateProducerResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CreateProducerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CreateProducerResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getProducerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(2, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.node.CreateProducerResponse.prototype.getProducerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.CreateProducerResponse.prototype.setProducerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.node.CreateProducerResponse.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 2);
  };
  proto.media.node.CreateProducerResponse.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.node.CreateProducerResponse.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.node.CreateProducerResponse.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CloseConsumerRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CloseConsumerRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.CloseConsumerRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        consumerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CloseConsumerRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CloseConsumerRequest();
    return proto.media.node.CloseConsumerRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CloseConsumerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setConsumerId(value);
          break;
        case 2:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CloseConsumerRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CloseConsumerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CloseConsumerRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getConsumerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(2, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.node.CloseConsumerRequest.prototype.getConsumerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.CloseConsumerRequest.prototype.setConsumerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.node.CloseConsumerRequest.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 2);
  };
  proto.media.node.CloseConsumerRequest.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.node.CloseConsumerRequest.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.node.CloseConsumerRequest.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CloseConsumerResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CloseConsumerResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.CloseConsumerResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CloseConsumerResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CloseConsumerResponse();
    return proto.media.node.CloseConsumerResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CloseConsumerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CloseConsumerResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CloseConsumerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CloseConsumerResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(1, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.node.CloseConsumerResponse.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 1);
  };
  proto.media.node.CloseConsumerResponse.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.media.node.CloseConsumerResponse.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.node.CloseConsumerResponse.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CloseProducerRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CloseProducerRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.CloseProducerRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        producerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CloseProducerRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CloseProducerRequest();
    return proto.media.node.CloseProducerRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CloseProducerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setProducerId(value);
          break;
        case 2:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CloseProducerRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CloseProducerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CloseProducerRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getProducerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(2, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.node.CloseProducerRequest.prototype.getProducerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.CloseProducerRequest.prototype.setProducerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.node.CloseProducerRequest.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 2);
  };
  proto.media.node.CloseProducerRequest.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.media.node.CloseProducerRequest.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.node.CloseProducerRequest.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CloseProducerResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CloseProducerResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.CloseProducerResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        description: (f = msg.getDescription()) && media_common_pb2.SessionDescription.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CloseProducerResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CloseProducerResponse();
    return proto.media.node.CloseProducerResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CloseProducerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new media_common_pb2.SessionDescription();
          reader.readMessage(value, media_common_pb2.SessionDescription.deserializeBinaryFromReader);
          msg.setDescription(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CloseProducerResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CloseProducerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CloseProducerResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getDescription();
    if (f != null) {
      writer.writeMessage(1, f, media_common_pb2.SessionDescription.serializeBinaryToWriter);
    }
  };
  proto.media.node.CloseProducerResponse.prototype.getDescription = function() {
    return jspb2.Message.getWrapperField(this, media_common_pb2.SessionDescription, 1);
  };
  proto.media.node.CloseProducerResponse.prototype.setDescription = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.media.node.CloseProducerResponse.prototype.clearDescription = function() {
    return this.setDescription(void 0);
  };
  proto.media.node.CloseProducerResponse.prototype.hasDescription = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CloseTransportRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CloseTransportRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.CloseTransportRequest.toObject = function(includeInstance, msg) {
      var obj = {
        transportId: jspb2.Message.getFieldWithDefault(msg, 1, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CloseTransportRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CloseTransportRequest();
    return proto.media.node.CloseTransportRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CloseTransportRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setTransportId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CloseTransportRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CloseTransportRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CloseTransportRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getTransportId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
  };
  proto.media.node.CloseTransportRequest.prototype.getTransportId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.CloseTransportRequest.prototype.setTransportId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.CloseTransportResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.CloseTransportResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.CloseTransportResponse.toObject = function(includeInstance, msg) {
      var obj = {};
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.CloseTransportResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.CloseTransportResponse();
    return proto.media.node.CloseTransportResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.CloseTransportResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.CloseTransportResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.CloseTransportResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.CloseTransportResponse.serializeBinaryToWriter = function(message2, writer) {
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.ToggleProducerRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.ToggleProducerRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.ToggleProducerRequest.toObject = function(includeInstance, msg) {
      var obj = {
        producerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        value: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.ToggleProducerRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.ToggleProducerRequest();
    return proto.media.node.ToggleProducerRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.ToggleProducerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setProducerId(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setValue(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.ToggleProducerRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.ToggleProducerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.ToggleProducerRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getProducerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getValue();
    if (f) {
      writer.writeBool(2, f);
    }
  };
  proto.media.node.ToggleProducerRequest.prototype.getProducerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.ToggleProducerRequest.prototype.setProducerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.node.ToggleProducerRequest.prototype.getValue = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.media.node.ToggleProducerRequest.prototype.setValue = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.ToggleProducerResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.ToggleProducerResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.ToggleProducerResponse.toObject = function(includeInstance, msg) {
      var obj = {};
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.ToggleProducerResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.ToggleProducerResponse();
    return proto.media.node.ToggleProducerResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.ToggleProducerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.ToggleProducerResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.ToggleProducerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.ToggleProducerResponse.serializeBinaryToWriter = function(message2, writer) {
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.ToggleConsumerRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.ToggleConsumerRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.ToggleConsumerRequest.toObject = function(includeInstance, msg) {
      var obj = {
        consumerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        value: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.ToggleConsumerRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.ToggleConsumerRequest();
    return proto.media.node.ToggleConsumerRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.ToggleConsumerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setConsumerId(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setValue(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.ToggleConsumerRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.ToggleConsumerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.ToggleConsumerRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getConsumerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getValue();
    if (f) {
      writer.writeBool(2, f);
    }
  };
  proto.media.node.ToggleConsumerRequest.prototype.getConsumerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.media.node.ToggleConsumerRequest.prototype.setConsumerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.media.node.ToggleConsumerRequest.prototype.getValue = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.media.node.ToggleConsumerRequest.prototype.setValue = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.ToggleConsumerResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.ToggleConsumerResponse.toObject(opt_includeInstance, this);
    };
    proto.media.node.ToggleConsumerResponse.toObject = function(includeInstance, msg) {
      var obj = {};
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.ToggleConsumerResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.ToggleConsumerResponse();
    return proto.media.node.ToggleConsumerResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.ToggleConsumerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.ToggleConsumerResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.ToggleConsumerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.ToggleConsumerResponse.serializeBinaryToWriter = function(message2, writer) {
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.media.node.AudioLevelsRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.media.node.AudioLevelsRequest.toObject(opt_includeInstance, this);
    };
    proto.media.node.AudioLevelsRequest.toObject = function(includeInstance, msg) {
      var obj = {
        audioLevel: jspb2.Message.getFieldWithDefault(msg, 1, 0)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.media.node.AudioLevelsRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.media.node.AudioLevelsRequest();
    return proto.media.node.AudioLevelsRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.media.node.AudioLevelsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readInt32();
          msg.setAudioLevel(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.media.node.AudioLevelsRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.media.node.AudioLevelsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.media.node.AudioLevelsRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getAudioLevel();
    if (f !== 0) {
      writer.writeInt32(1, f);
    }
  };
  proto.media.node.AudioLevelsRequest.prototype.getAudioLevel = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, 0);
  };
  proto.media.node.AudioLevelsRequest.prototype.setAudioLevel = function(value) {
    return jspb2.Message.setProto3IntField(this, 1, value);
  };
  goog2.object.extend(exports2, proto.media.node);
})(hub_node_pb);
const grpc = {};
grpc.web = grpcWeb;
var media_common_pb = common_pb;
const proto$1 = {};
proto$1.media = {};
proto$1.media.node = hub_node_pb;
proto$1.media.node.HiveNodeClient = function(hostname, credentials, options) {
  if (!options)
    options = {};
  options.format = "binary";
  this.client_ = new grpc.web.GrpcWebClientBase(options);
  this.hostname_ = hostname;
};
proto$1.media.node.HiveNodePromiseClient = function(hostname, credentials, options) {
  if (!options)
    options = {};
  options.format = "binary";
  this.client_ = new grpc.web.GrpcWebClientBase(options);
  this.hostname_ = hostname;
};
const methodDescriptor_HiveNode_GetCapacity = new grpc.web.MethodDescriptor("/media.node.HiveNode/GetCapacity", grpc.web.MethodType.UNARY, proto$1.media.node.GetCapacityRequest, proto$1.media.node.GetCapacityResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.GetCapacityResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.getCapacity = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/GetCapacity", request, metadata || {}, methodDescriptor_HiveNode_GetCapacity, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.getCapacity = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/GetCapacity", request, metadata || {}, methodDescriptor_HiveNode_GetCapacity);
};
const methodDescriptor_HiveNode_ReserveCapacity = new grpc.web.MethodDescriptor("/media.node.HiveNode/ReserveCapacity", grpc.web.MethodType.UNARY, proto$1.media.node.ReserveCapacityRequest, proto$1.media.node.ReserveCapacityResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.ReserveCapacityResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.reserveCapacity = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/ReserveCapacity", request, metadata || {}, methodDescriptor_HiveNode_ReserveCapacity, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.reserveCapacity = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/ReserveCapacity", request, metadata || {}, methodDescriptor_HiveNode_ReserveCapacity);
};
const methodDescriptor_HiveNode_RegisterHubHandshake = new grpc.web.MethodDescriptor("/media.node.HiveNode/RegisterHubHandshake", grpc.web.MethodType.UNARY, proto$1.media.node.RegisterHubHandshakeRequest, proto$1.media.node.RegisterHubHandshakeResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.RegisterHubHandshakeResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.registerHubHandshake = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/RegisterHubHandshake", request, metadata || {}, methodDescriptor_HiveNode_RegisterHubHandshake, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.registerHubHandshake = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/RegisterHubHandshake", request, metadata || {}, methodDescriptor_HiveNode_RegisterHubHandshake);
};
const methodDescriptor_HiveNode_DeregisterHubHandshake = new grpc.web.MethodDescriptor("/media.node.HiveNode/DeregisterHubHandshake", grpc.web.MethodType.UNARY, proto$1.media.node.DeregisterHubHandshakeRequest, proto$1.media.node.DeregisterHubHandshakeResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.DeregisterHubHandshakeResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.deregisterHubHandshake = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/DeregisterHubHandshake", request, metadata || {}, methodDescriptor_HiveNode_DeregisterHubHandshake, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.deregisterHubHandshake = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/DeregisterHubHandshake", request, metadata || {}, methodDescriptor_HiveNode_DeregisterHubHandshake);
};
const methodDescriptor_HiveNode_CreateTransport = new grpc.web.MethodDescriptor("/media.node.HiveNode/CreateTransport", grpc.web.MethodType.UNARY, media_common_pb.CreateTransportRequest, media_common_pb.CreateTransportResponse, function(request) {
  return request.serializeBinary();
}, media_common_pb.CreateTransportResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.createTransport = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/CreateTransport", request, metadata || {}, methodDescriptor_HiveNode_CreateTransport, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.createTransport = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/CreateTransport", request, metadata || {}, methodDescriptor_HiveNode_CreateTransport);
};
const methodDescriptor_HiveNode_CreateConsumers = new grpc.web.MethodDescriptor("/media.node.HiveNode/CreateConsumers", grpc.web.MethodType.UNARY, proto$1.media.node.CreateConsumersRequest, proto$1.media.node.CreateConsumersResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.CreateConsumersResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.createConsumers = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/CreateConsumers", request, metadata || {}, methodDescriptor_HiveNode_CreateConsumers, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.createConsumers = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/CreateConsumers", request, metadata || {}, methodDescriptor_HiveNode_CreateConsumers);
};
const methodDescriptor_HiveNode_CreateConsumersForMultiplePeers = new grpc.web.MethodDescriptor("/media.node.HiveNode/CreateConsumersForMultiplePeers", grpc.web.MethodType.UNARY, proto$1.media.node.CreateConsumersForMultiplePeersRequest, proto$1.media.node.CreateConsumersForMultiplePeersResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.CreateConsumersForMultiplePeersResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.createConsumersForMultiplePeers = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/CreateConsumersForMultiplePeers", request, metadata || {}, methodDescriptor_HiveNode_CreateConsumersForMultiplePeers, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.createConsumersForMultiplePeers = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/CreateConsumersForMultiplePeers", request, metadata || {}, methodDescriptor_HiveNode_CreateConsumersForMultiplePeers);
};
const methodDescriptor_HiveNode_CreateProducer = new grpc.web.MethodDescriptor("/media.node.HiveNode/CreateProducer", grpc.web.MethodType.UNARY, proto$1.media.node.CreateProducerRequest, proto$1.media.node.CreateProducerResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.CreateProducerResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.createProducer = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/CreateProducer", request, metadata || {}, methodDescriptor_HiveNode_CreateProducer, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.createProducer = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/CreateProducer", request, metadata || {}, methodDescriptor_HiveNode_CreateProducer);
};
const methodDescriptor_HiveNode_ToggleProducer = new grpc.web.MethodDescriptor("/media.node.HiveNode/ToggleProducer", grpc.web.MethodType.UNARY, proto$1.media.node.ToggleProducerRequest, proto$1.media.node.ToggleProducerResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.ToggleProducerResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.toggleProducer = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/ToggleProducer", request, metadata || {}, methodDescriptor_HiveNode_ToggleProducer, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.toggleProducer = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/ToggleProducer", request, metadata || {}, methodDescriptor_HiveNode_ToggleProducer);
};
const methodDescriptor_HiveNode_ToggleConsumer = new grpc.web.MethodDescriptor("/media.node.HiveNode/ToggleConsumer", grpc.web.MethodType.UNARY, proto$1.media.node.ToggleConsumerRequest, proto$1.media.node.ToggleConsumerResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.ToggleConsumerResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.toggleConsumer = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/ToggleConsumer", request, metadata || {}, methodDescriptor_HiveNode_ToggleConsumer, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.toggleConsumer = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/ToggleConsumer", request, metadata || {}, methodDescriptor_HiveNode_ToggleConsumer);
};
const methodDescriptor_HiveNode_CloseConsumer = new grpc.web.MethodDescriptor("/media.node.HiveNode/CloseConsumer", grpc.web.MethodType.UNARY, proto$1.media.node.CloseConsumerRequest, proto$1.media.node.CloseConsumerResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.CloseConsumerResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.closeConsumer = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/CloseConsumer", request, metadata || {}, methodDescriptor_HiveNode_CloseConsumer, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.closeConsumer = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/CloseConsumer", request, metadata || {}, methodDescriptor_HiveNode_CloseConsumer);
};
const methodDescriptor_HiveNode_CloseProducer = new grpc.web.MethodDescriptor("/media.node.HiveNode/CloseProducer", grpc.web.MethodType.UNARY, proto$1.media.node.CloseProducerRequest, proto$1.media.node.CloseProducerResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.CloseProducerResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.closeProducer = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/CloseProducer", request, metadata || {}, methodDescriptor_HiveNode_CloseProducer, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.closeProducer = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/CloseProducer", request, metadata || {}, methodDescriptor_HiveNode_CloseProducer);
};
const methodDescriptor_HiveNode_CloseTransport = new grpc.web.MethodDescriptor("/media.node.HiveNode/CloseTransport", grpc.web.MethodType.UNARY, proto$1.media.node.CloseTransportRequest, proto$1.media.node.CloseTransportResponse, function(request) {
  return request.serializeBinary();
}, proto$1.media.node.CloseTransportResponse.deserializeBinary);
proto$1.media.node.HiveNodeClient.prototype.closeTransport = function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ + "/media.node.HiveNode/CloseTransport", request, metadata || {}, methodDescriptor_HiveNode_CloseTransport, callback);
};
proto$1.media.node.HiveNodePromiseClient.prototype.closeTransport = function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ + "/media.node.HiveNode/CloseTransport", request, metadata || {}, methodDescriptor_HiveNode_CloseTransport);
};
var hub_node_grpc_web_pb = proto$1.media.node;
var api_pb = {};
(function(exports2) {
  var jspb2 = googleProtobuf$1;
  var goog2 = jspb2;
  var global2 = Function("return this")();
  goog2.exportSymbol("proto.socket.api.BaseSocketHubMessage", null, global2);
  goog2.exportSymbol("proto.socket.api.ErrorMessage", null, global2);
  proto.socket.api.BaseSocketHubMessage = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.api.BaseSocketHubMessage, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.api.BaseSocketHubMessage.displayName = "proto.socket.api.BaseSocketHubMessage";
  }
  proto.socket.api.ErrorMessage = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.api.ErrorMessage, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.api.ErrorMessage.displayName = "proto.socket.api.ErrorMessage";
  }
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.api.BaseSocketHubMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.api.BaseSocketHubMessage.toObject(opt_includeInstance, this);
    };
    proto.socket.api.BaseSocketHubMessage.toObject = function(includeInstance, msg) {
      var obj = {
        event: jspb2.Message.getFieldWithDefault(msg, 1, 0),
        id: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        peerId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
        roomId: jspb2.Message.getFieldWithDefault(msg, 4, ""),
        payload: msg.getPayload_asB64()
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.api.BaseSocketHubMessage.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.api.BaseSocketHubMessage();
    return proto.socket.api.BaseSocketHubMessage.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.api.BaseSocketHubMessage.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readInt32();
          msg.setEvent(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setId(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setPeerId(value);
          break;
        case 4:
          var value = reader.readString();
          msg.setRoomId(value);
          break;
        case 5:
          var value = reader.readBytes();
          msg.setPayload(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.api.BaseSocketHubMessage.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.api.BaseSocketHubMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.api.BaseSocketHubMessage.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getEvent();
    if (f !== 0) {
      writer.writeInt32(1, f);
    }
    f = message2.getId();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getPeerId();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
    f = message2.getRoomId();
    if (f.length > 0) {
      writer.writeString(4, f);
    }
    f = message2.getPayload_asU8();
    if (f.length > 0) {
      writer.writeBytes(5, f);
    }
  };
  proto.socket.api.BaseSocketHubMessage.prototype.getEvent = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, 0);
  };
  proto.socket.api.BaseSocketHubMessage.prototype.setEvent = function(value) {
    return jspb2.Message.setProto3IntField(this, 1, value);
  };
  proto.socket.api.BaseSocketHubMessage.prototype.getId = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.api.BaseSocketHubMessage.prototype.setId = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.api.BaseSocketHubMessage.prototype.getPeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.socket.api.BaseSocketHubMessage.prototype.setPeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  proto.socket.api.BaseSocketHubMessage.prototype.getRoomId = function() {
    return jspb2.Message.getFieldWithDefault(this, 4, "");
  };
  proto.socket.api.BaseSocketHubMessage.prototype.setRoomId = function(value) {
    return jspb2.Message.setProto3StringField(this, 4, value);
  };
  proto.socket.api.BaseSocketHubMessage.prototype.getPayload = function() {
    return jspb2.Message.getFieldWithDefault(this, 5, "");
  };
  proto.socket.api.BaseSocketHubMessage.prototype.getPayload_asB64 = function() {
    return jspb2.Message.bytesAsB64(this.getPayload());
  };
  proto.socket.api.BaseSocketHubMessage.prototype.getPayload_asU8 = function() {
    return jspb2.Message.bytesAsU8(this.getPayload());
  };
  proto.socket.api.BaseSocketHubMessage.prototype.setPayload = function(value) {
    return jspb2.Message.setProto3BytesField(this, 5, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.api.ErrorMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.api.ErrorMessage.toObject(opt_includeInstance, this);
    };
    proto.socket.api.ErrorMessage.toObject = function(includeInstance, msg) {
      var obj = {
        code: jspb2.Message.getFieldWithDefault(msg, 1, 0),
        message: jspb2.Message.getFieldWithDefault(msg, 2, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.api.ErrorMessage.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.api.ErrorMessage();
    return proto.socket.api.ErrorMessage.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.api.ErrorMessage.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readInt32();
          msg.setCode(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setMessage(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.api.ErrorMessage.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.api.ErrorMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.api.ErrorMessage.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = jspb2.Message.getField(message2, 1);
    if (f != null) {
      writer.writeInt32(1, f);
    }
    f = message2.getMessage();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };
  proto.socket.api.ErrorMessage.prototype.getCode = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, 0);
  };
  proto.socket.api.ErrorMessage.prototype.setCode = function(value) {
    return jspb2.Message.setField(this, 1, value);
  };
  proto.socket.api.ErrorMessage.prototype.clearCode = function() {
    return jspb2.Message.setField(this, 1, void 0);
  };
  proto.socket.api.ErrorMessage.prototype.hasCode = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  proto.socket.api.ErrorMessage.prototype.getMessage = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.api.ErrorMessage.prototype.setMessage = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  goog2.object.extend(exports2, proto.socket.api);
})(api_pb);
var preset_pb = {};
(function(exports2) {
  var jspb2 = googleProtobuf$1;
  var goog2 = jspb2;
  var global2 = Function("return this")();
  goog2.exportSymbol("proto.socket.PeerPreset", null, global2);
  goog2.exportSymbol("proto.socket.PeerPreset.Chat", null, global2);
  goog2.exportSymbol("proto.socket.PeerPreset.Data", null, global2);
  goog2.exportSymbol("proto.socket.PeerPreset.Permissions", null, global2);
  goog2.exportSymbol("proto.socket.PeerPreset.Plugins", null, global2);
  goog2.exportSymbol("proto.socket.PeerPreset.Polls", null, global2);
  goog2.exportSymbol("proto.socket.PeerPreset.Preset", null, global2);
  goog2.exportSymbol("proto.socket.PeerPreset.Private", null, global2);
  goog2.exportSymbol("proto.socket.PeerPreset.Produce", null, global2);
  goog2.exportSymbol("proto.socket.PeerPreset.Public", null, global2);
  goog2.exportSymbol("proto.socket.PeerPreset.Screenshare", null, global2);
  goog2.exportSymbol("proto.socket.PeerPreset.Video", null, global2);
  proto.socket.PeerPreset = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.displayName = "proto.socket.PeerPreset";
  }
  proto.socket.PeerPreset.Plugins = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset.Plugins, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.Plugins.displayName = "proto.socket.PeerPreset.Plugins";
  }
  proto.socket.PeerPreset.Polls = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset.Polls, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.Polls.displayName = "proto.socket.PeerPreset.Polls";
  }
  proto.socket.PeerPreset.Video = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset.Video, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.Video.displayName = "proto.socket.PeerPreset.Video";
  }
  proto.socket.PeerPreset.Screenshare = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset.Screenshare, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.Screenshare.displayName = "proto.socket.PeerPreset.Screenshare";
  }
  proto.socket.PeerPreset.Produce = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset.Produce, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.Produce.displayName = "proto.socket.PeerPreset.Produce";
  }
  proto.socket.PeerPreset.Public = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset.Public, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.Public.displayName = "proto.socket.PeerPreset.Public";
  }
  proto.socket.PeerPreset.Private = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset.Private, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.Private.displayName = "proto.socket.PeerPreset.Private";
  }
  proto.socket.PeerPreset.Chat = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset.Chat, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.Chat.displayName = "proto.socket.PeerPreset.Chat";
  }
  proto.socket.PeerPreset.Permissions = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset.Permissions, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.Permissions.displayName = "proto.socket.PeerPreset.Permissions";
  }
  proto.socket.PeerPreset.Preset = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset.Preset, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.Preset.displayName = "proto.socket.PeerPreset.Preset";
  }
  proto.socket.PeerPreset.Data = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.PeerPreset.Data, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.PeerPreset.Data.displayName = "proto.socket.PeerPreset.Data";
  }
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.toObject = function(includeInstance, msg) {
      var f, obj = {
        success: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        message: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        data: (f = msg.getData()) && proto.socket.PeerPreset.Data.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset();
    return proto.socket.PeerPreset.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setSuccess(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setMessage(value);
          break;
        case 3:
          var value = new proto.socket.PeerPreset.Data();
          reader.readMessage(value, proto.socket.PeerPreset.Data.deserializeBinaryFromReader);
          msg.setData(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getSuccess();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message2.getMessage();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getData();
    if (f != null) {
      writer.writeMessage(3, f, proto.socket.PeerPreset.Data.serializeBinaryToWriter);
    }
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.Plugins.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.Plugins.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.Plugins.toObject = function(includeInstance, msg) {
      var obj = {
        canClose: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        canStart: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.Plugins.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset.Plugins();
    return proto.socket.PeerPreset.Plugins.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.Plugins.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setCanClose(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setCanStart(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.Plugins.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.Plugins.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.Plugins.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getCanClose();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message2.getCanStart();
    if (f) {
      writer.writeBool(2, f);
    }
  };
  proto.socket.PeerPreset.Plugins.prototype.getCanClose = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.socket.PeerPreset.Plugins.prototype.setCanClose = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.socket.PeerPreset.Plugins.prototype.getCanStart = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.socket.PeerPreset.Plugins.prototype.setCanStart = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.Polls.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.Polls.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.Polls.toObject = function(includeInstance, msg) {
      var obj = {
        canCreate: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        canVote: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false),
        canView: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.Polls.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset.Polls();
    return proto.socket.PeerPreset.Polls.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.Polls.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setCanCreate(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setCanVote(value);
          break;
        case 3:
          var value = reader.readBool();
          msg.setCanView(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.Polls.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.Polls.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.Polls.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getCanCreate();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message2.getCanVote();
    if (f) {
      writer.writeBool(2, f);
    }
    f = message2.getCanView();
    if (f) {
      writer.writeBool(3, f);
    }
  };
  proto.socket.PeerPreset.Polls.prototype.getCanCreate = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.socket.PeerPreset.Polls.prototype.setCanCreate = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.socket.PeerPreset.Polls.prototype.getCanVote = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.socket.PeerPreset.Polls.prototype.setCanVote = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  proto.socket.PeerPreset.Polls.prototype.getCanView = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 3, false);
  };
  proto.socket.PeerPreset.Polls.prototype.setCanView = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 3, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.Video.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.Video.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.Video.toObject = function(includeInstance, msg) {
      var obj = {
        allow: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        quality: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        frameRate: jspb2.Message.getFieldWithDefault(msg, 3, 0)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.Video.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset.Video();
    return proto.socket.PeerPreset.Video.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.Video.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setAllow(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setQuality(value);
          break;
        case 3:
          var value = reader.readUint32();
          msg.setFrameRate(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.Video.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.Video.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.Video.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getAllow();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message2.getQuality();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getFrameRate();
    if (f !== 0) {
      writer.writeUint32(3, f);
    }
  };
  proto.socket.PeerPreset.Video.prototype.getAllow = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.socket.PeerPreset.Video.prototype.setAllow = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.socket.PeerPreset.Video.prototype.getQuality = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.PeerPreset.Video.prototype.setQuality = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.PeerPreset.Video.prototype.getFrameRate = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, 0);
  };
  proto.socket.PeerPreset.Video.prototype.setFrameRate = function(value) {
    return jspb2.Message.setProto3IntField(this, 3, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.Screenshare.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.Screenshare.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.Screenshare.toObject = function(includeInstance, msg) {
      var obj = {
        allow: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        quality: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        frameRate: jspb2.Message.getFieldWithDefault(msg, 3, 0)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.Screenshare.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset.Screenshare();
    return proto.socket.PeerPreset.Screenshare.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.Screenshare.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setAllow(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setQuality(value);
          break;
        case 3:
          var value = reader.readUint32();
          msg.setFrameRate(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.Screenshare.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.Screenshare.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.Screenshare.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getAllow();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message2.getQuality();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getFrameRate();
    if (f !== 0) {
      writer.writeUint32(3, f);
    }
  };
  proto.socket.PeerPreset.Screenshare.prototype.getAllow = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.socket.PeerPreset.Screenshare.prototype.setAllow = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.socket.PeerPreset.Screenshare.prototype.getQuality = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.PeerPreset.Screenshare.prototype.setQuality = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.PeerPreset.Screenshare.prototype.getFrameRate = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, 0);
  };
  proto.socket.PeerPreset.Screenshare.prototype.setFrameRate = function(value) {
    return jspb2.Message.setProto3IntField(this, 3, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.Produce.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.Produce.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.Produce.toObject = function(includeInstance, msg) {
      var f, obj = {
        video: (f = msg.getVideo()) && proto.socket.PeerPreset.Video.toObject(includeInstance, f),
        audio: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false),
        screenshare: (f = msg.getScreenshare()) && proto.socket.PeerPreset.Screenshare.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.Produce.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset.Produce();
    return proto.socket.PeerPreset.Produce.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.Produce.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.PeerPreset.Video();
          reader.readMessage(value, proto.socket.PeerPreset.Video.deserializeBinaryFromReader);
          msg.setVideo(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setAudio(value);
          break;
        case 3:
          var value = new proto.socket.PeerPreset.Screenshare();
          reader.readMessage(value, proto.socket.PeerPreset.Screenshare.deserializeBinaryFromReader);
          msg.setScreenshare(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.Produce.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.Produce.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.Produce.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getVideo();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.PeerPreset.Video.serializeBinaryToWriter);
    }
    f = message2.getAudio();
    if (f) {
      writer.writeBool(2, f);
    }
    f = message2.getScreenshare();
    if (f != null) {
      writer.writeMessage(3, f, proto.socket.PeerPreset.Screenshare.serializeBinaryToWriter);
    }
  };
  proto.socket.PeerPreset.Produce.prototype.getVideo = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.PeerPreset.Video, 1);
  };
  proto.socket.PeerPreset.Produce.prototype.setVideo = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.PeerPreset.Produce.prototype.clearVideo = function() {
    return this.setVideo(void 0);
  };
  proto.socket.PeerPreset.Produce.prototype.hasVideo = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  proto.socket.PeerPreset.Produce.prototype.getAudio = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.socket.PeerPreset.Produce.prototype.setAudio = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  proto.socket.PeerPreset.Produce.prototype.getScreenshare = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.PeerPreset.Screenshare, 3);
  };
  proto.socket.PeerPreset.Produce.prototype.setScreenshare = function(value) {
    return jspb2.Message.setWrapperField(this, 3, value);
  };
  proto.socket.PeerPreset.Produce.prototype.clearScreenshare = function() {
    return this.setScreenshare(void 0);
  };
  proto.socket.PeerPreset.Produce.prototype.hasScreenshare = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.Public.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.Public.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.Public.toObject = function(includeInstance, msg) {
      var obj = {
        canSend: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        text: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false),
        files: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.Public.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset.Public();
    return proto.socket.PeerPreset.Public.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.Public.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setCanSend(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setText(value);
          break;
        case 3:
          var value = reader.readBool();
          msg.setFiles(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.Public.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.Public.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.Public.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getCanSend();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message2.getText();
    if (f) {
      writer.writeBool(2, f);
    }
    f = message2.getFiles();
    if (f) {
      writer.writeBool(3, f);
    }
  };
  proto.socket.PeerPreset.Public.prototype.getCanSend = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.socket.PeerPreset.Public.prototype.setCanSend = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.socket.PeerPreset.Public.prototype.getText = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.socket.PeerPreset.Public.prototype.setText = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  proto.socket.PeerPreset.Public.prototype.getFiles = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 3, false);
  };
  proto.socket.PeerPreset.Public.prototype.setFiles = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 3, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.Private.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.Private.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.Private.toObject = function(includeInstance, msg) {
      var obj = {
        canSend: jspb2.Message.getBooleanFieldWithDefault(msg, 1, false),
        canReceive: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false),
        text: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false),
        files: jspb2.Message.getBooleanFieldWithDefault(msg, 4, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.Private.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset.Private();
    return proto.socket.PeerPreset.Private.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.Private.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readBool();
          msg.setCanSend(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setCanReceive(value);
          break;
        case 3:
          var value = reader.readBool();
          msg.setText(value);
          break;
        case 4:
          var value = reader.readBool();
          msg.setFiles(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.Private.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.Private.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.Private.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getCanSend();
    if (f) {
      writer.writeBool(1, f);
    }
    f = message2.getCanReceive();
    if (f) {
      writer.writeBool(2, f);
    }
    f = message2.getText();
    if (f) {
      writer.writeBool(3, f);
    }
    f = message2.getFiles();
    if (f) {
      writer.writeBool(4, f);
    }
  };
  proto.socket.PeerPreset.Private.prototype.getCanSend = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.socket.PeerPreset.Private.prototype.setCanSend = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.socket.PeerPreset.Private.prototype.getCanReceive = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.socket.PeerPreset.Private.prototype.setCanReceive = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  proto.socket.PeerPreset.Private.prototype.getText = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 3, false);
  };
  proto.socket.PeerPreset.Private.prototype.setText = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 3, value);
  };
  proto.socket.PeerPreset.Private.prototype.getFiles = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 4, false);
  };
  proto.socket.PeerPreset.Private.prototype.setFiles = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 4, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.Chat.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.Chat.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.Chat.toObject = function(includeInstance, msg) {
      var f, obj = {
        pb_public: (f = msg.getPublic()) && proto.socket.PeerPreset.Public.toObject(includeInstance, f),
        pb_private: (f = msg.getPrivate()) && proto.socket.PeerPreset.Private.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.Chat.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset.Chat();
    return proto.socket.PeerPreset.Chat.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.Chat.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.PeerPreset.Public();
          reader.readMessage(value, proto.socket.PeerPreset.Public.deserializeBinaryFromReader);
          msg.setPublic(value);
          break;
        case 2:
          var value = new proto.socket.PeerPreset.Private();
          reader.readMessage(value, proto.socket.PeerPreset.Private.deserializeBinaryFromReader);
          msg.setPrivate(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.Chat.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.Chat.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.Chat.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPublic();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.PeerPreset.Public.serializeBinaryToWriter);
    }
    f = message2.getPrivate();
    if (f != null) {
      writer.writeMessage(2, f, proto.socket.PeerPreset.Private.serializeBinaryToWriter);
    }
  };
  proto.socket.PeerPreset.Chat.prototype.getPublic = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.PeerPreset.Public, 1);
  };
  proto.socket.PeerPreset.Chat.prototype.setPublic = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.PeerPreset.Chat.prototype.clearPublic = function() {
    return this.setPublic(void 0);
  };
  proto.socket.PeerPreset.Chat.prototype.hasPublic = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  proto.socket.PeerPreset.Chat.prototype.getPrivate = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.PeerPreset.Private, 2);
  };
  proto.socket.PeerPreset.Chat.prototype.setPrivate = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.socket.PeerPreset.Chat.prototype.clearPrivate = function() {
    return this.setPrivate(void 0);
  };
  proto.socket.PeerPreset.Chat.prototype.hasPrivate = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.Permissions.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.Permissions.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.Permissions.toObject = function(includeInstance, msg) {
      var f, obj = {
        viewType: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        acceptWaitingRequests: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false),
        requestProduce: jspb2.Message.getBooleanFieldWithDefault(msg, 3, false),
        canAllowParticipantAudio: jspb2.Message.getBooleanFieldWithDefault(msg, 4, false),
        canAllowParticipantScreensharing: jspb2.Message.getBooleanFieldWithDefault(msg, 5, false),
        canAllowParticipantVideo: jspb2.Message.getBooleanFieldWithDefault(msg, 6, false),
        requestKickParticipant: jspb2.Message.getBooleanFieldWithDefault(msg, 7, false),
        kickParticipant: jspb2.Message.getBooleanFieldWithDefault(msg, 8, false),
        pinParticipant: jspb2.Message.getBooleanFieldWithDefault(msg, 9, false),
        canRecord: jspb2.Message.getBooleanFieldWithDefault(msg, 10, false),
        waitingRoomType: jspb2.Message.getFieldWithDefault(msg, 11, ""),
        plugins: (f = msg.getPlugins()) && proto.socket.PeerPreset.Plugins.toObject(includeInstance, f),
        polls: (f = msg.getPolls()) && proto.socket.PeerPreset.Polls.toObject(includeInstance, f),
        produce: (f = msg.getProduce()) && proto.socket.PeerPreset.Produce.toObject(includeInstance, f),
        chat: (f = msg.getChat()) && proto.socket.PeerPreset.Chat.toObject(includeInstance, f),
        reactions: jspb2.Message.getBooleanFieldWithDefault(msg, 16, false),
        hiddenParticipant: jspb2.Message.getBooleanFieldWithDefault(msg, 17, false),
        showParticipantList: jspb2.Message.getBooleanFieldWithDefault(msg, 18, false),
        canChangeParticipantRole: jspb2.Message.getBooleanFieldWithDefault(msg, 19, false),
        canChangeTheme: jspb2.Message.getBooleanFieldWithDefault(msg, 20, false),
        canPresent: jspb2.Message.getBooleanFieldWithDefault(msg, 21, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.Permissions.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset.Permissions();
    return proto.socket.PeerPreset.Permissions.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.Permissions.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setViewType(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setAcceptWaitingRequests(value);
          break;
        case 3:
          var value = reader.readBool();
          msg.setRequestProduce(value);
          break;
        case 4:
          var value = reader.readBool();
          msg.setCanAllowParticipantAudio(value);
          break;
        case 5:
          var value = reader.readBool();
          msg.setCanAllowParticipantScreensharing(value);
          break;
        case 6:
          var value = reader.readBool();
          msg.setCanAllowParticipantVideo(value);
          break;
        case 7:
          var value = reader.readBool();
          msg.setRequestKickParticipant(value);
          break;
        case 8:
          var value = reader.readBool();
          msg.setKickParticipant(value);
          break;
        case 9:
          var value = reader.readBool();
          msg.setPinParticipant(value);
          break;
        case 10:
          var value = reader.readBool();
          msg.setCanRecord(value);
          break;
        case 11:
          var value = reader.readString();
          msg.setWaitingRoomType(value);
          break;
        case 12:
          var value = new proto.socket.PeerPreset.Plugins();
          reader.readMessage(value, proto.socket.PeerPreset.Plugins.deserializeBinaryFromReader);
          msg.setPlugins(value);
          break;
        case 13:
          var value = new proto.socket.PeerPreset.Polls();
          reader.readMessage(value, proto.socket.PeerPreset.Polls.deserializeBinaryFromReader);
          msg.setPolls(value);
          break;
        case 14:
          var value = new proto.socket.PeerPreset.Produce();
          reader.readMessage(value, proto.socket.PeerPreset.Produce.deserializeBinaryFromReader);
          msg.setProduce(value);
          break;
        case 15:
          var value = new proto.socket.PeerPreset.Chat();
          reader.readMessage(value, proto.socket.PeerPreset.Chat.deserializeBinaryFromReader);
          msg.setChat(value);
          break;
        case 16:
          var value = reader.readBool();
          msg.setReactions(value);
          break;
        case 17:
          var value = reader.readBool();
          msg.setHiddenParticipant(value);
          break;
        case 18:
          var value = reader.readBool();
          msg.setShowParticipantList(value);
          break;
        case 19:
          var value = reader.readBool();
          msg.setCanChangeParticipantRole(value);
          break;
        case 20:
          var value = reader.readBool();
          msg.setCanChangeTheme(value);
          break;
        case 21:
          var value = reader.readBool();
          msg.setCanPresent(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.Permissions.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.Permissions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.Permissions.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getViewType();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getAcceptWaitingRequests();
    if (f) {
      writer.writeBool(2, f);
    }
    f = message2.getRequestProduce();
    if (f) {
      writer.writeBool(3, f);
    }
    f = message2.getCanAllowParticipantAudio();
    if (f) {
      writer.writeBool(4, f);
    }
    f = message2.getCanAllowParticipantScreensharing();
    if (f) {
      writer.writeBool(5, f);
    }
    f = message2.getCanAllowParticipantVideo();
    if (f) {
      writer.writeBool(6, f);
    }
    f = message2.getRequestKickParticipant();
    if (f) {
      writer.writeBool(7, f);
    }
    f = message2.getKickParticipant();
    if (f) {
      writer.writeBool(8, f);
    }
    f = message2.getPinParticipant();
    if (f) {
      writer.writeBool(9, f);
    }
    f = message2.getCanRecord();
    if (f) {
      writer.writeBool(10, f);
    }
    f = message2.getWaitingRoomType();
    if (f.length > 0) {
      writer.writeString(11, f);
    }
    f = message2.getPlugins();
    if (f != null) {
      writer.writeMessage(12, f, proto.socket.PeerPreset.Plugins.serializeBinaryToWriter);
    }
    f = message2.getPolls();
    if (f != null) {
      writer.writeMessage(13, f, proto.socket.PeerPreset.Polls.serializeBinaryToWriter);
    }
    f = message2.getProduce();
    if (f != null) {
      writer.writeMessage(14, f, proto.socket.PeerPreset.Produce.serializeBinaryToWriter);
    }
    f = message2.getChat();
    if (f != null) {
      writer.writeMessage(15, f, proto.socket.PeerPreset.Chat.serializeBinaryToWriter);
    }
    f = message2.getReactions();
    if (f) {
      writer.writeBool(16, f);
    }
    f = message2.getHiddenParticipant();
    if (f) {
      writer.writeBool(17, f);
    }
    f = message2.getShowParticipantList();
    if (f) {
      writer.writeBool(18, f);
    }
    f = message2.getCanChangeParticipantRole();
    if (f) {
      writer.writeBool(19, f);
    }
    f = message2.getCanChangeTheme();
    if (f) {
      writer.writeBool(20, f);
    }
    f = message2.getCanPresent();
    if (f) {
      writer.writeBool(21, f);
    }
  };
  proto.socket.PeerPreset.Permissions.prototype.getViewType = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.PeerPreset.Permissions.prototype.setViewType = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getAcceptWaitingRequests = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setAcceptWaitingRequests = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getRequestProduce = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 3, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setRequestProduce = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 3, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getCanAllowParticipantAudio = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 4, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setCanAllowParticipantAudio = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 4, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getCanAllowParticipantScreensharing = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 5, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setCanAllowParticipantScreensharing = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 5, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getCanAllowParticipantVideo = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 6, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setCanAllowParticipantVideo = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 6, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getRequestKickParticipant = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 7, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setRequestKickParticipant = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 7, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getKickParticipant = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 8, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setKickParticipant = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 8, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getPinParticipant = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 9, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setPinParticipant = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 9, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getCanRecord = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 10, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setCanRecord = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 10, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getWaitingRoomType = function() {
    return jspb2.Message.getFieldWithDefault(this, 11, "");
  };
  proto.socket.PeerPreset.Permissions.prototype.setWaitingRoomType = function(value) {
    return jspb2.Message.setProto3StringField(this, 11, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getPlugins = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.PeerPreset.Plugins, 12);
  };
  proto.socket.PeerPreset.Permissions.prototype.setPlugins = function(value) {
    return jspb2.Message.setWrapperField(this, 12, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.clearPlugins = function() {
    return this.setPlugins(void 0);
  };
  proto.socket.PeerPreset.Permissions.prototype.hasPlugins = function() {
    return jspb2.Message.getField(this, 12) != null;
  };
  proto.socket.PeerPreset.Permissions.prototype.getPolls = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.PeerPreset.Polls, 13);
  };
  proto.socket.PeerPreset.Permissions.prototype.setPolls = function(value) {
    return jspb2.Message.setWrapperField(this, 13, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.clearPolls = function() {
    return this.setPolls(void 0);
  };
  proto.socket.PeerPreset.Permissions.prototype.hasPolls = function() {
    return jspb2.Message.getField(this, 13) != null;
  };
  proto.socket.PeerPreset.Permissions.prototype.getProduce = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.PeerPreset.Produce, 14);
  };
  proto.socket.PeerPreset.Permissions.prototype.setProduce = function(value) {
    return jspb2.Message.setWrapperField(this, 14, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.clearProduce = function() {
    return this.setProduce(void 0);
  };
  proto.socket.PeerPreset.Permissions.prototype.hasProduce = function() {
    return jspb2.Message.getField(this, 14) != null;
  };
  proto.socket.PeerPreset.Permissions.prototype.getChat = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.PeerPreset.Chat, 15);
  };
  proto.socket.PeerPreset.Permissions.prototype.setChat = function(value) {
    return jspb2.Message.setWrapperField(this, 15, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.clearChat = function() {
    return this.setChat(void 0);
  };
  proto.socket.PeerPreset.Permissions.prototype.hasChat = function() {
    return jspb2.Message.getField(this, 15) != null;
  };
  proto.socket.PeerPreset.Permissions.prototype.getReactions = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 16, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setReactions = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 16, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getHiddenParticipant = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 17, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setHiddenParticipant = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 17, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getShowParticipantList = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 18, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setShowParticipantList = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 18, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getCanChangeParticipantRole = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 19, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setCanChangeParticipantRole = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 19, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getCanChangeTheme = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 20, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setCanChangeTheme = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 20, value);
  };
  proto.socket.PeerPreset.Permissions.prototype.getCanPresent = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 21, false);
  };
  proto.socket.PeerPreset.Permissions.prototype.setCanPresent = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 21, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.Preset.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.Preset.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.Preset.toObject = function(includeInstance, msg) {
      var f, obj = {
        permissions: (f = msg.getPermissions()) && proto.socket.PeerPreset.Permissions.toObject(includeInstance, f),
        version: jspb2.Message.getFieldWithDefault(msg, 3, ""),
        presetName: jspb2.Message.getFieldWithDefault(msg, 4, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.Preset.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset.Preset();
    return proto.socket.PeerPreset.Preset.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.Preset.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.PeerPreset.Permissions();
          reader.readMessage(value, proto.socket.PeerPreset.Permissions.deserializeBinaryFromReader);
          msg.setPermissions(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setVersion(value);
          break;
        case 4:
          var value = reader.readString();
          msg.setPresetName(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.Preset.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.Preset.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.Preset.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPermissions();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.PeerPreset.Permissions.serializeBinaryToWriter);
    }
    f = message2.getVersion();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
    f = message2.getPresetName();
    if (f.length > 0) {
      writer.writeString(4, f);
    }
  };
  proto.socket.PeerPreset.Preset.prototype.getPermissions = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.PeerPreset.Permissions, 1);
  };
  proto.socket.PeerPreset.Preset.prototype.setPermissions = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.PeerPreset.Preset.prototype.clearPermissions = function() {
    return this.setPermissions(void 0);
  };
  proto.socket.PeerPreset.Preset.prototype.hasPermissions = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  proto.socket.PeerPreset.Preset.prototype.getVersion = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.socket.PeerPreset.Preset.prototype.setVersion = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  proto.socket.PeerPreset.Preset.prototype.getPresetName = function() {
    return jspb2.Message.getFieldWithDefault(this, 4, "");
  };
  proto.socket.PeerPreset.Preset.prototype.setPresetName = function(value) {
    return jspb2.Message.setProto3StringField(this, 4, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.PeerPreset.Data.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.PeerPreset.Data.toObject(opt_includeInstance, this);
    };
    proto.socket.PeerPreset.Data.toObject = function(includeInstance, msg) {
      var f, obj = {
        preset: (f = msg.getPreset()) && proto.socket.PeerPreset.Preset.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.PeerPreset.Data.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.PeerPreset.Data();
    return proto.socket.PeerPreset.Data.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.PeerPreset.Data.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.PeerPreset.Preset();
          reader.readMessage(value, proto.socket.PeerPreset.Preset.deserializeBinaryFromReader);
          msg.setPreset(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.PeerPreset.Data.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.PeerPreset.Data.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.PeerPreset.Data.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPreset();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.PeerPreset.Preset.serializeBinaryToWriter);
    }
  };
  proto.socket.PeerPreset.Data.prototype.getPreset = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.PeerPreset.Preset, 1);
  };
  proto.socket.PeerPreset.Data.prototype.setPreset = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.PeerPreset.Data.prototype.clearPreset = function() {
    return this.setPreset(void 0);
  };
  proto.socket.PeerPreset.Data.prototype.hasPreset = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  proto.socket.PeerPreset.prototype.getSuccess = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 1, false);
  };
  proto.socket.PeerPreset.prototype.setSuccess = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 1, value);
  };
  proto.socket.PeerPreset.prototype.getMessage = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.PeerPreset.prototype.setMessage = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.PeerPreset.prototype.getData = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.PeerPreset.Data, 3);
  };
  proto.socket.PeerPreset.prototype.setData = function(value) {
    return jspb2.Message.setWrapperField(this, 3, value);
  };
  proto.socket.PeerPreset.prototype.clearData = function() {
    return this.setData(void 0);
  };
  proto.socket.PeerPreset.prototype.hasData = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  goog2.object.extend(exports2, proto.socket);
})(preset_pb);
var chat_pb = {};
var timestamp_pb = {};
(function(exports2) {
  var jspb2 = googleProtobuf$1;
  var goog2 = jspb2;
  var global2 = function() {
    if (this) {
      return this;
    }
    if (typeof window !== "undefined") {
      return window;
    }
    if (typeof global2 !== "undefined") {
      return global2;
    }
    if (typeof self !== "undefined") {
      return self;
    }
    return Function("return this")();
  }.call(null);
  goog2.exportSymbol("proto.google.protobuf.Timestamp", null, global2);
  proto.google.protobuf.Timestamp = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.google.protobuf.Timestamp, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.google.protobuf.Timestamp.displayName = "proto.google.protobuf.Timestamp";
  }
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.google.protobuf.Timestamp.prototype.toObject = function(opt_includeInstance) {
      return proto.google.protobuf.Timestamp.toObject(opt_includeInstance, this);
    };
    proto.google.protobuf.Timestamp.toObject = function(includeInstance, msg) {
      var obj = {
        seconds: jspb2.Message.getFieldWithDefault(msg, 1, 0),
        nanos: jspb2.Message.getFieldWithDefault(msg, 2, 0)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.google.protobuf.Timestamp.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.google.protobuf.Timestamp();
    return proto.google.protobuf.Timestamp.deserializeBinaryFromReader(msg, reader);
  };
  proto.google.protobuf.Timestamp.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readInt64();
          msg.setSeconds(value);
          break;
        case 2:
          var value = reader.readInt32();
          msg.setNanos(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.google.protobuf.Timestamp.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.google.protobuf.Timestamp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.google.protobuf.Timestamp.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getSeconds();
    if (f !== 0) {
      writer.writeInt64(1, f);
    }
    f = message2.getNanos();
    if (f !== 0) {
      writer.writeInt32(2, f);
    }
  };
  proto.google.protobuf.Timestamp.prototype.getSeconds = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, 0);
  };
  proto.google.protobuf.Timestamp.prototype.setSeconds = function(value) {
    return jspb2.Message.setProto3IntField(this, 1, value);
  };
  proto.google.protobuf.Timestamp.prototype.getNanos = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, 0);
  };
  proto.google.protobuf.Timestamp.prototype.setNanos = function(value) {
    return jspb2.Message.setProto3IntField(this, 2, value);
  };
  goog2.object.extend(exports2, proto.google.protobuf);
  proto.google.protobuf.Timestamp.prototype.toDate = function() {
    var seconds = this.getSeconds();
    var nanos = this.getNanos();
    return new Date(seconds * 1e3 + nanos / 1e6);
  };
  proto.google.protobuf.Timestamp.prototype.fromDate = function(value) {
    this.setSeconds(Math.floor(value.getTime() / 1e3));
    this.setNanos(value.getMilliseconds() * 1e6);
  };
  proto.google.protobuf.Timestamp.fromDate = function(value) {
    var timestamp = new proto.google.protobuf.Timestamp();
    timestamp.fromDate(value);
    return timestamp;
  };
})(timestamp_pb);
(function(exports2) {
  var jspb2 = googleProtobuf$1;
  var goog2 = jspb2;
  var global2 = Function("return this")();
  var google_protobuf_timestamp_pb = timestamp_pb;
  goog2.object.extend(proto, google_protobuf_timestamp_pb);
  goog2.exportSymbol("proto.socket.chat.ChatMessage", null, global2);
  goog2.exportSymbol("proto.socket.chat.DeleteChatMessageRequest", null, global2);
  goog2.exportSymbol("proto.socket.chat.DeleteChatMessageResponse", null, global2);
  goog2.exportSymbol("proto.socket.chat.EditChatMessageRequest", null, global2);
  goog2.exportSymbol("proto.socket.chat.EditChatMessageResponse", null, global2);
  goog2.exportSymbol("proto.socket.chat.GetChatMessagesResponse", null, global2);
  goog2.exportSymbol("proto.socket.chat.SendChatMessageToPeersRequest", null, global2);
  goog2.exportSymbol("proto.socket.chat.SendChatMessageToPeersResponse", null, global2);
  goog2.exportSymbol("proto.socket.chat.SendChatMessageToRoomRequest", null, global2);
  goog2.exportSymbol("proto.socket.chat.SendChatMessageToRoomResponse", null, global2);
  proto.socket.chat.ChatMessage = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.chat.ChatMessage, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.chat.ChatMessage.displayName = "proto.socket.chat.ChatMessage";
  }
  proto.socket.chat.GetChatMessagesResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.socket.chat.GetChatMessagesResponse.repeatedFields_, null);
  };
  goog2.inherits(proto.socket.chat.GetChatMessagesResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.chat.GetChatMessagesResponse.displayName = "proto.socket.chat.GetChatMessagesResponse";
  }
  proto.socket.chat.SendChatMessageToRoomRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.chat.SendChatMessageToRoomRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.chat.SendChatMessageToRoomRequest.displayName = "proto.socket.chat.SendChatMessageToRoomRequest";
  }
  proto.socket.chat.SendChatMessageToRoomResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.chat.SendChatMessageToRoomResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.chat.SendChatMessageToRoomResponse.displayName = "proto.socket.chat.SendChatMessageToRoomResponse";
  }
  proto.socket.chat.SendChatMessageToPeersRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.socket.chat.SendChatMessageToPeersRequest.repeatedFields_, null);
  };
  goog2.inherits(proto.socket.chat.SendChatMessageToPeersRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.chat.SendChatMessageToPeersRequest.displayName = "proto.socket.chat.SendChatMessageToPeersRequest";
  }
  proto.socket.chat.SendChatMessageToPeersResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.chat.SendChatMessageToPeersResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.chat.SendChatMessageToPeersResponse.displayName = "proto.socket.chat.SendChatMessageToPeersResponse";
  }
  proto.socket.chat.EditChatMessageRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.chat.EditChatMessageRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.chat.EditChatMessageRequest.displayName = "proto.socket.chat.EditChatMessageRequest";
  }
  proto.socket.chat.EditChatMessageResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.chat.EditChatMessageResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.chat.EditChatMessageResponse.displayName = "proto.socket.chat.EditChatMessageResponse";
  }
  proto.socket.chat.DeleteChatMessageRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.chat.DeleteChatMessageRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.chat.DeleteChatMessageRequest.displayName = "proto.socket.chat.DeleteChatMessageRequest";
  }
  proto.socket.chat.DeleteChatMessageResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.chat.DeleteChatMessageResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.chat.DeleteChatMessageResponse.displayName = "proto.socket.chat.DeleteChatMessageResponse";
  }
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.chat.ChatMessage.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.chat.ChatMessage.toObject(opt_includeInstance, this);
    };
    proto.socket.chat.ChatMessage.toObject = function(includeInstance, msg) {
      var f, obj = {
        chatId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        peerId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        userId: jspb2.Message.getFieldWithDefault(msg, 3, ""),
        displayName: jspb2.Message.getFieldWithDefault(msg, 4, ""),
        pinned: jspb2.Message.getBooleanFieldWithDefault(msg, 5, false),
        isEdited: jspb2.Message.getBooleanFieldWithDefault(msg, 6, false),
        payloadType: jspb2.Message.getFieldWithDefault(msg, 7, 0),
        payload: jspb2.Message.getFieldWithDefault(msg, 8, ""),
        createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.chat.ChatMessage.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.chat.ChatMessage();
    return proto.socket.chat.ChatMessage.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.chat.ChatMessage.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setChatId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setPeerId(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setUserId(value);
          break;
        case 4:
          var value = reader.readString();
          msg.setDisplayName(value);
          break;
        case 5:
          var value = reader.readBool();
          msg.setPinned(value);
          break;
        case 6:
          var value = reader.readBool();
          msg.setIsEdited(value);
          break;
        case 7:
          var value = reader.readInt32();
          msg.setPayloadType(value);
          break;
        case 8:
          var value = reader.readString();
          msg.setPayload(value);
          break;
        case 9:
          var value = new google_protobuf_timestamp_pb.Timestamp();
          reader.readMessage(value, google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
          msg.setCreatedAt(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.chat.ChatMessage.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.chat.ChatMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.chat.ChatMessage.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getChatId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getPeerId();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getUserId();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
    f = message2.getDisplayName();
    if (f.length > 0) {
      writer.writeString(4, f);
    }
    f = message2.getPinned();
    if (f) {
      writer.writeBool(5, f);
    }
    f = message2.getIsEdited();
    if (f) {
      writer.writeBool(6, f);
    }
    f = message2.getPayloadType();
    if (f !== 0) {
      writer.writeInt32(7, f);
    }
    f = message2.getPayload();
    if (f.length > 0) {
      writer.writeString(8, f);
    }
    f = message2.getCreatedAt();
    if (f != null) {
      writer.writeMessage(9, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
    }
  };
  proto.socket.chat.ChatMessage.prototype.getChatId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.chat.ChatMessage.prototype.setChatId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.chat.ChatMessage.prototype.getPeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.chat.ChatMessage.prototype.setPeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.chat.ChatMessage.prototype.getUserId = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.socket.chat.ChatMessage.prototype.setUserId = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  proto.socket.chat.ChatMessage.prototype.getDisplayName = function() {
    return jspb2.Message.getFieldWithDefault(this, 4, "");
  };
  proto.socket.chat.ChatMessage.prototype.setDisplayName = function(value) {
    return jspb2.Message.setProto3StringField(this, 4, value);
  };
  proto.socket.chat.ChatMessage.prototype.getPinned = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 5, false);
  };
  proto.socket.chat.ChatMessage.prototype.setPinned = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 5, value);
  };
  proto.socket.chat.ChatMessage.prototype.getIsEdited = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 6, false);
  };
  proto.socket.chat.ChatMessage.prototype.setIsEdited = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 6, value);
  };
  proto.socket.chat.ChatMessage.prototype.getPayloadType = function() {
    return jspb2.Message.getFieldWithDefault(this, 7, 0);
  };
  proto.socket.chat.ChatMessage.prototype.setPayloadType = function(value) {
    return jspb2.Message.setProto3IntField(this, 7, value);
  };
  proto.socket.chat.ChatMessage.prototype.getPayload = function() {
    return jspb2.Message.getFieldWithDefault(this, 8, "");
  };
  proto.socket.chat.ChatMessage.prototype.setPayload = function(value) {
    return jspb2.Message.setProto3StringField(this, 8, value);
  };
  proto.socket.chat.ChatMessage.prototype.getCreatedAt = function() {
    return jspb2.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9);
  };
  proto.socket.chat.ChatMessage.prototype.setCreatedAt = function(value) {
    return jspb2.Message.setWrapperField(this, 9, value);
  };
  proto.socket.chat.ChatMessage.prototype.clearCreatedAt = function() {
    return this.setCreatedAt(void 0);
  };
  proto.socket.chat.ChatMessage.prototype.hasCreatedAt = function() {
    return jspb2.Message.getField(this, 9) != null;
  };
  proto.socket.chat.GetChatMessagesResponse.repeatedFields_ = [1];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.chat.GetChatMessagesResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.chat.GetChatMessagesResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.chat.GetChatMessagesResponse.toObject = function(includeInstance, msg) {
      var obj = {
        messagesList: jspb2.Message.toObjectList(msg.getMessagesList(), proto.socket.chat.ChatMessage.toObject, includeInstance)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.chat.GetChatMessagesResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.chat.GetChatMessagesResponse();
    return proto.socket.chat.GetChatMessagesResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.chat.GetChatMessagesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.chat.ChatMessage();
          reader.readMessage(value, proto.socket.chat.ChatMessage.deserializeBinaryFromReader);
          msg.addMessages(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.chat.GetChatMessagesResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.chat.GetChatMessagesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.chat.GetChatMessagesResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getMessagesList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(1, f, proto.socket.chat.ChatMessage.serializeBinaryToWriter);
    }
  };
  proto.socket.chat.GetChatMessagesResponse.prototype.getMessagesList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.socket.chat.ChatMessage, 1);
  };
  proto.socket.chat.GetChatMessagesResponse.prototype.setMessagesList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 1, value);
  };
  proto.socket.chat.GetChatMessagesResponse.prototype.addMessages = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.socket.chat.ChatMessage, opt_index);
  };
  proto.socket.chat.GetChatMessagesResponse.prototype.clearMessagesList = function() {
    return this.setMessagesList([]);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.chat.SendChatMessageToRoomRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.chat.SendChatMessageToRoomRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.chat.SendChatMessageToRoomRequest.toObject = function(includeInstance, msg) {
      var obj = {
        payloadType: jspb2.Message.getFieldWithDefault(msg, 1, 0),
        payload: jspb2.Message.getFieldWithDefault(msg, 2, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.chat.SendChatMessageToRoomRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.chat.SendChatMessageToRoomRequest();
    return proto.socket.chat.SendChatMessageToRoomRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.chat.SendChatMessageToRoomRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readInt32();
          msg.setPayloadType(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setPayload(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.chat.SendChatMessageToRoomRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.chat.SendChatMessageToRoomRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.chat.SendChatMessageToRoomRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPayloadType();
    if (f !== 0) {
      writer.writeInt32(1, f);
    }
    f = message2.getPayload();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };
  proto.socket.chat.SendChatMessageToRoomRequest.prototype.getPayloadType = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, 0);
  };
  proto.socket.chat.SendChatMessageToRoomRequest.prototype.setPayloadType = function(value) {
    return jspb2.Message.setProto3IntField(this, 1, value);
  };
  proto.socket.chat.SendChatMessageToRoomRequest.prototype.getPayload = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.chat.SendChatMessageToRoomRequest.prototype.setPayload = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.chat.SendChatMessageToRoomResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.chat.SendChatMessageToRoomResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.chat.SendChatMessageToRoomResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        message: (f = msg.getMessage()) && proto.socket.chat.ChatMessage.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.chat.SendChatMessageToRoomResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.chat.SendChatMessageToRoomResponse();
    return proto.socket.chat.SendChatMessageToRoomResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.chat.SendChatMessageToRoomResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.chat.ChatMessage();
          reader.readMessage(value, proto.socket.chat.ChatMessage.deserializeBinaryFromReader);
          msg.setMessage(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.chat.SendChatMessageToRoomResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.chat.SendChatMessageToRoomResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.chat.SendChatMessageToRoomResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getMessage();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.chat.ChatMessage.serializeBinaryToWriter);
    }
  };
  proto.socket.chat.SendChatMessageToRoomResponse.prototype.getMessage = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.chat.ChatMessage, 1);
  };
  proto.socket.chat.SendChatMessageToRoomResponse.prototype.setMessage = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.chat.SendChatMessageToRoomResponse.prototype.clearMessage = function() {
    return this.setMessage(void 0);
  };
  proto.socket.chat.SendChatMessageToRoomResponse.prototype.hasMessage = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  proto.socket.chat.SendChatMessageToPeersRequest.repeatedFields_ = [1];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.chat.SendChatMessageToPeersRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.chat.SendChatMessageToPeersRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.chat.SendChatMessageToPeersRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        peerIdsList: (f = jspb2.Message.getRepeatedField(msg, 1)) == null ? void 0 : f,
        payloadType: jspb2.Message.getFieldWithDefault(msg, 2, 0),
        payload: jspb2.Message.getFieldWithDefault(msg, 3, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.chat.SendChatMessageToPeersRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.chat.SendChatMessageToPeersRequest();
    return proto.socket.chat.SendChatMessageToPeersRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.chat.SendChatMessageToPeersRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.addPeerIds(value);
          break;
        case 2:
          var value = reader.readInt32();
          msg.setPayloadType(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setPayload(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.chat.SendChatMessageToPeersRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.chat.SendChatMessageToPeersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.chat.SendChatMessageToPeersRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPeerIdsList();
    if (f.length > 0) {
      writer.writeRepeatedString(1, f);
    }
    f = message2.getPayloadType();
    if (f !== 0) {
      writer.writeInt32(2, f);
    }
    f = message2.getPayload();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
  };
  proto.socket.chat.SendChatMessageToPeersRequest.prototype.getPeerIdsList = function() {
    return jspb2.Message.getRepeatedField(this, 1);
  };
  proto.socket.chat.SendChatMessageToPeersRequest.prototype.setPeerIdsList = function(value) {
    return jspb2.Message.setField(this, 1, value || []);
  };
  proto.socket.chat.SendChatMessageToPeersRequest.prototype.addPeerIds = function(value, opt_index) {
    return jspb2.Message.addToRepeatedField(this, 1, value, opt_index);
  };
  proto.socket.chat.SendChatMessageToPeersRequest.prototype.clearPeerIdsList = function() {
    return this.setPeerIdsList([]);
  };
  proto.socket.chat.SendChatMessageToPeersRequest.prototype.getPayloadType = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, 0);
  };
  proto.socket.chat.SendChatMessageToPeersRequest.prototype.setPayloadType = function(value) {
    return jspb2.Message.setProto3IntField(this, 2, value);
  };
  proto.socket.chat.SendChatMessageToPeersRequest.prototype.getPayload = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.socket.chat.SendChatMessageToPeersRequest.prototype.setPayload = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.chat.SendChatMessageToPeersResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.chat.SendChatMessageToPeersResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.chat.SendChatMessageToPeersResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        message: (f = msg.getMessage()) && proto.socket.chat.ChatMessage.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.chat.SendChatMessageToPeersResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.chat.SendChatMessageToPeersResponse();
    return proto.socket.chat.SendChatMessageToPeersResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.chat.SendChatMessageToPeersResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.chat.ChatMessage();
          reader.readMessage(value, proto.socket.chat.ChatMessage.deserializeBinaryFromReader);
          msg.setMessage(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.chat.SendChatMessageToPeersResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.chat.SendChatMessageToPeersResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.chat.SendChatMessageToPeersResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getMessage();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.chat.ChatMessage.serializeBinaryToWriter);
    }
  };
  proto.socket.chat.SendChatMessageToPeersResponse.prototype.getMessage = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.chat.ChatMessage, 1);
  };
  proto.socket.chat.SendChatMessageToPeersResponse.prototype.setMessage = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.chat.SendChatMessageToPeersResponse.prototype.clearMessage = function() {
    return this.setMessage(void 0);
  };
  proto.socket.chat.SendChatMessageToPeersResponse.prototype.hasMessage = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.chat.EditChatMessageRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.chat.EditChatMessageRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.chat.EditChatMessageRequest.toObject = function(includeInstance, msg) {
      var obj = {
        chatId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        payloadType: jspb2.Message.getFieldWithDefault(msg, 2, 0),
        payload: jspb2.Message.getFieldWithDefault(msg, 3, ""),
        pinned: jspb2.Message.getBooleanFieldWithDefault(msg, 4, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.chat.EditChatMessageRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.chat.EditChatMessageRequest();
    return proto.socket.chat.EditChatMessageRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.chat.EditChatMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setChatId(value);
          break;
        case 2:
          var value = reader.readInt32();
          msg.setPayloadType(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setPayload(value);
          break;
        case 4:
          var value = reader.readBool();
          msg.setPinned(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.chat.EditChatMessageRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.chat.EditChatMessageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.chat.EditChatMessageRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getChatId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = jspb2.Message.getField(message2, 2);
    if (f != null) {
      writer.writeInt32(2, f);
    }
    f = jspb2.Message.getField(message2, 3);
    if (f != null) {
      writer.writeString(3, f);
    }
    f = jspb2.Message.getField(message2, 4);
    if (f != null) {
      writer.writeBool(4, f);
    }
  };
  proto.socket.chat.EditChatMessageRequest.prototype.getChatId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.chat.EditChatMessageRequest.prototype.setChatId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.chat.EditChatMessageRequest.prototype.getPayloadType = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, 0);
  };
  proto.socket.chat.EditChatMessageRequest.prototype.setPayloadType = function(value) {
    return jspb2.Message.setField(this, 2, value);
  };
  proto.socket.chat.EditChatMessageRequest.prototype.clearPayloadType = function() {
    return jspb2.Message.setField(this, 2, void 0);
  };
  proto.socket.chat.EditChatMessageRequest.prototype.hasPayloadType = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  proto.socket.chat.EditChatMessageRequest.prototype.getPayload = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.socket.chat.EditChatMessageRequest.prototype.setPayload = function(value) {
    return jspb2.Message.setField(this, 3, value);
  };
  proto.socket.chat.EditChatMessageRequest.prototype.clearPayload = function() {
    return jspb2.Message.setField(this, 3, void 0);
  };
  proto.socket.chat.EditChatMessageRequest.prototype.hasPayload = function() {
    return jspb2.Message.getField(this, 3) != null;
  };
  proto.socket.chat.EditChatMessageRequest.prototype.getPinned = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 4, false);
  };
  proto.socket.chat.EditChatMessageRequest.prototype.setPinned = function(value) {
    return jspb2.Message.setField(this, 4, value);
  };
  proto.socket.chat.EditChatMessageRequest.prototype.clearPinned = function() {
    return jspb2.Message.setField(this, 4, void 0);
  };
  proto.socket.chat.EditChatMessageRequest.prototype.hasPinned = function() {
    return jspb2.Message.getField(this, 4) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.chat.EditChatMessageResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.chat.EditChatMessageResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.chat.EditChatMessageResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        message: (f = msg.getMessage()) && proto.socket.chat.ChatMessage.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.chat.EditChatMessageResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.chat.EditChatMessageResponse();
    return proto.socket.chat.EditChatMessageResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.chat.EditChatMessageResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.chat.ChatMessage();
          reader.readMessage(value, proto.socket.chat.ChatMessage.deserializeBinaryFromReader);
          msg.setMessage(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.chat.EditChatMessageResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.chat.EditChatMessageResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.chat.EditChatMessageResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getMessage();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.chat.ChatMessage.serializeBinaryToWriter);
    }
  };
  proto.socket.chat.EditChatMessageResponse.prototype.getMessage = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.chat.ChatMessage, 1);
  };
  proto.socket.chat.EditChatMessageResponse.prototype.setMessage = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.chat.EditChatMessageResponse.prototype.clearMessage = function() {
    return this.setMessage(void 0);
  };
  proto.socket.chat.EditChatMessageResponse.prototype.hasMessage = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.chat.DeleteChatMessageRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.chat.DeleteChatMessageRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.chat.DeleteChatMessageRequest.toObject = function(includeInstance, msg) {
      var obj = {
        chatId: jspb2.Message.getFieldWithDefault(msg, 1, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.chat.DeleteChatMessageRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.chat.DeleteChatMessageRequest();
    return proto.socket.chat.DeleteChatMessageRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.chat.DeleteChatMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setChatId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.chat.DeleteChatMessageRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.chat.DeleteChatMessageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.chat.DeleteChatMessageRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getChatId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
  };
  proto.socket.chat.DeleteChatMessageRequest.prototype.getChatId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.chat.DeleteChatMessageRequest.prototype.setChatId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.chat.DeleteChatMessageResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.chat.DeleteChatMessageResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.chat.DeleteChatMessageResponse.toObject = function(includeInstance, msg) {
      var obj = {
        chatId: jspb2.Message.getFieldWithDefault(msg, 1, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.chat.DeleteChatMessageResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.chat.DeleteChatMessageResponse();
    return proto.socket.chat.DeleteChatMessageResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.chat.DeleteChatMessageResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setChatId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.chat.DeleteChatMessageResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.chat.DeleteChatMessageResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.chat.DeleteChatMessageResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getChatId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
  };
  proto.socket.chat.DeleteChatMessageResponse.prototype.getChatId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.chat.DeleteChatMessageResponse.prototype.setChatId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  goog2.object.extend(exports2, proto.socket.chat);
})(chat_pb);
var room_pb = {};
(function(exports2) {
  var jspb2 = googleProtobuf$1;
  var goog2 = jspb2;
  var global2 = Function("return this")();
  var socket_preset_pb = preset_pb;
  goog2.object.extend(proto, socket_preset_pb);
  goog2.exportSymbol("proto.socket.room.GetPeerInfoRequest", null, global2);
  goog2.exportSymbol("proto.socket.room.JoinRoomRequest", null, global2);
  goog2.exportSymbol("proto.socket.room.LeaveRoomRequest", null, global2);
  goog2.exportSymbol("proto.socket.room.Peer", null, global2);
  goog2.exportSymbol("proto.socket.room.PeerInfoResponse", null, global2);
  goog2.exportSymbol("proto.socket.room.Room", null, global2);
  goog2.exportSymbol("proto.socket.room.RoomInfoResponse", null, global2);
  goog2.exportSymbol("proto.socket.room.RoomPeersInfoResponse", null, global2);
  goog2.exportSymbol("proto.socket.room.UpdatePeerInfoRequest", null, global2);
  goog2.exportSymbol("proto.socket.room.UpdateRoomInfoRequest", null, global2);
  proto.socket.room.Peer = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.room.Peer, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.room.Peer.displayName = "proto.socket.room.Peer";
  }
  proto.socket.room.PeerInfoResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.room.PeerInfoResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.room.PeerInfoResponse.displayName = "proto.socket.room.PeerInfoResponse";
  }
  proto.socket.room.RoomPeersInfoResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.socket.room.RoomPeersInfoResponse.repeatedFields_, null);
  };
  goog2.inherits(proto.socket.room.RoomPeersInfoResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.room.RoomPeersInfoResponse.displayName = "proto.socket.room.RoomPeersInfoResponse";
  }
  proto.socket.room.Room = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.room.Room, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.room.Room.displayName = "proto.socket.room.Room";
  }
  proto.socket.room.RoomInfoResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.room.RoomInfoResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.room.RoomInfoResponse.displayName = "proto.socket.room.RoomInfoResponse";
  }
  proto.socket.room.GetPeerInfoRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.room.GetPeerInfoRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.room.GetPeerInfoRequest.displayName = "proto.socket.room.GetPeerInfoRequest";
  }
  proto.socket.room.UpdatePeerInfoRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.room.UpdatePeerInfoRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.room.UpdatePeerInfoRequest.displayName = "proto.socket.room.UpdatePeerInfoRequest";
  }
  proto.socket.room.JoinRoomRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.room.JoinRoomRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.room.JoinRoomRequest.displayName = "proto.socket.room.JoinRoomRequest";
  }
  proto.socket.room.LeaveRoomRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.room.LeaveRoomRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.room.LeaveRoomRequest.displayName = "proto.socket.room.LeaveRoomRequest";
  }
  proto.socket.room.UpdateRoomInfoRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.room.UpdateRoomInfoRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.room.UpdateRoomInfoRequest.displayName = "proto.socket.room.UpdateRoomInfoRequest";
  }
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.room.Peer.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.room.Peer.toObject(opt_includeInstance, this);
    };
    proto.socket.room.Peer.toObject = function(includeInstance, msg) {
      var obj = {
        peerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        userId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        displayName: jspb2.Message.getFieldWithDefault(msg, 3, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.room.Peer.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.room.Peer();
    return proto.socket.room.Peer.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.room.Peer.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPeerId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setUserId(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setDisplayName(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.room.Peer.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.room.Peer.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.room.Peer.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPeerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getUserId();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getDisplayName();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
  };
  proto.socket.room.Peer.prototype.getPeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.room.Peer.prototype.setPeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.room.Peer.prototype.getUserId = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.room.Peer.prototype.setUserId = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.room.Peer.prototype.getDisplayName = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.socket.room.Peer.prototype.setDisplayName = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.room.PeerInfoResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.room.PeerInfoResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.room.PeerInfoResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        peer: (f = msg.getPeer()) && proto.socket.room.Peer.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.room.PeerInfoResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.room.PeerInfoResponse();
    return proto.socket.room.PeerInfoResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.room.PeerInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.room.Peer();
          reader.readMessage(value, proto.socket.room.Peer.deserializeBinaryFromReader);
          msg.setPeer(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.room.PeerInfoResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.room.PeerInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.room.PeerInfoResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPeer();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.room.Peer.serializeBinaryToWriter);
    }
  };
  proto.socket.room.PeerInfoResponse.prototype.getPeer = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.room.Peer, 1);
  };
  proto.socket.room.PeerInfoResponse.prototype.setPeer = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.room.PeerInfoResponse.prototype.clearPeer = function() {
    return this.setPeer(void 0);
  };
  proto.socket.room.PeerInfoResponse.prototype.hasPeer = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  proto.socket.room.RoomPeersInfoResponse.repeatedFields_ = [1];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.room.RoomPeersInfoResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.room.RoomPeersInfoResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.room.RoomPeersInfoResponse.toObject = function(includeInstance, msg) {
      var obj = {
        peersList: jspb2.Message.toObjectList(msg.getPeersList(), proto.socket.room.Peer.toObject, includeInstance)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.room.RoomPeersInfoResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.room.RoomPeersInfoResponse();
    return proto.socket.room.RoomPeersInfoResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.room.RoomPeersInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.room.Peer();
          reader.readMessage(value, proto.socket.room.Peer.deserializeBinaryFromReader);
          msg.addPeers(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.room.RoomPeersInfoResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.room.RoomPeersInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.room.RoomPeersInfoResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPeersList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(1, f, proto.socket.room.Peer.serializeBinaryToWriter);
    }
  };
  proto.socket.room.RoomPeersInfoResponse.prototype.getPeersList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.socket.room.Peer, 1);
  };
  proto.socket.room.RoomPeersInfoResponse.prototype.setPeersList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 1, value);
  };
  proto.socket.room.RoomPeersInfoResponse.prototype.addPeers = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.socket.room.Peer, opt_index);
  };
  proto.socket.room.RoomPeersInfoResponse.prototype.clearPeersList = function() {
    return this.setPeersList([]);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.room.Room.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.room.Room.toObject(opt_includeInstance, this);
    };
    proto.socket.room.Room.toObject = function(includeInstance, msg) {
      var obj = {
        roomId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        title: jspb2.Message.getFieldWithDefault(msg, 2, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.room.Room.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.room.Room();
    return proto.socket.room.Room.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.room.Room.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setRoomId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setTitle(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.room.Room.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.room.Room.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.room.Room.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getRoomId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getTitle();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };
  proto.socket.room.Room.prototype.getRoomId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.room.Room.prototype.setRoomId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.room.Room.prototype.getTitle = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.room.Room.prototype.setTitle = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.room.RoomInfoResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.room.RoomInfoResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.room.RoomInfoResponse.toObject = function(includeInstance, msg) {
      var f, obj = {
        room: (f = msg.getRoom()) && proto.socket.room.Room.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.room.RoomInfoResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.room.RoomInfoResponse();
    return proto.socket.room.RoomInfoResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.room.RoomInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.room.Room();
          reader.readMessage(value, proto.socket.room.Room.deserializeBinaryFromReader);
          msg.setRoom(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.room.RoomInfoResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.room.RoomInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.room.RoomInfoResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getRoom();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.room.Room.serializeBinaryToWriter);
    }
  };
  proto.socket.room.RoomInfoResponse.prototype.getRoom = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.room.Room, 1);
  };
  proto.socket.room.RoomInfoResponse.prototype.setRoom = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.room.RoomInfoResponse.prototype.clearRoom = function() {
    return this.setRoom(void 0);
  };
  proto.socket.room.RoomInfoResponse.prototype.hasRoom = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.room.GetPeerInfoRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.room.GetPeerInfoRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.room.GetPeerInfoRequest.toObject = function(includeInstance, msg) {
      var obj = {
        peerId: jspb2.Message.getFieldWithDefault(msg, 1, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.room.GetPeerInfoRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.room.GetPeerInfoRequest();
    return proto.socket.room.GetPeerInfoRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.room.GetPeerInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPeerId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.room.GetPeerInfoRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.room.GetPeerInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.room.GetPeerInfoRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPeerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
  };
  proto.socket.room.GetPeerInfoRequest.prototype.getPeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.room.GetPeerInfoRequest.prototype.setPeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.room.UpdatePeerInfoRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.room.UpdatePeerInfoRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.room.UpdatePeerInfoRequest.toObject = function(includeInstance, msg) {
      var obj = {
        peerId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        displayName: jspb2.Message.getFieldWithDefault(msg, 2, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.room.UpdatePeerInfoRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.room.UpdatePeerInfoRequest();
    return proto.socket.room.UpdatePeerInfoRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.room.UpdatePeerInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPeerId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setDisplayName(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.room.UpdatePeerInfoRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.room.UpdatePeerInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.room.UpdatePeerInfoRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPeerId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = jspb2.Message.getField(message2, 2);
    if (f != null) {
      writer.writeString(2, f);
    }
  };
  proto.socket.room.UpdatePeerInfoRequest.prototype.getPeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.room.UpdatePeerInfoRequest.prototype.setPeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.room.UpdatePeerInfoRequest.prototype.getDisplayName = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.room.UpdatePeerInfoRequest.prototype.setDisplayName = function(value) {
    return jspb2.Message.setField(this, 2, value);
  };
  proto.socket.room.UpdatePeerInfoRequest.prototype.clearDisplayName = function() {
    return jspb2.Message.setField(this, 2, void 0);
  };
  proto.socket.room.UpdatePeerInfoRequest.prototype.hasDisplayName = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.room.JoinRoomRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.room.JoinRoomRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.room.JoinRoomRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        peer: (f = msg.getPeer()) && proto.socket.room.Peer.toObject(includeInstance, f),
        preset: (f = msg.getPreset()) && socket_preset_pb.PeerPreset.toObject(includeInstance, f),
        roomUuid: jspb2.Message.getFieldWithDefault(msg, 3, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.room.JoinRoomRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.room.JoinRoomRequest();
    return proto.socket.room.JoinRoomRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.room.JoinRoomRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.room.Peer();
          reader.readMessage(value, proto.socket.room.Peer.deserializeBinaryFromReader);
          msg.setPeer(value);
          break;
        case 2:
          var value = new socket_preset_pb.PeerPreset();
          reader.readMessage(value, socket_preset_pb.PeerPreset.deserializeBinaryFromReader);
          msg.setPreset(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setRoomUuid(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.room.JoinRoomRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.room.JoinRoomRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.room.JoinRoomRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPeer();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.room.Peer.serializeBinaryToWriter);
    }
    f = message2.getPreset();
    if (f != null) {
      writer.writeMessage(2, f, socket_preset_pb.PeerPreset.serializeBinaryToWriter);
    }
    f = message2.getRoomUuid();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
  };
  proto.socket.room.JoinRoomRequest.prototype.getPeer = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.room.Peer, 1);
  };
  proto.socket.room.JoinRoomRequest.prototype.setPeer = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.room.JoinRoomRequest.prototype.clearPeer = function() {
    return this.setPeer(void 0);
  };
  proto.socket.room.JoinRoomRequest.prototype.hasPeer = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  proto.socket.room.JoinRoomRequest.prototype.getPreset = function() {
    return jspb2.Message.getWrapperField(this, socket_preset_pb.PeerPreset, 2);
  };
  proto.socket.room.JoinRoomRequest.prototype.setPreset = function(value) {
    return jspb2.Message.setWrapperField(this, 2, value);
  };
  proto.socket.room.JoinRoomRequest.prototype.clearPreset = function() {
    return this.setPreset(void 0);
  };
  proto.socket.room.JoinRoomRequest.prototype.hasPreset = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  proto.socket.room.JoinRoomRequest.prototype.getRoomUuid = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.socket.room.JoinRoomRequest.prototype.setRoomUuid = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.room.LeaveRoomRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.room.LeaveRoomRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.room.LeaveRoomRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        peer: (f = msg.getPeer()) && proto.socket.room.Peer.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.room.LeaveRoomRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.room.LeaveRoomRequest();
    return proto.socket.room.LeaveRoomRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.room.LeaveRoomRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.room.Peer();
          reader.readMessage(value, proto.socket.room.Peer.deserializeBinaryFromReader);
          msg.setPeer(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.room.LeaveRoomRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.room.LeaveRoomRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.room.LeaveRoomRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPeer();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.room.Peer.serializeBinaryToWriter);
    }
  };
  proto.socket.room.LeaveRoomRequest.prototype.getPeer = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.room.Peer, 1);
  };
  proto.socket.room.LeaveRoomRequest.prototype.setPeer = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.room.LeaveRoomRequest.prototype.clearPeer = function() {
    return this.setPeer(void 0);
  };
  proto.socket.room.LeaveRoomRequest.prototype.hasPeer = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.room.UpdateRoomInfoRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.room.UpdateRoomInfoRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.room.UpdateRoomInfoRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        room: (f = msg.getRoom()) && proto.socket.room.Room.toObject(includeInstance, f)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.room.UpdateRoomInfoRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.room.UpdateRoomInfoRequest();
    return proto.socket.room.UpdateRoomInfoRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.room.UpdateRoomInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.room.Room();
          reader.readMessage(value, proto.socket.room.Room.deserializeBinaryFromReader);
          msg.setRoom(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.room.UpdateRoomInfoRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.room.UpdateRoomInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.room.UpdateRoomInfoRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getRoom();
    if (f != null) {
      writer.writeMessage(1, f, proto.socket.room.Room.serializeBinaryToWriter);
    }
  };
  proto.socket.room.UpdateRoomInfoRequest.prototype.getRoom = function() {
    return jspb2.Message.getWrapperField(this, proto.socket.room.Room, 1);
  };
  proto.socket.room.UpdateRoomInfoRequest.prototype.setRoom = function(value) {
    return jspb2.Message.setWrapperField(this, 1, value);
  };
  proto.socket.room.UpdateRoomInfoRequest.prototype.clearRoom = function() {
    return this.setRoom(void 0);
  };
  proto.socket.room.UpdateRoomInfoRequest.prototype.hasRoom = function() {
    return jspb2.Message.getField(this, 1) != null;
  };
  goog2.object.extend(exports2, proto.socket.room);
})(room_pb);
var plugin_pb = {};
(function(exports2) {
  var jspb2 = googleProtobuf$1;
  var goog2 = jspb2;
  var global2 = Function("return this")();
  goog2.exportSymbol("proto.socket.plugin.AddPluginRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.DisablePluginForPeersRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.DisablePluginForRoomRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.DisablePluginResponse", null, global2);
  goog2.exportSymbol("proto.socket.plugin.EnablePluginForPeersRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.EnablePluginForRoomRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.EnablePluginResponse", null, global2);
  goog2.exportSymbol("proto.socket.plugin.EnablePluginsResponse", null, global2);
  goog2.exportSymbol("proto.socket.plugin.PluginEventResponse", null, global2);
  goog2.exportSymbol("proto.socket.plugin.PluginEventToPeersRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.PluginEventToRoomRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.PluginStoreDeleteKeysRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.PluginStoreDeleteRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.PluginStoreGetKeysRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.PluginStoreInsertKeysRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.PluginStoreItem", null, global2);
  goog2.exportSymbol("proto.socket.plugin.PluginStoreResponse", null, global2);
  goog2.exportSymbol("proto.socket.plugin.RemovePluginRequest", null, global2);
  goog2.exportSymbol("proto.socket.plugin.StoreKeys", null, global2);
  proto.socket.plugin.AddPluginRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.plugin.AddPluginRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.AddPluginRequest.displayName = "proto.socket.plugin.AddPluginRequest";
  }
  proto.socket.plugin.RemovePluginRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.plugin.RemovePluginRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.RemovePluginRequest.displayName = "proto.socket.plugin.RemovePluginRequest";
  }
  proto.socket.plugin.EnablePluginForRoomRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.plugin.EnablePluginForRoomRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.EnablePluginForRoomRequest.displayName = "proto.socket.plugin.EnablePluginForRoomRequest";
  }
  proto.socket.plugin.DisablePluginForRoomRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.plugin.DisablePluginForRoomRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.DisablePluginForRoomRequest.displayName = "proto.socket.plugin.DisablePluginForRoomRequest";
  }
  proto.socket.plugin.EnablePluginForPeersRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.socket.plugin.EnablePluginForPeersRequest.repeatedFields_, null);
  };
  goog2.inherits(proto.socket.plugin.EnablePluginForPeersRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.EnablePluginForPeersRequest.displayName = "proto.socket.plugin.EnablePluginForPeersRequest";
  }
  proto.socket.plugin.DisablePluginForPeersRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.socket.plugin.DisablePluginForPeersRequest.repeatedFields_, null);
  };
  goog2.inherits(proto.socket.plugin.DisablePluginForPeersRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.DisablePluginForPeersRequest.displayName = "proto.socket.plugin.DisablePluginForPeersRequest";
  }
  proto.socket.plugin.PluginEventToRoomRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.plugin.PluginEventToRoomRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.PluginEventToRoomRequest.displayName = "proto.socket.plugin.PluginEventToRoomRequest";
  }
  proto.socket.plugin.PluginEventToPeersRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.socket.plugin.PluginEventToPeersRequest.repeatedFields_, null);
  };
  goog2.inherits(proto.socket.plugin.PluginEventToPeersRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.PluginEventToPeersRequest.displayName = "proto.socket.plugin.PluginEventToPeersRequest";
  }
  proto.socket.plugin.StoreKeys = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.plugin.StoreKeys, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.StoreKeys.displayName = "proto.socket.plugin.StoreKeys";
  }
  proto.socket.plugin.PluginStoreInsertKeysRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.socket.plugin.PluginStoreInsertKeysRequest.repeatedFields_, null);
  };
  goog2.inherits(proto.socket.plugin.PluginStoreInsertKeysRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.PluginStoreInsertKeysRequest.displayName = "proto.socket.plugin.PluginStoreInsertKeysRequest";
  }
  proto.socket.plugin.PluginStoreGetKeysRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.socket.plugin.PluginStoreGetKeysRequest.repeatedFields_, null);
  };
  goog2.inherits(proto.socket.plugin.PluginStoreGetKeysRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.PluginStoreGetKeysRequest.displayName = "proto.socket.plugin.PluginStoreGetKeysRequest";
  }
  proto.socket.plugin.PluginStoreDeleteKeysRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.socket.plugin.PluginStoreDeleteKeysRequest.repeatedFields_, null);
  };
  goog2.inherits(proto.socket.plugin.PluginStoreDeleteKeysRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.PluginStoreDeleteKeysRequest.displayName = "proto.socket.plugin.PluginStoreDeleteKeysRequest";
  }
  proto.socket.plugin.PluginStoreDeleteRequest = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.plugin.PluginStoreDeleteRequest, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.PluginStoreDeleteRequest.displayName = "proto.socket.plugin.PluginStoreDeleteRequest";
  }
  proto.socket.plugin.EnablePluginResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.plugin.EnablePluginResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.EnablePluginResponse.displayName = "proto.socket.plugin.EnablePluginResponse";
  }
  proto.socket.plugin.EnablePluginsResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.socket.plugin.EnablePluginsResponse.repeatedFields_, null);
  };
  goog2.inherits(proto.socket.plugin.EnablePluginsResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.EnablePluginsResponse.displayName = "proto.socket.plugin.EnablePluginsResponse";
  }
  proto.socket.plugin.DisablePluginResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.plugin.DisablePluginResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.DisablePluginResponse.displayName = "proto.socket.plugin.DisablePluginResponse";
  }
  proto.socket.plugin.PluginStoreItem = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.plugin.PluginStoreItem, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.PluginStoreItem.displayName = "proto.socket.plugin.PluginStoreItem";
  }
  proto.socket.plugin.PluginStoreResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, proto.socket.plugin.PluginStoreResponse.repeatedFields_, null);
  };
  goog2.inherits(proto.socket.plugin.PluginStoreResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.PluginStoreResponse.displayName = "proto.socket.plugin.PluginStoreResponse";
  }
  proto.socket.plugin.PluginEventResponse = function(opt_data) {
    jspb2.Message.initialize(this, opt_data, 0, -1, null, null);
  };
  goog2.inherits(proto.socket.plugin.PluginEventResponse, jspb2.Message);
  if (goog2.DEBUG && !COMPILED) {
    proto.socket.plugin.PluginEventResponse.displayName = "proto.socket.plugin.PluginEventResponse";
  }
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.AddPluginRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.AddPluginRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.AddPluginRequest.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        staggered: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.AddPluginRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.AddPluginRequest();
    return proto.socket.plugin.AddPluginRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.AddPluginRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setStaggered(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.AddPluginRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.AddPluginRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.AddPluginRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getStaggered();
    if (f) {
      writer.writeBool(2, f);
    }
  };
  proto.socket.plugin.AddPluginRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.AddPluginRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.AddPluginRequest.prototype.getStaggered = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.socket.plugin.AddPluginRequest.prototype.setStaggered = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.RemovePluginRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.RemovePluginRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.RemovePluginRequest.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        staggered: jspb2.Message.getBooleanFieldWithDefault(msg, 2, false)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.RemovePluginRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.RemovePluginRequest();
    return proto.socket.plugin.RemovePluginRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.RemovePluginRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readBool();
          msg.setStaggered(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.RemovePluginRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.RemovePluginRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.RemovePluginRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getStaggered();
    if (f) {
      writer.writeBool(2, f);
    }
  };
  proto.socket.plugin.RemovePluginRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.RemovePluginRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.RemovePluginRequest.prototype.getStaggered = function() {
    return jspb2.Message.getBooleanFieldWithDefault(this, 2, false);
  };
  proto.socket.plugin.RemovePluginRequest.prototype.setStaggered = function(value) {
    return jspb2.Message.setProto3BooleanField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.EnablePluginForRoomRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.EnablePluginForRoomRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.EnablePluginForRoomRequest.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.EnablePluginForRoomRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.EnablePluginForRoomRequest();
    return proto.socket.plugin.EnablePluginForRoomRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.EnablePluginForRoomRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.EnablePluginForRoomRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.EnablePluginForRoomRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.EnablePluginForRoomRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
  };
  proto.socket.plugin.EnablePluginForRoomRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.EnablePluginForRoomRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.DisablePluginForRoomRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.DisablePluginForRoomRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.DisablePluginForRoomRequest.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.DisablePluginForRoomRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.DisablePluginForRoomRequest();
    return proto.socket.plugin.DisablePluginForRoomRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.DisablePluginForRoomRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.DisablePluginForRoomRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.DisablePluginForRoomRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.DisablePluginForRoomRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
  };
  proto.socket.plugin.DisablePluginForRoomRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.DisablePluginForRoomRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.EnablePluginForPeersRequest.repeatedFields_ = [2];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.EnablePluginForPeersRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.EnablePluginForPeersRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.EnablePluginForPeersRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        peerIdsList: (f = jspb2.Message.getRepeatedField(msg, 2)) == null ? void 0 : f
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.EnablePluginForPeersRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.EnablePluginForPeersRequest();
    return proto.socket.plugin.EnablePluginForPeersRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.EnablePluginForPeersRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.addPeerIds(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.EnablePluginForPeersRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.EnablePluginForPeersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.EnablePluginForPeersRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getPeerIdsList();
    if (f.length > 0) {
      writer.writeRepeatedString(2, f);
    }
  };
  proto.socket.plugin.EnablePluginForPeersRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.EnablePluginForPeersRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.EnablePluginForPeersRequest.prototype.getPeerIdsList = function() {
    return jspb2.Message.getRepeatedField(this, 2);
  };
  proto.socket.plugin.EnablePluginForPeersRequest.prototype.setPeerIdsList = function(value) {
    return jspb2.Message.setField(this, 2, value || []);
  };
  proto.socket.plugin.EnablePluginForPeersRequest.prototype.addPeerIds = function(value, opt_index) {
    return jspb2.Message.addToRepeatedField(this, 2, value, opt_index);
  };
  proto.socket.plugin.EnablePluginForPeersRequest.prototype.clearPeerIdsList = function() {
    return this.setPeerIdsList([]);
  };
  proto.socket.plugin.DisablePluginForPeersRequest.repeatedFields_ = [2];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.DisablePluginForPeersRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.DisablePluginForPeersRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.DisablePluginForPeersRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        peerIdsList: (f = jspb2.Message.getRepeatedField(msg, 2)) == null ? void 0 : f
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.DisablePluginForPeersRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.DisablePluginForPeersRequest();
    return proto.socket.plugin.DisablePluginForPeersRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.DisablePluginForPeersRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.addPeerIds(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.DisablePluginForPeersRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.DisablePluginForPeersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.DisablePluginForPeersRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getPeerIdsList();
    if (f.length > 0) {
      writer.writeRepeatedString(2, f);
    }
  };
  proto.socket.plugin.DisablePluginForPeersRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.DisablePluginForPeersRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.DisablePluginForPeersRequest.prototype.getPeerIdsList = function() {
    return jspb2.Message.getRepeatedField(this, 2);
  };
  proto.socket.plugin.DisablePluginForPeersRequest.prototype.setPeerIdsList = function(value) {
    return jspb2.Message.setField(this, 2, value || []);
  };
  proto.socket.plugin.DisablePluginForPeersRequest.prototype.addPeerIds = function(value, opt_index) {
    return jspb2.Message.addToRepeatedField(this, 2, value, opt_index);
  };
  proto.socket.plugin.DisablePluginForPeersRequest.prototype.clearPeerIdsList = function() {
    return this.setPeerIdsList([]);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.PluginEventToRoomRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.PluginEventToRoomRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.PluginEventToRoomRequest.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        pluginData: msg.getPluginData_asB64()
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.PluginEventToRoomRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.PluginEventToRoomRequest();
    return proto.socket.plugin.PluginEventToRoomRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.PluginEventToRoomRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readBytes();
          msg.setPluginData(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.PluginEventToRoomRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.PluginEventToRoomRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.PluginEventToRoomRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getPluginData_asU8();
    if (f.length > 0) {
      writer.writeBytes(2, f);
    }
  };
  proto.socket.plugin.PluginEventToRoomRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.PluginEventToRoomRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.PluginEventToRoomRequest.prototype.getPluginData = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.plugin.PluginEventToRoomRequest.prototype.getPluginData_asB64 = function() {
    return jspb2.Message.bytesAsB64(this.getPluginData());
  };
  proto.socket.plugin.PluginEventToRoomRequest.prototype.getPluginData_asU8 = function() {
    return jspb2.Message.bytesAsU8(this.getPluginData());
  };
  proto.socket.plugin.PluginEventToRoomRequest.prototype.setPluginData = function(value) {
    return jspb2.Message.setProto3BytesField(this, 2, value);
  };
  proto.socket.plugin.PluginEventToPeersRequest.repeatedFields_ = [2];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.PluginEventToPeersRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.PluginEventToPeersRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.PluginEventToPeersRequest.toObject = function(includeInstance, msg) {
      var f, obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        peerIdsList: (f = jspb2.Message.getRepeatedField(msg, 2)) == null ? void 0 : f,
        pluginData: msg.getPluginData_asB64()
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.PluginEventToPeersRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.PluginEventToPeersRequest();
    return proto.socket.plugin.PluginEventToPeersRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.PluginEventToPeersRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.addPeerIds(value);
          break;
        case 3:
          var value = reader.readBytes();
          msg.setPluginData(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.PluginEventToPeersRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.PluginEventToPeersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.PluginEventToPeersRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getPeerIdsList();
    if (f.length > 0) {
      writer.writeRepeatedString(2, f);
    }
    f = message2.getPluginData_asU8();
    if (f.length > 0) {
      writer.writeBytes(3, f);
    }
  };
  proto.socket.plugin.PluginEventToPeersRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.PluginEventToPeersRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.PluginEventToPeersRequest.prototype.getPeerIdsList = function() {
    return jspb2.Message.getRepeatedField(this, 2);
  };
  proto.socket.plugin.PluginEventToPeersRequest.prototype.setPeerIdsList = function(value) {
    return jspb2.Message.setField(this, 2, value || []);
  };
  proto.socket.plugin.PluginEventToPeersRequest.prototype.addPeerIds = function(value, opt_index) {
    return jspb2.Message.addToRepeatedField(this, 2, value, opt_index);
  };
  proto.socket.plugin.PluginEventToPeersRequest.prototype.clearPeerIdsList = function() {
    return this.setPeerIdsList([]);
  };
  proto.socket.plugin.PluginEventToPeersRequest.prototype.getPluginData = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.socket.plugin.PluginEventToPeersRequest.prototype.getPluginData_asB64 = function() {
    return jspb2.Message.bytesAsB64(this.getPluginData());
  };
  proto.socket.plugin.PluginEventToPeersRequest.prototype.getPluginData_asU8 = function() {
    return jspb2.Message.bytesAsU8(this.getPluginData());
  };
  proto.socket.plugin.PluginEventToPeersRequest.prototype.setPluginData = function(value) {
    return jspb2.Message.setProto3BytesField(this, 3, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.StoreKeys.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.StoreKeys.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.StoreKeys.toObject = function(includeInstance, msg) {
      var obj = {
        storeKey: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        payload: msg.getPayload_asB64()
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.StoreKeys.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.StoreKeys();
    return proto.socket.plugin.StoreKeys.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.StoreKeys.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setStoreKey(value);
          break;
        case 2:
          var value = reader.readBytes();
          msg.setPayload(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.StoreKeys.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.StoreKeys.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.StoreKeys.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getStoreKey();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = jspb2.Message.getField(message2, 2);
    if (f != null) {
      writer.writeBytes(2, f);
    }
  };
  proto.socket.plugin.StoreKeys.prototype.getStoreKey = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.StoreKeys.prototype.setStoreKey = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.StoreKeys.prototype.getPayload = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.plugin.StoreKeys.prototype.getPayload_asB64 = function() {
    return jspb2.Message.bytesAsB64(this.getPayload());
  };
  proto.socket.plugin.StoreKeys.prototype.getPayload_asU8 = function() {
    return jspb2.Message.bytesAsU8(this.getPayload());
  };
  proto.socket.plugin.StoreKeys.prototype.setPayload = function(value) {
    return jspb2.Message.setField(this, 2, value);
  };
  proto.socket.plugin.StoreKeys.prototype.clearPayload = function() {
    return jspb2.Message.setField(this, 2, void 0);
  };
  proto.socket.plugin.StoreKeys.prototype.hasPayload = function() {
    return jspb2.Message.getField(this, 2) != null;
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.repeatedFields_ = [3];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.PluginStoreInsertKeysRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.PluginStoreInsertKeysRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.PluginStoreInsertKeysRequest.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        storeName: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        insertKeysList: jspb2.Message.toObjectList(msg.getInsertKeysList(), proto.socket.plugin.StoreKeys.toObject, includeInstance)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.PluginStoreInsertKeysRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.PluginStoreInsertKeysRequest();
    return proto.socket.plugin.PluginStoreInsertKeysRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setStoreName(value);
          break;
        case 3:
          var value = new proto.socket.plugin.StoreKeys();
          reader.readMessage(value, proto.socket.plugin.StoreKeys.deserializeBinaryFromReader);
          msg.addInsertKeys(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.PluginStoreInsertKeysRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getStoreName();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getInsertKeysList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(3, f, proto.socket.plugin.StoreKeys.serializeBinaryToWriter);
    }
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.prototype.getStoreName = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.prototype.setStoreName = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.prototype.getInsertKeysList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.socket.plugin.StoreKeys, 3);
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.prototype.setInsertKeysList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 3, value);
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.prototype.addInsertKeys = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.socket.plugin.StoreKeys, opt_index);
  };
  proto.socket.plugin.PluginStoreInsertKeysRequest.prototype.clearInsertKeysList = function() {
    return this.setInsertKeysList([]);
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.repeatedFields_ = [3];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.PluginStoreGetKeysRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.PluginStoreGetKeysRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.PluginStoreGetKeysRequest.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        storeName: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        getKeysList: jspb2.Message.toObjectList(msg.getGetKeysList(), proto.socket.plugin.StoreKeys.toObject, includeInstance)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.PluginStoreGetKeysRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.PluginStoreGetKeysRequest();
    return proto.socket.plugin.PluginStoreGetKeysRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setStoreName(value);
          break;
        case 3:
          var value = new proto.socket.plugin.StoreKeys();
          reader.readMessage(value, proto.socket.plugin.StoreKeys.deserializeBinaryFromReader);
          msg.addGetKeys(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.PluginStoreGetKeysRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getStoreName();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getGetKeysList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(3, f, proto.socket.plugin.StoreKeys.serializeBinaryToWriter);
    }
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.prototype.getStoreName = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.prototype.setStoreName = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.prototype.getGetKeysList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.socket.plugin.StoreKeys, 3);
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.prototype.setGetKeysList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 3, value);
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.prototype.addGetKeys = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.socket.plugin.StoreKeys, opt_index);
  };
  proto.socket.plugin.PluginStoreGetKeysRequest.prototype.clearGetKeysList = function() {
    return this.setGetKeysList([]);
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.repeatedFields_ = [3];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.PluginStoreDeleteKeysRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.PluginStoreDeleteKeysRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.PluginStoreDeleteKeysRequest.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        storeName: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        deleteKeysList: jspb2.Message.toObjectList(msg.getDeleteKeysList(), proto.socket.plugin.StoreKeys.toObject, includeInstance)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.PluginStoreDeleteKeysRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.PluginStoreDeleteKeysRequest();
    return proto.socket.plugin.PluginStoreDeleteKeysRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setStoreName(value);
          break;
        case 3:
          var value = new proto.socket.plugin.StoreKeys();
          reader.readMessage(value, proto.socket.plugin.StoreKeys.deserializeBinaryFromReader);
          msg.addDeleteKeys(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.PluginStoreDeleteKeysRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getStoreName();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getDeleteKeysList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(3, f, proto.socket.plugin.StoreKeys.serializeBinaryToWriter);
    }
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.prototype.getStoreName = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.prototype.setStoreName = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.prototype.getDeleteKeysList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.socket.plugin.StoreKeys, 3);
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.prototype.setDeleteKeysList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 3, value);
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.prototype.addDeleteKeys = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.socket.plugin.StoreKeys, opt_index);
  };
  proto.socket.plugin.PluginStoreDeleteKeysRequest.prototype.clearDeleteKeysList = function() {
    return this.setDeleteKeysList([]);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.PluginStoreDeleteRequest.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.PluginStoreDeleteRequest.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.PluginStoreDeleteRequest.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        storeName: jspb2.Message.getFieldWithDefault(msg, 2, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.PluginStoreDeleteRequest.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.PluginStoreDeleteRequest();
    return proto.socket.plugin.PluginStoreDeleteRequest.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.PluginStoreDeleteRequest.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setStoreName(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.PluginStoreDeleteRequest.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.PluginStoreDeleteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.PluginStoreDeleteRequest.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getStoreName();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };
  proto.socket.plugin.PluginStoreDeleteRequest.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.PluginStoreDeleteRequest.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.PluginStoreDeleteRequest.prototype.getStoreName = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.plugin.PluginStoreDeleteRequest.prototype.setStoreName = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.EnablePluginResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.EnablePluginResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.EnablePluginResponse.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        enabledBy: jspb2.Message.getFieldWithDefault(msg, 2, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.EnablePluginResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.EnablePluginResponse();
    return proto.socket.plugin.EnablePluginResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.EnablePluginResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setEnabledBy(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.EnablePluginResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.EnablePluginResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.EnablePluginResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getEnabledBy();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };
  proto.socket.plugin.EnablePluginResponse.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.EnablePluginResponse.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.EnablePluginResponse.prototype.getEnabledBy = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.plugin.EnablePluginResponse.prototype.setEnabledBy = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.plugin.EnablePluginsResponse.repeatedFields_ = [1];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.EnablePluginsResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.EnablePluginsResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.EnablePluginsResponse.toObject = function(includeInstance, msg) {
      var obj = {
        pluginsList: jspb2.Message.toObjectList(msg.getPluginsList(), proto.socket.plugin.EnablePluginResponse.toObject, includeInstance)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.EnablePluginsResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.EnablePluginsResponse();
    return proto.socket.plugin.EnablePluginsResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.EnablePluginsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.socket.plugin.EnablePluginResponse();
          reader.readMessage(value, proto.socket.plugin.EnablePluginResponse.deserializeBinaryFromReader);
          msg.addPlugins(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.EnablePluginsResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.EnablePluginsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.EnablePluginsResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginsList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(1, f, proto.socket.plugin.EnablePluginResponse.serializeBinaryToWriter);
    }
  };
  proto.socket.plugin.EnablePluginsResponse.prototype.getPluginsList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.socket.plugin.EnablePluginResponse, 1);
  };
  proto.socket.plugin.EnablePluginsResponse.prototype.setPluginsList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 1, value);
  };
  proto.socket.plugin.EnablePluginsResponse.prototype.addPlugins = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.socket.plugin.EnablePluginResponse, opt_index);
  };
  proto.socket.plugin.EnablePluginsResponse.prototype.clearPluginsList = function() {
    return this.setPluginsList([]);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.DisablePluginResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.DisablePluginResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.DisablePluginResponse.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        disabledBy: jspb2.Message.getFieldWithDefault(msg, 2, "")
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.DisablePluginResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.DisablePluginResponse();
    return proto.socket.plugin.DisablePluginResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.DisablePluginResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setDisabledBy(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.DisablePluginResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.DisablePluginResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.DisablePluginResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getDisabledBy();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
  };
  proto.socket.plugin.DisablePluginResponse.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.DisablePluginResponse.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.DisablePluginResponse.prototype.getDisabledBy = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.plugin.DisablePluginResponse.prototype.setDisabledBy = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.PluginStoreItem.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.PluginStoreItem.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.PluginStoreItem.toObject = function(includeInstance, msg) {
      var obj = {
        timestamp: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        peerId: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        storeKey: jspb2.Message.getFieldWithDefault(msg, 3, ""),
        payload: msg.getPayload_asB64()
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.PluginStoreItem.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.PluginStoreItem();
    return proto.socket.plugin.PluginStoreItem.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.PluginStoreItem.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setTimestamp(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setPeerId(value);
          break;
        case 3:
          var value = reader.readString();
          msg.setStoreKey(value);
          break;
        case 4:
          var value = reader.readBytes();
          msg.setPayload(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.PluginStoreItem.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.PluginStoreItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.PluginStoreItem.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getTimestamp();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getPeerId();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getStoreKey();
    if (f.length > 0) {
      writer.writeString(3, f);
    }
    f = message2.getPayload_asU8();
    if (f.length > 0) {
      writer.writeBytes(4, f);
    }
  };
  proto.socket.plugin.PluginStoreItem.prototype.getTimestamp = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.PluginStoreItem.prototype.setTimestamp = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.PluginStoreItem.prototype.getPeerId = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.plugin.PluginStoreItem.prototype.setPeerId = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.plugin.PluginStoreItem.prototype.getStoreKey = function() {
    return jspb2.Message.getFieldWithDefault(this, 3, "");
  };
  proto.socket.plugin.PluginStoreItem.prototype.setStoreKey = function(value) {
    return jspb2.Message.setProto3StringField(this, 3, value);
  };
  proto.socket.plugin.PluginStoreItem.prototype.getPayload = function() {
    return jspb2.Message.getFieldWithDefault(this, 4, "");
  };
  proto.socket.plugin.PluginStoreItem.prototype.getPayload_asB64 = function() {
    return jspb2.Message.bytesAsB64(this.getPayload());
  };
  proto.socket.plugin.PluginStoreItem.prototype.getPayload_asU8 = function() {
    return jspb2.Message.bytesAsU8(this.getPayload());
  };
  proto.socket.plugin.PluginStoreItem.prototype.setPayload = function(value) {
    return jspb2.Message.setProto3BytesField(this, 4, value);
  };
  proto.socket.plugin.PluginStoreResponse.repeatedFields_ = [3];
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.PluginStoreResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.PluginStoreResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.PluginStoreResponse.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        storeName: jspb2.Message.getFieldWithDefault(msg, 2, ""),
        storeItemsList: jspb2.Message.toObjectList(msg.getStoreItemsList(), proto.socket.plugin.PluginStoreItem.toObject, includeInstance)
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.PluginStoreResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.PluginStoreResponse();
    return proto.socket.plugin.PluginStoreResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.PluginStoreResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readString();
          msg.setStoreName(value);
          break;
        case 3:
          var value = new proto.socket.plugin.PluginStoreItem();
          reader.readMessage(value, proto.socket.plugin.PluginStoreItem.deserializeBinaryFromReader);
          msg.addStoreItems(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.PluginStoreResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.PluginStoreResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.PluginStoreResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getStoreName();
    if (f.length > 0) {
      writer.writeString(2, f);
    }
    f = message2.getStoreItemsList();
    if (f.length > 0) {
      writer.writeRepeatedMessage(3, f, proto.socket.plugin.PluginStoreItem.serializeBinaryToWriter);
    }
  };
  proto.socket.plugin.PluginStoreResponse.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.PluginStoreResponse.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.PluginStoreResponse.prototype.getStoreName = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.plugin.PluginStoreResponse.prototype.setStoreName = function(value) {
    return jspb2.Message.setProto3StringField(this, 2, value);
  };
  proto.socket.plugin.PluginStoreResponse.prototype.getStoreItemsList = function() {
    return jspb2.Message.getRepeatedWrapperField(this, proto.socket.plugin.PluginStoreItem, 3);
  };
  proto.socket.plugin.PluginStoreResponse.prototype.setStoreItemsList = function(value) {
    return jspb2.Message.setRepeatedWrapperField(this, 3, value);
  };
  proto.socket.plugin.PluginStoreResponse.prototype.addStoreItems = function(opt_value, opt_index) {
    return jspb2.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.socket.plugin.PluginStoreItem, opt_index);
  };
  proto.socket.plugin.PluginStoreResponse.prototype.clearStoreItemsList = function() {
    return this.setStoreItemsList([]);
  };
  if (jspb2.Message.GENERATE_TO_OBJECT) {
    proto.socket.plugin.PluginEventResponse.prototype.toObject = function(opt_includeInstance) {
      return proto.socket.plugin.PluginEventResponse.toObject(opt_includeInstance, this);
    };
    proto.socket.plugin.PluginEventResponse.toObject = function(includeInstance, msg) {
      var obj = {
        pluginId: jspb2.Message.getFieldWithDefault(msg, 1, ""),
        pluginData: msg.getPluginData_asB64()
      };
      if (includeInstance) {
        obj.$jspbMessageInstance = msg;
      }
      return obj;
    };
  }
  proto.socket.plugin.PluginEventResponse.deserializeBinary = function(bytes) {
    var reader = new jspb2.BinaryReader(bytes);
    var msg = new proto.socket.plugin.PluginEventResponse();
    return proto.socket.plugin.PluginEventResponse.deserializeBinaryFromReader(msg, reader);
  };
  proto.socket.plugin.PluginEventResponse.deserializeBinaryFromReader = function(msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = reader.readString();
          msg.setPluginId(value);
          break;
        case 2:
          var value = reader.readBytes();
          msg.setPluginData(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };
  proto.socket.plugin.PluginEventResponse.prototype.serializeBinary = function() {
    var writer = new jspb2.BinaryWriter();
    proto.socket.plugin.PluginEventResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  };
  proto.socket.plugin.PluginEventResponse.serializeBinaryToWriter = function(message2, writer) {
    var f = void 0;
    f = message2.getPluginId();
    if (f.length > 0) {
      writer.writeString(1, f);
    }
    f = message2.getPluginData_asU8();
    if (f.length > 0) {
      writer.writeBytes(2, f);
    }
  };
  proto.socket.plugin.PluginEventResponse.prototype.getPluginId = function() {
    return jspb2.Message.getFieldWithDefault(this, 1, "");
  };
  proto.socket.plugin.PluginEventResponse.prototype.setPluginId = function(value) {
    return jspb2.Message.setProto3StringField(this, 1, value);
  };
  proto.socket.plugin.PluginEventResponse.prototype.getPluginData = function() {
    return jspb2.Message.getFieldWithDefault(this, 2, "");
  };
  proto.socket.plugin.PluginEventResponse.prototype.getPluginData_asB64 = function() {
    return jspb2.Message.bytesAsB64(this.getPluginData());
  };
  proto.socket.plugin.PluginEventResponse.prototype.getPluginData_asU8 = function() {
    return jspb2.Message.bytesAsU8(this.getPluginData());
  };
  proto.socket.plugin.PluginEventResponse.prototype.setPluginData = function(value) {
    return jspb2.Message.setProto3BytesField(this, 2, value);
  };
  goog2.object.extend(exports2, proto.socket.plugin);
})(plugin_pb);
(function(exports2) {
  var __createBinding = commonjsGlobal$1 && commonjsGlobal$1.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = commonjsGlobal$1 && commonjsGlobal$1.__exportStar || function(m, exports3) {
    for (var p in m)
      if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p))
        __createBinding(exports3, m, p);
  };
  Object.defineProperty(exports2, "__esModule", { value: true });
  __exportStar(client_edge_pb, exports2);
  __exportStar(common_pb, exports2);
  __exportStar(edge_hub_pb, exports2);
  __exportStar(hub_node_grpc_web_pb, exports2);
  __exportStar(hub_node_pb, exports2);
  __exportStar(api_pb, exports2);
  __exportStar(preset_pb, exports2);
  __exportStar(chat_pb, exports2);
  __exportStar(room_pb, exports2);
  __exportStar(plugin_pb, exports2);
})(dist);
const roomMessageBase = 0;
const chatMessageBase = 1;
const pluginMessageBase = 2;
const roomEventSlugs = {
  getPeerInfo: 0,
  updatePeerInfo: 1,
  getRoomPeersInfo: 2,
  joinRoom: 3,
  leaveRoom: 4,
  getRoomInfo: 5,
  updateRoomInfo: 6,
  closeRoom: 7
};
const chatEventSlugs = {
  getMessages: 0,
  sendMessageToRoom: 1,
  sendMessageToPeers: 2,
  editMessage: 3,
  deleteMessage: 4
};
const pluginEventSlugs = {
  getPlugins: 0,
  addPlugin: 1,
  enablePluginForRoom: 2,
  disablePluginForPeers: 3,
  enablePluginForPeers: 4,
  disablePluginForRoom: 5,
  removePlugin: 6,
  customPluginEventToRoom: 7,
  customPluginEventToPeers: 8,
  storeInsertKeys: 9,
  storeGetKeys: 10,
  storeDeleteKeys: 11,
  storeDelete: 12
};
function generateEvents(base, slugs) {
  return Object.keys(slugs).reduce((acc, key) => {
    acc[key] = (base << 16) + slugs[key];
    return acc;
  }, {});
}
const roomEvents = generateEvents(roomMessageBase, roomEventSlugs);
const chatEvents = generateEvents(chatMessageBase, chatEventSlugs);
const pluginEvents = generateEvents(pluginMessageBase, pluginEventSlugs);
class RoomSocketHandler {
  constructor(socketService) {
    __publicField(this, "socket");
    this.socket = socketService;
    this.setupEvents();
  }
  setupEvents() {
    this.socket.onStateEvent("disconnected", ({ reason, code: code2 }) => {
      log.info(`Disconnected from room: [${code2}] ${reason}`);
    });
  }
  set onReconnect(fn) {
    this.socket.onStateEvent("reconnected", fn);
  }
  joinRoom(displayName, peerId, userId, roomUUID) {
    this.socket.sendMessage(roomEvents.joinRoom, new dist.JoinRoomRequest().setPeer(new dist.Peer().setDisplayName(displayName).setPeerId(peerId).setUserId(userId)).setRoomUuid(roomUUID));
  }
  leaveRoom() {
    this.socket.sendMessage(roomEvents.leaveRoom, new dist.LeaveRoomRequest());
  }
}
var ViewType;
(function(ViewType2) {
  ViewType2["groupCall"] = "GROUPCALL";
  ViewType2["webinar"] = "WEBINAR";
  ViewType2["audioRoom"] = "AUDIO_ROOM";
})(ViewType || (ViewType = {}));
var MediaThemeQuality;
(function(MediaThemeQuality2) {
  MediaThemeQuality2[MediaThemeQuality2["hd"] = 0] = "hd";
  MediaThemeQuality2[MediaThemeQuality2["vga"] = 1] = "vga";
  MediaThemeQuality2[MediaThemeQuality2["qvga"] = 2] = "qvga";
})(MediaThemeQuality || (MediaThemeQuality = {}));
const DEFAULT_THEME_SNAKE_CASED = {
  waiting_room: { is_enabled: false, enable_preview: true },
  view_type: ViewType.groupCall,
  max_video_streams: { mobile: 4, desktop: 12 },
  max_screen_share_count: 2,
  media: {
    video: {
      quality: 0,
      frame_rate: 123
    },
    screenshare: {
      quality: 0,
      frame_rate: 5
    }
  }
};
const DEFAULT_THEME_CAMEL_CASED = objectToCamelCase(DEFAULT_THEME_SNAKE_CASED);
const _DyteThemePreset = class {
  constructor(presetTheme) {
    __privateAdd2(this, _theme3, void 0);
    if (!presetTheme) {
      throw new DyteError("Could not load preset theme.");
    }
    __privateSet2(this, _theme3, presetTheme);
    DyteTelemetry.addEventInCurrentSpan("debug", "preset_theme", {
      theme: __privateGet2(this, _theme3)
    });
  }
  static fromResponse(theme) {
    return new _DyteThemePreset(theme);
  }
  static default() {
    return new _DyteThemePreset(DEFAULT_THEME_CAMEL_CASED);
  }
  get waitingRoom() {
    return __privateGet2(this, _theme3).waitingRoom;
  }
  get viewType() {
    return __privateGet2(this, _theme3).viewType;
  }
  get maxVideoStreams() {
    return __privateGet2(this, _theme3).maxVideoStreams;
  }
  get maxScreenShareCount() {
    return __privateGet2(this, _theme3).maxScreenShareCount;
  }
};
let DyteThemePreset = _DyteThemePreset;
_theme3 = new WeakMap();
var __defProp$b = Object.defineProperty;
var __getOwnPropDesc$b = Object.getOwnPropertyDescriptor;
var __decorateClass$b = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$b(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$b(target, key, result);
  return result;
};
const _SelfController = (_e = class {
  constructor(socketService, roomNodeClient, self2) {
    __publicField(this, "self");
    __publicField(this, "authToken");
    __publicField(this, "peerId");
    __privateAdd2(this, _socketService, void 0);
    __privateAdd2(this, _roomNodeClient2, void 0);
    __privateSet2(this, _socketService, socketService);
    __privateSet2(this, _roomNodeClient2, roomNodeClient);
    this.authToken = roomNodeClient.authToken;
    this.peerId = roomNodeClient.peerId;
    this.self = self2;
    this.setupEvents();
  }
  static async init(socketService, roomNodeClient, options, localMediaHandler) {
    var _a3, _b2;
    const { defaults, modules } = options;
    const APIClient2 = getAPIClient();
    const userResponse = await APIClient2.getUserDetails();
    const { isV2AuthToken } = constants;
    let permissions = isV2AuthToken ? DytePermissionsPreset.default() : DytePermissionsPresetV1.default();
    let theme = isV2AuthToken ? DyteThemePreset.default() : DyteThemePresetV1.default();
    const modulePermissions = (_a3 = modules.permissions) != null ? _a3 : true;
    const moduleTheme = (_b2 = modules.theme) != null ? _b2 : true;
    if (modulePermissions || moduleTheme) {
      const userPreset = isV2AuthToken ? void 0 : await APIClient2.getUserPreset(roomNodeClient.roomName);
      if (modulePermissions) {
        permissions = isV2AuthToken ? DytePermissionsPreset.fromResponse(userResponse.preset.permissions) : DytePermissionsPresetV1.fromResponse(userPreset.permissions);
      }
      if (moduleTheme) {
        theme = isV2AuthToken ? DyteThemePreset.fromResponse(userResponse.preset.theme) : DyteThemePresetV1.fromResponse(userPreset.theme);
      }
    }
    const self2 = await DyteSelf.init(roomNodeClient, constants.isV2AuthToken ? userResponse.participant : userResponse, permissions, theme, defaults, localMediaHandler);
    const organizationId = isV2AuthToken ? userResponse.participant.organizationId : userResponse.organizationId;
    DyteTelemetry.meetingMetadata.organizationId = organizationId;
    await dist$1.globalFlagsmith.identify(`${FlagsmithIdentifierPrefix.PEER}_${roomNodeClient.peerId}`, JSON.parse(JSON.stringify(__spreadValues({
      entity: FlagsmithIdentifierPrefix.PEER,
      clientId: organizationId,
      isAnonUser: !organizationId,
      sdkVersion: WEB_CORE_VERSION,
      roomName: roomNodeClient.roomName
    }, browserSpecs.getDeviceInfo()))));
    DyteTelemetry.addEventInCurrentSpan("info", "flagsmith::allFlags", { flags: dist$1.globalFlagsmith.getAllFlags() }, true);
    if (dist$1.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.INTERNAL_CALL_STATS) && navigator.product !== "ReactNative") {
      setTimeout(async () => {
        callStats.initialize({
          peerId: roomNodeClient.peerId,
          engineName: browserSpecs.getDeviceInfo().engineName,
          env: "production",
          iceServers: await APIClient2.getICEServers(),
          apiBase: config.apiBase
        });
      });
    }
    return new _SelfController(socketService, roomNodeClient, self2);
  }
  async shareMediaTracks() {
    return Promise.all([
      this.self.videoTrack && __privateGet2(this, _roomNodeClient2).shareWebcam(this.self.videoTrack),
      this.self.audioTrack && __privateGet2(this, _roomNodeClient2).shareMic(this.self.audioTrack)
    ]);
  }
  setupEvents() {
    SessionStore.on(SessionEvents.DISABLE_AUDIO, async () => {
      if (this.self.audioEnabled) {
        await this.self.disableAudio();
        callStats.audioOff();
      }
    });
    SessionStore.on(SessionEvents.DISABLE_VIDEO, async () => {
      if (this.self.videoEnabled) {
        await this.self.disableVideo();
        callStats.videoOff();
      }
    });
    SessionStore.on(SessionEvents.MUTE_ALL, async () => {
      if (this.self.audioEnabled) {
        await this.self.disableAudio();
        callStats.audioOff();
      }
    });
    SessionStore.on(SessionEvents.MUTE_ALL_VIDEO, async () => {
      if (this.self.videoEnabled) {
        await this.self.disableVideo();
        callStats.videoOff();
      }
    });
    SessionStore.on(SessionEvents.WAITLISTED, () => {
      this.self.waitlistStatus = "waiting";
      this.self.emit("waitlisted");
    });
    SessionStore.on(SessionEvents.WAITLIST_ACCEPTED, async () => {
      this.self.waitlistStatus = "accepted";
      this.joinRoom();
    });
    SessionStore.on(SessionEvents.WAITLIST_REJECTED, async () => {
      this.self.waitlistStatus = "rejected";
      this.leaveRoom("rejected");
    });
    SessionStore.on(SessionEvents.KICKED, async (payload) => {
      let state = "kicked";
      if ((payload == null ? void 0 : payload.kickType) === "kickAll")
        state = "ended";
      this.leaveRoom(state);
    });
    SessionStore.on(SessionEvents.SELF_ROOM_JOINED, () => {
      this.self.emit("roomJoined");
    });
    SessionStore.on(SessionEvents.MEDIA_PERMISSION_ERROR, async (payload) => {
      this.self.emit("mediaPermissionError", payload);
    });
  }
  async joinRoom() {
    var _a3, _b2;
    if (__privateGet2(this, _roomNodeClient2).isDisconnected) {
      __privateGet2(this, _roomNodeClient2).reconnect();
      return;
    }
    const roomState = await __privateGet2(this, _roomNodeClient2).getRoomState();
    const APIClient2 = getAPIClient();
    const { roomUUID } = (_b2 = (_a3 = roomState == null ? void 0 : roomState.payload) == null ? void 0 : _a3.roomState) != null ? _b2 : {};
    APIClient2.setRoomUUID(roomUUID);
    if (!constants.isV2AuthToken) {
      const roomSocketHandler = new RoomSocketHandler(__privateGet2(this, _socketService));
      roomSocketHandler.joinRoom(this.self.name, this.self.id, this.self.userId, roomUUID);
      roomSocketHandler.onReconnect = () => {
        roomSocketHandler.joinRoom(this.self.name, this.self.id, this.self.userId, roomUUID);
      };
    }
    await __privateGet2(this, _roomNodeClient2).joinRoom(this.self.name, !this.self.audioEnabled, roomUUID, void 0, {
      audio: this.self.audioEnabled,
      video: this.self.videoEnabled,
      screen: this.self.screenShareEnabled
    });
    await this.shareMediaTracks();
  }
  async leaveRoom(state = "left") {
    __privateGet2(this, _socketService).disconnect();
    await __privateGet2(this, _roomNodeClient2).leaveRoom();
    __privateGet2(this, _roomNodeClient2).roomJoined = false;
    this.self.emit("roomLeft", { state });
  }
}, _socketService = new WeakMap(), _roomNodeClient2 = new WeakMap(), _e);
let SelfController = _SelfController;
__decorateClass$b([
  DyteTelemetry.trace("SelfController.setupEvents")
], SelfController.prototype, "setupEvents", 1);
__decorateClass$b([
  DyteTelemetry.trace("SelfController.joinRoom")
], SelfController.prototype, "joinRoom", 1);
__decorateClass$b([
  DyteTelemetry.trace("SelfController.leaveRoom")
], SelfController.prototype, "leaveRoom", 1);
var __defProp$a = Object.defineProperty;
var __getOwnPropDesc$a = Object.getOwnPropertyDescriptor;
var __decorateClass$a = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$a(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$a(target, key, result);
  return result;
};
class DyteParticipant extends DyteEventEmitter {
  constructor(participant, self2, roomNodeClient) {
    super();
    __publicField(this, "id");
    __publicField(this, "userId");
    __publicField(this, "name");
    __publicField(this, "picture");
    __publicField(this, "isHost");
    __publicField(this, "clientSpecificId");
    __publicField(this, "flags");
    __publicField(this, "device");
    __publicField(this, "videoTrack");
    __publicField(this, "audioTrack");
    __publicField(this, "screenShareTracks");
    __publicField(this, "videoEnabled");
    __publicField(this, "audioEnabled");
    __publicField(this, "screenShareEnabled");
    __privateAdd2(this, _isPinned2, void 0);
    __publicField(this, "supportsRemoteControl", false);
    __privateAdd2(this, _roomNodeClient3, void 0);
    __privateAdd2(this, _self, void 0);
    const {
      id,
      userId,
      displayName: name,
      device,
      picture,
      isHost,
      flags,
      clientSpecificId,
      audioMuted,
      audioTrack,
      videoEnabled = false,
      videoTrack
    } = participant;
    this.id = id;
    this.userId = userId;
    this.name = name;
    this.device = device;
    this.picture = picture;
    this.isHost = isHost;
    this.flags = flags;
    this.clientSpecificId = clientSpecificId;
    this.audioEnabled = !audioMuted;
    this.audioTrack = audioTrack;
    this.videoEnabled = videoEnabled;
    this.videoTrack = videoTrack;
    this.screenShareTracks = {
      audio: void 0,
      video: void 0
    };
    __privateSet2(this, _isPinned2, false);
    __privateSet2(this, _self, self2);
    __privateSet2(this, _roomNodeClient3, roomNodeClient);
  }
  setVideoEnabled(videoEnabled, emitEvent = true) {
    var _a3;
    this.videoEnabled = videoEnabled;
    if (!emitEvent)
      return;
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipant::setVideoEnabled::videoUpdate", {
      audioEnabled: this.videoEnabled,
      trackId: (_a3 = this.videoTrack) == null ? void 0 : _a3.id
    });
    this.emit("videoUpdate", {
      videoEnabled: this.videoEnabled,
      videoTrack: this.videoTrack
    });
  }
  setAudioEnabled(audioEnabled, emitEvent = true) {
    var _a3;
    this.audioEnabled = audioEnabled;
    if (!emitEvent)
      return;
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipant::setAudioEnabled::audioUpdate", {
      audioEnabled: this.audioEnabled,
      trackId: (_a3 = this.audioTrack) == null ? void 0 : _a3.id
    });
    this.emit("audioUpdate", {
      audioEnabled: this.audioEnabled,
      audioTrack: this.audioTrack
    });
  }
  setScreenShareEnabled(screenShareEnabled, emitEvent = true) {
    this.screenShareEnabled = screenShareEnabled;
    if (!emitEvent)
      return;
    this.emit("screenShareUpdate", {
      screenShareEnabled: this.screenShareEnabled,
      screenShareTracks: this.screenShareTracks
    });
  }
  async pin() {
    return __privateGet2(this, _roomNodeClient3).pinPeer(this.id);
  }
  async unpin() {
    return __privateGet2(this, _roomNodeClient3).pinPeer(null);
  }
  setIsPinned(isPinned, emitEvent = true) {
    __privateSet2(this, _isPinned2, isPinned);
    const event = isPinned ? "pinned" : "unpinned";
    if (emitEvent)
      this.emit(event, this);
  }
  async disableAudio() {
    const peerId = this.id;
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipant::disable_audio", { peerId });
    if (__privateGet2(this, _self).permissions.canAllowParticipantAudio) {
      return __privateGet2(this, _roomNodeClient3).disableAudio(peerId);
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipant::unauthorized_disable_audio", { peerId });
    throw new DyteError("Unauthorized: User does not have permission to disable participant audio.");
  }
  async kick() {
    const peerId = this.id;
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipant::kick", { peerId });
    if (__privateGet2(this, _self).permissions.kickParticipant) {
      return __privateGet2(this, _roomNodeClient3).kick(peerId);
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipant::unauthorized_kick", { peerId });
    throw new DyteError("Unauthorized: User does not have permission to kick participants.");
  }
  async disableVideo() {
    const peerId = this.id;
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipant::disable_video", { peerId });
    if (__privateGet2(this, _self).permissions.canAllowParticipantVideo) {
      return __privateGet2(this, _roomNodeClient3).disableVideo(peerId);
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipant::unauthorized_disable_video", { peerId });
    throw new DyteError("Unauthorized: User does not have permission to disable participant video.");
  }
  get isPinned() {
    return __privateGet2(this, _isPinned2);
  }
}
_isPinned2 = new WeakMap();
_roomNodeClient3 = new WeakMap();
_self = new WeakMap();
__decorateClass$a([
  DyteTelemetry.trace("DyteParticipant.disableAudio")
], DyteParticipant.prototype, "disableAudio", 1);
__decorateClass$a([
  DyteTelemetry.trace("DyteParticipant.kick")
], DyteParticipant.prototype, "kick", 1);
__decorateClass$a([
  DyteTelemetry.trace("DyteParticipant.disableVideo")
], DyteParticipant.prototype, "disableVideo", 1);
class DyteMap extends Map {
  constructor(options) {
    const {
      onAddEvent = "added",
      onDeleteEvent = "deleted",
      onClearEvent = "cleared"
    } = options != null ? options : {};
    super();
    __privateAdd2(this, _eventEmitter2, void 0);
    __privateAdd2(this, _listeners2, void 0);
    __publicField(this, "onAddEvent");
    __publicField(this, "onDeleteEvent");
    __publicField(this, "onClearEvent");
    __privateSet2(this, _eventEmitter2, new DyteEventEmitter());
    this.onAddEvent = onAddEvent;
    this.onDeleteEvent = onDeleteEvent;
    this.onClearEvent = onClearEvent;
    __privateSet2(this, _listeners2, new Map());
  }
  emit(event, ...args) {
    return __privateGet2(this, _eventEmitter2).emit(event, ...args);
  }
  on(event, callback) {
    return __privateGet2(this, _eventEmitter2).on(event, callback);
  }
  addListener(event, callback) {
    return __privateGet2(this, _eventEmitter2).addListener(event, callback);
  }
  off(event, callback) {
    return __privateGet2(this, _eventEmitter2).off(event, callback);
  }
  once(event, callback) {
    return __privateGet2(this, _eventEmitter2).once(event, callback);
  }
  prependListener(event, callback) {
    return __privateGet2(this, _eventEmitter2).prependListener(event, callback);
  }
  prependOnceListener(event, callback) {
    return __privateGet2(this, _eventEmitter2).prependOnceListener(event, callback);
  }
  removeListener(event, callback) {
    return __privateGet2(this, _eventEmitter2).removeListener(event, callback);
  }
  removeAllListeners(event) {
    return __privateGet2(this, _eventEmitter2).removeAllListeners(event);
  }
  listeners(event) {
    return __privateGet2(this, _eventEmitter2).listeners(event);
  }
  listenerCount(event) {
    return __privateGet2(this, _eventEmitter2).listenerCount(event);
  }
  getMaxListeners() {
    return __privateGet2(this, _eventEmitter2).getMaxListeners();
  }
  setMaxListeners(n2) {
    return __privateGet2(this, _eventEmitter2).setMaxListeners(n2);
  }
  eventNames() {
    return __privateGet2(this, _eventEmitter2).eventNames();
  }
  add(obj, emitEvent = true) {
    return this.set(obj.id, obj, emitEvent);
  }
  set(objId, obj, emitEvent = true) {
    const setVal = super.set(objId, obj);
    const listener = (event, ...args) => {
      this.emit(event, obj, ...args);
    };
    __privateGet2(this, _listeners2).set(objId, listener);
    obj.on("*", listener);
    if (emitEvent) {
      __privateGet2(this, _eventEmitter2).emit(this.onAddEvent, obj);
    }
    return setVal;
  }
  delete(objId, emitEvent = true, removeListeners = false) {
    const obj = this.get(objId);
    if (!obj) {
      return false;
    }
    obj.removeListener("*", __privateGet2(this, _listeners2).get(objId));
    const deleteVal = super.delete(objId);
    if (removeListeners) {
      obj.removeAllListeners();
    }
    if (emitEvent) {
      __privateGet2(this, _eventEmitter2).emit(this.onDeleteEvent, obj);
    }
    return deleteVal;
  }
  clear(emitEvent = true, removeListeners = false) {
    this.forEach((obj) => {
      obj.removeListener("*", __privateGet2(this, _listeners2).get(obj.id));
      if (removeListeners) {
        obj.removeAllListeners();
      }
    });
    const clearVal = super.clear();
    if (emitEvent) {
      __privateGet2(this, _eventEmitter2).emit(this.onClearEvent);
    }
    return clearVal;
  }
  toArray() {
    return Array.from(this.values());
  }
}
_eventEmitter2 = new WeakMap();
_listeners2 = new WeakMap();
class DyteParticipantMap extends DyteMap {
  constructor(options) {
    const {
      onAddEvent = "participantJoined",
      onDeleteEvent = "participantLeft",
      onClearEvent = "participantsCleared"
    } = options != null ? options : {};
    super({
      onAddEvent,
      onDeleteEvent,
      onClearEvent
    });
  }
  add(participant, emitEvent = true) {
    return super.add(participant, emitEvent);
  }
  clear(emitEvent = true, removeListeners = false) {
    return super.clear(emitEvent, removeListeners);
  }
  delete(participantId, emitEvent = true, removeListeners = false) {
    return super.delete(participantId, emitEvent, removeListeners);
  }
}
var __defProp$9 = Object.defineProperty;
var __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor;
var __decorateClass$9 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$9(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$9(target, key, result);
  return result;
};
class DyteParticipants extends DyteEventEmitter {
  constructor(roomNodeClient, self2) {
    super();
    __publicField(this, "waitlisted");
    __publicField(this, "joined");
    __publicField(this, "active");
    __publicField(this, "pinned");
    __privateAdd2(this, _roomNodeClient4, void 0);
    __privateAdd2(this, _self2, void 0);
    __publicField(this, "viewMode");
    __publicField(this, "currentPage");
    __publicField(this, "lastActiveSpeaker");
    __privateSet2(this, _roomNodeClient4, roomNodeClient);
    __privateSet2(this, _self2, self2);
    this.waitlisted = new DyteParticipantMap();
    this.joined = new DyteParticipantMap();
    this.active = new DyteParticipantMap();
    this.pinned = new DyteParticipantMap();
    this.viewMode = "ACTIVE_GRID";
    this.currentPage = 0;
  }
  get count() {
    return this.joined.size;
  }
  get maxActiveParticipantsCount() {
    return __privateGet2(this, _roomNodeClient4).maxPreferredStreams;
  }
  get pageCount() {
    return this.viewMode === "PAGINATED" ? Math.ceil(this.joined.size / __privateGet2(this, _roomNodeClient4).maxPreferredStreams) : 0;
  }
  async acceptWaitingRoomRequest(id) {
    return __privateGet2(this, _roomNodeClient4).acceptWaitingRequest(id);
  }
  async rejectWaitingRoomRequest(id) {
    await __privateGet2(this, _roomNodeClient4).rejectWaitingRequest(id);
    this.waitlisted.delete(id);
  }
  async setViewMode(viewMode) {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::set_view_mode", {
      viewMode
    });
    if (!["ACTIVE_GRID", "PAGINATED"].includes(viewMode)) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::setViewMode::invalid_view_mode", {
        viewMode
      });
      throw new DyteError(`Invalid view mode: ${viewMode}. Try ACTIVE_GRID or PAGINATED.`);
    }
    if (this.viewMode === viewMode) {
      DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::setViewMode::view_mode_same_as_previous", {
        viewMode
      });
      return;
    }
    this.viewMode = viewMode;
    if (viewMode === "PAGINATED") {
      this.currentPage = 1;
      SessionStore.emit(SessionEvents.GET_PAGE, (await __privateGet2(this, _roomNodeClient4).getPage(this.currentPage)).payload);
    } else if (viewMode === "ACTIVE_GRID") {
      this.currentPage = 0;
      __privateGet2(this, _roomNodeClient4).getPage(this.currentPage);
    }
    this.emit("viewModeChanged", {
      viewMode,
      currentPage: this.currentPage,
      pageCount: this.pageCount
    });
  }
  async setPage(page) {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::set_page", {
      page,
      maxPageCount: this.pageCount
    });
    if (this.viewMode !== "PAGINATED") {
      return;
    }
    if (!Number.isInteger(page)) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::invalid_page_number", {
        page,
        maxPageCount: this.pageCount
      });
      throw new DyteError(`Invalid page: ${page}. Page must be an integer.`);
    }
    if (page < 1 || page > this.pageCount) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::invalid_page_number", {
        page,
        maxPageCount: this.pageCount
      });
      throw new DyteError(`Invalid page: ${page}. Page must be greater than 0 and less than or equal to ${this.pageCount}.`);
    }
    SessionStore.emit(SessionEvents.GET_PAGE, (await __privateGet2(this, _roomNodeClient4).getPage(page)).payload);
    this.currentPage = page;
    this.emit("pageChanged", {
      viewMode: this.viewMode,
      currentPage: this.currentPage,
      pageCount: this.pageCount
    });
  }
  async disableAllAudio(allowUnMute) {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::disable_all_audio", {
      allowUnMute
    });
    if (__privateGet2(this, _self2).permissions.canAllowParticipantAudio) {
      return __privateGet2(this, _roomNodeClient4).muteAll(allowUnMute);
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::unauthorized_disable_all_audio", {
      allowUnMute
    });
    throw new DyteError("Unauthorized: User does not have permission to disable peer audio.");
  }
  async disableAllVideo() {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::disable_all_video");
    if (__privateGet2(this, _self2).permissions.canAllowParticipantVideo) {
      return __privateGet2(this, _roomNodeClient4).muteAllVideo();
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::unauthorized_disable_all_video");
    throw new DyteError("Unauthorized: User does not have permission to disable peer video.");
  }
  async disableAudio(participantId) {
    this.joined.get(participantId).disableAudio();
  }
  async disableVideo(participantId) {
    this.joined.get(participantId).disableVideo();
  }
  async kick(participantId) {
    this.joined.get(participantId).kick();
  }
  async kickAll() {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::kick_all");
    if (__privateGet2(this, _self2).permissions.kickParticipant) {
      return __privateGet2(this, _roomNodeClient4).kickAll();
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::unauthorized_kick_all");
    throw new DyteError("Unauthorized: User does not have permission to kick peers.");
  }
  async broadcastMessage(type, payload) {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::broadcastMessage");
    if (!(type == null ? void 0 : type.trim())) {
      throw new DyteError("`type` must be a non-empty string.");
    }
    __privateGet2(this, _roomNodeClient4).broadcastMessage(type, payload);
  }
}
_roomNodeClient4 = new WeakMap();
_self2 = new WeakMap();
__decorateClass$9([
  DyteTelemetry.trace("DyteParticipants.setViewMode")
], DyteParticipants.prototype, "setViewMode", 1);
__decorateClass$9([
  DyteTelemetry.trace("DyteParticipants.setPage")
], DyteParticipants.prototype, "setPage", 1);
__decorateClass$9([
  DyteTelemetry.trace("DyteParticipants.disableAllAudio")
], DyteParticipants.prototype, "disableAllAudio", 1);
__decorateClass$9([
  DyteTelemetry.trace("DyteParticipants.disableAllVideo")
], DyteParticipants.prototype, "disableAllVideo", 1);
__decorateClass$9([
  DyteTelemetry.trace("DyteParticipants.disablePeerAudio")
], DyteParticipants.prototype, "disableAudio", 1);
__decorateClass$9([
  DyteTelemetry.trace("DyteParticipants.disablePeerVideo")
], DyteParticipants.prototype, "disableVideo", 1);
__decorateClass$9([
  DyteTelemetry.trace("DyteParticipants.kickPeer")
], DyteParticipants.prototype, "kick", 1);
__decorateClass$9([
  DyteTelemetry.trace("DyteParticipants.kickAll")
], DyteParticipants.prototype, "kickAll", 1);
__decorateClass$9([
  DyteTelemetry.trace("DyteParticipants.broadcastMessage")
], DyteParticipants.prototype, "broadcastMessage", 1);
var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __decorateClass$8 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$8(target, key, result);
  return result;
};
class ParticipantController {
  constructor(roomNodeClient, self2) {
    __publicField(this, "participants");
    __privateAdd2(this, _roomNodeClient5, void 0);
    __privateAdd2(this, _self3, void 0);
    __privateAdd2(this, _consumerPeerMap, void 0);
    __privateSet2(this, _roomNodeClient5, roomNodeClient);
    this.participants = new DyteParticipants(roomNodeClient, self2);
    __privateSet2(this, _consumerPeerMap, new Map());
    __privateSet2(this, _self3, self2);
    this.setupEvents();
  }
  updatePageParticipants(peerIds) {
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::updatePageParticipants", {
      peerIds: JSON.stringify(peerIds)
    });
    const activePeers = new Map(this.participants.active);
    this.participants.active.forEach((_, participantId) => {
      this.participants.active.delete(participantId, !peerIds.includes(participantId));
    });
    peerIds.forEach((peerId) => {
      if (!this.participants.joined.get(peerId)) {
        DyteTelemetry.addEventInCurrentSpan("warn", "updatePageParticipants::participant_not_in_joined_list", {
          peerId
        });
        return;
      }
      this.participants.active.add(this.participants.joined.get(peerId), !activePeers.get(peerId));
    });
  }
  updatePinnedParticipants() {
    this.participants.pinned.forEach((p) => {
      p.setIsPinned(false);
      this.participants.pinned.delete(p.id);
    });
  }
  updateActiveParticipants(peerIds) {
    if (!__privateGet2(this, _roomNodeClient5).roomJoined) {
      DyteTelemetry.addEventInCurrentSpan("info", "Skipped::ParticipantController::updateActiveParticipants", {
        peerIds: JSON.stringify(peerIds),
        roomJoined: __privateGet2(this, _roomNodeClient5).roomJoined
      });
      return;
    }
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::updateActiveParticipants", {
      peerIds: JSON.stringify(peerIds)
    });
    const activePeerIds = Array.from(this.participants.active.keys());
    const activePeers = new Map(this.participants.active);
    const peerIdMap = {};
    peerIds.forEach((peerId) => {
      peerIdMap[peerId] = true;
    });
    const replaceableIndices = [];
    activePeerIds.forEach((activePeerId, index) => {
      if (!peerIdMap[activePeerId] || !this.participants.joined.get(activePeerId)) {
        replaceableIndices.push(index);
      }
    });
    peerIds.forEach((peerId) => {
      if (!activePeers.get(peerId)) {
        if (activePeerIds.length < peerIds.length) {
          activePeerIds.push(peerId);
        } else {
          activePeerIds[replaceableIndices.shift()] = peerId;
        }
      }
    });
    activePeerIds.forEach((peerId, index) => {
      if (!peerIdMap[peerId]) {
        activePeerIds.splice(index, 1);
      }
    });
    Array.from(this.participants.active.keys()).forEach((peerId) => {
      this.participants.active.delete(peerId, !peerIdMap[peerId]);
    });
    activePeerIds.forEach((peerId) => {
      if (!this.participants.joined.get(peerId)) {
        DyteTelemetry.addEventInCurrentSpan("warn", "updateActiveParticipants::participant_not_in_joined_list", { peerId });
        return;
      }
      this.participants.active.add(this.participants.joined.get(peerId), !activePeers.get(peerId));
    });
    DyteTelemetry.addEventInCurrentSpan("info", "updateActiveParticipants::refreshed_participants");
    this.participants.active.emit("participantsUpdate");
  }
  setupEvents() {
    SessionStore.on(SessionEvents.PEER_JOINED, async (p) => {
      var _a3, _b2;
      const participant = new DyteParticipant(p, __privateGet2(this, _self3), __privateGet2(this, _roomNodeClient5));
      DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::peer_joined", { info: JSON.stringify(p, null, 4) });
      if (__privateGet2(this, _self3).id !== participant.id && !((_a3 = p.flags) == null ? void 0 : _a3.recorder) && !((_b2 = participant.flags) == null ? void 0 : _b2.hidden_participant)) {
        this.participants.joined.add(participant);
        this.participants.waitlisted.delete(participant.id);
        if (this.participants.currentPage === this.participants.pageCount) {
          SessionStore.emit(SessionEvents.GET_PAGE, (await __privateGet2(this, _roomNodeClient5).getPage(this.participants.currentPage)).payload);
        }
      }
    });
    SessionStore.on(SessionEvents.WAITLIST_PEER_ADDED, ({ id, name }) => {
      this.participants.waitlisted.add(new DyteParticipant({
        id,
        displayName: name,
        audioMuted: true,
        videoEnabled: false,
        audioTrack: void 0,
        videoTrack: void 0,
        userId: void 0,
        flags: {},
        isHost: false
      }, __privateGet2(this, _self3), __privateGet2(this, _roomNodeClient5)));
    });
    SessionStore.on(SessionEvents.WAITLIST_PEER_REMOVED, ({ id }) => {
      this.participants.waitlisted.delete(id);
    });
    SessionStore.on(SessionEvents.ROOM_JOINED, (payload) => {
      DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::room_joined", { info: JSON.stringify(payload, null, 4) });
      payload.peers.forEach((participant) => {
        var _a3, _b2;
        if (((_a3 = participant.flags) == null ? void 0 : _a3.recorder) || ((_b2 = participant.flags) == null ? void 0 : _b2.hidden_participant))
          return;
        const p = new DyteParticipant(participant, __privateGet2(this, _self3), __privateGet2(this, _roomNodeClient5));
        if (p.id === payload.pinnedPeerId) {
          p.setIsPinned(true, false);
          this.participants.pinned.add(p);
        }
        this.participants.joined.add(p);
      });
      __privateGet2(this, _roomNodeClient5).getPage(this.participants.currentPage);
    });
    SessionStore.on(SessionEvents.PEER_CLOSED, async ({ id }) => {
      this.participants.joined.delete(id, true, true);
      this.participants.pinned.delete(id, true, true);
      const isActive = this.participants.active.get(id);
      if (!isActive)
        return;
      SessionStore.emit(SessionEvents.GET_PAGE, (await __privateGet2(this, _roomNodeClient5).getPage(this.participants.currentPage)).payload);
    });
    SessionStore.on(SessionEvents.ROOM_NODE_DISCONNECTED, () => {
      Array.from(this.participants.joined.keys()).forEach((participantId) => {
        this.participants.joined.delete(participantId);
      });
      Array.from(this.participants.active.keys()).forEach((participantId) => {
        this.participants.active.delete(participantId);
      });
      Array.from(this.participants.pinned.keys()).forEach((participantId) => {
        this.participants.pinned.delete(participantId);
      });
      this.participants.currentPage = 0;
      this.participants.viewMode = "ACTIVE_GRID";
      this.participants.emit("viewModeChanged", {
        viewMode: "ACTIVE_GRID",
        currentPage: this.participants.currentPage,
        pageCount: this.participants.pageCount
      });
    });
    SessionStore.on(SessionEvents.PEER_MUTED, ({ peerId }) => {
      const participant = this.participants.joined.get(peerId);
      if (participant)
        participant.setAudioEnabled(false);
    });
    SessionStore.on(SessionEvents.PEER_UNMUTED, ({ peerId }) => {
      const participant = this.participants.joined.get(peerId);
      if (participant)
        participant.setAudioEnabled(true);
    });
    SessionStore.on(SessionEvents.CONSUMER_PAUSED, ({ id: consumerId }) => {
      this.processConsumerPaused(consumerId);
    });
    SessionStore.on(SessionEvents.CONSUMER_RESUMED, ({ id: consumerId }) => {
      this.processConsumerResumed(consumerId);
    });
    SessionStore.on(SessionEvents.NEW_CONSUMER, ({ id: consumerId }) => {
      this.processNewConsumer(consumerId);
    });
    SessionStore.on(SessionEvents.CONSUMER_CLOSED, ({ id: consumerId }) => {
      this.processConsumerClosed(consumerId);
    });
    SessionStore.on(SessionEvents.GET_PAGE, ({ peerIds }) => {
      if (this.participants.viewMode !== "PAGINATED") {
        return;
      }
      this.updatePageParticipants(peerIds);
    });
    SessionStore.on(SessionEvents.SELECTED_PEERS, ({ peerIds }) => {
      if (this.participants.viewMode !== "ACTIVE_GRID") {
        return;
      }
      this.updateActiveParticipants(peerIds);
    });
    SessionStore.on(SessionEvents.ACTIVE_SPEAKER, ({ peerId, volume }) => {
      this.participants.lastActiveSpeaker = peerId;
      this.participants.emit("activeSpeaker", { peerId, volume });
    });
    SessionStore.on(SessionEvents.ROOM_MESSAGE, async ({ payload, type }) => {
      this.participants.emit("broadcastedMessage", { type, payload });
    });
    SessionStore.on(SessionEvents.LOW_CONSUMER_SCORE, ({ peerId, score, kind }) => {
      const participant = this.participants.joined.get(peerId);
      participant.emit("poorConnection", { score, kind });
      this.participants.emit("poorConnection", { participantId: peerId, score, kind });
    });
    SessionStore.on(SessionEvents.PEER_PINNED, ({ peerId }) => {
      if (!peerId) {
        if (__privateGet2(this, _self3).isPinned)
          __privateGet2(this, _self3).setIsPinned(false);
        if (this.participants.pinned.size !== 0) {
          this.updatePinnedParticipants();
        }
        return;
      }
      if (peerId === __privateGet2(this, _self3).id) {
        if (this.participants.pinned.size !== 0) {
          this.updatePinnedParticipants();
        }
        __privateGet2(this, _self3).setIsPinned(true);
        return;
      }
      const peer = this.participants.joined.get(peerId);
      if (__privateGet2(this, _self3).isPinned)
        __privateGet2(this, _self3).setIsPinned(false);
      this.updatePinnedParticipants();
      peer.setIsPinned(true);
      this.participants.pinned.add(peer);
    });
  }
  processMedia(consumerId) {
    const consumers = __privateGet2(this, _roomNodeClient5).getConsumers();
    const {
      peerId,
      kind,
      appData: untypedAppData,
      remotelyPaused,
      track
    } = consumers.get(consumerId);
    const appData = untypedAppData;
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processMedia", {
      consumerId,
      peerId,
      kind,
      appData,
      remotelyPaused
    });
    __privateGet2(this, _consumerPeerMap).set(consumerId, {
      type: kind,
      peerId,
      appData
    });
    return {
      peerId,
      kind,
      appData,
      remotelyPaused,
      track
    };
  }
  processConsumerClosed(consumerId) {
    const { peerId, type, appData } = __privateGet2(this, _consumerPeerMap).get(consumerId) || {};
    const participant = this.participants.joined.get(peerId);
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processConsumerClosed", {
      consumerId,
      peerId,
      type,
      appData
    });
    __privateGet2(this, _consumerPeerMap).delete(consumerId);
    if (!participant)
      return;
    if (appData && appData.screenShare) {
      participant.setScreenShareEnabled(false);
      callStats.consumerSharedMediaState(consumerId, { screen: false });
      participant.screenShareTracks = {
        audio: void 0,
        video: void 0
      };
      return;
    }
    if (type === "audio") {
      participant.setAudioEnabled(false);
      callStats.consumerSharedMediaState(consumerId, { audio: false });
      participant.audioTrack = void 0;
    } else if (type === "video") {
      participant.setVideoEnabled(false);
      callStats.consumerSharedMediaState(consumerId, { video: false });
      participant.videoTrack = void 0;
    }
  }
  processConsumerResumed(consumerId) {
    const {
      peerId,
      kind,
      appData,
      track
    } = this.processMedia(consumerId);
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processConsumerResumed", {
      consumerId,
      peerId,
      kind,
      appData
    });
    const participant = this.participants.joined.get(peerId);
    if (!participant)
      return;
    if (appData.screenShare) {
      if (kind === "video") {
        participant.screenShareTracks.video = track;
      } else if (kind === "audio") {
        participant.screenShareTracks.audio = track;
      }
      participant.setScreenShareEnabled(true);
      callStats.consumerSharedMediaState(consumerId, { screen: true });
      return;
    }
    if (kind === "video") {
      participant.videoTrack = track;
      participant.setVideoEnabled(true);
      callStats.consumerSharedMediaState(consumerId, { video: true });
    } else if (kind === "audio") {
      participant.audioTrack = track;
      participant.setAudioEnabled(participant.audioEnabled);
      callStats.consumerSharedMediaState(consumerId, { audio: participant.audioEnabled });
    }
  }
  processConsumerPaused(consumerId) {
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processConsumerPaused", {
      consumerId
    });
    const {
      peerId,
      kind,
      track,
      appData
    } = this.processMedia(consumerId);
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processConsumerPaused", {
      consumerId,
      peerId,
      kind,
      appData
    });
    const participant = this.participants.joined.get(peerId);
    if (!participant)
      return;
    if (kind === "video") {
      participant.videoTrack = track;
      participant.setVideoEnabled(false);
      callStats.consumerSharedMediaState(consumerId, { video: false });
    } else if (kind === "audio") {
      participant.audioTrack = track;
      participant.setAudioEnabled(participant.audioEnabled);
      callStats.consumerSharedMediaState(consumerId, { audio: participant.audioEnabled });
    }
  }
  processNewConsumer(consumerId) {
    const {
      peerId,
      kind,
      remotelyPaused,
      track,
      appData
    } = this.processMedia(consumerId);
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processNewConsumer", {
      consumerId,
      peerId,
      kind,
      remotelyPaused,
      appData
    });
    const participant = this.participants.joined.get(peerId);
    if (!participant)
      return;
    if (appData.screenShare) {
      if (kind === "video") {
        participant.screenShareTracks.video = track;
      } else if (kind === "audio") {
        participant.screenShareTracks.audio = track;
      }
      if (!remotelyPaused) {
        participant.setScreenShareEnabled(true);
      }
      if (appData.supportsRemoteControl) {
        participant.supportsRemoteControl = true;
      }
      return;
    }
    if (kind === "video") {
      participant.videoTrack = track;
      if (!remotelyPaused) {
        participant.setVideoEnabled(true);
      }
      callStats.consumerSharedMediaState(consumerId, { video: !remotelyPaused });
    }
  }
}
_roomNodeClient5 = new WeakMap();
_self3 = new WeakMap();
_consumerPeerMap = new WeakMap();
__decorateClass$8([
  DyteTelemetry.trace("updatePageParticipants")
], ParticipantController.prototype, "updatePageParticipants", 1);
__decorateClass$8([
  DyteTelemetry.trace("updateActiveParticipants")
], ParticipantController.prototype, "updateActiveParticipants", 1);
__decorateClass$8([
  DyteTelemetry.trace("ParticipantController.setupEvents")
], ParticipantController.prototype, "setupEvents", 1);
__decorateClass$8([
  DyteTelemetry.trace("processMedia")
], ParticipantController.prototype, "processMedia", 1);
__decorateClass$8([
  DyteTelemetry.trace("processConsumerClosed")
], ParticipantController.prototype, "processConsumerClosed", 1);
__decorateClass$8([
  DyteTelemetry.trace("processConsumerResumed")
], ParticipantController.prototype, "processConsumerResumed", 1);
__decorateClass$8([
  DyteTelemetry.trace("processConsumerPaused")
], ParticipantController.prototype, "processConsumerPaused", 1);
__decorateClass$8([
  DyteTelemetry.trace("processNewConsumer")
], ParticipantController.prototype, "processNewConsumer", 1);
var RoomViewType;
(function(RoomViewType2) {
  RoomViewType2[RoomViewType2["webinar"] = 0] = "webinar";
  RoomViewType2[RoomViewType2["groupCall"] = 1] = "groupCall";
  RoomViewType2[RoomViewType2["audioRoom"] = 2] = "audioRoom";
})(RoomViewType || (RoomViewType = {}));
class DyteMeta extends DyteEventEmitter {
  constructor(roomNodeClient) {
    super();
    __privateAdd2(this, _roomNodeClient6, void 0);
    __publicField(this, "roomType");
    __publicField(this, "meetingStartedTimestamp");
    __privateSet2(this, _roomNodeClient6, roomNodeClient);
    this.roomType = "groupCall";
  }
  get joined() {
    return __privateGet2(this, _roomNodeClient6).roomJoined;
  }
  get roomName() {
    return __privateGet2(this, _roomNodeClient6).roomName;
  }
  get meetingTitle() {
    return __privateGet2(this, _roomNodeClient6).meetingTitle;
  }
}
_roomNodeClient6 = new WeakMap();
var __defProp$7 = Object.defineProperty;
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __decorateClass$7 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$7(target, key, result);
  return result;
};
class MetaController {
  constructor(roomNodeClient) {
    __publicField(this, "meta");
    this.meta = new DyteMeta(roomNodeClient);
    this.setupEvents();
  }
  get roomName() {
    return this.meta.roomName;
  }
  setupEvents() {
    SessionStore.on(SessionEvents.ROOM_JOINED, (response) => {
      this.meta.meetingStartedTimestamp = new Date(response.startedAt);
    });
    SessionStore.on(SessionEvents.ROOM_NODE_CONNECTED, () => {
      this.meta.emit("connected");
    });
    SessionStore.on(SessionEvents.ROOM_NODE_DISCONNECTED, () => {
      this.meta.emit("disconnected");
    });
    SessionStore.on(SessionEvents.LOW_PRODUCER_SCORE, () => {
      this.meta.emit("poorConnection");
    });
  }
}
__decorateClass$7([
  DyteTelemetry.trace("MetaController.setupEvents")
], MetaController.prototype, "setupEvents", 1);
const localPluginEvents = {
  getPeer: 14,
  getPeers: 15,
  chatMessage: 16,
  getRoomName: 17,
  getDisplayTitle: 18,
  getPluginInitiator: 19,
  customPluginEventToParent: 20,
  peerJoined: 22,
  peerLeft: 23,
  sendData: 24
};
class DytePlugin extends DyteEventEmitter {
  constructor({
    baseURL,
    createdAt,
    description,
    id,
    name,
    organizationId,
    picture,
    private: isPrivate,
    published,
    staggered,
    tags,
    type,
    updatedAt
  }, pluginSocketHandler, roomNodeClient, socketServerName, self2, participants, chat) {
    super();
    __privateAdd2(this, _pluginSocketHandler, void 0);
    __privateAdd2(this, _roomNodeClient7, void 0);
    __privateAdd2(this, _socketServerName, void 0);
    __publicField(this, "baseURL");
    __publicField(this, "createdAt");
    __publicField(this, "description");
    __publicField(this, "id");
    __publicField(this, "name");
    __privateAdd2(this, _self4, void 0);
    __privateAdd2(this, _participants, void 0);
    __privateAdd2(this, _chat, void 0);
    __publicField(this, "organizationId");
    __publicField(this, "picture");
    __publicField(this, "private");
    __publicField(this, "published");
    __publicField(this, "staggered");
    __publicField(this, "tags");
    __publicField(this, "type");
    __publicField(this, "updatedAt");
    __publicField(this, "config");
    __privateAdd2(this, _authToken, void 0);
    __publicField(this, "active");
    __publicField(this, "iframes");
    __publicField(this, "enabledBy");
    this.baseURL = baseURL;
    this.createdAt = new Date(createdAt);
    this.description = description;
    this.id = id;
    this.name = name;
    __privateSet2(this, _self4, self2);
    this.organizationId = organizationId;
    this.picture = picture;
    this.private = isPrivate;
    this.published = published;
    this.staggered = staggered;
    this.tags = tags;
    this.type = type;
    this.updatedAt = new Date(updatedAt);
    this.active = false;
    this.iframes = new Map();
    __privateSet2(this, _pluginSocketHandler, pluginSocketHandler);
    __privateSet2(this, _roomNodeClient7, roomNodeClient);
    __privateSet2(this, _socketServerName, socketServerName);
    __privateSet2(this, _participants, participants);
    __privateSet2(this, _chat, chat);
    this.enabledBy = "";
  }
  sendIframeEvent(message2) {
    if (!this.iframes.size) {
      return;
    }
    [...this.iframes.keys()].forEach((viewId) => {
      const { iframe } = this.iframes.get(viewId);
      if (!iframe)
        return;
      log.info(`Sending message to plugin ${this.id}`, message2, iframe);
      iframe.contentWindow.postMessage(message2, "*");
    });
  }
  async handleIframeMessage(iframeMessage) {
    var _a3, _b2;
    let response;
    if (__privateGet2(this, _socketServerName) === "socket-service") {
      const message22 = iframeMessage;
      const { payload, uuid, type } = message22;
      switch (type) {
        case pluginEvents.customPluginEventToRoom: {
          __privateGet2(this, _pluginSocketHandler).customPluginEventToRoom(this.id, payload, uuid);
          break;
        }
        case pluginEvents.customPluginEventToPeers: {
          __privateGet2(this, _pluginSocketHandler).customPluginEventToPeers(this.id, payload, payload.peerIds, uuid);
          break;
        }
        case pluginEvents.enablePluginForRoom: {
          __privateGet2(this, _pluginSocketHandler).enablePluginForRoom(this.id, uuid);
          break;
        }
        case pluginEvents.enablePluginForPeers: {
          __privateGet2(this, _pluginSocketHandler).enablePluginForPeers(this.id, payload.peerIds, uuid);
          break;
        }
        case pluginEvents.disablePluginForRoom: {
          __privateGet2(this, _pluginSocketHandler).disablePluginForRoom(this.id, uuid);
          break;
        }
        case pluginEvents.disablePluginForPeers: {
          __privateGet2(this, _pluginSocketHandler).disablePluginForPeers(this.id, payload.peerIds, uuid);
          break;
        }
        case pluginEvents.storeInsertKeys: {
          __privateGet2(this, _pluginSocketHandler).storeInsertKeys(this.id, payload.store, payload.insertKeys, uuid);
          break;
        }
        case pluginEvents.storeGetKeys: {
          __privateGet2(this, _pluginSocketHandler).storeGetKeys(this.id, payload.store, payload.getKeys, uuid);
          break;
        }
        case pluginEvents.storeDeleteKeys: {
          __privateGet2(this, _pluginSocketHandler).storeDeleteKeys(this.id, payload.store, payload.deleteKeys, uuid);
          break;
        }
        case pluginEvents.storeDelete: {
          __privateGet2(this, _pluginSocketHandler).storeDelete(this.id, payload.store, uuid);
          break;
        }
        case localPluginEvents.chatMessage: {
          const {
            messagePayload,
            peerIds
          } = payload;
          if (!__privateGet2(this, _chat)) {
            this.sendIframeEvent({
              type: localPluginEvents.chatMessage,
              uuid: message22.uuid,
              payload: { error: "Chat is disabled for this room." }
            });
            return;
          }
          try {
            await __privateGet2(this, _chat).sendMessage(messagePayload, peerIds);
            this.sendIframeEvent({
              type: localPluginEvents.chatMessage,
              uuid: message22.uuid,
              payload: { success: true }
            });
          } catch (e) {
            this.sendIframeEvent({
              type: localPluginEvents.chatMessage,
              uuid: message22.uuid,
              payload: {
                error: e
              }
            });
          }
          break;
        }
        case localPluginEvents.getPeer: {
          let peer;
          const { peerId } = payload;
          if (peerId) {
            peer = __privateGet2(this, _participants).joined.get(payload.peerId);
            if (__privateGet2(this, _self4).id === peerId)
              peer = __privateGet2(this, _self4);
          } else
            peer = __privateGet2(this, _self4);
          this.sendIframeEvent({
            type: localPluginEvents.getPeer,
            payload: { peer: peer && postMessageSanitizer(peer) },
            uuid: message22.uuid
          });
          break;
        }
        case localPluginEvents.getPeers: {
          const peers = __privateGet2(this, _participants).joined.toArray().map((p) => postMessageSanitizer(p));
          this.sendIframeEvent({
            type: localPluginEvents.getPeers,
            payload: { peers },
            uuid: message22.uuid
          });
          break;
        }
        case localPluginEvents.getPluginInitiator: {
          this.sendIframeEvent({
            type: localPluginEvents.getPluginInitiator,
            payload: { enabledBy: this.enabledBy },
            uuid: message22.uuid
          });
          break;
        }
        case localPluginEvents.getDisplayTitle: {
          this.sendIframeEvent({
            type: localPluginEvents.getDisplayTitle,
            payload: { displayTitle: __privateGet2(this, _roomNodeClient7).meetingTitle },
            uuid: message22.uuid
          });
          break;
        }
        case localPluginEvents.getRoomName: {
          this.sendIframeEvent({
            type: localPluginEvents.getRoomName,
            payload: { roomName: __privateGet2(this, _roomNodeClient7).roomName },
            uuid: message22.uuid
          });
          break;
        }
        case localPluginEvents.customPluginEventToParent: {
          this.emit(message22.payload.eventName, message22.payload.data);
          break;
        }
      }
      return;
    }
    const getEnabledByPeerId = (enabledBy, peers) => {
      if (__privateGet2(this, _self4).userId === enabledBy)
        return __privateGet2(this, _self4).id;
      let enabledById;
      peers.forEach((p) => {
        if (p.userId === enabledBy)
          enabledById = p.id;
      });
      return enabledById;
    };
    const message2 = iframeMessage;
    switch (message2.type) {
      case "pluginEvent":
      case "storePluginData":
      case "getPluginData":
      case "enablePluginForAll":
      case "enablePluginForUser":
      case "disablePluginForUser":
      case "chatMessage": {
        response = await __privateGet2(this, _roomNodeClient7).sendMessage(message2);
        this.sendIframeEvent(response);
        break;
      }
      case "getJoinedPeers": {
        response = await __privateGet2(this, _roomNodeClient7).getRoomState();
        this.sendIframeEvent({
          type: "websocket/get-joined-peers",
          payload: __spreadProps(__spreadValues({}, message2.payload), {
            peers: response.payload.roomState.peers
          })
        });
        break;
      }
      case "getPeerInfo": {
        response = await __privateGet2(this, _roomNodeClient7).sendMessage({
          type: message2.type,
          payload: __spreadProps(__spreadValues({}, message2.payload), {
            peerId: (_b2 = (_a3 = message2.payload) == null ? void 0 : _a3.peerId) != null ? _b2 : __privateGet2(this, _self4).id
          })
        });
        this.sendIframeEvent(response);
        break;
      }
      case "getRoomState": {
        response = await __privateGet2(this, _roomNodeClient7).getRoomState();
        const { plugins, peers } = response.payload.roomState;
        const { enabledBy } = plugins.find((x) => x.id === this.id);
        const enabledByPeerId = getEnabledByPeerId(enabledBy, peers);
        this.sendIframeEvent({
          type: "websocket/get-room-state",
          payload: __spreadProps(__spreadValues({}, message2.payload), {
            roomName: response.payload.roomState.roomName,
            pluginInitiatorPeerId: enabledByPeerId,
            pluginInitiatorUserId: enabledBy,
            peers: response.payload.roomState.peers,
            displayTitle: response.payload.roomState.displayTitle,
            roomUUID: response.payload.roomState.roomUUID,
            currentPeer: __privateGet2(this, _self4).id
          })
        });
        break;
      }
      case "getPluginInitiatorId": {
        response = await __privateGet2(this, _roomNodeClient7).getRoomState();
        const { plugins, peers } = response.payload.roomState;
        const { enabledBy } = plugins.find((x) => x.id === this.id);
        const enabledByPeerId = getEnabledByPeerId(enabledBy, peers);
        this.sendIframeEvent({
          type: "websocket/get-plugin-initiator-peer-id",
          payload: __spreadProps(__spreadValues({}, message2.payload), {
            pluginInitiatorPeerId: enabledByPeerId
          })
        });
        break;
      }
      case "getPluginInitiatorUserId": {
        response = await __privateGet2(this, _roomNodeClient7).getRoomState();
        const { plugins } = response.payload.roomState;
        const { enabledBy } = plugins.find((x) => x.id === this.id);
        this.sendIframeEvent({
          type: "websocket/get-plugin-initiator-user-id",
          payload: __spreadProps(__spreadValues({}, message2.payload), {
            pluginInitiatorUserId: enabledBy
          })
        });
        break;
      }
      case "pluginEventToParent": {
        this.emit(message2.payload.eventName, message2.payload.data);
        break;
      }
    }
  }
  sendData(data) {
    if (__privateGet2(this, _socketServerName) === "socket-service") {
      this.sendIframeEvent({
        type: localPluginEvents.sendData,
        uuid: "",
        payload: data
      });
      return;
    }
    this.sendIframeEvent({
      type: SessionEvents.PLUGIN_INTERNAL_DATA,
      payload: {
        pluginId: this.id,
        data
      }
    });
  }
  removePluginView(viewId = "default") {
    var _a3;
    const { iframe, listener } = (_a3 = this.iframes.get(viewId)) != null ? _a3 : {};
    if (iframe || listener) {
      window.removeEventListener("message", listener);
      this.iframes.delete(viewId);
    }
  }
  addPluginView(iframe, viewId = "default") {
    if (!__privateGet2(this, _authToken)) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePlugin::addPluginView::no_auth_token_set_for_plugin");
      throw new DyteError("No auth token set for plugin.");
    }
    if (!iframe) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePlugin::addPluginView::iframe_was_not_provided");
      throw new DyteError("Iframe was not provided.");
    }
    this.removePluginView(viewId);
    const iframeElement = iframe;
    const url = new URL(this.baseURL);
    const params = {
      auth: __privateGet2(this, _authToken),
      parent: window.location.origin,
      backend: config.apiBase,
      pluginId: this.id
    };
    Object.keys(params).forEach((param) => {
      url.searchParams.set(param, params[param]);
    });
    iframeElement.src = url.href;
    iframeElement.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    iframeElement.title = viewId;
    const listener = async (message2) => {
      if (message2.source === iframe.contentWindow) {
        await this.handleIframeMessage(message2.data);
      }
    };
    window.addEventListener("message", listener);
    this.iframes.set(viewId, { iframe: iframeElement, listener });
  }
  setActive(active) {
    var _a3, _b2;
    this.active = active;
    if (active) {
      this.emit("stateUpdate", {
        active: this.active,
        pluginId: this.id,
        bind: this.addPluginView.bind(this),
        views: (_a3 = this.config) == null ? void 0 : _a3.views
      });
      return;
    }
    this.active = false;
    this.emit("stateUpdate", {
      active: this.active,
      pluginId: this.id,
      views: (_b2 = this.config) == null ? void 0 : _b2.views
    });
  }
  async enable() {
    const APIClient2 = getAPIClient();
    const authToken = await APIClient2.authorizePlugin(this.id);
    __privateSet2(this, _authToken, authToken);
    try {
      const pluginConfig = await APIClient2.getPluginConfig(this.baseURL);
      this.config = pluginConfig;
    } catch (err) {
      log.error(err);
    }
    this.setActive(true);
  }
  disable() {
    [...this.iframes.keys()].forEach((viewId) => {
      this.removePluginView(viewId);
    });
    this.iframes.clear();
    this.setActive(false);
    this.emit("closed");
  }
  async activate() {
    var _a3, _b2;
    if (!((_b2 = (_a3 = __privateGet2(this, _self4).permissions) == null ? void 0 : _a3.plugins) == null ? void 0 : _b2.canStart)) {
      return;
    }
    if (__privateGet2(this, _socketServerName) === "socket-service") {
      __privateGet2(this, _pluginSocketHandler).addPlugin(this.id, this.staggered);
      return;
    }
    await __privateGet2(this, _roomNodeClient7).addRoomPlugin(this);
  }
  async deactivate() {
    var _a3, _b2;
    if (!((_b2 = (_a3 = __privateGet2(this, _self4).permissions) == null ? void 0 : _a3.plugins) == null ? void 0 : _b2.canClose)) {
      return;
    }
    if (__privateGet2(this, _socketServerName) === "socket-service") {
      __privateGet2(this, _pluginSocketHandler).removePlugin(this.id);
      return;
    }
    await __privateGet2(this, _roomNodeClient7).removeRoomPlugin(this);
  }
}
_pluginSocketHandler = new WeakMap();
_roomNodeClient7 = new WeakMap();
_socketServerName = new WeakMap();
_self4 = new WeakMap();
_participants = new WeakMap();
_chat = new WeakMap();
_authToken = new WeakMap();
class DytePluginMap extends DyteMap {
  constructor() {
    super({
      onAddEvent: "pluginAdded",
      onDeleteEvent: "pluginDeleted"
    });
  }
  add(plugin, emitEvent = true) {
    return super.add(plugin, emitEvent);
  }
  delete(pluginId, emitEvent = true, removeListeners = false) {
    return super.delete(pluginId, emitEvent, removeListeners);
  }
}
class DytePlugins extends DyteEventEmitter {
  constructor() {
    super();
    __publicField(this, "all");
    __publicField(this, "active");
    this.all = new DytePluginMap();
    this.active = new DytePluginMap();
  }
}
var ChatMessageType;
(function(ChatMessageType2) {
  ChatMessageType2[ChatMessageType2["TEXT"] = 0] = "TEXT";
  ChatMessageType2[ChatMessageType2["IMAGE"] = 1] = "IMAGE";
  ChatMessageType2[ChatMessageType2["FILE"] = 2] = "FILE";
})(ChatMessageType || (ChatMessageType = {}));
class ChatSocketHandler {
  constructor(socketService) {
    __publicField(this, "socket");
    this.socket = socketService;
  }
  getChatMessages() {
    return this.socket.sendMessagePromise(chatEvents.getMessages);
  }
  sendMessageToRoom(message2, messageType) {
    this.socket.sendMessage(chatEvents.sendMessageToRoom, new dist.SendChatMessageToRoomRequest().setPayloadType(messageType).setPayload(message2));
  }
  sendMessageToPeers(message2, messageType, peerIds) {
    this.socket.sendMessage(chatEvents.sendMessageToPeers, new dist.SendChatMessageToPeersRequest().setPayloadType(messageType).setPeerIdsList(peerIds).setPayload(message2));
  }
  sendMessage(message2, messageType, peerIds) {
    if (peerIds && peerIds.length > 0) {
      this.sendMessageToPeers(message2, messageType, peerIds);
      return;
    }
    this.sendMessageToRoom(message2, messageType);
  }
  editMessage(chatId, message2, messageType, pinned) {
    this.socket.sendMessage(chatEvents.editMessage, new dist.EditChatMessageRequest().setChatId(chatId).setPayloadType(messageType).setPayload(message2).setPinned(pinned));
  }
  deleteMessage(chatId) {
    this.socket.sendMessage(chatEvents.deleteMessage, new dist.DeleteChatMessageRequest().setChatId(chatId));
  }
}
var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __decorateClass$6 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$6(target, key, result);
  return result;
};
var MessageType;
(function(MessageType2) {
  MessageType2["text"] = "text";
  MessageType2["image"] = "image";
  MessageType2["file"] = "file";
  MessageType2["poll"] = "poll";
})(MessageType || (MessageType = {}));
const messageTypes = ["text", "image", "file", "poll"];
class DyteChat extends DyteEventEmitter {
  constructor(chatSocketHandler, roomNodeClient, socketServerName, self2) {
    super();
    __publicField(this, "messages");
    __privateAdd2(this, _self5, void 0);
    __privateAdd2(this, _chatSocketHandler, void 0);
    __privateAdd2(this, _roomNodeClient8, void 0);
    __privateAdd2(this, _socketServerName2, void 0);
    __privateSet2(this, _chatSocketHandler, chatSocketHandler);
    __privateSet2(this, _roomNodeClient8, roomNodeClient);
    __privateSet2(this, _socketServerName2, socketServerName);
    __privateSet2(this, _self5, self2);
    this.messages = [];
  }
  async sendTextMessage(message2, participantIds) {
    var _a3, _b2, _c2, _d2;
    if (!((_b2 = (_a3 = __privateGet2(this, _self5).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet2(this, _self5).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.text)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendTextMessage::permission_denied");
      return;
    }
    if (!message2) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendTextMessage::message_can_not_be_empty");
      return;
    }
    if (__privateGet2(this, _socketServerName2) === "socket-service") {
      const peerIds = participantIds;
      if (peerIds && peerIds.length > 0) {
        peerIds.push(__privateGet2(this, _self5).id);
      }
      __privateGet2(this, _chatSocketHandler).sendMessage(message2, ChatMessageType.TEXT, peerIds);
      return;
    }
    const text = {
      userId: __privateGet2(this, _self5).userId,
      displayName: __privateGet2(this, _self5).name,
      message: message2,
      type: messageTypes.indexOf(MessageType.text),
      time: +new Date()
    };
    await __privateGet2(this, _roomNodeClient8).sendChatMessage(text);
  }
  async sendImageMessage(image, participantIds) {
    var _a3, _b2, _c2, _d2;
    if (!((_b2 = (_a3 = __privateGet2(this, _self5).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet2(this, _self5).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.files)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendImageMessage::permission_denied");
      return;
    }
    if (!image) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendImageMessage::required_argument_image_can_not_be_empty");
      return;
    }
    const acceptedImageTypes = ["image/gif", "image/jpeg", "image/png"];
    if (!acceptedImageTypes.includes(image.type)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendImageMessage::image_type_not_supported", {
        imageType: image.type
      });
      return;
    }
    try {
      const APIClient2 = getAPIClient();
      const { getLocation, putLocation } = await APIClient2.getPresignedUrls(image.name);
      await APIClient2.uploadFile(image, putLocation);
      if (__privateGet2(this, _socketServerName2) === "socket-service") {
        const peerIds = participantIds;
        if (peerIds && peerIds.length > 0) {
          peerIds.push(__privateGet2(this, _self5).id);
        }
        __privateGet2(this, _chatSocketHandler).sendMessage(getLocation, ChatMessageType.IMAGE, peerIds);
        return;
      }
      const imageObj = {
        userId: __privateGet2(this, _self5).userId,
        displayName: __privateGet2(this, _self5).name,
        type: messageTypes.indexOf(MessageType.image),
        link: getLocation,
        time: +new Date()
      };
      await __privateGet2(this, _roomNodeClient8).sendChatMessage(imageObj);
    } catch (err) {
      throw new DyteError("Error sending image message.");
    }
  }
  async sendFileMessage(file, participantIds) {
    var _a3, _b2, _c2, _d2;
    if (!((_b2 = (_a3 = __privateGet2(this, _self5).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet2(this, _self5).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.files)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendFileMessage::permission_denied");
      return;
    }
    if (!file) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendFileMessage::required_argument_file_can_not_be_empty");
      return;
    }
    try {
      const APIClient2 = getAPIClient();
      const { getLocation, putLocation } = await APIClient2.getPresignedUrls(file.name);
      await APIClient2.uploadFile(file, putLocation);
      if (__privateGet2(this, _socketServerName2) === "socket-service") {
        const peerIds = participantIds;
        if (peerIds && peerIds.length > 0) {
          peerIds.push(__privateGet2(this, _self5).id);
        }
        __privateGet2(this, _chatSocketHandler).sendMessage(JSON.stringify({
          link: getLocation,
          name: file.name,
          size: file.size
        }), ChatMessageType.FILE, peerIds);
        return;
      }
      const fileObj = {
        userId: __privateGet2(this, _self5).userId,
        displayName: __privateGet2(this, _self5).name,
        type: messageTypes.indexOf(MessageType.file),
        link: getLocation,
        name: file.name,
        size: file.size,
        time: +new Date()
      };
      await __privateGet2(this, _roomNodeClient8).sendChatMessage(fileObj);
    } catch (err) {
      throw new DyteError("Error sending file message.");
    }
  }
  async sendMessage(message2, participantIds) {
    switch (message2.type) {
      case MessageType.text:
        await this.sendTextMessage(message2.message, participantIds);
        break;
      case MessageType.image:
        await this.sendImageMessage(message2.image, participantIds);
        break;
      case MessageType.file:
        await this.sendFileMessage(message2.file, participantIds);
        break;
      default:
        DyteTelemetry.addEventInCurrentSpan("error", "sendMessage::message_type_not_supported", {
          messageType: message2.type
        });
        break;
    }
  }
  async editTextMessage(messageId, message2) {
    var _a3, _b2, _c2, _d2;
    if (__privateGet2(this, _socketServerName2) !== "socket-service") {
      log.warn("Coming soon!");
      return;
    }
    if (!((_b2 = (_a3 = __privateGet2(this, _self5).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet2(this, _self5).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.text)) {
      DyteTelemetry.addEventInCurrentSpan("error", "editTextMessage::permission_denied");
      return;
    }
    if (!message2) {
      DyteTelemetry.addEventInCurrentSpan("error", "editTextMessage::message_can_not_be_empty");
      return;
    }
    __privateGet2(this, _chatSocketHandler).editMessage(messageId, message2, ChatMessageType.TEXT);
  }
  async editImageMessage(messageId, image) {
    var _a3, _b2, _c2, _d2;
    if (__privateGet2(this, _socketServerName2) !== "socket-service") {
      log.warn("Coming soon!");
      return;
    }
    if (!((_b2 = (_a3 = __privateGet2(this, _self5).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet2(this, _self5).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.files)) {
      DyteTelemetry.addEventInCurrentSpan("error", "editImageMessage::permission_denied");
      return;
    }
    if (!image) {
      DyteTelemetry.addEventInCurrentSpan("error", "editImageMessage::required_argument_image_can_not_be_empty");
      return;
    }
    const acceptedImageTypes = ["image/gif", "image/jpeg", "image/png"];
    if (!acceptedImageTypes.includes(image.type)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendImageMessage::image_type_not_supported", {
        imageType: image.type
      });
      return;
    }
    try {
      const APIClient2 = getAPIClient();
      const { getLocation, putLocation } = await APIClient2.getPresignedUrls(image.name);
      await APIClient2.uploadFile(image, putLocation);
      __privateGet2(this, _chatSocketHandler).editMessage(messageId, getLocation, ChatMessageType.IMAGE);
    } catch {
      throw new DyteError("Error editing image message.");
    }
  }
  async editFileMessage(messageId, file) {
    var _a3, _b2, _c2, _d2;
    if (__privateGet2(this, _socketServerName2) !== "socket-service") {
      log.warn("Coming soon!");
      return;
    }
    if (!((_b2 = (_a3 = __privateGet2(this, _self5).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet2(this, _self5).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.files)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendFileMessage::permission_denied");
      return;
    }
    if (!file) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendFileMessage::required_argument_file_can_not_be_empty");
      return;
    }
    try {
      const APIClient2 = getAPIClient();
      const { getLocation, putLocation } = await APIClient2.getPresignedUrls(file.name);
      await APIClient2.uploadFile(file, putLocation);
      __privateGet2(this, _chatSocketHandler).editMessage(messageId, JSON.stringify({
        link: getLocation,
        name: file.name,
        size: file.size
      }), ChatMessageType.FILE);
    } catch {
      throw new DyteError("Error editing file message.");
    }
  }
  async editMessage(messageId, message2) {
    if (__privateGet2(this, _socketServerName2) !== "socket-service") {
      log.warn("Coming soon!");
      return;
    }
    switch (message2.type) {
      case MessageType.text: {
        this.editTextMessage(messageId, message2.message);
        break;
      }
      case MessageType.image: {
        this.editImageMessage(messageId, message2.image);
        break;
      }
      case MessageType.file: {
        this.editFileMessage(messageId, message2.file);
        break;
      }
      default: {
        DyteTelemetry.addEventInCurrentSpan("error", "editMessage::message_type_not_supported", {
          messageType: message2.type
        });
        break;
      }
    }
  }
  async deleteMessage(messageId) {
    if (__privateGet2(this, _socketServerName2) !== "socket-service") {
      log.warn("Coming soon!");
      return;
    }
    __privateGet2(this, _chatSocketHandler).deleteMessage(messageId);
  }
  getMessagesByUser(userId) {
    return this.messages.filter((message2) => message2.userId === userId);
  }
  getMessagesByType(type) {
    return this.messages.filter((message2) => message2.type === type);
  }
  async pin(id) {
    if (__privateGet2(this, _socketServerName2) === "socket-service") {
      return;
    }
    await __privateGet2(this, _roomNodeClient8).pinChatMessage({ id });
  }
  async unpin(id) {
    if (__privateGet2(this, _socketServerName2) === "socket-service") {
      return;
    }
    await __privateGet2(this, _roomNodeClient8).unpinChatMessage({ id });
  }
  get pinned() {
    return this.messages.filter((message2) => message2.pinned);
  }
}
_self5 = new WeakMap();
_chatSocketHandler = new WeakMap();
_roomNodeClient8 = new WeakMap();
_socketServerName2 = new WeakMap();
__decorateClass$6([
  DyteTelemetry.trace("sendTextMessage")
], DyteChat.prototype, "sendTextMessage", 1);
__decorateClass$6([
  DyteTelemetry.trace("sendImageMessage")
], DyteChat.prototype, "sendImageMessage", 1);
__decorateClass$6([
  DyteTelemetry.trace("sendFileMessage")
], DyteChat.prototype, "sendFileMessage", 1);
__decorateClass$6([
  DyteTelemetry.trace("sendMessage")
], DyteChat.prototype, "sendMessage", 1);
__decorateClass$6([
  DyteTelemetry.trace("editTextMessage")
], DyteChat.prototype, "editTextMessage", 1);
__decorateClass$6([
  DyteTelemetry.trace("editImageMessage")
], DyteChat.prototype, "editImageMessage", 1);
__decorateClass$6([
  DyteTelemetry.trace("editFileMessage")
], DyteChat.prototype, "editFileMessage", 1);
__decorateClass$6([
  DyteTelemetry.trace("editMessage")
], DyteChat.prototype, "editMessage", 1);
__decorateClass$6([
  DyteTelemetry.trace("deleteMessage")
], DyteChat.prototype, "deleteMessage", 1);
var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __decorateClass$5 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$5(target, key, result);
  return result;
};
const _ChatController = (_f = class {
  constructor(chatSocketHandler, roomNodeClient, socketServerName, self2) {
    __publicField(this, "chat");
    __publicField(this, "chatSocketHandler");
    __privateAdd2(this, _roomNodeClient9, void 0);
    __privateAdd2(this, _socketServerName3, void 0);
    this.chatSocketHandler = chatSocketHandler;
    __privateSet2(this, _roomNodeClient9, roomNodeClient);
    __privateSet2(this, _socketServerName3, socketServerName);
    this.chat = new DyteChat(chatSocketHandler, roomNodeClient, socketServerName, self2);
    this.setupEvents();
  }
  static async init(chatSocketHandler, roomNodeClient, self2) {
    const flagsmithChatSocketServer = !constants.isV2AuthToken && await dist$1.globalFlagsmith.getValue(FlagsmithFeatureFlags.CHAT_SOCKET_SERVER);
    log.debug(`Received flagsmith chat_socket_server: ${flagsmithChatSocketServer}`);
    const socketServerName = flagsmithChatSocketServer === "socket-service" ? "socket-service" : "room-node";
    log.info(`Using socket server: ${socketServerName}`);
    return new _ChatController(chatSocketHandler, roomNodeClient, socketServerName, self2);
  }
  static formatMessage(message2) {
    return __spreadProps(__spreadValues({}, message2), {
      time: new Date(message2.time),
      type: messageTypes[message2.type]
    });
  }
  static formatSocketServiceMessage(sockMessage) {
    const chatMessage = {
      displayName: sockMessage.getDisplayName(),
      id: sockMessage.getChatId(),
      time: +sockMessage.getCreatedAt().toDate(),
      type: sockMessage.getPayloadType(),
      isEdited: sockMessage.getIsEdited(),
      userId: sockMessage.getUserId(),
      message: "",
      link: "",
      name: "",
      size: 0
    };
    switch (chatMessage.type) {
      case ChatMessageType.TEXT: {
        chatMessage.message = sockMessage.getPayload();
        break;
      }
      case ChatMessageType.IMAGE: {
        chatMessage.link = sockMessage.getPayload();
        break;
      }
      case ChatMessageType.FILE: {
        const { link, name, size } = JSON.parse(sockMessage.getPayload());
        chatMessage.link = link;
        chatMessage.name = name;
        chatMessage.size = size;
        break;
      }
    }
    return _ChatController.formatMessage(chatMessage);
  }
  async getChatMessages() {
    if (__privateGet2(this, _socketServerName3) === "socket-service") {
      const protoChatMessages = await this.chatSocketHandler.getChatMessages();
      const chatMessages = dist.GetChatMessagesResponse.deserializeBinary(protoChatMessages.payload).getMessagesList();
      this.chat.messages = chatMessages.map((m) => _ChatController.formatSocketServiceMessage(m));
      return;
    }
    const { messages } = (await __privateGet2(this, _roomNodeClient9).getChatMessages()).payload;
    this.chat.messages = messages.map(_ChatController.formatMessage);
  }
  setupEvents() {
    SessionStore.onAsync(SessionEvents.ROOM_JOINED, async () => {
      await this.getChatMessages();
      log.debug("[ROOM_JOINED] resolved request to fetch chat messages.");
    });
    if (__privateGet2(this, _socketServerName3) === "socket-service") {
      this.chatSocketHandler.socket.on(chatEvents.sendMessageToRoom, ({ payload }) => {
        const sockMessage = dist.SendChatMessageToRoomResponse.deserializeBinary(payload).getMessage();
        const message2 = _ChatController.formatSocketServiceMessage(sockMessage);
        this.chat.messages = [...this.chat.messages, message2];
        log.info("Emitting chatUpdate event for new message");
        this.chat.emit("chatUpdate", {
          action: "add",
          message: message2,
          messages: this.chat.messages
        });
      });
      this.chatSocketHandler.socket.on(chatEvents.sendMessageToPeers, ({ payload }) => {
        const sockMessage = dist.SendChatMessageToPeersResponse.deserializeBinary(payload).getMessage();
        const message2 = _ChatController.formatSocketServiceMessage(sockMessage);
        this.chat.messages = [...this.chat.messages, message2];
        log.info("Emitting chatUpdate event for new message");
        this.chat.emit("chatUpdate", {
          action: "add",
          message: message2,
          messages: this.chat.messages
        });
      });
      this.chatSocketHandler.socket.on(chatEvents.editMessage, ({ payload }) => {
        const sockMessage = dist.EditChatMessageResponse.deserializeBinary(payload).getMessage();
        const message2 = _ChatController.formatSocketServiceMessage(sockMessage);
        const index = this.chat.messages.findIndex((m) => m.id === message2.id);
        if (index === -1)
          return;
        this.chat.messages[index] = message2;
        this.chat.emit("chatUpdate", {
          action: "edit",
          message: message2,
          messages: this.chat.messages
        });
      });
      this.chatSocketHandler.socket.on(chatEvents.deleteMessage, ({ payload }) => {
        const sockMessageId = dist.DeleteChatMessageResponse.deserializeBinary(payload).getChatId();
        const index = this.chat.messages.findIndex((m) => m.id === sockMessageId);
        if (index === -1)
          return;
        const [message2] = this.chat.messages.splice(index, 1);
        this.chat.emit("chatUpdate", {
          action: "delete",
          message: message2,
          messages: this.chat.messages
        });
      });
      return;
    }
    SessionStore.on(SessionEvents.NEW_CHAT_MESSAGE, (payload) => {
      if (messageTypes[payload == null ? void 0 : payload.type] === "poll")
        return;
      const message2 = _ChatController.formatMessage(payload);
      this.chat.messages = [...this.chat.messages, message2];
      this.chat.emit("chatUpdate", {
        message: message2,
        messages: this.chat.messages
      });
    });
    SessionStore.on(SessionEvents.PIN_CHAT_MESSAGE, async (payload) => {
      const message2 = _ChatController.formatMessage(payload);
      const index = this.chat.messages.findIndex((msg) => msg.id === message2.id);
      this.chat.messages[index] = message2;
      this.chat.emit("pinMessage", {
        message: message2,
        messages: this.chat.messages
      });
    });
    SessionStore.on(SessionEvents.UNPIN_CHAT_MESSAGE, async (payload) => {
      const message2 = _ChatController.formatMessage(payload);
      const index = this.chat.messages.findIndex((msg) => msg.id === message2.id);
      this.chat.messages[index] = message2;
      this.chat.emit("unpinMessage", {
        message: message2,
        messages: this.chat.messages
      });
    });
  }
}, _roomNodeClient9 = new WeakMap(), _socketServerName3 = new WeakMap(), _f);
let ChatController = _ChatController;
__decorateClass$5([
  DyteTelemetry.trace("ChatController.setupEvents")
], ChatController.prototype, "setupEvents", 1);
var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$4(target, key, result);
  return result;
};
const _PluginController = (_g = class {
  constructor(pluginSocketHandler, chatSocketHandler, roomNodeClient, socketServerName, plugins, self2) {
    __publicField(this, "plugins");
    __privateAdd2(this, _self6, void 0);
    __privateAdd2(this, _pluginSocketHandler2, void 0);
    __privateAdd2(this, _roomNodeClient10, void 0);
    __privateAdd2(this, _socketServerName4, void 0);
    __privateAdd2(this, _chatSocketHandler2, void 0);
    __privateSet2(this, _pluginSocketHandler2, pluginSocketHandler);
    __privateSet2(this, _chatSocketHandler2, chatSocketHandler);
    __privateSet2(this, _roomNodeClient10, roomNodeClient);
    __privateSet2(this, _socketServerName4, socketServerName);
    this.plugins = plugins;
    __privateSet2(this, _self6, self2);
    this.setupEvents();
  }
  static async init(pluginSocketHandler, chatSocketHandler, chat, roomNodeClient, self2, participants) {
    const APIClient2 = getAPIClient();
    const receivedPlugins = await APIClient2.getPlugins();
    const flagsmithPluginSocketServer = constants.isV2AuthToken ? false : dist$1.globalFlagsmith.getValue(FlagsmithFeatureFlags.PLUGIN_SOCKET_SERVER);
    log.debug(`Received flagsmith plugin_socket_server: ${flagsmithPluginSocketServer}`);
    const socketServerName = flagsmithPluginSocketServer === "socket-service" ? "socket-service" : "room-node";
    log.info(`Using socket server: ${socketServerName}`);
    const plugins = new DytePlugins();
    const flagsmithDevModePlugins = JSON.parse(dist$1.globalFlagsmith.getValue(FlagsmithFeatureFlags.DEV_MODE_PLUGINS) || "[]");
    receivedPlugins.forEach((p) => {
      if (flagsmithDevModePlugins.includes(p.id))
        return;
      const plugin = new DytePlugin(p, pluginSocketHandler, roomNodeClient, socketServerName, self2, participants, chat);
      plugins.all.add(plugin);
    });
    return new _PluginController(pluginSocketHandler, chatSocketHandler, roomNodeClient, socketServerName, plugins, self2);
  }
  async getRoomPlugins() {
    if (__privateGet2(this, _socketServerName4) === "socket-service") {
      const plugins = (await __privateGet2(this, _pluginSocketHandler2).getActivePlugins()).getPluginsList();
      await Promise.all(plugins.map((plugin) => this.enablePlugin({
        id: plugin.getPluginId(),
        enabledBy: plugin.getEnabledBy()
      })));
      return;
    }
    const { payload } = await __privateGet2(this, _roomNodeClient10).getRoomState();
    await Promise.all(payload.roomState.plugins.map((plugin) => this.enablePlugin(plugin)));
  }
  async enablePlugin({ id, enabledBy }) {
    const plugin = this.plugins.all.get(id);
    if (!plugin) {
      return;
    }
    await plugin.enable();
    plugin.enabledBy = enabledBy;
  }
  async disablePlugin({ id }) {
    const plugin = this.plugins.all.get(id);
    if (!plugin) {
      return;
    }
    plugin.disable();
  }
  sendIframeEventOld(event, payload) {
    const { id } = payload;
    const plugin = this.plugins.all.get(id);
    if (!plugin)
      return;
    plugin.sendIframeEvent({ type: event, payload });
  }
  sendIframeEvent(event, pluginId, uuid, payload) {
    const plugin = this.plugins.all.get(pluginId);
    if (!pluginId)
      return;
    plugin.sendIframeEvent({ type: event, uuid, payload });
  }
  broadcastIframeEventOld(event, payload) {
    this.plugins.active.forEach((plugin) => {
      this.sendIframeEventOld(event, __spreadProps(__spreadValues({}, payload), { id: plugin.id }));
    });
  }
  broadcastIframeEvent(event, payload) {
    this.plugins.active.forEach((plugin) => {
      this.sendIframeEvent(event, plugin.id, "", payload);
    });
  }
  setupEvents() {
    this.plugins.all.on("stateUpdate", ({ active, id }) => {
      if (active) {
        this.plugins.active.add(this.plugins.all.get(id));
        return;
      }
      this.plugins.active.delete(id);
    });
    SessionStore.onAsync(SessionEvents.ROOM_JOINED, async () => {
      await this.getRoomPlugins();
      log.debug("[ROOM_JOINED] resolved request to fetch plugins.");
    });
    if (__privateGet2(this, _socketServerName4) === "socket-service") {
      __privateGet2(this, _pluginSocketHandler2).socket.on(pluginEvents.addPlugin, async ({ payload }) => {
        var _a3;
        const plugin = dist.EnablePluginResponse.deserializeBinary(payload);
        const id = plugin.getPluginId();
        if ((_a3 = this.plugins.all.get(id)) == null ? void 0 : _a3.active) {
          return;
        }
        await this.enablePlugin({ id, enabledBy: plugin.getEnabledBy() });
      });
      __privateGet2(this, _pluginSocketHandler2).socket.on(pluginEvents.removePlugin, async ({ payload }) => {
        var _a3;
        const id = dist.DisablePluginResponse.deserializeBinary(payload).getPluginId();
        if (!((_a3 = this.plugins.all.get(id)) == null ? void 0 : _a3.active)) {
          return;
        }
        await this.disablePlugin({ id });
      });
      [
        pluginEvents.enablePluginForPeers,
        pluginEvents.enablePluginForRoom
      ].forEach((event) => {
        __privateGet2(this, _pluginSocketHandler2).socket.on(event, async ({ payload, id }) => {
          const plugin = dist.EnablePluginResponse.deserializeBinary(payload);
          this.sendIframeEvent(event, plugin.getPluginId(), id, {
            enabledBy: plugin.getEnabledBy()
          });
        });
      });
      [
        pluginEvents.disablePluginForPeers,
        pluginEvents.disablePluginForRoom
      ].forEach((event) => {
        __privateGet2(this, _pluginSocketHandler2).socket.on(event, async ({ payload, id }) => {
          const plugin = dist.DisablePluginResponse.deserializeBinary(payload);
          this.sendIframeEvent(event, plugin.getPluginId(), id, {
            disabledBy: plugin.getDisabledBy()
          });
        });
      });
      [
        pluginEvents.customPluginEventToPeers,
        pluginEvents.customPluginEventToRoom
      ].forEach((event) => {
        __privateGet2(this, _pluginSocketHandler2).socket.on(event, async ({ payload, id }) => {
          const plugin = dist.PluginEventResponse.deserializeBinary(payload);
          this.sendIframeEvent(event, plugin.getPluginId(), id, {
            data: JSON.parse(new TextDecoder().decode(plugin.getPluginData()))
          });
        });
      });
      [
        pluginEvents.storeInsertKeys,
        pluginEvents.storeGetKeys,
        pluginEvents.storeDeleteKeys
      ].forEach((event) => {
        __privateGet2(this, _pluginSocketHandler2).socket.on(event, async ({ payload, id }) => {
          var _a3;
          const plugin = dist.PluginStoreResponse.deserializeBinary(payload);
          const storeItems = (_a3 = plugin.getStoreItemsList()) == null ? void 0 : _a3.map((storeItem) => ({
            timestamp: storeItem.getTimestamp(),
            peerId: storeItem.getPeerId(),
            payload: JSON.parse(storeItem.getPayload() ? new TextDecoder().decode(storeItem.getPayload()) : "{}"),
            key: storeItem.getStoreKey()
          }));
          this.sendIframeEvent(event, plugin.getPluginId(), id, {
            storeName: plugin.getStoreName(),
            storeItems
          });
        });
      });
      __privateGet2(this, _pluginSocketHandler2).socket.on(pluginEvents.storeDelete, async ({ payload, id }) => {
        const plugin = dist.PluginStoreResponse.deserializeBinary(payload);
        this.sendIframeEvent(pluginEvents.storeDelete, plugin.getPluginId(), id, {
          storeName: plugin.getStoreName()
        });
      });
      __privateGet2(this, _chatSocketHandler2).socket.on(chatEvents.sendMessageToPeers, ({ payload }) => {
        const sockMessage = dist.SendChatMessageToPeersResponse.deserializeBinary(payload).getMessage();
        const message2 = ChatController == null ? void 0 : ChatController.formatSocketServiceMessage(sockMessage);
        this.broadcastIframeEvent(localPluginEvents.chatMessage, { message: message2 });
      });
      __privateGet2(this, _chatSocketHandler2).socket.on(chatEvents.sendMessageToRoom, ({ payload }) => {
        const sockMessage = dist.SendChatMessageToRoomResponse.deserializeBinary(payload).getMessage();
        const message2 = ChatController == null ? void 0 : ChatController.formatSocketServiceMessage(sockMessage);
        this.broadcastIframeEvent(localPluginEvents.chatMessage, { message: message2 });
      });
      SessionStore.on(SessionEvents.PEER_JOINED, (payload) => {
        this.broadcastIframeEvent(localPluginEvents.peerJoined, payload);
      });
      SessionStore.on(SessionEvents.PEER_CLOSED, (payload) => {
        this.broadcastIframeEvent(localPluginEvents.peerLeft, payload);
      });
      return;
    }
    SessionStore.on(SessionEvents.ENABLE_PLUGIN, async ({ id, enabledBy }) => {
      await this.enablePlugin({ id, enabledBy });
    });
    SessionStore.on(SessionEvents.DISABLE_PLUGIN, async ({ id }) => {
      await this.disablePlugin({ id });
    });
    [
      SessionEvents.PLUGIN_DATA,
      SessionEvents.PLUGIN_EVENT
    ].forEach((event) => {
      SessionStore.on(event, (payload) => {
        this.sendIframeEventOld(event, payload);
      });
    });
    [
      SessionEvents.PEER_JOINED,
      SessionEvents.PEER_CLOSED,
      SessionEvents.NEW_CHAT_MESSAGE
    ].forEach((event) => {
      SessionStore.on(event, (payload) => {
        this.broadcastIframeEventOld(event, payload);
      });
    });
  }
}, _self6 = new WeakMap(), _pluginSocketHandler2 = new WeakMap(), _roomNodeClient10 = new WeakMap(), _socketServerName4 = new WeakMap(), _chatSocketHandler2 = new WeakMap(), _g);
let PluginController = _PluginController;
__decorateClass$4([
  DyteTelemetry.trace("PluginController.setupEvents")
], PluginController.prototype, "setupEvents", 1);
function setupMediaPolyfill() {
  if (browserSpecs.isElectron()) {
    if (window.dyteElectronGetDisplayMediaSource) {
      navigator.mediaDevices.getDisplayMedia = async (constraints) => {
        const source = await window.dyteElectronGetDisplayMediaSource({
          types: ["window", "screen"]
        });
        let video = false;
        if (constraints.video) {
          const videoConstrainst = constraints.video;
          video = {
            mandatory: {
              chromeMediaSource: "desktop",
              chromeMediaSourceId: source.id,
              maxWidth: videoConstrainst.width.max,
              maxHeight: videoConstrainst.height.max
            }
          };
        }
        const electronConstraints = {
          audio: false,
          video
        };
        const stream = await navigator.mediaDevices.getUserMedia(electronConstraints);
        return stream;
      };
    }
  }
}
class DytePolls extends DyteEventEmitter {
  constructor(roomNodeClient, self2) {
    super();
    __publicField(this, "items");
    __privateAdd2(this, _roomNodeClient11, void 0);
    __privateAdd2(this, _self7, void 0);
    __privateSet2(this, _roomNodeClient11, roomNodeClient);
    __privateSet2(this, _self7, self2);
    this.items = [];
  }
  async create(question, options, anonymous = false, hideVotes = false) {
    if (!__privateGet2(this, _self7).permissions.polls.canCreate) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePolls::create::permission_denied");
      return;
    }
    if (!question || !options) {
      DyteTelemetry.addEventInCurrentSpan("error", "question_and_options_can_not_be_empty", {
        question,
        options
      });
      return;
    }
    if (options.length < 2) {
      DyteTelemetry.addEventInCurrentSpan("error", "there_must_be_at_least_two_options", { options });
      return;
    }
    const pollCreateMessage = {
      question,
      options,
      anonymous,
      hideVotes,
      createdBy: __privateGet2(this, _self7).name,
      createdByUserId: __privateGet2(this, _self7).userId
    };
    await __privateGet2(this, _roomNodeClient11).newPoll(pollCreateMessage);
  }
  async vote(id, index) {
    if (!__privateGet2(this, _self7).permissions.polls.canVote) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePolls::vote::permission_denied");
      return;
    }
    const pollVoteMessage = {
      pollId: id,
      index
    };
    await __privateGet2(this, _roomNodeClient11).votePoll(pollVoteMessage);
  }
}
_roomNodeClient11 = new WeakMap();
_self7 = new WeakMap();
var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$3(target, key, result);
  return result;
};
class PollController {
  constructor(roomNodeClient, self2) {
    __publicField(this, "polls");
    __privateAdd2(this, _roomNodeClient12, void 0);
    __privateAdd2(this, _self8, void 0);
    __privateSet2(this, _roomNodeClient12, roomNodeClient);
    this.polls = new DytePolls(roomNodeClient, self2);
    __privateSet2(this, _self8, self2);
    this.setupEvents();
  }
  canViewPolls() {
    return constants.isV2AuthToken ? __privateGet2(this, _self8).permissions.polls.canViewResults || __privateGet2(this, _self8).permissions.polls.canVote : __privateGet2(this, _self8).permissions.polls.canView;
  }
  setupEvents() {
    SessionStore.onAsync(SessionEvents.ROOM_JOINED, async () => {
      if (!this.canViewPolls()) {
        return;
      }
      const { polls } = (await __privateGet2(this, _roomNodeClient12).getPolls()).payload;
      this.polls.items = Object.values(polls);
      log.debug("[ROOM_JOINED] resolved request to fetch polls.");
    });
    SessionStore.on(SessionEvents.UPDATE_POLL, async ({ poll }) => {
      if (!this.canViewPolls()) {
        return;
      }
      const index = this.polls.items.findIndex((p) => p.id === poll.id);
      if (index > -1) {
        const oldPoll = JSON.stringify(this.polls.items[index]);
        this.polls.items[index] = poll;
        if (oldPoll !== JSON.stringify(poll)) {
          this.polls.emit("pollsUpdate", { polls: this.polls.items });
        }
        return;
      }
      this.polls.items = [...this.polls.items, poll];
      this.polls.emit("pollsUpdate", { polls: this.polls.items });
    });
  }
}
_roomNodeClient12 = new WeakMap();
_self8 = new WeakMap();
__decorateClass$3([
  DyteTelemetry.trace("PollController.setupEvents")
], PollController.prototype, "setupEvents", 1);
class DyteRemoteMap extends DyteMap {
  constructor() {
    super({
      onAddEvent: "remoteRequestAdd",
      onDeleteEvent: "remoteRequestRemove"
    });
  }
  add(request, emitEvent = true) {
    return super.add(request, emitEvent);
  }
  delete(requestId, emitEvent = true, removeListeners = false) {
    return super.delete(requestId, emitEvent, removeListeners);
  }
}
const _DyteRemote = class extends DyteEventEmitter {
  constructor(roomNodeClient, self2, participants) {
    super();
    __publicField(this, "incomingRequests");
    __publicField(this, "outgoingRequests");
    __publicField(this, "active");
    __privateAdd2(this, _roomNodeClient13, void 0);
    __privateAdd2(this, _self9, void 0);
    __privateAdd2(this, _participants2, void 0);
    __privateSet2(this, _roomNodeClient13, roomNodeClient);
    __privateSet2(this, _participants2, participants);
    __privateSet2(this, _self9, self2);
    this.incomingRequests = new DyteRemoteMap();
    this.outgoingRequests = new DyteRemoteMap();
    this.active = null;
    this.mouseEvent = this.mouseEvent.bind(this);
    this.keyboardEvent = this.keyboardEvent.bind(this);
  }
  async requestControl(peerId) {
    var _a3;
    const peer = __privateGet2(this, _participants2).joined.get(peerId);
    if (!peer) {
      throw new DyteError("Invalid peer.");
    }
    const duplicateRequest = (_a3 = this.outgoingRequests) == null ? void 0 : _a3.toArray().find((request2) => request2.hostPeerId === peerId);
    if (duplicateRequest) {
      return duplicateRequest.id;
    }
    const requestId = v4();
    const request = new DyteRemoteRequest({
      requestId,
      hostPeerId: peerId,
      remotePeerId: __privateGet2(this, _self9).id,
      state: RemoteRequestState.PENDING
    });
    this.outgoingRequests.add(request);
    await __privateGet2(this, _roomNodeClient13).requestRemoteControl(request);
    this.emit("remoteUpdate", {
      payload: {
        request: {
          id: request.id,
          hostPeerId: request.hostPeerId,
          remotePeerId: request.remotePeerId
        }
      },
      type: RemoteUpdateType.REQUEST_SENT
    });
    return requestId;
  }
  async acceptControl(requestId) {
    var _a3;
    if (((_a3 = this.active) == null ? void 0 : _a3.id) === requestId) {
      return;
    }
    const request = this.incomingRequests.get(requestId);
    if (!request)
      throw new DyteError("No request found.");
    request.state = RemoteRequestState.ACCEPTED;
    this.endControl();
    this.active = request;
    __privateGet2(this, _roomNodeClient13).acceptRemoteControl(request);
    this.emit("remoteUpdate", {
      payload: {
        request: {
          id: this.active.id,
          hostPeerId: this.active.hostPeerId,
          remotePeerId: this.active.remotePeerId
        }
      },
      type: RemoteUpdateType.INCOMING_REQUEST_ACCEPTED
    });
  }
  async endControl() {
    if (!this.active) {
      return;
    }
    const lastActiveControl = __spreadValues({}, this.active);
    __privateGet2(this, _roomNodeClient13).terminateRemoteControl(this.active.hostPeerId === __privateGet2(this, _self9).id ? this.active.remotePeerId : this.active.hostPeerId, this.active);
    this.active = null;
    this.emit("remoteUpdate", {
      payload: {
        request: {
          id: lastActiveControl.id,
          hostPeerId: lastActiveControl.hostPeerId,
          remotePeerId: lastActiveControl.remotePeerId
        }
      },
      type: lastActiveControl.hostPeerId === __privateGet2(this, _self9).id ? RemoteUpdateType.INCOMING_REQUEST_ENDED : RemoteUpdateType.OUTGOING_REQUEST_ENDED
    });
  }
  async keyboardEvent(event) {
    if (!this.active) {
      return;
    }
    const keyboardEvent = _DyteRemote.getFormattedKeyboardEvent(event);
    if (keyboardEvent) {
      const data = {
        eventType: RemoteEventType.KEYBOARD,
        keyboardEvent
      };
      __privateGet2(this, _roomNodeClient13).sendEventRemoteControl(this.active.hostPeerId, this.active.id, data);
    }
  }
  async mouseEvent(event, screenShareVideoElement) {
    if (!this.active) {
      return;
    }
    const mouseEvent = _DyteRemote.getFormattedRemoteMouseEvent(event, screenShareVideoElement);
    if (mouseEvent) {
      const data = {
        eventType: RemoteEventType.MOUSE,
        mouseEvent
      };
      __privateGet2(this, _roomNodeClient13).sendEventRemoteControl(this.active.hostPeerId, this.active.id, data);
    }
  }
  static getFormattedRemoteMouseEvent(event, screenShareVideoElement) {
    const remoteRect = screenShareVideoElement.getBoundingClientRect();
    const formattedEvent = {
      type: event.type,
      position: {
        x: Math.floor(event.x - remoteRect.left),
        y: Math.floor(event.y - remoteRect.top)
      },
      boundingRect: {
        width: remoteRect.width,
        height: remoteRect.height
      }
    };
    return formattedEvent;
  }
  static getFormattedKeyboardEvent(event) {
    if (event.type === "keydown") {
      const formattedEvent = {
        type: event.type,
        key: event.key
      };
      return formattedEvent;
    }
    return null;
  }
};
let DyteRemote = _DyteRemote;
_roomNodeClient13 = new WeakMap();
_self9 = new WeakMap();
_participants2 = new WeakMap();
const _RemoteController = class {
  constructor(roomNodeClient, self2, participants) {
    __publicField(this, "remote");
    __publicField(this, "hostPeetId");
    __publicField(this, "remotePeetId");
    __publicField(this, "remoteRequestTokens");
    __publicField(this, "activeRemoteToken");
    __privateAdd2(this, _roomNodeClient14, void 0);
    __privateAdd2(this, _self10, void 0);
    __privateAdd2(this, _participants3, void 0);
    __privateSet2(this, _roomNodeClient14, roomNodeClient);
    __privateSet2(this, _self10, self2);
    __privateSet2(this, _participants3, participants);
    this.hostPeetId = self2.id;
    this.remote = new DyteRemote(roomNodeClient, self2, participants);
    this.setupEvents();
  }
  setupEvents() {
    SessionStore.on(SessionEvents.MESSAGE, (payload) => {
      var _a3;
      if (payload.remoteRequestType === RemoteRequestType.REQUEST) {
        this.remote.incomingRequests.add(new DyteRemoteRequest({
          requestId: payload.remoteRequestId,
          hostPeerId: payload.hostPeerId,
          remotePeerId: payload.remotePeerId,
          state: RemoteRequestState.PENDING
        }));
        this.remote.emit("remoteUpdate", {
          payload: {
            request: {
              id: payload.remoteRequestId,
              hostPeerId: payload.hostPeerId,
              remotePeerId: payload.remotePeerId
            }
          },
          type: RemoteUpdateType.REQUEST_RECEIVED
        });
      }
      if (payload.remoteRequestType === RemoteRequestType.ACCEPT) {
        const outgoingRequest = this.remote.outgoingRequests.get(payload.remoteRequestId);
        if (!outgoingRequest) {
          throw new DyteError("There is no pending remote control request to accept.");
        }
        this.remote.endControl();
        outgoingRequest.state = RemoteRequestState.ACCEPTED;
        this.remote.active = new DyteRemoteRequest({
          requestId: payload.remoteRequestId,
          hostPeerId: payload.hostPeerId,
          remotePeerId: payload.remotePeerId,
          state: RemoteRequestState.ACCEPTED
        });
        this.remote.emit("remoteUpdate", {
          payload: {
            request: {
              id: payload.remoteRequestId,
              hostPeerId: payload.hostPeerId,
              remotePeerId: payload.remotePeerId
            }
          },
          type: RemoteUpdateType.OUTGOING_REQUEST_ACCEPTED
        });
      }
      if (payload.remoteRequestType === RemoteRequestType.END) {
        if (((_a3 = this.remote.active) == null ? void 0 : _a3.id) === payload.remoteRequestId) {
          this.remote.active = null;
        }
        this.remote.emit("remoteUpdate", {
          payload: {
            request: {
              id: payload.remoteRequestId,
              hostPeerId: payload.hostPeerId,
              remotePeerId: payload.remotePeerId
            }
          },
          type: payload.hostPeerId === __privateGet2(this, _self10).id ? RemoteUpdateType.INCOMING_REQUEST_ENDED : RemoteUpdateType.OUTGOING_REQUEST_ENDED
        });
      }
      if (payload.remoteRequestType === RemoteRequestType.EVENT && this.remote.active && this.remote.active.id === payload.remoteRequestId) {
        if (window.DyteRobot) {
          if (payload.remoteEvent.eventType === RemoteEventType.MOUSE) {
            _RemoteController.executeMouseEvent(payload.remoteEvent.mouseEvent);
          } else if (payload.remoteEvent.eventType === RemoteEventType.KEYBOARD) {
            _RemoteController.executeKeyboardEvent(payload.remoteEvent.keyboardEvent);
          }
        }
      }
    });
    SessionStore.on(SessionEvents.PEER_CLOSED, ({ id: closedPeerId }) => {
      var _a3, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
      if ([
        (_b2 = (_a3 = this.remote) == null ? void 0 : _a3.active) == null ? void 0 : _b2.hostPeerId,
        (_d2 = (_c2 = this.remote) == null ? void 0 : _c2.active) == null ? void 0 : _d2.remotePeerId
      ].includes(closedPeerId)) {
        this.remote.endControl();
      }
      (_f2 = (_e2 = this.remote) == null ? void 0 : _e2.incomingRequests) == null ? void 0 : _f2.toArray().forEach((req) => {
        if ([req.hostPeerId, req.remotePeerId].includes(closedPeerId)) {
          this.remote.incomingRequests.delete(req.id);
        }
      });
      (_h2 = (_g2 = this.remote) == null ? void 0 : _g2.outgoingRequests) == null ? void 0 : _h2.toArray().forEach((req) => {
        if ([req.hostPeerId, req.remotePeerId].includes(closedPeerId)) {
          this.remote.outgoingRequests.delete(req.id);
        }
      });
    });
  }
  static executeMouseEvent(mouseEvent) {
    const xOnThisScreen = window.screen.width * mouseEvent.position.x / mouseEvent.boundingRect.width;
    const yOnThisScreen = window.screen.height * mouseEvent.position.y / mouseEvent.boundingRect.height;
    const browserScreen = {
      width: window.screen.width,
      height: window.screen.height
    };
    switch (mouseEvent.type) {
      case RemoteMouseEventTypes.LEFT_CLICK:
        window.DyteRobot.mouse.leftClick(xOnThisScreen, yOnThisScreen, browserScreen);
        break;
      case RemoteMouseEventTypes.RIGHT_CLICK:
        window.DyteRobot.mouse.rightClick(xOnThisScreen, yOnThisScreen, browserScreen);
        break;
      case RemoteMouseEventTypes.MOVE:
        window.DyteRobot.mouse.moveTo(xOnThisScreen, yOnThisScreen, browserScreen);
        break;
    }
  }
  static executeKeyboardEvent(keyboardEvent) {
    switch (keyboardEvent.type) {
      case "keydown":
        window.DyteRobot.keyboard.press(keyboardEvent.key);
        break;
    }
  }
};
let RemoteController = _RemoteController;
_roomNodeClient14 = new WeakMap();
_self10 = new WeakMap();
_participants3 = new WeakMap();
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _logger, _level, _ws, _url, _config, _shouldConnect, _currentTimeout, _logger2, _sendQueue, _eventEmitter, _constructWebSocketAddress, constructWebSocketAddress_fn, _onMessage, onMessage_fn, _handleErrors, handleErrors_fn, _send, send_fn;
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var events = { exports: {} };
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply22(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target);
  };
}
function ProcessEmitWarning(warning) {
  if (console && console.warn)
    console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN22(value) {
  return value !== value;
};
function EventEmitter() {
  EventEmitter.init.call(this);
}
events.exports = EventEmitter;
events.exports.once = once;
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = void 0;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(listener) {
  if (typeof listener !== "function") {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
    }
    defaultMaxListeners = arg;
  }
});
EventEmitter.init = function() {
  if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
    this._events = /* @__PURE__ */ Object.create(null);
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || void 0;
};
EventEmitter.prototype.setMaxListeners = function setMaxListeners2(n2) {
  if (typeof n2 !== "number" || n2 < 0 || NumberIsNaN(n2)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n2 + ".");
  }
  this._maxListeners = n2;
  return this;
};
function _getMaxListeners(that) {
  if (that._maxListeners === void 0)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners2() {
  return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit2(type) {
  var args = [];
  for (var i2 = 1; i2 < arguments.length; i2++)
    args.push(arguments[i2]);
  var doError = type === "error";
  var events2 = this._events;
  if (events2 !== void 0)
    doError = doError && events2.error === void 0;
  else if (!doError)
    return false;
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      throw er;
    }
    var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
    err.context = er;
    throw err;
  }
  var handler = events2[type];
  if (handler === void 0)
    return false;
  if (typeof handler === "function") {
    ReflectApply(handler, this, args);
  } else {
    var len2 = handler.length;
    var listeners22 = arrayClone(handler, len2);
    for (var i2 = 0; i2 < len2; ++i2)
      ReflectApply(listeners22[i2], this, args);
  }
  return true;
};
function _addListener(target, type, listener, prepend) {
  var m;
  var events2;
  var existing;
  checkListener(listener);
  events2 = target._events;
  if (events2 === void 0) {
    events2 = target._events = /* @__PURE__ */ Object.create(null);
    target._eventsCount = 0;
  } else {
    if (events2.newListener !== void 0) {
      target.emit("newListener", type, listener.listener ? listener.listener : listener);
      events2 = target._events;
    }
    existing = events2[type];
  }
  if (existing === void 0) {
    existing = events2[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === "function") {
      existing = events2[type] = prepend ? [listener, existing] : [existing, listener];
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      var w2 = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      w2.name = "MaxListenersExceededWarning";
      w2.emitter = target;
      w2.type = type;
      w2.count = existing.length;
      ProcessEmitWarning(w2);
    }
  }
  return target;
}
EventEmitter.prototype.addListener = function addListener2(type, listener) {
  return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener2(type, listener) {
  return _addListener(this, type, listener, true);
};
function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}
function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: void 0, target, type, listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}
EventEmitter.prototype.once = function once22(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener2(type, listener) {
  checkListener(listener);
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter.prototype.removeListener = function removeListener2(type, listener) {
  var list, events2, position, i2, originalListener;
  checkListener(listener);
  events2 = this._events;
  if (events2 === void 0)
    return this;
  list = events2[type];
  if (list === void 0)
    return this;
  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0)
      this._events = /* @__PURE__ */ Object.create(null);
    else {
      delete events2[type];
      if (events2.removeListener)
        this.emit("removeListener", type, list.listener || listener);
    }
  } else if (typeof list !== "function") {
    position = -1;
    for (i2 = list.length - 1; i2 >= 0; i2--) {
      if (list[i2] === listener || list[i2].listener === listener) {
        originalListener = list[i2].listener;
        position = i2;
        break;
      }
    }
    if (position < 0)
      return this;
    if (position === 0)
      list.shift();
    else {
      spliceOne(list, position);
    }
    if (list.length === 1)
      events2[type] = list[0];
    if (events2.removeListener !== void 0)
      this.emit("removeListener", type, originalListener || listener);
  }
  return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners2(type) {
  var listeners22, events2, i2;
  events2 = this._events;
  if (events2 === void 0)
    return this;
  if (events2.removeListener === void 0) {
    if (arguments.length === 0) {
      this._events = /* @__PURE__ */ Object.create(null);
      this._eventsCount = 0;
    } else if (events2[type] !== void 0) {
      if (--this._eventsCount === 0)
        this._events = /* @__PURE__ */ Object.create(null);
      else
        delete events2[type];
    }
    return this;
  }
  if (arguments.length === 0) {
    var keys = Object.keys(events2);
    var key;
    for (i2 = 0; i2 < keys.length; ++i2) {
      key = keys[i2];
      if (key === "removeListener")
        continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners("removeListener");
    this._events = /* @__PURE__ */ Object.create(null);
    this._eventsCount = 0;
    return this;
  }
  listeners22 = events2[type];
  if (typeof listeners22 === "function") {
    this.removeListener(type, listeners22);
  } else if (listeners22 !== void 0) {
    for (i2 = listeners22.length - 1; i2 >= 0; i2--) {
      this.removeListener(type, listeners22[i2]);
    }
  }
  return this;
};
function _listeners(target, type, unwrap) {
  var events2 = target._events;
  if (events2 === void 0)
    return [];
  var evlistener = events2[type];
  if (evlistener === void 0)
    return [];
  if (typeof evlistener === "function")
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners2(type) {
  return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners2(type) {
  return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === "function") {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events2 = this._events;
  if (events2 !== void 0) {
    var evlistener = events2[type];
    if (typeof evlistener === "function") {
      return 1;
    } else if (evlistener !== void 0) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter.prototype.eventNames = function eventNames2() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n2) {
  var copy = new Array(n2);
  for (var i2 = 0; i2 < n2; ++i2)
    copy[i2] = arr[i2];
  return copy;
}
function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}
function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i2 = 0; i2 < ret.length; ++i2) {
    ret[i2] = arr[i2].listener || arr[i2];
  }
  return ret;
}
function once(emitter, name) {
  return new Promise(function(resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }
    function resolver() {
      if (typeof emitter.removeListener === "function") {
        emitter.removeListener("error", errorListener);
      }
      resolve([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== "error") {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === "function") {
    eventTargetAgnosticAddListener(emitter, "error", handler, flags);
  }
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === "function") {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === "function") {
    emitter.addEventListener(name, function wrapListener(arg) {
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}
var EventEmitter$1 = events.exports;
const logLevels = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3
};
class Logger {
  constructor(level) {
    __privateAdd(this, _logger, void 0);
    __privateAdd(this, _level, void 0);
    __privateSet(this, _logger, console);
    __privateSet(this, _level, level);
  }
  debug(...args) {
    if (logLevels[__privateGet(this, _level)] > logLevels.debug) {
      return;
    }
    __privateGet(this, _logger).debug("[Sockrates]:", ...args);
  }
  info(...args) {
    if (logLevels[__privateGet(this, _level)] > logLevels.info) {
      return;
    }
    __privateGet(this, _logger).info("[Sockrates]:", ...args);
  }
  warn(...args) {
    if (logLevels[__privateGet(this, _level)] > logLevels.warn) {
      return;
    }
    __privateGet(this, _logger).warn("[Sockrates]:", ...args);
  }
  error(...args) {
    if (logLevels[__privateGet(this, _level)] > logLevels.error) {
      return;
    }
    __privateGet(this, _logger).error("[Sockrates]:", ...args);
  }
}
_logger = new WeakMap();
_level = new WeakMap();
var googleProtobuf = {};
(function(exports) {
  var $jscomp = $jscomp || {};
  $jscomp.scope = {};
  $jscomp.findInternal = function(a2, b, c) {
    a2 instanceof String && (a2 = String(a2));
    for (var d = a2.length, e = 0; e < d; e++) {
      var f = a2[e];
      if (b.call(c, f, e, a2))
        return { i: e, v: f };
    }
    return { i: -1, v: void 0 };
  };
  $jscomp.ASSUME_ES5 = false;
  $jscomp.ASSUME_NO_NATIVE_MAP = false;
  $jscomp.ASSUME_NO_NATIVE_SET = false;
  $jscomp.SIMPLE_FROUND_POLYFILL = false;
  $jscomp.defineProperty = $jscomp.ASSUME_ES5 || typeof Object.defineProperties == "function" ? Object.defineProperty : function(a2, b, c) {
    a2 != Array.prototype && a2 != Object.prototype && (a2[b] = c.value);
  };
  $jscomp.getGlobal = function(a2) {
    return typeof window != "undefined" && window === a2 ? a2 : typeof commonjsGlobal != "undefined" && commonjsGlobal != null ? commonjsGlobal : a2;
  };
  $jscomp.global = $jscomp.getGlobal(commonjsGlobal);
  $jscomp.polyfill = function(a2, b, c, d) {
    if (b) {
      c = $jscomp.global;
      a2 = a2.split(".");
      for (d = 0; d < a2.length - 1; d++) {
        var e = a2[d];
        e in c || (c[e] = {});
        c = c[e];
      }
      a2 = a2[a2.length - 1];
      d = c[a2];
      b = b(d);
      b != d && b != null && $jscomp.defineProperty(c, a2, { configurable: true, writable: true, value: b });
    }
  };
  $jscomp.polyfill("Array.prototype.findIndex", function(a2) {
    return a2 ? a2 : function(a3, c) {
      return $jscomp.findInternal(this, a3, c).i;
    };
  }, "es6", "es3");
  $jscomp.checkStringArgs = function(a2, b, c) {
    if (a2 == null)
      throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
    if (b instanceof RegExp)
      throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
    return a2 + "";
  };
  $jscomp.polyfill("String.prototype.endsWith", function(a2) {
    return a2 ? a2 : function(a3, c) {
      var b = $jscomp.checkStringArgs(this, a3, "endsWith");
      a3 += "";
      c === void 0 && (c = b.length);
      c = Math.max(0, Math.min(c | 0, b.length));
      for (var e = a3.length; 0 < e && 0 < c; )
        if (b[--c] != a3[--e])
          return false;
      return 0 >= e;
    };
  }, "es6", "es3");
  $jscomp.polyfill("Array.prototype.find", function(a2) {
    return a2 ? a2 : function(a3, c) {
      return $jscomp.findInternal(this, a3, c).v;
    };
  }, "es6", "es3");
  $jscomp.polyfill("String.prototype.startsWith", function(a2) {
    return a2 ? a2 : function(a3, c) {
      var b = $jscomp.checkStringArgs(this, a3, "startsWith");
      a3 += "";
      var e = b.length, f = a3.length;
      c = Math.max(0, Math.min(c | 0, b.length));
      for (var g = 0; g < f && c < e; )
        if (b[c++] != a3[g++])
          return false;
      return g >= f;
    };
  }, "es6", "es3");
  $jscomp.polyfill("String.prototype.repeat", function(a2) {
    return a2 ? a2 : function(a3) {
      var b = $jscomp.checkStringArgs(this, null, "repeat");
      if (0 > a3 || 1342177279 < a3)
        throw new RangeError("Invalid count value");
      a3 |= 0;
      for (var d = ""; a3; )
        if (a3 & 1 && (d += b), a3 >>>= 1)
          b += b;
      return d;
    };
  }, "es6", "es3");
  var COMPILED = true, goog = goog || {};
  goog.global = commonjsGlobal || self;
  goog.isDef = function(a2) {
    return a2 !== void 0;
  };
  goog.isString = function(a2) {
    return typeof a2 == "string";
  };
  goog.isBoolean = function(a2) {
    return typeof a2 == "boolean";
  };
  goog.isNumber = function(a2) {
    return typeof a2 == "number";
  };
  goog.exportPath_ = function(a2, b, c) {
    a2 = a2.split(".");
    c = c || goog.global;
    a2[0] in c || typeof c.execScript == "undefined" || c.execScript("var " + a2[0]);
    for (var d; a2.length && (d = a2.shift()); )
      !a2.length && goog.isDef(b) ? c[d] = b : c = c[d] && c[d] !== Object.prototype[d] ? c[d] : c[d] = {};
  };
  goog.define = function(a2, b) {
    return b;
  };
  goog.FEATURESET_YEAR = 2012;
  goog.DEBUG = true;
  goog.LOCALE = "en";
  goog.TRUSTED_SITE = true;
  goog.STRICT_MODE_COMPATIBLE = false;
  goog.DISALLOW_TEST_ONLY_CODE = !goog.DEBUG;
  goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = false;
  goog.provide = function(a2) {
    if (goog.isInModuleLoader_())
      throw Error("goog.provide cannot be used within a module.");
    goog.constructNamespace_(a2);
  };
  goog.constructNamespace_ = function(a2, b) {
    goog.exportPath_(a2, b);
  };
  goog.getScriptNonce = function(a2) {
    if (a2 && a2 != goog.global)
      return goog.getScriptNonce_(a2.document);
    goog.cspNonce_ === null && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document));
    return goog.cspNonce_;
  };
  goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/;
  goog.cspNonce_ = null;
  goog.getScriptNonce_ = function(a2) {
    return (a2 = a2.querySelector && a2.querySelector("script[nonce]")) && (a2 = a2.nonce || a2.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(a2) ? a2 : "";
  };
  goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
  goog.module = function(a2) {
    if (!goog.isString(a2) || !a2 || a2.search(goog.VALID_MODULE_RE_) == -1)
      throw Error("Invalid module identifier");
    if (!goog.isInGoogModuleLoader_())
      throw Error("Module " + a2 + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
    if (goog.moduleLoaderState_.moduleName)
      throw Error("goog.module may only be called once per module.");
    goog.moduleLoaderState_.moduleName = a2;
  };
  goog.module.get = function(a2) {
    return goog.module.getInternal_(a2);
  };
  goog.module.getInternal_ = function(a2) {
    return null;
  };
  goog.ModuleType = { ES6: "es6", GOOG: "goog" };
  goog.moduleLoaderState_ = null;
  goog.isInModuleLoader_ = function() {
    return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
  };
  goog.isInGoogModuleLoader_ = function() {
    return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
  };
  goog.isInEs6ModuleLoader_ = function() {
    if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6)
      return true;
    var a2 = goog.global.$jscomp;
    return a2 ? typeof a2.getCurrentModulePath != "function" ? false : !!a2.getCurrentModulePath() : false;
  };
  goog.module.declareLegacyNamespace = function() {
    goog.moduleLoaderState_.declareLegacyNamespace = true;
  };
  goog.declareModuleId = function(a2) {
    if (goog.moduleLoaderState_)
      goog.moduleLoaderState_.moduleName = a2;
    else {
      var b = goog.global.$jscomp;
      if (!b || typeof b.getCurrentModulePath != "function")
        throw Error('Module with namespace "' + a2 + '" has been loaded incorrectly.');
      b = b.require(b.getCurrentModulePath());
      goog.loadedModules_[a2] = { exports: b, type: goog.ModuleType.ES6, moduleId: a2 };
    }
  };
  goog.setTestOnly = function(a2) {
    if (goog.DISALLOW_TEST_ONLY_CODE)
      throw a2 = a2 || "", Error("Importing test-only code into non-debug environment" + (a2 ? ": " + a2 : "."));
  };
  goog.forwardDeclare = function(a2) {
  };
  goog.getObjectByName = function(a2, b) {
    a2 = a2.split(".");
    b = b || goog.global;
    for (var c = 0; c < a2.length; c++)
      if (b = b[a2[c]], !goog.isDefAndNotNull(b))
        return null;
    return b;
  };
  goog.globalize = function(a2, b) {
    b = b || goog.global;
    for (var c in a2)
      b[c] = a2[c];
  };
  goog.addDependency = function(a2, b, c, d) {
  };
  goog.ENABLE_DEBUG_LOADER = true;
  goog.logToConsole_ = function(a2) {
    goog.global.console && goog.global.console.error(a2);
  };
  goog.require = function(a2) {
  };
  goog.requireType = function(a2) {
    return {};
  };
  goog.basePath = "";
  goog.nullFunction = function() {
  };
  goog.abstractMethod = function() {
    throw Error("unimplemented abstract method");
  };
  goog.addSingletonGetter = function(a2) {
    a2.instance_ = void 0;
    a2.getInstance = function() {
      if (a2.instance_)
        return a2.instance_;
      goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a2);
      return a2.instance_ = new a2();
    };
  };
  goog.instantiatedSingletons_ = [];
  goog.LOAD_MODULE_USING_EVAL = true;
  goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
  goog.loadedModules_ = {};
  goog.DEPENDENCIES_ENABLED = !COMPILED;
  goog.TRANSPILE = "detect";
  goog.ASSUME_ES_MODULES_TRANSPILED = false;
  goog.TRANSPILE_TO_LANGUAGE = "";
  goog.TRANSPILER = "transpile.js";
  goog.hasBadLetScoping = null;
  goog.useSafari10Workaround = function() {
    if (goog.hasBadLetScoping == null) {
      try {
        var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
      } catch (b) {
        a = false;
      }
      goog.hasBadLetScoping = a;
    }
    return goog.hasBadLetScoping;
  };
  goog.workaroundSafari10EvalBug = function(a2) {
    return "(function(){" + a2 + "\n;})();\n";
  };
  goog.loadModule = function(a2) {
    var b = goog.moduleLoaderState_;
    try {
      goog.moduleLoaderState_ = { moduleName: "", declareLegacyNamespace: false, type: goog.ModuleType.GOOG };
      if (goog.isFunction(a2))
        var c = a2.call(void 0, {});
      else if (goog.isString(a2))
        goog.useSafari10Workaround() && (a2 = goog.workaroundSafari10EvalBug(a2)), c = goog.loadModuleFromSource_.call(void 0, a2);
      else
        throw Error("Invalid module definition");
      var d = goog.moduleLoaderState_.moduleName;
      if (goog.isString(d) && d)
        goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(d, c) : goog.SEAL_MODULE_EXPORTS && Object.seal && typeof c == "object" && c != null && Object.seal(c), goog.loadedModules_[d] = { exports: c, type: goog.ModuleType.GOOG, moduleId: goog.moduleLoaderState_.moduleName };
      else
        throw Error('Invalid module name "' + d + '"');
    } finally {
      goog.moduleLoaderState_ = b;
    }
  };
  goog.loadModuleFromSource_ = function(a) {
    eval(a);
    return {};
  };
  goog.normalizePath_ = function(a2) {
    a2 = a2.split("/");
    for (var b = 0; b < a2.length; )
      a2[b] == "." ? a2.splice(b, 1) : b && a2[b] == ".." && a2[b - 1] && a2[b - 1] != ".." ? a2.splice(--b, 2) : b++;
    return a2.join("/");
  };
  goog.loadFileSync_ = function(a2) {
    if (goog.global.CLOSURE_LOAD_FILE_SYNC)
      return goog.global.CLOSURE_LOAD_FILE_SYNC(a2);
    try {
      var b = new goog.global.XMLHttpRequest();
      b.open("get", a2, false);
      b.send();
      return b.status == 0 || b.status == 200 ? b.responseText : null;
    } catch (c) {
      return null;
    }
  };
  goog.transpile_ = function(a2, b, c) {
    var d = goog.global.$jscomp;
    d || (goog.global.$jscomp = d = {});
    var e = d.transpile;
    if (!e) {
      var f = goog.basePath + goog.TRANSPILER, g = goog.loadFileSync_(f);
      if (g) {
        (function() {
          (0, eval)(g + "\n//# sourceURL=" + f);
        }).call(goog.global);
        if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile)
          throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
        goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
        d = goog.global.$jscomp;
        e = d.transpile;
      }
    }
    e || (e = d.transpile = function(a3, b2) {
      goog.logToConsole_(b2 + " requires transpilation but no transpiler was found.");
      return a3;
    });
    return e(a2, b, c);
  };
  goog.typeOf = function(a2) {
    var b = typeof a2;
    if (b == "object")
      if (a2) {
        if (a2 instanceof Array)
          return "array";
        if (a2 instanceof Object)
          return b;
        var c = Object.prototype.toString.call(a2);
        if (c == "[object Window]")
          return "object";
        if (c == "[object Array]" || typeof a2.length == "number" && typeof a2.splice != "undefined" && typeof a2.propertyIsEnumerable != "undefined" && !a2.propertyIsEnumerable("splice"))
          return "array";
        if (c == "[object Function]" || typeof a2.call != "undefined" && typeof a2.propertyIsEnumerable != "undefined" && !a2.propertyIsEnumerable("call"))
          return "function";
      } else
        return "null";
    else if (b == "function" && typeof a2.call == "undefined")
      return "object";
    return b;
  };
  goog.isNull = function(a2) {
    return a2 === null;
  };
  goog.isDefAndNotNull = function(a2) {
    return a2 != null;
  };
  goog.isArray = function(a2) {
    return goog.typeOf(a2) == "array";
  };
  goog.isArrayLike = function(a2) {
    var b = goog.typeOf(a2);
    return b == "array" || b == "object" && typeof a2.length == "number";
  };
  goog.isDateLike = function(a2) {
    return goog.isObject(a2) && typeof a2.getFullYear == "function";
  };
  goog.isFunction = function(a2) {
    return goog.typeOf(a2) == "function";
  };
  goog.isObject = function(a2) {
    var b = typeof a2;
    return b == "object" && a2 != null || b == "function";
  };
  goog.getUid = function(a2) {
    return a2[goog.UID_PROPERTY_] || (a2[goog.UID_PROPERTY_] = ++goog.uidCounter_);
  };
  goog.hasUid = function(a2) {
    return !!a2[goog.UID_PROPERTY_];
  };
  goog.removeUid = function(a2) {
    a2 !== null && "removeAttribute" in a2 && a2.removeAttribute(goog.UID_PROPERTY_);
    try {
      delete a2[goog.UID_PROPERTY_];
    } catch (b) {
    }
  };
  goog.UID_PROPERTY_ = "closure_uid_" + (1e9 * Math.random() >>> 0);
  goog.uidCounter_ = 0;
  goog.getHashCode = goog.getUid;
  goog.removeHashCode = goog.removeUid;
  goog.cloneObject = function(a2) {
    var b = goog.typeOf(a2);
    if (b == "object" || b == "array") {
      if (typeof a2.clone === "function")
        return a2.clone();
      b = b == "array" ? [] : {};
      for (var c in a2)
        b[c] = goog.cloneObject(a2[c]);
      return b;
    }
    return a2;
  };
  goog.bindNative_ = function(a2, b, c) {
    return a2.call.apply(a2.bind, arguments);
  };
  goog.bindJs_ = function(a2, b, c) {
    if (!a2)
      throw Error();
    if (2 < arguments.length) {
      var d = Array.prototype.slice.call(arguments, 2);
      return function() {
        var c2 = Array.prototype.slice.call(arguments);
        Array.prototype.unshift.apply(c2, d);
        return a2.apply(b, c2);
      };
    }
    return function() {
      return a2.apply(b, arguments);
    };
  };
  goog.bind = function(a2, b, c) {
    Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
    return goog.bind.apply(null, arguments);
  };
  goog.partial = function(a2, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
      var b2 = c.slice();
      b2.push.apply(b2, arguments);
      return a2.apply(this, b2);
    };
  };
  goog.mixin = function(a2, b) {
    for (var c in b)
      a2[c] = b[c];
  };
  goog.now = goog.TRUSTED_SITE && Date.now || function() {
    return +new Date();
  };
  goog.globalEval = function(a2) {
    if (goog.global.execScript)
      goog.global.execScript(a2, "JavaScript");
    else if (goog.global.eval) {
      if (goog.evalWorksForGlobals_ == null) {
        try {
          goog.global.eval("var _evalTest_ = 1;");
        } catch (d) {
        }
        if (typeof goog.global._evalTest_ != "undefined") {
          try {
            delete goog.global._evalTest_;
          } catch (d) {
          }
          goog.evalWorksForGlobals_ = true;
        } else
          goog.evalWorksForGlobals_ = false;
      }
      if (goog.evalWorksForGlobals_)
        goog.global.eval(a2);
      else {
        var b = goog.global.document, c = b.createElement("SCRIPT");
        c.type = "text/javascript";
        c.defer = false;
        c.appendChild(b.createTextNode(a2));
        b.head.appendChild(c);
        b.head.removeChild(c);
      }
    } else
      throw Error("goog.globalEval not available");
  };
  goog.evalWorksForGlobals_ = null;
  goog.getCssName = function(a2, b) {
    if (String(a2).charAt(0) == ".")
      throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a2);
    var c = function(a3) {
      return goog.cssNameMapping_[a3] || a3;
    }, d = function(a3) {
      a3 = a3.split("-");
      for (var b2 = [], d2 = 0; d2 < a3.length; d2++)
        b2.push(c(a3[d2]));
      return b2.join("-");
    };
    d = goog.cssNameMapping_ ? goog.cssNameMappingStyle_ == "BY_WHOLE" ? c : d : function(a3) {
      return a3;
    };
    a2 = b ? a2 + "-" + d(b) : d(a2);
    return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(a2) : a2;
  };
  goog.setCssNameMapping = function(a2, b) {
    goog.cssNameMapping_ = a2;
    goog.cssNameMappingStyle_ = b;
  };
  goog.getMsg = function(a2, b, c) {
    c && c.html && (a2 = a2.replace(/</g, "&lt;"));
    b && (a2 = a2.replace(/\{\$([^}]+)}/g, function(a3, c2) {
      return b != null && c2 in b ? b[c2] : a3;
    }));
    return a2;
  };
  goog.getMsgWithFallback = function(a2, b) {
    return a2;
  };
  goog.exportSymbol = function(a2, b, c) {
    goog.exportPath_(a2, b, c);
  };
  goog.exportProperty = function(a2, b, c) {
    a2[b] = c;
  };
  goog.inherits = function(a2, b) {
    function c() {
    }
    c.prototype = b.prototype;
    a2.superClass_ = b.prototype;
    a2.prototype = new c();
    a2.prototype.constructor = a2;
    a2.base = function(a3, c2, f) {
      for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++)
        d[e - 2] = arguments[e];
      return b.prototype[c2].apply(a3, d);
    };
  };
  goog.base = function(a2, b, c) {
    var d = arguments.callee.caller;
    if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !d)
      throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");
    if (typeof d.superClass_ !== "undefined") {
      for (var e = Array(arguments.length - 1), f = 1; f < arguments.length; f++)
        e[f - 1] = arguments[f];
      return d.superClass_.constructor.apply(a2, e);
    }
    if (typeof b != "string" && typeof b != "symbol")
      throw Error("method names provided to goog.base must be a string or a symbol");
    e = Array(arguments.length - 2);
    for (f = 2; f < arguments.length; f++)
      e[f - 2] = arguments[f];
    f = false;
    for (var g = a2.constructor.prototype; g; g = Object.getPrototypeOf(g))
      if (g[b] === d)
        f = true;
      else if (f)
        return g[b].apply(a2, e);
    if (a2[b] === d)
      return a2.constructor.prototype[b].apply(a2, e);
    throw Error("goog.base called from a method of one name to a method of a different name");
  };
  goog.scope = function(a2) {
    if (goog.isInModuleLoader_())
      throw Error("goog.scope is not supported within a module.");
    a2.call(goog.global);
  };
  goog.defineClass = function(a2, b) {
    var c = b.constructor, d = b.statics;
    c && c != Object.prototype.constructor || (c = function() {
      throw Error("cannot instantiate an interface (no constructor defined).");
    });
    c = goog.defineClass.createSealingConstructor_(c, a2);
    a2 && goog.inherits(c, a2);
    delete b.constructor;
    delete b.statics;
    goog.defineClass.applyProperties_(c.prototype, b);
    d != null && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
    return c;
  };
  goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
  goog.defineClass.createSealingConstructor_ = function(a2, b) {
    if (!goog.defineClass.SEAL_CLASS_INSTANCES)
      return a2;
    var c = !goog.defineClass.isUnsealable_(b), d = function() {
      var b2 = a2.apply(this, arguments) || this;
      b2[goog.UID_PROPERTY_] = b2[goog.UID_PROPERTY_];
      this.constructor === d && c && Object.seal instanceof Function && Object.seal(b2);
      return b2;
    };
    return d;
  };
  goog.defineClass.isUnsealable_ = function(a2) {
    return a2 && a2.prototype && a2.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
  };
  goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
  goog.defineClass.applyProperties_ = function(a2, b) {
    for (var c in b)
      Object.prototype.hasOwnProperty.call(b, c) && (a2[c] = b[c]);
    for (var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++)
      c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a2[c] = b[c]);
  };
  goog.tagUnsealableClass = function(a2) {
  };
  goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable";
  goog.TRUSTED_TYPES_POLICY_NAME = "";
  goog.identity_ = function(a2) {
    return a2;
  };
  goog.createTrustedTypesPolicy = function(a2) {
    var b = null;
    if (typeof TrustedTypes === "undefined" || !TrustedTypes.createPolicy)
      return b;
    try {
      b = TrustedTypes.createPolicy(a2, { createHTML: goog.identity_, createScript: goog.identity_, createScriptURL: goog.identity_, createURL: goog.identity_ });
    } catch (c) {
      goog.logToConsole_(c.message);
    }
    return b;
  };
  goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null;
  goog.object = {};
  goog.object.is = function(a2, b) {
    return a2 === b ? a2 !== 0 || 1 / a2 === 1 / b : a2 !== a2 && b !== b;
  };
  goog.object.forEach = function(a2, b, c) {
    for (var d in a2)
      b.call(c, a2[d], d, a2);
  };
  goog.object.filter = function(a2, b, c) {
    var d = {}, e;
    for (e in a2)
      b.call(c, a2[e], e, a2) && (d[e] = a2[e]);
    return d;
  };
  goog.object.map = function(a2, b, c) {
    var d = {}, e;
    for (e in a2)
      d[e] = b.call(c, a2[e], e, a2);
    return d;
  };
  goog.object.some = function(a2, b, c) {
    for (var d in a2)
      if (b.call(c, a2[d], d, a2))
        return true;
    return false;
  };
  goog.object.every = function(a2, b, c) {
    for (var d in a2)
      if (!b.call(c, a2[d], d, a2))
        return false;
    return true;
  };
  goog.object.getCount = function(a2) {
    var b = 0, c;
    for (c in a2)
      b++;
    return b;
  };
  goog.object.getAnyKey = function(a2) {
    for (var b in a2)
      return b;
  };
  goog.object.getAnyValue = function(a2) {
    for (var b in a2)
      return a2[b];
  };
  goog.object.contains = function(a2, b) {
    return goog.object.containsValue(a2, b);
  };
  goog.object.getValues = function(a2) {
    var b = [], c = 0, d;
    for (d in a2)
      b[c++] = a2[d];
    return b;
  };
  goog.object.getKeys = function(a2) {
    var b = [], c = 0, d;
    for (d in a2)
      b[c++] = d;
    return b;
  };
  goog.object.getValueByKeys = function(a2, b) {
    var c = goog.isArrayLike(b), d = c ? b : arguments;
    for (c = c ? 0 : 1; c < d.length; c++) {
      if (a2 == null)
        return;
      a2 = a2[d[c]];
    }
    return a2;
  };
  goog.object.containsKey = function(a2, b) {
    return a2 !== null && b in a2;
  };
  goog.object.containsValue = function(a2, b) {
    for (var c in a2)
      if (a2[c] == b)
        return true;
    return false;
  };
  goog.object.findKey = function(a2, b, c) {
    for (var d in a2)
      if (b.call(c, a2[d], d, a2))
        return d;
  };
  goog.object.findValue = function(a2, b, c) {
    return (b = goog.object.findKey(a2, b, c)) && a2[b];
  };
  goog.object.isEmpty = function(a2) {
    for (var b in a2)
      return false;
    return true;
  };
  goog.object.clear = function(a2) {
    for (var b in a2)
      delete a2[b];
  };
  goog.object.remove = function(a2, b) {
    var c;
    (c = b in a2) && delete a2[b];
    return c;
  };
  goog.object.add = function(a2, b, c) {
    if (a2 !== null && b in a2)
      throw Error('The object already contains the key "' + b + '"');
    goog.object.set(a2, b, c);
  };
  goog.object.get = function(a2, b, c) {
    return a2 !== null && b in a2 ? a2[b] : c;
  };
  goog.object.set = function(a2, b, c) {
    a2[b] = c;
  };
  goog.object.setIfUndefined = function(a2, b, c) {
    return b in a2 ? a2[b] : a2[b] = c;
  };
  goog.object.setWithReturnValueIfNotSet = function(a2, b, c) {
    if (b in a2)
      return a2[b];
    c = c();
    return a2[b] = c;
  };
  goog.object.equals = function(a2, b) {
    for (var c in a2)
      if (!(c in b) || a2[c] !== b[c])
        return false;
    for (var d in b)
      if (!(d in a2))
        return false;
    return true;
  };
  goog.object.clone = function(a2) {
    var b = {}, c;
    for (c in a2)
      b[c] = a2[c];
    return b;
  };
  goog.object.unsafeClone = function(a2) {
    var b = goog.typeOf(a2);
    if (b == "object" || b == "array") {
      if (goog.isFunction(a2.clone))
        return a2.clone();
      b = b == "array" ? [] : {};
      for (var c in a2)
        b[c] = goog.object.unsafeClone(a2[c]);
      return b;
    }
    return a2;
  };
  goog.object.transpose = function(a2) {
    var b = {}, c;
    for (c in a2)
      b[a2[c]] = c;
    return b;
  };
  goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
  goog.object.extend = function(a2, b) {
    for (var c, d, e = 1; e < arguments.length; e++) {
      d = arguments[e];
      for (c in d)
        a2[c] = d[c];
      for (var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++)
        c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a2[c] = d[c]);
    }
  };
  goog.object.create = function(a2) {
    var b = arguments.length;
    if (b == 1 && goog.isArray(arguments[0]))
      return goog.object.create.apply(null, arguments[0]);
    if (b % 2)
      throw Error("Uneven number of arguments");
    for (var c = {}, d = 0; d < b; d += 2)
      c[arguments[d]] = arguments[d + 1];
    return c;
  };
  goog.object.createSet = function(a2) {
    var b = arguments.length;
    if (b == 1 && goog.isArray(arguments[0]))
      return goog.object.createSet.apply(null, arguments[0]);
    for (var c = {}, d = 0; d < b; d++)
      c[arguments[d]] = true;
    return c;
  };
  goog.object.createImmutableView = function(a2) {
    var b = a2;
    Object.isFrozen && !Object.isFrozen(a2) && (b = Object.create(a2), Object.freeze(b));
    return b;
  };
  goog.object.isImmutableView = function(a2) {
    return !!Object.isFrozen && Object.isFrozen(a2);
  };
  goog.object.getAllPropertyNames = function(a2, b, c) {
    if (!a2)
      return [];
    if (!Object.getOwnPropertyNames || !Object.getPrototypeOf)
      return goog.object.getKeys(a2);
    for (var d = {}; a2 && (a2 !== Object.prototype || b) && (a2 !== Function.prototype || c); ) {
      for (var e = Object.getOwnPropertyNames(a2), f = 0; f < e.length; f++)
        d[e[f]] = true;
      a2 = Object.getPrototypeOf(a2);
    }
    return goog.object.getKeys(d);
  };
  goog.object.getSuperClass = function(a2) {
    return (a2 = Object.getPrototypeOf(a2.prototype)) && a2.constructor;
  };
  goog.debug = {};
  goog.debug.Error = function(a2) {
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, goog.debug.Error);
    else {
      var b = Error().stack;
      b && (this.stack = b);
    }
    a2 && (this.message = String(a2));
    this.reportErrorToServer = true;
  };
  goog.inherits(goog.debug.Error, Error);
  goog.debug.Error.prototype.name = "CustomError";
  goog.dom = {};
  goog.dom.NodeType = { ELEMENT: 1, ATTRIBUTE: 2, TEXT: 3, CDATA_SECTION: 4, ENTITY_REFERENCE: 5, ENTITY: 6, PROCESSING_INSTRUCTION: 7, COMMENT: 8, DOCUMENT: 9, DOCUMENT_TYPE: 10, DOCUMENT_FRAGMENT: 11, NOTATION: 12 };
  goog.asserts = {};
  goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
  goog.asserts.AssertionError = function(a2, b) {
    goog.debug.Error.call(this, goog.asserts.subs_(a2, b));
    this.messagePattern = a2;
  };
  goog.inherits(goog.asserts.AssertionError, goog.debug.Error);
  goog.asserts.AssertionError.prototype.name = "AssertionError";
  goog.asserts.DEFAULT_ERROR_HANDLER = function(a2) {
    throw a2;
  };
  goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
  goog.asserts.subs_ = function(a2, b) {
    a2 = a2.split("%s");
    for (var c = "", d = a2.length - 1, e = 0; e < d; e++)
      c += a2[e] + (e < b.length ? b[e] : "%s");
    return c + a2[d];
  };
  goog.asserts.doAssertFailure_ = function(a2, b, c, d) {
    var e = "Assertion failed";
    if (c) {
      e += ": " + c;
      var f = d;
    } else
      a2 && (e += ": " + a2, f = b);
    a2 = new goog.asserts.AssertionError("" + e, f || []);
    goog.asserts.errorHandler_(a2);
  };
  goog.asserts.setErrorHandler = function(a2) {
    goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a2);
  };
  goog.asserts.assert = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !a2 && goog.asserts.doAssertFailure_("", null, b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertExists = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && a2 == null && goog.asserts.doAssertFailure_("Expected to exist: %s.", [a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.fail = function(a2, b) {
    goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a2 ? ": " + a2 : ""), Array.prototype.slice.call(arguments, 1)));
  };
  goog.asserts.assertNumber = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isNumber(a2) && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertString = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isString(a2) && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertFunction = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isFunction(a2) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertObject = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isObject(a2) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertArray = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isArray(a2) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertBoolean = function(a2, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isBoolean(a2) && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertElement = function(a2, b, c) {
    !goog.asserts.ENABLE_ASSERTS || goog.isObject(a2) && a2.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [goog.typeOf(a2), a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertInstanceof = function(a2, b, c, d) {
    !goog.asserts.ENABLE_ASSERTS || a2 instanceof b || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [goog.asserts.getType_(b), goog.asserts.getType_(a2)], c, Array.prototype.slice.call(arguments, 3));
    return a2;
  };
  goog.asserts.assertFinite = function(a2, b, c) {
    !goog.asserts.ENABLE_ASSERTS || typeof a2 == "number" && isFinite(a2) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [a2], b, Array.prototype.slice.call(arguments, 2));
    return a2;
  };
  goog.asserts.assertObjectPrototypeIsIntact = function() {
    for (var a2 in Object.prototype)
      goog.asserts.fail(a2 + " should not be enumerable in Object.prototype.");
  };
  goog.asserts.getType_ = function(a2) {
    return a2 instanceof Function ? a2.displayName || a2.name || "unknown type name" : a2 instanceof Object ? a2.constructor.displayName || a2.constructor.name || Object.prototype.toString.call(a2) : a2 === null ? "null" : typeof a2;
  };
  var jspb = { BinaryConstants: {}, ConstBinaryMessage: function() {
  }, BinaryMessage: function() {
  } };
  jspb.BinaryConstants.FieldType = { INVALID: -1, DOUBLE: 1, FLOAT: 2, INT64: 3, UINT64: 4, INT32: 5, FIXED64: 6, FIXED32: 7, BOOL: 8, STRING: 9, GROUP: 10, MESSAGE: 11, BYTES: 12, UINT32: 13, ENUM: 14, SFIXED32: 15, SFIXED64: 16, SINT32: 17, SINT64: 18, FHASH64: 30, VHASH64: 31 };
  jspb.BinaryConstants.WireType = { INVALID: -1, VARINT: 0, FIXED64: 1, DELIMITED: 2, START_GROUP: 3, END_GROUP: 4, FIXED32: 5 };
  jspb.BinaryConstants.FieldTypeToWireType = function(a2) {
    var b = jspb.BinaryConstants.FieldType, c = jspb.BinaryConstants.WireType;
    switch (a2) {
      case b.INT32:
      case b.INT64:
      case b.UINT32:
      case b.UINT64:
      case b.SINT32:
      case b.SINT64:
      case b.BOOL:
      case b.ENUM:
      case b.VHASH64:
        return c.VARINT;
      case b.DOUBLE:
      case b.FIXED64:
      case b.SFIXED64:
      case b.FHASH64:
        return c.FIXED64;
      case b.STRING:
      case b.MESSAGE:
      case b.BYTES:
        return c.DELIMITED;
      case b.FLOAT:
      case b.FIXED32:
      case b.SFIXED32:
        return c.FIXED32;
      default:
        return c.INVALID;
    }
  };
  jspb.BinaryConstants.INVALID_FIELD_NUMBER = -1;
  jspb.BinaryConstants.FLOAT32_EPS = 1401298464324817e-60;
  jspb.BinaryConstants.FLOAT32_MIN = 11754943508222875e-54;
  jspb.BinaryConstants.FLOAT32_MAX = 34028234663852886e22;
  jspb.BinaryConstants.FLOAT64_EPS = 5e-324;
  jspb.BinaryConstants.FLOAT64_MIN = 22250738585072014e-324;
  jspb.BinaryConstants.FLOAT64_MAX = 17976931348623157e292;
  jspb.BinaryConstants.TWO_TO_20 = 1048576;
  jspb.BinaryConstants.TWO_TO_23 = 8388608;
  jspb.BinaryConstants.TWO_TO_31 = 2147483648;
  jspb.BinaryConstants.TWO_TO_32 = 4294967296;
  jspb.BinaryConstants.TWO_TO_52 = 4503599627370496;
  jspb.BinaryConstants.TWO_TO_63 = 9223372036854776e3;
  jspb.BinaryConstants.TWO_TO_64 = 18446744073709552e3;
  jspb.BinaryConstants.ZERO_HASH = "\0\0\0\0\0\0\0\0";
  goog.array = {};
  goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
  goog.array.ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
  goog.array.peek = function(a2) {
    return a2[a2.length - 1];
  };
  goog.array.last = goog.array.peek;
  goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.indexOf.call(a2, b, c);
  } : function(a2, b, c) {
    c = c == null ? 0 : 0 > c ? Math.max(0, a2.length + c) : c;
    if (goog.isString(a2))
      return goog.isString(b) && b.length == 1 ? a2.indexOf(b, c) : -1;
    for (; c < a2.length; c++)
      if (c in a2 && a2[c] === b)
        return c;
    return -1;
  };
  goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.lastIndexOf.call(a2, b, c == null ? a2.length - 1 : c);
  } : function(a2, b, c) {
    c = c == null ? a2.length - 1 : c;
    0 > c && (c = Math.max(0, a2.length + c));
    if (goog.isString(a2))
      return goog.isString(b) && b.length == 1 ? a2.lastIndexOf(b, c) : -1;
    for (; 0 <= c; c--)
      if (c in a2 && a2[c] === b)
        return c;
    return -1;
  };
  goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    Array.prototype.forEach.call(a2, b, c);
  } : function(a2, b, c) {
    for (var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2, f = 0; f < d; f++)
      f in e && b.call(c, e[f], f, a2);
  };
  goog.array.forEachRight = function(a2, b, c) {
    var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2;
    for (--d; 0 <= d; --d)
      d in e && b.call(c, e[d], d, a2);
  };
  goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.filter.call(a2, b, c);
  } : function(a2, b, c) {
    for (var d = a2.length, e = [], f = 0, g = goog.isString(a2) ? a2.split("") : a2, h = 0; h < d; h++)
      if (h in g) {
        var k = g[h];
        b.call(c, k, h, a2) && (e[f++] = k);
      }
    return e;
  };
  goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.map.call(a2, b, c);
  } : function(a2, b, c) {
    for (var d = a2.length, e = Array(d), f = goog.isString(a2) ? a2.split("") : a2, g = 0; g < d; g++)
      g in f && (e[g] = b.call(c, f[g], g, a2));
    return e;
  };
  goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a2, b, c, d) {
    goog.asserts.assert(a2.length != null);
    d && (b = goog.bind(b, d));
    return Array.prototype.reduce.call(a2, b, c);
  } : function(a2, b, c, d) {
    var e = c;
    goog.array.forEach(a2, function(c2, g) {
      e = b.call(d, e, c2, g, a2);
    });
    return e;
  };
  goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a2, b, c, d) {
    goog.asserts.assert(a2.length != null);
    goog.asserts.assert(b != null);
    d && (b = goog.bind(b, d));
    return Array.prototype.reduceRight.call(a2, b, c);
  } : function(a2, b, c, d) {
    var e = c;
    goog.array.forEachRight(a2, function(c2, g) {
      e = b.call(d, e, c2, g, a2);
    });
    return e;
  };
  goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.some.call(a2, b, c);
  } : function(a2, b, c) {
    for (var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2, f = 0; f < d; f++)
      if (f in e && b.call(c, e[f], f, a2))
        return true;
    return false;
  };
  goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.every.call(a2, b, c);
  } : function(a2, b, c) {
    for (var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2, f = 0; f < d; f++)
      if (f in e && !b.call(c, e[f], f, a2))
        return false;
    return true;
  };
  goog.array.count = function(a2, b, c) {
    var d = 0;
    goog.array.forEach(a2, function(a3, f, g) {
      b.call(c, a3, f, g) && ++d;
    }, c);
    return d;
  };
  goog.array.find = function(a2, b, c) {
    b = goog.array.findIndex(a2, b, c);
    return 0 > b ? null : goog.isString(a2) ? a2.charAt(b) : a2[b];
  };
  goog.array.findIndex = function(a2, b, c) {
    for (var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2, f = 0; f < d; f++)
      if (f in e && b.call(c, e[f], f, a2))
        return f;
    return -1;
  };
  goog.array.findRight = function(a2, b, c) {
    b = goog.array.findIndexRight(a2, b, c);
    return 0 > b ? null : goog.isString(a2) ? a2.charAt(b) : a2[b];
  };
  goog.array.findIndexRight = function(a2, b, c) {
    var d = a2.length, e = goog.isString(a2) ? a2.split("") : a2;
    for (--d; 0 <= d; d--)
      if (d in e && b.call(c, e[d], d, a2))
        return d;
    return -1;
  };
  goog.array.contains = function(a2, b) {
    return 0 <= goog.array.indexOf(a2, b);
  };
  goog.array.isEmpty = function(a2) {
    return a2.length == 0;
  };
  goog.array.clear = function(a2) {
    if (!goog.isArray(a2))
      for (var b = a2.length - 1; 0 <= b; b--)
        delete a2[b];
    a2.length = 0;
  };
  goog.array.insert = function(a2, b) {
    goog.array.contains(a2, b) || a2.push(b);
  };
  goog.array.insertAt = function(a2, b, c) {
    goog.array.splice(a2, c, 0, b);
  };
  goog.array.insertArrayAt = function(a2, b, c) {
    goog.partial(goog.array.splice, a2, c, 0).apply(null, b);
  };
  goog.array.insertBefore = function(a2, b, c) {
    var d;
    arguments.length == 2 || 0 > (d = goog.array.indexOf(a2, c)) ? a2.push(b) : goog.array.insertAt(a2, b, d);
  };
  goog.array.remove = function(a2, b) {
    b = goog.array.indexOf(a2, b);
    var c;
    (c = 0 <= b) && goog.array.removeAt(a2, b);
    return c;
  };
  goog.array.removeLast = function(a2, b) {
    b = goog.array.lastIndexOf(a2, b);
    return 0 <= b ? (goog.array.removeAt(a2, b), true) : false;
  };
  goog.array.removeAt = function(a2, b) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.splice.call(a2, b, 1).length == 1;
  };
  goog.array.removeIf = function(a2, b, c) {
    b = goog.array.findIndex(a2, b, c);
    return 0 <= b ? (goog.array.removeAt(a2, b), true) : false;
  };
  goog.array.removeAllIf = function(a2, b, c) {
    var d = 0;
    goog.array.forEachRight(a2, function(e, f) {
      b.call(c, e, f, a2) && goog.array.removeAt(a2, f) && d++;
    });
    return d;
  };
  goog.array.concat = function(a2) {
    return Array.prototype.concat.apply([], arguments);
  };
  goog.array.join = function(a2) {
    return Array.prototype.concat.apply([], arguments);
  };
  goog.array.toArray = function(a2) {
    var b = a2.length;
    if (0 < b) {
      for (var c = Array(b), d = 0; d < b; d++)
        c[d] = a2[d];
      return c;
    }
    return [];
  };
  goog.array.clone = goog.array.toArray;
  goog.array.extend = function(a2, b) {
    for (var c = 1; c < arguments.length; c++) {
      var d = arguments[c];
      if (goog.isArrayLike(d)) {
        var e = a2.length || 0, f = d.length || 0;
        a2.length = e + f;
        for (var g = 0; g < f; g++)
          a2[e + g] = d[g];
      } else
        a2.push(d);
    }
  };
  goog.array.splice = function(a2, b, c, d) {
    goog.asserts.assert(a2.length != null);
    return Array.prototype.splice.apply(a2, goog.array.slice(arguments, 1));
  };
  goog.array.slice = function(a2, b, c) {
    goog.asserts.assert(a2.length != null);
    return 2 >= arguments.length ? Array.prototype.slice.call(a2, b) : Array.prototype.slice.call(a2, b, c);
  };
  goog.array.removeDuplicates = function(a2, b, c) {
    b = b || a2;
    var d = function(a3) {
      return goog.isObject(a3) ? "o" + goog.getUid(a3) : (typeof a3).charAt(0) + a3;
    };
    c = c || d;
    d = {};
    for (var e = 0, f = 0; f < a2.length; ) {
      var g = a2[f++], h = c(g);
      Object.prototype.hasOwnProperty.call(d, h) || (d[h] = true, b[e++] = g);
    }
    b.length = e;
  };
  goog.array.binarySearch = function(a2, b, c) {
    return goog.array.binarySearch_(a2, c || goog.array.defaultCompare, false, b);
  };
  goog.array.binarySelect = function(a2, b, c) {
    return goog.array.binarySearch_(a2, b, true, void 0, c);
  };
  goog.array.binarySearch_ = function(a2, b, c, d, e) {
    for (var f = 0, g = a2.length, h; f < g; ) {
      var k = f + g >> 1;
      var l = c ? b.call(e, a2[k], k, a2) : b(d, a2[k]);
      0 < l ? f = k + 1 : (g = k, h = !l);
    }
    return h ? f : ~f;
  };
  goog.array.sort = function(a2, b) {
    a2.sort(b || goog.array.defaultCompare);
  };
  goog.array.stableSort = function(a2, b) {
    for (var c = Array(a2.length), d = 0; d < a2.length; d++)
      c[d] = { index: d, value: a2[d] };
    var e = b || goog.array.defaultCompare;
    goog.array.sort(c, function(a3, b2) {
      return e(a3.value, b2.value) || a3.index - b2.index;
    });
    for (d = 0; d < a2.length; d++)
      a2[d] = c[d].value;
  };
  goog.array.sortByKey = function(a2, b, c) {
    var d = c || goog.array.defaultCompare;
    goog.array.sort(a2, function(a3, c2) {
      return d(b(a3), b(c2));
    });
  };
  goog.array.sortObjectsByKey = function(a2, b, c) {
    goog.array.sortByKey(a2, function(a3) {
      return a3[b];
    }, c);
  };
  goog.array.isSorted = function(a2, b, c) {
    b = b || goog.array.defaultCompare;
    for (var d = 1; d < a2.length; d++) {
      var e = b(a2[d - 1], a2[d]);
      if (0 < e || e == 0 && c)
        return false;
    }
    return true;
  };
  goog.array.equals = function(a2, b, c) {
    if (!goog.isArrayLike(a2) || !goog.isArrayLike(b) || a2.length != b.length)
      return false;
    var d = a2.length;
    c = c || goog.array.defaultCompareEquality;
    for (var e = 0; e < d; e++)
      if (!c(a2[e], b[e]))
        return false;
    return true;
  };
  goog.array.compare3 = function(a2, b, c) {
    c = c || goog.array.defaultCompare;
    for (var d = Math.min(a2.length, b.length), e = 0; e < d; e++) {
      var f = c(a2[e], b[e]);
      if (f != 0)
        return f;
    }
    return goog.array.defaultCompare(a2.length, b.length);
  };
  goog.array.defaultCompare = function(a2, b) {
    return a2 > b ? 1 : a2 < b ? -1 : 0;
  };
  goog.array.inverseDefaultCompare = function(a2, b) {
    return -goog.array.defaultCompare(a2, b);
  };
  goog.array.defaultCompareEquality = function(a2, b) {
    return a2 === b;
  };
  goog.array.binaryInsert = function(a2, b, c) {
    c = goog.array.binarySearch(a2, b, c);
    return 0 > c ? (goog.array.insertAt(a2, b, -(c + 1)), true) : false;
  };
  goog.array.binaryRemove = function(a2, b, c) {
    b = goog.array.binarySearch(a2, b, c);
    return 0 <= b ? goog.array.removeAt(a2, b) : false;
  };
  goog.array.bucket = function(a2, b, c) {
    for (var d = {}, e = 0; e < a2.length; e++) {
      var f = a2[e], g = b.call(c, f, e, a2);
      goog.isDef(g) && (d[g] || (d[g] = [])).push(f);
    }
    return d;
  };
  goog.array.toObject = function(a2, b, c) {
    var d = {};
    goog.array.forEach(a2, function(e, f) {
      d[b.call(c, e, f, a2)] = e;
    });
    return d;
  };
  goog.array.range = function(a2, b, c) {
    var d = [], e = 0, f = a2;
    c = c || 1;
    b !== void 0 && (e = a2, f = b);
    if (0 > c * (f - e))
      return [];
    if (0 < c)
      for (a2 = e; a2 < f; a2 += c)
        d.push(a2);
    else
      for (a2 = e; a2 > f; a2 += c)
        d.push(a2);
    return d;
  };
  goog.array.repeat = function(a2, b) {
    for (var c = [], d = 0; d < b; d++)
      c[d] = a2;
    return c;
  };
  goog.array.flatten = function(a2) {
    for (var b = [], c = 0; c < arguments.length; c++) {
      var d = arguments[c];
      if (goog.isArray(d))
        for (var e = 0; e < d.length; e += 8192) {
          var f = goog.array.slice(d, e, e + 8192);
          f = goog.array.flatten.apply(null, f);
          for (var g = 0; g < f.length; g++)
            b.push(f[g]);
        }
      else
        b.push(d);
    }
    return b;
  };
  goog.array.rotate = function(a2, b) {
    goog.asserts.assert(a2.length != null);
    a2.length && (b %= a2.length, 0 < b ? Array.prototype.unshift.apply(a2, a2.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a2, a2.splice(0, -b)));
    return a2;
  };
  goog.array.moveItem = function(a2, b, c) {
    goog.asserts.assert(0 <= b && b < a2.length);
    goog.asserts.assert(0 <= c && c < a2.length);
    b = Array.prototype.splice.call(a2, b, 1);
    Array.prototype.splice.call(a2, c, 0, b[0]);
  };
  goog.array.zip = function(a2) {
    if (!arguments.length)
      return [];
    for (var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++)
      arguments[d].length < c && (c = arguments[d].length);
    for (d = 0; d < c; d++) {
      for (var e = [], f = 0; f < arguments.length; f++)
        e.push(arguments[f][d]);
      b.push(e);
    }
    return b;
  };
  goog.array.shuffle = function(a2, b) {
    b = b || Math.random;
    for (var c = a2.length - 1; 0 < c; c--) {
      var d = Math.floor(b() * (c + 1)), e = a2[c];
      a2[c] = a2[d];
      a2[d] = e;
    }
  };
  goog.array.copyByIndex = function(a2, b) {
    var c = [];
    goog.array.forEach(b, function(b2) {
      c.push(a2[b2]);
    });
    return c;
  };
  goog.array.concatMap = function(a2, b, c) {
    return goog.array.concat.apply([], goog.array.map(a2, b, c));
  };
  goog.crypt = {};
  goog.crypt.stringToByteArray = function(a2) {
    for (var b = [], c = 0, d = 0; d < a2.length; d++) {
      var e = a2.charCodeAt(d);
      255 < e && (b[c++] = e & 255, e >>= 8);
      b[c++] = e;
    }
    return b;
  };
  goog.crypt.byteArrayToString = function(a2) {
    if (8192 >= a2.length)
      return String.fromCharCode.apply(null, a2);
    for (var b = "", c = 0; c < a2.length; c += 8192) {
      var d = goog.array.slice(a2, c, c + 8192);
      b += String.fromCharCode.apply(null, d);
    }
    return b;
  };
  goog.crypt.byteArrayToHex = function(a2, b) {
    return goog.array.map(a2, function(a3) {
      a3 = a3.toString(16);
      return 1 < a3.length ? a3 : "0" + a3;
    }).join(b || "");
  };
  goog.crypt.hexToByteArray = function(a2) {
    goog.asserts.assert(a2.length % 2 == 0, "Key string length must be multiple of 2");
    for (var b = [], c = 0; c < a2.length; c += 2)
      b.push(parseInt(a2.substring(c, c + 2), 16));
    return b;
  };
  goog.crypt.stringToUtf8ByteArray = function(a2) {
    for (var b = [], c = 0, d = 0; d < a2.length; d++) {
      var e = a2.charCodeAt(d);
      128 > e ? b[c++] = e : (2048 > e ? b[c++] = e >> 6 | 192 : ((e & 64512) == 55296 && d + 1 < a2.length && (a2.charCodeAt(d + 1) & 64512) == 56320 ? (e = 65536 + ((e & 1023) << 10) + (a2.charCodeAt(++d) & 1023), b[c++] = e >> 18 | 240, b[c++] = e >> 12 & 63 | 128) : b[c++] = e >> 12 | 224, b[c++] = e >> 6 & 63 | 128), b[c++] = e & 63 | 128);
    }
    return b;
  };
  goog.crypt.utf8ByteArrayToString = function(a2) {
    for (var b = [], c = 0, d = 0; c < a2.length; ) {
      var e = a2[c++];
      if (128 > e)
        b[d++] = String.fromCharCode(e);
      else if (191 < e && 224 > e) {
        var f = a2[c++];
        b[d++] = String.fromCharCode((e & 31) << 6 | f & 63);
      } else if (239 < e && 365 > e) {
        f = a2[c++];
        var g = a2[c++], h = a2[c++];
        e = ((e & 7) << 18 | (f & 63) << 12 | (g & 63) << 6 | h & 63) - 65536;
        b[d++] = String.fromCharCode(55296 + (e >> 10));
        b[d++] = String.fromCharCode(56320 + (e & 1023));
      } else
        f = a2[c++], g = a2[c++], b[d++] = String.fromCharCode((e & 15) << 12 | (f & 63) << 6 | g & 63);
    }
    return b.join("");
  };
  goog.crypt.xorByteArray = function(a2, b) {
    goog.asserts.assert(a2.length == b.length, "XOR array lengths must match");
    for (var c = [], d = 0; d < a2.length; d++)
      c.push(a2[d] ^ b[d]);
    return c;
  };
  goog.dom.asserts = {};
  goog.dom.asserts.assertIsLocation = function(a2) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var b = goog.dom.asserts.getWindow_(a2);
      b && (!a2 || !(a2 instanceof b.Location) && a2 instanceof b.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(a2));
    }
    return a2;
  };
  goog.dom.asserts.assertIsElementType_ = function(a2, b) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var c = goog.dom.asserts.getWindow_(a2);
      c && typeof c[b] != "undefined" && (a2 && (a2 instanceof c[b] || !(a2 instanceof c.Location || a2 instanceof c.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, goog.dom.asserts.debugStringForType_(a2)));
    }
    return a2;
  };
  goog.dom.asserts.assertIsHTMLAnchorElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLAnchorElement");
  };
  goog.dom.asserts.assertIsHTMLButtonElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLButtonElement");
  };
  goog.dom.asserts.assertIsHTMLLinkElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLLinkElement");
  };
  goog.dom.asserts.assertIsHTMLImageElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLImageElement");
  };
  goog.dom.asserts.assertIsHTMLAudioElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLAudioElement");
  };
  goog.dom.asserts.assertIsHTMLVideoElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLVideoElement");
  };
  goog.dom.asserts.assertIsHTMLInputElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLInputElement");
  };
  goog.dom.asserts.assertIsHTMLTextAreaElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLTextAreaElement");
  };
  goog.dom.asserts.assertIsHTMLCanvasElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLCanvasElement");
  };
  goog.dom.asserts.assertIsHTMLEmbedElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLEmbedElement");
  };
  goog.dom.asserts.assertIsHTMLFormElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLFormElement");
  };
  goog.dom.asserts.assertIsHTMLFrameElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLFrameElement");
  };
  goog.dom.asserts.assertIsHTMLIFrameElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLIFrameElement");
  };
  goog.dom.asserts.assertIsHTMLObjectElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLObjectElement");
  };
  goog.dom.asserts.assertIsHTMLScriptElement = function(a2) {
    return goog.dom.asserts.assertIsElementType_(a2, "HTMLScriptElement");
  };
  goog.dom.asserts.debugStringForType_ = function(a2) {
    if (goog.isObject(a2))
      try {
        return a2.constructor.displayName || a2.constructor.name || Object.prototype.toString.call(a2);
      } catch (b) {
        return "<object could not be stringified>";
      }
    else
      return a2 === void 0 ? "undefined" : a2 === null ? "null" : typeof a2;
  };
  goog.dom.asserts.getWindow_ = function(a2) {
    try {
      var b = a2 && a2.ownerDocument, c = b && (b.defaultView || b.parentWindow);
      c = c || goog.global;
      if (c.Element && c.Location)
        return c;
    } catch (d) {
    }
    return null;
  };
  goog.functions = {};
  goog.functions.constant = function(a2) {
    return function() {
      return a2;
    };
  };
  goog.functions.FALSE = function() {
    return false;
  };
  goog.functions.TRUE = function() {
    return true;
  };
  goog.functions.NULL = function() {
    return null;
  };
  goog.functions.identity = function(a2, b) {
    return a2;
  };
  goog.functions.error = function(a2) {
    return function() {
      throw Error(a2);
    };
  };
  goog.functions.fail = function(a2) {
    return function() {
      throw a2;
    };
  };
  goog.functions.lock = function(a2, b) {
    b = b || 0;
    return function() {
      return a2.apply(this, Array.prototype.slice.call(arguments, 0, b));
    };
  };
  goog.functions.nth = function(a2) {
    return function() {
      return arguments[a2];
    };
  };
  goog.functions.partialRight = function(a2, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
      var b2 = Array.prototype.slice.call(arguments);
      b2.push.apply(b2, c);
      return a2.apply(this, b2);
    };
  };
  goog.functions.withReturnValue = function(a2, b) {
    return goog.functions.sequence(a2, goog.functions.constant(b));
  };
  goog.functions.equalTo = function(a2, b) {
    return function(c) {
      return b ? a2 == c : a2 === c;
    };
  };
  goog.functions.compose = function(a2, b) {
    var c = arguments, d = c.length;
    return function() {
      var a3;
      d && (a3 = c[d - 1].apply(this, arguments));
      for (var b2 = d - 2; 0 <= b2; b2--)
        a3 = c[b2].call(this, a3);
      return a3;
    };
  };
  goog.functions.sequence = function(a2) {
    var b = arguments, c = b.length;
    return function() {
      for (var a3, e = 0; e < c; e++)
        a3 = b[e].apply(this, arguments);
      return a3;
    };
  };
  goog.functions.and = function(a2) {
    var b = arguments, c = b.length;
    return function() {
      for (var a3 = 0; a3 < c; a3++)
        if (!b[a3].apply(this, arguments))
          return false;
      return true;
    };
  };
  goog.functions.or = function(a2) {
    var b = arguments, c = b.length;
    return function() {
      for (var a3 = 0; a3 < c; a3++)
        if (b[a3].apply(this, arguments))
          return true;
      return false;
    };
  };
  goog.functions.not = function(a2) {
    return function() {
      return !a2.apply(this, arguments);
    };
  };
  goog.functions.create = function(a2, b) {
    var c = function() {
    };
    c.prototype = a2.prototype;
    c = new c();
    a2.apply(c, Array.prototype.slice.call(arguments, 1));
    return c;
  };
  goog.functions.CACHE_RETURN_VALUE = true;
  goog.functions.cacheReturnValue = function(a2) {
    var b = false, c;
    return function() {
      if (!goog.functions.CACHE_RETURN_VALUE)
        return a2();
      b || (c = a2(), b = true);
      return c;
    };
  };
  goog.functions.once = function(a2) {
    var b = a2;
    return function() {
      if (b) {
        var a3 = b;
        b = null;
        a3();
      }
    };
  };
  goog.functions.debounce = function(a2, b, c) {
    var d = 0;
    return function(e) {
      goog.global.clearTimeout(d);
      var f = arguments;
      d = goog.global.setTimeout(function() {
        a2.apply(c, f);
      }, b);
    };
  };
  goog.functions.throttle = function(a2, b, c) {
    var d = 0, e = false, f = [], g = function() {
      d = 0;
      e && (e = false, h());
    }, h = function() {
      d = goog.global.setTimeout(g, b);
      a2.apply(c, f);
    };
    return function(a3) {
      f = arguments;
      d ? e = true : h();
    };
  };
  goog.functions.rateLimit = function(a2, b, c) {
    var d = 0, e = function() {
      d = 0;
    };
    return function(f) {
      d || (d = goog.global.setTimeout(e, b), a2.apply(c, arguments));
    };
  };
  goog.dom.HtmlElement = function() {
  };
  goog.dom.TagName = function(a2) {
    this.tagName_ = a2;
  };
  goog.dom.TagName.prototype.toString = function() {
    return this.tagName_;
  };
  goog.dom.TagName.A = new goog.dom.TagName("A");
  goog.dom.TagName.ABBR = new goog.dom.TagName("ABBR");
  goog.dom.TagName.ACRONYM = new goog.dom.TagName("ACRONYM");
  goog.dom.TagName.ADDRESS = new goog.dom.TagName("ADDRESS");
  goog.dom.TagName.APPLET = new goog.dom.TagName("APPLET");
  goog.dom.TagName.AREA = new goog.dom.TagName("AREA");
  goog.dom.TagName.ARTICLE = new goog.dom.TagName("ARTICLE");
  goog.dom.TagName.ASIDE = new goog.dom.TagName("ASIDE");
  goog.dom.TagName.AUDIO = new goog.dom.TagName("AUDIO");
  goog.dom.TagName.B = new goog.dom.TagName("B");
  goog.dom.TagName.BASE = new goog.dom.TagName("BASE");
  goog.dom.TagName.BASEFONT = new goog.dom.TagName("BASEFONT");
  goog.dom.TagName.BDI = new goog.dom.TagName("BDI");
  goog.dom.TagName.BDO = new goog.dom.TagName("BDO");
  goog.dom.TagName.BIG = new goog.dom.TagName("BIG");
  goog.dom.TagName.BLOCKQUOTE = new goog.dom.TagName("BLOCKQUOTE");
  goog.dom.TagName.BODY = new goog.dom.TagName("BODY");
  goog.dom.TagName.BR = new goog.dom.TagName("BR");
  goog.dom.TagName.BUTTON = new goog.dom.TagName("BUTTON");
  goog.dom.TagName.CANVAS = new goog.dom.TagName("CANVAS");
  goog.dom.TagName.CAPTION = new goog.dom.TagName("CAPTION");
  goog.dom.TagName.CENTER = new goog.dom.TagName("CENTER");
  goog.dom.TagName.CITE = new goog.dom.TagName("CITE");
  goog.dom.TagName.CODE = new goog.dom.TagName("CODE");
  goog.dom.TagName.COL = new goog.dom.TagName("COL");
  goog.dom.TagName.COLGROUP = new goog.dom.TagName("COLGROUP");
  goog.dom.TagName.COMMAND = new goog.dom.TagName("COMMAND");
  goog.dom.TagName.DATA = new goog.dom.TagName("DATA");
  goog.dom.TagName.DATALIST = new goog.dom.TagName("DATALIST");
  goog.dom.TagName.DD = new goog.dom.TagName("DD");
  goog.dom.TagName.DEL = new goog.dom.TagName("DEL");
  goog.dom.TagName.DETAILS = new goog.dom.TagName("DETAILS");
  goog.dom.TagName.DFN = new goog.dom.TagName("DFN");
  goog.dom.TagName.DIALOG = new goog.dom.TagName("DIALOG");
  goog.dom.TagName.DIR = new goog.dom.TagName("DIR");
  goog.dom.TagName.DIV = new goog.dom.TagName("DIV");
  goog.dom.TagName.DL = new goog.dom.TagName("DL");
  goog.dom.TagName.DT = new goog.dom.TagName("DT");
  goog.dom.TagName.EM = new goog.dom.TagName("EM");
  goog.dom.TagName.EMBED = new goog.dom.TagName("EMBED");
  goog.dom.TagName.FIELDSET = new goog.dom.TagName("FIELDSET");
  goog.dom.TagName.FIGCAPTION = new goog.dom.TagName("FIGCAPTION");
  goog.dom.TagName.FIGURE = new goog.dom.TagName("FIGURE");
  goog.dom.TagName.FONT = new goog.dom.TagName("FONT");
  goog.dom.TagName.FOOTER = new goog.dom.TagName("FOOTER");
  goog.dom.TagName.FORM = new goog.dom.TagName("FORM");
  goog.dom.TagName.FRAME = new goog.dom.TagName("FRAME");
  goog.dom.TagName.FRAMESET = new goog.dom.TagName("FRAMESET");
  goog.dom.TagName.H1 = new goog.dom.TagName("H1");
  goog.dom.TagName.H2 = new goog.dom.TagName("H2");
  goog.dom.TagName.H3 = new goog.dom.TagName("H3");
  goog.dom.TagName.H4 = new goog.dom.TagName("H4");
  goog.dom.TagName.H5 = new goog.dom.TagName("H5");
  goog.dom.TagName.H6 = new goog.dom.TagName("H6");
  goog.dom.TagName.HEAD = new goog.dom.TagName("HEAD");
  goog.dom.TagName.HEADER = new goog.dom.TagName("HEADER");
  goog.dom.TagName.HGROUP = new goog.dom.TagName("HGROUP");
  goog.dom.TagName.HR = new goog.dom.TagName("HR");
  goog.dom.TagName.HTML = new goog.dom.TagName("HTML");
  goog.dom.TagName.I = new goog.dom.TagName("I");
  goog.dom.TagName.IFRAME = new goog.dom.TagName("IFRAME");
  goog.dom.TagName.IMG = new goog.dom.TagName("IMG");
  goog.dom.TagName.INPUT = new goog.dom.TagName("INPUT");
  goog.dom.TagName.INS = new goog.dom.TagName("INS");
  goog.dom.TagName.ISINDEX = new goog.dom.TagName("ISINDEX");
  goog.dom.TagName.KBD = new goog.dom.TagName("KBD");
  goog.dom.TagName.KEYGEN = new goog.dom.TagName("KEYGEN");
  goog.dom.TagName.LABEL = new goog.dom.TagName("LABEL");
  goog.dom.TagName.LEGEND = new goog.dom.TagName("LEGEND");
  goog.dom.TagName.LI = new goog.dom.TagName("LI");
  goog.dom.TagName.LINK = new goog.dom.TagName("LINK");
  goog.dom.TagName.MAIN = new goog.dom.TagName("MAIN");
  goog.dom.TagName.MAP = new goog.dom.TagName("MAP");
  goog.dom.TagName.MARK = new goog.dom.TagName("MARK");
  goog.dom.TagName.MATH = new goog.dom.TagName("MATH");
  goog.dom.TagName.MENU = new goog.dom.TagName("MENU");
  goog.dom.TagName.MENUITEM = new goog.dom.TagName("MENUITEM");
  goog.dom.TagName.META = new goog.dom.TagName("META");
  goog.dom.TagName.METER = new goog.dom.TagName("METER");
  goog.dom.TagName.NAV = new goog.dom.TagName("NAV");
  goog.dom.TagName.NOFRAMES = new goog.dom.TagName("NOFRAMES");
  goog.dom.TagName.NOSCRIPT = new goog.dom.TagName("NOSCRIPT");
  goog.dom.TagName.OBJECT = new goog.dom.TagName("OBJECT");
  goog.dom.TagName.OL = new goog.dom.TagName("OL");
  goog.dom.TagName.OPTGROUP = new goog.dom.TagName("OPTGROUP");
  goog.dom.TagName.OPTION = new goog.dom.TagName("OPTION");
  goog.dom.TagName.OUTPUT = new goog.dom.TagName("OUTPUT");
  goog.dom.TagName.P = new goog.dom.TagName("P");
  goog.dom.TagName.PARAM = new goog.dom.TagName("PARAM");
  goog.dom.TagName.PICTURE = new goog.dom.TagName("PICTURE");
  goog.dom.TagName.PRE = new goog.dom.TagName("PRE");
  goog.dom.TagName.PROGRESS = new goog.dom.TagName("PROGRESS");
  goog.dom.TagName.Q = new goog.dom.TagName("Q");
  goog.dom.TagName.RP = new goog.dom.TagName("RP");
  goog.dom.TagName.RT = new goog.dom.TagName("RT");
  goog.dom.TagName.RTC = new goog.dom.TagName("RTC");
  goog.dom.TagName.RUBY = new goog.dom.TagName("RUBY");
  goog.dom.TagName.S = new goog.dom.TagName("S");
  goog.dom.TagName.SAMP = new goog.dom.TagName("SAMP");
  goog.dom.TagName.SCRIPT = new goog.dom.TagName("SCRIPT");
  goog.dom.TagName.SECTION = new goog.dom.TagName("SECTION");
  goog.dom.TagName.SELECT = new goog.dom.TagName("SELECT");
  goog.dom.TagName.SMALL = new goog.dom.TagName("SMALL");
  goog.dom.TagName.SOURCE = new goog.dom.TagName("SOURCE");
  goog.dom.TagName.SPAN = new goog.dom.TagName("SPAN");
  goog.dom.TagName.STRIKE = new goog.dom.TagName("STRIKE");
  goog.dom.TagName.STRONG = new goog.dom.TagName("STRONG");
  goog.dom.TagName.STYLE = new goog.dom.TagName("STYLE");
  goog.dom.TagName.SUB = new goog.dom.TagName("SUB");
  goog.dom.TagName.SUMMARY = new goog.dom.TagName("SUMMARY");
  goog.dom.TagName.SUP = new goog.dom.TagName("SUP");
  goog.dom.TagName.SVG = new goog.dom.TagName("SVG");
  goog.dom.TagName.TABLE = new goog.dom.TagName("TABLE");
  goog.dom.TagName.TBODY = new goog.dom.TagName("TBODY");
  goog.dom.TagName.TD = new goog.dom.TagName("TD");
  goog.dom.TagName.TEMPLATE = new goog.dom.TagName("TEMPLATE");
  goog.dom.TagName.TEXTAREA = new goog.dom.TagName("TEXTAREA");
  goog.dom.TagName.TFOOT = new goog.dom.TagName("TFOOT");
  goog.dom.TagName.TH = new goog.dom.TagName("TH");
  goog.dom.TagName.THEAD = new goog.dom.TagName("THEAD");
  goog.dom.TagName.TIME = new goog.dom.TagName("TIME");
  goog.dom.TagName.TITLE = new goog.dom.TagName("TITLE");
  goog.dom.TagName.TR = new goog.dom.TagName("TR");
  goog.dom.TagName.TRACK = new goog.dom.TagName("TRACK");
  goog.dom.TagName.TT = new goog.dom.TagName("TT");
  goog.dom.TagName.U = new goog.dom.TagName("U");
  goog.dom.TagName.UL = new goog.dom.TagName("UL");
  goog.dom.TagName.VAR = new goog.dom.TagName("VAR");
  goog.dom.TagName.VIDEO = new goog.dom.TagName("VIDEO");
  goog.dom.TagName.WBR = new goog.dom.TagName("WBR");
  goog.dom.tags = {};
  goog.dom.tags.VOID_TAGS_ = { area: true, base: true, br: true, col: true, command: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true };
  goog.dom.tags.isVoidTag = function(a2) {
    return goog.dom.tags.VOID_TAGS_[a2] === true;
  };
  goog.html = {};
  goog.html.trustedtypes = {};
  goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html") : null;
  goog.string = {};
  goog.string.TypedString = function() {
  };
  goog.string.Const = function(a2, b) {
    this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = a2 === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && b || "";
    this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
  };
  goog.string.Const.prototype.implementsGoogStringTypedString = true;
  goog.string.Const.prototype.getTypedStringValue = function() {
    return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
  };
  goog.string.Const.prototype.toString = function() {
    return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
  };
  goog.string.Const.unwrap = function(a2) {
    if (a2 instanceof goog.string.Const && a2.constructor === goog.string.Const && a2.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_)
      return a2.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
    goog.asserts.fail("expected object of type Const, got '" + a2 + "'");
    return "type_error:Const";
  };
  goog.string.Const.from = function(a2) {
    return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, a2);
  };
  goog.string.Const.TYPE_MARKER_ = {};
  goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {};
  goog.string.Const.EMPTY = goog.string.Const.from("");
  goog.html.SafeScript = function() {
    this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = "";
    this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  };
  goog.html.SafeScript.prototype.implementsGoogStringTypedString = true;
  goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.SafeScript.fromConstant = function(a2) {
    a2 = goog.string.Const.unwrap(a2);
    return a2.length === 0 ? goog.html.SafeScript.EMPTY : goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeScript.fromConstantAndArgs = function(a2, b) {
    for (var c = [], d = 1; d < arguments.length; d++)
      c.push(goog.html.SafeScript.stringify_(arguments[d]));
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(a2) + ")(" + c.join(", ") + ");");
  };
  goog.html.SafeScript.fromJson = function(a2) {
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(a2));
  };
  goog.html.SafeScript.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
  };
  goog.DEBUG && (goog.html.SafeScript.prototype.toString = function() {
    return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
  });
  goog.html.SafeScript.unwrap = function(a2) {
    return goog.html.SafeScript.unwrapTrustedScript(a2).toString();
  };
  goog.html.SafeScript.unwrapTrustedScript = function(a2) {
    if (a2 instanceof goog.html.SafeScript && a2.constructor === goog.html.SafeScript && a2.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseSafeScriptWrappedValue_;
    goog.asserts.fail("expected object of type SafeScript, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:SafeScript";
  };
  goog.html.SafeScript.stringify_ = function(a2) {
    return JSON.stringify(a2).replace(/</g, "\\x3c");
  };
  goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(a2) {
    return new goog.html.SafeScript().initSecurityPrivateDoNotAccessOrElse_(a2);
  };
  goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a2) {
    this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(a2) : a2;
    return this;
  };
  goog.html.SafeScript.EMPTY = goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");
  goog.fs = {};
  goog.fs.url = {};
  goog.fs.url.createObjectUrl = function(a2) {
    return goog.fs.url.getUrlObject_().createObjectURL(a2);
  };
  goog.fs.url.revokeObjectUrl = function(a2) {
    goog.fs.url.getUrlObject_().revokeObjectURL(a2);
  };
  goog.fs.url.getUrlObject_ = function() {
    var a2 = goog.fs.url.findUrlObject_();
    if (a2 != null)
      return a2;
    throw Error("This browser doesn't seem to support blob URLs");
  };
  goog.fs.url.findUrlObject_ = function() {
    return goog.isDef(goog.global.URL) && goog.isDef(goog.global.URL.createObjectURL) ? goog.global.URL : goog.isDef(goog.global.webkitURL) && goog.isDef(goog.global.webkitURL.createObjectURL) ? goog.global.webkitURL : goog.isDef(goog.global.createObjectURL) ? goog.global : null;
  };
  goog.fs.url.browserSupportsObjectUrls = function() {
    return goog.fs.url.findUrlObject_() != null;
  };
  goog.i18n = {};
  goog.i18n.bidi = {};
  goog.i18n.bidi.FORCE_RTL = false;
  goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || (goog.LOCALE.substring(0, 2).toLowerCase() == "ar" || goog.LOCALE.substring(0, 2).toLowerCase() == "fa" || goog.LOCALE.substring(0, 2).toLowerCase() == "he" || goog.LOCALE.substring(0, 2).toLowerCase() == "iw" || goog.LOCALE.substring(0, 2).toLowerCase() == "ps" || goog.LOCALE.substring(0, 2).toLowerCase() == "sd" || goog.LOCALE.substring(0, 2).toLowerCase() == "ug" || goog.LOCALE.substring(0, 2).toLowerCase() == "ur" || goog.LOCALE.substring(0, 2).toLowerCase() == "yi") && (goog.LOCALE.length == 2 || goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") || 3 <= goog.LOCALE.length && goog.LOCALE.substring(0, 3).toLowerCase() == "ckb" && (goog.LOCALE.length == 3 || goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") || 7 <= goog.LOCALE.length && (goog.LOCALE.substring(2, 3) == "-" || goog.LOCALE.substring(2, 3) == "_") && (goog.LOCALE.substring(3, 7).toLowerCase() == "adlm" || goog.LOCALE.substring(3, 7).toLowerCase() == "arab" || goog.LOCALE.substring(3, 7).toLowerCase() == "hebr" || goog.LOCALE.substring(3, 7).toLowerCase() == "nkoo" || goog.LOCALE.substring(3, 7).toLowerCase() == "rohg" || goog.LOCALE.substring(3, 7).toLowerCase() == "thaa") || 8 <= goog.LOCALE.length && (goog.LOCALE.substring(3, 4) == "-" || goog.LOCALE.substring(3, 4) == "_") && (goog.LOCALE.substring(4, 8).toLowerCase() == "adlm" || goog.LOCALE.substring(4, 8).toLowerCase() == "arab" || goog.LOCALE.substring(4, 8).toLowerCase() == "hebr" || goog.LOCALE.substring(4, 8).toLowerCase() == "nkoo" || goog.LOCALE.substring(4, 8).toLowerCase() == "rohg" || goog.LOCALE.substring(4, 8).toLowerCase() == "thaa");
  goog.i18n.bidi.Format = { LRE: "\u202A", RLE: "\u202B", PDF: "\u202C", LRM: "\u200E", RLM: "\u200F" };
  goog.i18n.bidi.Dir = { LTR: 1, RTL: -1, NEUTRAL: 0 };
  goog.i18n.bidi.RIGHT = "right";
  goog.i18n.bidi.LEFT = "left";
  goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT;
  goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT;
  goog.i18n.bidi.toDir = function(a2, b) {
    return typeof a2 == "number" ? 0 < a2 ? goog.i18n.bidi.Dir.LTR : 0 > a2 ? goog.i18n.bidi.Dir.RTL : b ? null : goog.i18n.bidi.Dir.NEUTRAL : a2 == null ? null : a2 ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
  };
  goog.i18n.bidi.ltrChars_ = "A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u0300-\u0590\u0900-\u1FFF\u200E\u2C00-\uD801\uD804-\uD839\uD83C-\uDBFF\uF900-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF";
  goog.i18n.bidi.rtlChars_ = "\u0591-\u06EF\u06FA-\u08FF\u200F\uD802-\uD803\uD83A-\uD83B\uFB1D-\uFDFF\uFE70-\uFEFC";
  goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g;
  goog.i18n.bidi.stripHtmlIfNeeded_ = function(a2, b) {
    return b ? a2.replace(goog.i18n.bidi.htmlSkipReg_, "") : a2;
  };
  goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]");
  goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]");
  goog.i18n.bidi.hasAnyRtl = function(a2, b) {
    return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl;
  goog.i18n.bidi.hasAnyLtr = function(a2, b) {
    return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]");
  goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]");
  goog.i18n.bidi.isRtlChar = function(a2) {
    return goog.i18n.bidi.rtlRe_.test(a2);
  };
  goog.i18n.bidi.isLtrChar = function(a2) {
    return goog.i18n.bidi.ltrRe_.test(a2);
  };
  goog.i18n.bidi.isNeutralChar = function(a2) {
    return !goog.i18n.bidi.isLtrChar(a2) && !goog.i18n.bidi.isRtlChar(a2);
  };
  goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]");
  goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]");
  goog.i18n.bidi.startsWithRtl = function(a2, b) {
    return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl;
  goog.i18n.bidi.startsWithLtr = function(a2, b) {
    return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr;
  goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/;
  goog.i18n.bidi.isNeutralText = function(a2, b) {
    a2 = goog.i18n.bidi.stripHtmlIfNeeded_(a2, b);
    return goog.i18n.bidi.isRequiredLtrRe_.test(a2) || !goog.i18n.bidi.hasAnyLtr(a2) && !goog.i18n.bidi.hasAnyRtl(a2);
  };
  goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$");
  goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$");
  goog.i18n.bidi.endsWithLtr = function(a2, b) {
    return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr;
  goog.i18n.bidi.endsWithRtl = function(a2, b) {
    return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a2, b));
  };
  goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl;
  goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;
  goog.i18n.bidi.isRtlLanguage = function(a2) {
    return goog.i18n.bidi.rtlLocalesRe_.test(a2);
  };
  goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
  goog.i18n.bidi.guardBracketInText = function(a2, b) {
    b = (b === void 0 ? goog.i18n.bidi.hasAnyRtl(a2) : b) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM;
    return a2.replace(goog.i18n.bidi.bracketGuardTextRe_, b + "$&" + b);
  };
  goog.i18n.bidi.enforceRtlInHtml = function(a2) {
    return a2.charAt(0) == "<" ? a2.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + a2 + "</span>";
  };
  goog.i18n.bidi.enforceRtlInText = function(a2) {
    return goog.i18n.bidi.Format.RLE + a2 + goog.i18n.bidi.Format.PDF;
  };
  goog.i18n.bidi.enforceLtrInHtml = function(a2) {
    return a2.charAt(0) == "<" ? a2.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + a2 + "</span>";
  };
  goog.i18n.bidi.enforceLtrInText = function(a2) {
    return goog.i18n.bidi.Format.LRE + a2 + goog.i18n.bidi.Format.PDF;
  };
  goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;
  goog.i18n.bidi.leftRe_ = /left/gi;
  goog.i18n.bidi.rightRe_ = /right/gi;
  goog.i18n.bidi.tempRe_ = /%%%%/g;
  goog.i18n.bidi.mirrorCSS = function(a2) {
    return a2.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
  };
  goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g;
  goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g;
  goog.i18n.bidi.normalizeHebrewQuote = function(a2) {
    return a2.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1\u05F4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1\u05F3");
  };
  goog.i18n.bidi.wordSeparatorRe_ = /\s+/;
  goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/;
  goog.i18n.bidi.rtlDetectionThreshold_ = 0.4;
  goog.i18n.bidi.estimateDirection = function(a2, b) {
    var c = 0, d = 0, e = false;
    a2 = goog.i18n.bidi.stripHtmlIfNeeded_(a2, b).split(goog.i18n.bidi.wordSeparatorRe_);
    for (b = 0; b < a2.length; b++) {
      var f = a2[b];
      goog.i18n.bidi.startsWithRtl(f) ? (c++, d++) : goog.i18n.bidi.isRequiredLtrRe_.test(f) ? e = true : goog.i18n.bidi.hasAnyLtr(f) ? d++ : goog.i18n.bidi.hasNumeralsRe_.test(f) && (e = true);
    }
    return d == 0 ? e ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : c / d > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
  };
  goog.i18n.bidi.detectRtlDirectionality = function(a2, b) {
    return goog.i18n.bidi.estimateDirection(a2, b) == goog.i18n.bidi.Dir.RTL;
  };
  goog.i18n.bidi.setElementDirAndAlign = function(a2, b) {
    a2 && (b = goog.i18n.bidi.toDir(b)) && (a2.style.textAlign = b == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, a2.dir = b == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
  };
  goog.i18n.bidi.setElementDirByTextDirectionality = function(a2, b) {
    switch (goog.i18n.bidi.estimateDirection(b)) {
      case goog.i18n.bidi.Dir.LTR:
        a2.dir = "ltr";
        break;
      case goog.i18n.bidi.Dir.RTL:
        a2.dir = "rtl";
        break;
      default:
        a2.removeAttribute("dir");
    }
  };
  goog.i18n.bidi.DirectionalString = function() {
  };
  goog.html.TrustedResourceUrl = function() {
    this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = "";
    this.trustedURL_ = null;
    this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  };
  goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = true;
  goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
  };
  goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = true;
  goog.html.TrustedResourceUrl.prototype.getDirection = function() {
    return goog.i18n.bidi.Dir.LTR;
  };
  goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(a2, b) {
    var c = goog.html.TrustedResourceUrl.unwrap(this);
    c = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);
    var d = c[3] || "";
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", c[2] || "", a2) + goog.html.TrustedResourceUrl.stringifyParams_("#", d, b));
  };
  goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
    return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
  });
  goog.html.TrustedResourceUrl.unwrap = function(a2) {
    return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a2).toString();
  };
  goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(a2) {
    if (a2 instanceof goog.html.TrustedResourceUrl && a2.constructor === goog.html.TrustedResourceUrl && a2.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;
    goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:TrustedResourceUrl";
  };
  goog.html.TrustedResourceUrl.unwrapTrustedURL = function(a2) {
    return a2.trustedURL_ ? a2.trustedURL_ : goog.html.TrustedResourceUrl.unwrap(a2);
  };
  goog.html.TrustedResourceUrl.format = function(a2, b) {
    var c = goog.string.Const.unwrap(a2);
    if (!goog.html.TrustedResourceUrl.BASE_URL_.test(c))
      throw Error("Invalid TrustedResourceUrl format: " + c);
    a2 = c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(a3, e) {
      if (!Object.prototype.hasOwnProperty.call(b, e))
        throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
      a3 = b[e];
      return a3 instanceof goog.string.Const ? goog.string.Const.unwrap(a3) : encodeURIComponent(String(a3));
    });
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g;
  goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;
  goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
  goog.html.TrustedResourceUrl.formatWithParams = function(a2, b, c, d) {
    return goog.html.TrustedResourceUrl.format(a2, b).cloneWithParams(c, d);
  };
  goog.html.TrustedResourceUrl.fromConstant = function(a2) {
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a2));
  };
  goog.html.TrustedResourceUrl.fromConstants = function(a2) {
    for (var b = "", c = 0; c < a2.length; c++)
      b += goog.string.Const.unwrap(a2[c]);
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(a2) {
    var b = new goog.html.TrustedResourceUrl();
    b.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(a2) : a2;
    goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY && (b.trustedURL_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a2));
    return b;
  };
  goog.html.TrustedResourceUrl.stringifyParams_ = function(a2, b, c) {
    if (c == null)
      return b;
    if (goog.isString(c))
      return c ? a2 + encodeURIComponent(c) : "";
    for (var d in c) {
      var e = c[d];
      e = goog.isArray(e) ? e : [e];
      for (var f = 0; f < e.length; f++) {
        var g = e[f];
        g != null && (b || (b = a2), b += (b.length > a2.length ? "&" : "") + encodeURIComponent(d) + "=" + encodeURIComponent(String(g)));
      }
    }
    return b;
  };
  goog.string.internal = {};
  goog.string.internal.startsWith = function(a2, b) {
    return a2.lastIndexOf(b, 0) == 0;
  };
  goog.string.internal.endsWith = function(a2, b) {
    var c = a2.length - b.length;
    return 0 <= c && a2.indexOf(b, c) == c;
  };
  goog.string.internal.caseInsensitiveStartsWith = function(a2, b) {
    return goog.string.internal.caseInsensitiveCompare(b, a2.substr(0, b.length)) == 0;
  };
  goog.string.internal.caseInsensitiveEndsWith = function(a2, b) {
    return goog.string.internal.caseInsensitiveCompare(b, a2.substr(a2.length - b.length, b.length)) == 0;
  };
  goog.string.internal.caseInsensitiveEquals = function(a2, b) {
    return a2.toLowerCase() == b.toLowerCase();
  };
  goog.string.internal.isEmptyOrWhitespace = function(a2) {
    return /^[\s\xa0]*$/.test(a2);
  };
  goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a2) {
    return a2.trim();
  } : function(a2) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a2)[1];
  };
  goog.string.internal.caseInsensitiveCompare = function(a2, b) {
    a2 = String(a2).toLowerCase();
    b = String(b).toLowerCase();
    return a2 < b ? -1 : a2 == b ? 0 : 1;
  };
  goog.string.internal.newLineToBr = function(a2, b) {
    return a2.replace(/(\r\n|\r|\n)/g, b ? "<br />" : "<br>");
  };
  goog.string.internal.htmlEscape = function(a2, b) {
    if (b)
      a2 = a2.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
    else {
      if (!goog.string.internal.ALL_RE_.test(a2))
        return a2;
      a2.indexOf("&") != -1 && (a2 = a2.replace(goog.string.internal.AMP_RE_, "&amp;"));
      a2.indexOf("<") != -1 && (a2 = a2.replace(goog.string.internal.LT_RE_, "&lt;"));
      a2.indexOf(">") != -1 && (a2 = a2.replace(goog.string.internal.GT_RE_, "&gt;"));
      a2.indexOf('"') != -1 && (a2 = a2.replace(goog.string.internal.QUOT_RE_, "&quot;"));
      a2.indexOf("'") != -1 && (a2 = a2.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;"));
      a2.indexOf("\0") != -1 && (a2 = a2.replace(goog.string.internal.NULL_RE_, "&#0;"));
    }
    return a2;
  };
  goog.string.internal.AMP_RE_ = /&/g;
  goog.string.internal.LT_RE_ = /</g;
  goog.string.internal.GT_RE_ = />/g;
  goog.string.internal.QUOT_RE_ = /"/g;
  goog.string.internal.SINGLE_QUOTE_RE_ = /'/g;
  goog.string.internal.NULL_RE_ = /\x00/g;
  goog.string.internal.ALL_RE_ = /[\x00&<>"']/;
  goog.string.internal.whitespaceEscape = function(a2, b) {
    return goog.string.internal.newLineToBr(a2.replace(/  /g, " &#160;"), b);
  };
  goog.string.internal.contains = function(a2, b) {
    return a2.indexOf(b) != -1;
  };
  goog.string.internal.caseInsensitiveContains = function(a2, b) {
    return goog.string.internal.contains(a2.toLowerCase(), b.toLowerCase());
  };
  goog.string.internal.compareVersions = function(a2, b) {
    var c = 0;
    a2 = goog.string.internal.trim(String(a2)).split(".");
    b = goog.string.internal.trim(String(b)).split(".");
    for (var d = Math.max(a2.length, b.length), e = 0; c == 0 && e < d; e++) {
      var f = a2[e] || "", g = b[e] || "";
      do {
        f = /(\d*)(\D*)(.*)/.exec(f) || ["", "", "", ""];
        g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];
        if (f[0].length == 0 && g[0].length == 0)
          break;
        c = f[1].length == 0 ? 0 : parseInt(f[1], 10);
        var h = g[1].length == 0 ? 0 : parseInt(g[1], 10);
        c = goog.string.internal.compareElements_(c, h) || goog.string.internal.compareElements_(f[2].length == 0, g[2].length == 0) || goog.string.internal.compareElements_(f[2], g[2]);
        f = f[3];
        g = g[3];
      } while (c == 0);
    }
    return c;
  };
  goog.string.internal.compareElements_ = function(a2, b) {
    return a2 < b ? -1 : a2 > b ? 1 : 0;
  };
  goog.html.SafeUrl = function() {
    this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = "";
    this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  };
  goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez";
  goog.html.SafeUrl.prototype.implementsGoogStringTypedString = true;
  goog.html.SafeUrl.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
  };
  goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = true;
  goog.html.SafeUrl.prototype.getDirection = function() {
    return goog.i18n.bidi.Dir.LTR;
  };
  goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
    return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
  });
  goog.html.SafeUrl.unwrap = function(a2) {
    return goog.html.SafeUrl.unwrapTrustedURL(a2).toString();
  };
  goog.html.SafeUrl.unwrapTrustedURL = function(a2) {
    if (a2 instanceof goog.html.SafeUrl && a2.constructor === goog.html.SafeUrl && a2.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseSafeUrlWrappedValue_;
    goog.asserts.fail("expected object of type SafeUrl, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:SafeUrl";
  };
  goog.html.SafeUrl.fromConstant = function(a2) {
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a2));
  };
  goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime))(?:;\w+=(?:\w+|"[\w;=]+"))*$/i;
  goog.html.SafeUrl.isSafeMimeType = function(a2) {
    return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a2);
  };
  goog.html.SafeUrl.fromBlob = function(a2) {
    a2 = goog.html.SAFE_MIME_TYPE_PATTERN_.test(a2.type) ? goog.fs.url.createObjectUrl(a2) : goog.html.SafeUrl.INNOCUOUS_STRING;
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.DATA_URL_PATTERN_ = /^data:([^,]*);base64,[a-z0-9+\/]+=*$/i;
  goog.html.SafeUrl.fromDataUrl = function(a2) {
    a2 = a2.replace(/(%0A|%0D)/g, "");
    var b = a2.match(goog.html.DATA_URL_PATTERN_);
    b = b && goog.html.SAFE_MIME_TYPE_PATTERN_.test(b[1]);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b ? a2 : goog.html.SafeUrl.INNOCUOUS_STRING);
  };
  goog.html.SafeUrl.fromTelUrl = function(a2) {
    goog.string.internal.caseInsensitiveStartsWith(a2, "tel:") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;
  goog.html.SafeUrl.fromSipUrl = function(a2) {
    goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a2)) || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.fromFacebookMessengerUrl = function(a2) {
    goog.string.internal.caseInsensitiveStartsWith(a2, "fb-messenger://share") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.fromWhatsAppUrl = function(a2) {
    goog.string.internal.caseInsensitiveStartsWith(a2, "whatsapp://send") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.fromSmsUrl = function(a2) {
    goog.string.internal.caseInsensitiveStartsWith(a2, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(a2) || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.isSmsUrlBodyValid_ = function(a2) {
    var b = a2.indexOf("#");
    0 < b && (a2 = a2.substring(0, b));
    b = a2.match(/[?&]body=/gi);
    if (!b)
      return true;
    if (1 < b.length)
      return false;
    a2 = a2.match(/[?&]body=([^&]*)/)[1];
    if (!a2)
      return true;
    try {
      decodeURIComponent(a2);
    } catch (c) {
      return false;
    }
    return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a2);
  };
  goog.html.SafeUrl.fromSshUrl = function(a2) {
    goog.string.internal.caseInsensitiveStartsWith(a2, "ssh://") || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(a2, b) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, a2, b);
  };
  goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(a2, b) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, a2, b);
  };
  goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(a2, b) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, a2, b);
  };
  goog.html.SafeUrl.sanitizeExtensionUrl_ = function(a2, b, c) {
    (a2 = a2.exec(b)) ? (a2 = a2[1], (c instanceof goog.string.Const ? [goog.string.Const.unwrap(c)] : c.map(function(a3) {
      return goog.string.Const.unwrap(a3);
    })).indexOf(a2) == -1 && (b = goog.html.SafeUrl.INNOCUOUS_STRING)) : b = goog.html.SafeUrl.INNOCUOUS_STRING;
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.SafeUrl.fromTrustedResourceUrl = function(a2) {
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a2));
  };
  goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
  goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_;
  goog.html.SafeUrl.sanitize = function(a2) {
    if (a2 instanceof goog.html.SafeUrl)
      return a2;
    a2 = typeof a2 == "object" && a2.implementsGoogStringTypedString ? a2.getTypedStringValue() : String(a2);
    goog.html.SAFE_URL_PATTERN_.test(a2) || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.sanitizeAssertUnchanged = function(a2, b) {
    if (a2 instanceof goog.html.SafeUrl)
      return a2;
    a2 = typeof a2 == "object" && a2.implementsGoogStringTypedString ? a2.getTypedStringValue() : String(a2);
    if (b && /^data:/i.test(a2) && (b = goog.html.SafeUrl.fromDataUrl(a2), b.getTypedStringValue() == a2))
      return b;
    goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a2), "%s does not match the safe URL pattern", a2) || (a2 = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(a2) {
    var b = new goog.html.SafeUrl();
    b.privateDoNotAccessOrElseSafeUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a2) : a2;
    return b;
  };
  goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");
  goog.html.SafeStyle = function() {
    this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = "";
    this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  };
  goog.html.SafeStyle.prototype.implementsGoogStringTypedString = true;
  goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.SafeStyle.fromConstant = function(a2) {
    a2 = goog.string.Const.unwrap(a2);
    if (a2.length === 0)
      return goog.html.SafeStyle.EMPTY;
    goog.asserts.assert(goog.string.internal.endsWith(a2, ";"), "Last character of style string is not ';': " + a2);
    goog.asserts.assert(goog.string.internal.contains(a2, ":"), `Style string must contain at least one ':', to specify a "name: value" pair: ` + a2);
    return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeStyle.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
  };
  goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
    return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
  });
  goog.html.SafeStyle.unwrap = function(a2) {
    if (a2 instanceof goog.html.SafeStyle && a2.constructor === goog.html.SafeStyle && a2.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseSafeStyleWrappedValue_;
    goog.asserts.fail("expected object of type SafeStyle, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:SafeStyle";
  };
  goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(a2) {
    return new goog.html.SafeStyle().initSecurityPrivateDoNotAccessOrElse_(a2);
  };
  goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a2) {
    this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = a2;
    return this;
  };
  goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");
  goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez";
  goog.html.SafeStyle.create = function(a2) {
    var b = "", c;
    for (c in a2) {
      if (!/^[-_a-zA-Z0-9]+$/.test(c))
        throw Error("Name allows only [-_a-zA-Z0-9], got: " + c);
      var d = a2[c];
      d != null && (d = goog.isArray(d) ? goog.array.map(d, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(d), b += c + ":" + d + ";");
    }
    return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
  };
  goog.html.SafeStyle.sanitizePropertyValue_ = function(a2) {
    if (a2 instanceof goog.html.SafeUrl)
      return 'url("' + goog.html.SafeUrl.unwrap(a2).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
    a2 = a2 instanceof goog.string.Const ? goog.string.Const.unwrap(a2) : goog.html.SafeStyle.sanitizePropertyValueString_(String(a2));
    if (/[{;}]/.test(a2))
      throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [a2]);
    return a2;
  };
  goog.html.SafeStyle.sanitizePropertyValueString_ = function(a2) {
    var b = a2.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
    if (goog.html.SafeStyle.VALUE_RE_.test(b)) {
      if (goog.html.SafeStyle.COMMENT_RE_.test(a2))
        return goog.asserts.fail("String value disallows comments, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
      if (!goog.html.SafeStyle.hasBalancedQuotes_(a2))
        return goog.asserts.fail("String value requires balanced quotes, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
      if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(a2))
        return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
    } else
      return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + a2), goog.html.SafeStyle.INNOCUOUS_STRING;
    return goog.html.SafeStyle.sanitizeUrl_(a2);
  };
  goog.html.SafeStyle.hasBalancedQuotes_ = function(a2) {
    for (var b = true, c = true, d = 0; d < a2.length; d++) {
      var e = a2.charAt(d);
      e == "'" && c ? b = !b : e == '"' && b && (c = !c);
    }
    return b && c;
  };
  goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(a2) {
    for (var b = true, c = /^[-_a-zA-Z0-9]$/, d = 0; d < a2.length; d++) {
      var e = a2.charAt(d);
      if (e == "]") {
        if (b)
          return false;
        b = true;
      } else if (e == "[") {
        if (!b)
          return false;
        b = false;
      } else if (!b && !c.test(e))
        return false;
    }
    return b;
  };
  goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = `[-,."'%_!# a-zA-Z0-9\\[\\]]`;
  goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$");
  goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;
  goog.html.SafeStyle.FUNCTIONS_RE_ = /\b(hsl|hsla|rgb|rgba|matrix|calc|minmax|fit-content|repeat|(rotate|scale|translate)(X|Y|Z|3d)?)\([-+*/0-9a-z.%\[\], ]+\)/g;
  goog.html.SafeStyle.COMMENT_RE_ = /\/\*/;
  goog.html.SafeStyle.sanitizeUrl_ = function(a2) {
    return a2.replace(goog.html.SafeStyle.URL_RE_, function(a3, c, d, e) {
      var b = "";
      d = d.replace(/^(['"])(.*)\1$/, function(a4, c2, d2) {
        b = c2;
        return d2;
      });
      a3 = goog.html.SafeUrl.sanitize(d).getTypedStringValue();
      return c + b + a3 + b + e;
    });
  };
  goog.html.SafeStyle.concat = function(a2) {
    var b = "", c = function(a3) {
      goog.isArray(a3) ? goog.array.forEach(a3, c) : b += goog.html.SafeStyle.unwrap(a3);
    };
    goog.array.forEach(arguments, c);
    return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
  };
  goog.html.SafeStyleSheet = function() {
    this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = "";
    this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
  };
  goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString = true;
  goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.SafeStyleSheet.createRule = function(a2, b) {
    if (goog.string.internal.contains(a2, "<"))
      throw Error("Selector does not allow '<', got: " + a2);
    var c = a2.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
    if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c))
      throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + a2);
    if (!goog.html.SafeStyleSheet.hasBalancedBrackets_(c))
      throw Error("() and [] in selector must be balanced, got: " + a2);
    b instanceof goog.html.SafeStyle || (b = goog.html.SafeStyle.create(b));
    a2 = a2 + "{" + goog.html.SafeStyle.unwrap(b).replace(/</g, "\\3C ") + "}";
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeStyleSheet.hasBalancedBrackets_ = function(a2) {
    for (var b = { "(": ")", "[": "]" }, c = [], d = 0; d < a2.length; d++) {
      var e = a2[d];
      if (b[e])
        c.push(b[e]);
      else if (goog.object.contains(b, e) && c.pop() != e)
        return false;
    }
    return c.length == 0;
  };
  goog.html.SafeStyleSheet.concat = function(a2) {
    var b = "", c = function(a3) {
      goog.isArray(a3) ? goog.array.forEach(a3, c) : b += goog.html.SafeStyleSheet.unwrap(a3);
    };
    goog.array.forEach(arguments, c);
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.SafeStyleSheet.fromConstant = function(a2) {
    a2 = goog.string.Const.unwrap(a2);
    if (a2.length === 0)
      return goog.html.SafeStyleSheet.EMPTY;
    goog.asserts.assert(!goog.string.internal.contains(a2, "<"), "Forbidden '<' character in style sheet string: " + a2);
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a2);
  };
  goog.html.SafeStyleSheet.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
  };
  goog.DEBUG && (goog.html.SafeStyleSheet.prototype.toString = function() {
    return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
  });
  goog.html.SafeStyleSheet.unwrap = function(a2) {
    if (a2 instanceof goog.html.SafeStyleSheet && a2.constructor === goog.html.SafeStyleSheet && a2.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
    goog.asserts.fail("expected object of type SafeStyleSheet, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:SafeStyleSheet";
  };
  goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(a2) {
    return new goog.html.SafeStyleSheet().initSecurityPrivateDoNotAccessOrElse_(a2);
  };
  goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a2) {
    this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = a2;
    return this;
  };
  goog.html.SafeStyleSheet.EMPTY = goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");
  goog.labs = {};
  goog.labs.userAgent = {};
  goog.labs.userAgent.util = {};
  goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
    var a2 = goog.labs.userAgent.util.getNavigator_();
    return a2 && (a2 = a2.userAgent) ? a2 : "";
  };
  goog.labs.userAgent.util.getNavigator_ = function() {
    return goog.global.navigator;
  };
  goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_();
  goog.labs.userAgent.util.setUserAgent = function(a2) {
    goog.labs.userAgent.util.userAgent_ = a2 || goog.labs.userAgent.util.getNativeUserAgentString_();
  };
  goog.labs.userAgent.util.getUserAgent = function() {
    return goog.labs.userAgent.util.userAgent_;
  };
  goog.labs.userAgent.util.matchUserAgent = function(a2) {
    var b = goog.labs.userAgent.util.getUserAgent();
    return goog.string.internal.contains(b, a2);
  };
  goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(a2) {
    var b = goog.labs.userAgent.util.getUserAgent();
    return goog.string.internal.caseInsensitiveContains(b, a2);
  };
  goog.labs.userAgent.util.extractVersionTuples = function(a2) {
    for (var b = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, c = [], d; d = b.exec(a2); )
      c.push([d[1], d[2], d[3] || void 0]);
    return c;
  };
  goog.labs.userAgent.browser = {};
  goog.labs.userAgent.browser.matchOpera_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Opera");
  };
  goog.labs.userAgent.browser.matchIE_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
  };
  goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edge");
  };
  goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edg/");
  };
  goog.labs.userAgent.browser.matchOperaChromium_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("OPR");
  };
  goog.labs.userAgent.browser.matchFirefox_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
  };
  goog.labs.userAgent.browser.matchSafari_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
  };
  goog.labs.userAgent.browser.matchCoast_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Coast");
  };
  goog.labs.userAgent.browser.matchIosWebview_ = function() {
    return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
  };
  goog.labs.userAgent.browser.matchChrome_ = function() {
    return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
  };
  goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
  };
  goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_;
  goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_;
  goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_;
  goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_;
  goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_;
  goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_;
  goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_;
  goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_;
  goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_;
  goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_;
  goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_;
  goog.labs.userAgent.browser.isSilk = function() {
    return goog.labs.userAgent.util.matchUserAgent("Silk");
  };
  goog.labs.userAgent.browser.getVersion = function() {
    function a2(a3) {
      a3 = goog.array.find(a3, d);
      return c[a3] || "";
    }
    var b = goog.labs.userAgent.util.getUserAgent();
    if (goog.labs.userAgent.browser.isIE())
      return goog.labs.userAgent.browser.getIEVersion_(b);
    b = goog.labs.userAgent.util.extractVersionTuples(b);
    var c = {};
    goog.array.forEach(b, function(a3) {
      c[a3[0]] = a3[1];
    });
    var d = goog.partial(goog.object.containsKey, c);
    return goog.labs.userAgent.browser.isOpera() ? a2(["Version", "Opera"]) : goog.labs.userAgent.browser.isEdge() ? a2(["Edge"]) : goog.labs.userAgent.browser.isEdgeChromium() ? a2(["Edg"]) : goog.labs.userAgent.browser.isChrome() ? a2(["Chrome", "CriOS"]) : (b = b[2]) && b[1] || "";
  };
  goog.labs.userAgent.browser.isVersionOrHigher = function(a2) {
    return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), a2);
  };
  goog.labs.userAgent.browser.getIEVersion_ = function(a2) {
    var b = /rv: *([\d\.]*)/.exec(a2);
    if (b && b[1])
      return b[1];
    b = "";
    var c = /MSIE +([\d\.]+)/.exec(a2);
    if (c && c[1])
      if (a2 = /Trident\/(\d.\d)/.exec(a2), c[1] == "7.0")
        if (a2 && a2[1])
          switch (a2[1]) {
            case "4.0":
              b = "8.0";
              break;
            case "5.0":
              b = "9.0";
              break;
            case "6.0":
              b = "10.0";
              break;
            case "7.0":
              b = "11.0";
          }
        else
          b = "7.0";
      else
        b = c[1];
    return b;
  };
  goog.html.SafeHtml = function() {
    this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = "";
    this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    this.dir_ = null;
  };
  goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = true;
  goog.html.SafeHtml.prototype.getDirection = function() {
    return this.dir_;
  };
  goog.html.SafeHtml.prototype.implementsGoogStringTypedString = true;
  goog.html.SafeHtml.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
  };
  goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
    return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
  });
  goog.html.SafeHtml.unwrap = function(a2) {
    return goog.html.SafeHtml.unwrapTrustedHTML(a2).toString();
  };
  goog.html.SafeHtml.unwrapTrustedHTML = function(a2) {
    if (a2 instanceof goog.html.SafeHtml && a2.constructor === goog.html.SafeHtml && a2.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_)
      return a2.privateDoNotAccessOrElseSafeHtmlWrappedValue_;
    goog.asserts.fail("expected object of type SafeHtml, got '" + a2 + "' of type " + goog.typeOf(a2));
    return "type_error:SafeHtml";
  };
  goog.html.SafeHtml.htmlEscape = function(a2) {
    if (a2 instanceof goog.html.SafeHtml)
      return a2;
    var b = typeof a2 == "object", c = null;
    b && a2.implementsGoogI18nBidiDirectionalString && (c = a2.getDirection());
    a2 = b && a2.implementsGoogStringTypedString ? a2.getTypedStringValue() : String(a2);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a2), c);
  };
  goog.html.SafeHtml.htmlEscapePreservingNewlines = function(a2) {
    if (a2 instanceof goog.html.SafeHtml)
      return a2;
    a2 = goog.html.SafeHtml.htmlEscape(a2);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a2)), a2.getDirection());
  };
  goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(a2) {
    if (a2 instanceof goog.html.SafeHtml)
      return a2;
    a2 = goog.html.SafeHtml.htmlEscape(a2);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a2)), a2.getDirection());
  };
  goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape;
  goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/;
  goog.html.SafeHtml.URL_ATTRIBUTES_ = { action: true, cite: true, data: true, formaction: true, href: true, manifest: true, poster: true, src: true };
  goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = { APPLET: true, BASE: true, EMBED: true, IFRAME: true, LINK: true, MATH: true, META: true, OBJECT: true, SCRIPT: true, STYLE: true, SVG: true, TEMPLATE: true };
  goog.html.SafeHtml.create = function(a2, b, c) {
    goog.html.SafeHtml.verifyTagName(String(a2));
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a2), b, c);
  };
  goog.html.SafeHtml.verifyTagName = function(a2) {
    if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a2))
      throw Error("Invalid tag name <" + a2 + ">.");
    if (a2.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_)
      throw Error("Tag name <" + a2 + "> is not allowed for SafeHtml.");
  };
  goog.html.SafeHtml.createIframe = function(a2, b, c, d) {
    a2 && goog.html.TrustedResourceUrl.unwrap(a2);
    var e = {};
    e.src = a2 || null;
    e.srcdoc = b && goog.html.SafeHtml.unwrap(b);
    a2 = goog.html.SafeHtml.combineAttributes(e, { sandbox: "" }, c);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a2, d);
  };
  goog.html.SafeHtml.createSandboxIframe = function(a2, b, c, d) {
    if (!goog.html.SafeHtml.canUseSandboxIframe())
      throw Error("The browser does not support sandboxed iframes.");
    var e = {};
    e.src = a2 ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a2)) : null;
    e.srcdoc = b || null;
    e.sandbox = "";
    a2 = goog.html.SafeHtml.combineAttributes(e, {}, c);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a2, d);
  };
  goog.html.SafeHtml.canUseSandboxIframe = function() {
    return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
  };
  goog.html.SafeHtml.createScriptSrc = function(a2, b) {
    goog.html.TrustedResourceUrl.unwrap(a2);
    a2 = goog.html.SafeHtml.combineAttributes({ src: a2 }, {}, b);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", a2);
  };
  goog.html.SafeHtml.createScript = function(a2, b) {
    for (var c in b) {
      var d = c.toLowerCase();
      if (d == "language" || d == "src" || d == "text" || d == "type")
        throw Error('Cannot set "' + d + '" attribute');
    }
    c = "";
    a2 = goog.array.concat(a2);
    for (d = 0; d < a2.length; d++)
      c += goog.html.SafeScript.unwrap(a2[d]);
    a2 = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", b, a2);
  };
  goog.html.SafeHtml.createStyle = function(a2, b) {
    b = goog.html.SafeHtml.combineAttributes({ type: "text/css" }, {}, b);
    var c = "";
    a2 = goog.array.concat(a2);
    for (var d = 0; d < a2.length; d++)
      c += goog.html.SafeStyleSheet.unwrap(a2[d]);
    a2 = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", b, a2);
  };
  goog.html.SafeHtml.createMetaRefresh = function(a2, b) {
    a2 = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a2));
    (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(a2, ";") && (a2 = "'" + a2.replace(/'/g, "%27") + "'");
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", { "http-equiv": "refresh", content: (b || 0) + "; url=" + a2 });
  };
  goog.html.SafeHtml.getAttrNameAndValue_ = function(a2, b, c) {
    if (c instanceof goog.string.Const)
      c = goog.string.Const.unwrap(c);
    else if (b.toLowerCase() == "style")
      c = goog.html.SafeHtml.getStyleValue_(c);
    else {
      if (/^on/i.test(b))
        throw Error('Attribute "' + b + '" requires goog.string.Const value, "' + c + '" given.');
      if (b.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_)
        if (c instanceof goog.html.TrustedResourceUrl)
          c = goog.html.TrustedResourceUrl.unwrap(c);
        else if (c instanceof goog.html.SafeUrl)
          c = goog.html.SafeUrl.unwrap(c);
        else if (goog.isString(c))
          c = goog.html.SafeUrl.sanitize(c).getTypedStringValue();
        else
          throw Error('Attribute "' + b + '" on tag "' + a2 + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + c + '" given.');
    }
    c.implementsGoogStringTypedString && (c = c.getTypedStringValue());
    goog.asserts.assert(goog.isString(c) || goog.isNumber(c), "String or number value expected, got " + typeof c + " with value: " + c);
    return b + '="' + goog.string.internal.htmlEscape(String(c)) + '"';
  };
  goog.html.SafeHtml.getStyleValue_ = function(a2) {
    if (!goog.isObject(a2))
      throw Error('The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof a2 + " given: " + a2);
    a2 instanceof goog.html.SafeStyle || (a2 = goog.html.SafeStyle.create(a2));
    return goog.html.SafeStyle.unwrap(a2);
  };
  goog.html.SafeHtml.createWithDir = function(a2, b, c, d) {
    b = goog.html.SafeHtml.create(b, c, d);
    b.dir_ = a2;
    return b;
  };
  goog.html.SafeHtml.join = function(a2, b) {
    a2 = goog.html.SafeHtml.htmlEscape(a2);
    var c = a2.getDirection(), d = [], e = function(a3) {
      goog.isArray(a3) ? goog.array.forEach(a3, e) : (a3 = goog.html.SafeHtml.htmlEscape(a3), d.push(goog.html.SafeHtml.unwrap(a3)), a3 = a3.getDirection(), c == goog.i18n.bidi.Dir.NEUTRAL ? c = a3 : a3 != goog.i18n.bidi.Dir.NEUTRAL && c != a3 && (c = null));
    };
    goog.array.forEach(b, e);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a2)), c);
  };
  goog.html.SafeHtml.concat = function(a2) {
    return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
  };
  goog.html.SafeHtml.concatWithDir = function(a2, b) {
    var c = goog.html.SafeHtml.concat(goog.array.slice(arguments, 1));
    c.dir_ = a2;
    return c;
  };
  goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
  goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(a2, b) {
    return new goog.html.SafeHtml().initSecurityPrivateDoNotAccessOrElse_(a2, b);
  };
  goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a2, b) {
    this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(a2) : a2;
    this.dir_ = b;
    return this;
  };
  goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(a2, b, c) {
    var d = null;
    var e = "<" + a2 + goog.html.SafeHtml.stringifyAttributes(a2, b);
    goog.isDefAndNotNull(c) ? goog.isArray(c) || (c = [c]) : c = [];
    goog.dom.tags.isVoidTag(a2.toLowerCase()) ? (goog.asserts.assert(!c.length, "Void tag <" + a2 + "> does not allow content."), e += ">") : (d = goog.html.SafeHtml.concat(c), e += ">" + goog.html.SafeHtml.unwrap(d) + "</" + a2 + ">", d = d.getDirection());
    (a2 = b && b.dir) && (d = /^(ltr|rtl|auto)$/i.test(a2) ? goog.i18n.bidi.Dir.NEUTRAL : null);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e, d);
  };
  goog.html.SafeHtml.stringifyAttributes = function(a2, b) {
    var c = "";
    if (b)
      for (var d in b) {
        if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d))
          throw Error('Invalid attribute name "' + d + '".');
        var e = b[d];
        goog.isDefAndNotNull(e) && (c += " " + goog.html.SafeHtml.getAttrNameAndValue_(a2, d, e));
      }
    return c;
  };
  goog.html.SafeHtml.combineAttributes = function(a2, b, c) {
    var d = {}, e;
    for (e in a2)
      goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = a2[e];
    for (e in b)
      goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = b[e];
    for (e in c) {
      var f = e.toLowerCase();
      if (f in a2)
        throw Error('Cannot override "' + f + '" attribute, got "' + e + '" with value "' + c[e] + '"');
      f in b && delete d[f];
      d[e] = c[e];
    }
    return d;
  };
  goog.html.SafeHtml.DOCTYPE_HTML = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL);
  goog.html.SafeHtml.EMPTY = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("", goog.i18n.bidi.Dir.NEUTRAL);
  goog.html.SafeHtml.BR = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL);
  goog.html.uncheckedconversions = {};
  goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(a2, b, c) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b, c || null);
  };
  goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(a2, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(a2, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(a2, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(a2, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(a2, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a2), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a2)), "must provide non-empty justification");
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
  };
  goog.dom.safe = {};
  goog.dom.safe.InsertAdjacentHtmlPosition = { AFTERBEGIN: "afterbegin", AFTEREND: "afterend", BEFOREBEGIN: "beforebegin", BEFOREEND: "beforeend" };
  goog.dom.safe.insertAdjacentHtml = function(a2, b, c) {
    a2.insertAdjacentHTML(b, goog.html.SafeHtml.unwrapTrustedHTML(c));
  };
  goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = { MATH: true, SCRIPT: true, STYLE: true, SVG: true, TEMPLATE: true };
  goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
    if (goog.DEBUG && typeof document === "undefined")
      return false;
    var a2 = document.createElement("div"), b = document.createElement("div");
    b.appendChild(document.createElement("div"));
    a2.appendChild(b);
    if (goog.DEBUG && !a2.firstChild)
      return false;
    b = a2.firstChild.firstChild;
    a2.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);
    return !b.parentElement;
  });
  goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(a2, b) {
    if (goog.dom.safe.isInnerHtmlCleanupRecursive_())
      for (; a2.lastChild; )
        a2.removeChild(a2.lastChild);
    a2.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
  };
  goog.dom.safe.setInnerHtml = function(a2, b) {
    if (goog.asserts.ENABLE_ASSERTS) {
      var c = a2.tagName.toUpperCase();
      if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c])
        throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + a2.tagName + ".");
    }
    goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a2, b);
  };
  goog.dom.safe.setOuterHtml = function(a2, b) {
    a2.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
  };
  goog.dom.safe.setFormElementAction = function(a2, b) {
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    goog.dom.asserts.assertIsHTMLFormElement(a2).action = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setButtonFormAction = function(a2, b) {
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    goog.dom.asserts.assertIsHTMLButtonElement(a2).formAction = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setInputFormAction = function(a2, b) {
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    goog.dom.asserts.assertIsHTMLInputElement(a2).formAction = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setStyle = function(a2, b) {
    a2.style.cssText = goog.html.SafeStyle.unwrap(b);
  };
  goog.dom.safe.documentWrite = function(a2, b) {
    a2.write(goog.html.SafeHtml.unwrapTrustedHTML(b));
  };
  goog.dom.safe.setAnchorHref = function(a2, b) {
    goog.dom.asserts.assertIsHTMLAnchorElement(a2);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a2.href = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setImageSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLImageElement(a2);
    if (!(b instanceof goog.html.SafeUrl)) {
      var c = /^data:image\//i.test(b);
      b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
    }
    a2.src = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setAudioSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLAudioElement(a2);
    if (!(b instanceof goog.html.SafeUrl)) {
      var c = /^data:audio\//i.test(b);
      b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
    }
    a2.src = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setVideoSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLVideoElement(a2);
    if (!(b instanceof goog.html.SafeUrl)) {
      var c = /^data:video\//i.test(b);
      b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
    }
    a2.src = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setEmbedSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLEmbedElement(a2);
    a2.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
  };
  goog.dom.safe.setFrameSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLFrameElement(a2);
    a2.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setIframeSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLIFrameElement(a2);
    a2.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.setIframeSrcdoc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLIFrameElement(a2);
    a2.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(b);
  };
  goog.dom.safe.setLinkHrefAndRel = function(a2, b, c) {
    goog.dom.asserts.assertIsHTMLLinkElement(a2);
    a2.rel = c;
    goog.string.internal.caseInsensitiveContains(c, "stylesheet") ? (goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), a2.href = goog.html.TrustedResourceUrl.unwrapTrustedURL(b)) : a2.href = b instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrapTrustedURL(b) : b instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrapTrustedURL(b) : goog.html.SafeUrl.unwrapTrustedURL(goog.html.SafeUrl.sanitizeAssertUnchanged(b));
  };
  goog.dom.safe.setObjectData = function(a2, b) {
    goog.dom.asserts.assertIsHTMLObjectElement(a2);
    a2.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
  };
  goog.dom.safe.setScriptSrc = function(a2, b) {
    goog.dom.asserts.assertIsHTMLScriptElement(a2);
    a2.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
    (b = goog.getScriptNonce()) && a2.setAttribute("nonce", b);
  };
  goog.dom.safe.setScriptContent = function(a2, b) {
    goog.dom.asserts.assertIsHTMLScriptElement(a2);
    a2.text = goog.html.SafeScript.unwrapTrustedScript(b);
    (b = goog.getScriptNonce()) && a2.setAttribute("nonce", b);
  };
  goog.dom.safe.setLocationHref = function(a2, b) {
    goog.dom.asserts.assertIsLocation(a2);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a2.href = goog.html.SafeUrl.unwrapTrustedURL(b);
  };
  goog.dom.safe.assignLocation = function(a2, b) {
    goog.dom.asserts.assertIsLocation(a2);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a2.assign(goog.html.SafeUrl.unwrapTrustedURL(b));
  };
  goog.dom.safe.replaceLocation = function(a2, b) {
    goog.dom.asserts.assertIsLocation(a2);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a2.replace(goog.html.SafeUrl.unwrapTrustedURL(b));
  };
  goog.dom.safe.openInWindow = function(a2, b, c, d, e) {
    a2 = a2 instanceof goog.html.SafeUrl ? a2 : goog.html.SafeUrl.sanitizeAssertUnchanged(a2);
    return (b || goog.global).open(goog.html.SafeUrl.unwrapTrustedURL(a2), c ? goog.string.Const.unwrap(c) : "", d, e);
  };
  goog.dom.safe.parseFromStringHtml = function(a2, b) {
    return goog.dom.safe.parseFromString(a2, b, "text/html");
  };
  goog.dom.safe.parseFromString = function(a2, b, c) {
    return a2.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b), c);
  };
  goog.dom.safe.createImageFromBlob = function(a2) {
    if (!/^image\/.*/g.test(a2.type))
      throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
    var b = goog.global.URL.createObjectURL(a2);
    a2 = new goog.global.Image();
    a2.onload = function() {
      goog.global.URL.revokeObjectURL(b);
    };
    goog.dom.safe.setImageSrc(a2, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), b));
    return a2;
  };
  goog.string.DETECT_DOUBLE_ESCAPING = false;
  goog.string.FORCE_NON_DOM_HTML_UNESCAPING = false;
  goog.string.Unicode = { NBSP: "\xA0" };
  goog.string.startsWith = goog.string.internal.startsWith;
  goog.string.endsWith = goog.string.internal.endsWith;
  goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith;
  goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith;
  goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals;
  goog.string.subs = function(a2, b) {
    for (var c = a2.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length; )
      d += c.shift() + e.shift();
    return d + c.join("%s");
  };
  goog.string.collapseWhitespace = function(a2) {
    return a2.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
  };
  goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace;
  goog.string.isEmptyString = function(a2) {
    return a2.length == 0;
  };
  goog.string.isEmpty = goog.string.isEmptyOrWhitespace;
  goog.string.isEmptyOrWhitespaceSafe = function(a2) {
    return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a2));
  };
  goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;
  goog.string.isBreakingWhitespace = function(a2) {
    return !/[^\t\n\r ]/.test(a2);
  };
  goog.string.isAlpha = function(a2) {
    return !/[^a-zA-Z]/.test(a2);
  };
  goog.string.isNumeric = function(a2) {
    return !/[^0-9]/.test(a2);
  };
  goog.string.isAlphaNumeric = function(a2) {
    return !/[^a-zA-Z0-9]/.test(a2);
  };
  goog.string.isSpace = function(a2) {
    return a2 == " ";
  };
  goog.string.isUnicodeChar = function(a2) {
    return a2.length == 1 && " " <= a2 && "~" >= a2 || "\x80" <= a2 && "\uFFFD" >= a2;
  };
  goog.string.stripNewlines = function(a2) {
    return a2.replace(/(\r\n|\r|\n)+/g, " ");
  };
  goog.string.canonicalizeNewlines = function(a2) {
    return a2.replace(/(\r\n|\r|\n)/g, "\n");
  };
  goog.string.normalizeWhitespace = function(a2) {
    return a2.replace(/\xa0|\s/g, " ");
  };
  goog.string.normalizeSpaces = function(a2) {
    return a2.replace(/\xa0|[ \t]+/g, " ");
  };
  goog.string.collapseBreakingSpaces = function(a2) {
    return a2.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
  };
  goog.string.trim = goog.string.internal.trim;
  goog.string.trimLeft = function(a2) {
    return a2.replace(/^[\s\xa0]+/, "");
  };
  goog.string.trimRight = function(a2) {
    return a2.replace(/[\s\xa0]+$/, "");
  };
  goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare;
  goog.string.numberAwareCompare_ = function(a2, b, c) {
    if (a2 == b)
      return 0;
    if (!a2)
      return -1;
    if (!b)
      return 1;
    for (var d = a2.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++) {
      c = d[g];
      var h = e[g];
      if (c != h)
        return a2 = parseInt(c, 10), !isNaN(a2) && (b = parseInt(h, 10), !isNaN(b) && a2 - b) ? a2 - b : c < h ? -1 : 1;
    }
    return d.length != e.length ? d.length - e.length : a2 < b ? -1 : 1;
  };
  goog.string.intAwareCompare = function(a2, b) {
    return goog.string.numberAwareCompare_(a2, b, /\d+|\D+/g);
  };
  goog.string.floatAwareCompare = function(a2, b) {
    return goog.string.numberAwareCompare_(a2, b, /\d+|\.\d+|\D+/g);
  };
  goog.string.numerateCompare = goog.string.floatAwareCompare;
  goog.string.urlEncode = function(a2) {
    return encodeURIComponent(String(a2));
  };
  goog.string.urlDecode = function(a2) {
    return decodeURIComponent(a2.replace(/\+/g, " "));
  };
  goog.string.newLineToBr = goog.string.internal.newLineToBr;
  goog.string.htmlEscape = function(a2, b) {
    a2 = goog.string.internal.htmlEscape(a2, b);
    goog.string.DETECT_DOUBLE_ESCAPING && (a2 = a2.replace(goog.string.E_RE_, "&#101;"));
    return a2;
  };
  goog.string.E_RE_ = /e/g;
  goog.string.unescapeEntities = function(a2) {
    return goog.string.contains(a2, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a2) : goog.string.unescapePureXmlEntities_(a2) : a2;
  };
  goog.string.unescapeEntitiesWithDocument = function(a2, b) {
    return goog.string.contains(a2, "&") ? goog.string.unescapeEntitiesUsingDom_(a2, b) : a2;
  };
  goog.string.unescapeEntitiesUsingDom_ = function(a2, b) {
    var c = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"' };
    var d = b ? b.createElement("div") : goog.global.document.createElement("div");
    return a2.replace(goog.string.HTML_ENTITY_PATTERN_, function(a3, b2) {
      var e = c[a3];
      if (e)
        return e;
      b2.charAt(0) == "#" && (b2 = Number("0" + b2.substr(1)), isNaN(b2) || (e = String.fromCharCode(b2)));
      e || (goog.dom.safe.setInnerHtml(d, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), a3 + " ")), e = d.firstChild.nodeValue.slice(0, -1));
      return c[a3] = e;
    });
  };
  goog.string.unescapePureXmlEntities_ = function(a2) {
    return a2.replace(/&([^;]+);/g, function(a3, c) {
      switch (c) {
        case "amp":
          return "&";
        case "lt":
          return "<";
        case "gt":
          return ">";
        case "quot":
          return '"';
        default:
          return c.charAt(0) != "#" || (c = Number("0" + c.substr(1)), isNaN(c)) ? a3 : String.fromCharCode(c);
      }
    });
  };
  goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;
  goog.string.whitespaceEscape = function(a2, b) {
    return goog.string.newLineToBr(a2.replace(/  /g, " &#160;"), b);
  };
  goog.string.preserveSpaces = function(a2) {
    return a2.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
  };
  goog.string.stripQuotes = function(a2, b) {
    for (var c = b.length, d = 0; d < c; d++) {
      var e = c == 1 ? b : b.charAt(d);
      if (a2.charAt(0) == e && a2.charAt(a2.length - 1) == e)
        return a2.substring(1, a2.length - 1);
    }
    return a2;
  };
  goog.string.truncate = function(a2, b, c) {
    c && (a2 = goog.string.unescapeEntities(a2));
    a2.length > b && (a2 = a2.substring(0, b - 3) + "...");
    c && (a2 = goog.string.htmlEscape(a2));
    return a2;
  };
  goog.string.truncateMiddle = function(a2, b, c, d) {
    c && (a2 = goog.string.unescapeEntities(a2));
    if (d && a2.length > b) {
      d > b && (d = b);
      var e = a2.length - d;
      a2 = a2.substring(0, b - d) + "..." + a2.substring(e);
    } else
      a2.length > b && (d = Math.floor(b / 2), e = a2.length - d, a2 = a2.substring(0, d + b % 2) + "..." + a2.substring(e));
    c && (a2 = goog.string.htmlEscape(a2));
    return a2;
  };
  goog.string.specialEscapeChars_ = { "\0": "\\0", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t", "\v": "\\x0B", '"': '\\"', "\\": "\\\\", "<": "\\u003C" };
  goog.string.jsEscapeCache_ = { "'": "\\'" };
  goog.string.quote = function(a2) {
    a2 = String(a2);
    for (var b = ['"'], c = 0; c < a2.length; c++) {
      var d = a2.charAt(c), e = d.charCodeAt(0);
      b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
    }
    b.push('"');
    return b.join("");
  };
  goog.string.escapeString = function(a2) {
    for (var b = [], c = 0; c < a2.length; c++)
      b[c] = goog.string.escapeChar(a2.charAt(c));
    return b.join("");
  };
  goog.string.escapeChar = function(a2) {
    if (a2 in goog.string.jsEscapeCache_)
      return goog.string.jsEscapeCache_[a2];
    if (a2 in goog.string.specialEscapeChars_)
      return goog.string.jsEscapeCache_[a2] = goog.string.specialEscapeChars_[a2];
    var b = a2.charCodeAt(0);
    if (31 < b && 127 > b)
      var c = a2;
    else {
      if (256 > b) {
        if (c = "\\x", 16 > b || 256 < b)
          c += "0";
      } else
        c = "\\u", 4096 > b && (c += "0");
      c += b.toString(16).toUpperCase();
    }
    return goog.string.jsEscapeCache_[a2] = c;
  };
  goog.string.contains = goog.string.internal.contains;
  goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains;
  goog.string.countOf = function(a2, b) {
    return a2 && b ? a2.split(b).length - 1 : 0;
  };
  goog.string.removeAt = function(a2, b, c) {
    var d = a2;
    0 <= b && b < a2.length && 0 < c && (d = a2.substr(0, b) + a2.substr(b + c, a2.length - b - c));
    return d;
  };
  goog.string.remove = function(a2, b) {
    return a2.replace(b, "");
  };
  goog.string.removeAll = function(a2, b) {
    b = new RegExp(goog.string.regExpEscape(b), "g");
    return a2.replace(b, "");
  };
  goog.string.replaceAll = function(a2, b, c) {
    b = new RegExp(goog.string.regExpEscape(b), "g");
    return a2.replace(b, c.replace(/\$/g, "$$$$"));
  };
  goog.string.regExpEscape = function(a2) {
    return String(a2).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
  };
  goog.string.repeat = String.prototype.repeat ? function(a2, b) {
    return a2.repeat(b);
  } : function(a2, b) {
    return Array(b + 1).join(a2);
  };
  goog.string.padNumber = function(a2, b, c) {
    a2 = goog.isDef(c) ? a2.toFixed(c) : String(a2);
    c = a2.indexOf(".");
    c == -1 && (c = a2.length);
    return goog.string.repeat("0", Math.max(0, b - c)) + a2;
  };
  goog.string.makeSafe = function(a2) {
    return a2 == null ? "" : String(a2);
  };
  goog.string.buildString = function(a2) {
    return Array.prototype.join.call(arguments, "");
  };
  goog.string.getRandomString = function() {
    return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
  };
  goog.string.compareVersions = goog.string.internal.compareVersions;
  goog.string.hashCode = function(a2) {
    for (var b = 0, c = 0; c < a2.length; ++c)
      b = 31 * b + a2.charCodeAt(c) >>> 0;
    return b;
  };
  goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;
  goog.string.createUniqueString = function() {
    return "goog_" + goog.string.uniqueStringCounter_++;
  };
  goog.string.toNumber = function(a2) {
    var b = Number(a2);
    return b == 0 && goog.string.isEmptyOrWhitespace(a2) ? NaN : b;
  };
  goog.string.isLowerCamelCase = function(a2) {
    return /^[a-z]+([A-Z][a-z]*)*$/.test(a2);
  };
  goog.string.isUpperCamelCase = function(a2) {
    return /^([A-Z][a-z]*)+$/.test(a2);
  };
  goog.string.toCamelCase = function(a2) {
    return String(a2).replace(/\-([a-z])/g, function(a3, c) {
      return c.toUpperCase();
    });
  };
  goog.string.toSelectorCase = function(a2) {
    return String(a2).replace(/([A-Z])/g, "-$1").toLowerCase();
  };
  goog.string.toTitleCase = function(a2, b) {
    b = goog.isString(b) ? goog.string.regExpEscape(b) : "\\s";
    return a2.replace(new RegExp("(^" + (b ? "|[" + b + "]+" : "") + ")([a-z])", "g"), function(a3, b2, e) {
      return b2 + e.toUpperCase();
    });
  };
  goog.string.capitalize = function(a2) {
    return String(a2.charAt(0)).toUpperCase() + String(a2.substr(1)).toLowerCase();
  };
  goog.string.parseInt = function(a2) {
    isFinite(a2) && (a2 = String(a2));
    return goog.isString(a2) ? /^\s*-?0x/i.test(a2) ? parseInt(a2, 16) : parseInt(a2, 10) : NaN;
  };
  goog.string.splitLimit = function(a2, b, c) {
    a2 = a2.split(b);
    for (var d = []; 0 < c && a2.length; )
      d.push(a2.shift()), c--;
    a2.length && d.push(a2.join(b));
    return d;
  };
  goog.string.lastComponent = function(a2, b) {
    if (b)
      typeof b == "string" && (b = [b]);
    else
      return a2;
    for (var c = -1, d = 0; d < b.length; d++)
      if (b[d] != "") {
        var e = a2.lastIndexOf(b[d]);
        e > c && (c = e);
      }
    return c == -1 ? a2 : a2.slice(c + 1);
  };
  goog.string.editDistance = function(a2, b) {
    var c = [], d = [];
    if (a2 == b)
      return 0;
    if (!a2.length || !b.length)
      return Math.max(a2.length, b.length);
    for (var e = 0; e < b.length + 1; e++)
      c[e] = e;
    for (e = 0; e < a2.length; e++) {
      d[0] = e + 1;
      for (var f = 0; f < b.length; f++)
        d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a2[e] != b[f]));
      for (f = 0; f < c.length; f++)
        c[f] = d[f];
    }
    return d[b.length];
  };
  goog.labs.userAgent.engine = {};
  goog.labs.userAgent.engine.isPresto = function() {
    return goog.labs.userAgent.util.matchUserAgent("Presto");
  };
  goog.labs.userAgent.engine.isTrident = function() {
    return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
  };
  goog.labs.userAgent.engine.isEdge = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edge");
  };
  goog.labs.userAgent.engine.isWebKit = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit") && !goog.labs.userAgent.engine.isEdge();
  };
  goog.labs.userAgent.engine.isGecko = function() {
    return goog.labs.userAgent.util.matchUserAgent("Gecko") && !goog.labs.userAgent.engine.isWebKit() && !goog.labs.userAgent.engine.isTrident() && !goog.labs.userAgent.engine.isEdge();
  };
  goog.labs.userAgent.engine.getVersion = function() {
    var a2 = goog.labs.userAgent.util.getUserAgent();
    if (a2) {
      a2 = goog.labs.userAgent.util.extractVersionTuples(a2);
      var b = goog.labs.userAgent.engine.getEngineTuple_(a2);
      if (b)
        return b[0] == "Gecko" ? goog.labs.userAgent.engine.getVersionForKey_(a2, "Firefox") : b[1];
      a2 = a2[0];
      var c;
      if (a2 && (c = a2[2]) && (c = /Trident\/([^\s;]+)/.exec(c)))
        return c[1];
    }
    return "";
  };
  goog.labs.userAgent.engine.getEngineTuple_ = function(a2) {
    if (!goog.labs.userAgent.engine.isEdge())
      return a2[1];
    for (var b = 0; b < a2.length; b++) {
      var c = a2[b];
      if (c[0] == "Edge")
        return c;
    }
  };
  goog.labs.userAgent.engine.isVersionOrHigher = function(a2) {
    return 0 <= goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(), a2);
  };
  goog.labs.userAgent.engine.getVersionForKey_ = function(a2, b) {
    return (a2 = goog.array.find(a2, function(a3) {
      return b == a3[0];
    })) && a2[1] || "";
  };
  goog.labs.userAgent.platform = {};
  goog.labs.userAgent.platform.isAndroid = function() {
    return goog.labs.userAgent.util.matchUserAgent("Android");
  };
  goog.labs.userAgent.platform.isIpod = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPod");
  };
  goog.labs.userAgent.platform.isIphone = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPhone") && !goog.labs.userAgent.util.matchUserAgent("iPod") && !goog.labs.userAgent.util.matchUserAgent("iPad");
  };
  goog.labs.userAgent.platform.isIpad = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPad");
  };
  goog.labs.userAgent.platform.isIos = function() {
    return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpad() || goog.labs.userAgent.platform.isIpod();
  };
  goog.labs.userAgent.platform.isMacintosh = function() {
    return goog.labs.userAgent.util.matchUserAgent("Macintosh");
  };
  goog.labs.userAgent.platform.isLinux = function() {
    return goog.labs.userAgent.util.matchUserAgent("Linux");
  };
  goog.labs.userAgent.platform.isWindows = function() {
    return goog.labs.userAgent.util.matchUserAgent("Windows");
  };
  goog.labs.userAgent.platform.isChromeOS = function() {
    return goog.labs.userAgent.util.matchUserAgent("CrOS");
  };
  goog.labs.userAgent.platform.isChromecast = function() {
    return goog.labs.userAgent.util.matchUserAgent("CrKey");
  };
  goog.labs.userAgent.platform.isKaiOS = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("KaiOS");
  };
  goog.labs.userAgent.platform.isGo2Phone = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("GAFP");
  };
  goog.labs.userAgent.platform.getVersion = function() {
    var a2 = goog.labs.userAgent.util.getUserAgent(), b = "";
    goog.labs.userAgent.platform.isWindows() ? (b = /Windows (?:NT|Phone) ([0-9.]+)/, b = (a2 = b.exec(a2)) ? a2[1] : "0.0") : goog.labs.userAgent.platform.isIos() ? (b = /(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/, b = (a2 = b.exec(a2)) && a2[1].replace(/_/g, ".")) : goog.labs.userAgent.platform.isMacintosh() ? (b = /Mac OS X ([0-9_.]+)/, b = (a2 = b.exec(a2)) ? a2[1].replace(/_/g, ".") : "10") : goog.labs.userAgent.platform.isKaiOS() ? (b = /(?:KaiOS)\/(\S+)/i, b = (a2 = b.exec(a2)) && a2[1]) : goog.labs.userAgent.platform.isAndroid() ? (b = /Android\s+([^\);]+)(\)|;)/, b = (a2 = b.exec(a2)) && a2[1]) : goog.labs.userAgent.platform.isChromeOS() && (b = /(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/, b = (a2 = b.exec(a2)) && a2[1]);
    return b || "";
  };
  goog.labs.userAgent.platform.isVersionOrHigher = function(a2) {
    return 0 <= goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(), a2);
  };
  goog.reflect = {};
  goog.reflect.object = function(a2, b) {
    return b;
  };
  goog.reflect.objectProperty = function(a2, b) {
    return a2;
  };
  goog.reflect.sinkValue = function(a2) {
    goog.reflect.sinkValue[" "](a2);
    return a2;
  };
  goog.reflect.sinkValue[" "] = goog.nullFunction;
  goog.reflect.canAccessProperty = function(a2, b) {
    try {
      return goog.reflect.sinkValue(a2[b]), true;
    } catch (c) {
    }
    return false;
  };
  goog.reflect.cache = function(a2, b, c, d) {
    d = d ? d(b) : b;
    return Object.prototype.hasOwnProperty.call(a2, d) ? a2[d] : a2[d] = c(b);
  };
  goog.userAgent = {};
  goog.userAgent.ASSUME_IE = false;
  goog.userAgent.ASSUME_EDGE = false;
  goog.userAgent.ASSUME_GECKO = false;
  goog.userAgent.ASSUME_WEBKIT = false;
  goog.userAgent.ASSUME_MOBILE_WEBKIT = false;
  goog.userAgent.ASSUME_OPERA = false;
  goog.userAgent.ASSUME_ANY_VERSION = false;
  goog.userAgent.BROWSER_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_GECKO || goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_OPERA;
  goog.userAgent.getUserAgentString = function() {
    return goog.labs.userAgent.util.getUserAgent();
  };
  goog.userAgent.getNavigatorTyped = function() {
    return goog.global.navigator || null;
  };
  goog.userAgent.getNavigator = function() {
    return goog.userAgent.getNavigatorTyped();
  };
  goog.userAgent.OPERA = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_OPERA : goog.labs.userAgent.browser.isOpera();
  goog.userAgent.IE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_IE : goog.labs.userAgent.browser.isIE();
  goog.userAgent.EDGE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_EDGE : goog.labs.userAgent.engine.isEdge();
  goog.userAgent.EDGE_OR_IE = goog.userAgent.EDGE || goog.userAgent.IE;
  goog.userAgent.GECKO = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_GECKO : goog.labs.userAgent.engine.isGecko();
  goog.userAgent.WEBKIT = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_MOBILE_WEBKIT : goog.labs.userAgent.engine.isWebKit();
  goog.userAgent.isMobile_ = function() {
    return goog.userAgent.WEBKIT && goog.labs.userAgent.util.matchUserAgent("Mobile");
  };
  goog.userAgent.MOBILE = goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.isMobile_();
  goog.userAgent.SAFARI = goog.userAgent.WEBKIT;
  goog.userAgent.determinePlatform_ = function() {
    var a2 = goog.userAgent.getNavigatorTyped();
    return a2 && a2.platform || "";
  };
  goog.userAgent.PLATFORM = goog.userAgent.determinePlatform_();
  goog.userAgent.ASSUME_MAC = false;
  goog.userAgent.ASSUME_WINDOWS = false;
  goog.userAgent.ASSUME_LINUX = false;
  goog.userAgent.ASSUME_X11 = false;
  goog.userAgent.ASSUME_ANDROID = false;
  goog.userAgent.ASSUME_IPHONE = false;
  goog.userAgent.ASSUME_IPAD = false;
  goog.userAgent.ASSUME_IPOD = false;
  goog.userAgent.ASSUME_KAIOS = false;
  goog.userAgent.ASSUME_GO2PHONE = false;
  goog.userAgent.PLATFORM_KNOWN_ = goog.userAgent.ASSUME_MAC || goog.userAgent.ASSUME_WINDOWS || goog.userAgent.ASSUME_LINUX || goog.userAgent.ASSUME_X11 || goog.userAgent.ASSUME_ANDROID || goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD;
  goog.userAgent.MAC = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_MAC : goog.labs.userAgent.platform.isMacintosh();
  goog.userAgent.WINDOWS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_WINDOWS : goog.labs.userAgent.platform.isWindows();
  goog.userAgent.isLegacyLinux_ = function() {
    return goog.labs.userAgent.platform.isLinux() || goog.labs.userAgent.platform.isChromeOS();
  };
  goog.userAgent.LINUX = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_LINUX : goog.userAgent.isLegacyLinux_();
  goog.userAgent.isX11_ = function() {
    var a2 = goog.userAgent.getNavigatorTyped();
    return !!a2 && goog.string.contains(a2.appVersion || "", "X11");
  };
  goog.userAgent.X11 = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_X11 : goog.userAgent.isX11_();
  goog.userAgent.ANDROID = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_ANDROID : goog.labs.userAgent.platform.isAndroid();
  goog.userAgent.IPHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE : goog.labs.userAgent.platform.isIphone();
  goog.userAgent.IPAD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad();
  goog.userAgent.IPOD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIpod();
  goog.userAgent.IOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIos();
  goog.userAgent.KAIOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_KAIOS : goog.labs.userAgent.platform.isKaiOS();
  goog.userAgent.GO2PHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_GO2PHONE : goog.labs.userAgent.platform.isGo2Phone();
  goog.userAgent.determineVersion_ = function() {
    var a2 = "", b = goog.userAgent.getVersionRegexResult_();
    b && (a2 = b ? b[1] : "");
    return goog.userAgent.IE && (b = goog.userAgent.getDocumentMode_(), b != null && b > parseFloat(a2)) ? String(b) : a2;
  };
  goog.userAgent.getVersionRegexResult_ = function() {
    var a2 = goog.userAgent.getUserAgentString();
    if (goog.userAgent.GECKO)
      return /rv:([^\);]+)(\)|;)/.exec(a2);
    if (goog.userAgent.EDGE)
      return /Edge\/([\d\.]+)/.exec(a2);
    if (goog.userAgent.IE)
      return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a2);
    if (goog.userAgent.WEBKIT)
      return /WebKit\/(\S+)/.exec(a2);
    if (goog.userAgent.OPERA)
      return /(?:Version)[ \/]?(\S+)/.exec(a2);
  };
  goog.userAgent.getDocumentMode_ = function() {
    var a2 = goog.global.document;
    return a2 ? a2.documentMode : void 0;
  };
  goog.userAgent.VERSION = goog.userAgent.determineVersion_();
  goog.userAgent.compare = function(a2, b) {
    return goog.string.compareVersions(a2, b);
  };
  goog.userAgent.isVersionOrHigherCache_ = {};
  goog.userAgent.isVersionOrHigher = function(a2) {
    return goog.userAgent.ASSUME_ANY_VERSION || goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_, a2, function() {
      return 0 <= goog.string.compareVersions(goog.userAgent.VERSION, a2);
    });
  };
  goog.userAgent.isVersion = goog.userAgent.isVersionOrHigher;
  goog.userAgent.isDocumentModeOrHigher = function(a2) {
    return Number(goog.userAgent.DOCUMENT_MODE) >= a2;
  };
  goog.userAgent.isDocumentMode = goog.userAgent.isDocumentModeOrHigher;
  goog.userAgent.DOCUMENT_MODE = function() {
    if (goog.global.document && goog.userAgent.IE)
      return goog.userAgent.getDocumentMode_();
  }();
  goog.userAgent.product = {};
  goog.userAgent.product.ASSUME_FIREFOX = false;
  goog.userAgent.product.ASSUME_IPHONE = false;
  goog.userAgent.product.ASSUME_IPAD = false;
  goog.userAgent.product.ASSUME_ANDROID = false;
  goog.userAgent.product.ASSUME_CHROME = false;
  goog.userAgent.product.ASSUME_SAFARI = false;
  goog.userAgent.product.PRODUCT_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_OPERA || goog.userAgent.product.ASSUME_FIREFOX || goog.userAgent.product.ASSUME_IPHONE || goog.userAgent.product.ASSUME_IPAD || goog.userAgent.product.ASSUME_ANDROID || goog.userAgent.product.ASSUME_CHROME || goog.userAgent.product.ASSUME_SAFARI;
  goog.userAgent.product.OPERA = goog.userAgent.OPERA;
  goog.userAgent.product.IE = goog.userAgent.IE;
  goog.userAgent.product.EDGE = goog.userAgent.EDGE;
  goog.userAgent.product.FIREFOX = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_FIREFOX : goog.labs.userAgent.browser.isFirefox();
  goog.userAgent.product.isIphoneOrIpod_ = function() {
    return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpod();
  };
  goog.userAgent.product.IPHONE = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPHONE : goog.userAgent.product.isIphoneOrIpod_();
  goog.userAgent.product.IPAD = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad();
  goog.userAgent.product.ANDROID = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_ANDROID : goog.labs.userAgent.browser.isAndroidBrowser();
  goog.userAgent.product.CHROME = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_CHROME : goog.labs.userAgent.browser.isChrome();
  goog.userAgent.product.isSafariDesktop_ = function() {
    return goog.labs.userAgent.browser.isSafari() && !goog.labs.userAgent.platform.isIos();
  };
  goog.userAgent.product.SAFARI = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_SAFARI : goog.userAgent.product.isSafariDesktop_();
  goog.crypt.base64 = {};
  goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  goog.crypt.base64.ENCODED_VALS = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "+/=";
  goog.crypt.base64.ENCODED_VALS_WEBSAFE = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "-_.";
  goog.crypt.base64.Alphabet = { DEFAULT: 0, NO_PADDING: 1, WEBSAFE: 2, WEBSAFE_DOT_PADDING: 3, WEBSAFE_NO_PADDING: 4 };
  goog.crypt.base64.paddingChars_ = "=.";
  goog.crypt.base64.isPadding_ = function(a2) {
    return goog.string.contains(goog.crypt.base64.paddingChars_, a2);
  };
  goog.crypt.base64.byteToCharMaps_ = {};
  goog.crypt.base64.charToByteMap_ = null;
  goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ = goog.userAgent.GECKO || goog.userAgent.WEBKIT && !goog.userAgent.product.SAFARI || goog.userAgent.OPERA;
  goog.crypt.base64.HAS_NATIVE_ENCODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || typeof goog.global.btoa == "function";
  goog.crypt.base64.HAS_NATIVE_DECODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || !goog.userAgent.product.SAFARI && !goog.userAgent.IE && typeof goog.global.atob == "function";
  goog.crypt.base64.encodeByteArray = function(a2, b) {
    goog.asserts.assert(goog.isArrayLike(a2), "encodeByteArray takes an array as a parameter");
    b === void 0 && (b = goog.crypt.base64.Alphabet.DEFAULT);
    goog.crypt.base64.init_();
    b = goog.crypt.base64.byteToCharMaps_[b];
    for (var c = [], d = 0; d < a2.length; d += 3) {
      var e = a2[d], f = d + 1 < a2.length, g = f ? a2[d + 1] : 0, h = d + 2 < a2.length, k = h ? a2[d + 2] : 0, l = e >> 2;
      e = (e & 3) << 4 | g >> 4;
      g = (g & 15) << 2 | k >> 6;
      k &= 63;
      h || (k = 64, f || (g = 64));
      c.push(b[l], b[e], b[g] || "", b[k] || "");
    }
    return c.join("");
  };
  goog.crypt.base64.encodeString = function(a2, b) {
    return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !b ? goog.global.btoa(a2) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(a2), b);
  };
  goog.crypt.base64.decodeString = function(a2, b) {
    if (goog.crypt.base64.HAS_NATIVE_DECODE_ && !b)
      return goog.global.atob(a2);
    var c = "";
    goog.crypt.base64.decodeStringInternal_(a2, function(a3) {
      c += String.fromCharCode(a3);
    });
    return c;
  };
  goog.crypt.base64.decodeStringToByteArray = function(a2, b) {
    var c = [];
    goog.crypt.base64.decodeStringInternal_(a2, function(a3) {
      c.push(a3);
    });
    return c;
  };
  goog.crypt.base64.decodeStringToUint8Array = function(a2) {
    goog.asserts.assert(!goog.userAgent.IE || goog.userAgent.isVersionOrHigher("10"), "Browser does not support typed arrays");
    var b = a2.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : goog.crypt.base64.isPadding_(a2[b - 1]) && (c = goog.crypt.base64.isPadding_(a2[b - 2]) ? c - 2 : c - 1);
    var d = new Uint8Array(c), e = 0;
    goog.crypt.base64.decodeStringInternal_(a2, function(a3) {
      d[e++] = a3;
    });
    return d.subarray(0, e);
  };
  goog.crypt.base64.decodeStringInternal_ = function(a2, b) {
    function c(b2) {
      for (; d < a2.length; ) {
        var c2 = a2.charAt(d++), e2 = goog.crypt.base64.charToByteMap_[c2];
        if (e2 != null)
          return e2;
        if (!goog.string.isEmptyOrWhitespace(c2))
          throw Error("Unknown base64 encoding at char: " + c2);
      }
      return b2;
    }
    goog.crypt.base64.init_();
    for (var d = 0; ; ) {
      var e = c(-1), f = c(0), g = c(64), h = c(64);
      if (h === 64 && e === -1)
        break;
      b(e << 2 | f >> 4);
      g != 64 && (b(f << 4 & 240 | g >> 2), h != 64 && b(g << 6 & 192 | h));
    }
  };
  goog.crypt.base64.init_ = function() {
    if (!goog.crypt.base64.charToByteMap_) {
      goog.crypt.base64.charToByteMap_ = {};
      for (var a2 = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""), b = ["+/=", "+/", "-_=", "-_.", "-_"], c = 0; 5 > c; c++) {
        var d = a2.concat(b[c].split(""));
        goog.crypt.base64.byteToCharMaps_[c] = d;
        for (var e = 0; e < d.length; e++) {
          var f = d[e], g = goog.crypt.base64.charToByteMap_[f];
          g === void 0 ? goog.crypt.base64.charToByteMap_[f] = e : goog.asserts.assert(g === e);
        }
      }
    }
  };
  jspb.utils = {};
  jspb.utils.split64Low = 0;
  jspb.utils.split64High = 0;
  jspb.utils.splitUint64 = function(a2) {
    var b = a2 >>> 0;
    a2 = Math.floor((a2 - b) / jspb.BinaryConstants.TWO_TO_32) >>> 0;
    jspb.utils.split64Low = b;
    jspb.utils.split64High = a2;
  };
  jspb.utils.splitInt64 = function(a2) {
    var b = 0 > a2;
    a2 = Math.abs(a2);
    var c = a2 >>> 0;
    a2 = Math.floor((a2 - c) / jspb.BinaryConstants.TWO_TO_32);
    a2 >>>= 0;
    b && (a2 = ~a2 >>> 0, c = (~c >>> 0) + 1, 4294967295 < c && (c = 0, a2++, 4294967295 < a2 && (a2 = 0)));
    jspb.utils.split64Low = c;
    jspb.utils.split64High = a2;
  };
  jspb.utils.splitZigzag64 = function(a2) {
    var b = 0 > a2;
    a2 = 2 * Math.abs(a2);
    jspb.utils.splitUint64(a2);
    a2 = jspb.utils.split64Low;
    var c = jspb.utils.split64High;
    b && (a2 == 0 ? c == 0 ? c = a2 = 4294967295 : (c--, a2 = 4294967295) : a2--);
    jspb.utils.split64Low = a2;
    jspb.utils.split64High = c;
  };
  jspb.utils.splitFloat32 = function(a2) {
    var b = 0 > a2 ? 1 : 0;
    a2 = b ? -a2 : a2;
    if (a2 === 0)
      0 < 1 / a2 ? (jspb.utils.split64High = 0, jspb.utils.split64Low = 0) : (jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483648);
    else if (isNaN(a2))
      jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483647;
    else if (a2 > jspb.BinaryConstants.FLOAT32_MAX)
      jspb.utils.split64High = 0, jspb.utils.split64Low = (b << 31 | 2139095040) >>> 0;
    else if (a2 < jspb.BinaryConstants.FLOAT32_MIN)
      a2 = Math.round(a2 / Math.pow(2, -149)), jspb.utils.split64High = 0, jspb.utils.split64Low = (b << 31 | a2) >>> 0;
    else {
      var c = Math.floor(Math.log(a2) / Math.LN2);
      a2 *= Math.pow(2, -c);
      a2 = Math.round(a2 * jspb.BinaryConstants.TWO_TO_23);
      16777216 <= a2 && ++c;
      jspb.utils.split64High = 0;
      jspb.utils.split64Low = (b << 31 | c + 127 << 23 | a2 & 8388607) >>> 0;
    }
  };
  jspb.utils.splitFloat64 = function(a2) {
    var b = 0 > a2 ? 1 : 0;
    a2 = b ? -a2 : a2;
    if (a2 === 0)
      jspb.utils.split64High = 0 < 1 / a2 ? 0 : 2147483648, jspb.utils.split64Low = 0;
    else if (isNaN(a2))
      jspb.utils.split64High = 2147483647, jspb.utils.split64Low = 4294967295;
    else if (a2 > jspb.BinaryConstants.FLOAT64_MAX)
      jspb.utils.split64High = (b << 31 | 2146435072) >>> 0, jspb.utils.split64Low = 0;
    else if (a2 < jspb.BinaryConstants.FLOAT64_MIN) {
      var c = a2 / Math.pow(2, -1074);
      a2 = c / jspb.BinaryConstants.TWO_TO_32;
      jspb.utils.split64High = (b << 31 | a2) >>> 0;
      jspb.utils.split64Low = c >>> 0;
    } else {
      c = a2;
      var d = 0;
      if (2 <= c)
        for (; 2 <= c && 1023 > d; )
          d++, c /= 2;
      else
        for (; 1 > c && -1022 < d; )
          c *= 2, d--;
      c = a2 * Math.pow(2, -d);
      a2 = c * jspb.BinaryConstants.TWO_TO_20 & 1048575;
      c = c * jspb.BinaryConstants.TWO_TO_52 >>> 0;
      jspb.utils.split64High = (b << 31 | d + 1023 << 20 | a2) >>> 0;
      jspb.utils.split64Low = c;
    }
  };
  jspb.utils.splitHash64 = function(a2) {
    var b = a2.charCodeAt(0), c = a2.charCodeAt(1), d = a2.charCodeAt(2), e = a2.charCodeAt(3), f = a2.charCodeAt(4), g = a2.charCodeAt(5), h = a2.charCodeAt(6);
    a2 = a2.charCodeAt(7);
    jspb.utils.split64Low = b + (c << 8) + (d << 16) + (e << 24) >>> 0;
    jspb.utils.split64High = f + (g << 8) + (h << 16) + (a2 << 24) >>> 0;
  };
  jspb.utils.joinUint64 = function(a2, b) {
    return b * jspb.BinaryConstants.TWO_TO_32 + (a2 >>> 0);
  };
  jspb.utils.joinInt64 = function(a2, b) {
    var c = b & 2147483648;
    c && (a2 = ~a2 + 1 >>> 0, b = ~b >>> 0, a2 == 0 && (b = b + 1 >>> 0));
    a2 = jspb.utils.joinUint64(a2, b);
    return c ? -a2 : a2;
  };
  jspb.utils.toZigzag64 = function(a2, b, c) {
    var d = b >> 31;
    return c(a2 << 1 ^ d, (b << 1 | a2 >>> 31) ^ d);
  };
  jspb.utils.joinZigzag64 = function(a2, b) {
    return jspb.utils.fromZigzag64(a2, b, jspb.utils.joinInt64);
  };
  jspb.utils.fromZigzag64 = function(a2, b, c) {
    var d = -(a2 & 1);
    return c((a2 >>> 1 | b << 31) ^ d, b >>> 1 ^ d);
  };
  jspb.utils.joinFloat32 = function(a2, b) {
    b = 2 * (a2 >> 31) + 1;
    var c = a2 >>> 23 & 255;
    a2 &= 8388607;
    return c == 255 ? a2 ? NaN : Infinity * b : c == 0 ? b * Math.pow(2, -149) * a2 : b * Math.pow(2, c - 150) * (a2 + Math.pow(2, 23));
  };
  jspb.utils.joinFloat64 = function(a2, b) {
    var c = 2 * (b >> 31) + 1, d = b >>> 20 & 2047;
    a2 = jspb.BinaryConstants.TWO_TO_32 * (b & 1048575) + a2;
    return d == 2047 ? a2 ? NaN : Infinity * c : d == 0 ? c * Math.pow(2, -1074) * a2 : c * Math.pow(2, d - 1075) * (a2 + jspb.BinaryConstants.TWO_TO_52);
  };
  jspb.utils.joinHash64 = function(a2, b) {
    return String.fromCharCode(a2 >>> 0 & 255, a2 >>> 8 & 255, a2 >>> 16 & 255, a2 >>> 24 & 255, b >>> 0 & 255, b >>> 8 & 255, b >>> 16 & 255, b >>> 24 & 255);
  };
  jspb.utils.DIGITS = "0123456789abcdef".split("");
  jspb.utils.ZERO_CHAR_CODE_ = 48;
  jspb.utils.A_CHAR_CODE_ = 97;
  jspb.utils.joinUnsignedDecimalString = function(a2, b) {
    function c(a3, b2) {
      a3 = a3 ? String(a3) : "";
      return b2 ? "0000000".slice(a3.length) + a3 : a3;
    }
    if (2097151 >= b)
      return "" + jspb.utils.joinUint64(a2, b);
    var d = (a2 >>> 24 | b << 8) >>> 0 & 16777215;
    b = b >> 16 & 65535;
    a2 = (a2 & 16777215) + 6777216 * d + 6710656 * b;
    d += 8147497 * b;
    b *= 2;
    1e7 <= a2 && (d += Math.floor(a2 / 1e7), a2 %= 1e7);
    1e7 <= d && (b += Math.floor(d / 1e7), d %= 1e7);
    return c(b, 0) + c(d, b) + c(a2, 1);
  };
  jspb.utils.joinSignedDecimalString = function(a2, b) {
    var c = b & 2147483648;
    c && (a2 = ~a2 + 1 >>> 0, b = ~b + (a2 == 0 ? 1 : 0) >>> 0);
    a2 = jspb.utils.joinUnsignedDecimalString(a2, b);
    return c ? "-" + a2 : a2;
  };
  jspb.utils.hash64ToDecimalString = function(a2, b) {
    jspb.utils.splitHash64(a2);
    a2 = jspb.utils.split64Low;
    var c = jspb.utils.split64High;
    return b ? jspb.utils.joinSignedDecimalString(a2, c) : jspb.utils.joinUnsignedDecimalString(a2, c);
  };
  jspb.utils.hash64ArrayToDecimalStrings = function(a2, b) {
    for (var c = Array(a2.length), d = 0; d < a2.length; d++)
      c[d] = jspb.utils.hash64ToDecimalString(a2[d], b);
    return c;
  };
  jspb.utils.decimalStringToHash64 = function(a2) {
    function b(a3, b2) {
      for (var c2 = 0; 8 > c2 && (a3 !== 1 || 0 < b2); c2++)
        b2 = a3 * e[c2] + b2, e[c2] = b2 & 255, b2 >>>= 8;
    }
    function c() {
      for (var a3 = 0; 8 > a3; a3++)
        e[a3] = ~e[a3] & 255;
    }
    goog.asserts.assert(0 < a2.length);
    var d = false;
    a2[0] === "-" && (d = true, a2 = a2.slice(1));
    for (var e = [0, 0, 0, 0, 0, 0, 0, 0], f = 0; f < a2.length; f++)
      b(10, a2.charCodeAt(f) - jspb.utils.ZERO_CHAR_CODE_);
    d && (c(), b(1, 1));
    return goog.crypt.byteArrayToString(e);
  };
  jspb.utils.splitDecimalString = function(a2) {
    jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a2));
  };
  jspb.utils.toHexDigit_ = function(a2) {
    return String.fromCharCode(10 > a2 ? jspb.utils.ZERO_CHAR_CODE_ + a2 : jspb.utils.A_CHAR_CODE_ - 10 + a2);
  };
  jspb.utils.fromHexCharCode_ = function(a2) {
    return a2 >= jspb.utils.A_CHAR_CODE_ ? a2 - jspb.utils.A_CHAR_CODE_ + 10 : a2 - jspb.utils.ZERO_CHAR_CODE_;
  };
  jspb.utils.hash64ToHexString = function(a2) {
    var b = Array(18);
    b[0] = "0";
    b[1] = "x";
    for (var c = 0; 8 > c; c++) {
      var d = a2.charCodeAt(7 - c);
      b[2 * c + 2] = jspb.utils.toHexDigit_(d >> 4);
      b[2 * c + 3] = jspb.utils.toHexDigit_(d & 15);
    }
    return b.join("");
  };
  jspb.utils.hexStringToHash64 = function(a2) {
    a2 = a2.toLowerCase();
    goog.asserts.assert(a2.length == 18);
    goog.asserts.assert(a2[0] == "0");
    goog.asserts.assert(a2[1] == "x");
    for (var b = "", c = 0; 8 > c; c++) {
      var d = jspb.utils.fromHexCharCode_(a2.charCodeAt(2 * c + 2)), e = jspb.utils.fromHexCharCode_(a2.charCodeAt(2 * c + 3));
      b = String.fromCharCode(16 * d + e) + b;
    }
    return b;
  };
  jspb.utils.hash64ToNumber = function(a2, b) {
    jspb.utils.splitHash64(a2);
    a2 = jspb.utils.split64Low;
    var c = jspb.utils.split64High;
    return b ? jspb.utils.joinInt64(a2, c) : jspb.utils.joinUint64(a2, c);
  };
  jspb.utils.numberToHash64 = function(a2) {
    jspb.utils.splitInt64(a2);
    return jspb.utils.joinHash64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.utils.countVarints = function(a2, b, c) {
    for (var d = 0, e = b; e < c; e++)
      d += a2[e] >> 7;
    return c - b - d;
  };
  jspb.utils.countVarintFields = function(a2, b, c, d) {
    var e = 0;
    d = 8 * d + jspb.BinaryConstants.WireType.VARINT;
    if (128 > d)
      for (; b < c && a2[b++] == d; )
        for (e++; ; ) {
          var f = a2[b++];
          if ((f & 128) == 0)
            break;
        }
    else
      for (; b < c; ) {
        for (f = d; 128 < f; ) {
          if (a2[b] != (f & 127 | 128))
            return e;
          b++;
          f >>= 7;
        }
        if (a2[b++] != f)
          break;
        for (e++; f = a2[b++], (f & 128) != 0; )
          ;
      }
    return e;
  };
  jspb.utils.countFixedFields_ = function(a2, b, c, d, e) {
    var f = 0;
    if (128 > d)
      for (; b < c && a2[b++] == d; )
        f++, b += e;
    else
      for (; b < c; ) {
        for (var g = d; 128 < g; ) {
          if (a2[b++] != (g & 127 | 128))
            return f;
          g >>= 7;
        }
        if (a2[b++] != g)
          break;
        f++;
        b += e;
      }
    return f;
  };
  jspb.utils.countFixed32Fields = function(a2, b, c, d) {
    return jspb.utils.countFixedFields_(a2, b, c, 8 * d + jspb.BinaryConstants.WireType.FIXED32, 4);
  };
  jspb.utils.countFixed64Fields = function(a2, b, c, d) {
    return jspb.utils.countFixedFields_(a2, b, c, 8 * d + jspb.BinaryConstants.WireType.FIXED64, 8);
  };
  jspb.utils.countDelimitedFields = function(a2, b, c, d) {
    var e = 0;
    for (d = 8 * d + jspb.BinaryConstants.WireType.DELIMITED; b < c; ) {
      for (var f = d; 128 < f; ) {
        if (a2[b++] != (f & 127 | 128))
          return e;
        f >>= 7;
      }
      if (a2[b++] != f)
        break;
      e++;
      for (var g = 0, h = 1; f = a2[b++], g += (f & 127) * h, h *= 128, (f & 128) != 0; )
        ;
      b += g;
    }
    return e;
  };
  jspb.utils.debugBytesToTextFormat = function(a2) {
    var b = '"';
    if (a2) {
      a2 = jspb.utils.byteSourceToUint8Array(a2);
      for (var c = 0; c < a2.length; c++)
        b += "\\x", 16 > a2[c] && (b += "0"), b += a2[c].toString(16);
    }
    return b + '"';
  };
  jspb.utils.debugScalarToTextFormat = function(a2) {
    return typeof a2 === "string" ? goog.string.quote(a2) : a2.toString();
  };
  jspb.utils.stringToByteArray = function(a2) {
    for (var b = new Uint8Array(a2.length), c = 0; c < a2.length; c++) {
      var d = a2.charCodeAt(c);
      if (255 < d)
        throw Error("Conversion error: string contains codepoint outside of byte range");
      b[c] = d;
    }
    return b;
  };
  jspb.utils.byteSourceToUint8Array = function(a2) {
    if (a2.constructor === Uint8Array)
      return a2;
    if (a2.constructor === ArrayBuffer || typeof Buffer != "undefined" && a2.constructor === Buffer || a2.constructor === Array)
      return new Uint8Array(a2);
    if (a2.constructor === String)
      return goog.crypt.base64.decodeStringToUint8Array(a2);
    goog.asserts.fail("Type not convertible to Uint8Array.");
    return new Uint8Array(0);
  };
  jspb.BinaryDecoder = function(a2, b, c) {
    this.bytes_ = null;
    this.cursor_ = this.end_ = this.start_ = 0;
    this.error_ = false;
    a2 && this.setBlock(a2, b, c);
  };
  jspb.BinaryDecoder.instanceCache_ = [];
  jspb.BinaryDecoder.alloc = function(a2, b, c) {
    if (jspb.BinaryDecoder.instanceCache_.length) {
      var d = jspb.BinaryDecoder.instanceCache_.pop();
      a2 && d.setBlock(a2, b, c);
      return d;
    }
    return new jspb.BinaryDecoder(a2, b, c);
  };
  jspb.BinaryDecoder.prototype.free = function() {
    this.clear();
    100 > jspb.BinaryDecoder.instanceCache_.length && jspb.BinaryDecoder.instanceCache_.push(this);
  };
  jspb.BinaryDecoder.prototype.clone = function() {
    return jspb.BinaryDecoder.alloc(this.bytes_, this.start_, this.end_ - this.start_);
  };
  jspb.BinaryDecoder.prototype.clear = function() {
    this.bytes_ = null;
    this.cursor_ = this.end_ = this.start_ = 0;
    this.error_ = false;
  };
  jspb.BinaryDecoder.prototype.getBuffer = function() {
    return this.bytes_;
  };
  jspb.BinaryDecoder.prototype.setBlock = function(a2, b, c) {
    this.bytes_ = jspb.utils.byteSourceToUint8Array(a2);
    this.start_ = b !== void 0 ? b : 0;
    this.end_ = c !== void 0 ? this.start_ + c : this.bytes_.length;
    this.cursor_ = this.start_;
  };
  jspb.BinaryDecoder.prototype.getEnd = function() {
    return this.end_;
  };
  jspb.BinaryDecoder.prototype.setEnd = function(a2) {
    this.end_ = a2;
  };
  jspb.BinaryDecoder.prototype.reset = function() {
    this.cursor_ = this.start_;
  };
  jspb.BinaryDecoder.prototype.getCursor = function() {
    return this.cursor_;
  };
  jspb.BinaryDecoder.prototype.setCursor = function(a2) {
    this.cursor_ = a2;
  };
  jspb.BinaryDecoder.prototype.advance = function(a2) {
    this.cursor_ += a2;
    goog.asserts.assert(this.cursor_ <= this.end_);
  };
  jspb.BinaryDecoder.prototype.atEnd = function() {
    return this.cursor_ == this.end_;
  };
  jspb.BinaryDecoder.prototype.pastEnd = function() {
    return this.cursor_ > this.end_;
  };
  jspb.BinaryDecoder.prototype.getError = function() {
    return this.error_ || 0 > this.cursor_ || this.cursor_ > this.end_;
  };
  jspb.BinaryDecoder.prototype.readSplitVarint64 = function(a2) {
    for (var b = 128, c = 0, d = 0, e = 0; 4 > e && 128 <= b; e++)
      b = this.bytes_[this.cursor_++], c |= (b & 127) << 7 * e;
    128 <= b && (b = this.bytes_[this.cursor_++], c |= (b & 127) << 28, d |= (b & 127) >> 4);
    if (128 <= b)
      for (e = 0; 5 > e && 128 <= b; e++)
        b = this.bytes_[this.cursor_++], d |= (b & 127) << 7 * e + 3;
    if (128 > b)
      return a2(c >>> 0, d >>> 0);
    goog.asserts.fail("Failed to read varint, encoding is invalid.");
    this.error_ = true;
  };
  jspb.BinaryDecoder.prototype.readSplitZigzagVarint64 = function(a2) {
    return this.readSplitVarint64(function(b, c) {
      return jspb.utils.fromZigzag64(b, c, a2);
    });
  };
  jspb.BinaryDecoder.prototype.readSplitFixed64 = function(a2) {
    var b = this.bytes_, c = this.cursor_;
    this.cursor_ += 8;
    for (var d = 0, e = 0, f = c + 7; f >= c; f--)
      d = d << 8 | b[f], e = e << 8 | b[f + 4];
    return a2(d, e);
  };
  jspb.BinaryDecoder.prototype.skipVarint = function() {
    for (; this.bytes_[this.cursor_] & 128; )
      this.cursor_++;
    this.cursor_++;
  };
  jspb.BinaryDecoder.prototype.unskipVarint = function(a2) {
    for (; 128 < a2; )
      this.cursor_--, a2 >>>= 7;
    this.cursor_--;
  };
  jspb.BinaryDecoder.prototype.readUnsignedVarint32 = function() {
    var a2 = this.bytes_;
    var b = a2[this.cursor_ + 0];
    var c = b & 127;
    if (128 > b)
      return this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a2[this.cursor_ + 1];
    c |= (b & 127) << 7;
    if (128 > b)
      return this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a2[this.cursor_ + 2];
    c |= (b & 127) << 14;
    if (128 > b)
      return this.cursor_ += 3, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a2[this.cursor_ + 3];
    c |= (b & 127) << 21;
    if (128 > b)
      return this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a2[this.cursor_ + 4];
    c |= (b & 15) << 28;
    if (128 > b)
      return this.cursor_ += 5, goog.asserts.assert(this.cursor_ <= this.end_), c >>> 0;
    this.cursor_ += 5;
    128 <= a2[this.cursor_++] && 128 <= a2[this.cursor_++] && 128 <= a2[this.cursor_++] && 128 <= a2[this.cursor_++] && 128 <= a2[this.cursor_++] && goog.asserts.assert(false);
    goog.asserts.assert(this.cursor_ <= this.end_);
    return c;
  };
  jspb.BinaryDecoder.prototype.readSignedVarint32 = jspb.BinaryDecoder.prototype.readUnsignedVarint32;
  jspb.BinaryDecoder.prototype.readUnsignedVarint32String = function() {
    return this.readUnsignedVarint32().toString();
  };
  jspb.BinaryDecoder.prototype.readSignedVarint32String = function() {
    return this.readSignedVarint32().toString();
  };
  jspb.BinaryDecoder.prototype.readZigzagVarint32 = function() {
    var a2 = this.readUnsignedVarint32();
    return a2 >>> 1 ^ -(a2 & 1);
  };
  jspb.BinaryDecoder.prototype.readUnsignedVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinUint64);
  };
  jspb.BinaryDecoder.prototype.readUnsignedVarint64String = function() {
    return this.readSplitVarint64(jspb.utils.joinUnsignedDecimalString);
  };
  jspb.BinaryDecoder.prototype.readSignedVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinInt64);
  };
  jspb.BinaryDecoder.prototype.readSignedVarint64String = function() {
    return this.readSplitVarint64(jspb.utils.joinSignedDecimalString);
  };
  jspb.BinaryDecoder.prototype.readZigzagVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinZigzag64);
  };
  jspb.BinaryDecoder.prototype.readZigzagVarintHash64 = function() {
    return this.readSplitZigzagVarint64(jspb.utils.joinHash64);
  };
  jspb.BinaryDecoder.prototype.readZigzagVarint64String = function() {
    return this.readSplitZigzagVarint64(jspb.utils.joinSignedDecimalString);
  };
  jspb.BinaryDecoder.prototype.readUint8 = function() {
    var a2 = this.bytes_[this.cursor_ + 0];
    this.cursor_ += 1;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a2;
  };
  jspb.BinaryDecoder.prototype.readUint16 = function() {
    var a2 = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1];
    this.cursor_ += 2;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a2 << 0 | b << 8;
  };
  jspb.BinaryDecoder.prototype.readUint32 = function() {
    var a2 = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1], c = this.bytes_[this.cursor_ + 2], d = this.bytes_[this.cursor_ + 3];
    this.cursor_ += 4;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return (a2 << 0 | b << 8 | c << 16 | d << 24) >>> 0;
  };
  jspb.BinaryDecoder.prototype.readUint64 = function() {
    var a2 = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinUint64(a2, b);
  };
  jspb.BinaryDecoder.prototype.readUint64String = function() {
    var a2 = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinUnsignedDecimalString(a2, b);
  };
  jspb.BinaryDecoder.prototype.readInt8 = function() {
    var a2 = this.bytes_[this.cursor_ + 0];
    this.cursor_ += 1;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a2 << 24 >> 24;
  };
  jspb.BinaryDecoder.prototype.readInt16 = function() {
    var a2 = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1];
    this.cursor_ += 2;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return (a2 << 0 | b << 8) << 16 >> 16;
  };
  jspb.BinaryDecoder.prototype.readInt32 = function() {
    var a2 = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1], c = this.bytes_[this.cursor_ + 2], d = this.bytes_[this.cursor_ + 3];
    this.cursor_ += 4;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a2 << 0 | b << 8 | c << 16 | d << 24;
  };
  jspb.BinaryDecoder.prototype.readInt64 = function() {
    var a2 = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinInt64(a2, b);
  };
  jspb.BinaryDecoder.prototype.readInt64String = function() {
    var a2 = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinSignedDecimalString(a2, b);
  };
  jspb.BinaryDecoder.prototype.readFloat = function() {
    var a2 = this.readUint32();
    return jspb.utils.joinFloat32(a2, 0);
  };
  jspb.BinaryDecoder.prototype.readDouble = function() {
    var a2 = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinFloat64(a2, b);
  };
  jspb.BinaryDecoder.prototype.readBool = function() {
    return !!this.bytes_[this.cursor_++];
  };
  jspb.BinaryDecoder.prototype.readEnum = function() {
    return this.readSignedVarint32();
  };
  jspb.BinaryDecoder.prototype.readString = function(a2) {
    var b = this.bytes_, c = this.cursor_;
    a2 = c + a2;
    for (var d = [], e = ""; c < a2; ) {
      var f = b[c++];
      if (128 > f)
        d.push(f);
      else if (192 > f)
        continue;
      else if (224 > f) {
        var g = b[c++];
        d.push((f & 31) << 6 | g & 63);
      } else if (240 > f) {
        g = b[c++];
        var h = b[c++];
        d.push((f & 15) << 12 | (g & 63) << 6 | h & 63);
      } else if (248 > f) {
        g = b[c++];
        h = b[c++];
        var k = b[c++];
        f = (f & 7) << 18 | (g & 63) << 12 | (h & 63) << 6 | k & 63;
        f -= 65536;
        d.push((f >> 10 & 1023) + 55296, (f & 1023) + 56320);
      }
      8192 <= d.length && (e += String.fromCharCode.apply(null, d), d.length = 0);
    }
    e += goog.crypt.byteArrayToString(d);
    this.cursor_ = c;
    return e;
  };
  jspb.BinaryDecoder.prototype.readStringWithLength = function() {
    var a2 = this.readUnsignedVarint32();
    return this.readString(a2);
  };
  jspb.BinaryDecoder.prototype.readBytes = function(a2) {
    if (0 > a2 || this.cursor_ + a2 > this.bytes_.length)
      return this.error_ = true, goog.asserts.fail("Invalid byte length!"), new Uint8Array(0);
    var b = this.bytes_.subarray(this.cursor_, this.cursor_ + a2);
    this.cursor_ += a2;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return b;
  };
  jspb.BinaryDecoder.prototype.readVarintHash64 = function() {
    return this.readSplitVarint64(jspb.utils.joinHash64);
  };
  jspb.BinaryDecoder.prototype.readFixedHash64 = function() {
    var a2 = this.bytes_, b = this.cursor_, c = a2[b + 0], d = a2[b + 1], e = a2[b + 2], f = a2[b + 3], g = a2[b + 4], h = a2[b + 5], k = a2[b + 6];
    a2 = a2[b + 7];
    this.cursor_ += 8;
    return String.fromCharCode(c, d, e, f, g, h, k, a2);
  };
  jspb.BinaryReader = function(a2, b, c) {
    this.decoder_ = jspb.BinaryDecoder.alloc(a2, b, c);
    this.fieldCursor_ = this.decoder_.getCursor();
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
    this.error_ = false;
    this.readCallbacks_ = null;
  };
  jspb.BinaryReader.instanceCache_ = [];
  jspb.BinaryReader.alloc = function(a2, b, c) {
    if (jspb.BinaryReader.instanceCache_.length) {
      var d = jspb.BinaryReader.instanceCache_.pop();
      a2 && d.decoder_.setBlock(a2, b, c);
      return d;
    }
    return new jspb.BinaryReader(a2, b, c);
  };
  jspb.BinaryReader.prototype.alloc = jspb.BinaryReader.alloc;
  jspb.BinaryReader.prototype.free = function() {
    this.decoder_.clear();
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
    this.error_ = false;
    this.readCallbacks_ = null;
    100 > jspb.BinaryReader.instanceCache_.length && jspb.BinaryReader.instanceCache_.push(this);
  };
  jspb.BinaryReader.prototype.getFieldCursor = function() {
    return this.fieldCursor_;
  };
  jspb.BinaryReader.prototype.getCursor = function() {
    return this.decoder_.getCursor();
  };
  jspb.BinaryReader.prototype.getBuffer = function() {
    return this.decoder_.getBuffer();
  };
  jspb.BinaryReader.prototype.getFieldNumber = function() {
    return this.nextField_;
  };
  jspb.BinaryReader.prototype.getWireType = function() {
    return this.nextWireType_;
  };
  jspb.BinaryReader.prototype.isDelimited = function() {
    return this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED;
  };
  jspb.BinaryReader.prototype.isEndGroup = function() {
    return this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP;
  };
  jspb.BinaryReader.prototype.getError = function() {
    return this.error_ || this.decoder_.getError();
  };
  jspb.BinaryReader.prototype.setBlock = function(a2, b, c) {
    this.decoder_.setBlock(a2, b, c);
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
  };
  jspb.BinaryReader.prototype.reset = function() {
    this.decoder_.reset();
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
  };
  jspb.BinaryReader.prototype.advance = function(a2) {
    this.decoder_.advance(a2);
  };
  jspb.BinaryReader.prototype.nextField = function() {
    if (this.decoder_.atEnd())
      return false;
    if (this.getError())
      return goog.asserts.fail("Decoder hit an error"), false;
    this.fieldCursor_ = this.decoder_.getCursor();
    var a2 = this.decoder_.readUnsignedVarint32(), b = a2 >>> 3;
    a2 &= 7;
    if (a2 != jspb.BinaryConstants.WireType.VARINT && a2 != jspb.BinaryConstants.WireType.FIXED32 && a2 != jspb.BinaryConstants.WireType.FIXED64 && a2 != jspb.BinaryConstants.WireType.DELIMITED && a2 != jspb.BinaryConstants.WireType.START_GROUP && a2 != jspb.BinaryConstants.WireType.END_GROUP)
      return goog.asserts.fail("Invalid wire type: %s (at position %s)", a2, this.fieldCursor_), this.error_ = true, false;
    this.nextField_ = b;
    this.nextWireType_ = a2;
    return true;
  };
  jspb.BinaryReader.prototype.unskipHeader = function() {
    this.decoder_.unskipVarint(this.nextField_ << 3 | this.nextWireType_);
  };
  jspb.BinaryReader.prototype.skipMatchingFields = function() {
    var a2 = this.nextField_;
    for (this.unskipHeader(); this.nextField() && this.getFieldNumber() == a2; )
      this.skipField();
    this.decoder_.atEnd() || this.unskipHeader();
  };
  jspb.BinaryReader.prototype.skipVarintField = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.VARINT ? (goog.asserts.fail("Invalid wire type for skipVarintField"), this.skipField()) : this.decoder_.skipVarint();
  };
  jspb.BinaryReader.prototype.skipDelimitedField = function() {
    if (this.nextWireType_ != jspb.BinaryConstants.WireType.DELIMITED)
      goog.asserts.fail("Invalid wire type for skipDelimitedField"), this.skipField();
    else {
      var a2 = this.decoder_.readUnsignedVarint32();
      this.decoder_.advance(a2);
    }
  };
  jspb.BinaryReader.prototype.skipFixed32Field = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED32 ? (goog.asserts.fail("Invalid wire type for skipFixed32Field"), this.skipField()) : this.decoder_.advance(4);
  };
  jspb.BinaryReader.prototype.skipFixed64Field = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED64 ? (goog.asserts.fail("Invalid wire type for skipFixed64Field"), this.skipField()) : this.decoder_.advance(8);
  };
  jspb.BinaryReader.prototype.skipGroup = function() {
    var a2 = this.nextField_;
    do {
      if (!this.nextField()) {
        goog.asserts.fail("Unmatched start-group tag: stream EOF");
        this.error_ = true;
        break;
      }
      if (this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP) {
        this.nextField_ != a2 && (goog.asserts.fail("Unmatched end-group tag"), this.error_ = true);
        break;
      }
      this.skipField();
    } while (1);
  };
  jspb.BinaryReader.prototype.skipField = function() {
    switch (this.nextWireType_) {
      case jspb.BinaryConstants.WireType.VARINT:
        this.skipVarintField();
        break;
      case jspb.BinaryConstants.WireType.FIXED64:
        this.skipFixed64Field();
        break;
      case jspb.BinaryConstants.WireType.DELIMITED:
        this.skipDelimitedField();
        break;
      case jspb.BinaryConstants.WireType.FIXED32:
        this.skipFixed32Field();
        break;
      case jspb.BinaryConstants.WireType.START_GROUP:
        this.skipGroup();
        break;
      default:
        goog.asserts.fail("Invalid wire encoding for field.");
    }
  };
  jspb.BinaryReader.prototype.registerReadCallback = function(a2, b) {
    this.readCallbacks_ === null && (this.readCallbacks_ = {});
    goog.asserts.assert(!this.readCallbacks_[a2]);
    this.readCallbacks_[a2] = b;
  };
  jspb.BinaryReader.prototype.runReadCallback = function(a2) {
    goog.asserts.assert(this.readCallbacks_ !== null);
    a2 = this.readCallbacks_[a2];
    goog.asserts.assert(a2);
    return a2(this);
  };
  jspb.BinaryReader.prototype.readAny = function(a2) {
    this.nextWireType_ = jspb.BinaryConstants.FieldTypeToWireType(a2);
    var b = jspb.BinaryConstants.FieldType;
    switch (a2) {
      case b.DOUBLE:
        return this.readDouble();
      case b.FLOAT:
        return this.readFloat();
      case b.INT64:
        return this.readInt64();
      case b.UINT64:
        return this.readUint64();
      case b.INT32:
        return this.readInt32();
      case b.FIXED64:
        return this.readFixed64();
      case b.FIXED32:
        return this.readFixed32();
      case b.BOOL:
        return this.readBool();
      case b.STRING:
        return this.readString();
      case b.GROUP:
        goog.asserts.fail("Group field type not supported in readAny()");
      case b.MESSAGE:
        goog.asserts.fail("Message field type not supported in readAny()");
      case b.BYTES:
        return this.readBytes();
      case b.UINT32:
        return this.readUint32();
      case b.ENUM:
        return this.readEnum();
      case b.SFIXED32:
        return this.readSfixed32();
      case b.SFIXED64:
        return this.readSfixed64();
      case b.SINT32:
        return this.readSint32();
      case b.SINT64:
        return this.readSint64();
      case b.FHASH64:
        return this.readFixedHash64();
      case b.VHASH64:
        return this.readVarintHash64();
      default:
        goog.asserts.fail("Invalid field type in readAny()");
    }
    return 0;
  };
  jspb.BinaryReader.prototype.readMessage = function(a2, b) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var c = this.decoder_.getEnd(), d = this.decoder_.readUnsignedVarint32();
    d = this.decoder_.getCursor() + d;
    this.decoder_.setEnd(d);
    b(a2, this);
    this.decoder_.setCursor(d);
    this.decoder_.setEnd(c);
  };
  jspb.BinaryReader.prototype.readGroup = function(a2, b, c) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.START_GROUP);
    goog.asserts.assert(this.nextField_ == a2);
    c(b, this);
    this.error_ || this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP || (goog.asserts.fail("Group submessage did not end with an END_GROUP tag"), this.error_ = true);
  };
  jspb.BinaryReader.prototype.getFieldDecoder = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var a2 = this.decoder_.readUnsignedVarint32(), b = this.decoder_.getCursor(), c = b + a2;
    a2 = jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(), b, a2);
    this.decoder_.setCursor(c);
    return a2;
  };
  jspb.BinaryReader.prototype.readInt32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint32();
  };
  jspb.BinaryReader.prototype.readInt32String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint32String();
  };
  jspb.BinaryReader.prototype.readInt64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint64();
  };
  jspb.BinaryReader.prototype.readInt64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint64String();
  };
  jspb.BinaryReader.prototype.readUint32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint32();
  };
  jspb.BinaryReader.prototype.readUint32String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint32String();
  };
  jspb.BinaryReader.prototype.readUint64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint64();
  };
  jspb.BinaryReader.prototype.readUint64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint64String();
  };
  jspb.BinaryReader.prototype.readSint32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarint32();
  };
  jspb.BinaryReader.prototype.readSint64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarint64();
  };
  jspb.BinaryReader.prototype.readSint64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarint64String();
  };
  jspb.BinaryReader.prototype.readFixed32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readUint32();
  };
  jspb.BinaryReader.prototype.readFixed64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readUint64();
  };
  jspb.BinaryReader.prototype.readFixed64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readUint64String();
  };
  jspb.BinaryReader.prototype.readSfixed32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readInt32();
  };
  jspb.BinaryReader.prototype.readSfixed32String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readInt32().toString();
  };
  jspb.BinaryReader.prototype.readSfixed64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readInt64();
  };
  jspb.BinaryReader.prototype.readSfixed64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readInt64String();
  };
  jspb.BinaryReader.prototype.readFloat = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readFloat();
  };
  jspb.BinaryReader.prototype.readDouble = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readDouble();
  };
  jspb.BinaryReader.prototype.readBool = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return !!this.decoder_.readUnsignedVarint32();
  };
  jspb.BinaryReader.prototype.readEnum = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint64();
  };
  jspb.BinaryReader.prototype.readString = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var a2 = this.decoder_.readUnsignedVarint32();
    return this.decoder_.readString(a2);
  };
  jspb.BinaryReader.prototype.readBytes = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var a2 = this.decoder_.readUnsignedVarint32();
    return this.decoder_.readBytes(a2);
  };
  jspb.BinaryReader.prototype.readVarintHash64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readVarintHash64();
  };
  jspb.BinaryReader.prototype.readSintHash64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarintHash64();
  };
  jspb.BinaryReader.prototype.readSplitVarint64 = function(a2) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSplitVarint64(a2);
  };
  jspb.BinaryReader.prototype.readSplitZigzagVarint64 = function(a2) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSplitVarint64(function(b, c) {
      return jspb.utils.fromZigzag64(b, c, a2);
    });
  };
  jspb.BinaryReader.prototype.readFixedHash64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readFixedHash64();
  };
  jspb.BinaryReader.prototype.readSplitFixed64 = function(a2) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readSplitFixed64(a2);
  };
  jspb.BinaryReader.prototype.readPackedField_ = function(a2) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var b = this.decoder_.readUnsignedVarint32();
    b = this.decoder_.getCursor() + b;
    for (var c = []; this.decoder_.getCursor() < b; )
      c.push(a2.call(this.decoder_));
    return c;
  };
  jspb.BinaryReader.prototype.readPackedInt32 = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint32);
  };
  jspb.BinaryReader.prototype.readPackedInt32String = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint32String);
  };
  jspb.BinaryReader.prototype.readPackedInt64 = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint64);
  };
  jspb.BinaryReader.prototype.readPackedInt64String = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint64String);
  };
  jspb.BinaryReader.prototype.readPackedUint32 = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint32);
  };
  jspb.BinaryReader.prototype.readPackedUint32String = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint32String);
  };
  jspb.BinaryReader.prototype.readPackedUint64 = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint64);
  };
  jspb.BinaryReader.prototype.readPackedUint64String = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint64String);
  };
  jspb.BinaryReader.prototype.readPackedSint32 = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint32);
  };
  jspb.BinaryReader.prototype.readPackedSint64 = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint64);
  };
  jspb.BinaryReader.prototype.readPackedSint64String = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint64String);
  };
  jspb.BinaryReader.prototype.readPackedFixed32 = function() {
    return this.readPackedField_(this.decoder_.readUint32);
  };
  jspb.BinaryReader.prototype.readPackedFixed64 = function() {
    return this.readPackedField_(this.decoder_.readUint64);
  };
  jspb.BinaryReader.prototype.readPackedFixed64String = function() {
    return this.readPackedField_(this.decoder_.readUint64String);
  };
  jspb.BinaryReader.prototype.readPackedSfixed32 = function() {
    return this.readPackedField_(this.decoder_.readInt32);
  };
  jspb.BinaryReader.prototype.readPackedSfixed64 = function() {
    return this.readPackedField_(this.decoder_.readInt64);
  };
  jspb.BinaryReader.prototype.readPackedSfixed64String = function() {
    return this.readPackedField_(this.decoder_.readInt64String);
  };
  jspb.BinaryReader.prototype.readPackedFloat = function() {
    return this.readPackedField_(this.decoder_.readFloat);
  };
  jspb.BinaryReader.prototype.readPackedDouble = function() {
    return this.readPackedField_(this.decoder_.readDouble);
  };
  jspb.BinaryReader.prototype.readPackedBool = function() {
    return this.readPackedField_(this.decoder_.readBool);
  };
  jspb.BinaryReader.prototype.readPackedEnum = function() {
    return this.readPackedField_(this.decoder_.readEnum);
  };
  jspb.BinaryReader.prototype.readPackedVarintHash64 = function() {
    return this.readPackedField_(this.decoder_.readVarintHash64);
  };
  jspb.BinaryReader.prototype.readPackedFixedHash64 = function() {
    return this.readPackedField_(this.decoder_.readFixedHash64);
  };
  jspb.BinaryEncoder = function() {
    this.buffer_ = [];
  };
  jspb.BinaryEncoder.prototype.length = function() {
    return this.buffer_.length;
  };
  jspb.BinaryEncoder.prototype.end = function() {
    var a2 = this.buffer_;
    this.buffer_ = [];
    return a2;
  };
  jspb.BinaryEncoder.prototype.writeSplitVarint64 = function(a2, b) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(b == Math.floor(b));
    goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_32);
    for (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32); 0 < b || 127 < a2; )
      this.buffer_.push(a2 & 127 | 128), a2 = (a2 >>> 7 | b << 25) >>> 0, b >>>= 7;
    this.buffer_.push(a2);
  };
  jspb.BinaryEncoder.prototype.writeSplitFixed64 = function(a2, b) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(b == Math.floor(b));
    goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_32);
    goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32);
    this.writeUint32(a2);
    this.writeUint32(b);
  };
  jspb.BinaryEncoder.prototype.writeUnsignedVarint32 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    for (goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_32); 127 < a2; )
      this.buffer_.push(a2 & 127 | 128), a2 >>>= 7;
    this.buffer_.push(a2);
  };
  jspb.BinaryEncoder.prototype.writeSignedVarint32 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_31 && a2 < jspb.BinaryConstants.TWO_TO_31);
    if (0 <= a2)
      this.writeUnsignedVarint32(a2);
    else {
      for (var b = 0; 9 > b; b++)
        this.buffer_.push(a2 & 127 | 128), a2 >>= 7;
      this.buffer_.push(1);
    }
  };
  jspb.BinaryEncoder.prototype.writeUnsignedVarint64 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_64);
    jspb.utils.splitInt64(a2);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeSignedVarint64 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_63 && a2 < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitInt64(a2);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeZigzagVarint32 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_31 && a2 < jspb.BinaryConstants.TWO_TO_31);
    this.writeUnsignedVarint32((a2 << 1 ^ a2 >> 31) >>> 0);
  };
  jspb.BinaryEncoder.prototype.writeZigzagVarint64 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_63 && a2 < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitZigzag64(a2);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeZigzagVarint64String = function(a2) {
    this.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(a2));
  };
  jspb.BinaryEncoder.prototype.writeZigzagVarintHash64 = function(a2) {
    var b = this;
    jspb.utils.splitHash64(a2);
    jspb.utils.toZigzag64(jspb.utils.split64Low, jspb.utils.split64High, function(a3, d) {
      b.writeSplitVarint64(a3 >>> 0, d >>> 0);
    });
  };
  jspb.BinaryEncoder.prototype.writeUint8 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(0 <= a2 && 256 > a2);
    this.buffer_.push(a2 >>> 0 & 255);
  };
  jspb.BinaryEncoder.prototype.writeUint16 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(0 <= a2 && 65536 > a2);
    this.buffer_.push(a2 >>> 0 & 255);
    this.buffer_.push(a2 >>> 8 & 255);
  };
  jspb.BinaryEncoder.prototype.writeUint32 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_32);
    this.buffer_.push(a2 >>> 0 & 255);
    this.buffer_.push(a2 >>> 8 & 255);
    this.buffer_.push(a2 >>> 16 & 255);
    this.buffer_.push(a2 >>> 24 & 255);
  };
  jspb.BinaryEncoder.prototype.writeUint64 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(0 <= a2 && a2 < jspb.BinaryConstants.TWO_TO_64);
    jspb.utils.splitUint64(a2);
    this.writeUint32(jspb.utils.split64Low);
    this.writeUint32(jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeInt8 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(-128 <= a2 && 128 > a2);
    this.buffer_.push(a2 >>> 0 & 255);
  };
  jspb.BinaryEncoder.prototype.writeInt16 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(-32768 <= a2 && 32768 > a2);
    this.buffer_.push(a2 >>> 0 & 255);
    this.buffer_.push(a2 >>> 8 & 255);
  };
  jspb.BinaryEncoder.prototype.writeInt32 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_31 && a2 < jspb.BinaryConstants.TWO_TO_31);
    this.buffer_.push(a2 >>> 0 & 255);
    this.buffer_.push(a2 >>> 8 & 255);
    this.buffer_.push(a2 >>> 16 & 255);
    this.buffer_.push(a2 >>> 24 & 255);
  };
  jspb.BinaryEncoder.prototype.writeInt64 = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_63 && a2 < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitInt64(a2);
    this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeInt64String = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(+a2 >= -jspb.BinaryConstants.TWO_TO_63 && +a2 < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a2));
    this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeFloat = function(a2) {
    goog.asserts.assert(a2 === Infinity || a2 === -Infinity || isNaN(a2) || a2 >= -jspb.BinaryConstants.FLOAT32_MAX && a2 <= jspb.BinaryConstants.FLOAT32_MAX);
    jspb.utils.splitFloat32(a2);
    this.writeUint32(jspb.utils.split64Low);
  };
  jspb.BinaryEncoder.prototype.writeDouble = function(a2) {
    goog.asserts.assert(a2 === Infinity || a2 === -Infinity || isNaN(a2) || a2 >= -jspb.BinaryConstants.FLOAT64_MAX && a2 <= jspb.BinaryConstants.FLOAT64_MAX);
    jspb.utils.splitFloat64(a2);
    this.writeUint32(jspb.utils.split64Low);
    this.writeUint32(jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeBool = function(a2) {
    goog.asserts.assert(typeof a2 === "boolean" || typeof a2 === "number");
    this.buffer_.push(a2 ? 1 : 0);
  };
  jspb.BinaryEncoder.prototype.writeEnum = function(a2) {
    goog.asserts.assert(a2 == Math.floor(a2));
    goog.asserts.assert(a2 >= -jspb.BinaryConstants.TWO_TO_31 && a2 < jspb.BinaryConstants.TWO_TO_31);
    this.writeSignedVarint32(a2);
  };
  jspb.BinaryEncoder.prototype.writeBytes = function(a2) {
    this.buffer_.push.apply(this.buffer_, a2);
  };
  jspb.BinaryEncoder.prototype.writeVarintHash64 = function(a2) {
    jspb.utils.splitHash64(a2);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeFixedHash64 = function(a2) {
    jspb.utils.splitHash64(a2);
    this.writeUint32(jspb.utils.split64Low);
    this.writeUint32(jspb.utils.split64High);
  };
  jspb.BinaryEncoder.prototype.writeString = function(a2) {
    for (var b = this.buffer_.length, c = 0; c < a2.length; c++) {
      var d = a2.charCodeAt(c);
      if (128 > d)
        this.buffer_.push(d);
      else if (2048 > d)
        this.buffer_.push(d >> 6 | 192), this.buffer_.push(d & 63 | 128);
      else if (65536 > d)
        if (55296 <= d && 56319 >= d && c + 1 < a2.length) {
          var e = a2.charCodeAt(c + 1);
          56320 <= e && 57343 >= e && (d = 1024 * (d - 55296) + e - 56320 + 65536, this.buffer_.push(d >> 18 | 240), this.buffer_.push(d >> 12 & 63 | 128), this.buffer_.push(d >> 6 & 63 | 128), this.buffer_.push(d & 63 | 128), c++);
        } else
          this.buffer_.push(d >> 12 | 224), this.buffer_.push(d >> 6 & 63 | 128), this.buffer_.push(d & 63 | 128);
    }
    return this.buffer_.length - b;
  };
  jspb.arith = {};
  jspb.arith.UInt64 = function(a2, b) {
    this.lo = a2;
    this.hi = b;
  };
  jspb.arith.UInt64.prototype.cmp = function(a2) {
    return this.hi < a2.hi || this.hi == a2.hi && this.lo < a2.lo ? -1 : this.hi == a2.hi && this.lo == a2.lo ? 0 : 1;
  };
  jspb.arith.UInt64.prototype.rightShift = function() {
    return new jspb.arith.UInt64((this.lo >>> 1 | (this.hi & 1) << 31) >>> 0, this.hi >>> 1 >>> 0);
  };
  jspb.arith.UInt64.prototype.leftShift = function() {
    return new jspb.arith.UInt64(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
  };
  jspb.arith.UInt64.prototype.msb = function() {
    return !!(this.hi & 2147483648);
  };
  jspb.arith.UInt64.prototype.lsb = function() {
    return !!(this.lo & 1);
  };
  jspb.arith.UInt64.prototype.zero = function() {
    return this.lo == 0 && this.hi == 0;
  };
  jspb.arith.UInt64.prototype.add = function(a2) {
    return new jspb.arith.UInt64((this.lo + a2.lo & 4294967295) >>> 0 >>> 0, ((this.hi + a2.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + a2.lo ? 1 : 0) >>> 0);
  };
  jspb.arith.UInt64.prototype.sub = function(a2) {
    return new jspb.arith.UInt64((this.lo - a2.lo & 4294967295) >>> 0 >>> 0, ((this.hi - a2.hi & 4294967295) >>> 0) - (0 > this.lo - a2.lo ? 1 : 0) >>> 0);
  };
  jspb.arith.UInt64.mul32x32 = function(a2, b) {
    var c = a2 & 65535;
    a2 >>>= 16;
    var d = b & 65535, e = b >>> 16;
    b = c * d + 65536 * (c * e & 65535) + 65536 * (a2 * d & 65535);
    for (c = a2 * e + (c * e >>> 16) + (a2 * d >>> 16); 4294967296 <= b; )
      b -= 4294967296, c += 1;
    return new jspb.arith.UInt64(b >>> 0, c >>> 0);
  };
  jspb.arith.UInt64.prototype.mul = function(a2) {
    var b = jspb.arith.UInt64.mul32x32(this.lo, a2);
    a2 = jspb.arith.UInt64.mul32x32(this.hi, a2);
    a2.hi = a2.lo;
    a2.lo = 0;
    return b.add(a2);
  };
  jspb.arith.UInt64.prototype.div = function(a2) {
    if (a2 == 0)
      return [];
    var b = new jspb.arith.UInt64(0, 0), c = new jspb.arith.UInt64(this.lo, this.hi);
    a2 = new jspb.arith.UInt64(a2, 0);
    for (var d = new jspb.arith.UInt64(1, 0); !a2.msb(); )
      a2 = a2.leftShift(), d = d.leftShift();
    for (; !d.zero(); )
      0 >= a2.cmp(c) && (b = b.add(d), c = c.sub(a2)), a2 = a2.rightShift(), d = d.rightShift();
    return [b, c];
  };
  jspb.arith.UInt64.prototype.toString = function() {
    for (var a2 = "", b = this; !b.zero(); ) {
      b = b.div(10);
      var c = b[0];
      a2 = b[1].lo + a2;
      b = c;
    }
    a2 == "" && (a2 = "0");
    return a2;
  };
  jspb.arith.UInt64.fromString = function(a2) {
    for (var b = new jspb.arith.UInt64(0, 0), c = new jspb.arith.UInt64(0, 0), d = 0; d < a2.length; d++) {
      if ("0" > a2[d] || "9" < a2[d])
        return null;
      var e = parseInt(a2[d], 10);
      c.lo = e;
      b = b.mul(10).add(c);
    }
    return b;
  };
  jspb.arith.UInt64.prototype.clone = function() {
    return new jspb.arith.UInt64(this.lo, this.hi);
  };
  jspb.arith.Int64 = function(a2, b) {
    this.lo = a2;
    this.hi = b;
  };
  jspb.arith.Int64.prototype.add = function(a2) {
    return new jspb.arith.Int64((this.lo + a2.lo & 4294967295) >>> 0 >>> 0, ((this.hi + a2.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + a2.lo ? 1 : 0) >>> 0);
  };
  jspb.arith.Int64.prototype.sub = function(a2) {
    return new jspb.arith.Int64((this.lo - a2.lo & 4294967295) >>> 0 >>> 0, ((this.hi - a2.hi & 4294967295) >>> 0) - (0 > this.lo - a2.lo ? 1 : 0) >>> 0);
  };
  jspb.arith.Int64.prototype.clone = function() {
    return new jspb.arith.Int64(this.lo, this.hi);
  };
  jspb.arith.Int64.prototype.toString = function() {
    var a2 = (this.hi & 2147483648) != 0, b = new jspb.arith.UInt64(this.lo, this.hi);
    a2 && (b = new jspb.arith.UInt64(0, 0).sub(b));
    return (a2 ? "-" : "") + b.toString();
  };
  jspb.arith.Int64.fromString = function(a2) {
    var b = 0 < a2.length && a2[0] == "-";
    b && (a2 = a2.substring(1));
    a2 = jspb.arith.UInt64.fromString(a2);
    if (a2 === null)
      return null;
    b && (a2 = new jspb.arith.UInt64(0, 0).sub(a2));
    return new jspb.arith.Int64(a2.lo, a2.hi);
  };
  jspb.BinaryWriter = function() {
    this.blocks_ = [];
    this.totalLength_ = 0;
    this.encoder_ = new jspb.BinaryEncoder();
    this.bookmarks_ = [];
  };
  jspb.BinaryWriter.prototype.appendUint8Array_ = function(a2) {
    var b = this.encoder_.end();
    this.blocks_.push(b);
    this.blocks_.push(a2);
    this.totalLength_ += b.length + a2.length;
  };
  jspb.BinaryWriter.prototype.beginDelimited_ = function(a2) {
    this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED);
    a2 = this.encoder_.end();
    this.blocks_.push(a2);
    this.totalLength_ += a2.length;
    a2.push(this.totalLength_);
    return a2;
  };
  jspb.BinaryWriter.prototype.endDelimited_ = function(a2) {
    var b = a2.pop();
    b = this.totalLength_ + this.encoder_.length() - b;
    for (goog.asserts.assert(0 <= b); 127 < b; )
      a2.push(b & 127 | 128), b >>>= 7, this.totalLength_++;
    a2.push(b);
    this.totalLength_++;
  };
  jspb.BinaryWriter.prototype.writeSerializedMessage = function(a2, b, c) {
    this.appendUint8Array_(a2.subarray(b, c));
  };
  jspb.BinaryWriter.prototype.maybeWriteSerializedMessage = function(a2, b, c) {
    a2 != null && b != null && c != null && this.writeSerializedMessage(a2, b, c);
  };
  jspb.BinaryWriter.prototype.reset = function() {
    this.blocks_ = [];
    this.encoder_.end();
    this.totalLength_ = 0;
    this.bookmarks_ = [];
  };
  jspb.BinaryWriter.prototype.getResultBuffer = function() {
    goog.asserts.assert(this.bookmarks_.length == 0);
    for (var a2 = new Uint8Array(this.totalLength_ + this.encoder_.length()), b = this.blocks_, c = b.length, d = 0, e = 0; e < c; e++) {
      var f = b[e];
      a2.set(f, d);
      d += f.length;
    }
    b = this.encoder_.end();
    a2.set(b, d);
    d += b.length;
    goog.asserts.assert(d == a2.length);
    this.blocks_ = [a2];
    return a2;
  };
  jspb.BinaryWriter.prototype.getResultBase64String = function(a2) {
    return goog.crypt.base64.encodeByteArray(this.getResultBuffer(), a2);
  };
  jspb.BinaryWriter.prototype.beginSubMessage = function(a2) {
    this.bookmarks_.push(this.beginDelimited_(a2));
  };
  jspb.BinaryWriter.prototype.endSubMessage = function() {
    goog.asserts.assert(0 <= this.bookmarks_.length);
    this.endDelimited_(this.bookmarks_.pop());
  };
  jspb.BinaryWriter.prototype.writeFieldHeader_ = function(a2, b) {
    goog.asserts.assert(1 <= a2 && a2 == Math.floor(a2));
    this.encoder_.writeUnsignedVarint32(8 * a2 + b);
  };
  jspb.BinaryWriter.prototype.writeAny = function(a2, b, c) {
    var d = jspb.BinaryConstants.FieldType;
    switch (a2) {
      case d.DOUBLE:
        this.writeDouble(b, c);
        break;
      case d.FLOAT:
        this.writeFloat(b, c);
        break;
      case d.INT64:
        this.writeInt64(b, c);
        break;
      case d.UINT64:
        this.writeUint64(b, c);
        break;
      case d.INT32:
        this.writeInt32(b, c);
        break;
      case d.FIXED64:
        this.writeFixed64(b, c);
        break;
      case d.FIXED32:
        this.writeFixed32(b, c);
        break;
      case d.BOOL:
        this.writeBool(b, c);
        break;
      case d.STRING:
        this.writeString(b, c);
        break;
      case d.GROUP:
        goog.asserts.fail("Group field type not supported in writeAny()");
        break;
      case d.MESSAGE:
        goog.asserts.fail("Message field type not supported in writeAny()");
        break;
      case d.BYTES:
        this.writeBytes(b, c);
        break;
      case d.UINT32:
        this.writeUint32(b, c);
        break;
      case d.ENUM:
        this.writeEnum(b, c);
        break;
      case d.SFIXED32:
        this.writeSfixed32(b, c);
        break;
      case d.SFIXED64:
        this.writeSfixed64(b, c);
        break;
      case d.SINT32:
        this.writeSint32(b, c);
        break;
      case d.SINT64:
        this.writeSint64(b, c);
        break;
      case d.FHASH64:
        this.writeFixedHash64(b, c);
        break;
      case d.VHASH64:
        this.writeVarintHash64(b, c);
        break;
      default:
        goog.asserts.fail("Invalid field type in writeAny()");
    }
  };
  jspb.BinaryWriter.prototype.writeUnsignedVarint32_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint32(b));
  };
  jspb.BinaryWriter.prototype.writeSignedVarint32_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(b));
  };
  jspb.BinaryWriter.prototype.writeUnsignedVarint64_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint64(b));
  };
  jspb.BinaryWriter.prototype.writeSignedVarint64_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint64(b));
  };
  jspb.BinaryWriter.prototype.writeZigzagVarint32_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint32(b));
  };
  jspb.BinaryWriter.prototype.writeZigzagVarint64_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64(b));
  };
  jspb.BinaryWriter.prototype.writeZigzagVarint64String_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64String(b));
  };
  jspb.BinaryWriter.prototype.writeZigzagVarintHash64_ = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarintHash64(b));
  };
  jspb.BinaryWriter.prototype.writeInt32 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeInt32String = function(a2, b) {
    b != null && (b = parseInt(b, 10), goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeInt64 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeSignedVarint64_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeInt64String = function(a2, b) {
    b != null && (b = jspb.arith.Int64.fromString(b), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(b.lo, b.hi));
  };
  jspb.BinaryWriter.prototype.writeUint32 = function(a2, b) {
    b != null && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeUint32String = function(a2, b) {
    b != null && (b = parseInt(b, 10), goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeUint64 = function(a2, b) {
    b != null && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_64), this.writeUnsignedVarint64_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeUint64String = function(a2, b) {
    b != null && (b = jspb.arith.UInt64.fromString(b), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(b.lo, b.hi));
  };
  jspb.BinaryWriter.prototype.writeSint32 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeZigzagVarint32_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeSint64 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeZigzagVarint64_(a2, b));
  };
  jspb.BinaryWriter.prototype.writeSintHash64 = function(a2, b) {
    b != null && this.writeZigzagVarintHash64_(a2, b);
  };
  jspb.BinaryWriter.prototype.writeSint64String = function(a2, b) {
    b != null && this.writeZigzagVarint64String_(a2, b);
  };
  jspb.BinaryWriter.prototype.writeFixed32 = function(a2, b) {
    b != null && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeUint32(b));
  };
  jspb.BinaryWriter.prototype.writeFixed64 = function(a2, b) {
    b != null && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_64), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeUint64(b));
  };
  jspb.BinaryWriter.prototype.writeFixed64String = function(a2, b) {
    b != null && (b = jspb.arith.UInt64.fromString(b), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(b.lo, b.hi));
  };
  jspb.BinaryWriter.prototype.writeSfixed32 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeInt32(b));
  };
  jspb.BinaryWriter.prototype.writeSfixed64 = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeInt64(b));
  };
  jspb.BinaryWriter.prototype.writeSfixed64String = function(a2, b) {
    b != null && (b = jspb.arith.Int64.fromString(b), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(b.lo, b.hi));
  };
  jspb.BinaryWriter.prototype.writeFloat = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeFloat(b));
  };
  jspb.BinaryWriter.prototype.writeDouble = function(a2, b) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeDouble(b));
  };
  jspb.BinaryWriter.prototype.writeBool = function(a2, b) {
    b != null && (goog.asserts.assert(typeof b === "boolean" || typeof b === "number"), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeBool(b));
  };
  jspb.BinaryWriter.prototype.writeEnum = function(a2, b) {
    b != null && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(b));
  };
  jspb.BinaryWriter.prototype.writeString = function(a2, b) {
    b != null && (a2 = this.beginDelimited_(a2), this.encoder_.writeString(b), this.endDelimited_(a2));
  };
  jspb.BinaryWriter.prototype.writeBytes = function(a2, b) {
    b != null && (b = jspb.utils.byteSourceToUint8Array(b), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(b.length), this.appendUint8Array_(b));
  };
  jspb.BinaryWriter.prototype.writeMessage = function(a2, b, c) {
    b != null && (a2 = this.beginDelimited_(a2), c(b, this), this.endDelimited_(a2));
  };
  jspb.BinaryWriter.prototype.writeMessageSet = function(a2, b, c) {
    b != null && (this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.START_GROUP), this.writeFieldHeader_(2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(a2), a2 = this.beginDelimited_(3), c(b, this), this.endDelimited_(a2), this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.END_GROUP));
  };
  jspb.BinaryWriter.prototype.writeGroup = function(a2, b, c) {
    b != null && (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.START_GROUP), c(b, this), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.END_GROUP));
  };
  jspb.BinaryWriter.prototype.writeFixedHash64 = function(a2, b) {
    b != null && (goog.asserts.assert(b.length == 8), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeFixedHash64(b));
  };
  jspb.BinaryWriter.prototype.writeVarintHash64 = function(a2, b) {
    b != null && (goog.asserts.assert(b.length == 8), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeVarintHash64(b));
  };
  jspb.BinaryWriter.prototype.writeSplitFixed64 = function(a2, b, c) {
    this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.FIXED64);
    this.encoder_.writeSplitFixed64(b, c);
  };
  jspb.BinaryWriter.prototype.writeSplitVarint64 = function(a2, b, c) {
    this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT);
    this.encoder_.writeSplitVarint64(b, c);
  };
  jspb.BinaryWriter.prototype.writeSplitZigzagVarint64 = function(a2, b, c) {
    this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.VARINT);
    var d = this.encoder_;
    jspb.utils.toZigzag64(b, c, function(a3, b2) {
      d.writeSplitVarint64(a3 >>> 0, b2 >>> 0);
    });
  };
  jspb.BinaryWriter.prototype.writeRepeatedInt32 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeSignedVarint32_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedInt32String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeInt32String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedInt64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeSignedVarint64_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSplitFixed64 = function(a2, b, c, d) {
    if (b != null)
      for (var e = 0; e < b.length; e++)
        this.writeSplitFixed64(a2, c(b[e]), d(b[e]));
  };
  jspb.BinaryWriter.prototype.writeRepeatedSplitVarint64 = function(a2, b, c, d) {
    if (b != null)
      for (var e = 0; e < b.length; e++)
        this.writeSplitVarint64(a2, c(b[e]), d(b[e]));
  };
  jspb.BinaryWriter.prototype.writeRepeatedSplitZigzagVarint64 = function(a2, b, c, d) {
    if (b != null)
      for (var e = 0; e < b.length; e++)
        this.writeSplitZigzagVarint64(a2, c(b[e]), d(b[e]));
  };
  jspb.BinaryWriter.prototype.writeRepeatedInt64String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeInt64String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedUint32 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeUnsignedVarint32_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedUint32String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeUint32String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedUint64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeUnsignedVarint64_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedUint64String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeUint64String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSint32 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeZigzagVarint32_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSint64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeZigzagVarint64_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSint64String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeZigzagVarint64String_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSintHash64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeZigzagVarintHash64_(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedFixed32 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeFixed32(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedFixed64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeFixed64(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedFixed64String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeFixed64String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSfixed32 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeSfixed32(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSfixed64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeSfixed64(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedSfixed64String = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeSfixed64String(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedFloat = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeFloat(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedDouble = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeDouble(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedBool = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeBool(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedEnum = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeEnum(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedString = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeString(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedBytes = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeBytes(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedMessage = function(a2, b, c) {
    if (b != null)
      for (var d = 0; d < b.length; d++) {
        var e = this.beginDelimited_(a2);
        c(b[d], this);
        this.endDelimited_(e);
      }
  };
  jspb.BinaryWriter.prototype.writeRepeatedGroup = function(a2, b, c) {
    if (b != null)
      for (var d = 0; d < b.length; d++)
        this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.START_GROUP), c(b[d], this), this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.END_GROUP);
  };
  jspb.BinaryWriter.prototype.writeRepeatedFixedHash64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeFixedHash64(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writeRepeatedVarintHash64 = function(a2, b) {
    if (b != null)
      for (var c = 0; c < b.length; c++)
        this.writeVarintHash64(a2, b[c]);
  };
  jspb.BinaryWriter.prototype.writePackedInt32 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeSignedVarint32(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedInt32String = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeSignedVarint32(parseInt(b[c], 10));
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedInt64 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeSignedVarint64(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSplitFixed64 = function(a2, b, c, d) {
    if (b != null) {
      a2 = this.beginDelimited_(a2);
      for (var e = 0; e < b.length; e++)
        this.encoder_.writeSplitFixed64(c(b[e]), d(b[e]));
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSplitVarint64 = function(a2, b, c, d) {
    if (b != null) {
      a2 = this.beginDelimited_(a2);
      for (var e = 0; e < b.length; e++)
        this.encoder_.writeSplitVarint64(c(b[e]), d(b[e]));
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSplitZigzagVarint64 = function(a2, b, c, d) {
    if (b != null) {
      a2 = this.beginDelimited_(a2);
      for (var e = this.encoder_, f = 0; f < b.length; f++)
        jspb.utils.toZigzag64(c(b[f]), d(b[f]), function(a3, b2) {
          e.writeSplitVarint64(a3 >>> 0, b2 >>> 0);
        });
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedInt64String = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++) {
        var d = jspb.arith.Int64.fromString(b[c]);
        this.encoder_.writeSplitVarint64(d.lo, d.hi);
      }
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedUint32 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeUnsignedVarint32(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedUint32String = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeUnsignedVarint32(parseInt(b[c], 10));
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedUint64 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeUnsignedVarint64(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedUint64String = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++) {
        var d = jspb.arith.UInt64.fromString(b[c]);
        this.encoder_.writeSplitVarint64(d.lo, d.hi);
      }
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSint32 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeZigzagVarint32(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSint64 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeZigzagVarint64(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSint64String = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(b[c]));
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedSintHash64 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeZigzagVarintHash64(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedFixed32 = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeUint32(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedFixed64 = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeUint64(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedFixed64String = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++) {
        var c = jspb.arith.UInt64.fromString(b[a2]);
        this.encoder_.writeSplitFixed64(c.lo, c.hi);
      }
  };
  jspb.BinaryWriter.prototype.writePackedSfixed32 = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeInt32(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedSfixed64 = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeInt64(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedSfixed64String = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeInt64String(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedFloat = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeFloat(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedDouble = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeDouble(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedBool = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeBool(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedEnum = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeEnum(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.BinaryWriter.prototype.writePackedFixedHash64 = function(a2, b) {
    if (b != null && b.length)
      for (this.writeFieldHeader_(a2, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a2 = 0; a2 < b.length; a2++)
        this.encoder_.writeFixedHash64(b[a2]);
  };
  jspb.BinaryWriter.prototype.writePackedVarintHash64 = function(a2, b) {
    if (b != null && b.length) {
      a2 = this.beginDelimited_(a2);
      for (var c = 0; c < b.length; c++)
        this.encoder_.writeVarintHash64(b[c]);
      this.endDelimited_(a2);
    }
  };
  jspb.Map = function(a2, b) {
    this.arr_ = a2;
    this.valueCtor_ = b;
    this.map_ = {};
    this.arrClean = true;
    0 < this.arr_.length && this.loadFromArray_();
  };
  jspb.Map.prototype.loadFromArray_ = function() {
    for (var a2 = 0; a2 < this.arr_.length; a2++) {
      var b = this.arr_[a2], c = b[0];
      this.map_[c.toString()] = new jspb.Map.Entry_(c, b[1]);
    }
    this.arrClean = true;
  };
  jspb.Map.prototype.toArray = function() {
    if (this.arrClean) {
      if (this.valueCtor_) {
        var a2 = this.map_, b;
        for (b in a2)
          if (Object.prototype.hasOwnProperty.call(a2, b)) {
            var c = a2[b].valueWrapper;
            c && c.toArray();
          }
      }
    } else {
      this.arr_.length = 0;
      a2 = this.stringKeys_();
      a2.sort();
      for (b = 0; b < a2.length; b++) {
        var d = this.map_[a2[b]];
        (c = d.valueWrapper) && c.toArray();
        this.arr_.push([d.key, d.value]);
      }
      this.arrClean = true;
    }
    return this.arr_;
  };
  jspb.Map.prototype.toObject = function(a2, b) {
    for (var c = this.toArray(), d = [], e = 0; e < c.length; e++) {
      var f = this.map_[c[e][0].toString()];
      this.wrapEntry_(f);
      var g = f.valueWrapper;
      g ? (goog.asserts.assert(b), d.push([f.key, b(a2, g)])) : d.push([f.key, f.value]);
    }
    return d;
  };
  jspb.Map.fromObject = function(a2, b, c) {
    b = new jspb.Map([], b);
    for (var d = 0; d < a2.length; d++) {
      var e = a2[d][0], f = c(a2[d][1]);
      b.set(e, f);
    }
    return b;
  };
  jspb.Map.ArrayIteratorIterable_ = function(a2) {
    this.idx_ = 0;
    this.arr_ = a2;
  };
  jspb.Map.ArrayIteratorIterable_.prototype.next = function() {
    return this.idx_ < this.arr_.length ? { done: false, value: this.arr_[this.idx_++] } : { done: true, value: void 0 };
  };
  typeof Symbol != "undefined" && (jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator] = function() {
    return this;
  });
  jspb.Map.prototype.getLength = function() {
    return this.stringKeys_().length;
  };
  jspb.Map.prototype.clear = function() {
    this.map_ = {};
    this.arrClean = false;
  };
  jspb.Map.prototype.del = function(a2) {
    a2 = a2.toString();
    var b = this.map_.hasOwnProperty(a2);
    delete this.map_[a2];
    this.arrClean = false;
    return b;
  };
  jspb.Map.prototype.getEntryList = function() {
    var a2 = [], b = this.stringKeys_();
    b.sort();
    for (var c = 0; c < b.length; c++) {
      var d = this.map_[b[c]];
      a2.push([d.key, d.value]);
    }
    return a2;
  };
  jspb.Map.prototype.entries = function() {
    var a2 = [], b = this.stringKeys_();
    b.sort();
    for (var c = 0; c < b.length; c++) {
      var d = this.map_[b[c]];
      a2.push([d.key, this.wrapEntry_(d)]);
    }
    return new jspb.Map.ArrayIteratorIterable_(a2);
  };
  jspb.Map.prototype.keys = function() {
    var a2 = [], b = this.stringKeys_();
    b.sort();
    for (var c = 0; c < b.length; c++)
      a2.push(this.map_[b[c]].key);
    return new jspb.Map.ArrayIteratorIterable_(a2);
  };
  jspb.Map.prototype.values = function() {
    var a2 = [], b = this.stringKeys_();
    b.sort();
    for (var c = 0; c < b.length; c++)
      a2.push(this.wrapEntry_(this.map_[b[c]]));
    return new jspb.Map.ArrayIteratorIterable_(a2);
  };
  jspb.Map.prototype.forEach = function(a2, b) {
    var c = this.stringKeys_();
    c.sort();
    for (var d = 0; d < c.length; d++) {
      var e = this.map_[c[d]];
      a2.call(b, this.wrapEntry_(e), e.key, this);
    }
  };
  jspb.Map.prototype.set = function(a2, b) {
    var c = new jspb.Map.Entry_(a2);
    this.valueCtor_ ? (c.valueWrapper = b, c.value = b.toArray()) : c.value = b;
    this.map_[a2.toString()] = c;
    this.arrClean = false;
    return this;
  };
  jspb.Map.prototype.wrapEntry_ = function(a2) {
    return this.valueCtor_ ? (a2.valueWrapper || (a2.valueWrapper = new this.valueCtor_(a2.value)), a2.valueWrapper) : a2.value;
  };
  jspb.Map.prototype.get = function(a2) {
    if (a2 = this.map_[a2.toString()])
      return this.wrapEntry_(a2);
  };
  jspb.Map.prototype.has = function(a2) {
    return a2.toString() in this.map_;
  };
  jspb.Map.prototype.serializeBinary = function(a2, b, c, d, e) {
    var f = this.stringKeys_();
    f.sort();
    for (var g = 0; g < f.length; g++) {
      var h = this.map_[f[g]];
      b.beginSubMessage(a2);
      c.call(b, 1, h.key);
      this.valueCtor_ ? d.call(b, 2, this.wrapEntry_(h), e) : d.call(b, 2, h.value);
      b.endSubMessage();
    }
  };
  jspb.Map.deserializeBinary = function(a2, b, c, d, e, f, g) {
    for (; b.nextField() && !b.isEndGroup(); ) {
      var h = b.getFieldNumber();
      h == 1 ? f = c.call(b) : h == 2 && (a2.valueCtor_ ? (goog.asserts.assert(e), g || (g = new a2.valueCtor_()), d.call(b, g, e)) : g = d.call(b));
    }
    goog.asserts.assert(f != void 0);
    goog.asserts.assert(g != void 0);
    a2.set(f, g);
  };
  jspb.Map.prototype.stringKeys_ = function() {
    var a2 = this.map_, b = [], c;
    for (c in a2)
      Object.prototype.hasOwnProperty.call(a2, c) && b.push(c);
    return b;
  };
  jspb.Map.Entry_ = function(a2, b) {
    this.key = a2;
    this.value = b;
    this.valueWrapper = void 0;
  };
  jspb.ExtensionFieldInfo = function(a2, b, c, d, e) {
    this.fieldIndex = a2;
    this.fieldName = b;
    this.ctor = c;
    this.toObjectFn = d;
    this.isRepeated = e;
  };
  jspb.ExtensionFieldBinaryInfo = function(a2, b, c, d, e, f) {
    this.fieldInfo = a2;
    this.binaryReaderFn = b;
    this.binaryWriterFn = c;
    this.binaryMessageSerializeFn = d;
    this.binaryMessageDeserializeFn = e;
    this.isPacked = f;
  };
  jspb.ExtensionFieldInfo.prototype.isMessageType = function() {
    return !!this.ctor;
  };
  jspb.Message = function() {
  };
  jspb.Message.GENERATE_TO_OBJECT = true;
  jspb.Message.GENERATE_FROM_OBJECT = !goog.DISALLOW_TEST_ONLY_CODE;
  jspb.Message.GENERATE_TO_STRING = true;
  jspb.Message.ASSUME_LOCAL_ARRAYS = false;
  jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS = true;
  jspb.Message.SUPPORTS_UINT8ARRAY_ = typeof Uint8Array == "function";
  jspb.Message.prototype.getJsPbMessageId = function() {
    return this.messageId_;
  };
  jspb.Message.getIndex_ = function(a2, b) {
    return b + a2.arrayIndexOffset_;
  };
  jspb.Message.hiddenES6Property_ = function() {
  };
  jspb.Message.getFieldNumber_ = function(a2, b) {
    return b - a2.arrayIndexOffset_;
  };
  jspb.Message.initialize = function(a2, b, c, d, e, f) {
    a2.wrappers_ = null;
    b || (b = c ? [c] : []);
    a2.messageId_ = c ? String(c) : void 0;
    a2.arrayIndexOffset_ = c === 0 ? -1 : 0;
    a2.array = b;
    jspb.Message.initPivotAndExtensionObject_(a2, d);
    a2.convertedPrimitiveFields_ = {};
    jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS || (a2.repeatedFields = e);
    if (e)
      for (b = 0; b < e.length; b++)
        c = e[b], c < a2.pivot_ ? (c = jspb.Message.getIndex_(a2, c), a2.array[c] = a2.array[c] || jspb.Message.EMPTY_LIST_SENTINEL_) : (jspb.Message.maybeInitEmptyExtensionObject_(a2), a2.extensionObject_[c] = a2.extensionObject_[c] || jspb.Message.EMPTY_LIST_SENTINEL_);
    if (f && f.length)
      for (b = 0; b < f.length; b++)
        jspb.Message.computeOneofCase(a2, f[b]);
  };
  jspb.Message.EMPTY_LIST_SENTINEL_ = goog.DEBUG && Object.freeze ? Object.freeze([]) : [];
  jspb.Message.isArray_ = function(a2) {
    return jspb.Message.ASSUME_LOCAL_ARRAYS ? a2 instanceof Array : Array.isArray(a2);
  };
  jspb.Message.isExtensionObject_ = function(a2) {
    return a2 !== null && typeof a2 == "object" && !jspb.Message.isArray_(a2) && !(jspb.Message.SUPPORTS_UINT8ARRAY_ && a2 instanceof Uint8Array);
  };
  jspb.Message.initPivotAndExtensionObject_ = function(a2, b) {
    var c = a2.array.length, d = -1;
    if (c && (d = c - 1, c = a2.array[d], jspb.Message.isExtensionObject_(c))) {
      a2.pivot_ = jspb.Message.getFieldNumber_(a2, d);
      a2.extensionObject_ = c;
      return;
    }
    -1 < b ? (a2.pivot_ = Math.max(b, jspb.Message.getFieldNumber_(a2, d + 1)), a2.extensionObject_ = null) : a2.pivot_ = Number.MAX_VALUE;
  };
  jspb.Message.maybeInitEmptyExtensionObject_ = function(a2) {
    var b = jspb.Message.getIndex_(a2, a2.pivot_);
    a2.array[b] || (a2.extensionObject_ = a2.array[b] = {});
  };
  jspb.Message.toObjectList = function(a2, b, c) {
    for (var d = [], e = 0; e < a2.length; e++)
      d[e] = b.call(a2[e], c, a2[e]);
    return d;
  };
  jspb.Message.toObjectExtension = function(a2, b, c, d, e) {
    for (var f in c) {
      var g = c[f], h = d.call(a2, g);
      if (h != null) {
        for (var k in g.fieldName)
          if (g.fieldName.hasOwnProperty(k))
            break;
        b[k] = g.toObjectFn ? g.isRepeated ? jspb.Message.toObjectList(h, g.toObjectFn, e) : g.toObjectFn(e, h) : h;
      }
    }
  };
  jspb.Message.serializeBinaryExtensions = function(a2, b, c, d) {
    for (var e in c) {
      var f = c[e], g = f.fieldInfo;
      if (!f.binaryWriterFn)
        throw Error("Message extension present that was generated without binary serialization support");
      var h = d.call(a2, g);
      if (h != null)
        if (g.isMessageType())
          if (f.binaryMessageSerializeFn)
            f.binaryWriterFn.call(b, g.fieldIndex, h, f.binaryMessageSerializeFn);
          else
            throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
        else
          f.binaryWriterFn.call(b, g.fieldIndex, h);
    }
  };
  jspb.Message.readBinaryExtension = function(a2, b, c, d, e) {
    var f = c[b.getFieldNumber()];
    if (f) {
      c = f.fieldInfo;
      if (!f.binaryReaderFn)
        throw Error("Deserializing extension whose generated code does not support binary format");
      if (c.isMessageType()) {
        var g = new c.ctor();
        f.binaryReaderFn.call(b, g, f.binaryMessageDeserializeFn);
      } else
        g = f.binaryReaderFn.call(b);
      c.isRepeated && !f.isPacked ? (b = d.call(a2, c)) ? b.push(g) : e.call(a2, c, [g]) : e.call(a2, c, g);
    } else
      b.skipField();
  };
  jspb.Message.getField = function(a2, b) {
    if (b < a2.pivot_) {
      b = jspb.Message.getIndex_(a2, b);
      var c = a2.array[b];
      return c === jspb.Message.EMPTY_LIST_SENTINEL_ ? a2.array[b] = [] : c;
    }
    if (a2.extensionObject_)
      return c = a2.extensionObject_[b], c === jspb.Message.EMPTY_LIST_SENTINEL_ ? a2.extensionObject_[b] = [] : c;
  };
  jspb.Message.getRepeatedField = function(a2, b) {
    return jspb.Message.getField(a2, b);
  };
  jspb.Message.getOptionalFloatingPointField = function(a2, b) {
    a2 = jspb.Message.getField(a2, b);
    return a2 == null ? a2 : +a2;
  };
  jspb.Message.getBooleanField = function(a2, b) {
    a2 = jspb.Message.getField(a2, b);
    return a2 == null ? a2 : !!a2;
  };
  jspb.Message.getRepeatedFloatingPointField = function(a2, b) {
    var c = jspb.Message.getRepeatedField(a2, b);
    a2.convertedPrimitiveFields_ || (a2.convertedPrimitiveFields_ = {});
    if (!a2.convertedPrimitiveFields_[b]) {
      for (var d = 0; d < c.length; d++)
        c[d] = +c[d];
      a2.convertedPrimitiveFields_[b] = true;
    }
    return c;
  };
  jspb.Message.getRepeatedBooleanField = function(a2, b) {
    var c = jspb.Message.getRepeatedField(a2, b);
    a2.convertedPrimitiveFields_ || (a2.convertedPrimitiveFields_ = {});
    if (!a2.convertedPrimitiveFields_[b]) {
      for (var d = 0; d < c.length; d++)
        c[d] = !!c[d];
      a2.convertedPrimitiveFields_[b] = true;
    }
    return c;
  };
  jspb.Message.bytesAsB64 = function(a2) {
    if (a2 == null || typeof a2 === "string")
      return a2;
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a2 instanceof Uint8Array)
      return goog.crypt.base64.encodeByteArray(a2);
    goog.asserts.fail("Cannot coerce to b64 string: " + goog.typeOf(a2));
    return null;
  };
  jspb.Message.bytesAsU8 = function(a2) {
    if (a2 == null || a2 instanceof Uint8Array)
      return a2;
    if (typeof a2 === "string")
      return goog.crypt.base64.decodeStringToUint8Array(a2);
    goog.asserts.fail("Cannot coerce to Uint8Array: " + goog.typeOf(a2));
    return null;
  };
  jspb.Message.bytesListAsB64 = function(a2) {
    jspb.Message.assertConsistentTypes_(a2);
    return a2.length && typeof a2[0] !== "string" ? goog.array.map(a2, jspb.Message.bytesAsB64) : a2;
  };
  jspb.Message.bytesListAsU8 = function(a2) {
    jspb.Message.assertConsistentTypes_(a2);
    return !a2.length || a2[0] instanceof Uint8Array ? a2 : goog.array.map(a2, jspb.Message.bytesAsU8);
  };
  jspb.Message.assertConsistentTypes_ = function(a2) {
    if (goog.DEBUG && a2 && 1 < a2.length) {
      var b = goog.typeOf(a2[0]);
      goog.array.forEach(a2, function(a3) {
        goog.typeOf(a3) != b && goog.asserts.fail("Inconsistent type in JSPB repeated field array. Got " + goog.typeOf(a3) + " expected " + b);
      });
    }
  };
  jspb.Message.getFieldWithDefault = function(a2, b, c) {
    a2 = jspb.Message.getField(a2, b);
    return a2 == null ? c : a2;
  };
  jspb.Message.getBooleanFieldWithDefault = function(a2, b, c) {
    a2 = jspb.Message.getBooleanField(a2, b);
    return a2 == null ? c : a2;
  };
  jspb.Message.getFloatingPointFieldWithDefault = function(a2, b, c) {
    a2 = jspb.Message.getOptionalFloatingPointField(a2, b);
    return a2 == null ? c : a2;
  };
  jspb.Message.getFieldProto3 = jspb.Message.getFieldWithDefault;
  jspb.Message.getMapField = function(a2, b, c, d) {
    a2.wrappers_ || (a2.wrappers_ = {});
    if (b in a2.wrappers_)
      return a2.wrappers_[b];
    var e = jspb.Message.getField(a2, b);
    if (!e) {
      if (c)
        return;
      e = [];
      jspb.Message.setField(a2, b, e);
    }
    return a2.wrappers_[b] = new jspb.Map(e, d);
  };
  jspb.Message.setField = function(a2, b, c) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    b < a2.pivot_ ? a2.array[jspb.Message.getIndex_(a2, b)] = c : (jspb.Message.maybeInitEmptyExtensionObject_(a2), a2.extensionObject_[b] = c);
    return a2;
  };
  jspb.Message.setProto3IntField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, 0);
  };
  jspb.Message.setProto3FloatField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, 0);
  };
  jspb.Message.setProto3BooleanField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, false);
  };
  jspb.Message.setProto3StringField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, "");
  };
  jspb.Message.setProto3BytesField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, "");
  };
  jspb.Message.setProto3EnumField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, 0);
  };
  jspb.Message.setProto3StringIntField = function(a2, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a2, b, c, "0");
  };
  jspb.Message.setFieldIgnoringDefault_ = function(a2, b, c, d) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    c !== d ? jspb.Message.setField(a2, b, c) : b < a2.pivot_ ? a2.array[jspb.Message.getIndex_(a2, b)] = null : (jspb.Message.maybeInitEmptyExtensionObject_(a2), delete a2.extensionObject_[b]);
    return a2;
  };
  jspb.Message.addToRepeatedField = function(a2, b, c, d) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    b = jspb.Message.getRepeatedField(a2, b);
    d != void 0 ? b.splice(d, 0, c) : b.push(c);
    return a2;
  };
  jspb.Message.setOneofField = function(a2, b, c, d) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    (c = jspb.Message.computeOneofCase(a2, c)) && c !== b && d !== void 0 && (a2.wrappers_ && c in a2.wrappers_ && (a2.wrappers_[c] = void 0), jspb.Message.setField(a2, c, void 0));
    return jspb.Message.setField(a2, b, d);
  };
  jspb.Message.computeOneofCase = function(a2, b) {
    for (var c, d, e = 0; e < b.length; e++) {
      var f = b[e], g = jspb.Message.getField(a2, f);
      g != null && (c = f, d = g, jspb.Message.setField(a2, f, void 0));
    }
    return c ? (jspb.Message.setField(a2, c, d), c) : 0;
  };
  jspb.Message.getWrapperField = function(a2, b, c, d) {
    a2.wrappers_ || (a2.wrappers_ = {});
    if (!a2.wrappers_[c]) {
      var e = jspb.Message.getField(a2, c);
      if (d || e)
        a2.wrappers_[c] = new b(e);
    }
    return a2.wrappers_[c];
  };
  jspb.Message.getRepeatedWrapperField = function(a2, b, c) {
    jspb.Message.wrapRepeatedField_(a2, b, c);
    b = a2.wrappers_[c];
    b == jspb.Message.EMPTY_LIST_SENTINEL_ && (b = a2.wrappers_[c] = []);
    return b;
  };
  jspb.Message.wrapRepeatedField_ = function(a2, b, c) {
    a2.wrappers_ || (a2.wrappers_ = {});
    if (!a2.wrappers_[c]) {
      for (var d = jspb.Message.getRepeatedField(a2, c), e = [], f = 0; f < d.length; f++)
        e[f] = new b(d[f]);
      a2.wrappers_[c] = e;
    }
  };
  jspb.Message.setWrapperField = function(a2, b, c) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    a2.wrappers_ || (a2.wrappers_ = {});
    var d = c ? c.toArray() : c;
    a2.wrappers_[b] = c;
    return jspb.Message.setField(a2, b, d);
  };
  jspb.Message.setOneofWrapperField = function(a2, b, c, d) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    a2.wrappers_ || (a2.wrappers_ = {});
    var e = d ? d.toArray() : d;
    a2.wrappers_[b] = d;
    return jspb.Message.setOneofField(a2, b, c, e);
  };
  jspb.Message.setRepeatedWrapperField = function(a2, b, c) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    a2.wrappers_ || (a2.wrappers_ = {});
    c = c || [];
    for (var d = [], e = 0; e < c.length; e++)
      d[e] = c[e].toArray();
    a2.wrappers_[b] = c;
    return jspb.Message.setField(a2, b, d);
  };
  jspb.Message.addToRepeatedWrapperField = function(a2, b, c, d, e) {
    jspb.Message.wrapRepeatedField_(a2, d, b);
    var f = a2.wrappers_[b];
    f || (f = a2.wrappers_[b] = []);
    c = c ? c : new d();
    a2 = jspb.Message.getRepeatedField(a2, b);
    e != void 0 ? (f.splice(e, 0, c), a2.splice(e, 0, c.toArray())) : (f.push(c), a2.push(c.toArray()));
    return c;
  };
  jspb.Message.toMap = function(a2, b, c, d) {
    for (var e = {}, f = 0; f < a2.length; f++)
      e[b.call(a2[f])] = c ? c.call(a2[f], d, a2[f]) : a2[f];
    return e;
  };
  jspb.Message.prototype.syncMapFields_ = function() {
    if (this.wrappers_)
      for (var a2 in this.wrappers_) {
        var b = this.wrappers_[a2];
        if (Array.isArray(b))
          for (var c = 0; c < b.length; c++)
            b[c] && b[c].toArray();
        else
          b && b.toArray();
      }
  };
  jspb.Message.prototype.toArray = function() {
    this.syncMapFields_();
    return this.array;
  };
  jspb.Message.GENERATE_TO_STRING && (jspb.Message.prototype.toString = function() {
    this.syncMapFields_();
    return this.array.toString();
  });
  jspb.Message.prototype.getExtension = function(a2) {
    if (this.extensionObject_) {
      this.wrappers_ || (this.wrappers_ = {});
      var b = a2.fieldIndex;
      if (a2.isRepeated) {
        if (a2.isMessageType())
          return this.wrappers_[b] || (this.wrappers_[b] = goog.array.map(this.extensionObject_[b] || [], function(b2) {
            return new a2.ctor(b2);
          })), this.wrappers_[b];
      } else if (a2.isMessageType())
        return !this.wrappers_[b] && this.extensionObject_[b] && (this.wrappers_[b] = new a2.ctor(this.extensionObject_[b])), this.wrappers_[b];
      return this.extensionObject_[b];
    }
  };
  jspb.Message.prototype.setExtension = function(a2, b) {
    this.wrappers_ || (this.wrappers_ = {});
    jspb.Message.maybeInitEmptyExtensionObject_(this);
    var c = a2.fieldIndex;
    a2.isRepeated ? (b = b || [], a2.isMessageType() ? (this.wrappers_[c] = b, this.extensionObject_[c] = goog.array.map(b, function(a3) {
      return a3.toArray();
    })) : this.extensionObject_[c] = b) : a2.isMessageType() ? (this.wrappers_[c] = b, this.extensionObject_[c] = b ? b.toArray() : b) : this.extensionObject_[c] = b;
    return this;
  };
  jspb.Message.difference = function(a2, b) {
    if (!(a2 instanceof b.constructor))
      throw Error("Messages have different types.");
    var c = a2.toArray();
    b = b.toArray();
    var d = [], e = 0, f = c.length > b.length ? c.length : b.length;
    a2.getJsPbMessageId() && (d[0] = a2.getJsPbMessageId(), e = 1);
    for (; e < f; e++)
      jspb.Message.compareFields(c[e], b[e]) || (d[e] = b[e]);
    return new a2.constructor(d);
  };
  jspb.Message.equals = function(a2, b) {
    return a2 == b || !(!a2 || !b) && a2 instanceof b.constructor && jspb.Message.compareFields(a2.toArray(), b.toArray());
  };
  jspb.Message.compareExtensions = function(a2, b) {
    a2 = a2 || {};
    b = b || {};
    var c = {}, d;
    for (d in a2)
      c[d] = 0;
    for (d in b)
      c[d] = 0;
    for (d in c)
      if (!jspb.Message.compareFields(a2[d], b[d]))
        return false;
    return true;
  };
  jspb.Message.compareFields = function(a2, b) {
    if (a2 == b)
      return true;
    if (!goog.isObject(a2) || !goog.isObject(b))
      return typeof a2 === "number" && isNaN(a2) || typeof b === "number" && isNaN(b) ? String(a2) == String(b) : false;
    if (a2.constructor != b.constructor)
      return false;
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a2.constructor === Uint8Array) {
      if (a2.length != b.length)
        return false;
      for (var c = 0; c < a2.length; c++)
        if (a2[c] != b[c])
          return false;
      return true;
    }
    if (a2.constructor === Array) {
      var d = void 0, e = void 0, f = Math.max(a2.length, b.length);
      for (c = 0; c < f; c++) {
        var g = a2[c], h = b[c];
        g && g.constructor == Object && (goog.asserts.assert(d === void 0), goog.asserts.assert(c === a2.length - 1), d = g, g = void 0);
        h && h.constructor == Object && (goog.asserts.assert(e === void 0), goog.asserts.assert(c === b.length - 1), e = h, h = void 0);
        if (!jspb.Message.compareFields(g, h))
          return false;
      }
      return d || e ? (d = d || {}, e = e || {}, jspb.Message.compareExtensions(d, e)) : true;
    }
    if (a2.constructor === Object)
      return jspb.Message.compareExtensions(a2, b);
    throw Error("Invalid type in JSPB array");
  };
  jspb.Message.prototype.cloneMessage = function() {
    return jspb.Message.cloneMessage(this);
  };
  jspb.Message.prototype.clone = function() {
    return jspb.Message.cloneMessage(this);
  };
  jspb.Message.clone = function(a2) {
    return jspb.Message.cloneMessage(a2);
  };
  jspb.Message.cloneMessage = function(a2) {
    return new a2.constructor(jspb.Message.clone_(a2.toArray()));
  };
  jspb.Message.copyInto = function(a2, b) {
    goog.asserts.assertInstanceof(a2, jspb.Message);
    goog.asserts.assertInstanceof(b, jspb.Message);
    goog.asserts.assert(a2.constructor == b.constructor, "Copy source and target message should have the same type.");
    a2 = jspb.Message.clone(a2);
    for (var c = b.toArray(), d = a2.toArray(), e = c.length = 0; e < d.length; e++)
      c[e] = d[e];
    b.wrappers_ = a2.wrappers_;
    b.extensionObject_ = a2.extensionObject_;
  };
  jspb.Message.clone_ = function(a2) {
    if (Array.isArray(a2)) {
      for (var b = Array(a2.length), c = 0; c < a2.length; c++) {
        var d = a2[c];
        d != null && (b[c] = typeof d == "object" ? jspb.Message.clone_(goog.asserts.assert(d)) : d);
      }
      return b;
    }
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a2 instanceof Uint8Array)
      return new Uint8Array(a2);
    b = {};
    for (c in a2)
      d = a2[c], d != null && (b[c] = typeof d == "object" ? jspb.Message.clone_(goog.asserts.assert(d)) : d);
    return b;
  };
  jspb.Message.registerMessageType = function(a2, b) {
    b.messageId = a2;
  };
  jspb.Message.messageSetExtensions = {};
  jspb.Message.messageSetExtensionsBinary = {};
  jspb.Export = {};
  exports.Map = jspb.Map, exports.Message = jspb.Message, exports.BinaryReader = jspb.BinaryReader, exports.BinaryWriter = jspb.BinaryWriter, exports.ExtensionFieldInfo = jspb.ExtensionFieldInfo, exports.ExtensionFieldBinaryInfo = jspb.ExtensionFieldBinaryInfo, exports.exportSymbol = goog.exportSymbol, exports.inherits = goog.inherits, exports.object = { extend: goog.object.extend }, exports.typeOf = goog.typeOf;
})(googleProtobuf);
var message;
((message2) => {
  ((v12) => {
    class SocketMessage2 extends googleProtobuf.Message {
      constructor(data) {
        super();
        googleProtobuf.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
          if ("event" in data && data.event != void 0) {
            this.event = data.event;
          }
          if ("id" in data && data.id != void 0) {
            this.id = data.id;
          }
          if ("payload" in data && data.payload != void 0) {
            this.payload = data.payload;
          }
        }
      }
      get event() {
        return googleProtobuf.Message.getField(this, 1);
      }
      set event(value) {
        googleProtobuf.Message.setField(this, 1, value);
      }
      get id() {
        return googleProtobuf.Message.getField(this, 2);
      }
      set id(value) {
        googleProtobuf.Message.setField(this, 2, value);
      }
      get payload() {
        return googleProtobuf.Message.getField(this, 3);
      }
      set payload(value) {
        googleProtobuf.Message.setField(this, 3, value);
      }
      static fromObject(data) {
        const message3 = new SocketMessage2({});
        if (data.event != null) {
          message3.event = data.event;
        }
        if (data.id != null) {
          message3.id = data.id;
        }
        if (data.payload != null) {
          message3.payload = data.payload;
        }
        return message3;
      }
      toObject() {
        const data = {};
        if (this.event != null) {
          data.event = this.event;
        }
        if (this.id != null) {
          data.id = this.id;
        }
        if (this.payload != null) {
          data.payload = this.payload;
        }
        return data;
      }
      serialize(w2) {
        const writer = w2 || new googleProtobuf.BinaryWriter();
        if (this.event !== void 0)
          writer.writeUint32(1, this.event);
        if (typeof this.id === "string" && this.id.length)
          writer.writeString(2, this.id);
        if (this.payload !== void 0)
          writer.writeBytes(3, this.payload);
        if (!w2)
          return writer.getResultBuffer();
      }
      static deserialize(bytes) {
        const reader = bytes instanceof googleProtobuf.BinaryReader ? bytes : new googleProtobuf.BinaryReader(bytes), message3 = new SocketMessage2();
        while (reader.nextField()) {
          if (reader.isEndGroup())
            break;
          switch (reader.getFieldNumber()) {
            case 1:
              message3.event = reader.readUint32();
              break;
            case 2:
              message3.id = reader.readString();
              break;
            case 3:
              message3.payload = reader.readBytes();
              break;
            default:
              reader.skipField();
          }
        }
        return message3;
      }
      serializeBinary() {
        return this.serialize();
      }
      static deserializeBinary(bytes) {
        return SocketMessage2.deserialize(bytes);
      }
    }
    v12.SocketMessage = SocketMessage2;
  })(message2.v1 || (message2.v1 = {}));
})(message || (message = {}));
const { SocketMessage } = message.v1;
class Proto {
  static encode(message2) {
    return new SocketMessage(message2).serialize();
  }
  static decode(message2) {
    return SocketMessage.deserialize(message2);
  }
}
var WebSocketReadyStates = /* @__PURE__ */ ((WebSocketReadyStates2) => {
  WebSocketReadyStates2[WebSocketReadyStates2["CONNECTING"] = 0] = "CONNECTING";
  WebSocketReadyStates2[WebSocketReadyStates2["OPEN"] = 1] = "OPEN";
  WebSocketReadyStates2[WebSocketReadyStates2["CLOSING"] = 2] = "CLOSING";
  WebSocketReadyStates2[WebSocketReadyStates2["CLOSED"] = 3] = "CLOSED";
  return WebSocketReadyStates2;
})(WebSocketReadyStates || {});
class Sockrates {
  constructor(url, config2) {
    __privateAdd(this, _constructWebSocketAddress);
    __privateAdd(this, _onMessage);
    __privateAdd(this, _handleErrors);
    __privateAdd(this, _send);
    __privateAdd(this, _ws, void 0);
    __privateAdd(this, _url, void 0);
    __privateAdd(this, _config, void 0);
    __privateAdd(this, _shouldConnect, void 0);
    __privateAdd(this, _currentTimeout, void 0);
    __privateAdd(this, _logger2, void 0);
    __privateAdd(this, _sendQueue, void 0);
    __privateAdd(this, _eventEmitter, void 0);
    var _a3, _b2, _c2, _d2, _e2, _f2;
    __privateSet(this, _url, url);
    __privateSet(this, _sendQueue, []);
    __privateSet(this, _eventEmitter, new EventEmitter$1());
    __privateSet(this, _shouldConnect, true);
    __privateSet(this, _config, config2 != null ? config2 : {});
    (_b2 = (_a3 = __privateGet(this, _config)).autoReconnect) != null ? _b2 : _a3.autoReconnect = true;
    (_d2 = (_c2 = __privateGet(this, _config)).retryConnectionInterval) != null ? _d2 : _c2.retryConnectionInterval = 1e3;
    (_f2 = (_e2 = __privateGet(this, _config)).debug) != null ? _f2 : _e2.debug = false;
    __privateSet(this, _logger2, new Logger(__privateGet(this, _config).debug ? "debug" : "info"));
  }
  get readyState() {
    return __privateGet(this, _ws).readyState;
  }
  get url() {
    return __privateGet(this, _url);
  }
  get config() {
    return __privateGet(this, _config);
  }
  async connect() {
    return new Promise((resolve, reject) => {
      try {
        __privateSet(this, _ws, new WebSocket(__privateMethod(this, _constructWebSocketAddress, constructWebSocketAddress_fn).call(this, __privateGet(this, _url))));
        __privateGet(this, _ws).binaryType = "arraybuffer";
        __privateGet(this, _logger2).debug("Connecting to", __privateGet(this, _url));
        __privateGet(this, _ws).onopen = () => {
          __privateGet(this, _logger2).debug(`Ready State: ${WebSocketReadyStates[__privateGet(this, _ws).readyState]}`);
          __privateGet(this, _sendQueue).forEach((message2) => {
            __privateMethod(this, _send, send_fn).call(this, message2);
          });
          __privateGet(this, _eventEmitter).emit("connected");
          resolve();
        };
        __privateGet(this, _ws).onclose = (ev) => {
          try {
            const { code: code2, reason } = ev;
            __privateGet(this, _logger2).debug("Socket closed. Close event:", ev);
            __privateGet(this, _logger2).debug("Connection closed code:", code2);
            __privateGet(this, _logger2).debug("Connection closed reason:", reason);
            if (__privateGet(this, _shouldConnect) && code2 !== 1e3 && __privateGet(this, _config).autoReconnect) {
              __privateGet(this, _logger2).debug(`Attempting reconnection in ${__privateGet(this, _config).retryConnectionInterval} second(s).`);
              if (__privateGet(this, _currentTimeout)) {
                return;
              }
              __privateSet(this, _currentTimeout, setTimeout(async () => {
                await this.connect();
                __privateGet(this, _eventEmitter).emit("reconnected", { code: code2, reason });
                __privateSet(this, _currentTimeout, void 0);
              }, __privateGet(this, _config).retryConnectionInterval));
            }
            __privateGet(this, _eventEmitter).emit("disconnected", { code: code2, reason });
          } catch (err) {
            __privateMethod(this, _handleErrors, handleErrors_fn).call(this, err, reject);
          }
        };
        __privateGet(this, _ws).onerror = (ev) => {
          __privateMethod(this, _handleErrors, handleErrors_fn).call(this, ev, reject);
        };
        __privateGet(this, _ws).onmessage = (ev) => __privateMethod(this, _onMessage, onMessage_fn).call(this, ev);
      } catch (err) {
        __privateMethod(this, _handleErrors, handleErrors_fn).call(this, err);
      }
    });
  }
  send(event, id, payload) {
    const message2 = Proto.encode({ event, id, payload });
    __privateGet(this, _logger2).debug(`Sending message: ${message2}`);
    __privateMethod(this, _send, send_fn).call(this, message2);
  }
  emit(event, id, payload) {
    this.send(event, id, payload);
  }
  receive(event, listener) {
    __privateGet(this, _eventEmitter).on(event.toString(), listener);
  }
  on(event, listener) {
    if (typeof event === "string" && (event === "connected" || event === "disconnected" || event === "errored" || event === "reconnected")) {
      __privateGet(this, _eventEmitter).on(event, listener);
      return;
    }
    this.receive(event, listener);
  }
  removeAllListeners() {
    __privateGet(this, _eventEmitter).removeAllListeners();
  }
  removeReceiver(event, receiver) {
    this.removeListener(event, receiver);
  }
  removeListener(event, listener) {
    __privateGet(this, _eventEmitter).removeListener(event.toString(), listener);
  }
  removeReceivers(event) {
    this.removeListeners(event);
  }
  removeListeners(event) {
    __privateGet(this, _eventEmitter).listeners(event.toString()).map((listener) => this.removeListener(event, listener));
  }
  disconnect() {
    __privateSet(this, _shouldConnect, false);
    clearTimeout(__privateGet(this, _currentTimeout));
    __privateSet(this, _currentTimeout, void 0);
    this.removeAllListeners();
    __privateGet(this, _ws).close(1e3, "Sockrates disconnect method called.");
  }
}
_ws = new WeakMap();
_url = new WeakMap();
_config = new WeakMap();
_shouldConnect = new WeakMap();
_currentTimeout = new WeakMap();
_logger2 = new WeakMap();
_sendQueue = new WeakMap();
_eventEmitter = new WeakMap();
_constructWebSocketAddress = new WeakSet();
constructWebSocketAddress_fn = function(url) {
  if (url.startsWith("ws://") || url.startsWith("wss://")) {
    return url;
  }
  if (url.startsWith("https://")) {
    return `wss://${url.substring(8)}`;
  }
  if (url.startsWith("http://")) {
    return `ws://${url.substring(7)}`;
  }
  throw new Error("Invalid URL. URL must start with http(s):// or ws(s)://.");
};
_onMessage = new WeakSet();
onMessage_fn = function(ev) {
  const message2 = Proto.decode(ev.data);
  const { id, payload } = message2;
  __privateGet(this, _logger2).debug(`Received message: ${message2}`);
  __privateGet(this, _eventEmitter).emit(message2.event.toString(), { id, payload });
};
_handleErrors = new WeakSet();
handleErrors_fn = function(err, reject) {
  __privateGet(this, _logger2).error("Error:", err);
  __privateGet(this, _eventEmitter).emit("errored", { error: err });
  reject(err);
};
_send = new WeakSet();
send_fn = function(message2) {
  if (!__privateGet(this, _ws) || __privateGet(this, _ws).readyState !== 1) {
    __privateGet(this, _sendQueue).push(message2);
    return;
  }
  __privateGet(this, _ws).send(message2);
};
class SocketService {
  constructor({ peerId, roomName, authToken }) {
    __privateAdd2(this, _generateId);
    __privateAdd2(this, _url2, void 0);
    __privateAdd2(this, _sockrates, void 0);
    __privateAdd2(this, _peerId, void 0);
    const { apiBase } = config;
    const socketHost = apiBase.includes("staging.dyte") ? "socket-edge-staging.dyte.io" : "socket-edge.dyte.io";
    __privateSet2(this, _url2, `wss://${socketHost}/ws?roomID=${roomName}&peerID=${peerId}&authToken=${authToken}`);
    __privateSet2(this, _sockrates, new Sockrates(__privateGet2(this, _url2)));
    __privateSet2(this, _peerId, peerId);
  }
  async connect() {
    const disconnectListener = ({ reason, code: code2 }) => {
      log.info(`Disconnected from socket-edge: [${code2}] ${reason}`);
      if (code2 < 4e3 || code2 > 4002)
        return;
      if (code2 === 4e3) {
        log.error(`${code2} Bad Request`);
      } else if (code2 === 4001) {
        log.error(`${code2} Unauthorized`);
      } else if (code2 === 4002) {
        log.error(`${code2} Internal Error`);
      } else {
        log.error(`${code2} Unknown Error`);
      }
      this.disconnect();
      __privateGet2(this, _sockrates).removeListener("disconnected", disconnectListener);
    };
    this.onStateEvent("disconnected", disconnectListener);
    await __privateGet2(this, _sockrates).connect();
  }
  disconnect() {
    return __privateGet2(this, _sockrates).disconnect();
  }
  sendMessage(event, protobuf, messageId) {
    return __privateGet2(this, _sockrates).send(event, messageId != null ? messageId : __privateMethod2(this, _generateId, generateId_fn).call(this), protobuf.serializeBinary());
  }
  sendMessagePromise(event, protobuf, messageId) {
    return new Promise((resolve) => {
      const mId = messageId != null ? messageId : __privateMethod2(this, _generateId, generateId_fn).call(this);
      const listener = ({ id, payload }) => {
        if (mId === id) {
          resolve({ id, payload });
          __privateGet2(this, _sockrates).removeListener(event, listener);
        }
      };
      __privateGet2(this, _sockrates).on(event, listener);
      __privateGet2(this, _sockrates).send(event, mId, protobuf == null ? void 0 : protobuf.serializeBinary());
    });
  }
  on(event, listener) {
    __privateGet2(this, _sockrates).on(event, listener);
  }
  onStateEvent(event, listener) {
    __privateGet2(this, _sockrates).on(event, listener);
  }
}
_url2 = new WeakMap();
_sockrates = new WeakMap();
_peerId = new WeakMap();
_generateId = new WeakSet();
generateId_fn = function() {
  return `${__privateGet2(this, _peerId)}-${(Math.random() + 1).toString(36).substring(7)}`;
};
class PluginSocketHandler {
  constructor(socketService) {
    __publicField(this, "socket");
    this.socket = socketService;
  }
  addPlugin(pluginId, staggered) {
    this.socket.sendMessage(pluginEvents.addPlugin, new dist.AddPluginRequest().setPluginId(pluginId).setStaggered(staggered));
  }
  removePlugin(pluginId) {
    this.socket.sendMessage(pluginEvents.removePlugin, new dist.RemovePluginRequest().setPluginId(pluginId));
  }
  async getActivePlugins() {
    const { payload } = await this.socket.sendMessagePromise(pluginEvents.getPlugins);
    return dist.EnablePluginsResponse.deserializeBinary(payload);
  }
  customPluginEventToRoom(pluginId, data, messageId) {
    this.socket.sendMessage(pluginEvents.customPluginEventToRoom, new dist.PluginEventToRoomRequest().setPluginId(pluginId).setPluginData(new TextEncoder().encode(JSON.stringify(data))), messageId);
  }
  customPluginEventToPeers(pluginId, peerIds, data, messageId) {
    this.socket.sendMessage(pluginEvents.customPluginEventToPeers, new dist.PluginEventToPeersRequest().setPluginId(pluginId).setPluginData(new TextEncoder().encode(JSON.stringify(data))).setPeerIdsList(peerIds), messageId);
  }
  enablePluginForRoom(pluginId, messageId) {
    this.socket.sendMessage(pluginEvents.enablePluginForRoom, new dist.EnablePluginForRoomRequest().setPluginId(pluginId), messageId);
  }
  enablePluginForPeers(pluginId, peerIds, messageId) {
    this.socket.sendMessage(pluginEvents.enablePluginForPeers, new dist.EnablePluginForPeersRequest().setPluginId(pluginId).setPeerIdsList(peerIds), messageId);
  }
  disablePluginForRoom(pluginId, messageId) {
    this.socket.sendMessage(pluginEvents.disablePluginForRoom, new dist.DisablePluginForRoomRequest().setPluginId(pluginId), messageId);
  }
  disablePluginForPeers(pluginId, peerIds, messageId) {
    this.socket.sendMessage(pluginEvents.disablePluginForPeers, new dist.DisablePluginForPeersRequest().setPluginId(pluginId).setPeerIdsList(peerIds), messageId);
  }
  storeInsertKeys(pluginId, store, insertKeys, messageId) {
    this.socket.sendMessage(pluginEvents.storeInsertKeys, new dist.PluginStoreInsertKeysRequest().setPluginId(pluginId).setStoreName(store).setInsertKeysList(insertKeys.map((item) => new dist.StoreKeys().setStoreKey(item.key).setPayload(new TextEncoder().encode(JSON.stringify(item.payload))))), messageId);
  }
  storeGetKeys(pluginId, store, getKeys, messageId) {
    this.socket.sendMessage(pluginEvents.storeGetKeys, new dist.PluginStoreGetKeysRequest().setPluginId(pluginId).setStoreName(store).setGetKeysList(getKeys.map((item) => new dist.StoreKeys().setStoreKey(item.key))), messageId);
  }
  storeDeleteKeys(pluginId, store, deleteKeys, messageId) {
    this.socket.sendMessage(pluginEvents.storeDeleteKeys, new dist.PluginStoreDeleteKeysRequest().setPluginId(pluginId).setStoreName(store).setDeleteKeysList(deleteKeys.map((item) => new dist.StoreKeys().setStoreKey(item.key))), messageId);
  }
  storeDelete(pluginId, store, messageId) {
    this.socket.sendMessage(pluginEvents.storeDelete, new dist.PluginStoreDeleteRequest().setPluginId(pluginId).setStoreName(store), messageId);
  }
  getPluginDataOld(pluginId, store) {
    log.debug(this, pluginId, store);
  }
  storePluginDataOld(pluginId, store, data) {
    this.socket.sendMessage(pluginEvents.storeInsertKeys, new dist.PluginStoreInsertKeysRequest().setPluginId(pluginId).setInsertKeysList([
      new dist.StoreKeys().setStoreKey(data.key).setPayload(new TextEncoder().encode(JSON.stringify(data)))
    ]).setStoreName(store));
  }
}
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
class DyteRecording extends DyteEventEmitter {
  constructor(self2) {
    super();
    __privateAdd2(this, _self11, void 0);
    __publicField(this, "recordingState", "IDLE");
    __publicField(this, "recordingId");
    __publicField(this, "recordingPeerId");
    __privateSet2(this, _self11, self2);
  }
  setRecordingState(recordingState) {
    this.recordingState = recordingState;
    this.emitCurrentRecordingState();
  }
  emitCurrentRecordingState() {
    this.emit("recordingUpdate", this.recordingState);
  }
  async start() {
    if (!__privateGet2(this, _self11).permissions.canRecord) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::start::permission_denied");
      throw new DyteError("User does not have permission to start recording");
    }
    if (this.recordingState === "STARTING" || this.recordingState === "RECORDING" || this.recordingState === "STOPPING") {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::start::recording_in_progress");
      return;
    }
    this.setRecordingState("STARTING");
    try {
      const APIClient2 = getAPIClient();
      const recordingId = await APIClient2.startRecording();
      this.recordingId = recordingId;
    } catch {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::stop::recording_failed_to_start");
      this.setRecordingState("IDLE");
      throw new DyteError("Error while starting recording");
    }
  }
  async stop() {
    if (!__privateGet2(this, _self11).permissions.canRecord) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::stop::permission_denied");
      throw new DyteError("User does not have permission to stop recording");
    }
    if (!(this.recordingState === "RECORDING") || !this.recordingId) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::stop::recording_not_in_progress");
      return;
    }
    this.setRecordingState("STOPPING");
    try {
      const APIClient2 = getAPIClient();
      await APIClient2.stopRecording(this.recordingId);
      this.setRecordingState("IDLE");
    } catch {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::stop::recording_failed_to_stop");
      this.setRecordingState("RECORDING");
      throw new DyteError("Error while stopping recording");
    }
  }
  async refreshActiveRecordingState() {
    try {
      const APIClient2 = getAPIClient();
      const { status, id } = await APIClient2.getActiveRecording();
      if (status !== this.recordingState) {
        switch (status) {
          case "UPLOADING":
            this.setRecordingState("STOPPING");
            break;
          case "UPLOADED":
            this.setRecordingState("IDLE");
            break;
          case "INVOKED":
            this.setRecordingState("STARTING");
            this.recordingId = id;
            break;
          case "RECORDING":
            this.setRecordingState("RECORDING");
            this.recordingId = id;
            break;
          default:
            this.setRecordingState("IDLE");
            this.recordingId = void 0;
        }
      }
    } catch (error) {
      this.setRecordingState("IDLE");
      this.recordingId = void 0;
    }
  }
}
_self11 = new WeakMap();
__decorateClass$2([
  DyteTelemetry.trace("recording.start")
], DyteRecording.prototype, "start", 1);
__decorateClass$2([
  DyteTelemetry.trace("recording.stop")
], DyteRecording.prototype, "stop", 1);
__decorateClass$2([
  DyteTelemetry.trace("getActiveRecording")
], DyteRecording.prototype, "refreshActiveRecordingState", 1);
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
class RecordingController {
  constructor(self2) {
    __publicField(this, "recording");
    this.recording = new DyteRecording(self2);
    this.setupEvents();
  }
  setupEvents() {
    SessionStore.onAsync(SessionEvents.ROOM_JOINED, async () => {
      await this.recording.refreshActiveRecordingState();
      log.debug("[ROOM_JOINED] resolved request to fetch recordings.");
    });
    SessionStore.on(SessionEvents.PEER_JOINED, async (p) => {
      var _a3;
      if ((_a3 = p.flags) == null ? void 0 : _a3.recorder) {
        this.recording.recordingPeerId = p.id;
        await this.recording.refreshActiveRecordingState();
      }
    });
    SessionStore.on(SessionEvents.PEER_CLOSED, (p) => {
      if (p.id === this.recording.recordingPeerId) {
        this.recording.recordingPeerId = void 0;
        this.recording.setRecordingState("IDLE");
      }
    });
    SessionStore.on(SessionEvents.ROOM_JOINED, (payload) => {
      var _a3;
      const recordingPeers = (_a3 = payload.peers) == null ? void 0 : _a3.filter((p) => {
        var _a4;
        return !!((_a4 = p.flags) == null ? void 0 : _a4.recorder);
      });
      if (!recordingPeers.length)
        return;
      [{ id: this.recording.recordingPeerId }] = recordingPeers;
    });
    SessionStore.on(SessionEvents.RECORDING_STARTED, () => {
      this.recording.setRecordingState("RECORDING");
    });
    SessionStore.on(SessionEvents.RECORDING_STOPPED, () => {
      this.recording.recordingId = void 0;
      this.recording.recordingPeerId = void 0;
      this.recording.setRecordingState("IDLE");
    });
  }
}
__decorateClass$1([
  DyteTelemetry.trace("RecordingController.setupEvents")
], RecordingController.prototype, "setupEvents", 1);
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i2 = decorators.length - 1, decorator; i2 >= 0; i2--)
    if (decorator = decorators[i2])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _Controller = (_h = class {
  constructor(apiBase, metaController, selfController, pluginController, participantController, chatController, pollController, remoteController, recordingController, socketService, roomNodeClient) {
    __publicField(this, "apiBase");
    __privateAdd2(this, _socketService2, void 0);
    __publicField(this, "roomNodeClient");
    __publicField(this, "chatController");
    __publicField(this, "metaController");
    __publicField(this, "participantController");
    __publicField(this, "pluginController");
    __publicField(this, "pollController");
    __publicField(this, "remoteController");
    __publicField(this, "selfController");
    __publicField(this, "recordingController");
    this.apiBase = apiBase;
    this.metaController = metaController;
    this.selfController = selfController;
    this.pluginController = pluginController;
    this.participantController = participantController;
    this.chatController = chatController;
    this.pollController = pollController;
    this.remoteController = remoteController;
    this.recordingController = recordingController;
    __privateSet2(this, _socketService2, socketService);
    this.roomNodeClient = roomNodeClient;
  }
  static async init(options) {
    var _a3, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
    browserSpecs.init();
    const {
      apiBase = "https://api.cluster.dyte.in",
      defaults = { video: true, audio: true },
      authToken,
      modules = {
        chat: true,
        participant: true,
        plugin: true,
        poll: true,
        self: true,
        room: true,
        permissions: true,
        theme: true
      }
    } = options;
    setConfig(__spreadProps(__spreadValues({}, options), { apiBase }));
    const peerId = v4();
    const APIClient2 = setupAPIClient({ authToken, baseURL: apiBase });
    APIClient2.setHeader("dyte-tracing-id", peerId);
    APIClient2.setPeerId(peerId);
    APIClient2.setRoomName(options.roomName);
    setupMediaPolyfill();
    DyteTelemetry.init(peerId);
    DyteTelemetry.meetingMetadata.roomName = options.roomName;
    DyteTelemetry.meetingMetadata.sdkVersion = WEB_CORE_VERSION;
    DyteTelemetry.meetingMetadata.deviceInfo = browserSpecs.getDeviceInfo();
    let localMediaHandler;
    if (navigator.RNLocalMediaHandlerImpl) {
      const { RNLocalMediaHandlerImpl } = navigator;
      localMediaHandler = await RNLocalMediaHandlerImpl.init();
    } else {
      localMediaHandler = await LocalMediaHandler.init();
    }
    const [roomNodeClient, socketService] = await Promise.all([
      _Controller.createRoomNodeClient(options, localMediaHandler, peerId),
      constants.isV2AuthToken ? void 0 : _Controller.createSocketService(__spreadProps(__spreadValues({}, options), {
        peerId
      }))
    ]);
    let chatController;
    let participantController;
    let pluginController;
    let pollController;
    let selfController;
    let metaController;
    let remoteController;
    let recordingController;
    const chatSocketHandler = new ChatSocketHandler(socketService);
    const pluginSocketHandler = new PluginSocketHandler(socketService);
    if ((_a3 = modules.self) != null ? _a3 : true) {
      [selfController] = await Promise.all([SelfController.init(socketService, roomNodeClient, { modules, defaults }, localMediaHandler), roomNodeClient.setupTransports()]);
      APIClient2.setOrganizationId(selfController.self.organizationId);
    } else {
      await roomNodeClient.setupTransports();
    }
    if ((_b2 = modules.chat) != null ? _b2 : true) {
      if (!selfController) {
        throw new DyteError("The chat module cannot be initialized without the `self` module");
      }
      chatController = await ChatController.init(chatSocketHandler, roomNodeClient, selfController.self);
    }
    if ((_c2 = modules.participant) != null ? _c2 : true) {
      if (!selfController) {
        throw new DyteError("The participant module cannot be initialized without the `self` module");
      }
      participantController = new ParticipantController(roomNodeClient, selfController.self);
    }
    if ((_d2 = modules.plugin) != null ? _d2 : true) {
      pluginController = await PluginController.init(pluginSocketHandler, chatSocketHandler, chatController.chat, roomNodeClient, selfController.self, participantController.participants);
    }
    if ((_e2 = modules.poll) != null ? _e2 : true) {
      if (!selfController) {
        throw new DyteError("The poll cannot be initialized without the `self` module");
      }
      pollController = new PollController(roomNodeClient, selfController.self);
    }
    if ((_f2 = modules.room) != null ? _f2 : true) {
      metaController = new MetaController(roomNodeClient);
    }
    if ((_g2 = modules.remoteControl) != null ? _g2 : true) {
      if (!selfController) {
        throw new DyteError("The remote controller cannot be initialized without the `self` module");
      }
      remoteController = new RemoteController(roomNodeClient, selfController.self, participantController.participants);
    }
    if ((_h2 = modules.recording) != null ? _h2 : true) {
      recordingController = new RecordingController(selfController.self);
    }
    return new _Controller(apiBase, metaController, selfController, pluginController, participantController, chatController, pollController, remoteController, recordingController, socketService, roomNodeClient);
  }
  static async createSocketService(options) {
    const { peerId, roomName, authToken } = options;
    const socketService = new SocketService({
      peerId,
      roomName,
      authToken
    });
    try {
      await socketService.connect();
    } catch (err) {
      log.error("[Socket Service] Failed to connect to socket server:", err);
    }
    return socketService;
  }
  static async createRoomNodeClient(options, localMediaHandler, peerId) {
    const {
      roomName,
      authToken
    } = options;
    const socketRoomName = constants.isV2AuthToken ? JSON.parse(atob(authToken.split(".")[1])).meetingId : roomName;
    const APIClient2 = getAPIClient();
    const { roomNodeUrl, meetingTitle } = await APIClient2.getRoomNodeData(socketRoomName);
    const roomNodeClient = await RoomNodeClient.init({
      roomName: socketRoomName,
      authToken,
      peerId,
      roomNodeUrl,
      meetingTitle
    }, localMediaHandler);
    return roomNodeClient;
  }
  async joinRoom() {
    return this.selfController.joinRoom();
  }
  async leaveRoom(state = "left") {
    return this.selfController.leaveRoom(state);
  }
}, _socketService2 = new WeakMap(), _h);
let Controller = _Controller;
__decorateClass([
  DyteTelemetry.trace("joinRoom.Controller")
], Controller.prototype, "joinRoom", 1);
__decorateClass([
  DyteTelemetry.trace("Controller.leaveRoom")
], Controller.prototype, "leaveRoom", 1);
__decorateClass([
  DyteTelemetry.trace("createSocketService")
], Controller, "createSocketService", 1);
__decorateClass([
  DyteTelemetry.trace("createRoomNodeClient")
], Controller, "createRoomNodeClient", 1);
const _DyteClient = class {
  constructor(controller) {
    __privateAdd2(this, _controller, void 0);
    __privateSet2(this, _controller, controller);
  }
  static async init(options) {
    if (typeof window !== "undefined") {
      window.addEventListener("error", (event) => {
        var _a3;
        if (!((_a3 = event.filename) == null ? void 0 : _a3.includes("localhost")) && event.lineno !== 0) {
          DyteTelemetry.addEventInCurrentSpan("error", "window::error", {
            error: event.error
          }, true);
        }
      });
      window.addEventListener("unhandledrejection", (error) => {
        DyteTelemetry.addEventInCurrentSpan("error", "window::unhandledrejection", {
          reason: error.reason
        }, true);
      });
    }
    setIsV2AuthToken(options.authToken, options.roomName);
    const controller = await Controller.init(options);
    return new _DyteClient(controller);
  }
  async joinRoom() {
    return __privateGet2(this, _controller).joinRoom();
  }
  async leaveRoom() {
    return __privateGet2(this, _controller).leaveRoom();
  }
  get participants() {
    var _a3;
    return (_a3 = __privateGet2(this, _controller).participantController) == null ? void 0 : _a3.participants;
  }
  get self() {
    var _a3;
    return (_a3 = __privateGet2(this, _controller).selfController) == null ? void 0 : _a3.self;
  }
  get meta() {
    var _a3;
    return (_a3 = __privateGet2(this, _controller).metaController) == null ? void 0 : _a3.meta;
  }
  get plugins() {
    var _a3;
    return (_a3 = __privateGet2(this, _controller).pluginController) == null ? void 0 : _a3.plugins;
  }
  get chat() {
    var _a3;
    return (_a3 = __privateGet2(this, _controller).chatController) == null ? void 0 : _a3.chat;
  }
  get polls() {
    var _a3;
    return (_a3 = __privateGet2(this, _controller).pollController) == null ? void 0 : _a3.polls;
  }
  get remote() {
    var _a3;
    return (_a3 = __privateGet2(this, _controller).remoteController) == null ? void 0 : _a3.remote;
  }
  get recording() {
    var _a3;
    return (_a3 = __privateGet2(this, _controller).recordingController) == null ? void 0 : _a3.recording;
  }
};
let DyteClient = _DyteClient;
_controller = new WeakMap();
export { DyteClient as default };
